// @ts-nocheck
import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: any;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** A time of day in 24-hour "HH:MM" form, e.g. "05:30" */
  TimeOfDay: any;
  join__FieldSet: any;
  link__Import: any;
};

export type Access = {
  __typename?: 'Access';
  canAccessAdmin: Scalars['Boolean'];
  cms_media?: Maybe<Cms_MediaAccess>;
  cms_page?: Maybe<Cms_PageAccess>;
  footer?: Maybe<FooterAccess>;
  nav?: Maybe<NavAccess>;
  payload_preferences?: Maybe<Payload_PreferencesAccess>;
};

export type AccessibilityStatement = {
  __typename?: 'AccessibilityStatement';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<AccessibilityStatement_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type AccessibilityStatement_BlockSettings = {
  __typename?: 'AccessibilityStatement_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<AccessibilityStatement_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<AccessibilityStatement_BlockSettings_ResponsiveStyles>>;
};

export type AccessibilityStatement_BlockSettings_ResponsiveStyles = {
  __typename?: 'AccessibilityStatement_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<AccessibilityStatement_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<AccessibilityStatement_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<AccessibilityStatement_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum AccessibilityStatement_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum AccessibilityStatement_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum AccessibilityStatement_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum AccessibilityStatement_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type Accordion = {
  __typename?: 'Accordion';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<Accordion_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  button?: Maybe<Array<Accordion_Button>>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Accordion_Image>;
  items?: Maybe<Array<Accordion_Items>>;
  title?: Maybe<Scalars['JSON']>;
};


export type AccordionTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Accordion_BlockSettings = {
  __typename?: 'Accordion_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<Accordion_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<Accordion_BlockSettings_ResponsiveStyles>>;
};

export type Accordion_BlockSettings_ResponsiveStyles = {
  __typename?: 'Accordion_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<Accordion_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<Accordion_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<Accordion_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum Accordion_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum Accordion_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum Accordion_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum Accordion_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type Accordion_Button = {
  __typename?: 'Accordion_Button';
  button?: Maybe<Accordion_Button_Button>;
  id?: Maybe<Scalars['String']>;
};

export type Accordion_Button_Button = {
  __typename?: 'Accordion_Button_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<Accordion_Button_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<Accordion_Button_Button_Variant>;
};

export type Accordion_Button_Button_Link = {
  __typename?: 'Accordion_Button_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<Accordion_Button_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum Accordion_Button_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum Accordion_Button_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Text = 'text'
}

export type Accordion_Image = {
  __typename?: 'Accordion_Image';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type Accordion_ImageLgArgs = {
  where?: InputMaybe<Accordion_Image_Lg_Where>;
};


export type Accordion_ImageMdArgs = {
  where?: InputMaybe<Accordion_Image_Md_Where>;
};


export type Accordion_ImageSmArgs = {
  where?: InputMaybe<Accordion_Image_Sm_Where>;
};


export type Accordion_ImageXlArgs = {
  where?: InputMaybe<Accordion_Image_Xl_Where>;
};


export type Accordion_ImageXsArgs = {
  where?: InputMaybe<Accordion_Image_Xs_Where>;
};


export type Accordion_ImageXxlArgs = {
  where?: InputMaybe<Accordion_Image_Xxl_Where>;
};


export type Accordion_ImageXxsArgs = {
  where?: InputMaybe<Accordion_Image_Xxs_Where>;
};

export type Accordion_Image_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Lg_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Lg_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Lg_Width_Operator>;
};

export type Accordion_Image_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Lg_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Lg_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Lg_Width_Operator>;
};

export type Accordion_Image_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Lg_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Lg_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Lg_Width_Operator>;
};

export type Accordion_Image_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Md_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Md_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Md_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Md_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Md_Width_Operator>;
};

export type Accordion_Image_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Md_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Md_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Md_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Md_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Md_Width_Operator>;
};

export type Accordion_Image_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Md_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Md_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Md_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Md_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Md_Width_Operator>;
};

export type Accordion_Image_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Sm_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Sm_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Sm_Width_Operator>;
};

export type Accordion_Image_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Sm_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Sm_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Sm_Width_Operator>;
};

export type Accordion_Image_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Sm_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Sm_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Sm_Width_Operator>;
};

export type Accordion_Image_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Xl_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Xl_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Xl_Width_Operator>;
};

export type Accordion_Image_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Xl_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Xl_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Xl_Width_Operator>;
};

export type Accordion_Image_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Xl_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Xl_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Xl_Width_Operator>;
};

export type Accordion_Image_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Xs_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Xs_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Xs_Width_Operator>;
};

export type Accordion_Image_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Xs_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Xs_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Xs_Width_Operator>;
};

export type Accordion_Image_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Xs_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Xs_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Xs_Width_Operator>;
};

export type Accordion_Image_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Xxl_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Xxl_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Xxl_Width_Operator>;
};

export type Accordion_Image_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Xxl_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Xxl_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Xxl_Width_Operator>;
};

export type Accordion_Image_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Xxl_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Xxl_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Xxl_Width_Operator>;
};

export type Accordion_Image_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Image_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Accordion_Image_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Accordion_Image_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Xxs_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Xxs_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Xxs_Width_Operator>;
};

export type Accordion_Image_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Xxs_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Xxs_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Xxs_Width_Operator>;
};

export type Accordion_Image_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Accordion_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Accordion_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<Accordion_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<Accordion_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<Accordion_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<Accordion_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<Accordion_Image_Xxs_Height_Operator>;
  id?: InputMaybe<Accordion_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<Accordion_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Accordion_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Accordion_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Accordion_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Accordion_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<Accordion_Image_Xxs_Url_Operator>;
  width?: InputMaybe<Accordion_Image_Xxs_Width_Operator>;
};

export type Accordion_Image_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Accordion_Items = {
  __typename?: 'Accordion_Items';
  boldHeader?: Maybe<Scalars['Boolean']>;
  contentType?: Maybe<Accordion_Items_ContentType>;
  id?: Maybe<Scalars['String']>;
  richTextContent?: Maybe<Scalars['JSON']>;
  tableColumns?: Maybe<Scalars['Float']>;
  tableContent?: Maybe<Array<Accordion_Items_TableContent>>;
  title?: Maybe<Scalars['String']>;
};


export type Accordion_ItemsRichTextContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Accordion_Items_TableContent = {
  __typename?: 'Accordion_Items_TableContent';
  id?: Maybe<Scalars['String']>;
  rowInputs?: Maybe<Scalars['JSON']>;
};

export enum Accordion_Items_ContentType {
  RichTextContent = 'richTextContent',
  TableContent = 'tableContent'
}

export enum ActivityLevel {
  High = 'high',
  Low = 'low',
  Moderate = 'moderate'
}

export enum ActivityLevels {
  Active = 'Active',
  Normal = 'Normal',
  ObeseProne = 'Obese_Prone'
}

export type AddonLineItem = {
  __typename?: 'AddonLineItem';
  discount: Scalars['Float'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  recurring: Scalars['Boolean'];
  shopifyId: Scalars['String'];
  sku: Scalars['String'];
  type: Scalars['String'];
};

export type AddonLineItemInput = {
  discount: Scalars['Float'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  recurring: Scalars['Boolean'];
  shopifyId: Scalars['String'];
  sku: Scalars['String'];
  type: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']>;
  aptNo?: Maybe<Scalars['String']>;
  carrierCodeOverride?: Maybe<Scalars['String']>;
  carrierOverride?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  normalizedZipCode?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  stateAbbr?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['Int']>;
  subjectType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** The connection type for Address. */
export type AddressConnection = {
  __typename?: 'AddressConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AddressEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Address>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of AddressCreate */
export type AddressCreateInput = {
  addressInput: AddressInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AddressCreate. */
export type AddressCreatePayload = {
  __typename?: 'AddressCreatePayload';
  address: Address;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of AddressDelete */
export type AddressDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of AddressDelete. */
export type AddressDeletePayload = {
  __typename?: 'AddressDeletePayload';
  address: Address;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type AddressEdge = {
  __typename?: 'AddressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Address>;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']>;
  aptNo?: InputMaybe<Scalars['String']>;
  carrierCodeOverride?: InputMaybe<Scalars['String']>;
  carrierOverride?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  normalizedZipCode?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  stateAbbr?: InputMaybe<Scalars['String']>;
  subjectId?: InputMaybe<Scalars['Int']>;
  subjectType?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export enum AddressOrder {
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyModified = 'RECENTLY_MODIFIED'
}

/** Autogenerated input type of AddressUpdate */
export type AddressUpdateInput = {
  addressInput: AddressInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of AddressUpdate. */
export type AddressUpdatePayload = {
  __typename?: 'AddressUpdatePayload';
  address: Address;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AmountAmount = {
  __typename?: 'AmountAmount';
  amount?: Maybe<Scalars['Float']>;
};

export type AmountOrPercentage = {
  __typename?: 'AmountOrPercentage';
  amount?: Maybe<AmountAmount>;
  percentage?: Maybe<Scalars['Float']>;
};

/** Autogenerated return type of AssignUserToSubflow. */
export type AssignUserToSubflowPayload = {
  __typename?: 'AssignUserToSubflowPayload';
  authenticatable: User;
  credentials: Credential;
  recommendationWizard: RecommendationWizard;
};

export type Automation = {
  __typename?: 'Automation';
  active: Scalars['Boolean'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  lastRunAt?: Maybe<Scalars['ISO8601DateTime']>;
  name: Scalars['String'];
  scheduledFor?: Maybe<Scalars['ISO8601DateTime']>;
  targetDay: Scalars['Int'];
  time: Scalars['TimeOfDay'];
  updatedAt: Scalars['ISO8601DateTime'];
  weekday: Scalars['String'];
};

/** The connection type for Automation. */
export type AutomationConnection = {
  __typename?: 'AutomationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AutomationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Automation>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of AutomationCreate */
export type AutomationCreateInput = {
  automationInput: AutomationInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AutomationCreate. */
export type AutomationCreatePayload = {
  __typename?: 'AutomationCreatePayload';
  automation: Automation;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of AutomationDelete */
export type AutomationDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of AutomationDelete. */
export type AutomationDeletePayload = {
  __typename?: 'AutomationDeletePayload';
  automation: Automation;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type AutomationEdge = {
  __typename?: 'AutomationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Automation>;
};

export type AutomationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  name: AutomationName;
  targetDay: Scalars['Int'];
  time: Scalars['TimeOfDay'];
  weekday: AutomationWeekday;
};

export enum AutomationName {
  /** Close day for ops */
  CloseDayForOps = 'close_day_for_ops',
  /** Create shipment list */
  CreateShipmentList = 'create_shipment_list',
  /** Payment batch */
  PaymentBatch = 'payment_batch',
  /** Upload to ShipStation */
  UploadToShipStation = 'upload_to_ship_station'
}

/** Autogenerated input type of AutomationRun */
export type AutomationRunInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of AutomationRun. */
export type AutomationRunPayload = {
  __typename?: 'AutomationRunPayload';
  automation: Automation;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of AutomationUpdate */
export type AutomationUpdateInput = {
  automationInput: AutomationInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of AutomationUpdate. */
export type AutomationUpdatePayload = {
  __typename?: 'AutomationUpdatePayload';
  automation: Automation;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export enum AutomationWeekday {
  /** Friday */
  Friday = 'friday',
  /** Monday */
  Monday = 'monday',
  /** Saturday */
  Saturday = 'saturday',
  /** Sunday */
  Sunday = 'sunday',
  /** Thursday */
  Thursday = 'thursday',
  /** Tuesday */
  Tuesday = 'tuesday',
  /** Wednesday */
  Wednesday = 'wednesday'
}

export type Blob = {
  __typename?: 'Blob';
  byteSize?: Maybe<Scalars['Int']>;
  fileName?: Maybe<Scalars['String']>;
};

export type Box = {
  __typename?: 'Box';
  bagQuantity?: Maybe<Scalars['Int']>;
  bagVolume?: Maybe<Scalars['Int']>;
  bagWeight?: Maybe<Scalars['Int']>;
  boxVariants?: Maybe<Array<BoxVariant>>;
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  itemQuantity: Scalars['Int'];
  itemVolume?: Maybe<Scalars['Int']>;
  itemWeight?: Maybe<Scalars['Int']>;
  legacyCategory: Scalars['String'];
  legacyDefaultFrequency?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  packaging?: Maybe<Packaging>;
  packagingId?: Maybe<Scalars['Int']>;
  retail?: Maybe<RetailPrice>;
  routeCode: RouteCode;
  sku?: Maybe<Scalars['String']>;
  state: Scalars['String'];
};

/** The connection type for Box. */
export type BoxConnection = {
  __typename?: 'BoxConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BoxEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Box>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of BoxCreate */
export type BoxCreateInput = {
  boxInput: BoxInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of BoxCreate. */
export type BoxCreatePayload = {
  __typename?: 'BoxCreatePayload';
  box: Box;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of BoxDelete */
export type BoxDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of BoxDelete. */
export type BoxDeletePayload = {
  __typename?: 'BoxDeletePayload';
  box: Box;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type BoxEdge = {
  __typename?: 'BoxEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Box>;
};

export type BoxInput = {
  bagQuantity?: InputMaybe<Scalars['Int']>;
  bagVolume?: InputMaybe<Scalars['Int']>;
  bagWeight?: InputMaybe<Scalars['Int']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  itemQuantity?: InputMaybe<Scalars['Int']>;
  itemVolume?: InputMaybe<Scalars['Int']>;
  itemWeight?: InputMaybe<Scalars['Int']>;
  legacyCategory?: InputMaybe<Scalars['String']>;
  legacyDefaultFrequency?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  packagingId?: InputMaybe<Scalars['Int']>;
  routeCode?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<TypesBoxInputTypeState>;
};

/** Autogenerated input type of BoxUpdate */
export type BoxUpdateInput = {
  boxInput: BoxInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of BoxUpdate. */
export type BoxUpdatePayload = {
  __typename?: 'BoxUpdatePayload';
  box: Box;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type BoxVariant = {
  __typename?: 'BoxVariant';
  active?: Maybe<Scalars['Boolean']>;
  activeFrom?: Maybe<Scalars['ISO8601Date']>;
  activeUntil?: Maybe<Scalars['ISO8601Date']>;
  addonUnits: Scalars['Int'];
  box?: Maybe<Box>;
  calorieGroup?: Maybe<Scalars['Int']>;
  category: Scalars['String'];
  categoryMapped: TypesBoxVariantCategory;
  defaultFrequency?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['ISO8601Date']>;
  displayOrder?: Maybe<Scalars['Int']>;
  feedingGuideline?: Maybe<FeedingGuideline>;
  id: Scalars['ID'];
  mealVariants?: Maybe<Array<PetPlateMealVariantType>>;
  meals?: Maybe<Array<Meal>>;
  mealsPerDay: Scalars['Int'];
  name: Scalars['String'];
  parentShopifyId?: Maybe<Scalars['String']>;
  planType?: Maybe<BoxVariantPlanTypeEnum>;
  price?: Maybe<Scalars['Float']>;
  productVariants?: Maybe<Array<PetPlateProductVariantType>>;
  products?: Maybe<Array<PetPlateProduct>>;
  recommended: Scalars['Boolean'];
  sellingPlanId?: Maybe<Scalars['String']>;
  shopifyId?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
};


export type BoxVariantProductVariantsArgs = {
  first?: Scalars['Int'];
};

/** The connection type for BoxVariant. */
export type BoxVariantConnection = {
  __typename?: 'BoxVariantConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BoxVariantEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BoxVariant>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of BoxVariantCreate */
export type BoxVariantCreateInput = {
  boxVariantInput: BoxVariantInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of BoxVariantCreate. */
export type BoxVariantCreatePayload = {
  __typename?: 'BoxVariantCreatePayload';
  boxVariant: BoxVariant;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of BoxVariantDelete */
export type BoxVariantDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of BoxVariantDelete. */
export type BoxVariantDeletePayload = {
  __typename?: 'BoxVariantDeletePayload';
  boxVariant: BoxVariant;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type BoxVariantEdge = {
  __typename?: 'BoxVariantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<BoxVariant>;
};

export type BoxVariantInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  activeFrom?: InputMaybe<Scalars['ISO8601Date']>;
  activeUntil?: InputMaybe<Scalars['ISO8601Date']>;
  addonUnits?: InputMaybe<Scalars['Int']>;
  boxId?: InputMaybe<Scalars['Int']>;
  calorieGroup?: InputMaybe<Scalars['Int']>;
  categoryMapped?: InputMaybe<TypesBoxVariantCategory>;
  defaultFrequency?: InputMaybe<Scalars['Int']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  mealsPerDay?: InputMaybe<Scalars['Int']>;
  migrationPriceRollback?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentShopifyId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  sellingPlanId?: InputMaybe<Scalars['String']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
};

export enum BoxVariantPlanTypeEnum {
  Bundle = 'bundle',
  Chewy = 'chewy',
  Combo = 'combo',
  Custom = 'custom',
  FreshBaked = 'fresh_baked',
  Full = 'full',
  Retail = 'retail',
  SpaceSaver = 'space_saver',
  Topper = 'topper',
  Welcome = 'welcome'
}

/** Autogenerated input type of BoxVariantUpdate */
export type BoxVariantUpdateInput = {
  boxVariantInput: BoxVariantInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of BoxVariantUpdate. */
export type BoxVariantUpdatePayload = {
  __typename?: 'BoxVariantUpdatePayload';
  boxVariant: BoxVariant;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type Breed = {
  __typename?: 'Breed';
  active: Scalars['Boolean'];
  activityLevel?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  mixedBreed: Scalars['Boolean'];
  name: Scalars['String'];
  sizeClass?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Breed. */
export type BreedConnection = {
  __typename?: 'BreedConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BreedEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Breed>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of BreedCreate */
export type BreedCreateInput = {
  breedInput: BreedInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of BreedCreate. */
export type BreedCreatePayload = {
  __typename?: 'BreedCreatePayload';
  breed: Breed;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of BreedDelete */
export type BreedDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of BreedDelete. */
export type BreedDeletePayload = {
  __typename?: 'BreedDeletePayload';
  breed: Breed;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type BreedEdge = {
  __typename?: 'BreedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Breed>;
};

export type BreedInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  activityLevel?: InputMaybe<ActivityLevels>;
  mixedBreed?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  sizeClass?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of BreedUpdate */
export type BreedUpdateInput = {
  breedInput: BreedInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of BreedUpdate. */
export type BreedUpdatePayload = {
  __typename?: 'BreedUpdatePayload';
  breed: Breed;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CalorieMultiplier = {
  __typename?: 'CalorieMultiplier';
  activityLevel?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['String']>;
  bodyCondition?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  multiplier?: Maybe<Scalars['Float']>;
  noteToCustomer?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  obeseProneness?: Maybe<Scalars['String']>;
  spayedNeutered?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for CalorieMultiplier. */
export type CalorieMultiplierConnection = {
  __typename?: 'CalorieMultiplierConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CalorieMultiplierEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CalorieMultiplier>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of CalorieMultiplierCreate */
export type CalorieMultiplierCreateInput = {
  calorieMultiplierInput: CalorieMultiplierInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CalorieMultiplierCreate. */
export type CalorieMultiplierCreatePayload = {
  __typename?: 'CalorieMultiplierCreatePayload';
  calorieMultiplier: CalorieMultiplier;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CalorieMultiplierDelete */
export type CalorieMultiplierDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of CalorieMultiplierDelete. */
export type CalorieMultiplierDeletePayload = {
  __typename?: 'CalorieMultiplierDeletePayload';
  calorieMultiplier: CalorieMultiplier;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type CalorieMultiplierEdge = {
  __typename?: 'CalorieMultiplierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CalorieMultiplier>;
};

export type CalorieMultiplierInput = {
  activityLevel?: InputMaybe<ActivityLevel>;
  age?: InputMaybe<Scalars['String']>;
  bodyCondition?: InputMaybe<Scalars['String']>;
  multiplier?: InputMaybe<Scalars['Float']>;
  noteToCustomer?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  obeseProneness?: InputMaybe<PetActivityLevels>;
  spayedNeutered?: InputMaybe<Celibacy>;
};

/** Autogenerated input type of CalorieMultiplierUpdate */
export type CalorieMultiplierUpdateInput = {
  calorieMultiplierInput: CalorieMultiplierInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of CalorieMultiplierUpdate. */
export type CalorieMultiplierUpdatePayload = {
  __typename?: 'CalorieMultiplierUpdatePayload';
  calorieMultiplier: CalorieMultiplier;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CancellationSurvey = {
  __typename?: 'CancellationSurvey';
  additionalFeedback?: Maybe<Scalars['String']>;
  budgetGrade?: Maybe<Scalars['String']>;
  budgetTopper?: Maybe<Scalars['String']>;
  budgetWorth?: Maybe<Scalars['String']>;
  cancellationReasonId?: Maybe<Scalars['Int']>;
  cancellationReasonOther?: Maybe<Scalars['String']>;
  cancellationReasonOtherMoreDetails?: Maybe<Scalars['String']>;
  cancellationReasonTerm?: Maybe<Term>;
  covidReasonId?: Maybe<Scalars['Int']>;
  covidReasonOther?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  customerCareIssueOther?: Maybe<Scalars['String']>;
  customerCareIssueTerm?: Maybe<Term>;
  deliveryIssueOther?: Maybe<Scalars['String']>;
  deliveryIssueTerm?: Maybe<Term>;
  deliveryScheduleIssueGuidelines?: Maybe<Scalars['String']>;
  deliveryScheduleIssueOther?: Maybe<Scalars['String']>;
  deliveryScheduleIssueTerm?: Maybe<Term>;
  fitTransitionTerm?: Maybe<Scalars['String']>;
  foodTypeBrandOther?: Maybe<Scalars['String']>;
  foodTypeBrandTerm?: Maybe<Term>;
  foodTypeOther?: Maybe<Scalars['String']>;
  foodTypeTerm?: Maybe<Term>;
  id: Scalars['ID'];
  keepReceivingEmails?: Maybe<Scalars['Boolean']>;
  mealQualityIssueMealIds?: Maybe<Array<Scalars['Int']>>;
  mealQualityIssueOther?: Maybe<Scalars['String']>;
  mealQualityIssueTerm?: Maybe<Term>;
  serviceIssueOther?: Maybe<Scalars['String']>;
  serviceIssueTerm?: Maybe<Term>;
  subscription?: Maybe<Subscription>;
  tasteResponseMealIds?: Maybe<Array<Scalars['Int']>>;
  tasteResponseOther?: Maybe<Scalars['String']>;
  tasteResponseTerm?: Maybe<Term>;
  transitionIssueIds?: Maybe<Array<Scalars['Int']>>;
  transitionIssueMealIds?: Maybe<Array<Scalars['Int']>>;
  transitionIssueOther?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for CancellationSurvey. */
export type CancellationSurveyConnection = {
  __typename?: 'CancellationSurveyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CancellationSurveyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CancellationSurvey>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of CancellationSurveyCreate */
export type CancellationSurveyCreateInput = {
  cancellationSurveyInput: CancellationSurveyInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CancellationSurveyCreate. */
export type CancellationSurveyCreatePayload = {
  __typename?: 'CancellationSurveyCreatePayload';
  cancellationSurvey: CancellationSurvey;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CancellationSurveyDelete */
export type CancellationSurveyDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of CancellationSurveyDelete. */
export type CancellationSurveyDeletePayload = {
  __typename?: 'CancellationSurveyDeletePayload';
  cancellationSurvey: CancellationSurvey;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type CancellationSurveyEdge = {
  __typename?: 'CancellationSurveyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CancellationSurvey>;
};

export type CancellationSurveyInput = {
  additionalFeedback?: InputMaybe<Scalars['String']>;
  budgetGrade?: InputMaybe<Scalars['String']>;
  budgetTopper?: InputMaybe<Scalars['String']>;
  budgetWorth?: InputMaybe<Scalars['String']>;
  cancellationReasonId?: InputMaybe<Scalars['Int']>;
  cancellationReasonOther?: InputMaybe<Scalars['String']>;
  cancellationReasonOtherMoreDetails?: InputMaybe<Scalars['String']>;
  covidReasonId?: InputMaybe<Scalars['Int']>;
  covidReasonOther?: InputMaybe<Scalars['String']>;
  customerCareIssueId?: InputMaybe<Scalars['Int']>;
  customerCareIssueOther?: InputMaybe<Scalars['String']>;
  deliveryIssueId?: InputMaybe<Scalars['Int']>;
  deliveryIssueOther?: InputMaybe<Scalars['String']>;
  deliveryScheduleIssueGuidelines?: InputMaybe<Scalars['String']>;
  deliveryScheduleIssueId?: InputMaybe<Scalars['Int']>;
  deliveryScheduleIssueOther?: InputMaybe<Scalars['String']>;
  fitTransition?: InputMaybe<Scalars['String']>;
  foodTypeBrandId?: InputMaybe<Scalars['Int']>;
  foodTypeBrandOther?: InputMaybe<Scalars['String']>;
  foodTypeId?: InputMaybe<Scalars['Int']>;
  foodTypeOther?: InputMaybe<Scalars['String']>;
  keepReceivingEmails?: InputMaybe<Scalars['Boolean']>;
  mealQualityIssueId?: InputMaybe<Scalars['Int']>;
  mealQualityIssueMealIds?: InputMaybe<Array<Scalars['Int']>>;
  mealQualityIssueOther?: InputMaybe<Scalars['String']>;
  serviceIssueId?: InputMaybe<Scalars['Int']>;
  serviceIssueOther?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['Int']>;
  tasteResponseId?: InputMaybe<Scalars['Int']>;
  tasteResponseMealIds?: InputMaybe<Array<Scalars['Int']>>;
  tasteResponseOther?: InputMaybe<Scalars['String']>;
  transitionIssueIds?: InputMaybe<Array<Scalars['Int']>>;
  transitionIssueMealIds?: InputMaybe<Array<Scalars['Int']>>;
  transitionIssueOther?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CancellationSurveyUpdate */
export type CancellationSurveyUpdateInput = {
  cancellationSurveyInput: CancellationSurveyInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of CancellationSurveyUpdate. */
export type CancellationSurveyUpdatePayload = {
  __typename?: 'CancellationSurveyUpdatePayload';
  cancellationSurvey: CancellationSurvey;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export enum Celibacy {
  Neutered = 'neutered',
  NotNeutered = 'not_neutered',
  NotSpayed = 'not_spayed',
  Spayed = 'spayed'
}

export type Change = {
  __typename?: 'Change';
  key?: Maybe<Scalars['String']>;
  originalValue?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ChangelogEntry = {
  __typename?: 'ChangelogEntry';
  changes?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  event?: Maybe<Scalars['String']>;
  itemId: Scalars['ID'];
  itemType: Scalars['String'];
  whodunnit?: Maybe<Scalars['String']>;
};

/** The connection type for ChangelogEntry. */
export type ChangelogEntryConnection = {
  __typename?: 'ChangelogEntryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ChangelogEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ChangelogEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** An edge in a connection. */
export type ChangelogEntryEdge = {
  __typename?: 'ChangelogEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ChangelogEntry>;
};

export type Cms_Media = {
  __typename?: 'Cms_media';
  alt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filename?: Maybe<Scalars['String']>;
  filesize?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  sizes?: Maybe<Cms_Media_Sizes>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Cms_MediaCreateAccess = {
  __typename?: 'Cms_mediaCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_MediaCreateDocAccess = {
  __typename?: 'Cms_mediaCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_MediaDeleteAccess = {
  __typename?: 'Cms_mediaDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_MediaDeleteDocAccess = {
  __typename?: 'Cms_mediaDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_MediaDocAccessFields = {
  __typename?: 'Cms_mediaDocAccessFields';
  alt?: Maybe<Cms_MediaDocAccessFields_Alt>;
  createdAt?: Maybe<Cms_MediaDocAccessFields_CreatedAt>;
  filename?: Maybe<Cms_MediaDocAccessFields_Filename>;
  filesize?: Maybe<Cms_MediaDocAccessFields_Filesize>;
  height?: Maybe<Cms_MediaDocAccessFields_Height>;
  mimeType?: Maybe<Cms_MediaDocAccessFields_MimeType>;
  sizes?: Maybe<Cms_MediaDocAccessFields_Sizes>;
  updatedAt?: Maybe<Cms_MediaDocAccessFields_UpdatedAt>;
  url?: Maybe<Cms_MediaDocAccessFields_Url>;
  width?: Maybe<Cms_MediaDocAccessFields_Width>;
};

export type Cms_MediaDocAccessFields_Alt = {
  __typename?: 'Cms_mediaDocAccessFields_alt';
  create?: Maybe<Cms_MediaDocAccessFields_Alt_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Alt_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Alt_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Alt_Update>;
};

export type Cms_MediaDocAccessFields_Alt_Create = {
  __typename?: 'Cms_mediaDocAccessFields_alt_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Alt_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_alt_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Alt_Read = {
  __typename?: 'Cms_mediaDocAccessFields_alt_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Alt_Update = {
  __typename?: 'Cms_mediaDocAccessFields_alt_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_CreatedAt = {
  __typename?: 'Cms_mediaDocAccessFields_createdAt';
  create?: Maybe<Cms_MediaDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_CreatedAt_Update>;
};

export type Cms_MediaDocAccessFields_CreatedAt_Create = {
  __typename?: 'Cms_mediaDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_CreatedAt_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_CreatedAt_Read = {
  __typename?: 'Cms_mediaDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_CreatedAt_Update = {
  __typename?: 'Cms_mediaDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Filename = {
  __typename?: 'Cms_mediaDocAccessFields_filename';
  create?: Maybe<Cms_MediaDocAccessFields_Filename_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Filename_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Filename_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Filename_Update>;
};

export type Cms_MediaDocAccessFields_Filename_Create = {
  __typename?: 'Cms_mediaDocAccessFields_filename_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Filename_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_filename_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Filename_Read = {
  __typename?: 'Cms_mediaDocAccessFields_filename_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Filename_Update = {
  __typename?: 'Cms_mediaDocAccessFields_filename_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Filesize = {
  __typename?: 'Cms_mediaDocAccessFields_filesize';
  create?: Maybe<Cms_MediaDocAccessFields_Filesize_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Filesize_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Filesize_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Filesize_Update>;
};

export type Cms_MediaDocAccessFields_Filesize_Create = {
  __typename?: 'Cms_mediaDocAccessFields_filesize_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Filesize_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Filesize_Read = {
  __typename?: 'Cms_mediaDocAccessFields_filesize_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Filesize_Update = {
  __typename?: 'Cms_mediaDocAccessFields_filesize_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Height = {
  __typename?: 'Cms_mediaDocAccessFields_height';
  create?: Maybe<Cms_MediaDocAccessFields_Height_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Height_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Height_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Height_Update>;
};

export type Cms_MediaDocAccessFields_Height_Create = {
  __typename?: 'Cms_mediaDocAccessFields_height_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Height_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_height_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Height_Read = {
  __typename?: 'Cms_mediaDocAccessFields_height_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Height_Update = {
  __typename?: 'Cms_mediaDocAccessFields_height_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_MimeType = {
  __typename?: 'Cms_mediaDocAccessFields_mimeType';
  create?: Maybe<Cms_MediaDocAccessFields_MimeType_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_MimeType_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_MimeType_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_MimeType_Update>;
};

export type Cms_MediaDocAccessFields_MimeType_Create = {
  __typename?: 'Cms_mediaDocAccessFields_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_MimeType_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_MimeType_Read = {
  __typename?: 'Cms_mediaDocAccessFields_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_MimeType_Update = {
  __typename?: 'Cms_mediaDocAccessFields_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes = {
  __typename?: 'Cms_mediaDocAccessFields_sizes';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Delete>;
  fields?: Maybe<Cms_MediaDocAccessFields_Sizes_Fields>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Fields = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_Fields';
  card?: Maybe<Cms_MediaDocAccessFields_Sizes_Card>;
  tablet?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet>;
  thumbnail?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail>;
};

export type Cms_MediaDocAccessFields_Sizes_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Delete>;
  fields?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Fields>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Card_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Fields = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_Fields';
  filename?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Filename>;
  filesize?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Filesize>;
  height?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Height>;
  mimeType?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_MimeType>;
  url?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Url>;
  width?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Width>;
};

export type Cms_MediaDocAccessFields_Sizes_Card_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Filename = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_filename';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Filename_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Filename_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Filename_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Filename_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Card_Filename_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_filename_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Filename_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_filename_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Filename_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_filename_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Filename_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_filename_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Filesize = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_filesize';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Filesize_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Filesize_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Filesize_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Filesize_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Card_Filesize_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_filesize_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Filesize_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Filesize_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_filesize_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Filesize_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_filesize_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Height = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_height';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Height_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Height_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Height_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Height_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Card_Height_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_height_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Height_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_height_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Height_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_height_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Height_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_height_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_MimeType = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_mimeType';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_MimeType_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_MimeType_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_MimeType_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_MimeType_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Card_MimeType_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_MimeType_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_MimeType_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_MimeType_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Url = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_url';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Url_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Url_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Url_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Url_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Card_Url_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_url_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Url_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_url_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Url_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_url_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Url_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_url_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Width = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_width';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Width_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Width_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Width_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Card_Width_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Card_Width_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_width_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Width_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_width_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Width_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_width_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Card_Width_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_card_width_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Delete>;
  fields?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Fields>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Fields = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_Fields';
  filename?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Filename>;
  filesize?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Filesize>;
  height?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Height>;
  mimeType?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_MimeType>;
  url?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Url>;
  width?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Width>;
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Filename = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_filename';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Filename_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Filename_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Filename_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Filename_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Filename_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_filename_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Filename_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_filename_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Filename_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_filename_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Filename_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_filename_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Filesize = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_filesize';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Filesize_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Filesize_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Filesize_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Filesize_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Filesize_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_filesize_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Filesize_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Filesize_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_filesize_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Filesize_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_filesize_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Height = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_height';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Height_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Height_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Height_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Height_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Height_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_height_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Height_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_height_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Height_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_height_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Height_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_height_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_MimeType = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_mimeType';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_MimeType_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_MimeType_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_MimeType_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_MimeType_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_MimeType_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_MimeType_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_MimeType_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_MimeType_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Url = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_url';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Url_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Url_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Url_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Url_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Url_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_url_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Url_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_url_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Url_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_url_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Url_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_url_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Width = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_width';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Width_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Width_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Width_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Tablet_Width_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Width_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_width_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Width_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_width_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Width_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_width_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Tablet_Width_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_tablet_width_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Delete>;
  fields?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Fields>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Fields = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_Fields';
  filename?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Filename>;
  filesize?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Filesize>;
  height?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Height>;
  mimeType?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_MimeType>;
  url?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Url>;
  width?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Width>;
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Filename = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_filename';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Filename_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Filename_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Filename_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Filename_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Filename_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_filename_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Filename_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_filename_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Filename_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_filename_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Filename_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_filename_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Filesize = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_filesize';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Filesize_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Filesize_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Filesize_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Filesize_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Filesize_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_filesize_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Filesize_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Filesize_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_filesize_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Filesize_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_filesize_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Height = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_height';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Height_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Height_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Height_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Height_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Height_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_height_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Height_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_height_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Height_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_height_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Height_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_height_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_MimeType = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_mimeType';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_MimeType_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_MimeType_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_MimeType_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_MimeType_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_MimeType_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_MimeType_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_MimeType_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_MimeType_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Url = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_url';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Url_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Url_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Url_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Url_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Url_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_url_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Url_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_url_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Url_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_url_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Url_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_url_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Width = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_width';
  create?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Width_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Width_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Width_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Sizes_Thumbnail_Width_Update>;
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Width_Create = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_width_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Width_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_width_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Width_Read = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_width_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Sizes_Thumbnail_Width_Update = {
  __typename?: 'Cms_mediaDocAccessFields_sizes_thumbnail_width_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_UpdatedAt = {
  __typename?: 'Cms_mediaDocAccessFields_updatedAt';
  create?: Maybe<Cms_MediaDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_UpdatedAt_Update>;
};

export type Cms_MediaDocAccessFields_UpdatedAt_Create = {
  __typename?: 'Cms_mediaDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_UpdatedAt_Read = {
  __typename?: 'Cms_mediaDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_UpdatedAt_Update = {
  __typename?: 'Cms_mediaDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Url = {
  __typename?: 'Cms_mediaDocAccessFields_url';
  create?: Maybe<Cms_MediaDocAccessFields_Url_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Url_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Url_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Url_Update>;
};

export type Cms_MediaDocAccessFields_Url_Create = {
  __typename?: 'Cms_mediaDocAccessFields_url_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Url_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_url_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Url_Read = {
  __typename?: 'Cms_mediaDocAccessFields_url_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Url_Update = {
  __typename?: 'Cms_mediaDocAccessFields_url_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Width = {
  __typename?: 'Cms_mediaDocAccessFields_width';
  create?: Maybe<Cms_MediaDocAccessFields_Width_Create>;
  delete?: Maybe<Cms_MediaDocAccessFields_Width_Delete>;
  read?: Maybe<Cms_MediaDocAccessFields_Width_Read>;
  update?: Maybe<Cms_MediaDocAccessFields_Width_Update>;
};

export type Cms_MediaDocAccessFields_Width_Create = {
  __typename?: 'Cms_mediaDocAccessFields_width_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Width_Delete = {
  __typename?: 'Cms_mediaDocAccessFields_width_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Width_Read = {
  __typename?: 'Cms_mediaDocAccessFields_width_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaDocAccessFields_Width_Update = {
  __typename?: 'Cms_mediaDocAccessFields_width_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields = {
  __typename?: 'Cms_mediaFields';
  alt?: Maybe<Cms_MediaFields_Alt>;
  createdAt?: Maybe<Cms_MediaFields_CreatedAt>;
  filename?: Maybe<Cms_MediaFields_Filename>;
  filesize?: Maybe<Cms_MediaFields_Filesize>;
  height?: Maybe<Cms_MediaFields_Height>;
  mimeType?: Maybe<Cms_MediaFields_MimeType>;
  sizes?: Maybe<Cms_MediaFields_Sizes>;
  updatedAt?: Maybe<Cms_MediaFields_UpdatedAt>;
  url?: Maybe<Cms_MediaFields_Url>;
  width?: Maybe<Cms_MediaFields_Width>;
};

export type Cms_MediaFields_Alt = {
  __typename?: 'Cms_mediaFields_alt';
  create?: Maybe<Cms_MediaFields_Alt_Create>;
  delete?: Maybe<Cms_MediaFields_Alt_Delete>;
  read?: Maybe<Cms_MediaFields_Alt_Read>;
  update?: Maybe<Cms_MediaFields_Alt_Update>;
};

export type Cms_MediaFields_Alt_Create = {
  __typename?: 'Cms_mediaFields_alt_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Alt_Delete = {
  __typename?: 'Cms_mediaFields_alt_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Alt_Read = {
  __typename?: 'Cms_mediaFields_alt_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Alt_Update = {
  __typename?: 'Cms_mediaFields_alt_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_CreatedAt = {
  __typename?: 'Cms_mediaFields_createdAt';
  create?: Maybe<Cms_MediaFields_CreatedAt_Create>;
  delete?: Maybe<Cms_MediaFields_CreatedAt_Delete>;
  read?: Maybe<Cms_MediaFields_CreatedAt_Read>;
  update?: Maybe<Cms_MediaFields_CreatedAt_Update>;
};

export type Cms_MediaFields_CreatedAt_Create = {
  __typename?: 'Cms_mediaFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_CreatedAt_Delete = {
  __typename?: 'Cms_mediaFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_CreatedAt_Read = {
  __typename?: 'Cms_mediaFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_CreatedAt_Update = {
  __typename?: 'Cms_mediaFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Filename = {
  __typename?: 'Cms_mediaFields_filename';
  create?: Maybe<Cms_MediaFields_Filename_Create>;
  delete?: Maybe<Cms_MediaFields_Filename_Delete>;
  read?: Maybe<Cms_MediaFields_Filename_Read>;
  update?: Maybe<Cms_MediaFields_Filename_Update>;
};

export type Cms_MediaFields_Filename_Create = {
  __typename?: 'Cms_mediaFields_filename_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Filename_Delete = {
  __typename?: 'Cms_mediaFields_filename_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Filename_Read = {
  __typename?: 'Cms_mediaFields_filename_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Filename_Update = {
  __typename?: 'Cms_mediaFields_filename_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Filesize = {
  __typename?: 'Cms_mediaFields_filesize';
  create?: Maybe<Cms_MediaFields_Filesize_Create>;
  delete?: Maybe<Cms_MediaFields_Filesize_Delete>;
  read?: Maybe<Cms_MediaFields_Filesize_Read>;
  update?: Maybe<Cms_MediaFields_Filesize_Update>;
};

export type Cms_MediaFields_Filesize_Create = {
  __typename?: 'Cms_mediaFields_filesize_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Filesize_Delete = {
  __typename?: 'Cms_mediaFields_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Filesize_Read = {
  __typename?: 'Cms_mediaFields_filesize_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Filesize_Update = {
  __typename?: 'Cms_mediaFields_filesize_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Height = {
  __typename?: 'Cms_mediaFields_height';
  create?: Maybe<Cms_MediaFields_Height_Create>;
  delete?: Maybe<Cms_MediaFields_Height_Delete>;
  read?: Maybe<Cms_MediaFields_Height_Read>;
  update?: Maybe<Cms_MediaFields_Height_Update>;
};

export type Cms_MediaFields_Height_Create = {
  __typename?: 'Cms_mediaFields_height_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Height_Delete = {
  __typename?: 'Cms_mediaFields_height_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Height_Read = {
  __typename?: 'Cms_mediaFields_height_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Height_Update = {
  __typename?: 'Cms_mediaFields_height_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_MimeType = {
  __typename?: 'Cms_mediaFields_mimeType';
  create?: Maybe<Cms_MediaFields_MimeType_Create>;
  delete?: Maybe<Cms_MediaFields_MimeType_Delete>;
  read?: Maybe<Cms_MediaFields_MimeType_Read>;
  update?: Maybe<Cms_MediaFields_MimeType_Update>;
};

export type Cms_MediaFields_MimeType_Create = {
  __typename?: 'Cms_mediaFields_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_MimeType_Delete = {
  __typename?: 'Cms_mediaFields_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_MimeType_Read = {
  __typename?: 'Cms_mediaFields_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_MimeType_Update = {
  __typename?: 'Cms_mediaFields_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes = {
  __typename?: 'Cms_mediaFields_sizes';
  create?: Maybe<Cms_MediaFields_Sizes_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Delete>;
  fields?: Maybe<Cms_MediaFields_Sizes_Fields>;
  read?: Maybe<Cms_MediaFields_Sizes_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Update>;
};

export type Cms_MediaFields_Sizes_Create = {
  __typename?: 'Cms_mediaFields_sizes_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Delete = {
  __typename?: 'Cms_mediaFields_sizes_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Fields = {
  __typename?: 'Cms_mediaFields_sizes_Fields';
  card?: Maybe<Cms_MediaFields_Sizes_Card>;
  tablet?: Maybe<Cms_MediaFields_Sizes_Tablet>;
  thumbnail?: Maybe<Cms_MediaFields_Sizes_Thumbnail>;
};

export type Cms_MediaFields_Sizes_Read = {
  __typename?: 'Cms_mediaFields_sizes_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Update = {
  __typename?: 'Cms_mediaFields_sizes_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card = {
  __typename?: 'Cms_mediaFields_sizes_card';
  create?: Maybe<Cms_MediaFields_Sizes_Card_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Card_Delete>;
  fields?: Maybe<Cms_MediaFields_Sizes_Card_Fields>;
  read?: Maybe<Cms_MediaFields_Sizes_Card_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Card_Update>;
};

export type Cms_MediaFields_Sizes_Card_Create = {
  __typename?: 'Cms_mediaFields_sizes_card_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Delete = {
  __typename?: 'Cms_mediaFields_sizes_card_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Fields = {
  __typename?: 'Cms_mediaFields_sizes_card_Fields';
  filename?: Maybe<Cms_MediaFields_Sizes_Card_Filename>;
  filesize?: Maybe<Cms_MediaFields_Sizes_Card_Filesize>;
  height?: Maybe<Cms_MediaFields_Sizes_Card_Height>;
  mimeType?: Maybe<Cms_MediaFields_Sizes_Card_MimeType>;
  url?: Maybe<Cms_MediaFields_Sizes_Card_Url>;
  width?: Maybe<Cms_MediaFields_Sizes_Card_Width>;
};

export type Cms_MediaFields_Sizes_Card_Read = {
  __typename?: 'Cms_mediaFields_sizes_card_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Update = {
  __typename?: 'Cms_mediaFields_sizes_card_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Filename = {
  __typename?: 'Cms_mediaFields_sizes_card_filename';
  create?: Maybe<Cms_MediaFields_Sizes_Card_Filename_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Card_Filename_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Card_Filename_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Card_Filename_Update>;
};

export type Cms_MediaFields_Sizes_Card_Filename_Create = {
  __typename?: 'Cms_mediaFields_sizes_card_filename_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Filename_Delete = {
  __typename?: 'Cms_mediaFields_sizes_card_filename_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Filename_Read = {
  __typename?: 'Cms_mediaFields_sizes_card_filename_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Filename_Update = {
  __typename?: 'Cms_mediaFields_sizes_card_filename_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Filesize = {
  __typename?: 'Cms_mediaFields_sizes_card_filesize';
  create?: Maybe<Cms_MediaFields_Sizes_Card_Filesize_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Card_Filesize_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Card_Filesize_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Card_Filesize_Update>;
};

export type Cms_MediaFields_Sizes_Card_Filesize_Create = {
  __typename?: 'Cms_mediaFields_sizes_card_filesize_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Filesize_Delete = {
  __typename?: 'Cms_mediaFields_sizes_card_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Filesize_Read = {
  __typename?: 'Cms_mediaFields_sizes_card_filesize_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Filesize_Update = {
  __typename?: 'Cms_mediaFields_sizes_card_filesize_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Height = {
  __typename?: 'Cms_mediaFields_sizes_card_height';
  create?: Maybe<Cms_MediaFields_Sizes_Card_Height_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Card_Height_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Card_Height_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Card_Height_Update>;
};

export type Cms_MediaFields_Sizes_Card_Height_Create = {
  __typename?: 'Cms_mediaFields_sizes_card_height_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Height_Delete = {
  __typename?: 'Cms_mediaFields_sizes_card_height_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Height_Read = {
  __typename?: 'Cms_mediaFields_sizes_card_height_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Height_Update = {
  __typename?: 'Cms_mediaFields_sizes_card_height_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_MimeType = {
  __typename?: 'Cms_mediaFields_sizes_card_mimeType';
  create?: Maybe<Cms_MediaFields_Sizes_Card_MimeType_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Card_MimeType_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Card_MimeType_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Card_MimeType_Update>;
};

export type Cms_MediaFields_Sizes_Card_MimeType_Create = {
  __typename?: 'Cms_mediaFields_sizes_card_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_MimeType_Delete = {
  __typename?: 'Cms_mediaFields_sizes_card_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_MimeType_Read = {
  __typename?: 'Cms_mediaFields_sizes_card_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_MimeType_Update = {
  __typename?: 'Cms_mediaFields_sizes_card_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Url = {
  __typename?: 'Cms_mediaFields_sizes_card_url';
  create?: Maybe<Cms_MediaFields_Sizes_Card_Url_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Card_Url_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Card_Url_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Card_Url_Update>;
};

export type Cms_MediaFields_Sizes_Card_Url_Create = {
  __typename?: 'Cms_mediaFields_sizes_card_url_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Url_Delete = {
  __typename?: 'Cms_mediaFields_sizes_card_url_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Url_Read = {
  __typename?: 'Cms_mediaFields_sizes_card_url_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Url_Update = {
  __typename?: 'Cms_mediaFields_sizes_card_url_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Width = {
  __typename?: 'Cms_mediaFields_sizes_card_width';
  create?: Maybe<Cms_MediaFields_Sizes_Card_Width_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Card_Width_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Card_Width_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Card_Width_Update>;
};

export type Cms_MediaFields_Sizes_Card_Width_Create = {
  __typename?: 'Cms_mediaFields_sizes_card_width_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Width_Delete = {
  __typename?: 'Cms_mediaFields_sizes_card_width_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Width_Read = {
  __typename?: 'Cms_mediaFields_sizes_card_width_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Card_Width_Update = {
  __typename?: 'Cms_mediaFields_sizes_card_width_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet = {
  __typename?: 'Cms_mediaFields_sizes_tablet';
  create?: Maybe<Cms_MediaFields_Sizes_Tablet_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Tablet_Delete>;
  fields?: Maybe<Cms_MediaFields_Sizes_Tablet_Fields>;
  read?: Maybe<Cms_MediaFields_Sizes_Tablet_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Tablet_Update>;
};

export type Cms_MediaFields_Sizes_Tablet_Create = {
  __typename?: 'Cms_mediaFields_sizes_tablet_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Delete = {
  __typename?: 'Cms_mediaFields_sizes_tablet_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Fields = {
  __typename?: 'Cms_mediaFields_sizes_tablet_Fields';
  filename?: Maybe<Cms_MediaFields_Sizes_Tablet_Filename>;
  filesize?: Maybe<Cms_MediaFields_Sizes_Tablet_Filesize>;
  height?: Maybe<Cms_MediaFields_Sizes_Tablet_Height>;
  mimeType?: Maybe<Cms_MediaFields_Sizes_Tablet_MimeType>;
  url?: Maybe<Cms_MediaFields_Sizes_Tablet_Url>;
  width?: Maybe<Cms_MediaFields_Sizes_Tablet_Width>;
};

export type Cms_MediaFields_Sizes_Tablet_Read = {
  __typename?: 'Cms_mediaFields_sizes_tablet_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Update = {
  __typename?: 'Cms_mediaFields_sizes_tablet_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Filename = {
  __typename?: 'Cms_mediaFields_sizes_tablet_filename';
  create?: Maybe<Cms_MediaFields_Sizes_Tablet_Filename_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Tablet_Filename_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Tablet_Filename_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Tablet_Filename_Update>;
};

export type Cms_MediaFields_Sizes_Tablet_Filename_Create = {
  __typename?: 'Cms_mediaFields_sizes_tablet_filename_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Filename_Delete = {
  __typename?: 'Cms_mediaFields_sizes_tablet_filename_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Filename_Read = {
  __typename?: 'Cms_mediaFields_sizes_tablet_filename_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Filename_Update = {
  __typename?: 'Cms_mediaFields_sizes_tablet_filename_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Filesize = {
  __typename?: 'Cms_mediaFields_sizes_tablet_filesize';
  create?: Maybe<Cms_MediaFields_Sizes_Tablet_Filesize_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Tablet_Filesize_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Tablet_Filesize_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Tablet_Filesize_Update>;
};

export type Cms_MediaFields_Sizes_Tablet_Filesize_Create = {
  __typename?: 'Cms_mediaFields_sizes_tablet_filesize_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Filesize_Delete = {
  __typename?: 'Cms_mediaFields_sizes_tablet_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Filesize_Read = {
  __typename?: 'Cms_mediaFields_sizes_tablet_filesize_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Filesize_Update = {
  __typename?: 'Cms_mediaFields_sizes_tablet_filesize_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Height = {
  __typename?: 'Cms_mediaFields_sizes_tablet_height';
  create?: Maybe<Cms_MediaFields_Sizes_Tablet_Height_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Tablet_Height_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Tablet_Height_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Tablet_Height_Update>;
};

export type Cms_MediaFields_Sizes_Tablet_Height_Create = {
  __typename?: 'Cms_mediaFields_sizes_tablet_height_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Height_Delete = {
  __typename?: 'Cms_mediaFields_sizes_tablet_height_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Height_Read = {
  __typename?: 'Cms_mediaFields_sizes_tablet_height_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Height_Update = {
  __typename?: 'Cms_mediaFields_sizes_tablet_height_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_MimeType = {
  __typename?: 'Cms_mediaFields_sizes_tablet_mimeType';
  create?: Maybe<Cms_MediaFields_Sizes_Tablet_MimeType_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Tablet_MimeType_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Tablet_MimeType_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Tablet_MimeType_Update>;
};

export type Cms_MediaFields_Sizes_Tablet_MimeType_Create = {
  __typename?: 'Cms_mediaFields_sizes_tablet_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_MimeType_Delete = {
  __typename?: 'Cms_mediaFields_sizes_tablet_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_MimeType_Read = {
  __typename?: 'Cms_mediaFields_sizes_tablet_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_MimeType_Update = {
  __typename?: 'Cms_mediaFields_sizes_tablet_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Url = {
  __typename?: 'Cms_mediaFields_sizes_tablet_url';
  create?: Maybe<Cms_MediaFields_Sizes_Tablet_Url_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Tablet_Url_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Tablet_Url_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Tablet_Url_Update>;
};

export type Cms_MediaFields_Sizes_Tablet_Url_Create = {
  __typename?: 'Cms_mediaFields_sizes_tablet_url_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Url_Delete = {
  __typename?: 'Cms_mediaFields_sizes_tablet_url_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Url_Read = {
  __typename?: 'Cms_mediaFields_sizes_tablet_url_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Url_Update = {
  __typename?: 'Cms_mediaFields_sizes_tablet_url_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Width = {
  __typename?: 'Cms_mediaFields_sizes_tablet_width';
  create?: Maybe<Cms_MediaFields_Sizes_Tablet_Width_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Tablet_Width_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Tablet_Width_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Tablet_Width_Update>;
};

export type Cms_MediaFields_Sizes_Tablet_Width_Create = {
  __typename?: 'Cms_mediaFields_sizes_tablet_width_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Width_Delete = {
  __typename?: 'Cms_mediaFields_sizes_tablet_width_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Width_Read = {
  __typename?: 'Cms_mediaFields_sizes_tablet_width_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Tablet_Width_Update = {
  __typename?: 'Cms_mediaFields_sizes_tablet_width_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail';
  create?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Delete>;
  fields?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Fields>;
  read?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Update>;
};

export type Cms_MediaFields_Sizes_Thumbnail_Create = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Delete = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Fields = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_Fields';
  filename?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Filename>;
  filesize?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Filesize>;
  height?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Height>;
  mimeType?: Maybe<Cms_MediaFields_Sizes_Thumbnail_MimeType>;
  url?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Url>;
  width?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Width>;
};

export type Cms_MediaFields_Sizes_Thumbnail_Read = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Update = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Filename = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_filename';
  create?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Filename_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Filename_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Filename_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Filename_Update>;
};

export type Cms_MediaFields_Sizes_Thumbnail_Filename_Create = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_filename_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Filename_Delete = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_filename_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Filename_Read = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_filename_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Filename_Update = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_filename_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Filesize = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_filesize';
  create?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Filesize_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Filesize_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Filesize_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Filesize_Update>;
};

export type Cms_MediaFields_Sizes_Thumbnail_Filesize_Create = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_filesize_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Filesize_Delete = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Filesize_Read = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_filesize_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Filesize_Update = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_filesize_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Height = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_height';
  create?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Height_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Height_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Height_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Height_Update>;
};

export type Cms_MediaFields_Sizes_Thumbnail_Height_Create = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_height_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Height_Delete = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_height_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Height_Read = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_height_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Height_Update = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_height_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_MimeType = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_mimeType';
  create?: Maybe<Cms_MediaFields_Sizes_Thumbnail_MimeType_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Thumbnail_MimeType_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Thumbnail_MimeType_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Thumbnail_MimeType_Update>;
};

export type Cms_MediaFields_Sizes_Thumbnail_MimeType_Create = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_MimeType_Delete = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_MimeType_Read = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_MimeType_Update = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Url = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_url';
  create?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Url_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Url_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Url_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Url_Update>;
};

export type Cms_MediaFields_Sizes_Thumbnail_Url_Create = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_url_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Url_Delete = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_url_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Url_Read = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_url_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Url_Update = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_url_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Width = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_width';
  create?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Width_Create>;
  delete?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Width_Delete>;
  read?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Width_Read>;
  update?: Maybe<Cms_MediaFields_Sizes_Thumbnail_Width_Update>;
};

export type Cms_MediaFields_Sizes_Thumbnail_Width_Create = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_width_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Width_Delete = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_width_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Width_Read = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_width_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Sizes_Thumbnail_Width_Update = {
  __typename?: 'Cms_mediaFields_sizes_thumbnail_width_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_UpdatedAt = {
  __typename?: 'Cms_mediaFields_updatedAt';
  create?: Maybe<Cms_MediaFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_MediaFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_MediaFields_UpdatedAt_Read>;
  update?: Maybe<Cms_MediaFields_UpdatedAt_Update>;
};

export type Cms_MediaFields_UpdatedAt_Create = {
  __typename?: 'Cms_mediaFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_UpdatedAt_Delete = {
  __typename?: 'Cms_mediaFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_UpdatedAt_Read = {
  __typename?: 'Cms_mediaFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_UpdatedAt_Update = {
  __typename?: 'Cms_mediaFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Url = {
  __typename?: 'Cms_mediaFields_url';
  create?: Maybe<Cms_MediaFields_Url_Create>;
  delete?: Maybe<Cms_MediaFields_Url_Delete>;
  read?: Maybe<Cms_MediaFields_Url_Read>;
  update?: Maybe<Cms_MediaFields_Url_Update>;
};

export type Cms_MediaFields_Url_Create = {
  __typename?: 'Cms_mediaFields_url_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Url_Delete = {
  __typename?: 'Cms_mediaFields_url_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Url_Read = {
  __typename?: 'Cms_mediaFields_url_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Url_Update = {
  __typename?: 'Cms_mediaFields_url_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Width = {
  __typename?: 'Cms_mediaFields_width';
  create?: Maybe<Cms_MediaFields_Width_Create>;
  delete?: Maybe<Cms_MediaFields_Width_Delete>;
  read?: Maybe<Cms_MediaFields_Width_Read>;
  update?: Maybe<Cms_MediaFields_Width_Update>;
};

export type Cms_MediaFields_Width_Create = {
  __typename?: 'Cms_mediaFields_width_Create';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Width_Delete = {
  __typename?: 'Cms_mediaFields_width_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Width_Read = {
  __typename?: 'Cms_mediaFields_width_Read';
  permission: Scalars['Boolean'];
};

export type Cms_MediaFields_Width_Update = {
  __typename?: 'Cms_mediaFields_width_Update';
  permission: Scalars['Boolean'];
};

export type Cms_MediaReadAccess = {
  __typename?: 'Cms_mediaReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_MediaReadDocAccess = {
  __typename?: 'Cms_mediaReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_MediaUpdateAccess = {
  __typename?: 'Cms_mediaUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_MediaUpdateDocAccess = {
  __typename?: 'Cms_mediaUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_Media_Sizes = {
  __typename?: 'Cms_media_Sizes';
  card?: Maybe<Cms_Media_Sizes_Card>;
  tablet?: Maybe<Cms_Media_Sizes_Tablet>;
  thumbnail?: Maybe<Cms_Media_Sizes_Thumbnail>;
};

export type Cms_Media_Sizes_Card = {
  __typename?: 'Cms_media_Sizes_Card';
  filename?: Maybe<Scalars['String']>;
  filesize?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Cms_Media_Sizes_Tablet = {
  __typename?: 'Cms_media_Sizes_Tablet';
  filename?: Maybe<Scalars['String']>;
  filesize?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Cms_Media_Sizes_Thumbnail = {
  __typename?: 'Cms_media_Sizes_Thumbnail';
  filename?: Maybe<Scalars['String']>;
  filesize?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Cms_Media_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Cms_Media_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Cms_Media_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Cms_Media_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Cms_Media_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Cms_Media_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Cms_Media_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Cms_Media_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Cms_Media_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Cms_Media_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Cms_Media_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Cms_Media_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Cms_Media_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Cms_Media_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Media_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Media_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Media_Where_Or>>>;
  alt?: InputMaybe<Cms_Media_Alt_Operator>;
  createdAt?: InputMaybe<Cms_Media_CreatedAt_Operator>;
  filename?: InputMaybe<Cms_Media_Filename_Operator>;
  filesize?: InputMaybe<Cms_Media_Filesize_Operator>;
  height?: InputMaybe<Cms_Media_Height_Operator>;
  id?: InputMaybe<Cms_Media_Id_Operator>;
  mimeType?: InputMaybe<Cms_Media_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Cms_Media_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Cms_Media_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Cms_Media_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Cms_Media_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Cms_Media_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Cms_Media_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Cms_Media_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Cms_Media_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Cms_Media_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Cms_Media_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Cms_Media_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Cms_Media_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Cms_Media_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Cms_Media_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Cms_Media_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Cms_Media_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Cms_Media_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Cms_Media_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Cms_Media_UpdatedAt_Operator>;
  url?: InputMaybe<Cms_Media_Url_Operator>;
  width?: InputMaybe<Cms_Media_Width_Operator>;
};

export type Cms_Media_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Media_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Media_Where_Or>>>;
  alt?: InputMaybe<Cms_Media_Alt_Operator>;
  createdAt?: InputMaybe<Cms_Media_CreatedAt_Operator>;
  filename?: InputMaybe<Cms_Media_Filename_Operator>;
  filesize?: InputMaybe<Cms_Media_Filesize_Operator>;
  height?: InputMaybe<Cms_Media_Height_Operator>;
  id?: InputMaybe<Cms_Media_Id_Operator>;
  mimeType?: InputMaybe<Cms_Media_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Cms_Media_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Cms_Media_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Cms_Media_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Cms_Media_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Cms_Media_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Cms_Media_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Cms_Media_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Cms_Media_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Cms_Media_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Cms_Media_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Cms_Media_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Cms_Media_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Cms_Media_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Cms_Media_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Cms_Media_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Cms_Media_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Cms_Media_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Cms_Media_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Cms_Media_UpdatedAt_Operator>;
  url?: InputMaybe<Cms_Media_Url_Operator>;
  width?: InputMaybe<Cms_Media_Width_Operator>;
};

export type Cms_Media_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Media_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Media_Where_Or>>>;
  alt?: InputMaybe<Cms_Media_Alt_Operator>;
  createdAt?: InputMaybe<Cms_Media_CreatedAt_Operator>;
  filename?: InputMaybe<Cms_Media_Filename_Operator>;
  filesize?: InputMaybe<Cms_Media_Filesize_Operator>;
  height?: InputMaybe<Cms_Media_Height_Operator>;
  id?: InputMaybe<Cms_Media_Id_Operator>;
  mimeType?: InputMaybe<Cms_Media_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Cms_Media_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Cms_Media_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Cms_Media_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Cms_Media_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Cms_Media_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Cms_Media_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Cms_Media_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Cms_Media_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Cms_Media_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Cms_Media_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Cms_Media_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Cms_Media_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Cms_Media_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Cms_Media_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Cms_Media_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Cms_Media_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Cms_Media_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Cms_Media_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Cms_Media_UpdatedAt_Operator>;
  url?: InputMaybe<Cms_Media_Url_Operator>;
  width?: InputMaybe<Cms_Media_Width_Operator>;
};

export type Cms_Media_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Cms_Medias = {
  __typename?: 'Cms_medias';
  docs?: Maybe<Array<Maybe<Cms_Media>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type Cms_Page = {
  __typename?: 'Cms_page';
  _status?: Maybe<Cms_Page__Status>;
  breadcrumbs?: Maybe<Array<Cms_Page_Breadcrumbs>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  layout?: Maybe<Array<Cms_Page_Layout>>;
  meta?: Maybe<Cms_Page_Meta>;
  parent?: Maybe<Cms_Page>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Cms_PageCreateAccess = {
  __typename?: 'Cms_pageCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_PageCreateDocAccess = {
  __typename?: 'Cms_pageCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_PageDeleteAccess = {
  __typename?: 'Cms_pageDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_PageDeleteDocAccess = {
  __typename?: 'Cms_pageDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_PageDocAccessFields = {
  __typename?: 'Cms_pageDocAccessFields';
  _status?: Maybe<Cms_PageDocAccessFields__Status>;
  breadcrumbs?: Maybe<Cms_PageDocAccessFields_Breadcrumbs>;
  createdAt?: Maybe<Cms_PageDocAccessFields_CreatedAt>;
  layout?: Maybe<Cms_PageDocAccessFields_Layout>;
  meta?: Maybe<Cms_PageDocAccessFields_Meta>;
  parent?: Maybe<Cms_PageDocAccessFields_Parent>;
  slug?: Maybe<Cms_PageDocAccessFields_Slug>;
  title?: Maybe<Cms_PageDocAccessFields_Title>;
  updatedAt?: Maybe<Cms_PageDocAccessFields_UpdatedAt>;
};

export type Cms_PageDocAccessFields__Status = {
  __typename?: 'Cms_pageDocAccessFields__status';
  create?: Maybe<Cms_PageDocAccessFields__Status_Create>;
  delete?: Maybe<Cms_PageDocAccessFields__Status_Delete>;
  read?: Maybe<Cms_PageDocAccessFields__Status_Read>;
  update?: Maybe<Cms_PageDocAccessFields__Status_Update>;
};

export type Cms_PageDocAccessFields__Status_Create = {
  __typename?: 'Cms_pageDocAccessFields__status_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields__Status_Delete = {
  __typename?: 'Cms_pageDocAccessFields__status_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields__Status_Read = {
  __typename?: 'Cms_pageDocAccessFields__status_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields__Status_Update = {
  __typename?: 'Cms_pageDocAccessFields__status_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs';
  create?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Delete>;
  fields?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Fields>;
  read?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Read>;
  update?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Update>;
};

export type Cms_PageDocAccessFields_Breadcrumbs_Create = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Delete = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Fields = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_Fields';
  doc?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Doc>;
  id?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Id>;
  label?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Label>;
  url?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Url>;
};

export type Cms_PageDocAccessFields_Breadcrumbs_Read = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Update = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Doc = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_doc';
  create?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Doc_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Doc_Delete>;
  read?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Doc_Read>;
  update?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Doc_Update>;
};

export type Cms_PageDocAccessFields_Breadcrumbs_Doc_Create = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_doc_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Doc_Delete = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_doc_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Doc_Read = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_doc_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Doc_Update = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_doc_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Id = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_id';
  create?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Id_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Id_Delete>;
  read?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Id_Read>;
  update?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Id_Update>;
};

export type Cms_PageDocAccessFields_Breadcrumbs_Id_Create = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_id_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Id_Delete = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_id_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Id_Read = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_id_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Id_Update = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_id_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Label = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_label';
  create?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Label_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Label_Delete>;
  read?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Label_Read>;
  update?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Label_Update>;
};

export type Cms_PageDocAccessFields_Breadcrumbs_Label_Create = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_label_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Label_Delete = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_label_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Label_Read = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_label_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Label_Update = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_label_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Url = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_url';
  create?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Url_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Url_Delete>;
  read?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Url_Read>;
  update?: Maybe<Cms_PageDocAccessFields_Breadcrumbs_Url_Update>;
};

export type Cms_PageDocAccessFields_Breadcrumbs_Url_Create = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_url_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Url_Delete = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_url_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Url_Read = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_url_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Breadcrumbs_Url_Update = {
  __typename?: 'Cms_pageDocAccessFields_breadcrumbs_url_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_CreatedAt = {
  __typename?: 'Cms_pageDocAccessFields_createdAt';
  create?: Maybe<Cms_PageDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<Cms_PageDocAccessFields_CreatedAt_Read>;
  update?: Maybe<Cms_PageDocAccessFields_CreatedAt_Update>;
};

export type Cms_PageDocAccessFields_CreatedAt_Create = {
  __typename?: 'Cms_pageDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_CreatedAt_Delete = {
  __typename?: 'Cms_pageDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_CreatedAt_Read = {
  __typename?: 'Cms_pageDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_CreatedAt_Update = {
  __typename?: 'Cms_pageDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Layout = {
  __typename?: 'Cms_pageDocAccessFields_layout';
  create?: Maybe<Cms_PageDocAccessFields_Layout_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_Layout_Delete>;
  read?: Maybe<Cms_PageDocAccessFields_Layout_Read>;
  update?: Maybe<Cms_PageDocAccessFields_Layout_Update>;
};

export type Cms_PageDocAccessFields_Layout_Create = {
  __typename?: 'Cms_pageDocAccessFields_layout_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Layout_Delete = {
  __typename?: 'Cms_pageDocAccessFields_layout_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Layout_Read = {
  __typename?: 'Cms_pageDocAccessFields_layout_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Layout_Update = {
  __typename?: 'Cms_pageDocAccessFields_layout_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta = {
  __typename?: 'Cms_pageDocAccessFields_meta';
  create?: Maybe<Cms_PageDocAccessFields_Meta_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_Meta_Delete>;
  fields?: Maybe<Cms_PageDocAccessFields_Meta_Fields>;
  read?: Maybe<Cms_PageDocAccessFields_Meta_Read>;
  update?: Maybe<Cms_PageDocAccessFields_Meta_Update>;
};

export type Cms_PageDocAccessFields_Meta_Create = {
  __typename?: 'Cms_pageDocAccessFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Delete = {
  __typename?: 'Cms_pageDocAccessFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Fields = {
  __typename?: 'Cms_pageDocAccessFields_meta_Fields';
  description?: Maybe<Cms_PageDocAccessFields_Meta_Description>;
  keywords?: Maybe<Cms_PageDocAccessFields_Meta_Keywords>;
  title?: Maybe<Cms_PageDocAccessFields_Meta_Title>;
};

export type Cms_PageDocAccessFields_Meta_Read = {
  __typename?: 'Cms_pageDocAccessFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Update = {
  __typename?: 'Cms_pageDocAccessFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Description = {
  __typename?: 'Cms_pageDocAccessFields_meta_description';
  create?: Maybe<Cms_PageDocAccessFields_Meta_Description_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_Meta_Description_Delete>;
  read?: Maybe<Cms_PageDocAccessFields_Meta_Description_Read>;
  update?: Maybe<Cms_PageDocAccessFields_Meta_Description_Update>;
};

export type Cms_PageDocAccessFields_Meta_Description_Create = {
  __typename?: 'Cms_pageDocAccessFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Description_Delete = {
  __typename?: 'Cms_pageDocAccessFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Description_Read = {
  __typename?: 'Cms_pageDocAccessFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Description_Update = {
  __typename?: 'Cms_pageDocAccessFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Keywords = {
  __typename?: 'Cms_pageDocAccessFields_meta_keywords';
  create?: Maybe<Cms_PageDocAccessFields_Meta_Keywords_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_Meta_Keywords_Delete>;
  read?: Maybe<Cms_PageDocAccessFields_Meta_Keywords_Read>;
  update?: Maybe<Cms_PageDocAccessFields_Meta_Keywords_Update>;
};

export type Cms_PageDocAccessFields_Meta_Keywords_Create = {
  __typename?: 'Cms_pageDocAccessFields_meta_keywords_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Keywords_Delete = {
  __typename?: 'Cms_pageDocAccessFields_meta_keywords_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Keywords_Read = {
  __typename?: 'Cms_pageDocAccessFields_meta_keywords_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Keywords_Update = {
  __typename?: 'Cms_pageDocAccessFields_meta_keywords_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Title = {
  __typename?: 'Cms_pageDocAccessFields_meta_title';
  create?: Maybe<Cms_PageDocAccessFields_Meta_Title_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_Meta_Title_Delete>;
  read?: Maybe<Cms_PageDocAccessFields_Meta_Title_Read>;
  update?: Maybe<Cms_PageDocAccessFields_Meta_Title_Update>;
};

export type Cms_PageDocAccessFields_Meta_Title_Create = {
  __typename?: 'Cms_pageDocAccessFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Title_Delete = {
  __typename?: 'Cms_pageDocAccessFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Title_Read = {
  __typename?: 'Cms_pageDocAccessFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Meta_Title_Update = {
  __typename?: 'Cms_pageDocAccessFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Parent = {
  __typename?: 'Cms_pageDocAccessFields_parent';
  create?: Maybe<Cms_PageDocAccessFields_Parent_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_Parent_Delete>;
  read?: Maybe<Cms_PageDocAccessFields_Parent_Read>;
  update?: Maybe<Cms_PageDocAccessFields_Parent_Update>;
};

export type Cms_PageDocAccessFields_Parent_Create = {
  __typename?: 'Cms_pageDocAccessFields_parent_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Parent_Delete = {
  __typename?: 'Cms_pageDocAccessFields_parent_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Parent_Read = {
  __typename?: 'Cms_pageDocAccessFields_parent_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Parent_Update = {
  __typename?: 'Cms_pageDocAccessFields_parent_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Slug = {
  __typename?: 'Cms_pageDocAccessFields_slug';
  create?: Maybe<Cms_PageDocAccessFields_Slug_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_Slug_Delete>;
  read?: Maybe<Cms_PageDocAccessFields_Slug_Read>;
  update?: Maybe<Cms_PageDocAccessFields_Slug_Update>;
};

export type Cms_PageDocAccessFields_Slug_Create = {
  __typename?: 'Cms_pageDocAccessFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Slug_Delete = {
  __typename?: 'Cms_pageDocAccessFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Slug_Read = {
  __typename?: 'Cms_pageDocAccessFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Slug_Update = {
  __typename?: 'Cms_pageDocAccessFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Title = {
  __typename?: 'Cms_pageDocAccessFields_title';
  create?: Maybe<Cms_PageDocAccessFields_Title_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_Title_Delete>;
  read?: Maybe<Cms_PageDocAccessFields_Title_Read>;
  update?: Maybe<Cms_PageDocAccessFields_Title_Update>;
};

export type Cms_PageDocAccessFields_Title_Create = {
  __typename?: 'Cms_pageDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Title_Delete = {
  __typename?: 'Cms_pageDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Title_Read = {
  __typename?: 'Cms_pageDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_Title_Update = {
  __typename?: 'Cms_pageDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_UpdatedAt = {
  __typename?: 'Cms_pageDocAccessFields_updatedAt';
  create?: Maybe<Cms_PageDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_PageDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_PageDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<Cms_PageDocAccessFields_UpdatedAt_Update>;
};

export type Cms_PageDocAccessFields_UpdatedAt_Create = {
  __typename?: 'Cms_pageDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'Cms_pageDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_UpdatedAt_Read = {
  __typename?: 'Cms_pageDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageDocAccessFields_UpdatedAt_Update = {
  __typename?: 'Cms_pageDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields = {
  __typename?: 'Cms_pageFields';
  _status?: Maybe<Cms_PageFields__Status>;
  breadcrumbs?: Maybe<Cms_PageFields_Breadcrumbs>;
  createdAt?: Maybe<Cms_PageFields_CreatedAt>;
  layout?: Maybe<Cms_PageFields_Layout>;
  meta?: Maybe<Cms_PageFields_Meta>;
  parent?: Maybe<Cms_PageFields_Parent>;
  slug?: Maybe<Cms_PageFields_Slug>;
  title?: Maybe<Cms_PageFields_Title>;
  updatedAt?: Maybe<Cms_PageFields_UpdatedAt>;
};

export type Cms_PageFields__Status = {
  __typename?: 'Cms_pageFields__status';
  create?: Maybe<Cms_PageFields__Status_Create>;
  delete?: Maybe<Cms_PageFields__Status_Delete>;
  read?: Maybe<Cms_PageFields__Status_Read>;
  update?: Maybe<Cms_PageFields__Status_Update>;
};

export type Cms_PageFields__Status_Create = {
  __typename?: 'Cms_pageFields__status_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields__Status_Delete = {
  __typename?: 'Cms_pageFields__status_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields__Status_Read = {
  __typename?: 'Cms_pageFields__status_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields__Status_Update = {
  __typename?: 'Cms_pageFields__status_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs = {
  __typename?: 'Cms_pageFields_breadcrumbs';
  create?: Maybe<Cms_PageFields_Breadcrumbs_Create>;
  delete?: Maybe<Cms_PageFields_Breadcrumbs_Delete>;
  fields?: Maybe<Cms_PageFields_Breadcrumbs_Fields>;
  read?: Maybe<Cms_PageFields_Breadcrumbs_Read>;
  update?: Maybe<Cms_PageFields_Breadcrumbs_Update>;
};

export type Cms_PageFields_Breadcrumbs_Create = {
  __typename?: 'Cms_pageFields_breadcrumbs_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Delete = {
  __typename?: 'Cms_pageFields_breadcrumbs_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Fields = {
  __typename?: 'Cms_pageFields_breadcrumbs_Fields';
  doc?: Maybe<Cms_PageFields_Breadcrumbs_Doc>;
  id?: Maybe<Cms_PageFields_Breadcrumbs_Id>;
  label?: Maybe<Cms_PageFields_Breadcrumbs_Label>;
  url?: Maybe<Cms_PageFields_Breadcrumbs_Url>;
};

export type Cms_PageFields_Breadcrumbs_Read = {
  __typename?: 'Cms_pageFields_breadcrumbs_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Update = {
  __typename?: 'Cms_pageFields_breadcrumbs_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Doc = {
  __typename?: 'Cms_pageFields_breadcrumbs_doc';
  create?: Maybe<Cms_PageFields_Breadcrumbs_Doc_Create>;
  delete?: Maybe<Cms_PageFields_Breadcrumbs_Doc_Delete>;
  read?: Maybe<Cms_PageFields_Breadcrumbs_Doc_Read>;
  update?: Maybe<Cms_PageFields_Breadcrumbs_Doc_Update>;
};

export type Cms_PageFields_Breadcrumbs_Doc_Create = {
  __typename?: 'Cms_pageFields_breadcrumbs_doc_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Doc_Delete = {
  __typename?: 'Cms_pageFields_breadcrumbs_doc_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Doc_Read = {
  __typename?: 'Cms_pageFields_breadcrumbs_doc_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Doc_Update = {
  __typename?: 'Cms_pageFields_breadcrumbs_doc_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Id = {
  __typename?: 'Cms_pageFields_breadcrumbs_id';
  create?: Maybe<Cms_PageFields_Breadcrumbs_Id_Create>;
  delete?: Maybe<Cms_PageFields_Breadcrumbs_Id_Delete>;
  read?: Maybe<Cms_PageFields_Breadcrumbs_Id_Read>;
  update?: Maybe<Cms_PageFields_Breadcrumbs_Id_Update>;
};

export type Cms_PageFields_Breadcrumbs_Id_Create = {
  __typename?: 'Cms_pageFields_breadcrumbs_id_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Id_Delete = {
  __typename?: 'Cms_pageFields_breadcrumbs_id_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Id_Read = {
  __typename?: 'Cms_pageFields_breadcrumbs_id_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Id_Update = {
  __typename?: 'Cms_pageFields_breadcrumbs_id_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Label = {
  __typename?: 'Cms_pageFields_breadcrumbs_label';
  create?: Maybe<Cms_PageFields_Breadcrumbs_Label_Create>;
  delete?: Maybe<Cms_PageFields_Breadcrumbs_Label_Delete>;
  read?: Maybe<Cms_PageFields_Breadcrumbs_Label_Read>;
  update?: Maybe<Cms_PageFields_Breadcrumbs_Label_Update>;
};

export type Cms_PageFields_Breadcrumbs_Label_Create = {
  __typename?: 'Cms_pageFields_breadcrumbs_label_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Label_Delete = {
  __typename?: 'Cms_pageFields_breadcrumbs_label_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Label_Read = {
  __typename?: 'Cms_pageFields_breadcrumbs_label_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Label_Update = {
  __typename?: 'Cms_pageFields_breadcrumbs_label_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Url = {
  __typename?: 'Cms_pageFields_breadcrumbs_url';
  create?: Maybe<Cms_PageFields_Breadcrumbs_Url_Create>;
  delete?: Maybe<Cms_PageFields_Breadcrumbs_Url_Delete>;
  read?: Maybe<Cms_PageFields_Breadcrumbs_Url_Read>;
  update?: Maybe<Cms_PageFields_Breadcrumbs_Url_Update>;
};

export type Cms_PageFields_Breadcrumbs_Url_Create = {
  __typename?: 'Cms_pageFields_breadcrumbs_url_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Url_Delete = {
  __typename?: 'Cms_pageFields_breadcrumbs_url_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Url_Read = {
  __typename?: 'Cms_pageFields_breadcrumbs_url_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Breadcrumbs_Url_Update = {
  __typename?: 'Cms_pageFields_breadcrumbs_url_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_CreatedAt = {
  __typename?: 'Cms_pageFields_createdAt';
  create?: Maybe<Cms_PageFields_CreatedAt_Create>;
  delete?: Maybe<Cms_PageFields_CreatedAt_Delete>;
  read?: Maybe<Cms_PageFields_CreatedAt_Read>;
  update?: Maybe<Cms_PageFields_CreatedAt_Update>;
};

export type Cms_PageFields_CreatedAt_Create = {
  __typename?: 'Cms_pageFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_CreatedAt_Delete = {
  __typename?: 'Cms_pageFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_CreatedAt_Read = {
  __typename?: 'Cms_pageFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_CreatedAt_Update = {
  __typename?: 'Cms_pageFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Layout = {
  __typename?: 'Cms_pageFields_layout';
  create?: Maybe<Cms_PageFields_Layout_Create>;
  delete?: Maybe<Cms_PageFields_Layout_Delete>;
  read?: Maybe<Cms_PageFields_Layout_Read>;
  update?: Maybe<Cms_PageFields_Layout_Update>;
};

export type Cms_PageFields_Layout_Create = {
  __typename?: 'Cms_pageFields_layout_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Layout_Delete = {
  __typename?: 'Cms_pageFields_layout_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Layout_Read = {
  __typename?: 'Cms_pageFields_layout_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Layout_Update = {
  __typename?: 'Cms_pageFields_layout_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta = {
  __typename?: 'Cms_pageFields_meta';
  create?: Maybe<Cms_PageFields_Meta_Create>;
  delete?: Maybe<Cms_PageFields_Meta_Delete>;
  fields?: Maybe<Cms_PageFields_Meta_Fields>;
  read?: Maybe<Cms_PageFields_Meta_Read>;
  update?: Maybe<Cms_PageFields_Meta_Update>;
};

export type Cms_PageFields_Meta_Create = {
  __typename?: 'Cms_pageFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Delete = {
  __typename?: 'Cms_pageFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Fields = {
  __typename?: 'Cms_pageFields_meta_Fields';
  description?: Maybe<Cms_PageFields_Meta_Description>;
  keywords?: Maybe<Cms_PageFields_Meta_Keywords>;
  title?: Maybe<Cms_PageFields_Meta_Title>;
};

export type Cms_PageFields_Meta_Read = {
  __typename?: 'Cms_pageFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Update = {
  __typename?: 'Cms_pageFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Description = {
  __typename?: 'Cms_pageFields_meta_description';
  create?: Maybe<Cms_PageFields_Meta_Description_Create>;
  delete?: Maybe<Cms_PageFields_Meta_Description_Delete>;
  read?: Maybe<Cms_PageFields_Meta_Description_Read>;
  update?: Maybe<Cms_PageFields_Meta_Description_Update>;
};

export type Cms_PageFields_Meta_Description_Create = {
  __typename?: 'Cms_pageFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Description_Delete = {
  __typename?: 'Cms_pageFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Description_Read = {
  __typename?: 'Cms_pageFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Description_Update = {
  __typename?: 'Cms_pageFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Keywords = {
  __typename?: 'Cms_pageFields_meta_keywords';
  create?: Maybe<Cms_PageFields_Meta_Keywords_Create>;
  delete?: Maybe<Cms_PageFields_Meta_Keywords_Delete>;
  read?: Maybe<Cms_PageFields_Meta_Keywords_Read>;
  update?: Maybe<Cms_PageFields_Meta_Keywords_Update>;
};

export type Cms_PageFields_Meta_Keywords_Create = {
  __typename?: 'Cms_pageFields_meta_keywords_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Keywords_Delete = {
  __typename?: 'Cms_pageFields_meta_keywords_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Keywords_Read = {
  __typename?: 'Cms_pageFields_meta_keywords_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Keywords_Update = {
  __typename?: 'Cms_pageFields_meta_keywords_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Title = {
  __typename?: 'Cms_pageFields_meta_title';
  create?: Maybe<Cms_PageFields_Meta_Title_Create>;
  delete?: Maybe<Cms_PageFields_Meta_Title_Delete>;
  read?: Maybe<Cms_PageFields_Meta_Title_Read>;
  update?: Maybe<Cms_PageFields_Meta_Title_Update>;
};

export type Cms_PageFields_Meta_Title_Create = {
  __typename?: 'Cms_pageFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Title_Delete = {
  __typename?: 'Cms_pageFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Title_Read = {
  __typename?: 'Cms_pageFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Meta_Title_Update = {
  __typename?: 'Cms_pageFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Parent = {
  __typename?: 'Cms_pageFields_parent';
  create?: Maybe<Cms_PageFields_Parent_Create>;
  delete?: Maybe<Cms_PageFields_Parent_Delete>;
  read?: Maybe<Cms_PageFields_Parent_Read>;
  update?: Maybe<Cms_PageFields_Parent_Update>;
};

export type Cms_PageFields_Parent_Create = {
  __typename?: 'Cms_pageFields_parent_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Parent_Delete = {
  __typename?: 'Cms_pageFields_parent_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Parent_Read = {
  __typename?: 'Cms_pageFields_parent_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Parent_Update = {
  __typename?: 'Cms_pageFields_parent_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Slug = {
  __typename?: 'Cms_pageFields_slug';
  create?: Maybe<Cms_PageFields_Slug_Create>;
  delete?: Maybe<Cms_PageFields_Slug_Delete>;
  read?: Maybe<Cms_PageFields_Slug_Read>;
  update?: Maybe<Cms_PageFields_Slug_Update>;
};

export type Cms_PageFields_Slug_Create = {
  __typename?: 'Cms_pageFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Slug_Delete = {
  __typename?: 'Cms_pageFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Slug_Read = {
  __typename?: 'Cms_pageFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Slug_Update = {
  __typename?: 'Cms_pageFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Title = {
  __typename?: 'Cms_pageFields_title';
  create?: Maybe<Cms_PageFields_Title_Create>;
  delete?: Maybe<Cms_PageFields_Title_Delete>;
  read?: Maybe<Cms_PageFields_Title_Read>;
  update?: Maybe<Cms_PageFields_Title_Update>;
};

export type Cms_PageFields_Title_Create = {
  __typename?: 'Cms_pageFields_title_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Title_Delete = {
  __typename?: 'Cms_pageFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Title_Read = {
  __typename?: 'Cms_pageFields_title_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_Title_Update = {
  __typename?: 'Cms_pageFields_title_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_UpdatedAt = {
  __typename?: 'Cms_pageFields_updatedAt';
  create?: Maybe<Cms_PageFields_UpdatedAt_Create>;
  delete?: Maybe<Cms_PageFields_UpdatedAt_Delete>;
  read?: Maybe<Cms_PageFields_UpdatedAt_Read>;
  update?: Maybe<Cms_PageFields_UpdatedAt_Update>;
};

export type Cms_PageFields_UpdatedAt_Create = {
  __typename?: 'Cms_pageFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_UpdatedAt_Delete = {
  __typename?: 'Cms_pageFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_UpdatedAt_Read = {
  __typename?: 'Cms_pageFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type Cms_PageFields_UpdatedAt_Update = {
  __typename?: 'Cms_pageFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type Cms_PageReadAccess = {
  __typename?: 'Cms_pageReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_PageReadDocAccess = {
  __typename?: 'Cms_pageReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_PageReadVersionsAccess = {
  __typename?: 'Cms_pageReadVersionsAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_PageReadVersionsDocAccess = {
  __typename?: 'Cms_pageReadVersionsDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_PageUpdateAccess = {
  __typename?: 'Cms_pageUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Cms_PageUpdateDocAccess = {
  __typename?: 'Cms_pageUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export enum Cms_PageUpdate__Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type Cms_PageVersion = {
  __typename?: 'Cms_pageVersion';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  latest?: Maybe<Scalars['Boolean']>;
  parent?: Maybe<Cms_Page>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Cms_PageVersion_Version>;
};

export type Cms_PageVersion_Version = {
  __typename?: 'Cms_pageVersion_Version';
  _status?: Maybe<Cms_PageVersion_Version__Status>;
  breadcrumbs?: Maybe<Array<Cms_PageVersion_Version_Breadcrumbs>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  layout?: Maybe<Array<Cms_PageVersion_Version_Layout>>;
  meta?: Maybe<Cms_PageVersion_Version_Meta>;
  parent?: Maybe<Cms_Page>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Cms_PageVersion_Version_Breadcrumbs = {
  __typename?: 'Cms_pageVersion_Version_Breadcrumbs';
  doc?: Maybe<Cms_Page>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Cms_PageVersion_Version_Layout = AccessibilityStatement | Accordion | Contact | FutureFreshBlock | HomepageHero | HowItWorksBlock | IconGrid | ImageBackgroundCta | ImageBackgroundHero | ImageTextComparison | ImageTextCta | InstagramPostsCarousel | KitchenSink | LargeHeadingHero | MultiCardCarousel | MultiCardGrid | NewsletterSignup | NumberedText | PdpHero | PlanCalculator | PreparedWaysBlock | PressLogos | ProductTwoUp | Quote | QuotesCarousel | RealFoodNoJunkBlock | Referrals | ReviewsList | SectionHeader | StoreLocator | ThreeUpContentCards | Wysiwyg | YotpoReviewsCarousel;

export type Cms_PageVersion_Version_Meta = {
  __typename?: 'Cms_pageVersion_Version_Meta';
  description?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum Cms_PageVersion_Version__Status {
  Draft = 'draft',
  Published = 'published'
}

export type Cms_Page_Breadcrumbs = {
  __typename?: 'Cms_page_Breadcrumbs';
  doc?: Maybe<Cms_Page>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Cms_Page_Layout = AccessibilityStatement | Accordion | Contact | FutureFreshBlock | HomepageHero | HowItWorksBlock | IconGrid | ImageBackgroundCta | ImageBackgroundHero | ImageTextComparison | ImageTextCta | InstagramPostsCarousel | KitchenSink | LargeHeadingHero | MultiCardCarousel | MultiCardGrid | NewsletterSignup | NumberedText | PdpHero | PlanCalculator | PreparedWaysBlock | PressLogos | ProductTwoUp | Quote | QuotesCarousel | RealFoodNoJunkBlock | Referrals | ReviewsList | SectionHeader | StoreLocator | ThreeUpContentCards | Wysiwyg | YotpoReviewsCarousel;

export type Cms_Page_Meta = {
  __typename?: 'Cms_page_Meta';
  description?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum Cms_Page__Status {
  Draft = 'draft',
  Published = 'published'
}

export enum Cms_Page__Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export enum Cms_Page__Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type Cms_Page__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<Cms_Page__Status_Input>>>;
  equals?: InputMaybe<Cms_Page__Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Cms_Page__Status_Input>>>;
  not_equals?: InputMaybe<Cms_Page__Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Cms_Page__Status_Input>>>;
};

export type Cms_Page_Breadcrumbs__Doc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Cms_Page_Breadcrumbs__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Page_Breadcrumbs__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Page_Breadcrumbs__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Page_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Cms_Page_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Page_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type Cms_Page_Meta__Keywords_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Page_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Page_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Cms_Page_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Page_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cms_Page_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Cms_Page_Where = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Page_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Page_Where_Or>>>;
  _status?: InputMaybe<Cms_Page__Status_Operator>;
  breadcrumbs__doc?: InputMaybe<Cms_Page_Breadcrumbs__Doc_Operator>;
  breadcrumbs__id?: InputMaybe<Cms_Page_Breadcrumbs__Id_Operator>;
  breadcrumbs__label?: InputMaybe<Cms_Page_Breadcrumbs__Label_Operator>;
  breadcrumbs__url?: InputMaybe<Cms_Page_Breadcrumbs__Url_Operator>;
  createdAt?: InputMaybe<Cms_Page_CreatedAt_Operator>;
  id?: InputMaybe<Cms_Page_Id_Operator>;
  meta__description?: InputMaybe<Cms_Page_Meta__Description_Operator>;
  meta__keywords?: InputMaybe<Cms_Page_Meta__Keywords_Operator>;
  meta__title?: InputMaybe<Cms_Page_Meta__Title_Operator>;
  parent?: InputMaybe<Cms_Page_Parent_Operator>;
  slug?: InputMaybe<Cms_Page_Slug_Operator>;
  title?: InputMaybe<Cms_Page_Title_Operator>;
  updatedAt?: InputMaybe<Cms_Page_UpdatedAt_Operator>;
};

export type Cms_Page_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Page_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Page_Where_Or>>>;
  _status?: InputMaybe<Cms_Page__Status_Operator>;
  breadcrumbs__doc?: InputMaybe<Cms_Page_Breadcrumbs__Doc_Operator>;
  breadcrumbs__id?: InputMaybe<Cms_Page_Breadcrumbs__Id_Operator>;
  breadcrumbs__label?: InputMaybe<Cms_Page_Breadcrumbs__Label_Operator>;
  breadcrumbs__url?: InputMaybe<Cms_Page_Breadcrumbs__Url_Operator>;
  createdAt?: InputMaybe<Cms_Page_CreatedAt_Operator>;
  id?: InputMaybe<Cms_Page_Id_Operator>;
  meta__description?: InputMaybe<Cms_Page_Meta__Description_Operator>;
  meta__keywords?: InputMaybe<Cms_Page_Meta__Keywords_Operator>;
  meta__title?: InputMaybe<Cms_Page_Meta__Title_Operator>;
  parent?: InputMaybe<Cms_Page_Parent_Operator>;
  slug?: InputMaybe<Cms_Page_Slug_Operator>;
  title?: InputMaybe<Cms_Page_Title_Operator>;
  updatedAt?: InputMaybe<Cms_Page_UpdatedAt_Operator>;
};

export type Cms_Page_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Cms_Page_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Cms_Page_Where_Or>>>;
  _status?: InputMaybe<Cms_Page__Status_Operator>;
  breadcrumbs__doc?: InputMaybe<Cms_Page_Breadcrumbs__Doc_Operator>;
  breadcrumbs__id?: InputMaybe<Cms_Page_Breadcrumbs__Id_Operator>;
  breadcrumbs__label?: InputMaybe<Cms_Page_Breadcrumbs__Label_Operator>;
  breadcrumbs__url?: InputMaybe<Cms_Page_Breadcrumbs__Url_Operator>;
  createdAt?: InputMaybe<Cms_Page_CreatedAt_Operator>;
  id?: InputMaybe<Cms_Page_Id_Operator>;
  meta__description?: InputMaybe<Cms_Page_Meta__Description_Operator>;
  meta__keywords?: InputMaybe<Cms_Page_Meta__Keywords_Operator>;
  meta__title?: InputMaybe<Cms_Page_Meta__Title_Operator>;
  parent?: InputMaybe<Cms_Page_Parent_Operator>;
  slug?: InputMaybe<Cms_Page_Slug_Operator>;
  title?: InputMaybe<Cms_Page_Title_Operator>;
  updatedAt?: InputMaybe<Cms_Page_UpdatedAt_Operator>;
};

export type Cms_Pages = {
  __typename?: 'Cms_pages';
  docs?: Maybe<Array<Maybe<Cms_Page>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type Contact = {
  __typename?: 'Contact';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<Contact_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['JSON']>;
  email?: Maybe<Scalars['String']>;
  facebookURL?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Contact_Image>;
  instagramURL?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['JSON']>;
  twitterURL?: Maybe<Scalars['String']>;
};


export type ContactDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type ContactTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Contact_BlockSettings = {
  __typename?: 'Contact_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<Contact_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<Contact_BlockSettings_ResponsiveStyles>>;
};

export type Contact_BlockSettings_ResponsiveStyles = {
  __typename?: 'Contact_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<Contact_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<Contact_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<Contact_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum Contact_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum Contact_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum Contact_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum Contact_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type Contact_Image = {
  __typename?: 'Contact_Image';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type Contact_ImageLgArgs = {
  where?: InputMaybe<Contact_Image_Lg_Where>;
};


export type Contact_ImageMdArgs = {
  where?: InputMaybe<Contact_Image_Md_Where>;
};


export type Contact_ImageSmArgs = {
  where?: InputMaybe<Contact_Image_Sm_Where>;
};


export type Contact_ImageXlArgs = {
  where?: InputMaybe<Contact_Image_Xl_Where>;
};


export type Contact_ImageXsArgs = {
  where?: InputMaybe<Contact_Image_Xs_Where>;
};


export type Contact_ImageXxlArgs = {
  where?: InputMaybe<Contact_Image_Xxl_Where>;
};


export type Contact_ImageXxsArgs = {
  where?: InputMaybe<Contact_Image_Xxs_Where>;
};

export type Contact_Image_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Lg_Height_Operator>;
  id?: InputMaybe<Contact_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Lg_Url_Operator>;
  width?: InputMaybe<Contact_Image_Lg_Width_Operator>;
};

export type Contact_Image_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Lg_Height_Operator>;
  id?: InputMaybe<Contact_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Lg_Url_Operator>;
  width?: InputMaybe<Contact_Image_Lg_Width_Operator>;
};

export type Contact_Image_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Lg_Height_Operator>;
  id?: InputMaybe<Contact_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Lg_Url_Operator>;
  width?: InputMaybe<Contact_Image_Lg_Width_Operator>;
};

export type Contact_Image_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Md_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Md_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Md_Height_Operator>;
  id?: InputMaybe<Contact_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Md_Url_Operator>;
  width?: InputMaybe<Contact_Image_Md_Width_Operator>;
};

export type Contact_Image_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Md_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Md_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Md_Height_Operator>;
  id?: InputMaybe<Contact_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Md_Url_Operator>;
  width?: InputMaybe<Contact_Image_Md_Width_Operator>;
};

export type Contact_Image_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Md_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Md_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Md_Height_Operator>;
  id?: InputMaybe<Contact_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Md_Url_Operator>;
  width?: InputMaybe<Contact_Image_Md_Width_Operator>;
};

export type Contact_Image_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Sm_Height_Operator>;
  id?: InputMaybe<Contact_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Sm_Url_Operator>;
  width?: InputMaybe<Contact_Image_Sm_Width_Operator>;
};

export type Contact_Image_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Sm_Height_Operator>;
  id?: InputMaybe<Contact_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Sm_Url_Operator>;
  width?: InputMaybe<Contact_Image_Sm_Width_Operator>;
};

export type Contact_Image_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Sm_Height_Operator>;
  id?: InputMaybe<Contact_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Sm_Url_Operator>;
  width?: InputMaybe<Contact_Image_Sm_Width_Operator>;
};

export type Contact_Image_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Xl_Height_Operator>;
  id?: InputMaybe<Contact_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Xl_Url_Operator>;
  width?: InputMaybe<Contact_Image_Xl_Width_Operator>;
};

export type Contact_Image_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Xl_Height_Operator>;
  id?: InputMaybe<Contact_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Xl_Url_Operator>;
  width?: InputMaybe<Contact_Image_Xl_Width_Operator>;
};

export type Contact_Image_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Xl_Height_Operator>;
  id?: InputMaybe<Contact_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Xl_Url_Operator>;
  width?: InputMaybe<Contact_Image_Xl_Width_Operator>;
};

export type Contact_Image_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Xs_Height_Operator>;
  id?: InputMaybe<Contact_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Xs_Url_Operator>;
  width?: InputMaybe<Contact_Image_Xs_Width_Operator>;
};

export type Contact_Image_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Xs_Height_Operator>;
  id?: InputMaybe<Contact_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Xs_Url_Operator>;
  width?: InputMaybe<Contact_Image_Xs_Width_Operator>;
};

export type Contact_Image_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Xs_Height_Operator>;
  id?: InputMaybe<Contact_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Xs_Url_Operator>;
  width?: InputMaybe<Contact_Image_Xs_Width_Operator>;
};

export type Contact_Image_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Xxl_Height_Operator>;
  id?: InputMaybe<Contact_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Xxl_Url_Operator>;
  width?: InputMaybe<Contact_Image_Xxl_Width_Operator>;
};

export type Contact_Image_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Xxl_Height_Operator>;
  id?: InputMaybe<Contact_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Xxl_Url_Operator>;
  width?: InputMaybe<Contact_Image_Xxl_Width_Operator>;
};

export type Contact_Image_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Xxl_Height_Operator>;
  id?: InputMaybe<Contact_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Xxl_Url_Operator>;
  width?: InputMaybe<Contact_Image_Xxl_Width_Operator>;
};

export type Contact_Image_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Contact_Image_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Contact_Image_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Contact_Image_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Xxs_Height_Operator>;
  id?: InputMaybe<Contact_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Xxs_Url_Operator>;
  width?: InputMaybe<Contact_Image_Xxs_Width_Operator>;
};

export type Contact_Image_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Xxs_Height_Operator>;
  id?: InputMaybe<Contact_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Xxs_Url_Operator>;
  width?: InputMaybe<Contact_Image_Xxs_Width_Operator>;
};

export type Contact_Image_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Contact_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Contact_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<Contact_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<Contact_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<Contact_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<Contact_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<Contact_Image_Xxs_Height_Operator>;
  id?: InputMaybe<Contact_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<Contact_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Contact_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Contact_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Contact_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Contact_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Contact_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<Contact_Image_Xxs_Url_Operator>;
  width?: InputMaybe<Contact_Image_Xxs_Width_Operator>;
};

export type Contact_Image_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ConversionSurvey = {
  __typename?: 'ConversionSurvey';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  otherWebsite?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  subscription?: Maybe<Subscription>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ConversionSurvey. */
export type ConversionSurveyConnection = {
  __typename?: 'ConversionSurveyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConversionSurveyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ConversionSurvey>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of ConversionSurveyCreate */
export type ConversionSurveyCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  conversionSurveyInput: ConversionSurveyInput;
};

/** Autogenerated return type of ConversionSurveyCreate. */
export type ConversionSurveyCreatePayload = {
  __typename?: 'ConversionSurveyCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  conversionSurvey: ConversionSurvey;
};

/** Autogenerated input type of ConversionSurveyDelete */
export type ConversionSurveyDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ConversionSurveyDelete. */
export type ConversionSurveyDeletePayload = {
  __typename?: 'ConversionSurveyDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  conversionSurvey: ConversionSurvey;
};

/** An edge in a connection. */
export type ConversionSurveyEdge = {
  __typename?: 'ConversionSurveyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ConversionSurvey>;
};

export type ConversionSurveyInput = {
  otherWebsite?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of ConversionSurveyUpdate */
export type ConversionSurveyUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  conversionSurveyInput: ConversionSurveyInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of ConversionSurveyUpdate. */
export type ConversionSurveyUpdatePayload = {
  __typename?: 'ConversionSurveyUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  conversionSurvey: ConversionSurvey;
};

export type CountStats = {
  __typename?: 'CountStats';
  active: Scalars['Int'];
  canceled: Scalars['Int'];
  created: Scalars['Int'];
  paused: Scalars['Int'];
};

export type Coupon = {
  __typename?: 'Coupon';
  affectedCollections?: Maybe<Array<Scalars['String']>>;
  affectedProductSkus?: Maybe<Array<Scalars['String']>>;
  affectsClass?: Maybe<ShopifyDiscountAffectsClass>;
  amountOff?: Maybe<Scalars['Float']>;
  attributionSource?: Maybe<Scalars['JSON']>;
  attributions?: Maybe<Scalars['JSON']>;
  campaignList?: Maybe<Scalars['JSON']>;
  cap?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  codeUniqueness?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  cupsOff?: Maybe<Scalars['Int']>;
  customDescription?: Maybe<Scalars['String']>;
  customPromoText?: Maybe<Scalars['String']>;
  cxDiscount?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  duration?: Maybe<CouponDurationEnum>;
  giftCardRedeemed?: Maybe<Scalars['Boolean']>;
  giftCardRedeemedDate?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  inferredBannerText?: Maybe<Scalars['String']>;
  isGiftCard: Scalars['Boolean'];
  isIncremental: Scalars['Boolean'];
  issuedOnBehalfOfUserId?: Maybe<Scalars['ID']>;
  linkable?: Maybe<Scalars['Boolean']>;
  linkedCoupon?: Maybe<Coupon>;
  linkedCouponId?: Maybe<Scalars['ID']>;
  maskedCode?: Maybe<Scalars['String']>;
  maxAllowedRedemptions?: Maybe<Scalars['Int']>;
  maxRepeatUses?: Maybe<Scalars['Int']>;
  newOrders: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['Int']>;
  permittedRoleList?: Maybe<Scalars['JSON']>;
  redeemedFrom?: Maybe<Scalars['ISO8601Date']>;
  redeemedUntil?: Maybe<Scalars['ISO8601Date']>;
  removeOnDeactivation: Scalars['Boolean'];
  repeatOrders: Scalars['Boolean'];
  restrictedEmailDomain?: Maybe<Scalars['String']>;
  shopifyId?: Maybe<Scalars['String']>;
  tagList?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  weeksOff?: Maybe<Scalars['Int']>;
};

/** The connection type for Coupon. */
export type CouponConnection = {
  __typename?: 'CouponConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CouponEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Coupon>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

export enum CouponDurationEnum {
  Forever = 'forever',
  Limited = 'limited'
}

/** An edge in a connection. */
export type CouponEdge = {
  __typename?: 'CouponEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Coupon>;
};

/** Autogenerated input type of CouponImport */
export type CouponImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
};

/** Autogenerated return type of CouponImport. */
export type CouponImportPayload = {
  __typename?: 'CouponImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<ShopifyCouponRefresh>;
};

/** Attributes for creating or updating a coupon */
export type CouponInput = {
  customPromoText?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  linkable?: InputMaybe<Scalars['Boolean']>;
  linkedCouponId?: InputMaybe<Scalars['Int']>;
  maskedCode?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CouponRefresh */
export type CouponRefreshInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** Autogenerated return type of CouponRefresh. */
export type CouponRefreshPayload = {
  __typename?: 'CouponRefreshPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<ShopifyCouponRefresh>;
};

/** Autogenerated input type of CouponUpdate */
export type CouponUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  couponInput: CouponInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of CouponUpdate. */
export type CouponUpdatePayload = {
  __typename?: 'CouponUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  coupon: Coupon;
};

/** Autogenerated input type of CreatePaymentBatchJob */
export type CreatePaymentBatchJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fulfillmentDate: Scalars['ISO8601DateTime'];
};

/** Autogenerated return type of CreatePaymentBatchJob. */
export type CreatePaymentBatchJobPayload = {
  __typename?: 'CreatePaymentBatchJobPayload';
  batchJob: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateUserForSubflow. */
export type CreateUserForSubflowPayload = {
  __typename?: 'CreateUserForSubflowPayload';
  authenticatable: User;
  /**
   * Authentication credentials. Null if after signUp resource is not active for
   * authentication (e.g. Email confirmation required).
   */
  credentials?: Maybe<Credential>;
  recommendationWizard: RecommendationWizard;
};

export type Credential = {
  __typename?: 'Credential';
  accessToken: Scalars['String'];
  client: Scalars['String'];
  expiry: Scalars['Int'];
  tokenType: Scalars['String'];
  uid: Scalars['String'];
};

export type DbOrder = {
  __typename?: 'DbOrder';
  addons?: Maybe<Array<PlanLineItem>>;
  amazonPoNumber?: Maybe<Scalars['String']>;
  amazonShipMethod?: Maybe<Scalars['String']>;
  attributionChannel?: Maybe<Scalars['String']>;
  attributionSource?: Maybe<Scalars['String']>;
  attributions?: Maybe<Scalars['JSON']>;
  cancelReason?: Maybe<Scalars['String']>;
  canceledBy?: Maybe<OrderAuditUser>;
  charges: Array<PpPayment>;
  chewyPoNumber?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  couponsData?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdBy?: Maybe<OrderAuditUser>;
  customer?: Maybe<User>;
  customerId?: Maybe<Scalars['String']>;
  eligibleForRecreation?: Maybe<Scalars['Boolean']>;
  entreePacks?: Maybe<Array<PlanLineItem>>;
  entrees?: Maybe<Array<PlanLineItem>>;
  estimatedDeliveryDate?: Maybe<Scalars['ISO8601Date']>;
  estimatedShippingDate?: Maybe<Scalars['ISO8601Date']>;
  estimatedTaxRate?: Maybe<Scalars['Float']>;
  freshBakedEntrees?: Maybe<Array<PlanLineItem>>;
  freshCookedEntrees?: Maybe<Array<PlanLineItem>>;
  humanizedState?: Maybe<OrderHumanizedState>;
  id?: Maybe<Scalars['Int']>;
  invoicePreview?: Maybe<ShopifyOrderInvoicePreview>;
  isCancellable?: Maybe<Scalars['Boolean']>;
  lastChargeSuccessful?: Maybe<Scalars['Boolean']>;
  lastShipmentEntry?: Maybe<ShipmentEntry>;
  legacyData?: Maybe<Scalars['JSON']>;
  lineItemsData?: Maybe<Scalars['JSON']>;
  metadata?: Maybe<Scalars['JSON']>;
  normalizedCoupons?: Maybe<Array<Scalars['JSON']>>;
  orderImportBatchEntry?: Maybe<OrderImportBatchEntry>;
  orderNumber?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<OrderStatusForCustomer>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentStatus?: Maybe<Scalars['String']>;
  petNames?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['Int']>;
  planSku?: Maybe<Scalars['String']>;
  renewal?: Maybe<Scalars['Boolean']>;
  shipments: Array<V2Shipment>;
  shippingAddress?: Maybe<Scalars['JSON']>;
  shopifyAdminGraphqlApiId?: Maybe<Scalars['String']>;
  shopifyAdminUrl?: Maybe<Scalars['String']>;
  shopifyId?: Maybe<Scalars['String']>;
  shopifyInvoiceUrl?: Maybe<Scalars['String']>;
  shopifyTotal?: Maybe<Scalars['String']>;
  state?: Maybe<OrderState>;
  statement?: Maybe<OrderStatement>;
  statementItemsList?: Maybe<Scalars['JSON']>;
  storeCredits?: Maybe<Array<StoreCreditMovement>>;
  subscription?: Maybe<Subscription>;
  supplements?: Maybe<Array<PlanLineItem>>;
  taggings?: Maybe<Array<Tagging>>;
  treats?: Maybe<Array<PlanLineItem>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for DbOrder. */
export type DbOrderConnection = {
  __typename?: 'DbOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DbOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DbOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of DbOrderCreate */
export type DbOrderCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: MutationsDbOrderEditInput;
};

/** Autogenerated return type of DbOrderCreate. */
export type DbOrderCreatePayload = {
  __typename?: 'DbOrderCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dbOrder: DbOrder;
};

/** Autogenerated input type of DbOrderDelete */
export type DbOrderDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DbOrderDelete. */
export type DbOrderDeletePayload = {
  __typename?: 'DbOrderDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dbOrder: DbOrder;
};

/** An edge in a connection. */
export type DbOrderEdge = {
  __typename?: 'DbOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<DbOrder>;
};

/** Autogenerated input type of DbOrderEdit */
export type DbOrderEditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: MutationsDbOrderEditInput;
};

/** Autogenerated return type of DbOrderEdit. */
export type DbOrderEditPayload = {
  __typename?: 'DbOrderEditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DbOrderInput = {
  addonLineItems?: InputMaybe<Array<TypesSubscriptionInputTypeLineItemInput>>;
  attributionChannel?: InputMaybe<TypesDbOrderInputTypeAttributionChannel>;
  attributionSource?: InputMaybe<TypesDbOrderInputTypeAttributionSource>;
  attributions?: InputMaybe<Scalars['JSON']>;
  cancel?: InputMaybe<Scalars['Boolean']>;
  charge?: InputMaybe<Scalars['Boolean']>;
  chewyPoNumber?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  couponsData?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['Int']>;
  enqueuePayment?: InputMaybe<Scalars['Boolean']>;
  entreeLineItems?: InputMaybe<Array<TypesSubscriptionInputTypeLineItemInput>>;
  estimatedShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  humanizedState?: InputMaybe<Scalars['String']>;
  legacyData?: InputMaybe<Scalars['JSON']>;
  lineItemsData?: InputMaybe<Scalars['JSON']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  orderImportBatchEntryId?: InputMaybe<Scalars['Int']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['Int']>;
  planId?: InputMaybe<Scalars['Int']>;
  shippingAddress?: InputMaybe<Scalars['JSON']>;
  shopifyAdminGraphqlApiId?: InputMaybe<Scalars['String']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  shopifyTotal?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<TypesDbOrderInputTypeState>;
  subscriptionId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of DbOrderRecreate */
export type DbOrderRecreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DbOrderRecreate. */
export type DbOrderRecreatePayload = {
  __typename?: 'DbOrderRecreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  newDbOrder: DbOrder;
};

/** Autogenerated input type of DbOrderReplace */
export type DbOrderReplaceInput = {
  addonLineItems?: InputMaybe<Array<TypesSubscriptionInputTypeLineItemInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  entreeLineItems?: InputMaybe<Array<TypesSubscriptionInputTypeLineItemInput>>;
  id: Scalars['ID'];
  reasonId: Scalars['Int'];
};

/** Autogenerated return type of DbOrderReplace. */
export type DbOrderReplacePayload = {
  __typename?: 'DbOrderReplacePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dbOrder: DbOrder;
};

/** Autogenerated input type of DbOrderUpdate */
export type DbOrderUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dbOrderInput: DbOrderInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of DbOrderUpdate. */
export type DbOrderUpdatePayload = {
  __typename?: 'DbOrderUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dbOrder: DbOrder;
};

export enum Discount {
  Amount = 'amount',
  Percent = 'percent'
}

export type DryIceMatrixTier = {
  __typename?: 'DryIceMatrixTier';
  boxSize?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  day1?: Maybe<Scalars['Int']>;
  day2?: Maybe<Scalars['Int']>;
  day3?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type DryIceMatrixTierInput = {
  day1?: InputMaybe<Scalars['Int']>;
  day2?: InputMaybe<Scalars['Int']>;
  day3?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of DryIceMatrixTierUpdate */
export type DryIceMatrixTierUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dryIceMatrixTierInput: DryIceMatrixTierInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of DryIceMatrixTierUpdate. */
export type DryIceMatrixTierUpdatePayload = {
  __typename?: 'DryIceMatrixTierUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dryIceMatrixTier: DryIceMatrixTier;
};

export type DryIcePackaging = {
  __typename?: 'DryIcePackaging';
  createdAt: Scalars['ISO8601DateTime'];
  dryIceBlocks: Scalars['Int'];
  id: Scalars['ID'];
  packaging?: Maybe<Packaging>;
  transitConfiguration?: Maybe<TransitConfiguration>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for DryIcePackaging. */
export type DryIcePackagingConnection = {
  __typename?: 'DryIcePackagingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DryIcePackagingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DryIcePackaging>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of DryIcePackagingCreate */
export type DryIcePackagingCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dryIcePackagingInput: DryIcePackagingInput;
};

/** Autogenerated return type of DryIcePackagingCreate. */
export type DryIcePackagingCreatePayload = {
  __typename?: 'DryIcePackagingCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dryIcePackaging: DryIcePackaging;
};

/** Autogenerated input type of DryIcePackagingDelete */
export type DryIcePackagingDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DryIcePackagingDelete. */
export type DryIcePackagingDeletePayload = {
  __typename?: 'DryIcePackagingDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dryIcePackaging: DryIcePackaging;
};

/** An edge in a connection. */
export type DryIcePackagingEdge = {
  __typename?: 'DryIcePackagingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<DryIcePackaging>;
};

export type DryIcePackagingInput = {
  dryIceBlocks?: InputMaybe<Scalars['Int']>;
  packagingId?: InputMaybe<Scalars['Int']>;
  transitConfigurationId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of DryIcePackagingMassCreate */
export type DryIcePackagingMassCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inputs: Array<MutationsDryIcePackagingMassCreateMassCreate>;
};

/** Autogenerated return type of DryIcePackagingMassCreate. */
export type DryIcePackagingMassCreatePayload = {
  __typename?: 'DryIcePackagingMassCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dryIcePackagings: Array<DryIcePackaging>;
};

/** Autogenerated input type of DryIcePackagingMassUpdate */
export type DryIcePackagingMassUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inputs: Array<MutationsDryIcePackagingMassUpdateMassUpdate>;
};

/** Autogenerated return type of DryIcePackagingMassUpdate. */
export type DryIcePackagingMassUpdatePayload = {
  __typename?: 'DryIcePackagingMassUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dryIcePackagings: Array<DryIcePackaging>;
};

export enum DryIcePackagingOrder {
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyModified = 'RECENTLY_MODIFIED'
}

/** Autogenerated input type of DryIcePackagingUpdate */
export type DryIcePackagingUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dryIcePackagingInput: DryIcePackagingInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of DryIcePackagingUpdate. */
export type DryIcePackagingUpdatePayload = {
  __typename?: 'DryIcePackagingUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dryIcePackaging: DryIcePackaging;
};

/** Autogenerated input type of DynamicLineItemPut */
export type DynamicLineItemPutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: MutationsDynamicLineItemPutInput;
};

/** Autogenerated return type of DynamicLineItemPut. */
export type DynamicLineItemPutPayload = {
  __typename?: 'DynamicLineItemPutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type FeedingGuideline = {
  __typename?: 'FeedingGuideline';
  calorieGroup?: Maybe<Scalars['Int']>;
  dailyIntake?: Maybe<Scalars['String']>;
  dryMeasure?: Maybe<Scalars['String']>;
  dryPortion?: Maybe<Scalars['Float']>;
  dryWeight?: Maybe<Scalars['Float']>;
  dryWeightMeasure?: Maybe<Scalars['String']>;
  frozenMeasure?: Maybe<Scalars['String']>;
  frozenPortion?: Maybe<Scalars['Float']>;
  frozenWeight?: Maybe<Scalars['Float']>;
  frozenWeightMeasure?: Maybe<Scalars['String']>;
  planType?: Maybe<Scalars['String']>;
};

export type Footer = {
  __typename?: 'Footer';
  createdAt?: Maybe<Scalars['DateTime']>;
  sections?: Maybe<Array<Footer_Sections>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FooterDocAccessFields = {
  __typename?: 'FooterDocAccessFields';
  createdAt?: Maybe<FooterDocAccessFields_CreatedAt>;
  sections?: Maybe<FooterDocAccessFields_Sections>;
  updatedAt?: Maybe<FooterDocAccessFields_UpdatedAt>;
};

export type FooterDocAccessFields_CreatedAt = {
  __typename?: 'FooterDocAccessFields_createdAt';
  create?: Maybe<FooterDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<FooterDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<FooterDocAccessFields_CreatedAt_Read>;
  update?: Maybe<FooterDocAccessFields_CreatedAt_Update>;
};

export type FooterDocAccessFields_CreatedAt_Create = {
  __typename?: 'FooterDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_CreatedAt_Delete = {
  __typename?: 'FooterDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_CreatedAt_Read = {
  __typename?: 'FooterDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_CreatedAt_Update = {
  __typename?: 'FooterDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections = {
  __typename?: 'FooterDocAccessFields_sections';
  create?: Maybe<FooterDocAccessFields_Sections_Create>;
  delete?: Maybe<FooterDocAccessFields_Sections_Delete>;
  fields?: Maybe<FooterDocAccessFields_Sections_Fields>;
  read?: Maybe<FooterDocAccessFields_Sections_Read>;
  update?: Maybe<FooterDocAccessFields_Sections_Update>;
};

export type FooterDocAccessFields_Sections_Create = {
  __typename?: 'FooterDocAccessFields_sections_Create';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Delete = {
  __typename?: 'FooterDocAccessFields_sections_Delete';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Fields = {
  __typename?: 'FooterDocAccessFields_sections_Fields';
  header?: Maybe<FooterDocAccessFields_Sections_Header>;
  id?: Maybe<FooterDocAccessFields_Sections_Id>;
  links?: Maybe<FooterDocAccessFields_Sections_Links>;
};

export type FooterDocAccessFields_Sections_Read = {
  __typename?: 'FooterDocAccessFields_sections_Read';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Update = {
  __typename?: 'FooterDocAccessFields_sections_Update';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Header = {
  __typename?: 'FooterDocAccessFields_sections_header';
  create?: Maybe<FooterDocAccessFields_Sections_Header_Create>;
  delete?: Maybe<FooterDocAccessFields_Sections_Header_Delete>;
  read?: Maybe<FooterDocAccessFields_Sections_Header_Read>;
  update?: Maybe<FooterDocAccessFields_Sections_Header_Update>;
};

export type FooterDocAccessFields_Sections_Header_Create = {
  __typename?: 'FooterDocAccessFields_sections_header_Create';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Header_Delete = {
  __typename?: 'FooterDocAccessFields_sections_header_Delete';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Header_Read = {
  __typename?: 'FooterDocAccessFields_sections_header_Read';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Header_Update = {
  __typename?: 'FooterDocAccessFields_sections_header_Update';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Id = {
  __typename?: 'FooterDocAccessFields_sections_id';
  create?: Maybe<FooterDocAccessFields_Sections_Id_Create>;
  delete?: Maybe<FooterDocAccessFields_Sections_Id_Delete>;
  read?: Maybe<FooterDocAccessFields_Sections_Id_Read>;
  update?: Maybe<FooterDocAccessFields_Sections_Id_Update>;
};

export type FooterDocAccessFields_Sections_Id_Create = {
  __typename?: 'FooterDocAccessFields_sections_id_Create';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Id_Delete = {
  __typename?: 'FooterDocAccessFields_sections_id_Delete';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Id_Read = {
  __typename?: 'FooterDocAccessFields_sections_id_Read';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Id_Update = {
  __typename?: 'FooterDocAccessFields_sections_id_Update';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links = {
  __typename?: 'FooterDocAccessFields_sections_links';
  create?: Maybe<FooterDocAccessFields_Sections_Links_Create>;
  delete?: Maybe<FooterDocAccessFields_Sections_Links_Delete>;
  fields?: Maybe<FooterDocAccessFields_Sections_Links_Fields>;
  read?: Maybe<FooterDocAccessFields_Sections_Links_Read>;
  update?: Maybe<FooterDocAccessFields_Sections_Links_Update>;
};

export type FooterDocAccessFields_Sections_Links_Create = {
  __typename?: 'FooterDocAccessFields_sections_links_Create';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Delete = {
  __typename?: 'FooterDocAccessFields_sections_links_Delete';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Fields = {
  __typename?: 'FooterDocAccessFields_sections_links_Fields';
  id?: Maybe<FooterDocAccessFields_Sections_Links_Id>;
  isLinkPrefetched?: Maybe<FooterDocAccessFields_Sections_Links_IsLinkPrefetched>;
  stripQueryParams?: Maybe<FooterDocAccessFields_Sections_Links_StripQueryParams>;
  title?: Maybe<FooterDocAccessFields_Sections_Links_Title>;
  url?: Maybe<FooterDocAccessFields_Sections_Links_Url>;
};

export type FooterDocAccessFields_Sections_Links_Read = {
  __typename?: 'FooterDocAccessFields_sections_links_Read';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Update = {
  __typename?: 'FooterDocAccessFields_sections_links_Update';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Id = {
  __typename?: 'FooterDocAccessFields_sections_links_id';
  create?: Maybe<FooterDocAccessFields_Sections_Links_Id_Create>;
  delete?: Maybe<FooterDocAccessFields_Sections_Links_Id_Delete>;
  read?: Maybe<FooterDocAccessFields_Sections_Links_Id_Read>;
  update?: Maybe<FooterDocAccessFields_Sections_Links_Id_Update>;
};

export type FooterDocAccessFields_Sections_Links_Id_Create = {
  __typename?: 'FooterDocAccessFields_sections_links_id_Create';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Id_Delete = {
  __typename?: 'FooterDocAccessFields_sections_links_id_Delete';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Id_Read = {
  __typename?: 'FooterDocAccessFields_sections_links_id_Read';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Id_Update = {
  __typename?: 'FooterDocAccessFields_sections_links_id_Update';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_IsLinkPrefetched = {
  __typename?: 'FooterDocAccessFields_sections_links_isLinkPrefetched';
  create?: Maybe<FooterDocAccessFields_Sections_Links_IsLinkPrefetched_Create>;
  delete?: Maybe<FooterDocAccessFields_Sections_Links_IsLinkPrefetched_Delete>;
  read?: Maybe<FooterDocAccessFields_Sections_Links_IsLinkPrefetched_Read>;
  update?: Maybe<FooterDocAccessFields_Sections_Links_IsLinkPrefetched_Update>;
};

export type FooterDocAccessFields_Sections_Links_IsLinkPrefetched_Create = {
  __typename?: 'FooterDocAccessFields_sections_links_isLinkPrefetched_Create';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_IsLinkPrefetched_Delete = {
  __typename?: 'FooterDocAccessFields_sections_links_isLinkPrefetched_Delete';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_IsLinkPrefetched_Read = {
  __typename?: 'FooterDocAccessFields_sections_links_isLinkPrefetched_Read';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_IsLinkPrefetched_Update = {
  __typename?: 'FooterDocAccessFields_sections_links_isLinkPrefetched_Update';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_StripQueryParams = {
  __typename?: 'FooterDocAccessFields_sections_links_stripQueryParams';
  create?: Maybe<FooterDocAccessFields_Sections_Links_StripQueryParams_Create>;
  delete?: Maybe<FooterDocAccessFields_Sections_Links_StripQueryParams_Delete>;
  read?: Maybe<FooterDocAccessFields_Sections_Links_StripQueryParams_Read>;
  update?: Maybe<FooterDocAccessFields_Sections_Links_StripQueryParams_Update>;
};

export type FooterDocAccessFields_Sections_Links_StripQueryParams_Create = {
  __typename?: 'FooterDocAccessFields_sections_links_stripQueryParams_Create';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_StripQueryParams_Delete = {
  __typename?: 'FooterDocAccessFields_sections_links_stripQueryParams_Delete';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_StripQueryParams_Read = {
  __typename?: 'FooterDocAccessFields_sections_links_stripQueryParams_Read';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_StripQueryParams_Update = {
  __typename?: 'FooterDocAccessFields_sections_links_stripQueryParams_Update';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Title = {
  __typename?: 'FooterDocAccessFields_sections_links_title';
  create?: Maybe<FooterDocAccessFields_Sections_Links_Title_Create>;
  delete?: Maybe<FooterDocAccessFields_Sections_Links_Title_Delete>;
  read?: Maybe<FooterDocAccessFields_Sections_Links_Title_Read>;
  update?: Maybe<FooterDocAccessFields_Sections_Links_Title_Update>;
};

export type FooterDocAccessFields_Sections_Links_Title_Create = {
  __typename?: 'FooterDocAccessFields_sections_links_title_Create';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Title_Delete = {
  __typename?: 'FooterDocAccessFields_sections_links_title_Delete';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Title_Read = {
  __typename?: 'FooterDocAccessFields_sections_links_title_Read';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Title_Update = {
  __typename?: 'FooterDocAccessFields_sections_links_title_Update';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Url = {
  __typename?: 'FooterDocAccessFields_sections_links_url';
  create?: Maybe<FooterDocAccessFields_Sections_Links_Url_Create>;
  delete?: Maybe<FooterDocAccessFields_Sections_Links_Url_Delete>;
  read?: Maybe<FooterDocAccessFields_Sections_Links_Url_Read>;
  update?: Maybe<FooterDocAccessFields_Sections_Links_Url_Update>;
};

export type FooterDocAccessFields_Sections_Links_Url_Create = {
  __typename?: 'FooterDocAccessFields_sections_links_url_Create';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Url_Delete = {
  __typename?: 'FooterDocAccessFields_sections_links_url_Delete';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Url_Read = {
  __typename?: 'FooterDocAccessFields_sections_links_url_Read';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_Sections_Links_Url_Update = {
  __typename?: 'FooterDocAccessFields_sections_links_url_Update';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_UpdatedAt = {
  __typename?: 'FooterDocAccessFields_updatedAt';
  create?: Maybe<FooterDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<FooterDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<FooterDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<FooterDocAccessFields_UpdatedAt_Update>;
};

export type FooterDocAccessFields_UpdatedAt_Create = {
  __typename?: 'FooterDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'FooterDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_UpdatedAt_Read = {
  __typename?: 'FooterDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type FooterDocAccessFields_UpdatedAt_Update = {
  __typename?: 'FooterDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type FooterFields = {
  __typename?: 'FooterFields';
  createdAt?: Maybe<FooterFields_CreatedAt>;
  sections?: Maybe<FooterFields_Sections>;
  updatedAt?: Maybe<FooterFields_UpdatedAt>;
};

export type FooterFields_CreatedAt = {
  __typename?: 'FooterFields_createdAt';
  create?: Maybe<FooterFields_CreatedAt_Create>;
  delete?: Maybe<FooterFields_CreatedAt_Delete>;
  read?: Maybe<FooterFields_CreatedAt_Read>;
  update?: Maybe<FooterFields_CreatedAt_Update>;
};

export type FooterFields_CreatedAt_Create = {
  __typename?: 'FooterFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type FooterFields_CreatedAt_Delete = {
  __typename?: 'FooterFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type FooterFields_CreatedAt_Read = {
  __typename?: 'FooterFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type FooterFields_CreatedAt_Update = {
  __typename?: 'FooterFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections = {
  __typename?: 'FooterFields_sections';
  create?: Maybe<FooterFields_Sections_Create>;
  delete?: Maybe<FooterFields_Sections_Delete>;
  fields?: Maybe<FooterFields_Sections_Fields>;
  read?: Maybe<FooterFields_Sections_Read>;
  update?: Maybe<FooterFields_Sections_Update>;
};

export type FooterFields_Sections_Create = {
  __typename?: 'FooterFields_sections_Create';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Delete = {
  __typename?: 'FooterFields_sections_Delete';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Fields = {
  __typename?: 'FooterFields_sections_Fields';
  header?: Maybe<FooterFields_Sections_Header>;
  id?: Maybe<FooterFields_Sections_Id>;
  links?: Maybe<FooterFields_Sections_Links>;
};

export type FooterFields_Sections_Read = {
  __typename?: 'FooterFields_sections_Read';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Update = {
  __typename?: 'FooterFields_sections_Update';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Header = {
  __typename?: 'FooterFields_sections_header';
  create?: Maybe<FooterFields_Sections_Header_Create>;
  delete?: Maybe<FooterFields_Sections_Header_Delete>;
  read?: Maybe<FooterFields_Sections_Header_Read>;
  update?: Maybe<FooterFields_Sections_Header_Update>;
};

export type FooterFields_Sections_Header_Create = {
  __typename?: 'FooterFields_sections_header_Create';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Header_Delete = {
  __typename?: 'FooterFields_sections_header_Delete';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Header_Read = {
  __typename?: 'FooterFields_sections_header_Read';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Header_Update = {
  __typename?: 'FooterFields_sections_header_Update';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Id = {
  __typename?: 'FooterFields_sections_id';
  create?: Maybe<FooterFields_Sections_Id_Create>;
  delete?: Maybe<FooterFields_Sections_Id_Delete>;
  read?: Maybe<FooterFields_Sections_Id_Read>;
  update?: Maybe<FooterFields_Sections_Id_Update>;
};

export type FooterFields_Sections_Id_Create = {
  __typename?: 'FooterFields_sections_id_Create';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Id_Delete = {
  __typename?: 'FooterFields_sections_id_Delete';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Id_Read = {
  __typename?: 'FooterFields_sections_id_Read';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Id_Update = {
  __typename?: 'FooterFields_sections_id_Update';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links = {
  __typename?: 'FooterFields_sections_links';
  create?: Maybe<FooterFields_Sections_Links_Create>;
  delete?: Maybe<FooterFields_Sections_Links_Delete>;
  fields?: Maybe<FooterFields_Sections_Links_Fields>;
  read?: Maybe<FooterFields_Sections_Links_Read>;
  update?: Maybe<FooterFields_Sections_Links_Update>;
};

export type FooterFields_Sections_Links_Create = {
  __typename?: 'FooterFields_sections_links_Create';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Delete = {
  __typename?: 'FooterFields_sections_links_Delete';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Fields = {
  __typename?: 'FooterFields_sections_links_Fields';
  id?: Maybe<FooterFields_Sections_Links_Id>;
  isLinkPrefetched?: Maybe<FooterFields_Sections_Links_IsLinkPrefetched>;
  stripQueryParams?: Maybe<FooterFields_Sections_Links_StripQueryParams>;
  title?: Maybe<FooterFields_Sections_Links_Title>;
  url?: Maybe<FooterFields_Sections_Links_Url>;
};

export type FooterFields_Sections_Links_Read = {
  __typename?: 'FooterFields_sections_links_Read';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Update = {
  __typename?: 'FooterFields_sections_links_Update';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Id = {
  __typename?: 'FooterFields_sections_links_id';
  create?: Maybe<FooterFields_Sections_Links_Id_Create>;
  delete?: Maybe<FooterFields_Sections_Links_Id_Delete>;
  read?: Maybe<FooterFields_Sections_Links_Id_Read>;
  update?: Maybe<FooterFields_Sections_Links_Id_Update>;
};

export type FooterFields_Sections_Links_Id_Create = {
  __typename?: 'FooterFields_sections_links_id_Create';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Id_Delete = {
  __typename?: 'FooterFields_sections_links_id_Delete';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Id_Read = {
  __typename?: 'FooterFields_sections_links_id_Read';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Id_Update = {
  __typename?: 'FooterFields_sections_links_id_Update';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_IsLinkPrefetched = {
  __typename?: 'FooterFields_sections_links_isLinkPrefetched';
  create?: Maybe<FooterFields_Sections_Links_IsLinkPrefetched_Create>;
  delete?: Maybe<FooterFields_Sections_Links_IsLinkPrefetched_Delete>;
  read?: Maybe<FooterFields_Sections_Links_IsLinkPrefetched_Read>;
  update?: Maybe<FooterFields_Sections_Links_IsLinkPrefetched_Update>;
};

export type FooterFields_Sections_Links_IsLinkPrefetched_Create = {
  __typename?: 'FooterFields_sections_links_isLinkPrefetched_Create';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_IsLinkPrefetched_Delete = {
  __typename?: 'FooterFields_sections_links_isLinkPrefetched_Delete';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_IsLinkPrefetched_Read = {
  __typename?: 'FooterFields_sections_links_isLinkPrefetched_Read';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_IsLinkPrefetched_Update = {
  __typename?: 'FooterFields_sections_links_isLinkPrefetched_Update';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_StripQueryParams = {
  __typename?: 'FooterFields_sections_links_stripQueryParams';
  create?: Maybe<FooterFields_Sections_Links_StripQueryParams_Create>;
  delete?: Maybe<FooterFields_Sections_Links_StripQueryParams_Delete>;
  read?: Maybe<FooterFields_Sections_Links_StripQueryParams_Read>;
  update?: Maybe<FooterFields_Sections_Links_StripQueryParams_Update>;
};

export type FooterFields_Sections_Links_StripQueryParams_Create = {
  __typename?: 'FooterFields_sections_links_stripQueryParams_Create';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_StripQueryParams_Delete = {
  __typename?: 'FooterFields_sections_links_stripQueryParams_Delete';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_StripQueryParams_Read = {
  __typename?: 'FooterFields_sections_links_stripQueryParams_Read';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_StripQueryParams_Update = {
  __typename?: 'FooterFields_sections_links_stripQueryParams_Update';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Title = {
  __typename?: 'FooterFields_sections_links_title';
  create?: Maybe<FooterFields_Sections_Links_Title_Create>;
  delete?: Maybe<FooterFields_Sections_Links_Title_Delete>;
  read?: Maybe<FooterFields_Sections_Links_Title_Read>;
  update?: Maybe<FooterFields_Sections_Links_Title_Update>;
};

export type FooterFields_Sections_Links_Title_Create = {
  __typename?: 'FooterFields_sections_links_title_Create';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Title_Delete = {
  __typename?: 'FooterFields_sections_links_title_Delete';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Title_Read = {
  __typename?: 'FooterFields_sections_links_title_Read';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Title_Update = {
  __typename?: 'FooterFields_sections_links_title_Update';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Url = {
  __typename?: 'FooterFields_sections_links_url';
  create?: Maybe<FooterFields_Sections_Links_Url_Create>;
  delete?: Maybe<FooterFields_Sections_Links_Url_Delete>;
  read?: Maybe<FooterFields_Sections_Links_Url_Read>;
  update?: Maybe<FooterFields_Sections_Links_Url_Update>;
};

export type FooterFields_Sections_Links_Url_Create = {
  __typename?: 'FooterFields_sections_links_url_Create';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Url_Delete = {
  __typename?: 'FooterFields_sections_links_url_Delete';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Url_Read = {
  __typename?: 'FooterFields_sections_links_url_Read';
  permission: Scalars['Boolean'];
};

export type FooterFields_Sections_Links_Url_Update = {
  __typename?: 'FooterFields_sections_links_url_Update';
  permission: Scalars['Boolean'];
};

export type FooterFields_UpdatedAt = {
  __typename?: 'FooterFields_updatedAt';
  create?: Maybe<FooterFields_UpdatedAt_Create>;
  delete?: Maybe<FooterFields_UpdatedAt_Delete>;
  read?: Maybe<FooterFields_UpdatedAt_Read>;
  update?: Maybe<FooterFields_UpdatedAt_Update>;
};

export type FooterFields_UpdatedAt_Create = {
  __typename?: 'FooterFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type FooterFields_UpdatedAt_Delete = {
  __typename?: 'FooterFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type FooterFields_UpdatedAt_Read = {
  __typename?: 'FooterFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type FooterFields_UpdatedAt_Update = {
  __typename?: 'FooterFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type FooterReadAccess = {
  __typename?: 'FooterReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FooterReadDocAccess = {
  __typename?: 'FooterReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FooterUpdateAccess = {
  __typename?: 'FooterUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FooterUpdateDocAccess = {
  __typename?: 'FooterUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Footer_Sections = {
  __typename?: 'Footer_Sections';
  header?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Footer_Sections_Links>>;
};

export type Footer_Sections_Links = {
  __typename?: 'Footer_Sections_Links';
  id?: Maybe<Scalars['String']>;
  isLinkPrefetched?: Maybe<Scalars['Boolean']>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type FulfillmentScheduleRule = {
  __typename?: 'FulfillmentScheduleRule';
  endDate?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['ID']>;
  jumpDate?: Maybe<Scalars['ISO8601DateTime']>;
  routeCode?: Maybe<Scalars['String']>;
  scheduleData?: Maybe<Scalars['JSON']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
  strategy?: Maybe<FulfillmentScheduleRuleStrategyEnum>;
  warehouseCode?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** The connection type for FulfillmentScheduleRule. */
export type FulfillmentScheduleRuleConnection = {
  __typename?: 'FulfillmentScheduleRuleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FulfillmentScheduleRuleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FulfillmentScheduleRule>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of FulfillmentScheduleRuleDelete */
export type FulfillmentScheduleRuleDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of FulfillmentScheduleRuleDelete. */
export type FulfillmentScheduleRuleDeletePayload = {
  __typename?: 'FulfillmentScheduleRuleDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  fulfillmentScheduleRule: FulfillmentScheduleRule;
};

/** An edge in a connection. */
export type FulfillmentScheduleRuleEdge = {
  __typename?: 'FulfillmentScheduleRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<FulfillmentScheduleRule>;
};

export type FulfillmentScheduleRuleInput = {
  endDate: Scalars['ISO8601DateTime'];
  jumpDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  routeCode?: InputMaybe<Scalars['String']>;
  scheduleData: Scalars['JSON'];
  startDate: Scalars['ISO8601DateTime'];
  strategy?: InputMaybe<FulfillmentScheduleRuleStrategyEnum>;
  warehouseCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export enum FulfillmentScheduleRuleStrategyEnum {
  ClosestAfter = 'closest_after',
  ClosestBefore = 'closest_before',
  Static = 'static'
}

/** Autogenerated input type of FulfillmentScheduleRulesCreate */
export type FulfillmentScheduleRulesCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: Array<FulfillmentScheduleRuleInput>;
};

/** Autogenerated return type of FulfillmentScheduleRulesCreate. */
export type FulfillmentScheduleRulesCreatePayload = {
  __typename?: 'FulfillmentScheduleRulesCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type FutureFreshBlock = {
  __typename?: 'FutureFreshBlock';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export enum Gender {
  Boy = 'Boy',
  Girl = 'Girl'
}

export type HomepageHero = {
  __typename?: 'HomepageHero';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type HowItWorksBlock = {
  __typename?: 'HowItWorksBlock';
  backgroundColor?: Maybe<HowItWorksBlock_BackgroundColor>;
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<HowItWorksBlock_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type HowItWorksBlock_BlockSettings = {
  __typename?: 'HowItWorksBlock_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<HowItWorksBlock_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<HowItWorksBlock_BlockSettings_ResponsiveStyles>>;
};

export type HowItWorksBlock_BlockSettings_ResponsiveStyles = {
  __typename?: 'HowItWorksBlock_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<HowItWorksBlock_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<HowItWorksBlock_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<HowItWorksBlock_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum HowItWorksBlock_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum HowItWorksBlock_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum HowItWorksBlock_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum HowItWorksBlock_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export enum HowItWorksBlock_BackgroundColor {
  Dark = 'dark',
  Light = 'light'
}

export type IconGrid = {
  __typename?: 'IconGrid';
  backgroundColor?: Maybe<IconGrid_BackgroundColor>;
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<IconGrid_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  button?: Maybe<IconGrid_Button>;
  cards?: Maybe<Array<IconGrid_Cards>>;
  id?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['JSON']>;
};


export type IconGridSubtitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type IconGridTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type IconGrid_BlockSettings = {
  __typename?: 'IconGrid_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<IconGrid_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<IconGrid_BlockSettings_ResponsiveStyles>>;
};

export type IconGrid_BlockSettings_ResponsiveStyles = {
  __typename?: 'IconGrid_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<IconGrid_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<IconGrid_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<IconGrid_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum IconGrid_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum IconGrid_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum IconGrid_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum IconGrid_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type IconGrid_Button = {
  __typename?: 'IconGrid_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<IconGrid_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<IconGrid_Button_Variant>;
};

export type IconGrid_Button_Link = {
  __typename?: 'IconGrid_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<IconGrid_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum IconGrid_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum IconGrid_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Text = 'text'
}

export type IconGrid_Cards = {
  __typename?: 'IconGrid_Cards';
  cardSubtitle?: Maybe<Scalars['JSON']>;
  cardTitle?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Cms_Media>;
};


export type IconGrid_CardsCardSubtitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type IconGrid_CardsCardTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type IconGrid_CardsImageArgs = {
  where?: InputMaybe<IconGrid_Cards_Image_Where>;
};

export type IconGrid_Cards_Image_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type IconGrid_Cards_Image_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type IconGrid_Cards_Image_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type IconGrid_Cards_Image_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type IconGrid_Cards_Image_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type IconGrid_Cards_Image_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type IconGrid_Cards_Image_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type IconGrid_Cards_Image_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type IconGrid_Cards_Image_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type IconGrid_Cards_Image_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type IconGrid_Cards_Image_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type IconGrid_Cards_Image_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type IconGrid_Cards_Image_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type IconGrid_Cards_Image_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IconGrid_Cards_Image_Where = {
  AND?: InputMaybe<Array<InputMaybe<IconGrid_Cards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<IconGrid_Cards_Image_Where_Or>>>;
  alt?: InputMaybe<IconGrid_Cards_Image_Alt_Operator>;
  createdAt?: InputMaybe<IconGrid_Cards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<IconGrid_Cards_Image_Filename_Operator>;
  filesize?: InputMaybe<IconGrid_Cards_Image_Filesize_Operator>;
  height?: InputMaybe<IconGrid_Cards_Image_Height_Operator>;
  id?: InputMaybe<IconGrid_Cards_Image_Id_Operator>;
  mimeType?: InputMaybe<IconGrid_Cards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<IconGrid_Cards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<IconGrid_Cards_Image_Url_Operator>;
  width?: InputMaybe<IconGrid_Cards_Image_Width_Operator>;
};

export type IconGrid_Cards_Image_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<IconGrid_Cards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<IconGrid_Cards_Image_Where_Or>>>;
  alt?: InputMaybe<IconGrid_Cards_Image_Alt_Operator>;
  createdAt?: InputMaybe<IconGrid_Cards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<IconGrid_Cards_Image_Filename_Operator>;
  filesize?: InputMaybe<IconGrid_Cards_Image_Filesize_Operator>;
  height?: InputMaybe<IconGrid_Cards_Image_Height_Operator>;
  id?: InputMaybe<IconGrid_Cards_Image_Id_Operator>;
  mimeType?: InputMaybe<IconGrid_Cards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<IconGrid_Cards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<IconGrid_Cards_Image_Url_Operator>;
  width?: InputMaybe<IconGrid_Cards_Image_Width_Operator>;
};

export type IconGrid_Cards_Image_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<IconGrid_Cards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<IconGrid_Cards_Image_Where_Or>>>;
  alt?: InputMaybe<IconGrid_Cards_Image_Alt_Operator>;
  createdAt?: InputMaybe<IconGrid_Cards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<IconGrid_Cards_Image_Filename_Operator>;
  filesize?: InputMaybe<IconGrid_Cards_Image_Filesize_Operator>;
  height?: InputMaybe<IconGrid_Cards_Image_Height_Operator>;
  id?: InputMaybe<IconGrid_Cards_Image_Id_Operator>;
  mimeType?: InputMaybe<IconGrid_Cards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<IconGrid_Cards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<IconGrid_Cards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<IconGrid_Cards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<IconGrid_Cards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<IconGrid_Cards_Image_Url_Operator>;
  width?: InputMaybe<IconGrid_Cards_Image_Width_Operator>;
};

export type IconGrid_Cards_Image_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export enum IconGrid_BackgroundColor {
  Blue = 'blue',
  Neutral = 'neutral',
  White = 'white'
}

export type ImageBackgroundCta = {
  __typename?: 'ImageBackgroundCta';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<ImageBackgroundCta_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<ImageBackgroundCta_Buttons>>;
  description?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<ImageBackgroundCta_Image>;
  imageGradient?: Maybe<ImageBackgroundCta_ImageGradient>;
  textAlignment?: Maybe<ImageBackgroundCta_TextAlignment>;
  textColor?: Maybe<ImageBackgroundCta_TextColor>;
  title?: Maybe<Scalars['JSON']>;
};


export type ImageBackgroundCtaDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type ImageBackgroundCtaTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type ImageBackgroundCta_BlockSettings = {
  __typename?: 'ImageBackgroundCta_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<ImageBackgroundCta_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<ImageBackgroundCta_BlockSettings_ResponsiveStyles>>;
};

export type ImageBackgroundCta_BlockSettings_ResponsiveStyles = {
  __typename?: 'ImageBackgroundCta_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<ImageBackgroundCta_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<ImageBackgroundCta_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<ImageBackgroundCta_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum ImageBackgroundCta_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum ImageBackgroundCta_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ImageBackgroundCta_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ImageBackgroundCta_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type ImageBackgroundCta_Buttons = {
  __typename?: 'ImageBackgroundCta_Buttons';
  button?: Maybe<ImageBackgroundCta_Buttons_Button>;
  id?: Maybe<Scalars['String']>;
};

export type ImageBackgroundCta_Buttons_Button = {
  __typename?: 'ImageBackgroundCta_Buttons_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<ImageBackgroundCta_Buttons_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<ImageBackgroundCta_Buttons_Button_Variant>;
};

export type ImageBackgroundCta_Buttons_Button_Link = {
  __typename?: 'ImageBackgroundCta_Buttons_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<ImageBackgroundCta_Buttons_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum ImageBackgroundCta_Buttons_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum ImageBackgroundCta_Buttons_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Text = 'text'
}

export type ImageBackgroundCta_Image = {
  __typename?: 'ImageBackgroundCta_Image';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type ImageBackgroundCta_ImageLgArgs = {
  where?: InputMaybe<ImageBackgroundCta_Image_Lg_Where>;
};


export type ImageBackgroundCta_ImageMdArgs = {
  where?: InputMaybe<ImageBackgroundCta_Image_Md_Where>;
};


export type ImageBackgroundCta_ImageSmArgs = {
  where?: InputMaybe<ImageBackgroundCta_Image_Sm_Where>;
};


export type ImageBackgroundCta_ImageXlArgs = {
  where?: InputMaybe<ImageBackgroundCta_Image_Xl_Where>;
};


export type ImageBackgroundCta_ImageXsArgs = {
  where?: InputMaybe<ImageBackgroundCta_Image_Xs_Where>;
};


export type ImageBackgroundCta_ImageXxlArgs = {
  where?: InputMaybe<ImageBackgroundCta_Image_Xxl_Where>;
};


export type ImageBackgroundCta_ImageXxsArgs = {
  where?: InputMaybe<ImageBackgroundCta_Image_Xxs_Where>;
};

export type ImageBackgroundCta_Image_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Lg_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Lg_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Lg_Width_Operator>;
};

export type ImageBackgroundCta_Image_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Lg_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Lg_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Lg_Width_Operator>;
};

export type ImageBackgroundCta_Image_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Lg_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Lg_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Lg_Width_Operator>;
};

export type ImageBackgroundCta_Image_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Md_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Md_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Md_Width_Operator>;
};

export type ImageBackgroundCta_Image_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Md_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Md_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Md_Width_Operator>;
};

export type ImageBackgroundCta_Image_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Md_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Md_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Md_Width_Operator>;
};

export type ImageBackgroundCta_Image_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Sm_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Sm_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Sm_Width_Operator>;
};

export type ImageBackgroundCta_Image_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Sm_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Sm_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Sm_Width_Operator>;
};

export type ImageBackgroundCta_Image_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Sm_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Sm_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Sm_Width_Operator>;
};

export type ImageBackgroundCta_Image_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Xl_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Xl_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Xl_Width_Operator>;
};

export type ImageBackgroundCta_Image_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Xl_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Xl_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Xl_Width_Operator>;
};

export type ImageBackgroundCta_Image_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Xl_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Xl_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Xl_Width_Operator>;
};

export type ImageBackgroundCta_Image_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Xs_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Xs_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Xs_Width_Operator>;
};

export type ImageBackgroundCta_Image_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Xs_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Xs_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Xs_Width_Operator>;
};

export type ImageBackgroundCta_Image_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Xs_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Xs_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Xs_Width_Operator>;
};

export type ImageBackgroundCta_Image_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Xxl_Width_Operator>;
};

export type ImageBackgroundCta_Image_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Xxl_Width_Operator>;
};

export type ImageBackgroundCta_Image_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Xxl_Width_Operator>;
};

export type ImageBackgroundCta_Image_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundCta_Image_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundCta_Image_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundCta_Image_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Xxs_Width_Operator>;
};

export type ImageBackgroundCta_Image_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Xxs_Width_Operator>;
};

export type ImageBackgroundCta_Image_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundCta_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundCta_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundCta_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundCta_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundCta_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundCta_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ImageBackgroundCta_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundCta_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundCta_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundCta_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ImageBackgroundCta_Image_Xxs_Width_Operator>;
};

export type ImageBackgroundCta_Image_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export enum ImageBackgroundCta_ImageGradient {
  Dark = 'dark',
  Light = 'light'
}

export enum ImageBackgroundCta_TextAlignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export enum ImageBackgroundCta_TextColor {
  Dark = 'dark',
  Light = 'light'
}

export type ImageBackgroundHero = {
  __typename?: 'ImageBackgroundHero';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<ImageBackgroundHero_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<ImageBackgroundHero_Buttons>>;
  description?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<ImageBackgroundHero_Image>;
  imageSide?: Maybe<ImageBackgroundHero_ImageSide>;
  title?: Maybe<Scalars['JSON']>;
};


export type ImageBackgroundHeroDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type ImageBackgroundHeroTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type ImageBackgroundHero_BlockSettings = {
  __typename?: 'ImageBackgroundHero_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<ImageBackgroundHero_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<ImageBackgroundHero_BlockSettings_ResponsiveStyles>>;
};

export type ImageBackgroundHero_BlockSettings_ResponsiveStyles = {
  __typename?: 'ImageBackgroundHero_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<ImageBackgroundHero_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<ImageBackgroundHero_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<ImageBackgroundHero_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum ImageBackgroundHero_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum ImageBackgroundHero_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ImageBackgroundHero_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ImageBackgroundHero_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type ImageBackgroundHero_Buttons = {
  __typename?: 'ImageBackgroundHero_Buttons';
  button?: Maybe<ImageBackgroundHero_Buttons_Button>;
  id?: Maybe<Scalars['String']>;
};

export type ImageBackgroundHero_Buttons_Button = {
  __typename?: 'ImageBackgroundHero_Buttons_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<ImageBackgroundHero_Buttons_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<ImageBackgroundHero_Buttons_Button_Variant>;
};

export type ImageBackgroundHero_Buttons_Button_Link = {
  __typename?: 'ImageBackgroundHero_Buttons_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<ImageBackgroundHero_Buttons_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum ImageBackgroundHero_Buttons_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum ImageBackgroundHero_Buttons_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Text = 'text'
}

export type ImageBackgroundHero_Image = {
  __typename?: 'ImageBackgroundHero_Image';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type ImageBackgroundHero_ImageLgArgs = {
  where?: InputMaybe<ImageBackgroundHero_Image_Lg_Where>;
};


export type ImageBackgroundHero_ImageMdArgs = {
  where?: InputMaybe<ImageBackgroundHero_Image_Md_Where>;
};


export type ImageBackgroundHero_ImageSmArgs = {
  where?: InputMaybe<ImageBackgroundHero_Image_Sm_Where>;
};


export type ImageBackgroundHero_ImageXlArgs = {
  where?: InputMaybe<ImageBackgroundHero_Image_Xl_Where>;
};


export type ImageBackgroundHero_ImageXsArgs = {
  where?: InputMaybe<ImageBackgroundHero_Image_Xs_Where>;
};


export type ImageBackgroundHero_ImageXxlArgs = {
  where?: InputMaybe<ImageBackgroundHero_Image_Xxl_Where>;
};


export type ImageBackgroundHero_ImageXxsArgs = {
  where?: InputMaybe<ImageBackgroundHero_Image_Xxs_Where>;
};

export type ImageBackgroundHero_Image_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Lg_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Lg_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Lg_Width_Operator>;
};

export type ImageBackgroundHero_Image_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Lg_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Lg_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Lg_Width_Operator>;
};

export type ImageBackgroundHero_Image_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Lg_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Lg_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Lg_Width_Operator>;
};

export type ImageBackgroundHero_Image_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Md_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Md_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Md_Width_Operator>;
};

export type ImageBackgroundHero_Image_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Md_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Md_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Md_Width_Operator>;
};

export type ImageBackgroundHero_Image_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Md_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Md_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Md_Width_Operator>;
};

export type ImageBackgroundHero_Image_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Sm_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Sm_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Sm_Width_Operator>;
};

export type ImageBackgroundHero_Image_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Sm_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Sm_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Sm_Width_Operator>;
};

export type ImageBackgroundHero_Image_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Sm_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Sm_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Sm_Width_Operator>;
};

export type ImageBackgroundHero_Image_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Xl_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Xl_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Xl_Width_Operator>;
};

export type ImageBackgroundHero_Image_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Xl_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Xl_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Xl_Width_Operator>;
};

export type ImageBackgroundHero_Image_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Xl_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Xl_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Xl_Width_Operator>;
};

export type ImageBackgroundHero_Image_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Xs_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Xs_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Xs_Width_Operator>;
};

export type ImageBackgroundHero_Image_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Xs_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Xs_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Xs_Width_Operator>;
};

export type ImageBackgroundHero_Image_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Xs_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Xs_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Xs_Width_Operator>;
};

export type ImageBackgroundHero_Image_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Xxl_Width_Operator>;
};

export type ImageBackgroundHero_Image_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Xxl_Width_Operator>;
};

export type ImageBackgroundHero_Image_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Xxl_Width_Operator>;
};

export type ImageBackgroundHero_Image_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageBackgroundHero_Image_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageBackgroundHero_Image_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageBackgroundHero_Image_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Xxs_Width_Operator>;
};

export type ImageBackgroundHero_Image_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Xxs_Width_Operator>;
};

export type ImageBackgroundHero_Image_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageBackgroundHero_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ImageBackgroundHero_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ImageBackgroundHero_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageBackgroundHero_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ImageBackgroundHero_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ImageBackgroundHero_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ImageBackgroundHero_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageBackgroundHero_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageBackgroundHero_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageBackgroundHero_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ImageBackgroundHero_Image_Xxs_Width_Operator>;
};

export type ImageBackgroundHero_Image_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export enum ImageBackgroundHero_ImageSide {
  Left = 'left',
  Right = 'right'
}

export type ImageTextComparison = {
  __typename?: 'ImageTextComparison';
  backgroundColor?: Maybe<ImageTextComparison_BackgroundColor>;
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<ImageTextComparison_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<ImageTextComparison_Buttons>>;
  contentLogoItems?: Maybe<Array<ImageTextComparison_ContentLogoItems>>;
  contentTitle?: Maybe<Scalars['JSON']>;
  hasRoundedCornerImage?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<ImageTextComparison_Image>;
  imageSide?: Maybe<ImageTextComparison_ImageSide>;
  title?: Maybe<Scalars['JSON']>;
};


export type ImageTextComparisonContentTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type ImageTextComparisonTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type ImageTextComparison_BlockSettings = {
  __typename?: 'ImageTextComparison_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<ImageTextComparison_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<ImageTextComparison_BlockSettings_ResponsiveStyles>>;
};

export type ImageTextComparison_BlockSettings_ResponsiveStyles = {
  __typename?: 'ImageTextComparison_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<ImageTextComparison_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<ImageTextComparison_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<ImageTextComparison_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum ImageTextComparison_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum ImageTextComparison_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ImageTextComparison_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ImageTextComparison_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type ImageTextComparison_Buttons = {
  __typename?: 'ImageTextComparison_Buttons';
  button?: Maybe<ImageTextComparison_Buttons_Button>;
  id?: Maybe<Scalars['String']>;
};

export type ImageTextComparison_Buttons_Button = {
  __typename?: 'ImageTextComparison_Buttons_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<ImageTextComparison_Buttons_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<ImageTextComparison_Buttons_Button_Variant>;
};

export type ImageTextComparison_Buttons_Button_Link = {
  __typename?: 'ImageTextComparison_Buttons_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<ImageTextComparison_Buttons_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum ImageTextComparison_Buttons_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum ImageTextComparison_Buttons_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Text = 'text'
}

export type ImageTextComparison_ContentLogoItems = {
  __typename?: 'ImageTextComparison_ContentLogoItems';
  id?: Maybe<Scalars['String']>;
  logo?: Maybe<Cms_Media>;
  text?: Maybe<Scalars['JSON']>;
};


export type ImageTextComparison_ContentLogoItemsLogoArgs = {
  where?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Where>;
};


export type ImageTextComparison_ContentLogoItemsTextArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Width_Operator>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Width_Operator>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_ContentLogoItems_Logo_Width_Operator>;
};

export type ImageTextComparison_ContentLogoItems_Logo_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image = {
  __typename?: 'ImageTextComparison_Image';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type ImageTextComparison_ImageLgArgs = {
  where?: InputMaybe<ImageTextComparison_Image_Lg_Where>;
};


export type ImageTextComparison_ImageMdArgs = {
  where?: InputMaybe<ImageTextComparison_Image_Md_Where>;
};


export type ImageTextComparison_ImageSmArgs = {
  where?: InputMaybe<ImageTextComparison_Image_Sm_Where>;
};


export type ImageTextComparison_ImageXlArgs = {
  where?: InputMaybe<ImageTextComparison_Image_Xl_Where>;
};


export type ImageTextComparison_ImageXsArgs = {
  where?: InputMaybe<ImageTextComparison_Image_Xs_Where>;
};


export type ImageTextComparison_ImageXxlArgs = {
  where?: InputMaybe<ImageTextComparison_Image_Xxl_Where>;
};


export type ImageTextComparison_ImageXxsArgs = {
  where?: InputMaybe<ImageTextComparison_Image_Xxs_Where>;
};

export type ImageTextComparison_Image_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Lg_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Lg_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Lg_Width_Operator>;
};

export type ImageTextComparison_Image_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Lg_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Lg_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Lg_Width_Operator>;
};

export type ImageTextComparison_Image_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Lg_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Lg_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Lg_Width_Operator>;
};

export type ImageTextComparison_Image_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Md_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Md_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Md_Width_Operator>;
};

export type ImageTextComparison_Image_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Md_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Md_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Md_Width_Operator>;
};

export type ImageTextComparison_Image_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Md_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Md_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Md_Width_Operator>;
};

export type ImageTextComparison_Image_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Sm_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Sm_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Sm_Width_Operator>;
};

export type ImageTextComparison_Image_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Sm_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Sm_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Sm_Width_Operator>;
};

export type ImageTextComparison_Image_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Sm_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Sm_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Sm_Width_Operator>;
};

export type ImageTextComparison_Image_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Xl_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Xl_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Xl_Width_Operator>;
};

export type ImageTextComparison_Image_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Xl_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Xl_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Xl_Width_Operator>;
};

export type ImageTextComparison_Image_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Xl_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Xl_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Xl_Width_Operator>;
};

export type ImageTextComparison_Image_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Xs_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Xs_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Xs_Width_Operator>;
};

export type ImageTextComparison_Image_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Xs_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Xs_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Xs_Width_Operator>;
};

export type ImageTextComparison_Image_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Xs_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Xs_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Xs_Width_Operator>;
};

export type ImageTextComparison_Image_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Xxl_Width_Operator>;
};

export type ImageTextComparison_Image_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Xxl_Width_Operator>;
};

export type ImageTextComparison_Image_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Xxl_Width_Operator>;
};

export type ImageTextComparison_Image_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextComparison_Image_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextComparison_Image_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextComparison_Image_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Xxs_Width_Operator>;
};

export type ImageTextComparison_Image_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Xxs_Width_Operator>;
};

export type ImageTextComparison_Image_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextComparison_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ImageTextComparison_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextComparison_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextComparison_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ImageTextComparison_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ImageTextComparison_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ImageTextComparison_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ImageTextComparison_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextComparison_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextComparison_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextComparison_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ImageTextComparison_Image_Xxs_Width_Operator>;
};

export type ImageTextComparison_Image_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export enum ImageTextComparison_BackgroundColor {
  Blue = 'blue',
  Neutral = 'neutral',
  White = 'white'
}

export enum ImageTextComparison_ImageSide {
  Left = 'left',
  Right = 'right'
}

export type ImageTextCta = {
  __typename?: 'ImageTextCta';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<ImageTextCta_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<ImageTextCta_Buttons>>;
  contentGridItems?: Maybe<Array<ImageTextCta_ContentGridItems>>;
  contentImageItems?: Maybe<Array<ImageTextCta_ContentImageItems>>;
  contentLogoItems?: Maybe<Array<ImageTextCta_ContentLogoItems>>;
  description?: Maybe<Scalars['JSON']>;
  eyebrow?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<ImageTextCta_Image>;
  imageSide?: Maybe<ImageTextCta_ImageSide>;
  layoutType?: Maybe<ImageTextCta_LayoutType>;
  title?: Maybe<Scalars['JSON']>;
};


export type ImageTextCtaDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type ImageTextCtaEyebrowArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type ImageTextCtaTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type ImageTextCta_BlockSettings = {
  __typename?: 'ImageTextCta_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<ImageTextCta_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<ImageTextCta_BlockSettings_ResponsiveStyles>>;
};

export type ImageTextCta_BlockSettings_ResponsiveStyles = {
  __typename?: 'ImageTextCta_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<ImageTextCta_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<ImageTextCta_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<ImageTextCta_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum ImageTextCta_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum ImageTextCta_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ImageTextCta_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ImageTextCta_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type ImageTextCta_Buttons = {
  __typename?: 'ImageTextCta_Buttons';
  button?: Maybe<ImageTextCta_Buttons_Button>;
  id?: Maybe<Scalars['String']>;
};

export type ImageTextCta_Buttons_Button = {
  __typename?: 'ImageTextCta_Buttons_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<ImageTextCta_Buttons_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<ImageTextCta_Buttons_Button_Variant>;
};

export type ImageTextCta_Buttons_Button_Link = {
  __typename?: 'ImageTextCta_Buttons_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<ImageTextCta_Buttons_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum ImageTextCta_Buttons_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum ImageTextCta_Buttons_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Text = 'text'
}

export type ImageTextCta_ContentGridItems = {
  __typename?: 'ImageTextCta_ContentGridItems';
  content?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type ImageTextCta_ContentGridItemsContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type ImageTextCta_ContentImageItems = {
  __typename?: 'ImageTextCta_ContentImageItems';
  content?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Cms_Media>;
};


export type ImageTextCta_ContentImageItemsContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type ImageTextCta_ContentImageItemsImageArgs = {
  where?: InputMaybe<ImageTextCta_ContentImageItems_Image_Where>;
};

export type ImageTextCta_ContentImageItems_Image_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_ContentImageItems_Image_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentImageItems_Image_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentImageItems_Image_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentImageItems_Image_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_ContentImageItems_Image_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentImageItems_Image_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_ContentImageItems_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_ContentImageItems_Image_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_ContentImageItems_Image_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_ContentImageItems_Image_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_ContentImageItems_Image_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_ContentImageItems_Image_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_ContentImageItems_Image_Height_Operator>;
  id?: InputMaybe<ImageTextCta_ContentImageItems_Image_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_ContentImageItems_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_ContentImageItems_Image_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_ContentImageItems_Image_Url_Operator>;
  width?: InputMaybe<ImageTextCta_ContentImageItems_Image_Width_Operator>;
};

export type ImageTextCta_ContentImageItems_Image_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_ContentImageItems_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_ContentImageItems_Image_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_ContentImageItems_Image_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_ContentImageItems_Image_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_ContentImageItems_Image_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_ContentImageItems_Image_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_ContentImageItems_Image_Height_Operator>;
  id?: InputMaybe<ImageTextCta_ContentImageItems_Image_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_ContentImageItems_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_ContentImageItems_Image_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_ContentImageItems_Image_Url_Operator>;
  width?: InputMaybe<ImageTextCta_ContentImageItems_Image_Width_Operator>;
};

export type ImageTextCta_ContentImageItems_Image_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_ContentImageItems_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_ContentImageItems_Image_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_ContentImageItems_Image_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_ContentImageItems_Image_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_ContentImageItems_Image_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_ContentImageItems_Image_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_ContentImageItems_Image_Height_Operator>;
  id?: InputMaybe<ImageTextCta_ContentImageItems_Image_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_ContentImageItems_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_ContentImageItems_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_ContentImageItems_Image_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_ContentImageItems_Image_Url_Operator>;
  width?: InputMaybe<ImageTextCta_ContentImageItems_Image_Width_Operator>;
};

export type ImageTextCta_ContentImageItems_Image_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentLogoItems = {
  __typename?: 'ImageTextCta_ContentLogoItems';
  id?: Maybe<Scalars['String']>;
  logo?: Maybe<Cms_Media>;
  title?: Maybe<Scalars['String']>;
};


export type ImageTextCta_ContentLogoItemsLogoArgs = {
  where?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Where>;
};

export type ImageTextCta_ContentLogoItems_Logo_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_ContentLogoItems_Logo_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentLogoItems_Logo_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentLogoItems_Logo_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_ContentLogoItems_Logo_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_ContentLogoItems_Logo_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_ContentLogoItems_Logo_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_ContentLogoItems_Logo_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_ContentLogoItems_Logo_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Height_Operator>;
  id?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Url_Operator>;
  width?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Width_Operator>;
};

export type ImageTextCta_ContentLogoItems_Logo_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_ContentLogoItems_Logo_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_ContentLogoItems_Logo_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Height_Operator>;
  id?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Url_Operator>;
  width?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Width_Operator>;
};

export type ImageTextCta_ContentLogoItems_Logo_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_ContentLogoItems_Logo_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_ContentLogoItems_Logo_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Height_Operator>;
  id?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Url_Operator>;
  width?: InputMaybe<ImageTextCta_ContentLogoItems_Logo_Width_Operator>;
};

export type ImageTextCta_ContentLogoItems_Logo_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image = {
  __typename?: 'ImageTextCta_Image';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type ImageTextCta_ImageLgArgs = {
  where?: InputMaybe<ImageTextCta_Image_Lg_Where>;
};


export type ImageTextCta_ImageMdArgs = {
  where?: InputMaybe<ImageTextCta_Image_Md_Where>;
};


export type ImageTextCta_ImageSmArgs = {
  where?: InputMaybe<ImageTextCta_Image_Sm_Where>;
};


export type ImageTextCta_ImageXlArgs = {
  where?: InputMaybe<ImageTextCta_Image_Xl_Where>;
};


export type ImageTextCta_ImageXsArgs = {
  where?: InputMaybe<ImageTextCta_Image_Xs_Where>;
};


export type ImageTextCta_ImageXxlArgs = {
  where?: InputMaybe<ImageTextCta_Image_Xxl_Where>;
};


export type ImageTextCta_ImageXxsArgs = {
  where?: InputMaybe<ImageTextCta_Image_Xxs_Where>;
};

export type ImageTextCta_Image_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Lg_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Lg_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Lg_Width_Operator>;
};

export type ImageTextCta_Image_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Lg_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Lg_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Lg_Width_Operator>;
};

export type ImageTextCta_Image_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Lg_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Lg_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Lg_Width_Operator>;
};

export type ImageTextCta_Image_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Md_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Md_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Md_Width_Operator>;
};

export type ImageTextCta_Image_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Md_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Md_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Md_Width_Operator>;
};

export type ImageTextCta_Image_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Md_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Md_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Md_Width_Operator>;
};

export type ImageTextCta_Image_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Sm_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Sm_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Sm_Width_Operator>;
};

export type ImageTextCta_Image_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Sm_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Sm_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Sm_Width_Operator>;
};

export type ImageTextCta_Image_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Sm_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Sm_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Sm_Width_Operator>;
};

export type ImageTextCta_Image_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Xl_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Xl_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Xl_Width_Operator>;
};

export type ImageTextCta_Image_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Xl_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Xl_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Xl_Width_Operator>;
};

export type ImageTextCta_Image_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Xl_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Xl_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Xl_Width_Operator>;
};

export type ImageTextCta_Image_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Xs_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Xs_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Xs_Width_Operator>;
};

export type ImageTextCta_Image_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Xs_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Xs_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Xs_Width_Operator>;
};

export type ImageTextCta_Image_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Xs_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Xs_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Xs_Width_Operator>;
};

export type ImageTextCta_Image_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Xxl_Width_Operator>;
};

export type ImageTextCta_Image_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Xxl_Width_Operator>;
};

export type ImageTextCta_Image_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Xxl_Width_Operator>;
};

export type ImageTextCta_Image_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ImageTextCta_Image_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ImageTextCta_Image_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageTextCta_Image_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Xxs_Width_Operator>;
};

export type ImageTextCta_Image_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Xxs_Width_Operator>;
};

export type ImageTextCta_Image_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageTextCta_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ImageTextCta_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ImageTextCta_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ImageTextCta_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ImageTextCta_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ImageTextCta_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ImageTextCta_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ImageTextCta_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ImageTextCta_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ImageTextCta_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ImageTextCta_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ImageTextCta_Image_Xxs_Width_Operator>;
};

export type ImageTextCta_Image_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export enum ImageTextCta_ImageSide {
  Left = 'left',
  Right = 'right'
}

export enum ImageTextCta_LayoutType {
  ContentGrid = 'contentGrid',
  ContentImages = 'contentImages',
  ContentLogos = 'contentLogos',
  Default = 'default'
}

export type ImportJob = {
  __typename?: 'ImportJob';
  blob?: Maybe<Blob>;
  createdAt: Scalars['ISO8601DateTime'];
  createdLines?: Maybe<Scalars['Int']>;
  errorLines?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  ignoredLines?: Maybe<Scalars['Int']>;
  importJobLinePreviews?: Maybe<Array<ImportJobLinePreview>>;
  importType?: Maybe<Scalars['String']>;
  keyBinding?: Maybe<Scalars['JSON']>;
  keys?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  paperclipBackupContentType?: Maybe<Scalars['String']>;
  paperclipBackupFileName?: Maybe<Scalars['String']>;
  paperclipBackupFileSize?: Maybe<Scalars['Int']>;
  paperclipBackupUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  paperclipDataContentType?: Maybe<Scalars['String']>;
  paperclipDataFileName?: Maybe<Scalars['String']>;
  paperclipDataFileSize?: Maybe<Scalars['Int']>;
  paperclipDataUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  parsedHeaders?: Maybe<Scalars['JSON']>;
  shipmentId?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  totalLines?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  updatedLines?: Maybe<Scalars['Int']>;
  uploadedUrl?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** The connection type for ImportJob. */
export type ImportJobConnection = {
  __typename?: 'ImportJobConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ImportJobEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ImportJob>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of ImportJobCreate */
export type ImportJobCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  importJobInput: ImportJobInput;
};

/** Autogenerated return type of ImportJobCreate. */
export type ImportJobCreatePayload = {
  __typename?: 'ImportJobCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  importJob: ImportJob;
};

/** Autogenerated input type of ImportJobDelete */
export type ImportJobDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ImportJobDelete. */
export type ImportJobDeletePayload = {
  __typename?: 'ImportJobDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  importJob: ImportJob;
};

/** An edge in a connection. */
export type ImportJobEdge = {
  __typename?: 'ImportJobEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ImportJob>;
};

export type ImportJobInput = {
  createdLines?: InputMaybe<Scalars['Int']>;
  errorLines?: InputMaybe<Scalars['Int']>;
  importType?: InputMaybe<Scalars['String']>;
  keyBinding?: InputMaybe<Scalars['JSON']>;
  keys?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  paperclipBackupContentType?: InputMaybe<Scalars['String']>;
  paperclipBackupFileName?: InputMaybe<Scalars['String']>;
  paperclipBackupFileSize?: InputMaybe<Scalars['Int']>;
  paperclipBackupUpdatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  paperclipDataContentType?: InputMaybe<Scalars['String']>;
  paperclipDataFileName?: InputMaybe<Scalars['String']>;
  paperclipDataFileSize?: InputMaybe<Scalars['Int']>;
  paperclipDataUpdatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  parsedHeaders?: InputMaybe<Scalars['JSON']>;
  shipmentId?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  totalLines?: InputMaybe<Scalars['Int']>;
  updatedLines?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ImportJobLinePreview = {
  __typename?: 'ImportJobLinePreview';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  importJob?: Maybe<ImportJob>;
  lineNumber?: Maybe<Scalars['Int']>;
  previewObject?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ImportJobLinePreview. */
export type ImportJobLinePreviewConnection = {
  __typename?: 'ImportJobLinePreviewConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ImportJobLinePreviewEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ImportJobLinePreview>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of ImportJobLinePreviewCreate */
export type ImportJobLinePreviewCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  importJobLinePreviewInput: ImportJobLinePreviewInput;
};

/** Autogenerated return type of ImportJobLinePreviewCreate. */
export type ImportJobLinePreviewCreatePayload = {
  __typename?: 'ImportJobLinePreviewCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  importJobLinePreview: ImportJobLinePreview;
};

/** Autogenerated input type of ImportJobLinePreviewDelete */
export type ImportJobLinePreviewDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ImportJobLinePreviewDelete. */
export type ImportJobLinePreviewDeletePayload = {
  __typename?: 'ImportJobLinePreviewDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  importJobLinePreview: ImportJobLinePreview;
};

/** An edge in a connection. */
export type ImportJobLinePreviewEdge = {
  __typename?: 'ImportJobLinePreviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ImportJobLinePreview>;
};

export type ImportJobLinePreviewInput = {
  importJobId?: InputMaybe<Scalars['Int']>;
  lineNumber?: InputMaybe<Scalars['Int']>;
  previewObject?: InputMaybe<Scalars['JSON']>;
};

export enum ImportJobLinePreviewOrder {
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyModified = 'RECENTLY_MODIFIED'
}

/** Autogenerated input type of ImportJobLinePreviewUpdate */
export type ImportJobLinePreviewUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  importJobLinePreviewInput: ImportJobLinePreviewInput;
};

/** Autogenerated return type of ImportJobLinePreviewUpdate. */
export type ImportJobLinePreviewUpdatePayload = {
  __typename?: 'ImportJobLinePreviewUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  importJobLinePreview: ImportJobLinePreview;
};

/** Autogenerated input type of ImportJobUpdate */
export type ImportJobUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  importJobInput: ImportJobInput;
};

/** Autogenerated return type of ImportJobUpdate. */
export type ImportJobUpdatePayload = {
  __typename?: 'ImportJobUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  importJob: ImportJob;
};

export type Ingredient = {
  __typename?: 'Ingredient';
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** The connection type for Ingredient. */
export type IngredientConnection = {
  __typename?: 'IngredientConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IngredientEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Ingredient>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of IngredientCreate */
export type IngredientCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ingredientInput: IngredientInput;
};

/** Autogenerated return type of IngredientCreate. */
export type IngredientCreatePayload = {
  __typename?: 'IngredientCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ingredient: Ingredient;
};

/** Autogenerated input type of IngredientDelete */
export type IngredientDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of IngredientDelete. */
export type IngredientDeletePayload = {
  __typename?: 'IngredientDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ingredient: Ingredient;
};

/** An edge in a connection. */
export type IngredientEdge = {
  __typename?: 'IngredientEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Ingredient>;
};

export type IngredientInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export enum IngredientOrder {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

/** Autogenerated input type of IngredientUpdate */
export type IngredientUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  ingredientInput: IngredientInput;
};

/** Autogenerated return type of IngredientUpdate. */
export type IngredientUpdatePayload = {
  __typename?: 'IngredientUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ingredient: Ingredient;
};

export type InstagramPost = {
  __typename?: 'InstagramPost';
  caption?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  permalink: Scalars['String'];
};

export type InstagramPostsCarousel = {
  __typename?: 'InstagramPostsCarousel';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<InstagramPostsCarousel_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  buttonPosition?: Maybe<InstagramPostsCarousel_ButtonPosition>;
  buttons?: Maybe<Array<InstagramPostsCarousel_Buttons>>;
  description?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  maxPosts?: Maybe<Scalars['Float']>;
  showArrows?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['JSON']>;
};


export type InstagramPostsCarouselDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type InstagramPostsCarouselTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type InstagramPostsCarousel_BlockSettings = {
  __typename?: 'InstagramPostsCarousel_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<InstagramPostsCarousel_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<InstagramPostsCarousel_BlockSettings_ResponsiveStyles>>;
};

export type InstagramPostsCarousel_BlockSettings_ResponsiveStyles = {
  __typename?: 'InstagramPostsCarousel_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<InstagramPostsCarousel_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<InstagramPostsCarousel_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<InstagramPostsCarousel_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum InstagramPostsCarousel_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum InstagramPostsCarousel_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum InstagramPostsCarousel_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum InstagramPostsCarousel_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type InstagramPostsCarousel_Buttons = {
  __typename?: 'InstagramPostsCarousel_Buttons';
  button?: Maybe<InstagramPostsCarousel_Buttons_Button>;
  id?: Maybe<Scalars['String']>;
};

export type InstagramPostsCarousel_Buttons_Button = {
  __typename?: 'InstagramPostsCarousel_Buttons_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<InstagramPostsCarousel_Buttons_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<InstagramPostsCarousel_Buttons_Button_Variant>;
};

export type InstagramPostsCarousel_Buttons_Button_Link = {
  __typename?: 'InstagramPostsCarousel_Buttons_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<InstagramPostsCarousel_Buttons_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum InstagramPostsCarousel_Buttons_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum InstagramPostsCarousel_Buttons_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary'
}

export enum InstagramPostsCarousel_ButtonPosition {
  BottomRight = 'bottomRight',
  TopLeft = 'topLeft'
}

export type InvalidZipCodeAlerts = {
  __typename?: 'InvalidZipCodeAlerts';
  alertInvalidOrderZipCodes: Array<TypesInvalidZipCodeAlertsTypeInvalidOrderZipCodes>;
  alertInvalidSubZipCodes: Array<TypesInvalidZipCodeAlertsTypeInvalidSubZipCodes>;
};

export type KeyValueInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type KitchenSink = {
  __typename?: 'KitchenSink';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<KitchenSink_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  checkbox?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['JSON']>;
  date?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['EmailAddress']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Float']>;
  radio?: Maybe<KitchenSink_Radio>;
  select?: Maybe<KitchenSink_Select>;
  textAreaField?: Maybe<Scalars['String']>;
  textField?: Maybe<Scalars['String']>;
};


export type KitchenSinkContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type KitchenSink_BlockSettings = {
  __typename?: 'KitchenSink_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<KitchenSink_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<KitchenSink_BlockSettings_ResponsiveStyles>>;
};

export type KitchenSink_BlockSettings_ResponsiveStyles = {
  __typename?: 'KitchenSink_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<KitchenSink_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<KitchenSink_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<KitchenSink_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum KitchenSink_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum KitchenSink_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum KitchenSink_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum KitchenSink_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export enum KitchenSink_Radio {
  Option1 = 'option1',
  Option2 = 'option2'
}

export enum KitchenSink_Select {
  Option1 = 'option1',
  Option2 = 'option2'
}

export type LargeHeadingHero = {
  __typename?: 'LargeHeadingHero';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<LargeHeadingHero_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<LargeHeadingHero_Buttons>>;
  description?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<LargeHeadingHero_Image>;
  title?: Maybe<Scalars['JSON']>;
};


export type LargeHeadingHeroDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type LargeHeadingHeroTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type LargeHeadingHero_BlockSettings = {
  __typename?: 'LargeHeadingHero_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<LargeHeadingHero_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<LargeHeadingHero_BlockSettings_ResponsiveStyles>>;
};

export type LargeHeadingHero_BlockSettings_ResponsiveStyles = {
  __typename?: 'LargeHeadingHero_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<LargeHeadingHero_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<LargeHeadingHero_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<LargeHeadingHero_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum LargeHeadingHero_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum LargeHeadingHero_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum LargeHeadingHero_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum LargeHeadingHero_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type LargeHeadingHero_Buttons = {
  __typename?: 'LargeHeadingHero_Buttons';
  button?: Maybe<LargeHeadingHero_Buttons_Button>;
  id?: Maybe<Scalars['String']>;
};

export type LargeHeadingHero_Buttons_Button = {
  __typename?: 'LargeHeadingHero_Buttons_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<LargeHeadingHero_Buttons_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<LargeHeadingHero_Buttons_Button_Variant>;
};

export type LargeHeadingHero_Buttons_Button_Link = {
  __typename?: 'LargeHeadingHero_Buttons_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<LargeHeadingHero_Buttons_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum LargeHeadingHero_Buttons_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum LargeHeadingHero_Buttons_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Text = 'text'
}

export type LargeHeadingHero_Image = {
  __typename?: 'LargeHeadingHero_Image';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type LargeHeadingHero_ImageLgArgs = {
  where?: InputMaybe<LargeHeadingHero_Image_Lg_Where>;
};


export type LargeHeadingHero_ImageMdArgs = {
  where?: InputMaybe<LargeHeadingHero_Image_Md_Where>;
};


export type LargeHeadingHero_ImageSmArgs = {
  where?: InputMaybe<LargeHeadingHero_Image_Sm_Where>;
};


export type LargeHeadingHero_ImageXlArgs = {
  where?: InputMaybe<LargeHeadingHero_Image_Xl_Where>;
};


export type LargeHeadingHero_ImageXsArgs = {
  where?: InputMaybe<LargeHeadingHero_Image_Xs_Where>;
};


export type LargeHeadingHero_ImageXxlArgs = {
  where?: InputMaybe<LargeHeadingHero_Image_Xxl_Where>;
};


export type LargeHeadingHero_ImageXxsArgs = {
  where?: InputMaybe<LargeHeadingHero_Image_Xxs_Where>;
};

export type LargeHeadingHero_Image_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Lg_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Lg_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Lg_Width_Operator>;
};

export type LargeHeadingHero_Image_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Lg_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Lg_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Lg_Width_Operator>;
};

export type LargeHeadingHero_Image_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Lg_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Lg_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Lg_Width_Operator>;
};

export type LargeHeadingHero_Image_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Md_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Md_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Md_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Md_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Md_Width_Operator>;
};

export type LargeHeadingHero_Image_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Md_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Md_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Md_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Md_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Md_Width_Operator>;
};

export type LargeHeadingHero_Image_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Md_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Md_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Md_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Md_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Md_Width_Operator>;
};

export type LargeHeadingHero_Image_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Sm_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Sm_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Sm_Width_Operator>;
};

export type LargeHeadingHero_Image_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Sm_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Sm_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Sm_Width_Operator>;
};

export type LargeHeadingHero_Image_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Sm_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Sm_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Sm_Width_Operator>;
};

export type LargeHeadingHero_Image_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Xl_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Xl_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Xl_Width_Operator>;
};

export type LargeHeadingHero_Image_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Xl_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Xl_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Xl_Width_Operator>;
};

export type LargeHeadingHero_Image_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Xl_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Xl_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Xl_Width_Operator>;
};

export type LargeHeadingHero_Image_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Xs_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Xs_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Xs_Width_Operator>;
};

export type LargeHeadingHero_Image_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Xs_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Xs_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Xs_Width_Operator>;
};

export type LargeHeadingHero_Image_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Xs_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Xs_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Xs_Width_Operator>;
};

export type LargeHeadingHero_Image_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Xxl_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Xxl_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Xxl_Width_Operator>;
};

export type LargeHeadingHero_Image_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Xxl_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Xxl_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Xxl_Width_Operator>;
};

export type LargeHeadingHero_Image_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Xxl_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Xxl_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Xxl_Width_Operator>;
};

export type LargeHeadingHero_Image_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LargeHeadingHero_Image_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LargeHeadingHero_Image_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LargeHeadingHero_Image_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Xxs_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Xxs_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Xxs_Width_Operator>;
};

export type LargeHeadingHero_Image_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Xxs_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Xxs_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Xxs_Width_Operator>;
};

export type LargeHeadingHero_Image_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LargeHeadingHero_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<LargeHeadingHero_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<LargeHeadingHero_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<LargeHeadingHero_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<LargeHeadingHero_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<LargeHeadingHero_Image_Xxs_Height_Operator>;
  id?: InputMaybe<LargeHeadingHero_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<LargeHeadingHero_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<LargeHeadingHero_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<LargeHeadingHero_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<LargeHeadingHero_Image_Xxs_Url_Operator>;
  width?: InputMaybe<LargeHeadingHero_Image_Xxs_Width_Operator>;
};

export type LargeHeadingHero_Image_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  originalUnitPriceSet: ShopifyMoneyBag;
  product?: Maybe<OrderDetailProduct>;
  quantity?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  totalDiscountSet?: Maybe<ShopifyMoneyBag>;
  unfulfilledOriginalTotalSet?: Maybe<ShopifyMoneyBag>;
};

export type LineItemEdge = {
  __typename?: 'LineItemEdge';
  node?: Maybe<LineItem>;
};

export type LineItemEdgeWrapper = {
  __typename?: 'LineItemEdgeWrapper';
  edges?: Maybe<Array<LineItemEdge>>;
};

export type LineItemReplacement = {
  __typename?: 'LineItemReplacement';
  active: Scalars['Boolean'];
  sku: Scalars['String'];
};

export type LineItemRule = {
  __typename?: 'LineItemRule';
  active?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  fieldName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lineItemRuleSet?: Maybe<LineItemRuleSet>;
  operator?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  value: Scalars['JSON'];
};

/** The connection type for LineItemRule. */
export type LineItemRuleConnection = {
  __typename?: 'LineItemRuleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LineItemRuleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LineItemRule>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of LineItemRuleCreate */
export type LineItemRuleCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lineItemRuleInput: LineItemRuleInput;
};

/** Autogenerated return type of LineItemRuleCreate. */
export type LineItemRuleCreatePayload = {
  __typename?: 'LineItemRuleCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lineItemRule: LineItemRule;
};

/** Autogenerated input type of LineItemRuleDelete */
export type LineItemRuleDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of LineItemRuleDelete. */
export type LineItemRuleDeletePayload = {
  __typename?: 'LineItemRuleDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lineItemRule: LineItemRule;
};

/** An edge in a connection. */
export type LineItemRuleEdge = {
  __typename?: 'LineItemRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LineItemRule>;
};

export type LineItemRuleInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  fieldName?: InputMaybe<Scalars['String']>;
  lineItemRuleSetId?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<Operator>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type LineItemRuleSet = {
  __typename?: 'LineItemRuleSet';
  active?: Maybe<Scalars['Boolean']>;
  conflictStrategy?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  limit: Scalars['Int'];
  limitStrategy?: Maybe<MutationsDynamicLineItemPutLimitAction>;
  lineItemDiscount: Scalars['Float'];
  lineItemName?: Maybe<Scalars['String']>;
  lineItemOutOfStock?: Maybe<Scalars['Boolean']>;
  lineItemPrice: Scalars['Float'];
  lineItemQuantity: Scalars['Int'];
  lineItemReplaceSku?: Maybe<Scalars['String']>;
  lineItemReplacements?: Maybe<Array<LineItemReplacement>>;
  lineItemSku?: Maybe<Scalars['String']>;
  lineItemType?: Maybe<Scalars['String']>;
  lineItemWeight: Scalars['Float'];
  logicOperator?: Maybe<Scalars['String']>;
  mergeCostStrategy: Scalars['String'];
  mergeNameStrategy?: Maybe<Scalars['String']>;
  mergeQuantityStrategy?: Maybe<Scalars['String']>;
  mergeSkuStrategy?: Maybe<Scalars['String']>;
  mergeWeightStrategy?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  rules: Array<LineItemRule>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for LineItemRuleSet. */
export type LineItemRuleSetConnection = {
  __typename?: 'LineItemRuleSetConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LineItemRuleSetEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LineItemRuleSet>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of LineItemRuleSetCreate */
export type LineItemRuleSetCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lineItemRuleSetInput: LineItemRuleSetInput;
};

/** Autogenerated return type of LineItemRuleSetCreate. */
export type LineItemRuleSetCreatePayload = {
  __typename?: 'LineItemRuleSetCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lineItemRuleSet: LineItemRuleSet;
};

/** Autogenerated input type of LineItemRuleSetDelete */
export type LineItemRuleSetDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of LineItemRuleSetDelete. */
export type LineItemRuleSetDeletePayload = {
  __typename?: 'LineItemRuleSetDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lineItemRuleSet: LineItemRuleSet;
};

/** An edge in a connection. */
export type LineItemRuleSetEdge = {
  __typename?: 'LineItemRuleSetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LineItemRuleSet>;
};

export type LineItemRuleSetInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  conflictStrategy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  limitStrategy?: InputMaybe<Scalars['String']>;
  lineItemDiscount?: InputMaybe<Scalars['Float']>;
  lineItemName?: InputMaybe<Scalars['String']>;
  lineItemPrice?: InputMaybe<Scalars['Float']>;
  lineItemQuantity?: InputMaybe<Scalars['Int']>;
  lineItemSku?: InputMaybe<Scalars['String']>;
  lineItemType?: InputMaybe<Scalars['String']>;
  logicOperator?: InputMaybe<Scalars['String']>;
  mergeCostStrategy?: InputMaybe<Scalars['String']>;
  mergeNameStrategy?: InputMaybe<Scalars['String']>;
  mergeQuantityStrategy?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of LineItemRuleSetUpdate */
export type LineItemRuleSetUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lineItemRuleSetInput: LineItemRuleSetInput;
};

/** Autogenerated return type of LineItemRuleSetUpdate. */
export type LineItemRuleSetUpdatePayload = {
  __typename?: 'LineItemRuleSetUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lineItemRuleSet: LineItemRuleSet;
};

/** Autogenerated input type of LineItemRuleUpdate */
export type LineItemRuleUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lineItemRuleInput: LineItemRuleInput;
};

/** Autogenerated return type of LineItemRuleUpdate. */
export type LineItemRuleUpdatePayload = {
  __typename?: 'LineItemRuleUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lineItemRule: LineItemRule;
};

export type LogEvent = {
  __typename?: 'LogEvent';
  createdAt: Scalars['ISO8601DateTime'];
  data?: Maybe<Scalars['JSON']>;
  event?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['Int']>;
  sourceType?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['Int']>;
  targetType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  user?: Maybe<User>;
};

/** The connection type for LogEvent. */
export type LogEventConnection = {
  __typename?: 'LogEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LogEventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LogEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of LogEventCreate */
export type LogEventCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  logEventInput: LogEventInput;
};

/** Autogenerated return type of LogEventCreate. */
export type LogEventCreatePayload = {
  __typename?: 'LogEventCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  logEvent: LogEvent;
};

/** Autogenerated input type of LogEventDelete */
export type LogEventDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of LogEventDelete. */
export type LogEventDeletePayload = {
  __typename?: 'LogEventDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  logEvent: LogEvent;
};

/** An edge in a connection. */
export type LogEventEdge = {
  __typename?: 'LogEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LogEvent>;
};

export type LogEventInput = {
  data?: InputMaybe<Scalars['JSON']>;
  event?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['Int']>;
  sourceType?: InputMaybe<Scalars['String']>;
  targetId?: InputMaybe<Scalars['Int']>;
  targetType?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of LogEventUpdate */
export type LogEventUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  logEventInput: LogEventInput;
};

/** Autogenerated return type of LogEventUpdate. */
export type LogEventUpdatePayload = {
  __typename?: 'LogEventUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  logEvent: LogEvent;
};

/** Autogenerated input type of MarkOrderAsDelivered */
export type MarkOrderAsDeliveredInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** Autogenerated return type of MarkOrderAsDelivered. */
export type MarkOrderAsDeliveredPayload = {
  __typename?: 'MarkOrderAsDeliveredPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

/** Autogenerated input type of MarkOrderPaymentAsFailed */
export type MarkOrderPaymentAsFailedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  errorCode: Scalars['String'];
  id: Scalars['Int'];
  reason: Scalars['String'];
};

/** Autogenerated return type of MarkOrderPaymentAsFailed. */
export type MarkOrderPaymentAsFailedPayload = {
  __typename?: 'MarkOrderPaymentAsFailedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type Meal = {
  __typename?: 'Meal';
  active?: Maybe<Scalars['Boolean']>;
  analysis?: Maybe<Scalars['JSON']>;
  category?: Maybe<MealCategoryEnum>;
  clusterAvailable?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  emergencyOutOfStock?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  ingredients?: Maybe<Scalars['String']>;
  lineItemName?: Maybe<Scalars['String']>;
  mealPlanVariants?: Maybe<Array<MealPlanVariant>>;
  metadata?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  outOfStock?: Maybe<Scalars['Boolean']>;
  outOfStockMessage?: Maybe<Scalars['String']>;
  pageUrl?: Maybe<Scalars['String']>;
  parentShopifyId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  priceCategory?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  recipe?: Maybe<Recipe>;
  recipeId?: Maybe<Scalars['Int']>;
  recommended?: Maybe<Scalars['Boolean']>;
  shopifyId?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  surchargeAmount: Scalars['Float'];
  updatedAt: Scalars['ISO8601DateTime'];
  weightInOunces?: Maybe<Scalars['Float']>;
};

export enum MealCategoryEnum {
  /** FreshCooked meal/recipe options */
  Dry = 'dry',
  /** FreshBaked meal/recipe options */
  Wet = 'wet'
}

/** The connection type for Meal. */
export type MealConnection = {
  __typename?: 'MealConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MealEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Meal>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of MealCreate */
export type MealCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  mealInput: MealInput;
};

/** Autogenerated return type of MealCreate. */
export type MealCreatePayload = {
  __typename?: 'MealCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  meal: Meal;
};

/** Autogenerated input type of MealDelete */
export type MealDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of MealDelete. */
export type MealDeletePayload = {
  __typename?: 'MealDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  meal: Meal;
};

/** An edge in a connection. */
export type MealEdge = {
  __typename?: 'MealEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Meal>;
};

export type MealInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  analysis?: InputMaybe<Scalars['JSON']>;
  category?: InputMaybe<MealCategoryEnum>;
  clusterAvailable?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  emergencyOutOfStock?: InputMaybe<Scalars['Boolean']>;
  ingredients?: InputMaybe<Scalars['String']>;
  lineItemName?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  outOfStock?: InputMaybe<Scalars['Boolean']>;
  outOfStockMessage?: InputMaybe<Scalars['String']>;
  pageUrl?: InputMaybe<Scalars['String']>;
  parentShopifyId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  priceCategory?: InputMaybe<Scalars['String']>;
  productCategory?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  recipeId?: InputMaybe<Scalars['Int']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  surchargeAmount?: InputMaybe<Scalars['Float']>;
  weightInOunces?: InputMaybe<Scalars['Float']>;
};

export type MealLineItem = {
  __typename?: 'MealLineItem';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  meal?: Maybe<Meal>;
  subscription?: Maybe<Subscription>;
  total: Scalars['Int'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for MealLineItem. */
export type MealLineItemConnection = {
  __typename?: 'MealLineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MealLineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MealLineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of MealLineItemCreate */
export type MealLineItemCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  mealLineItemInput: MealLineItemInput;
};

/** Autogenerated return type of MealLineItemCreate. */
export type MealLineItemCreatePayload = {
  __typename?: 'MealLineItemCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  mealLineItem: MealLineItem;
};

/** Autogenerated input type of MealLineItemDelete */
export type MealLineItemDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of MealLineItemDelete. */
export type MealLineItemDeletePayload = {
  __typename?: 'MealLineItemDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  mealLineItem: MealLineItem;
};

/** An edge in a connection. */
export type MealLineItemEdge = {
  __typename?: 'MealLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MealLineItem>;
};

export type MealLineItemInput = {
  dishId?: InputMaybe<Scalars['Int']>;
  subscriptionId?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
};

export enum MealLineItemOrder {
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyModified = 'RECENTLY_MODIFIED'
}

/** Autogenerated input type of MealLineItemUpdate */
export type MealLineItemUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  mealLineItemInput: MealLineItemInput;
};

/** Autogenerated return type of MealLineItemUpdate. */
export type MealLineItemUpdatePayload = {
  __typename?: 'MealLineItemUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  mealLineItem: MealLineItem;
};

export type MealPlan = {
  __typename?: 'MealPlan';
  containers?: Maybe<Scalars['Int']>;
  feedingPortion?: Maybe<Scalars['Float']>;
  servingsPerDay?: Maybe<Scalars['Int']>;
};

export type MealPlanVariant = {
  __typename?: 'MealPlanVariant';
  name?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  variants?: Maybe<Array<MealPlanVariantEntry>>;
};

export type MealPlanVariantEntry = {
  __typename?: 'MealPlanVariantEntry';
  id?: Maybe<Scalars['ID']>;
  outOfStock?: Maybe<Scalars['Boolean']>;
  plan?: Maybe<BoxVariant>;
  state?: Maybe<MealPlanVariantState>;
};

export type MealPlanVariantInput = {
  inStock: Scalars['Boolean'];
  mealId: Scalars['ID'];
  mealVariantSku: Scalars['String'];
};

export enum MealPlanVariantState {
  Active = 'active',
  Discontinued = 'discontinued'
}

/** Autogenerated input type of MealPlanVariantUpdate */
export type MealPlanVariantUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: MealPlanVariantInput;
};

/** Autogenerated return type of MealPlanVariantUpdate. */
export type MealPlanVariantUpdatePayload = {
  __typename?: 'MealPlanVariantUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of MealUpdate */
export type MealUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  mealInput: MealInput;
};

/** Autogenerated return type of MealUpdate. */
export type MealUpdatePayload = {
  __typename?: 'MealUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  meal: Meal;
};

/** Autogenerated input type of MealVariantCreate */
export type MealVariantCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  mealVariantInput: MealVariantInput;
};

/** Autogenerated return type of MealVariantCreate. */
export type MealVariantCreatePayload = {
  __typename?: 'MealVariantCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  mealVariant?: Maybe<PetPlateMealVariantType>;
};

/** Autogenerated input type of MealVariantDelete */
export type MealVariantDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of MealVariantDelete. */
export type MealVariantDeletePayload = {
  __typename?: 'MealVariantDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  mealVariant: PetPlateMealVariantType;
};

export type MealVariantInput = {
  metadata?: InputMaybe<Scalars['JSON']>;
  migrationPriceRollback?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  outOfStock?: InputMaybe<Scalars['Boolean']>;
  planId: Scalars['Int'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['Int'];
  sku: Scalars['String'];
  state?: PetPlateMealVariantState;
};

export enum MealVariantOrder {
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyModified = 'RECENTLY_MODIFIED'
}

/** Autogenerated input type of MealVariantUpdate */
export type MealVariantUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  mealVariantInput: MealVariantInput;
};

/** Autogenerated return type of MealVariantUpdate. */
export type MealVariantUpdatePayload = {
  __typename?: 'MealVariantUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  mealVariant: PetPlateMealVariantType;
};

export type MultiCardCarousel = {
  __typename?: 'MultiCardCarousel';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<MultiCardCarousel_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  blogCards?: Maybe<Array<MultiCardCarousel_BlogCards>>;
  buttonPosition?: Maybe<MultiCardCarousel_ButtonPosition>;
  buttons?: Maybe<Array<MultiCardCarousel_Buttons>>;
  cardType?: Maybe<MultiCardCarousel_CardType>;
  description?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  ingredientCards?: Maybe<Array<MultiCardCarousel_IngredientCards>>;
  pressCards?: Maybe<Array<MultiCardCarousel_PressCards>>;
  productCards?: Maybe<Array<MultiCardCarousel_ProductCards>>;
  showArrows?: Maybe<Scalars['Boolean']>;
  socialMediaCards?: Maybe<Array<MultiCardCarousel_SocialMediaCards>>;
  title?: Maybe<Scalars['JSON']>;
};


export type MultiCardCarouselDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type MultiCardCarouselTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type MultiCardCarousel_BlockSettings = {
  __typename?: 'MultiCardCarousel_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<MultiCardCarousel_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<MultiCardCarousel_BlockSettings_ResponsiveStyles>>;
};

export type MultiCardCarousel_BlockSettings_ResponsiveStyles = {
  __typename?: 'MultiCardCarousel_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<MultiCardCarousel_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<MultiCardCarousel_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<MultiCardCarousel_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum MultiCardCarousel_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum MultiCardCarousel_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum MultiCardCarousel_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum MultiCardCarousel_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type MultiCardCarousel_BlogCards = {
  __typename?: 'MultiCardCarousel_BlogCards';
  categories?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Cms_Media>;
  link?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['JSON']>;
};


export type MultiCardCarousel_BlogCardsImageArgs = {
  where?: InputMaybe<MultiCardCarousel_BlogCards_Image_Where>;
};


export type MultiCardCarousel_BlogCardsTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type MultiCardCarousel_BlogCards_Image_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_BlogCards_Image_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_BlogCards_Image_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_BlogCards_Image_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_BlogCards_Image_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_BlogCards_Image_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_BlogCards_Image_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_BlogCards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_BlogCards_Image_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_BlogCards_Image_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_BlogCards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_BlogCards_Image_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_BlogCards_Image_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_BlogCards_Image_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_BlogCards_Image_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_BlogCards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_BlogCards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_BlogCards_Image_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_BlogCards_Image_Width_Operator>;
};

export type MultiCardCarousel_BlogCards_Image_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_BlogCards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_BlogCards_Image_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_BlogCards_Image_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_BlogCards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_BlogCards_Image_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_BlogCards_Image_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_BlogCards_Image_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_BlogCards_Image_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_BlogCards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_BlogCards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_BlogCards_Image_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_BlogCards_Image_Width_Operator>;
};

export type MultiCardCarousel_BlogCards_Image_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_BlogCards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_BlogCards_Image_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_BlogCards_Image_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_BlogCards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_BlogCards_Image_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_BlogCards_Image_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_BlogCards_Image_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_BlogCards_Image_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_BlogCards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_BlogCards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_BlogCards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_BlogCards_Image_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_BlogCards_Image_Width_Operator>;
};

export type MultiCardCarousel_BlogCards_Image_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_Buttons = {
  __typename?: 'MultiCardCarousel_Buttons';
  button?: Maybe<MultiCardCarousel_Buttons_Button>;
  id?: Maybe<Scalars['String']>;
};

export type MultiCardCarousel_Buttons_Button = {
  __typename?: 'MultiCardCarousel_Buttons_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<MultiCardCarousel_Buttons_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<MultiCardCarousel_Buttons_Button_Variant>;
};

export type MultiCardCarousel_Buttons_Button_Link = {
  __typename?: 'MultiCardCarousel_Buttons_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<MultiCardCarousel_Buttons_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum MultiCardCarousel_Buttons_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum MultiCardCarousel_Buttons_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type MultiCardCarousel_IngredientCards = {
  __typename?: 'MultiCardCarousel_IngredientCards';
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Cms_Media>;
  title?: Maybe<Scalars['String']>;
};


export type MultiCardCarousel_IngredientCardsImageArgs = {
  where?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Where>;
};

export type MultiCardCarousel_IngredientCards_Image_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_IngredientCards_Image_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_IngredientCards_Image_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_IngredientCards_Image_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_IngredientCards_Image_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_IngredientCards_Image_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_IngredientCards_Image_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_IngredientCards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_IngredientCards_Image_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_IngredientCards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_IngredientCards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_IngredientCards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Width_Operator>;
};

export type MultiCardCarousel_IngredientCards_Image_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_IngredientCards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_IngredientCards_Image_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_IngredientCards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_IngredientCards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_IngredientCards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Width_Operator>;
};

export type MultiCardCarousel_IngredientCards_Image_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_IngredientCards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_IngredientCards_Image_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_IngredientCards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_IngredientCards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_IngredientCards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_IngredientCards_Image_Width_Operator>;
};

export type MultiCardCarousel_IngredientCards_Image_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_PressCards = {
  __typename?: 'MultiCardCarousel_PressCards';
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<MultiCardCarousel_PressCards_Icon>;
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export enum MultiCardCarousel_PressCards_Icon {
  CbsNews = 'CbsNews',
  Forbes = 'Forbes',
  FoxNews = 'FoxNews',
  Newsday = 'Newsday',
  SharkTank = 'SharkTank'
}

export type MultiCardCarousel_ProductCards = {
  __typename?: 'MultiCardCarousel_ProductCards';
  cardSize?: Maybe<MultiCardCarousel_ProductCards_CardSize>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<MultiCardCarousel_ProductCards_Image>;
  link?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type MultiCardCarousel_ProductCards_Image = {
  __typename?: 'MultiCardCarousel_ProductCards_Image';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type MultiCardCarousel_ProductCards_ImageLgArgs = {
  where?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Where>;
};


export type MultiCardCarousel_ProductCards_ImageMdArgs = {
  where?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Where>;
};


export type MultiCardCarousel_ProductCards_ImageSmArgs = {
  where?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Where>;
};


export type MultiCardCarousel_ProductCards_ImageXlArgs = {
  where?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Where>;
};


export type MultiCardCarousel_ProductCards_ImageXsArgs = {
  where?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Where>;
};


export type MultiCardCarousel_ProductCards_ImageXxlArgs = {
  where?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Where>;
};


export type MultiCardCarousel_ProductCards_ImageXxsArgs = {
  where?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Where>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Lg_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Md_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Sm_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xl_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xs_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxl_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_ProductCards_Image_Xxs_Width_Operator>;
};

export type MultiCardCarousel_ProductCards_Image_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export enum MultiCardCarousel_ProductCards_CardSize {
  Large = 'large',
  Medium = 'medium'
}

export type MultiCardCarousel_SocialMediaCards = {
  __typename?: 'MultiCardCarousel_SocialMediaCards';
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Cms_Media>;
  link?: Maybe<Scalars['String']>;
};


export type MultiCardCarousel_SocialMediaCardsImageArgs = {
  where?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Where>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardCarousel_SocialMediaCards_Image_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Width_Operator>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Width_Operator>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Where_Or>>>;
  alt?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Filename_Operator>;
  filesize?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Filesize_Operator>;
  height?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Height_Operator>;
  id?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Id_Operator>;
  mimeType?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Url_Operator>;
  width?: InputMaybe<MultiCardCarousel_SocialMediaCards_Image_Width_Operator>;
};

export type MultiCardCarousel_SocialMediaCards_Image_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export enum MultiCardCarousel_ButtonPosition {
  BottomRight = 'bottomRight',
  TopLeft = 'topLeft'
}

export enum MultiCardCarousel_CardType {
  Blog = 'blog',
  Ingredient = 'ingredient',
  Press = 'press',
  Product = 'product',
  SocialMedia = 'socialMedia'
}

export type MultiCardGrid = {
  __typename?: 'MultiCardGrid';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<MultiCardGrid_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  cardType?: Maybe<MultiCardGrid_CardType>;
  id?: Maybe<Scalars['String']>;
  ingredientCards?: Maybe<Array<MultiCardGrid_IngredientCards>>;
  pressCards?: Maybe<Array<MultiCardGrid_PressCards>>;
  productCardSize?: Maybe<MultiCardGrid_ProductCardSize>;
  productCards?: Maybe<Array<MultiCardGrid_ProductCards>>;
  reviewCards?: Maybe<Array<MultiCardGrid_ReviewCards>>;
};

export type MultiCardGrid_BlockSettings = {
  __typename?: 'MultiCardGrid_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<MultiCardGrid_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<MultiCardGrid_BlockSettings_ResponsiveStyles>>;
};

export type MultiCardGrid_BlockSettings_ResponsiveStyles = {
  __typename?: 'MultiCardGrid_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<MultiCardGrid_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<MultiCardGrid_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<MultiCardGrid_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum MultiCardGrid_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum MultiCardGrid_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum MultiCardGrid_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum MultiCardGrid_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type MultiCardGrid_IngredientCards = {
  __typename?: 'MultiCardGrid_IngredientCards';
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Cms_Media>;
  title?: Maybe<Scalars['String']>;
};


export type MultiCardGrid_IngredientCardsImageArgs = {
  where?: InputMaybe<MultiCardGrid_IngredientCards_Image_Where>;
};

export type MultiCardGrid_IngredientCards_Image_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_IngredientCards_Image_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_IngredientCards_Image_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_IngredientCards_Image_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_IngredientCards_Image_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_IngredientCards_Image_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_IngredientCards_Image_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_IngredientCards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_IngredientCards_Image_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_IngredientCards_Image_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_IngredientCards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_IngredientCards_Image_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_IngredientCards_Image_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_IngredientCards_Image_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_IngredientCards_Image_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_IngredientCards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_IngredientCards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_IngredientCards_Image_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_IngredientCards_Image_Width_Operator>;
};

export type MultiCardGrid_IngredientCards_Image_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_IngredientCards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_IngredientCards_Image_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_IngredientCards_Image_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_IngredientCards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_IngredientCards_Image_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_IngredientCards_Image_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_IngredientCards_Image_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_IngredientCards_Image_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_IngredientCards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_IngredientCards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_IngredientCards_Image_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_IngredientCards_Image_Width_Operator>;
};

export type MultiCardGrid_IngredientCards_Image_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_IngredientCards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_IngredientCards_Image_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_IngredientCards_Image_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_IngredientCards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_IngredientCards_Image_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_IngredientCards_Image_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_IngredientCards_Image_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_IngredientCards_Image_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_IngredientCards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_IngredientCards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_IngredientCards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_IngredientCards_Image_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_IngredientCards_Image_Width_Operator>;
};

export type MultiCardGrid_IngredientCards_Image_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_PressCards = {
  __typename?: 'MultiCardGrid_PressCards';
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<MultiCardGrid_PressCards_Icon>;
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export enum MultiCardGrid_PressCards_Icon {
  CbsNews = 'CbsNews',
  Forbes = 'Forbes',
  FoxNews = 'FoxNews',
  Newsday = 'Newsday',
  SharkTank = 'SharkTank'
}

export type MultiCardGrid_ProductCards = {
  __typename?: 'MultiCardGrid_ProductCards';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<MultiCardGrid_ProductCards_Image>;
  link?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type MultiCardGrid_ProductCards_Image = {
  __typename?: 'MultiCardGrid_ProductCards_Image';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type MultiCardGrid_ProductCards_ImageLgArgs = {
  where?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Where>;
};


export type MultiCardGrid_ProductCards_ImageMdArgs = {
  where?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Where>;
};


export type MultiCardGrid_ProductCards_ImageSmArgs = {
  where?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Where>;
};


export type MultiCardGrid_ProductCards_ImageXlArgs = {
  where?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Where>;
};


export type MultiCardGrid_ProductCards_ImageXsArgs = {
  where?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Where>;
};


export type MultiCardGrid_ProductCards_ImageXxlArgs = {
  where?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Where>;
};


export type MultiCardGrid_ProductCards_ImageXxsArgs = {
  where?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Where>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Lg_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Md_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Md_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Md_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Md_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Sm_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xl_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xs_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxl_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Height_Operator>;
  id?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Url_Operator>;
  width?: InputMaybe<MultiCardGrid_ProductCards_Image_Xxs_Width_Operator>;
};

export type MultiCardGrid_ProductCards_Image_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type MultiCardGrid_ReviewCards = {
  __typename?: 'MultiCardGrid_ReviewCards';
  id?: Maybe<Scalars['String']>;
  reviewContent?: Maybe<Scalars['String']>;
  reviewRating?: Maybe<Scalars['Float']>;
  reviewer?: Maybe<Scalars['String']>;
};

export enum MultiCardGrid_CardType {
  Ingredient = 'ingredient',
  Press = 'press',
  Product = 'product',
  Review = 'review'
}

export enum MultiCardGrid_ProductCardSize {
  Large = 'large',
  Medium = 'medium'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Creates a new Address */
  addressCreate?: Maybe<AddressCreatePayload>;
  /** Delete an existing Address */
  addressDelete?: Maybe<AddressDeletePayload>;
  /** Update an existing Address by id */
  addressUpdate?: Maybe<AddressUpdatePayload>;
  /** Authenticates an existing user and assigns to recWiz */
  assignUserToSubflow?: Maybe<AssignUserToSubflowPayload>;
  /** Creates a new Automation */
  automationCreate?: Maybe<AutomationCreatePayload>;
  /** Delete an existing Automation */
  automationDelete?: Maybe<AutomationDeletePayload>;
  /** Run one step of the daily ops schedule now, outside its scheduled time */
  automationRun?: Maybe<AutomationRunPayload>;
  /** Update an existing Automation by id */
  automationUpdate?: Maybe<AutomationUpdatePayload>;
  /** Creates a new Box */
  boxCreate?: Maybe<BoxCreatePayload>;
  /** Delete an existing Box */
  boxDelete?: Maybe<BoxDeletePayload>;
  /** Update an existing Box by id */
  boxUpdate?: Maybe<BoxUpdatePayload>;
  /** Creates a new BoxVariant */
  boxVariantCreate?: Maybe<BoxVariantCreatePayload>;
  /** Delete an existing BoxVariant */
  boxVariantDelete?: Maybe<BoxVariantDeletePayload>;
  /** Update an existing BoxVariant by id */
  boxVariantUpdate?: Maybe<BoxVariantUpdatePayload>;
  /** Creates a new Breed */
  breedCreate?: Maybe<BreedCreatePayload>;
  /** Delete an existing Breed */
  breedDelete?: Maybe<BreedDeletePayload>;
  /** Update an existing Breed by id */
  breedUpdate?: Maybe<BreedUpdatePayload>;
  /** Creates a new CalorieMultiplier */
  calorieMultiplierCreate?: Maybe<CalorieMultiplierCreatePayload>;
  /** Delete an existing CalorieMultiplier */
  calorieMultiplierDelete?: Maybe<CalorieMultiplierDeletePayload>;
  /** Update an existing CalorieMultiplier by id */
  calorieMultiplierUpdate?: Maybe<CalorieMultiplierUpdatePayload>;
  /** Creates a new CancellationSurvey */
  cancellationSurveyCreate?: Maybe<CancellationSurveyCreatePayload>;
  /** Delete an existing CancellationSurvey */
  cancellationSurveyDelete?: Maybe<CancellationSurveyDeletePayload>;
  /** Update an existing CancellationSurvey by id */
  cancellationSurveyUpdate?: Maybe<CancellationSurveyUpdatePayload>;
  /** Creates a new ConversionSurvey */
  conversionSurveyCreate?: Maybe<ConversionSurveyCreatePayload>;
  /** Delete an existing ConversionSurvey */
  conversionSurveyDelete?: Maybe<ConversionSurveyDeletePayload>;
  /** Update an existing ConversionSurvey by id */
  conversionSurveyUpdate?: Maybe<ConversionSurveyUpdatePayload>;
  /** Imports a shopify coupon into the database */
  couponImport?: Maybe<CouponImportPayload>;
  /** Refreshes a shopify coupon */
  couponRefresh?: Maybe<CouponRefreshPayload>;
  /** Update an existing Coupon by id */
  couponUpdate?: Maybe<CouponUpdatePayload>;
  createCms_media?: Maybe<Cms_Media>;
  createCms_page?: Maybe<Cms_Page>;
  createPayloadPreference?: Maybe<PayloadPreference>;
  /** Creates a new address */
  createPaymentBatchJob?: Maybe<CreatePaymentBatchJobPayload>;
  /** Creates a new user and assigns to recWiz */
  createUserForSubflow?: Maybe<CreateUserForSubflowPayload>;
  /** Create a db_order, proxy to shopify */
  dbOrderCreate?: Maybe<DbOrderCreatePayload>;
  /** Delete an existing V2::Order */
  dbOrderDelete?: Maybe<DbOrderDeletePayload>;
  /** Edit a db_order by id */
  dbOrderEdit?: Maybe<DbOrderEditPayload>;
  /** Cancels the current order and creates a new one in draft mode */
  dbOrderRecreate?: Maybe<DbOrderRecreatePayload>;
  /** Replace a db_order by existing V2::Order id */
  dbOrderReplace?: Maybe<DbOrderReplacePayload>;
  /** Update an existing V2::Order by id */
  dbOrderUpdate?: Maybe<DbOrderUpdatePayload>;
  deleteCms_media?: Maybe<Cms_Media>;
  deleteCms_page?: Maybe<Cms_Page>;
  deletePayloadPreference?: Maybe<PayloadPreference>;
  /** Update an existing DryIceMatrixTier by id */
  dryIceMatrixTierUpdate?: Maybe<DryIceMatrixTierUpdatePayload>;
  /** Creates a new DryIcePackaging */
  dryIcePackagingCreate?: Maybe<DryIcePackagingCreatePayload>;
  /** Delete an existing DryIcePackaging */
  dryIcePackagingDelete?: Maybe<DryIcePackagingDeletePayload>;
  /** Creates many dry_ice_packagings in a single transaction */
  dryIcePackagingMassCreate?: Maybe<DryIcePackagingMassCreatePayload>;
  /** Updates many dry_ice_packagings by id */
  dryIcePackagingMassUpdate?: Maybe<DryIcePackagingMassUpdatePayload>;
  /** Update an existing DryIcePackaging by id */
  dryIcePackagingUpdate?: Maybe<DryIcePackagingUpdatePayload>;
  dynamicLineItem: DynamicLineItemPutPayload;
  /** Delete an existing FulfillmentScheduleRule */
  fulfillmentScheduleRuleDelete?: Maybe<FulfillmentScheduleRuleDeletePayload>;
  fulfillmentScheduleRulesCreate?: Maybe<FulfillmentScheduleRulesCreatePayload>;
  /** Creates a new ImportJob */
  importJobCreate?: Maybe<ImportJobCreatePayload>;
  /** Delete an existing ImportJob */
  importJobDelete?: Maybe<ImportJobDeletePayload>;
  /** Creates a new ImportJobLinePreview */
  importJobLinePreviewCreate?: Maybe<ImportJobLinePreviewCreatePayload>;
  /** Delete an existing ImportJobLinePreview */
  importJobLinePreviewDelete?: Maybe<ImportJobLinePreviewDeletePayload>;
  /** Update an existing ImportJobLinePreview by id */
  importJobLinePreviewUpdate?: Maybe<ImportJobLinePreviewUpdatePayload>;
  /** Update an existing ImportJob by id */
  importJobUpdate?: Maybe<ImportJobUpdatePayload>;
  /** Creates a new Ingredient */
  ingredientCreate?: Maybe<IngredientCreatePayload>;
  /** Delete an existing Ingredient */
  ingredientDelete?: Maybe<IngredientDeletePayload>;
  /** Update an existing Ingredient by id */
  ingredientUpdate?: Maybe<IngredientUpdatePayload>;
  /** Creates a new LineItemRule */
  lineItemRuleCreate?: Maybe<LineItemRuleCreatePayload>;
  /** Delete an existing LineItemRule */
  lineItemRuleDelete?: Maybe<LineItemRuleDeletePayload>;
  /** Creates a new LineItemRuleSet */
  lineItemRuleSetCreate?: Maybe<LineItemRuleSetCreatePayload>;
  /** Delete an existing LineItemRuleSet */
  lineItemRuleSetDelete?: Maybe<LineItemRuleSetDeletePayload>;
  /** Update an existing LineItemRuleSet by id */
  lineItemRuleSetUpdate?: Maybe<LineItemRuleSetUpdatePayload>;
  /** Update an existing LineItemRule by id */
  lineItemRuleUpdate?: Maybe<LineItemRuleUpdatePayload>;
  /** Creates a new LogEvent */
  logEventCreate?: Maybe<LogEventCreatePayload>;
  /** Delete an existing LogEvent */
  logEventDelete?: Maybe<LogEventDeletePayload>;
  /** Update an existing LogEvent by id */
  logEventUpdate?: Maybe<LogEventUpdatePayload>;
  /** Qa Tool to mark an order as delivered */
  markOrderAsDelivered?: Maybe<MarkOrderAsDeliveredPayload>;
  /** Qa Tool to mark the payment of an order as failed */
  markOrderPaymentAsFailed?: Maybe<MarkOrderPaymentAsFailedPayload>;
  /** Creates a new Meal */
  mealCreate?: Maybe<MealCreatePayload>;
  /** Delete an existing Meal */
  mealDelete?: Maybe<MealDeletePayload>;
  /** Creates a new MealLineItem */
  mealLineItemCreate?: Maybe<MealLineItemCreatePayload>;
  /** Delete an existing MealLineItem */
  mealLineItemDelete?: Maybe<MealLineItemDeletePayload>;
  /** Update an existing MealLineItem by id */
  mealLineItemUpdate?: Maybe<MealLineItemUpdatePayload>;
  /** Updates a meal plan variant's stock status */
  mealPlanVariantUpdate?: Maybe<MealPlanVariantUpdatePayload>;
  /** Update an existing Meal by id */
  mealUpdate?: Maybe<MealUpdatePayload>;
  /** Creates a new meal variant */
  mealVariantCreate?: Maybe<MealVariantCreatePayload>;
  /** Delete an existing MealVariant */
  mealVariantDelete?: Maybe<MealVariantDeletePayload>;
  /** Update an existing MealVariant by id */
  mealVariantUpdate?: Maybe<MealVariantUpdatePayload>;
  /** Creates a new NotificationBanner */
  notificationBannerCreate?: Maybe<NotificationBannerCreatePayload>;
  /** Delete an existing NotificationBanner */
  notificationBannerDelete?: Maybe<NotificationBannerDeletePayload>;
  /** Update an existing NotificationBanner by id */
  notificationBannerUpdate?: Maybe<NotificationBannerUpdatePayload>;
  /** Creates a new OrderImportBatch */
  orderImportBatchCreate?: Maybe<OrderImportBatchCreatePayload>;
  /** Delete an existing OrderImportBatch */
  orderImportBatchDelete?: Maybe<OrderImportBatchDeletePayload>;
  /** Creates a new OrderImportBatchEntry */
  orderImportBatchEntryCreate?: Maybe<OrderImportBatchEntryCreatePayload>;
  /** Delete an existing OrderImportBatchEntry */
  orderImportBatchEntryDelete?: Maybe<OrderImportBatchEntryDeletePayload>;
  /** Update an existing OrderImportBatchEntry by id */
  orderImportBatchEntryUpdate?: Maybe<OrderImportBatchEntryUpdatePayload>;
  /** Update an existing OrderImportBatch by id */
  orderImportBatchUpdate?: Maybe<OrderImportBatchUpdatePayload>;
  /** Creates a new Packaging */
  packagingCreate?: Maybe<PackagingCreatePayload>;
  /** Delete an existing Packaging */
  packagingDelete?: Maybe<PackagingDeletePayload>;
  /** Update an existing Packaging by id */
  packagingUpdate?: Maybe<PackagingUpdatePayload>;
  /** Creates a new PauseSurvey */
  pauseSurveyCreate?: Maybe<PauseSurveyCreatePayload>;
  /** Delete an existing PauseSurvey */
  pauseSurveyDelete?: Maybe<PauseSurveyDeletePayload>;
  /** Update an existing PauseSurvey by id */
  pauseSurveyUpdate?: Maybe<PauseSurveyUpdatePayload>;
  /** Creates a new PaymentAdjustment */
  paymentAdjustmentCreate?: Maybe<PaymentAdjustmentCreatePayload>;
  /** Delete an existing PaymentAdjustment */
  paymentAdjustmentDelete?: Maybe<PaymentAdjustmentDeletePayload>;
  /** Update an existing PaymentAdjustment by id */
  paymentAdjustmentUpdate?: Maybe<PaymentAdjustmentUpdatePayload>;
  /** Creates a new PaymentBatch */
  paymentBatchCreate?: Maybe<PaymentBatchCreatePayload>;
  /** Delete an existing PaymentBatch */
  paymentBatchDelete?: Maybe<PaymentBatchDeletePayload>;
  /** Creates a new PaymentBatchEntry */
  paymentBatchEntryCreate?: Maybe<PaymentBatchEntryCreatePayload>;
  /** Delete an existing PaymentBatchEntry */
  paymentBatchEntryDelete?: Maybe<PaymentBatchEntryDeletePayload>;
  /** Update an existing PaymentBatchEntry by id */
  paymentBatchEntryUpdate?: Maybe<PaymentBatchEntryUpdatePayload>;
  /** Update an existing PaymentBatch by id */
  paymentBatchUpdate?: Maybe<PaymentBatchUpdatePayload>;
  /** Creates a new PaymentMethod */
  paymentMethodCreate?: Maybe<PaymentMethodCreatePayload>;
  /** Delete an existing PaymentMethod */
  paymentMethodDelete?: Maybe<PaymentMethodDeletePayload>;
  /** Update an existing PaymentMethod by id */
  paymentMethodUpdate?: Maybe<PaymentMethodUpdatePayload>;
  /** Creates a new Pet */
  petCreate?: Maybe<PetCreatePayload>;
  /** Delete an existing Pet */
  petDelete?: Maybe<PetDeletePayload>;
  /** Creates a new Product */
  petPlateProductCreate?: Maybe<PetPlateProductCreatePayload>;
  /** Delete an existing Product */
  petPlateProductDelete?: Maybe<PetPlateProductDeletePayload>;
  /** Update an existing Product by id */
  petPlateProductUpdate?: Maybe<PetPlateProductUpdatePayload>;
  /** Creates a new Subscription */
  petPlateSubscriptionCreate?: Maybe<PetPlateSubscriptionCreatePayload>;
  /** Create a new V2::Order for a Subscription */
  petPlateSubscriptionCreateOrder?: Maybe<PetPlateSubscriptionCreateOrderPayload>;
  /** Update an existing Pet by id */
  petUpdate?: Maybe<PetUpdatePayload>;
  /** Updates a plan compatibility criterium */
  planCompatibilityCriteriumUpdate?: Maybe<PlanCompatibilityCriteriumUpdatePayload>;
  /** Creates a new PlanMatchCriterium */
  planMatchCriteriumCreate?: Maybe<PlanMatchCriteriumCreatePayload>;
  /** Delete an existing PlanMatchCriterium */
  planMatchCriteriumDelete?: Maybe<PlanMatchCriteriumDeletePayload>;
  /** Update an existing PlanMatchCriterium by id */
  planMatchCriteriumUpdate?: Maybe<PlanMatchCriteriumUpdatePayload>;
  /** Creates a new Comment */
  ppCommentCreate?: Maybe<PpCommentCreatePayload>;
  /** Delete an existing Comment */
  ppCommentDelete?: Maybe<PpCommentDeletePayload>;
  /** Update an existing Comment by id */
  ppCommentUpdate?: Maybe<PpCommentUpdatePayload>;
  /** Creates a new Payment */
  ppPaymentCreate?: Maybe<PpPaymentCreatePayload>;
  /** Delete an existing Payment */
  ppPaymentDelete?: Maybe<PpPaymentDeletePayload>;
  /** Update an existing Payment by id */
  ppPaymentUpdate?: Maybe<PpPaymentUpdatePayload>;
  /** Updates a product plan variant's stock status */
  productPlanVariantUpdate?: Maybe<ProductPlanVariantUpdatePayload>;
  /** Creates a new product variant */
  productVariantCreate?: Maybe<ProductVariantCreatePayload>;
  /** Delete an existing ProductVariant */
  productVariantDelete?: Maybe<ProductVariantDeletePayload>;
  /** Update an existing ProductVariant by id */
  productVariantUpdate?: Maybe<ProductVariantUpdatePayload>;
  /** Creates a new Recipe */
  recipeCreate?: Maybe<RecipeCreatePayload>;
  /** Delete an existing Recipe */
  recipeDelete?: Maybe<RecipeDeletePayload>;
  /** Update an existing Recipe by id */
  recipeUpdate?: Maybe<RecipeUpdatePayload>;
  /** Creates a new RecommendableProduct */
  recommendableProductCreate?: Maybe<RecommendableProductCreatePayload>;
  /** Delete an existing RecommendableProduct */
  recommendableProductDelete?: Maybe<RecommendableProductDeletePayload>;
  /** Update an existing RecommendableProduct by id */
  recommendableProductUpdate?: Maybe<RecommendableProductUpdatePayload>;
  /** Creates a new RecommendationWizard */
  recommendationWizardCreate?: Maybe<RecommendationWizardCreatePayload>;
  /** Delete an existing RecommendationWizard */
  recommendationWizardDelete?: Maybe<RecommendationWizardDeletePayload>;
  /** Update an existing RecommendationWizard by id */
  recommendationWizardUpdate?: Maybe<RecommendationWizardUpdatePayload>;
  /** Applies a coupon promo and adds an item to the subscription */
  redeemCouponPromo?: Maybe<RedeemCouponPromoPayload>;
  refundLegacyPayment?: Maybe<MutationsRefundLegacyPaymentPayload>;
  /** Creates a new ReportJob */
  reportJobCreate?: Maybe<ReportJobCreatePayload>;
  /** Delete an existing ReportJob */
  reportJobDelete?: Maybe<ReportJobDeletePayload>;
  /** Update an existing ReportJob by id */
  reportJobUpdate?: Maybe<ReportJobUpdatePayload>;
  restoreVersionCms_page?: Maybe<Cms_Page>;
  /** Creates a new RetailPrice */
  retailPriceCreate?: Maybe<RetailPriceCreatePayload>;
  /** Delete an existing RetailPrice */
  retailPriceDelete?: Maybe<RetailPriceDeletePayload>;
  /** Update an existing RetailPrice by id */
  retailPriceUpdate?: Maybe<RetailPriceUpdatePayload>;
  /** Creates a new RouteSchedule */
  routeScheduleCreate?: Maybe<RouteScheduleCreatePayload>;
  /** Delete an existing RouteSchedule */
  routeScheduleDelete?: Maybe<RouteScheduleDeletePayload>;
  /** Update an existing RouteSchedule by id */
  routeScheduleUpdate?: Maybe<RouteScheduleUpdatePayload>;
  /** Re-send account activation email to user for specified subscription */
  sendAccountActivationEmail?: Maybe<SendAccountActivationEmailPayload>;
  /** Delete a specific setting key */
  settingDelete?: Maybe<SettingDeletePayload>;
  /** Update platform settings */
  settingsUpdate?: Maybe<SettingsUpdatePayload>;
  /** Creates a new ShipmentEntry */
  shipmentEntryCreate?: Maybe<ShipmentEntryCreatePayload>;
  /** Delete an existing ShipmentEntry */
  shipmentEntryDelete?: Maybe<ShipmentEntryDeletePayload>;
  /** Update an existing ShipmentEntry by id */
  shipmentEntryUpdate?: Maybe<ShipmentEntryUpdatePayload>;
  /** Creates a new ShipmentList */
  shipmentListCreate?: Maybe<ShipmentListCreatePayload>;
  /** Delete an existing ShipmentList */
  shipmentListDelete?: Maybe<ShipmentListDeletePayload>;
  /** Uploads a shipment list to ShipStation */
  shipmentListShipStationUpload?: Maybe<ShipmentListShipStationUploadPayload>;
  /** Update an existing ShipmentList by id */
  shipmentListUpdate?: Maybe<ShipmentListUpdatePayload>;
  /** Uploads a shipment list to shipstation using the shipstation API */
  shipmentListUpload?: Maybe<ShipmentListUploadPayload>;
  /** Update an existing ShopifyCustomer by id */
  shopifyCustomerUpdate: ShopifyCustomerUpdatePayload;
  /** Creates a new SizeClass */
  sizeClassCreate?: Maybe<SizeClassCreatePayload>;
  /** Delete an existing SizeClass */
  sizeClassDelete?: Maybe<SizeClassDeletePayload>;
  /** Update an existing SizeClass by id */
  sizeClassUpdate?: Maybe<SizeClassUpdatePayload>;
  /** Creates a new StateChange */
  stateChangeCreate?: Maybe<StateChangeCreatePayload>;
  /** Delete an existing StateChange */
  stateChangeDelete?: Maybe<StateChangeDeletePayload>;
  /** Update an existing StateChange by id */
  stateChangeUpdate?: Maybe<StateChangeUpdatePayload>;
  /** Creates a new StoreCreditAccount */
  storeCreditAccountCreate?: Maybe<StoreCreditAccountCreatePayload>;
  /** Delete an existing StoreCreditAccount */
  storeCreditAccountDelete?: Maybe<StoreCreditAccountDeletePayload>;
  /** Update an existing StoreCreditAccount by id */
  storeCreditAccountUpdate?: Maybe<StoreCreditAccountUpdatePayload>;
  /** Creates a new StoreCreditMovement */
  storeCreditMovementCreate?: Maybe<StoreCreditMovementCreatePayload>;
  /** Delete an existing StoreCreditMovement */
  storeCreditMovementDelete?: Maybe<StoreCreditMovementDeletePayload>;
  /** Update an existing StoreCreditMovement by id */
  storeCreditMovementUpdate?: Maybe<StoreCreditMovementUpdatePayload>;
  /** Creates a new Subscription */
  subscriptionCreate?: Maybe<SubscriptionCreatePayload>;
  /** Delete an existing Subscription */
  subscriptionDelete?: Maybe<SubscriptionDeletePayload>;
  /** Edit a subscription by id */
  subscriptionEdit?: Maybe<SubscriptionEditPayload>;
  /** Update an existing Subscription by id */
  subscriptionUpdate?: Maybe<SubscriptionUpdatePayload>;
  /** Creates customer credentials that can be used by an admin to impersonate the customer */
  sudo?: Maybe<SudoPayload>;
  /** Resync Subscription with Shopify */
  syncSubscriptionEntities?: Maybe<SyncSubscriptionEntitiesPayload>;
  /** Creates a new Tagging */
  taggingCreate?: Maybe<TaggingCreatePayload>;
  /** Delete an existing Tagging */
  taggingDelete?: Maybe<TaggingDeletePayload>;
  /** Update an existing Tagging by id */
  taggingUpdate?: Maybe<TaggingUpdatePayload>;
  /** Creates a new Term */
  termCreate?: Maybe<TermCreatePayload>;
  /** Delete an existing Term */
  termDelete?: Maybe<TermDeletePayload>;
  /** Update an existing Term by id */
  termUpdate?: Maybe<TermUpdatePayload>;
  /** Creates a new TransitConfiguration */
  transitConfigurationCreate?: Maybe<TransitConfigurationCreatePayload>;
  /** Delete an existing TransitConfiguration */
  transitConfigurationDelete?: Maybe<TransitConfigurationDeletePayload>;
  /** Update an existing TransitConfiguration by id */
  transitConfigurationUpdate?: Maybe<TransitConfigurationUpdatePayload>;
  updateCms_media?: Maybe<Cms_Media>;
  updateCms_page?: Maybe<Cms_Page>;
  updateFooter?: Maybe<Footer>;
  updateNav?: Maybe<Nav>;
  updatePayloadPreference?: Maybe<PayloadPreference>;
  userConfirmRegistrationWithToken?: Maybe<UserConfirmRegistrationWithTokenPayload>;
  /** Creates a new User */
  userCreate?: Maybe<UserCreatePayload>;
  /** Delete an existing User */
  userDelete?: Maybe<UserDeletePayload>;
  userLogin?: Maybe<UserLoginPayload>;
  userLogout?: Maybe<UserLogoutPayload>;
  /** SignUp a customer for the newsletter */
  userNewsletterSignUp: UserNewsletterSignUpPayload;
  userRegister?: Maybe<UserRegisterPayload>;
  userResendConfirmationWithToken?: Maybe<UserResendConfirmationWithTokenPayload>;
  userResetPasswordWithToken?: Maybe<UserResetPasswordWithTokenPayload>;
  userSendPasswordResetWithToken?: Maybe<UserSendPasswordResetWithTokenPayload>;
  /** Creates and/or completes the set up of a new user */
  userSignUp?: Maybe<UserSignUpPayload>;
  /** Update an existing User by id */
  userUpdate?: Maybe<UserUpdatePayload>;
  userUpdatePasswordWithToken?: Maybe<UserUpdatePasswordWithTokenPayload>;
  /** Creates a new V2Shipment */
  v2ShipmentCreate?: Maybe<V2ShipmentCreatePayload>;
  /** Delete an existing V2Shipment */
  v2ShipmentDelete?: Maybe<V2ShipmentDeletePayload>;
  /** Update an existing V2Shipment by id */
  v2ShipmentUpdate?: Maybe<V2ShipmentUpdatePayload>;
  /** Verify the validity of a recaptcha token */
  verifyCaptchaToken: VerifyCaptchaTokenPayload;
  /** Creates a new WellnessGoal */
  wellnessGoalCreate?: Maybe<WellnessGoalCreatePayload>;
  /** Delete an existing WellnessGoal */
  wellnessGoalDelete?: Maybe<WellnessGoalDeletePayload>;
  /** Update an existing WellnessGoal by id */
  wellnessGoalUpdate?: Maybe<WellnessGoalUpdatePayload>;
  /** Creates a new ZipCode */
  zipCodeCreate?: Maybe<ZipCodeCreatePayload>;
  /** Delete an existing ZipCode */
  zipCodeDelete?: Maybe<ZipCodeDeletePayload>;
  /** Creates a new ZipCodeLocation */
  zipCodeLocationCreate?: Maybe<ZipCodeLocationCreatePayload>;
  /** Delete an existing ZipCodeLocation */
  zipCodeLocationDelete?: Maybe<ZipCodeLocationDeletePayload>;
  /** Update an existing ZipCodeLocation by id */
  zipCodeLocationUpdate?: Maybe<ZipCodeLocationUpdatePayload>;
  /** Update an existing ZipCode by id */
  zipCodeUpdate?: Maybe<ZipCodeUpdatePayload>;
};


export type MutationAddressCreateArgs = {
  input: AddressCreateInput;
};


export type MutationAddressDeleteArgs = {
  input: AddressDeleteInput;
};


export type MutationAddressUpdateArgs = {
  input: AddressUpdateInput;
};


export type MutationAssignUserToSubflowArgs = {
  email: Scalars['String'];
  guestToken: Scalars['String'];
  password: Scalars['String'];
  recommendationWizardId: Scalars['String'];
};


export type MutationAutomationCreateArgs = {
  input: AutomationCreateInput;
};


export type MutationAutomationDeleteArgs = {
  input: AutomationDeleteInput;
};


export type MutationAutomationRunArgs = {
  input: AutomationRunInput;
};


export type MutationAutomationUpdateArgs = {
  input: AutomationUpdateInput;
};


export type MutationBoxCreateArgs = {
  input: BoxCreateInput;
};


export type MutationBoxDeleteArgs = {
  input: BoxDeleteInput;
};


export type MutationBoxUpdateArgs = {
  input: BoxUpdateInput;
};


export type MutationBoxVariantCreateArgs = {
  input: BoxVariantCreateInput;
};


export type MutationBoxVariantDeleteArgs = {
  input: BoxVariantDeleteInput;
};


export type MutationBoxVariantUpdateArgs = {
  input: BoxVariantUpdateInput;
};


export type MutationBreedCreateArgs = {
  input: BreedCreateInput;
};


export type MutationBreedDeleteArgs = {
  input: BreedDeleteInput;
};


export type MutationBreedUpdateArgs = {
  input: BreedUpdateInput;
};


export type MutationCalorieMultiplierCreateArgs = {
  input: CalorieMultiplierCreateInput;
};


export type MutationCalorieMultiplierDeleteArgs = {
  input: CalorieMultiplierDeleteInput;
};


export type MutationCalorieMultiplierUpdateArgs = {
  input: CalorieMultiplierUpdateInput;
};


export type MutationCancellationSurveyCreateArgs = {
  input: CancellationSurveyCreateInput;
};


export type MutationCancellationSurveyDeleteArgs = {
  input: CancellationSurveyDeleteInput;
};


export type MutationCancellationSurveyUpdateArgs = {
  input: CancellationSurveyUpdateInput;
};


export type MutationConversionSurveyCreateArgs = {
  input: ConversionSurveyCreateInput;
};


export type MutationConversionSurveyDeleteArgs = {
  input: ConversionSurveyDeleteInput;
};


export type MutationConversionSurveyUpdateArgs = {
  input: ConversionSurveyUpdateInput;
};


export type MutationCouponImportArgs = {
  input: CouponImportInput;
};


export type MutationCouponRefreshArgs = {
  input: CouponRefreshInput;
};


export type MutationCouponUpdateArgs = {
  input: CouponUpdateInput;
};


export type MutationCreateCms_MediaArgs = {
  data: MutationCms_MediaInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateCms_PageArgs = {
  data: MutationCms_PageInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreatePayloadPreferenceArgs = {
  data: MutationPayloadPreferenceInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreatePaymentBatchJobArgs = {
  input: CreatePaymentBatchJobInput;
};


export type MutationCreateUserForSubflowArgs = {
  confirmUrl?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  guestToken: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  recommendationWizardId: Scalars['String'];
};


export type MutationDbOrderCreateArgs = {
  input: DbOrderCreateInput;
};


export type MutationDbOrderDeleteArgs = {
  input: DbOrderDeleteInput;
};


export type MutationDbOrderEditArgs = {
  input: DbOrderEditInput;
};


export type MutationDbOrderRecreateArgs = {
  input: DbOrderRecreateInput;
};


export type MutationDbOrderReplaceArgs = {
  input: DbOrderReplaceInput;
};


export type MutationDbOrderUpdateArgs = {
  input: DbOrderUpdateInput;
};


export type MutationDeleteCms_MediaArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCms_PageArgs = {
  id: Scalars['String'];
};


export type MutationDeletePayloadPreferenceArgs = {
  id: Scalars['String'];
};


export type MutationDryIceMatrixTierUpdateArgs = {
  input: DryIceMatrixTierUpdateInput;
};


export type MutationDryIcePackagingCreateArgs = {
  input: DryIcePackagingCreateInput;
};


export type MutationDryIcePackagingDeleteArgs = {
  input: DryIcePackagingDeleteInput;
};


export type MutationDryIcePackagingMassCreateArgs = {
  input: DryIcePackagingMassCreateInput;
};


export type MutationDryIcePackagingMassUpdateArgs = {
  input: DryIcePackagingMassUpdateInput;
};


export type MutationDryIcePackagingUpdateArgs = {
  input: DryIcePackagingUpdateInput;
};


export type MutationDynamicLineItemArgs = {
  input: DynamicLineItemPutInput;
};


export type MutationFulfillmentScheduleRuleDeleteArgs = {
  input: FulfillmentScheduleRuleDeleteInput;
};


export type MutationFulfillmentScheduleRulesCreateArgs = {
  input: FulfillmentScheduleRulesCreateInput;
};


export type MutationImportJobCreateArgs = {
  input: ImportJobCreateInput;
};


export type MutationImportJobDeleteArgs = {
  input: ImportJobDeleteInput;
};


export type MutationImportJobLinePreviewCreateArgs = {
  input: ImportJobLinePreviewCreateInput;
};


export type MutationImportJobLinePreviewDeleteArgs = {
  input: ImportJobLinePreviewDeleteInput;
};


export type MutationImportJobLinePreviewUpdateArgs = {
  input: ImportJobLinePreviewUpdateInput;
};


export type MutationImportJobUpdateArgs = {
  input: ImportJobUpdateInput;
};


export type MutationIngredientCreateArgs = {
  input: IngredientCreateInput;
};


export type MutationIngredientDeleteArgs = {
  input: IngredientDeleteInput;
};


export type MutationIngredientUpdateArgs = {
  input: IngredientUpdateInput;
};


export type MutationLineItemRuleCreateArgs = {
  input: LineItemRuleCreateInput;
};


export type MutationLineItemRuleDeleteArgs = {
  input: LineItemRuleDeleteInput;
};


export type MutationLineItemRuleSetCreateArgs = {
  input: LineItemRuleSetCreateInput;
};


export type MutationLineItemRuleSetDeleteArgs = {
  input: LineItemRuleSetDeleteInput;
};


export type MutationLineItemRuleSetUpdateArgs = {
  input: LineItemRuleSetUpdateInput;
};


export type MutationLineItemRuleUpdateArgs = {
  input: LineItemRuleUpdateInput;
};


export type MutationLogEventCreateArgs = {
  input: LogEventCreateInput;
};


export type MutationLogEventDeleteArgs = {
  input: LogEventDeleteInput;
};


export type MutationLogEventUpdateArgs = {
  input: LogEventUpdateInput;
};


export type MutationMarkOrderAsDeliveredArgs = {
  input: MarkOrderAsDeliveredInput;
};


export type MutationMarkOrderPaymentAsFailedArgs = {
  input: MarkOrderPaymentAsFailedInput;
};


export type MutationMealCreateArgs = {
  input: MealCreateInput;
};


export type MutationMealDeleteArgs = {
  input: MealDeleteInput;
};


export type MutationMealLineItemCreateArgs = {
  input: MealLineItemCreateInput;
};


export type MutationMealLineItemDeleteArgs = {
  input: MealLineItemDeleteInput;
};


export type MutationMealLineItemUpdateArgs = {
  input: MealLineItemUpdateInput;
};


export type MutationMealPlanVariantUpdateArgs = {
  input: MealPlanVariantUpdateInput;
};


export type MutationMealUpdateArgs = {
  input: MealUpdateInput;
};


export type MutationMealVariantCreateArgs = {
  input: MealVariantCreateInput;
};


export type MutationMealVariantDeleteArgs = {
  input: MealVariantDeleteInput;
};


export type MutationMealVariantUpdateArgs = {
  input: MealVariantUpdateInput;
};


export type MutationNotificationBannerCreateArgs = {
  input: NotificationBannerCreateInput;
};


export type MutationNotificationBannerDeleteArgs = {
  input: NotificationBannerDeleteInput;
};


export type MutationNotificationBannerUpdateArgs = {
  input: NotificationBannerUpdateInput;
};


export type MutationOrderImportBatchCreateArgs = {
  input: OrderImportBatchCreateInput;
};


export type MutationOrderImportBatchDeleteArgs = {
  input: OrderImportBatchDeleteInput;
};


export type MutationOrderImportBatchEntryCreateArgs = {
  input: OrderImportBatchEntryCreateInput;
};


export type MutationOrderImportBatchEntryDeleteArgs = {
  input: OrderImportBatchEntryDeleteInput;
};


export type MutationOrderImportBatchEntryUpdateArgs = {
  input: OrderImportBatchEntryUpdateInput;
};


export type MutationOrderImportBatchUpdateArgs = {
  input: OrderImportBatchUpdateInput;
};


export type MutationPackagingCreateArgs = {
  input: PackagingCreateInput;
};


export type MutationPackagingDeleteArgs = {
  input: PackagingDeleteInput;
};


export type MutationPackagingUpdateArgs = {
  input: PackagingUpdateInput;
};


export type MutationPauseSurveyCreateArgs = {
  input: PauseSurveyCreateInput;
};


export type MutationPauseSurveyDeleteArgs = {
  input: PauseSurveyDeleteInput;
};


export type MutationPauseSurveyUpdateArgs = {
  input: PauseSurveyUpdateInput;
};


export type MutationPaymentAdjustmentCreateArgs = {
  input: PaymentAdjustmentCreateInput;
};


export type MutationPaymentAdjustmentDeleteArgs = {
  input: PaymentAdjustmentDeleteInput;
};


export type MutationPaymentAdjustmentUpdateArgs = {
  input: PaymentAdjustmentUpdateInput;
};


export type MutationPaymentBatchCreateArgs = {
  input: PaymentBatchCreateInput;
};


export type MutationPaymentBatchDeleteArgs = {
  input: PaymentBatchDeleteInput;
};


export type MutationPaymentBatchEntryCreateArgs = {
  input: PaymentBatchEntryCreateInput;
};


export type MutationPaymentBatchEntryDeleteArgs = {
  input: PaymentBatchEntryDeleteInput;
};


export type MutationPaymentBatchEntryUpdateArgs = {
  input: PaymentBatchEntryUpdateInput;
};


export type MutationPaymentBatchUpdateArgs = {
  input: PaymentBatchUpdateInput;
};


export type MutationPaymentMethodCreateArgs = {
  input: PaymentMethodCreateInput;
};


export type MutationPaymentMethodDeleteArgs = {
  input: PaymentMethodDeleteInput;
};


export type MutationPaymentMethodUpdateArgs = {
  input: PaymentMethodUpdateInput;
};


export type MutationPetCreateArgs = {
  input: PetCreateInput;
};


export type MutationPetDeleteArgs = {
  input: PetDeleteInput;
};


export type MutationPetPlateProductCreateArgs = {
  input: PetPlateProductCreateInput;
};


export type MutationPetPlateProductDeleteArgs = {
  input: PetPlateProductDeleteInput;
};


export type MutationPetPlateProductUpdateArgs = {
  input: PetPlateProductUpdateInput;
};


export type MutationPetPlateSubscriptionCreateArgs = {
  input: PetPlateSubscriptionCreateInput;
};


export type MutationPetPlateSubscriptionCreateOrderArgs = {
  input: PetPlateSubscriptionCreateOrderInput;
};


export type MutationPetUpdateArgs = {
  input: PetUpdateInput;
};


export type MutationPlanCompatibilityCriteriumUpdateArgs = {
  input: PlanCompatibilityCriteriumUpdateInput;
};


export type MutationPlanMatchCriteriumCreateArgs = {
  input: PlanMatchCriteriumCreateInput;
};


export type MutationPlanMatchCriteriumDeleteArgs = {
  input: PlanMatchCriteriumDeleteInput;
};


export type MutationPlanMatchCriteriumUpdateArgs = {
  input: PlanMatchCriteriumUpdateInput;
};


export type MutationPpCommentCreateArgs = {
  input: PpCommentCreateInput;
};


export type MutationPpCommentDeleteArgs = {
  input: PpCommentDeleteInput;
};


export type MutationPpCommentUpdateArgs = {
  input: PpCommentUpdateInput;
};


export type MutationPpPaymentCreateArgs = {
  input: PpPaymentCreateInput;
};


export type MutationPpPaymentDeleteArgs = {
  input: PpPaymentDeleteInput;
};


export type MutationPpPaymentUpdateArgs = {
  input: PpPaymentUpdateInput;
};


export type MutationProductPlanVariantUpdateArgs = {
  input: ProductPlanVariantUpdateInput;
};


export type MutationProductVariantCreateArgs = {
  input: ProductVariantCreateInput;
};


export type MutationProductVariantDeleteArgs = {
  input: ProductVariantDeleteInput;
};


export type MutationProductVariantUpdateArgs = {
  input: ProductVariantUpdateInput;
};


export type MutationRecipeCreateArgs = {
  input: RecipeCreateInput;
};


export type MutationRecipeDeleteArgs = {
  input: RecipeDeleteInput;
};


export type MutationRecipeUpdateArgs = {
  input: RecipeUpdateInput;
};


export type MutationRecommendableProductCreateArgs = {
  input: RecommendableProductCreateInput;
};


export type MutationRecommendableProductDeleteArgs = {
  input: RecommendableProductDeleteInput;
};


export type MutationRecommendableProductUpdateArgs = {
  input: RecommendableProductUpdateInput;
};


export type MutationRecommendationWizardCreateArgs = {
  input: RecommendationWizardCreateInput;
};


export type MutationRecommendationWizardDeleteArgs = {
  input: RecommendationWizardDeleteInput;
};


export type MutationRecommendationWizardUpdateArgs = {
  input: RecommendationWizardUpdateInput;
};


export type MutationRedeemCouponPromoArgs = {
  input: RedeemCouponPromoInput;
};


export type MutationRefundLegacyPaymentArgs = {
  input: MutationsRefundLegacyPaymentInput;
};


export type MutationReportJobCreateArgs = {
  input: ReportJobCreateInput;
};


export type MutationReportJobDeleteArgs = {
  input: ReportJobDeleteInput;
};


export type MutationReportJobUpdateArgs = {
  input: ReportJobUpdateInput;
};


export type MutationRestoreVersionCms_PageArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type MutationRetailPriceCreateArgs = {
  input: RetailPriceCreateInput;
};


export type MutationRetailPriceDeleteArgs = {
  input: RetailPriceDeleteInput;
};


export type MutationRetailPriceUpdateArgs = {
  input: RetailPriceUpdateInput;
};


export type MutationRouteScheduleCreateArgs = {
  input: RouteScheduleCreateInput;
};


export type MutationRouteScheduleDeleteArgs = {
  input: RouteScheduleDeleteInput;
};


export type MutationRouteScheduleUpdateArgs = {
  input: RouteScheduleUpdateInput;
};


export type MutationSendAccountActivationEmailArgs = {
  input: SendAccountActivationEmailInput;
};


export type MutationSettingDeleteArgs = {
  input: SettingDeleteInput;
};


export type MutationSettingsUpdateArgs = {
  input: SettingsUpdateInput;
};


export type MutationShipmentEntryCreateArgs = {
  input: ShipmentEntryCreateInput;
};


export type MutationShipmentEntryDeleteArgs = {
  input: ShipmentEntryDeleteInput;
};


export type MutationShipmentEntryUpdateArgs = {
  input: ShipmentEntryUpdateInput;
};


export type MutationShipmentListCreateArgs = {
  input: ShipmentListCreateInput;
};


export type MutationShipmentListDeleteArgs = {
  input: ShipmentListDeleteInput;
};


export type MutationShipmentListShipStationUploadArgs = {
  input: ShipmentListShipStationUploadInput;
};


export type MutationShipmentListUpdateArgs = {
  input: ShipmentListUpdateInput;
};


export type MutationShipmentListUploadArgs = {
  input: ShipmentListUploadInput;
};


export type MutationShopifyCustomerUpdateArgs = {
  input: ShopifyCustomerUpdateInput;
};


export type MutationSizeClassCreateArgs = {
  input: SizeClassCreateInput;
};


export type MutationSizeClassDeleteArgs = {
  input: SizeClassDeleteInput;
};


export type MutationSizeClassUpdateArgs = {
  input: SizeClassUpdateInput;
};


export type MutationStateChangeCreateArgs = {
  input: StateChangeCreateInput;
};


export type MutationStateChangeDeleteArgs = {
  input: StateChangeDeleteInput;
};


export type MutationStateChangeUpdateArgs = {
  input: StateChangeUpdateInput;
};


export type MutationStoreCreditAccountCreateArgs = {
  input: StoreCreditAccountCreateInput;
};


export type MutationStoreCreditAccountDeleteArgs = {
  input: StoreCreditAccountDeleteInput;
};


export type MutationStoreCreditAccountUpdateArgs = {
  input: StoreCreditAccountUpdateInput;
};


export type MutationStoreCreditMovementCreateArgs = {
  input: StoreCreditMovementCreateInput;
};


export type MutationStoreCreditMovementDeleteArgs = {
  input: StoreCreditMovementDeleteInput;
};


export type MutationStoreCreditMovementUpdateArgs = {
  input: StoreCreditMovementUpdateInput;
};


export type MutationSubscriptionCreateArgs = {
  input: SubscriptionCreateInput;
};


export type MutationSubscriptionDeleteArgs = {
  input: SubscriptionDeleteInput;
};


export type MutationSubscriptionEditArgs = {
  input: SubscriptionEditInput;
};


export type MutationSubscriptionUpdateArgs = {
  input: SubscriptionUpdateInput;
};


export type MutationSudoArgs = {
  input: SudoInput;
};


export type MutationSyncSubscriptionEntitiesArgs = {
  input: SyncSubscriptionEntitiesInput;
};


export type MutationTaggingCreateArgs = {
  input: TaggingCreateInput;
};


export type MutationTaggingDeleteArgs = {
  input: TaggingDeleteInput;
};


export type MutationTaggingUpdateArgs = {
  input: TaggingUpdateInput;
};


export type MutationTermCreateArgs = {
  input: TermCreateInput;
};


export type MutationTermDeleteArgs = {
  input: TermDeleteInput;
};


export type MutationTermUpdateArgs = {
  input: TermUpdateInput;
};


export type MutationTransitConfigurationCreateArgs = {
  input: TransitConfigurationCreateInput;
};


export type MutationTransitConfigurationDeleteArgs = {
  input: TransitConfigurationDeleteInput;
};


export type MutationTransitConfigurationUpdateArgs = {
  input: TransitConfigurationUpdateInput;
};


export type MutationUpdateCms_MediaArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationCms_MediaUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateCms_PageArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationCms_PageUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateFooterArgs = {
  data: MutationFooterInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateNavArgs = {
  data: MutationNavInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdatePayloadPreferenceArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationPayloadPreferenceUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUserConfirmRegistrationWithTokenArgs = {
  confirmationToken: Scalars['String'];
};


export type MutationUserCreateArgs = {
  input: UserCreateInput;
};


export type MutationUserDeleteArgs = {
  input: UserDeleteInput;
};


export type MutationUserLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUserNewsletterSignUpArgs = {
  input: UserNewsletterSignUpInput;
};


export type MutationUserRegisterArgs = {
  confirmUrl?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationUserResendConfirmationWithTokenArgs = {
  confirmUrl: Scalars['String'];
  email: Scalars['String'];
};


export type MutationUserResetPasswordWithTokenArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};


export type MutationUserSendPasswordResetWithTokenArgs = {
  email: Scalars['String'];
  redirectUrl: Scalars['String'];
};


export type MutationUserSignUpArgs = {
  confirmUrl?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


export type MutationUserUpdatePasswordWithTokenArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};


export type MutationV2ShipmentCreateArgs = {
  input: V2ShipmentCreateInput;
};


export type MutationV2ShipmentDeleteArgs = {
  input: V2ShipmentDeleteInput;
};


export type MutationV2ShipmentUpdateArgs = {
  input: V2ShipmentUpdateInput;
};


export type MutationVerifyCaptchaTokenArgs = {
  input: VerifyCaptchaTokenInput;
};


export type MutationWellnessGoalCreateArgs = {
  input: WellnessGoalCreateInput;
};


export type MutationWellnessGoalDeleteArgs = {
  input: WellnessGoalDeleteInput;
};


export type MutationWellnessGoalUpdateArgs = {
  input: WellnessGoalUpdateInput;
};


export type MutationZipCodeCreateArgs = {
  input: ZipCodeCreateInput;
};


export type MutationZipCodeDeleteArgs = {
  input: ZipCodeDeleteInput;
};


export type MutationZipCodeLocationCreateArgs = {
  input: ZipCodeLocationCreateInput;
};


export type MutationZipCodeLocationDeleteArgs = {
  input: ZipCodeLocationDeleteInput;
};


export type MutationZipCodeLocationUpdateArgs = {
  input: ZipCodeLocationUpdateInput;
};


export type MutationZipCodeUpdateArgs = {
  input: ZipCodeUpdateInput;
};

export type MutationsDbOrderEditInput = {
  addonLineItems?: InputMaybe<Array<TypesSubscriptionInputTypeLineItemInput>>;
  attributionChannel: MutationsDbOrderEditInputAttributionChannel;
  attributionSource: MutationsDbOrderEditInputAttributionSource;
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  contactPhoneNumber: Scalars['String'];
  entreeLineItems?: InputMaybe<Array<TypesSubscriptionInputTypeLineItemInput>>;
  estimatedShippingDate: Scalars['ISO8601Date'];
  id?: InputMaybe<Scalars['Int']>;
  mealPlanWeeksServed?: InputMaybe<Scalars['Int']>;
  normalizedCoupons?: InputMaybe<Array<Scalars['JSON']>>;
  petNames: Scalars['String'];
  planId: Scalars['Int'];
  shippingAddress?: InputMaybe<Scalars['JSON']>;
};

export enum MutationsDbOrderEditInputAttributionChannel {
  /** PetPlate Admin */
  PpAd = 'PP_AD',
  /** Petplate Amazon Order */
  PpAz = 'PP_AZ',
  /** Petplate Chewy Order */
  PpCh = 'PP_CH',
  /** PetPlate Express Checkout */
  PpEc = 'PP_EC',
  /** PetPlate Gift Order */
  PpGift = 'PP_GIFT',
  /** Purchase Order */
  PpPo = 'PP_PO',
  /** PetPlate Sample Order */
  PpSample = 'PP_SAMPLE',
  /** PetPlate Subscription Checkout */
  PpSc = 'PP_SC'
}

export enum MutationsDbOrderEditInputAttributionSource {
  /** Amazon */
  Amz = 'AMZ',
  /** Chewy */
  Chw = 'CHW',
  /** Independent Pet Partners */
  Ipp = 'IPP',
  /** PetPlate */
  Pp = 'PP',
  /** Pet Supplies Plus */
  Psp = 'PSP',
  /** Williams Sonoma */
  Ws = 'WS'
}

export type MutationsDryIcePackagingMassCreateMassCreate = {
  dryIceBlocks: Scalars['Int'];
  packagingId: Scalars['ID'];
  transitConfigurationId: Scalars['ID'];
};

export type MutationsDryIcePackagingMassUpdateMassUpdate = {
  dryIceBlocks: Scalars['Int'];
  id: Scalars['ID'];
};

export enum MutationsDynamicLineItemPutConflictStrategy {
  /** 1-to-many replacements */
  Many = 'MANY',
  /** Direct replacement */
  Skip = 'SKIP'
}

export enum MutationsDynamicLineItemPutDupCostAction {
  /** Replace line item cost */
  Replace = 'REPLACE',
  /** Leave line item cost as is */
  Skip = 'SKIP'
}

export enum MutationsDynamicLineItemPutDupCountAction {
  /** Use larger line item quantity */
  Max = 'MAX',
  /** Use smaller line item quantity */
  Min = 'MIN',
  /** Replace line item quantity */
  Replace = 'REPLACE',
  /** Leave line item quantity as is */
  Skip = 'SKIP',
  /** Add together line item quantities */
  Sum = 'SUM'
}

export enum MutationsDynamicLineItemPutDupNameAction {
  /** Replace line item name */
  Replace = 'REPLACE',
  /** Leave line item name as is */
  Skip = 'SKIP'
}

export enum MutationsDynamicLineItemPutDupSkuAction {
  /** Replace line item sku */
  Replace = 'REPLACE',
  /** Replace line item SKU with many skus */
  ReplaceWithMany = 'REPLACE_WITH_MANY',
  /** Leave line item sku as is */
  Skip = 'SKIP'
}

export enum MutationsDynamicLineItemPutDupWeightAction {
  /** Replace line item weight */
  Replace = 'REPLACE',
  /** Leave line item weight as is */
  Skip = 'SKIP'
}

export type MutationsDynamicLineItemPutInput = {
  active: Scalars['Boolean'];
  conflictStrategy: MutationsDynamicLineItemPutConflictStrategy;
  description: Scalars['String'];
  discount: Scalars['Float'];
  duplicateCostAction: MutationsDynamicLineItemPutDupCostAction;
  duplicateNameAction: MutationsDynamicLineItemPutDupNameAction;
  duplicateQuantityAction: MutationsDynamicLineItemPutDupCountAction;
  duplicateSkuAction: MutationsDynamicLineItemPutDupSkuAction;
  duplicateWeightAction: MutationsDynamicLineItemPutDupWeightAction;
  id?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Int'];
  limitStrategy: MutationsDynamicLineItemPutLimitAction;
  lineItemReplaceSku?: InputMaybe<Scalars['String']>;
  lineItemReplacements?: InputMaybe<Array<MutationsDynamicLineItemPutLineItemReplacementInput>>;
  lineItemRules: Array<MutationsDynamicLineItemPutLineItemRuleInput>;
  name: Scalars['String'];
  outOfStock?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  priority: Scalars['Int'];
  quantity: Scalars['Int'];
  sku: Scalars['String'];
  type: MutationsDynamicLineItemPutType;
  weight: Scalars['Float'];
};

export enum MutationsDynamicLineItemPutLimitAction {
  /** Customer */
  Customer = 'CUSTOMER',
  /** Subscription */
  Subscription = 'SUBSCRIPTION'
}

export type MutationsDynamicLineItemPutLineItemReplacementInput = {
  active: Scalars['Boolean'];
  sku: Scalars['String'];
};

export type MutationsDynamicLineItemPutLineItemRuleInput = {
  active: Scalars['Boolean'];
  field: MutationsDynamicLineItemPutLineItemRuleInputField;
  operator: MutationsDynamicLineItemPutLineItemRuleInputOperator;
  value: Array<Scalars['String']>;
};

export enum MutationsDynamicLineItemPutLineItemRuleInputField {
  AddonSku = 'addon_sku',
  BirthdayMonth = 'birthday_month',
  BoxSku = 'box_sku',
  DishSku = 'dish_sku',
  DryIce = 'dry_ice',
  ItemVolume = 'item_volume',
  OrderAttributionChannel = 'order_attribution_channel',
  OrderAttributionSource = 'order_attribution_source',
  OrderNumber = 'order_number',
  OrderPlanType = 'order_plan_type',
  PlanSku = 'plan_sku',
  ProductSellingSku = 'product_selling_sku',
  ShipDate = 'ship_date',
  StateAbbr = 'state_abbr',
  SubscriptionNumber = 'subscription_number',
  SubscriptionRenewals = 'subscription_renewals',
  TotalCustomerShipments = 'total_customer_shipments',
  TotalSubscriptionShipments = 'total_subscription_shipments',
  WarehouseCode = 'warehouse_code',
  ZipCode = 'zip_code'
}

export enum MutationsDynamicLineItemPutLineItemRuleInputOperator {
  /** Equals */
  Eq = 'eq',
  /** Greater than */
  Gt = 'gt',
  /** Less than */
  Lt = 'lt',
  /** Not equal */
  Not = 'not'
}

export enum MutationsDynamicLineItemPutType {
  Addon = 'addon',
  Custom = 'custom',
  Dish = 'dish',
  Insert = 'insert',
  Item = 'item',
  Packaging = 'packaging'
}

/** Autogenerated input type of MutationsRefundLegacyPayment */
export type MutationsRefundLegacyPaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['ID'];
  source: RefundSource;
  termId: Scalars['ID'];
};

/** Autogenerated return type of MutationsRefundLegacyPayment. */
export type MutationsRefundLegacyPaymentPayload = {
  __typename?: 'MutationsRefundLegacyPaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type MutationsSubscriptionEditInput = {
  addonLineItems: Array<TypesSubscriptionInputTypeAddonLineItemInput>;
  couponCodes?: InputMaybe<Array<Scalars['String']>>;
  currentPlanFrequency: Scalars['Int'];
  currentPlanId: Scalars['Int'];
  entreeLineItems: Array<TypesSubscriptionInputTypeLineItemInput>;
  id: Scalars['ID'];
  nextPlanFrequency?: InputMaybe<Scalars['Int']>;
  nextPlanId?: InputMaybe<Scalars['Int']>;
  nextScheduledShippingDate?: InputMaybe<Scalars['ISO8601Date']>;
  planSettings: PlanSettingsInput;
  scheduledShippingDate: Scalars['ISO8601Date'];
  shippingAddressAttributes?: InputMaybe<AddressInput>;
  tags?: InputMaybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type Nav = {
  __typename?: 'Nav';
  createdAt?: Maybe<Scalars['DateTime']>;
  links?: Maybe<Array<Nav_Links>>;
  sections?: Maybe<Array<Nav_Sections>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NavDocAccessFields = {
  __typename?: 'NavDocAccessFields';
  createdAt?: Maybe<NavDocAccessFields_CreatedAt>;
  links?: Maybe<NavDocAccessFields_Links>;
  sections?: Maybe<NavDocAccessFields_Sections>;
  updatedAt?: Maybe<NavDocAccessFields_UpdatedAt>;
};

export type NavDocAccessFields_CreatedAt = {
  __typename?: 'NavDocAccessFields_createdAt';
  create?: Maybe<NavDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<NavDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<NavDocAccessFields_CreatedAt_Read>;
  update?: Maybe<NavDocAccessFields_CreatedAt_Update>;
};

export type NavDocAccessFields_CreatedAt_Create = {
  __typename?: 'NavDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_CreatedAt_Delete = {
  __typename?: 'NavDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_CreatedAt_Read = {
  __typename?: 'NavDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_CreatedAt_Update = {
  __typename?: 'NavDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links = {
  __typename?: 'NavDocAccessFields_links';
  create?: Maybe<NavDocAccessFields_Links_Create>;
  delete?: Maybe<NavDocAccessFields_Links_Delete>;
  fields?: Maybe<NavDocAccessFields_Links_Fields>;
  read?: Maybe<NavDocAccessFields_Links_Read>;
  update?: Maybe<NavDocAccessFields_Links_Update>;
};

export type NavDocAccessFields_Links_Create = {
  __typename?: 'NavDocAccessFields_links_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Delete = {
  __typename?: 'NavDocAccessFields_links_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Fields = {
  __typename?: 'NavDocAccessFields_links_Fields';
  id?: Maybe<NavDocAccessFields_Links_Id>;
  isLinkPrefetched?: Maybe<NavDocAccessFields_Links_IsLinkPrefetched>;
  stripQueryParams?: Maybe<NavDocAccessFields_Links_StripQueryParams>;
  title?: Maybe<NavDocAccessFields_Links_Title>;
  url?: Maybe<NavDocAccessFields_Links_Url>;
};

export type NavDocAccessFields_Links_Read = {
  __typename?: 'NavDocAccessFields_links_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Update = {
  __typename?: 'NavDocAccessFields_links_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Id = {
  __typename?: 'NavDocAccessFields_links_id';
  create?: Maybe<NavDocAccessFields_Links_Id_Create>;
  delete?: Maybe<NavDocAccessFields_Links_Id_Delete>;
  read?: Maybe<NavDocAccessFields_Links_Id_Read>;
  update?: Maybe<NavDocAccessFields_Links_Id_Update>;
};

export type NavDocAccessFields_Links_Id_Create = {
  __typename?: 'NavDocAccessFields_links_id_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Id_Delete = {
  __typename?: 'NavDocAccessFields_links_id_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Id_Read = {
  __typename?: 'NavDocAccessFields_links_id_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Id_Update = {
  __typename?: 'NavDocAccessFields_links_id_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_IsLinkPrefetched = {
  __typename?: 'NavDocAccessFields_links_isLinkPrefetched';
  create?: Maybe<NavDocAccessFields_Links_IsLinkPrefetched_Create>;
  delete?: Maybe<NavDocAccessFields_Links_IsLinkPrefetched_Delete>;
  read?: Maybe<NavDocAccessFields_Links_IsLinkPrefetched_Read>;
  update?: Maybe<NavDocAccessFields_Links_IsLinkPrefetched_Update>;
};

export type NavDocAccessFields_Links_IsLinkPrefetched_Create = {
  __typename?: 'NavDocAccessFields_links_isLinkPrefetched_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_IsLinkPrefetched_Delete = {
  __typename?: 'NavDocAccessFields_links_isLinkPrefetched_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_IsLinkPrefetched_Read = {
  __typename?: 'NavDocAccessFields_links_isLinkPrefetched_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_IsLinkPrefetched_Update = {
  __typename?: 'NavDocAccessFields_links_isLinkPrefetched_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_StripQueryParams = {
  __typename?: 'NavDocAccessFields_links_stripQueryParams';
  create?: Maybe<NavDocAccessFields_Links_StripQueryParams_Create>;
  delete?: Maybe<NavDocAccessFields_Links_StripQueryParams_Delete>;
  read?: Maybe<NavDocAccessFields_Links_StripQueryParams_Read>;
  update?: Maybe<NavDocAccessFields_Links_StripQueryParams_Update>;
};

export type NavDocAccessFields_Links_StripQueryParams_Create = {
  __typename?: 'NavDocAccessFields_links_stripQueryParams_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_StripQueryParams_Delete = {
  __typename?: 'NavDocAccessFields_links_stripQueryParams_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_StripQueryParams_Read = {
  __typename?: 'NavDocAccessFields_links_stripQueryParams_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_StripQueryParams_Update = {
  __typename?: 'NavDocAccessFields_links_stripQueryParams_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Title = {
  __typename?: 'NavDocAccessFields_links_title';
  create?: Maybe<NavDocAccessFields_Links_Title_Create>;
  delete?: Maybe<NavDocAccessFields_Links_Title_Delete>;
  read?: Maybe<NavDocAccessFields_Links_Title_Read>;
  update?: Maybe<NavDocAccessFields_Links_Title_Update>;
};

export type NavDocAccessFields_Links_Title_Create = {
  __typename?: 'NavDocAccessFields_links_title_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Title_Delete = {
  __typename?: 'NavDocAccessFields_links_title_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Title_Read = {
  __typename?: 'NavDocAccessFields_links_title_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Title_Update = {
  __typename?: 'NavDocAccessFields_links_title_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Url = {
  __typename?: 'NavDocAccessFields_links_url';
  create?: Maybe<NavDocAccessFields_Links_Url_Create>;
  delete?: Maybe<NavDocAccessFields_Links_Url_Delete>;
  read?: Maybe<NavDocAccessFields_Links_Url_Read>;
  update?: Maybe<NavDocAccessFields_Links_Url_Update>;
};

export type NavDocAccessFields_Links_Url_Create = {
  __typename?: 'NavDocAccessFields_links_url_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Url_Delete = {
  __typename?: 'NavDocAccessFields_links_url_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Url_Read = {
  __typename?: 'NavDocAccessFields_links_url_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Links_Url_Update = {
  __typename?: 'NavDocAccessFields_links_url_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections = {
  __typename?: 'NavDocAccessFields_sections';
  create?: Maybe<NavDocAccessFields_Sections_Create>;
  delete?: Maybe<NavDocAccessFields_Sections_Delete>;
  fields?: Maybe<NavDocAccessFields_Sections_Fields>;
  read?: Maybe<NavDocAccessFields_Sections_Read>;
  update?: Maybe<NavDocAccessFields_Sections_Update>;
};

export type NavDocAccessFields_Sections_Create = {
  __typename?: 'NavDocAccessFields_sections_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Delete = {
  __typename?: 'NavDocAccessFields_sections_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Fields = {
  __typename?: 'NavDocAccessFields_sections_Fields';
  header?: Maybe<NavDocAccessFields_Sections_Header>;
  id?: Maybe<NavDocAccessFields_Sections_Id>;
  links?: Maybe<NavDocAccessFields_Sections_Links>;
};

export type NavDocAccessFields_Sections_Read = {
  __typename?: 'NavDocAccessFields_sections_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Update = {
  __typename?: 'NavDocAccessFields_sections_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Header = {
  __typename?: 'NavDocAccessFields_sections_header';
  create?: Maybe<NavDocAccessFields_Sections_Header_Create>;
  delete?: Maybe<NavDocAccessFields_Sections_Header_Delete>;
  read?: Maybe<NavDocAccessFields_Sections_Header_Read>;
  update?: Maybe<NavDocAccessFields_Sections_Header_Update>;
};

export type NavDocAccessFields_Sections_Header_Create = {
  __typename?: 'NavDocAccessFields_sections_header_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Header_Delete = {
  __typename?: 'NavDocAccessFields_sections_header_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Header_Read = {
  __typename?: 'NavDocAccessFields_sections_header_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Header_Update = {
  __typename?: 'NavDocAccessFields_sections_header_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Id = {
  __typename?: 'NavDocAccessFields_sections_id';
  create?: Maybe<NavDocAccessFields_Sections_Id_Create>;
  delete?: Maybe<NavDocAccessFields_Sections_Id_Delete>;
  read?: Maybe<NavDocAccessFields_Sections_Id_Read>;
  update?: Maybe<NavDocAccessFields_Sections_Id_Update>;
};

export type NavDocAccessFields_Sections_Id_Create = {
  __typename?: 'NavDocAccessFields_sections_id_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Id_Delete = {
  __typename?: 'NavDocAccessFields_sections_id_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Id_Read = {
  __typename?: 'NavDocAccessFields_sections_id_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Id_Update = {
  __typename?: 'NavDocAccessFields_sections_id_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links = {
  __typename?: 'NavDocAccessFields_sections_links';
  create?: Maybe<NavDocAccessFields_Sections_Links_Create>;
  delete?: Maybe<NavDocAccessFields_Sections_Links_Delete>;
  fields?: Maybe<NavDocAccessFields_Sections_Links_Fields>;
  read?: Maybe<NavDocAccessFields_Sections_Links_Read>;
  update?: Maybe<NavDocAccessFields_Sections_Links_Update>;
};

export type NavDocAccessFields_Sections_Links_Create = {
  __typename?: 'NavDocAccessFields_sections_links_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Delete = {
  __typename?: 'NavDocAccessFields_sections_links_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Fields = {
  __typename?: 'NavDocAccessFields_sections_links_Fields';
  id?: Maybe<NavDocAccessFields_Sections_Links_Id>;
  isLinkPrefetched?: Maybe<NavDocAccessFields_Sections_Links_IsLinkPrefetched>;
  stripQueryParams?: Maybe<NavDocAccessFields_Sections_Links_StripQueryParams>;
  title?: Maybe<NavDocAccessFields_Sections_Links_Title>;
  url?: Maybe<NavDocAccessFields_Sections_Links_Url>;
};

export type NavDocAccessFields_Sections_Links_Read = {
  __typename?: 'NavDocAccessFields_sections_links_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Update = {
  __typename?: 'NavDocAccessFields_sections_links_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Id = {
  __typename?: 'NavDocAccessFields_sections_links_id';
  create?: Maybe<NavDocAccessFields_Sections_Links_Id_Create>;
  delete?: Maybe<NavDocAccessFields_Sections_Links_Id_Delete>;
  read?: Maybe<NavDocAccessFields_Sections_Links_Id_Read>;
  update?: Maybe<NavDocAccessFields_Sections_Links_Id_Update>;
};

export type NavDocAccessFields_Sections_Links_Id_Create = {
  __typename?: 'NavDocAccessFields_sections_links_id_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Id_Delete = {
  __typename?: 'NavDocAccessFields_sections_links_id_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Id_Read = {
  __typename?: 'NavDocAccessFields_sections_links_id_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Id_Update = {
  __typename?: 'NavDocAccessFields_sections_links_id_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_IsLinkPrefetched = {
  __typename?: 'NavDocAccessFields_sections_links_isLinkPrefetched';
  create?: Maybe<NavDocAccessFields_Sections_Links_IsLinkPrefetched_Create>;
  delete?: Maybe<NavDocAccessFields_Sections_Links_IsLinkPrefetched_Delete>;
  read?: Maybe<NavDocAccessFields_Sections_Links_IsLinkPrefetched_Read>;
  update?: Maybe<NavDocAccessFields_Sections_Links_IsLinkPrefetched_Update>;
};

export type NavDocAccessFields_Sections_Links_IsLinkPrefetched_Create = {
  __typename?: 'NavDocAccessFields_sections_links_isLinkPrefetched_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_IsLinkPrefetched_Delete = {
  __typename?: 'NavDocAccessFields_sections_links_isLinkPrefetched_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_IsLinkPrefetched_Read = {
  __typename?: 'NavDocAccessFields_sections_links_isLinkPrefetched_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_IsLinkPrefetched_Update = {
  __typename?: 'NavDocAccessFields_sections_links_isLinkPrefetched_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_StripQueryParams = {
  __typename?: 'NavDocAccessFields_sections_links_stripQueryParams';
  create?: Maybe<NavDocAccessFields_Sections_Links_StripQueryParams_Create>;
  delete?: Maybe<NavDocAccessFields_Sections_Links_StripQueryParams_Delete>;
  read?: Maybe<NavDocAccessFields_Sections_Links_StripQueryParams_Read>;
  update?: Maybe<NavDocAccessFields_Sections_Links_StripQueryParams_Update>;
};

export type NavDocAccessFields_Sections_Links_StripQueryParams_Create = {
  __typename?: 'NavDocAccessFields_sections_links_stripQueryParams_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_StripQueryParams_Delete = {
  __typename?: 'NavDocAccessFields_sections_links_stripQueryParams_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_StripQueryParams_Read = {
  __typename?: 'NavDocAccessFields_sections_links_stripQueryParams_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_StripQueryParams_Update = {
  __typename?: 'NavDocAccessFields_sections_links_stripQueryParams_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Title = {
  __typename?: 'NavDocAccessFields_sections_links_title';
  create?: Maybe<NavDocAccessFields_Sections_Links_Title_Create>;
  delete?: Maybe<NavDocAccessFields_Sections_Links_Title_Delete>;
  read?: Maybe<NavDocAccessFields_Sections_Links_Title_Read>;
  update?: Maybe<NavDocAccessFields_Sections_Links_Title_Update>;
};

export type NavDocAccessFields_Sections_Links_Title_Create = {
  __typename?: 'NavDocAccessFields_sections_links_title_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Title_Delete = {
  __typename?: 'NavDocAccessFields_sections_links_title_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Title_Read = {
  __typename?: 'NavDocAccessFields_sections_links_title_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Title_Update = {
  __typename?: 'NavDocAccessFields_sections_links_title_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Url = {
  __typename?: 'NavDocAccessFields_sections_links_url';
  create?: Maybe<NavDocAccessFields_Sections_Links_Url_Create>;
  delete?: Maybe<NavDocAccessFields_Sections_Links_Url_Delete>;
  read?: Maybe<NavDocAccessFields_Sections_Links_Url_Read>;
  update?: Maybe<NavDocAccessFields_Sections_Links_Url_Update>;
};

export type NavDocAccessFields_Sections_Links_Url_Create = {
  __typename?: 'NavDocAccessFields_sections_links_url_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Url_Delete = {
  __typename?: 'NavDocAccessFields_sections_links_url_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Url_Read = {
  __typename?: 'NavDocAccessFields_sections_links_url_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_Sections_Links_Url_Update = {
  __typename?: 'NavDocAccessFields_sections_links_url_Update';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_UpdatedAt = {
  __typename?: 'NavDocAccessFields_updatedAt';
  create?: Maybe<NavDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<NavDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<NavDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<NavDocAccessFields_UpdatedAt_Update>;
};

export type NavDocAccessFields_UpdatedAt_Create = {
  __typename?: 'NavDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'NavDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_UpdatedAt_Read = {
  __typename?: 'NavDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type NavDocAccessFields_UpdatedAt_Update = {
  __typename?: 'NavDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type NavFields = {
  __typename?: 'NavFields';
  createdAt?: Maybe<NavFields_CreatedAt>;
  links?: Maybe<NavFields_Links>;
  sections?: Maybe<NavFields_Sections>;
  updatedAt?: Maybe<NavFields_UpdatedAt>;
};

export type NavFields_CreatedAt = {
  __typename?: 'NavFields_createdAt';
  create?: Maybe<NavFields_CreatedAt_Create>;
  delete?: Maybe<NavFields_CreatedAt_Delete>;
  read?: Maybe<NavFields_CreatedAt_Read>;
  update?: Maybe<NavFields_CreatedAt_Update>;
};

export type NavFields_CreatedAt_Create = {
  __typename?: 'NavFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_CreatedAt_Delete = {
  __typename?: 'NavFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_CreatedAt_Read = {
  __typename?: 'NavFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_CreatedAt_Update = {
  __typename?: 'NavFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Links = {
  __typename?: 'NavFields_links';
  create?: Maybe<NavFields_Links_Create>;
  delete?: Maybe<NavFields_Links_Delete>;
  fields?: Maybe<NavFields_Links_Fields>;
  read?: Maybe<NavFields_Links_Read>;
  update?: Maybe<NavFields_Links_Update>;
};

export type NavFields_Links_Create = {
  __typename?: 'NavFields_links_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Delete = {
  __typename?: 'NavFields_links_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Fields = {
  __typename?: 'NavFields_links_Fields';
  id?: Maybe<NavFields_Links_Id>;
  isLinkPrefetched?: Maybe<NavFields_Links_IsLinkPrefetched>;
  stripQueryParams?: Maybe<NavFields_Links_StripQueryParams>;
  title?: Maybe<NavFields_Links_Title>;
  url?: Maybe<NavFields_Links_Url>;
};

export type NavFields_Links_Read = {
  __typename?: 'NavFields_links_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Update = {
  __typename?: 'NavFields_links_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Id = {
  __typename?: 'NavFields_links_id';
  create?: Maybe<NavFields_Links_Id_Create>;
  delete?: Maybe<NavFields_Links_Id_Delete>;
  read?: Maybe<NavFields_Links_Id_Read>;
  update?: Maybe<NavFields_Links_Id_Update>;
};

export type NavFields_Links_Id_Create = {
  __typename?: 'NavFields_links_id_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Id_Delete = {
  __typename?: 'NavFields_links_id_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Id_Read = {
  __typename?: 'NavFields_links_id_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Id_Update = {
  __typename?: 'NavFields_links_id_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_IsLinkPrefetched = {
  __typename?: 'NavFields_links_isLinkPrefetched';
  create?: Maybe<NavFields_Links_IsLinkPrefetched_Create>;
  delete?: Maybe<NavFields_Links_IsLinkPrefetched_Delete>;
  read?: Maybe<NavFields_Links_IsLinkPrefetched_Read>;
  update?: Maybe<NavFields_Links_IsLinkPrefetched_Update>;
};

export type NavFields_Links_IsLinkPrefetched_Create = {
  __typename?: 'NavFields_links_isLinkPrefetched_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_IsLinkPrefetched_Delete = {
  __typename?: 'NavFields_links_isLinkPrefetched_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_IsLinkPrefetched_Read = {
  __typename?: 'NavFields_links_isLinkPrefetched_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_IsLinkPrefetched_Update = {
  __typename?: 'NavFields_links_isLinkPrefetched_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_StripQueryParams = {
  __typename?: 'NavFields_links_stripQueryParams';
  create?: Maybe<NavFields_Links_StripQueryParams_Create>;
  delete?: Maybe<NavFields_Links_StripQueryParams_Delete>;
  read?: Maybe<NavFields_Links_StripQueryParams_Read>;
  update?: Maybe<NavFields_Links_StripQueryParams_Update>;
};

export type NavFields_Links_StripQueryParams_Create = {
  __typename?: 'NavFields_links_stripQueryParams_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_StripQueryParams_Delete = {
  __typename?: 'NavFields_links_stripQueryParams_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_StripQueryParams_Read = {
  __typename?: 'NavFields_links_stripQueryParams_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_StripQueryParams_Update = {
  __typename?: 'NavFields_links_stripQueryParams_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Title = {
  __typename?: 'NavFields_links_title';
  create?: Maybe<NavFields_Links_Title_Create>;
  delete?: Maybe<NavFields_Links_Title_Delete>;
  read?: Maybe<NavFields_Links_Title_Read>;
  update?: Maybe<NavFields_Links_Title_Update>;
};

export type NavFields_Links_Title_Create = {
  __typename?: 'NavFields_links_title_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Title_Delete = {
  __typename?: 'NavFields_links_title_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Title_Read = {
  __typename?: 'NavFields_links_title_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Title_Update = {
  __typename?: 'NavFields_links_title_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Url = {
  __typename?: 'NavFields_links_url';
  create?: Maybe<NavFields_Links_Url_Create>;
  delete?: Maybe<NavFields_Links_Url_Delete>;
  read?: Maybe<NavFields_Links_Url_Read>;
  update?: Maybe<NavFields_Links_Url_Update>;
};

export type NavFields_Links_Url_Create = {
  __typename?: 'NavFields_links_url_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Url_Delete = {
  __typename?: 'NavFields_links_url_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Url_Read = {
  __typename?: 'NavFields_links_url_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Links_Url_Update = {
  __typename?: 'NavFields_links_url_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections = {
  __typename?: 'NavFields_sections';
  create?: Maybe<NavFields_Sections_Create>;
  delete?: Maybe<NavFields_Sections_Delete>;
  fields?: Maybe<NavFields_Sections_Fields>;
  read?: Maybe<NavFields_Sections_Read>;
  update?: Maybe<NavFields_Sections_Update>;
};

export type NavFields_Sections_Create = {
  __typename?: 'NavFields_sections_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Delete = {
  __typename?: 'NavFields_sections_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Fields = {
  __typename?: 'NavFields_sections_Fields';
  header?: Maybe<NavFields_Sections_Header>;
  id?: Maybe<NavFields_Sections_Id>;
  links?: Maybe<NavFields_Sections_Links>;
};

export type NavFields_Sections_Read = {
  __typename?: 'NavFields_sections_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Update = {
  __typename?: 'NavFields_sections_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Header = {
  __typename?: 'NavFields_sections_header';
  create?: Maybe<NavFields_Sections_Header_Create>;
  delete?: Maybe<NavFields_Sections_Header_Delete>;
  read?: Maybe<NavFields_Sections_Header_Read>;
  update?: Maybe<NavFields_Sections_Header_Update>;
};

export type NavFields_Sections_Header_Create = {
  __typename?: 'NavFields_sections_header_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Header_Delete = {
  __typename?: 'NavFields_sections_header_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Header_Read = {
  __typename?: 'NavFields_sections_header_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Header_Update = {
  __typename?: 'NavFields_sections_header_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Id = {
  __typename?: 'NavFields_sections_id';
  create?: Maybe<NavFields_Sections_Id_Create>;
  delete?: Maybe<NavFields_Sections_Id_Delete>;
  read?: Maybe<NavFields_Sections_Id_Read>;
  update?: Maybe<NavFields_Sections_Id_Update>;
};

export type NavFields_Sections_Id_Create = {
  __typename?: 'NavFields_sections_id_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Id_Delete = {
  __typename?: 'NavFields_sections_id_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Id_Read = {
  __typename?: 'NavFields_sections_id_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Id_Update = {
  __typename?: 'NavFields_sections_id_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links = {
  __typename?: 'NavFields_sections_links';
  create?: Maybe<NavFields_Sections_Links_Create>;
  delete?: Maybe<NavFields_Sections_Links_Delete>;
  fields?: Maybe<NavFields_Sections_Links_Fields>;
  read?: Maybe<NavFields_Sections_Links_Read>;
  update?: Maybe<NavFields_Sections_Links_Update>;
};

export type NavFields_Sections_Links_Create = {
  __typename?: 'NavFields_sections_links_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Delete = {
  __typename?: 'NavFields_sections_links_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Fields = {
  __typename?: 'NavFields_sections_links_Fields';
  id?: Maybe<NavFields_Sections_Links_Id>;
  isLinkPrefetched?: Maybe<NavFields_Sections_Links_IsLinkPrefetched>;
  stripQueryParams?: Maybe<NavFields_Sections_Links_StripQueryParams>;
  title?: Maybe<NavFields_Sections_Links_Title>;
  url?: Maybe<NavFields_Sections_Links_Url>;
};

export type NavFields_Sections_Links_Read = {
  __typename?: 'NavFields_sections_links_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Update = {
  __typename?: 'NavFields_sections_links_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Id = {
  __typename?: 'NavFields_sections_links_id';
  create?: Maybe<NavFields_Sections_Links_Id_Create>;
  delete?: Maybe<NavFields_Sections_Links_Id_Delete>;
  read?: Maybe<NavFields_Sections_Links_Id_Read>;
  update?: Maybe<NavFields_Sections_Links_Id_Update>;
};

export type NavFields_Sections_Links_Id_Create = {
  __typename?: 'NavFields_sections_links_id_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Id_Delete = {
  __typename?: 'NavFields_sections_links_id_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Id_Read = {
  __typename?: 'NavFields_sections_links_id_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Id_Update = {
  __typename?: 'NavFields_sections_links_id_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_IsLinkPrefetched = {
  __typename?: 'NavFields_sections_links_isLinkPrefetched';
  create?: Maybe<NavFields_Sections_Links_IsLinkPrefetched_Create>;
  delete?: Maybe<NavFields_Sections_Links_IsLinkPrefetched_Delete>;
  read?: Maybe<NavFields_Sections_Links_IsLinkPrefetched_Read>;
  update?: Maybe<NavFields_Sections_Links_IsLinkPrefetched_Update>;
};

export type NavFields_Sections_Links_IsLinkPrefetched_Create = {
  __typename?: 'NavFields_sections_links_isLinkPrefetched_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_IsLinkPrefetched_Delete = {
  __typename?: 'NavFields_sections_links_isLinkPrefetched_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_IsLinkPrefetched_Read = {
  __typename?: 'NavFields_sections_links_isLinkPrefetched_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_IsLinkPrefetched_Update = {
  __typename?: 'NavFields_sections_links_isLinkPrefetched_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_StripQueryParams = {
  __typename?: 'NavFields_sections_links_stripQueryParams';
  create?: Maybe<NavFields_Sections_Links_StripQueryParams_Create>;
  delete?: Maybe<NavFields_Sections_Links_StripQueryParams_Delete>;
  read?: Maybe<NavFields_Sections_Links_StripQueryParams_Read>;
  update?: Maybe<NavFields_Sections_Links_StripQueryParams_Update>;
};

export type NavFields_Sections_Links_StripQueryParams_Create = {
  __typename?: 'NavFields_sections_links_stripQueryParams_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_StripQueryParams_Delete = {
  __typename?: 'NavFields_sections_links_stripQueryParams_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_StripQueryParams_Read = {
  __typename?: 'NavFields_sections_links_stripQueryParams_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_StripQueryParams_Update = {
  __typename?: 'NavFields_sections_links_stripQueryParams_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Title = {
  __typename?: 'NavFields_sections_links_title';
  create?: Maybe<NavFields_Sections_Links_Title_Create>;
  delete?: Maybe<NavFields_Sections_Links_Title_Delete>;
  read?: Maybe<NavFields_Sections_Links_Title_Read>;
  update?: Maybe<NavFields_Sections_Links_Title_Update>;
};

export type NavFields_Sections_Links_Title_Create = {
  __typename?: 'NavFields_sections_links_title_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Title_Delete = {
  __typename?: 'NavFields_sections_links_title_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Title_Read = {
  __typename?: 'NavFields_sections_links_title_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Title_Update = {
  __typename?: 'NavFields_sections_links_title_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Url = {
  __typename?: 'NavFields_sections_links_url';
  create?: Maybe<NavFields_Sections_Links_Url_Create>;
  delete?: Maybe<NavFields_Sections_Links_Url_Delete>;
  read?: Maybe<NavFields_Sections_Links_Url_Read>;
  update?: Maybe<NavFields_Sections_Links_Url_Update>;
};

export type NavFields_Sections_Links_Url_Create = {
  __typename?: 'NavFields_sections_links_url_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Url_Delete = {
  __typename?: 'NavFields_sections_links_url_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Url_Read = {
  __typename?: 'NavFields_sections_links_url_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_Sections_Links_Url_Update = {
  __typename?: 'NavFields_sections_links_url_Update';
  permission: Scalars['Boolean'];
};

export type NavFields_UpdatedAt = {
  __typename?: 'NavFields_updatedAt';
  create?: Maybe<NavFields_UpdatedAt_Create>;
  delete?: Maybe<NavFields_UpdatedAt_Delete>;
  read?: Maybe<NavFields_UpdatedAt_Read>;
  update?: Maybe<NavFields_UpdatedAt_Update>;
};

export type NavFields_UpdatedAt_Create = {
  __typename?: 'NavFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type NavFields_UpdatedAt_Delete = {
  __typename?: 'NavFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type NavFields_UpdatedAt_Read = {
  __typename?: 'NavFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type NavFields_UpdatedAt_Update = {
  __typename?: 'NavFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type NavReadAccess = {
  __typename?: 'NavReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type NavReadDocAccess = {
  __typename?: 'NavReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type NavUpdateAccess = {
  __typename?: 'NavUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type NavUpdateDocAccess = {
  __typename?: 'NavUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Nav_Links = {
  __typename?: 'Nav_Links';
  id?: Maybe<Scalars['String']>;
  isLinkPrefetched?: Maybe<Scalars['Boolean']>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Nav_Sections = {
  __typename?: 'Nav_Sections';
  header?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Nav_Sections_Links>>;
};

export type Nav_Sections_Links = {
  __typename?: 'Nav_Sections_Links';
  id?: Maybe<Scalars['String']>;
  isLinkPrefetched?: Maybe<Scalars['Boolean']>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type NewsletterSignup = {
  __typename?: 'NewsletterSignup';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<NewsletterSignup_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  listId?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['JSON']>;
};


export type NewsletterSignupTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type NewsletterSignup_BlockSettings = {
  __typename?: 'NewsletterSignup_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<NewsletterSignup_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<NewsletterSignup_BlockSettings_ResponsiveStyles>>;
};

export type NewsletterSignup_BlockSettings_ResponsiveStyles = {
  __typename?: 'NewsletterSignup_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<NewsletterSignup_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<NewsletterSignup_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<NewsletterSignup_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum NewsletterSignup_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum NewsletterSignup_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum NewsletterSignup_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum NewsletterSignup_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type NotificationBanner = {
  __typename?: 'NotificationBanner';
  createdAt: Scalars['ISO8601DateTime'];
  endDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  message: Scalars['String'];
  notificationBannerType: NotificationBannerTypeEnum;
  relevantDelayDate?: Maybe<Scalars['ISO8601Date']>;
  startDate: Scalars['ISO8601Date'];
  updatedAt: Scalars['ISO8601DateTime'];
  user?: Maybe<User>;
};

/** The connection type for NotificationBanner. */
export type NotificationBannerConnection = {
  __typename?: 'NotificationBannerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationBannerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<NotificationBanner>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of NotificationBannerCreate */
export type NotificationBannerCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  notificationBannerInput: NotificationBannerInput;
};

/** Autogenerated return type of NotificationBannerCreate. */
export type NotificationBannerCreatePayload = {
  __typename?: 'NotificationBannerCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  notificationBanner: NotificationBanner;
};

/** Autogenerated input type of NotificationBannerDelete */
export type NotificationBannerDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of NotificationBannerDelete. */
export type NotificationBannerDeletePayload = {
  __typename?: 'NotificationBannerDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  notificationBanner: NotificationBanner;
};

/** An edge in a connection. */
export type NotificationBannerEdge = {
  __typename?: 'NotificationBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<NotificationBanner>;
};

export type NotificationBannerInput = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  message?: InputMaybe<Scalars['String']>;
  notificationBannerType?: InputMaybe<NotificationBannerTypeEnum>;
  relevantDelayDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};

export enum NotificationBannerTypeEnum {
  Delay = 'delay',
  General = 'general'
}

/** Autogenerated input type of NotificationBannerUpdate */
export type NotificationBannerUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  notificationBannerInput: NotificationBannerInput;
};

/** Autogenerated return type of NotificationBannerUpdate. */
export type NotificationBannerUpdatePayload = {
  __typename?: 'NotificationBannerUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  notificationBanner: NotificationBanner;
};

export type NumberedText = {
  __typename?: 'NumberedText';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<NumberedText_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  items?: Maybe<Array<NumberedText_Items>>;
  title?: Maybe<Scalars['String']>;
};

export type NumberedText_BlockSettings = {
  __typename?: 'NumberedText_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<NumberedText_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<NumberedText_BlockSettings_ResponsiveStyles>>;
};

export type NumberedText_BlockSettings_ResponsiveStyles = {
  __typename?: 'NumberedText_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<NumberedText_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<NumberedText_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<NumberedText_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum NumberedText_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum NumberedText_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum NumberedText_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum NumberedText_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type NumberedText_Items = {
  __typename?: 'NumberedText_Items';
  description?: Maybe<Scalars['JSON']>;
  heading?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
};


export type NumberedText_ItemsDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type NumberedText_ItemsHeadingArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export enum Operator {
  /** Equals */
  Eq = 'eq',
  /** Greater than */
  Gt = 'gt',
  /** Less than */
  Lt = 'lt',
  /** Not equal */
  Not = 'not'
}

export type Option = {
  __typename?: 'Option';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type OrderAuditUser = {
  __typename?: 'OrderAuditUser';
  label?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type OrderBox = {
  __typename?: 'OrderBox';
  bagWeight?: Maybe<Scalars['Float']>;
  itemWeight?: Maybe<Scalars['Float']>;
};

export type OrderDetailProduct = {
  __typename?: 'OrderDetailProduct';
  productType?: Maybe<Scalars['String']>;
};

export enum OrderHumanizedState {
  AmazonAnonymized = 'amazon_anonymized',
  Canceled = 'canceled',
  ChargePending = 'charge_pending',
  Delivered = 'delivered',
  Drafted = 'drafted',
  NotDelivered = 'not_delivered',
  NotShipped = 'not_shipped',
  PaymentFailed = 'payment_failed',
  PaymentPartiallyRefunded = 'payment_partially_refunded',
  PaymentPending = 'payment_pending',
  PaymentRefunded = 'payment_refunded',
  PaymentSucceeded = 'payment_succeeded',
  Preparing = 'preparing',
  Refunded = 'refunded',
  Replaced = 'replaced',
  Scheduled = 'scheduled',
  Shipped = 'shipped',
  Voided = 'voided',
  WaitingAcknowledgement = 'waiting_acknowledgement'
}

export type OrderImportBatch = {
  __typename?: 'OrderImportBatch';
  createdAt: Scalars['ISO8601DateTime'];
  endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  entriesCount: Scalars['Int'];
  failedCount: Scalars['Int'];
  fromDate?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  pendingCount: Scalars['Int'];
  skippedCount: Scalars['Int'];
  startedAt: Scalars['ISO8601DateTime'];
  state: Scalars['String'];
  successCount: Scalars['Int'];
  untilDate?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for OrderImportBatch. */
export type OrderImportBatchConnection = {
  __typename?: 'OrderImportBatchConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderImportBatchEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OrderImportBatch>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of OrderImportBatchCreate */
export type OrderImportBatchCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderImportBatchInput: OrderImportBatchInput;
};

/** Autogenerated return type of OrderImportBatchCreate. */
export type OrderImportBatchCreatePayload = {
  __typename?: 'OrderImportBatchCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderImportBatch: OrderImportBatch;
};

/** Autogenerated input type of OrderImportBatchDelete */
export type OrderImportBatchDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of OrderImportBatchDelete. */
export type OrderImportBatchDeletePayload = {
  __typename?: 'OrderImportBatchDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderImportBatch: OrderImportBatch;
};

/** An edge in a connection. */
export type OrderImportBatchEdge = {
  __typename?: 'OrderImportBatchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<OrderImportBatch>;
};

export type OrderImportBatchEntry = {
  __typename?: 'OrderImportBatchEntry';
  action?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  departedFcAt?: Maybe<Scalars['ISO8601DateTime']>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  index: Scalars['Int'];
  orderImportBatchId?: Maybe<Scalars['Int']>;
  payload?: Maybe<Scalars['JSON']>;
  poNumber?: Maybe<Scalars['String']>;
  processData?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for OrderImportBatchEntry. */
export type OrderImportBatchEntryConnection = {
  __typename?: 'OrderImportBatchEntryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderImportBatchEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OrderImportBatchEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of OrderImportBatchEntryCreate */
export type OrderImportBatchEntryCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderImportBatchEntryInput: OrderImportBatchEntryInput;
};

/** Autogenerated return type of OrderImportBatchEntryCreate. */
export type OrderImportBatchEntryCreatePayload = {
  __typename?: 'OrderImportBatchEntryCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderImportBatchEntry: OrderImportBatchEntry;
};

/** Autogenerated input type of OrderImportBatchEntryDelete */
export type OrderImportBatchEntryDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of OrderImportBatchEntryDelete. */
export type OrderImportBatchEntryDeletePayload = {
  __typename?: 'OrderImportBatchEntryDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderImportBatchEntry: OrderImportBatchEntry;
};

/** An edge in a connection. */
export type OrderImportBatchEntryEdge = {
  __typename?: 'OrderImportBatchEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<OrderImportBatchEntry>;
};

export type OrderImportBatchEntryInput = {
  action?: InputMaybe<Scalars['String']>;
  departedFcAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  endedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  index?: InputMaybe<Scalars['Int']>;
  orderImportBatchId?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<Scalars['JSON']>;
  poNumber?: InputMaybe<Scalars['String']>;
  processData?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  state?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of OrderImportBatchEntryUpdate */
export type OrderImportBatchEntryUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  orderImportBatchEntryInput: OrderImportBatchEntryInput;
};

/** Autogenerated return type of OrderImportBatchEntryUpdate. */
export type OrderImportBatchEntryUpdatePayload = {
  __typename?: 'OrderImportBatchEntryUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderImportBatchEntry: OrderImportBatchEntry;
};

export type OrderImportBatchInput = {
  endedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  startedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  state?: InputMaybe<Scalars['String']>;
  untilDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of OrderImportBatchUpdate */
export type OrderImportBatchUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  orderImportBatchInput: OrderImportBatchInput;
};

/** Autogenerated return type of OrderImportBatchUpdate. */
export type OrderImportBatchUpdatePayload = {
  __typename?: 'OrderImportBatchUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderImportBatch: OrderImportBatch;
};

export type OrderStatamentLine = {
  __typename?: 'OrderStatamentLine';
  amount: Scalars['String'];
  coupon?: Maybe<OrderStatementCoupon>;
  label: Scalars['String'];
};

export enum OrderState {
  Anonymized = 'anonymized',
  Drafted = 'drafted',
  Invalid = 'invalid',
  ProcessingFulfillment = 'processing_fulfillment',
  ProcessingOrigination = 'processing_origination',
  RequiresFulfillers = 'requires_fulfillers',
  RequiresOriginatorDetermination = 'requires_originator_determination',
  RequiresOriginators = 'requires_originators',
  Settled = 'settled',
  Unsettled = 'unsettled',
  WaitingAcknowledge = 'waiting_acknowledge'
}

export type OrderStatement = {
  __typename?: 'OrderStatement';
  addonsLine?: Maybe<OrderStatamentLine>;
  bundleLine?: Maybe<OrderStatamentLine>;
  couponCodes?: Maybe<Array<Scalars['String']>>;
  creditLines: Array<OrderStatamentLine>;
  discountLines: Array<OrderStatamentLine>;
  planLine?: Maybe<OrderStatamentLine>;
  planWithSurchargesLine?: Maybe<OrderStatamentLine>;
  refundsLine?: Maybe<OrderStatamentLine>;
  shippingLine: OrderStatamentLine;
  subtotalLine: OrderStatamentLine;
  surchargesLine?: Maybe<OrderStatamentLine>;
  taxableSubtotal: Scalars['String'];
  taxesLine: OrderStatamentLine;
  totalDueLine: OrderStatamentLine;
  totalPaidLine: OrderStatamentLine;
  totalUnpaidLine: OrderStatamentLine;
  totalValueLine: OrderStatamentLine;
};

export type OrderStatementCoupon = {
  __typename?: 'OrderStatementCoupon';
  code: Scalars['String'];
  discountType: Discount;
  type: Scalars['String'];
  value: Scalars['String'];
};

export enum OrderStatusForCustomer {
  Canceled = 'canceled',
  Delivered = 'delivered',
  PaymentFailed = 'payment_failed',
  Preparing = 'preparing',
  Refunded = 'refunded',
  Scheduled = 'scheduled',
  Shipped = 'shipped'
}

/** Information about pagination in a connection. */
export type PpPageInfo = {
  __typename?: 'PPPageInfo';
  /** The current page */
  currentPage: Scalars['Int'];
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** The number of results requested per page */
  pageSize: Scalars['Int'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
  /** The total number of pages */
  totalPages: Scalars['Int'];
};

export type Packaging = {
  __typename?: 'Packaging';
  active?: Maybe<Scalars['Boolean']>;
  boxes?: Maybe<Array<Box>>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** The connection type for Packaging. */
export type PackagingConnection = {
  __typename?: 'PackagingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PackagingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Packaging>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of PackagingCreate */
export type PackagingCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  packagingInput: PackagingInput;
};

/** Autogenerated return type of PackagingCreate. */
export type PackagingCreatePayload = {
  __typename?: 'PackagingCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  packaging: Packaging;
};

/** Autogenerated input type of PackagingDelete */
export type PackagingDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PackagingDelete. */
export type PackagingDeletePayload = {
  __typename?: 'PackagingDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  packaging: Packaging;
};

/** An edge in a connection. */
export type PackagingEdge = {
  __typename?: 'PackagingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Packaging>;
};

export type PackagingInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of PackagingUpdate */
export type PackagingUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  packagingInput: PackagingInput;
};

/** Autogenerated return type of PackagingUpdate. */
export type PackagingUpdatePayload = {
  __typename?: 'PackagingUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  packaging: Packaging;
};

export type PauseSurvey = {
  __typename?: 'PauseSurvey';
  additionalFeedback?: Maybe<Scalars['String']>;
  breakAdvice?: Maybe<Scalars['String']>;
  breakReasonIds?: Maybe<Array<Scalars['Int']>>;
  breakReasonOther?: Maybe<Scalars['String']>;
  covidReasonId?: Maybe<Scalars['Int']>;
  covidReasonOther?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  evaluationContinue?: Maybe<Scalars['String']>;
  evaluationImportance?: Maybe<Scalars['String']>;
  evaluationReasonId?: Maybe<Scalars['Int']>;
  evaluationReasonOther?: Maybe<Scalars['String']>;
  foodTypeBrandId?: Maybe<Scalars['Int']>;
  foodTypeBrandOther?: Maybe<Scalars['String']>;
  foodTypeId?: Maybe<Scalars['Int']>;
  foodTypeOther?: Maybe<Scalars['String']>;
  healthAdvice?: Maybe<Scalars['String']>;
  healthIssueIds?: Maybe<Array<Scalars['Int']>>;
  healthIssueOther?: Maybe<Scalars['String']>;
  healthPrescriptionDiet?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  movingDestinationChange?: Maybe<Scalars['String']>;
  movingDuration?: Maybe<Scalars['Int']>;
  movingVacationDestinationChange?: Maybe<Scalars['String']>;
  pauseReasonOther?: Maybe<Scalars['String']>;
  pauseReasonTerm?: Maybe<Term>;
  pausedAt?: Maybe<Scalars['ISO8601DateTime']>;
  quantityBestPlan?: Maybe<Scalars['String']>;
  quantityChange?: Maybe<Scalars['String']>;
  quantityIssueId?: Maybe<Scalars['Int']>;
  quantityIssueOther?: Maybe<Scalars['String']>;
  quantityManageEasy?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
  travelingDestinationChange?: Maybe<Scalars['String']>;
  travelingDuration?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for PauseSurvey. */
export type PauseSurveyConnection = {
  __typename?: 'PauseSurveyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PauseSurveyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PauseSurvey>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of PauseSurveyCreate */
export type PauseSurveyCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  pauseSurveyInput: PauseSurveyInput;
};

/** Autogenerated return type of PauseSurveyCreate. */
export type PauseSurveyCreatePayload = {
  __typename?: 'PauseSurveyCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pauseSurvey: PauseSurvey;
};

/** Autogenerated input type of PauseSurveyDelete */
export type PauseSurveyDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PauseSurveyDelete. */
export type PauseSurveyDeletePayload = {
  __typename?: 'PauseSurveyDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pauseSurvey: PauseSurvey;
};

/** An edge in a connection. */
export type PauseSurveyEdge = {
  __typename?: 'PauseSurveyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PauseSurvey>;
};

export type PauseSurveyInput = {
  additionalFeedback?: InputMaybe<Scalars['String']>;
  breakAdvice?: InputMaybe<Scalars['String']>;
  breakReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  breakReasonOther?: InputMaybe<Scalars['String']>;
  covidReasonId?: InputMaybe<Scalars['Int']>;
  covidReasonOther?: InputMaybe<Scalars['String']>;
  evaluationContinue?: InputMaybe<Scalars['String']>;
  evaluationImportance?: InputMaybe<Scalars['String']>;
  evaluationReasonId?: InputMaybe<Scalars['Int']>;
  evaluationReasonOther?: InputMaybe<Scalars['String']>;
  foodTypeBrandId?: InputMaybe<Scalars['Int']>;
  foodTypeBrandOther?: InputMaybe<Scalars['String']>;
  foodTypeId?: InputMaybe<Scalars['Int']>;
  foodTypeOther?: InputMaybe<Scalars['String']>;
  healthAdvice?: InputMaybe<Scalars['String']>;
  healthIssueIds?: InputMaybe<Array<Scalars['Int']>>;
  healthIssueOther?: InputMaybe<Scalars['String']>;
  healthPrescriptionDiet?: InputMaybe<Scalars['String']>;
  movingDestinationChange?: InputMaybe<Scalars['String']>;
  movingDuration?: InputMaybe<Scalars['Int']>;
  movingVacationDestinationChange?: InputMaybe<Scalars['String']>;
  pauseReasonId?: InputMaybe<Scalars['Int']>;
  pauseReasonOther?: InputMaybe<Scalars['String']>;
  pausedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  quantityBestPlan?: InputMaybe<Scalars['String']>;
  quantityChange?: InputMaybe<Scalars['String']>;
  quantityIssueId?: InputMaybe<Scalars['Int']>;
  quantityIssueOther?: InputMaybe<Scalars['String']>;
  quantityManageEasy?: InputMaybe<Scalars['String']>;
  subscriptionId: Scalars['Int'];
  travelingDestinationChange?: InputMaybe<Scalars['String']>;
  travelingDuration?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of PauseSurveyUpdate */
export type PauseSurveyUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  pauseSurveyInput: PauseSurveyInput;
};

/** Autogenerated return type of PauseSurveyUpdate. */
export type PauseSurveyUpdatePayload = {
  __typename?: 'PauseSurveyUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pauseSurvey: PauseSurvey;
};

export type PayloadPreference = {
  __typename?: 'PayloadPreference';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['JSON']>;
};

export type PayloadPreference_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PayloadPreference_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PayloadPreference_Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PayloadPreference_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PayloadPreference_Value_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  intersects?: InputMaybe<Scalars['JSON']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  within?: InputMaybe<Scalars['JSON']>;
};

export type PayloadPreference_Where = {
  AND?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_Or>>>;
  createdAt?: InputMaybe<PayloadPreference_CreatedAt_Operator>;
  id?: InputMaybe<PayloadPreference_Id_Operator>;
  key?: InputMaybe<PayloadPreference_Key_Operator>;
  updatedAt?: InputMaybe<PayloadPreference_UpdatedAt_Operator>;
  value?: InputMaybe<PayloadPreference_Value_Operator>;
};

export type PayloadPreference_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_Or>>>;
  createdAt?: InputMaybe<PayloadPreference_CreatedAt_Operator>;
  id?: InputMaybe<PayloadPreference_Id_Operator>;
  key?: InputMaybe<PayloadPreference_Key_Operator>;
  updatedAt?: InputMaybe<PayloadPreference_UpdatedAt_Operator>;
  value?: InputMaybe<PayloadPreference_Value_Operator>;
};

export type PayloadPreference_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_Or>>>;
  createdAt?: InputMaybe<PayloadPreference_CreatedAt_Operator>;
  id?: InputMaybe<PayloadPreference_Id_Operator>;
  key?: InputMaybe<PayloadPreference_Key_Operator>;
  updatedAt?: InputMaybe<PayloadPreference_UpdatedAt_Operator>;
  value?: InputMaybe<PayloadPreference_Value_Operator>;
};

export type PayloadPreferences = {
  __typename?: 'PayloadPreferences';
  docs?: Maybe<Array<Maybe<PayloadPreference>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PayloadPreferencesCreateAccess = {
  __typename?: 'PayloadPreferencesCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesCreateDocAccess = {
  __typename?: 'PayloadPreferencesCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesDeleteAccess = {
  __typename?: 'PayloadPreferencesDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesDeleteDocAccess = {
  __typename?: 'PayloadPreferencesDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesDocAccessFields = {
  __typename?: 'PayloadPreferencesDocAccessFields';
  createdAt?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt>;
  key?: Maybe<PayloadPreferencesDocAccessFields_Key>;
  updatedAt?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt>;
  value?: Maybe<PayloadPreferencesDocAccessFields_Value>;
};

export type PayloadPreferencesDocAccessFields_CreatedAt = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt';
  create?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Read>;
  update?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Update>;
};

export type PayloadPreferencesDocAccessFields_CreatedAt_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_CreatedAt_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_CreatedAt_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_CreatedAt_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Key = {
  __typename?: 'PayloadPreferencesDocAccessFields_key';
  create?: Maybe<PayloadPreferencesDocAccessFields_Key_Create>;
  delete?: Maybe<PayloadPreferencesDocAccessFields_Key_Delete>;
  read?: Maybe<PayloadPreferencesDocAccessFields_Key_Read>;
  update?: Maybe<PayloadPreferencesDocAccessFields_Key_Update>;
};

export type PayloadPreferencesDocAccessFields_Key_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_key_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Key_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_key_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Key_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_key_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Key_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_key_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_UpdatedAt = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt';
  create?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Update>;
};

export type PayloadPreferencesDocAccessFields_UpdatedAt_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_UpdatedAt_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_UpdatedAt_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Value = {
  __typename?: 'PayloadPreferencesDocAccessFields_value';
  create?: Maybe<PayloadPreferencesDocAccessFields_Value_Create>;
  delete?: Maybe<PayloadPreferencesDocAccessFields_Value_Delete>;
  read?: Maybe<PayloadPreferencesDocAccessFields_Value_Read>;
  update?: Maybe<PayloadPreferencesDocAccessFields_Value_Update>;
};

export type PayloadPreferencesDocAccessFields_Value_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_value_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Value_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_value_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Value_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_value_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Value_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_value_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields = {
  __typename?: 'PayloadPreferencesFields';
  createdAt?: Maybe<PayloadPreferencesFields_CreatedAt>;
  key?: Maybe<PayloadPreferencesFields_Key>;
  updatedAt?: Maybe<PayloadPreferencesFields_UpdatedAt>;
  value?: Maybe<PayloadPreferencesFields_Value>;
};

export type PayloadPreferencesFields_CreatedAt = {
  __typename?: 'PayloadPreferencesFields_createdAt';
  create?: Maybe<PayloadPreferencesFields_CreatedAt_Create>;
  delete?: Maybe<PayloadPreferencesFields_CreatedAt_Delete>;
  read?: Maybe<PayloadPreferencesFields_CreatedAt_Read>;
  update?: Maybe<PayloadPreferencesFields_CreatedAt_Update>;
};

export type PayloadPreferencesFields_CreatedAt_Create = {
  __typename?: 'PayloadPreferencesFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_CreatedAt_Delete = {
  __typename?: 'PayloadPreferencesFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_CreatedAt_Read = {
  __typename?: 'PayloadPreferencesFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_CreatedAt_Update = {
  __typename?: 'PayloadPreferencesFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Key = {
  __typename?: 'PayloadPreferencesFields_key';
  create?: Maybe<PayloadPreferencesFields_Key_Create>;
  delete?: Maybe<PayloadPreferencesFields_Key_Delete>;
  read?: Maybe<PayloadPreferencesFields_Key_Read>;
  update?: Maybe<PayloadPreferencesFields_Key_Update>;
};

export type PayloadPreferencesFields_Key_Create = {
  __typename?: 'PayloadPreferencesFields_key_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Key_Delete = {
  __typename?: 'PayloadPreferencesFields_key_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Key_Read = {
  __typename?: 'PayloadPreferencesFields_key_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Key_Update = {
  __typename?: 'PayloadPreferencesFields_key_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_UpdatedAt = {
  __typename?: 'PayloadPreferencesFields_updatedAt';
  create?: Maybe<PayloadPreferencesFields_UpdatedAt_Create>;
  delete?: Maybe<PayloadPreferencesFields_UpdatedAt_Delete>;
  read?: Maybe<PayloadPreferencesFields_UpdatedAt_Read>;
  update?: Maybe<PayloadPreferencesFields_UpdatedAt_Update>;
};

export type PayloadPreferencesFields_UpdatedAt_Create = {
  __typename?: 'PayloadPreferencesFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_UpdatedAt_Delete = {
  __typename?: 'PayloadPreferencesFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_UpdatedAt_Read = {
  __typename?: 'PayloadPreferencesFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_UpdatedAt_Update = {
  __typename?: 'PayloadPreferencesFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Value = {
  __typename?: 'PayloadPreferencesFields_value';
  create?: Maybe<PayloadPreferencesFields_Value_Create>;
  delete?: Maybe<PayloadPreferencesFields_Value_Delete>;
  read?: Maybe<PayloadPreferencesFields_Value_Read>;
  update?: Maybe<PayloadPreferencesFields_Value_Update>;
};

export type PayloadPreferencesFields_Value_Create = {
  __typename?: 'PayloadPreferencesFields_value_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Value_Delete = {
  __typename?: 'PayloadPreferencesFields_value_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Value_Read = {
  __typename?: 'PayloadPreferencesFields_value_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Value_Update = {
  __typename?: 'PayloadPreferencesFields_value_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesReadAccess = {
  __typename?: 'PayloadPreferencesReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesReadDocAccess = {
  __typename?: 'PayloadPreferencesReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesUpdateAccess = {
  __typename?: 'PayloadPreferencesUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesUpdateDocAccess = {
  __typename?: 'PayloadPreferencesUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PaymentAdjustment = {
  __typename?: 'PaymentAdjustment';
  amount: Scalars['Float'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  payment?: Maybe<PpPayment>;
  sourceId?: Maybe<Scalars['Int']>;
  sourceType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for PaymentAdjustment. */
export type PaymentAdjustmentConnection = {
  __typename?: 'PaymentAdjustmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentAdjustmentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PaymentAdjustment>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of PaymentAdjustmentCreate */
export type PaymentAdjustmentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentAdjustmentInput: PaymentAdjustmentInput;
};

/** Autogenerated return type of PaymentAdjustmentCreate. */
export type PaymentAdjustmentCreatePayload = {
  __typename?: 'PaymentAdjustmentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentAdjustment: PaymentAdjustment;
};

/** Autogenerated input type of PaymentAdjustmentDelete */
export type PaymentAdjustmentDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PaymentAdjustmentDelete. */
export type PaymentAdjustmentDeletePayload = {
  __typename?: 'PaymentAdjustmentDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentAdjustment: PaymentAdjustment;
};

/** An edge in a connection. */
export type PaymentAdjustmentEdge = {
  __typename?: 'PaymentAdjustmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PaymentAdjustment>;
};

export type PaymentAdjustmentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  paymentId?: InputMaybe<Scalars['Int']>;
  sourceId?: InputMaybe<Scalars['Int']>;
  sourceType?: InputMaybe<Scalars['String']>;
};

export enum PaymentAdjustmentOrder {
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyModified = 'RECENTLY_MODIFIED'
}

/** Autogenerated input type of PaymentAdjustmentUpdate */
export type PaymentAdjustmentUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  paymentAdjustmentInput: PaymentAdjustmentInput;
};

/** Autogenerated return type of PaymentAdjustmentUpdate. */
export type PaymentAdjustmentUpdatePayload = {
  __typename?: 'PaymentAdjustmentUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentAdjustment: PaymentAdjustment;
};

export type PaymentBatch = {
  __typename?: 'PaymentBatch';
  chargedCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  dueAt?: Maybe<Scalars['ISO8601Date']>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  failedCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  overdueCount?: Maybe<Scalars['Int']>;
  paymentBatchEntries?: Maybe<Array<PaymentBatchEntry>>;
  pendingCount?: Maybe<Scalars['Int']>;
  shippingDates?: Maybe<Array<Scalars['ISO8601Date']>>;
  skippedCount?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  state: Scalars['String'];
  summaries?: Maybe<Array<PlanSummary>>;
  totalCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for PaymentBatch. */
export type PaymentBatchConnection = {
  __typename?: 'PaymentBatchConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentBatchEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PaymentBatch>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of PaymentBatchCreate */
export type PaymentBatchCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentBatchInput: PaymentBatchInput;
};

/** Autogenerated return type of PaymentBatchCreate. */
export type PaymentBatchCreatePayload = {
  __typename?: 'PaymentBatchCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentBatch: PaymentBatch;
};

/** Autogenerated input type of PaymentBatchDelete */
export type PaymentBatchDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PaymentBatchDelete. */
export type PaymentBatchDeletePayload = {
  __typename?: 'PaymentBatchDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentBatch: PaymentBatch;
};

/** An edge in a connection. */
export type PaymentBatchEdge = {
  __typename?: 'PaymentBatchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PaymentBatch>;
};

export type PaymentBatchEntry = {
  __typename?: 'PaymentBatchEntry';
  action?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  index: Scalars['Int'];
  order?: Maybe<DbOrder>;
  payment?: Maybe<PpPayment>;
  paymentBatch?: Maybe<PaymentBatch>;
  processData?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  state?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for PaymentBatchEntry. */
export type PaymentBatchEntryConnection = {
  __typename?: 'PaymentBatchEntryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentBatchEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PaymentBatchEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of PaymentBatchEntryCreate */
export type PaymentBatchEntryCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentBatchEntryInput: PaymentBatchEntryInput;
};

/** Autogenerated return type of PaymentBatchEntryCreate. */
export type PaymentBatchEntryCreatePayload = {
  __typename?: 'PaymentBatchEntryCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentBatchEntry: PaymentBatchEntry;
};

/** Autogenerated input type of PaymentBatchEntryDelete */
export type PaymentBatchEntryDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PaymentBatchEntryDelete. */
export type PaymentBatchEntryDeletePayload = {
  __typename?: 'PaymentBatchEntryDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentBatchEntry: PaymentBatchEntry;
};

/** An edge in a connection. */
export type PaymentBatchEntryEdge = {
  __typename?: 'PaymentBatchEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PaymentBatchEntry>;
};

export type PaymentBatchEntryInput = {
  action?: InputMaybe<Scalars['String']>;
  endedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  index?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['Int']>;
  paymentBatchId?: InputMaybe<Scalars['Int']>;
  paymentId?: InputMaybe<Scalars['Int']>;
  processData?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  state?: InputMaybe<TypesPaymentBatchEntryInputTypeState>;
  subscriptionId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of PaymentBatchEntryUpdate */
export type PaymentBatchEntryUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  paymentBatchEntryInput: PaymentBatchEntryInput;
};

/** Autogenerated return type of PaymentBatchEntryUpdate. */
export type PaymentBatchEntryUpdatePayload = {
  __typename?: 'PaymentBatchEntryUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentBatchEntry: PaymentBatchEntry;
};

export type PaymentBatchInput = {
  dueAt?: InputMaybe<Scalars['ISO8601Date']>;
  endedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  processData?: InputMaybe<Scalars['String']>;
  shippingDates?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  startedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  state?: InputMaybe<TypesPaymentBatchInputTypeState>;
};

/** Autogenerated input type of PaymentBatchUpdate */
export type PaymentBatchUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  paymentBatchInput: PaymentBatchInput;
};

/** Autogenerated return type of PaymentBatchUpdate. */
export type PaymentBatchUpdatePayload = {
  __typename?: 'PaymentBatchUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentBatch: PaymentBatch;
};

export type PaymentMetadata = {
  __typename?: 'PaymentMetadata';
  ccvResultCode?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  paypalEmail?: Maybe<Scalars['String']>;
  wallet?: Maybe<PaymentWallet>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  apiCardId?: Maybe<Scalars['String']>;
  apiCustomerId?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  cardFingerprint?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardMonth?: Maybe<Scalars['Int']>;
  cardYear?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  fraudScore?: Maybe<Scalars['String']>;
  funding?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lowercaseMetadata?: Maybe<PaymentMetadata>;
  migratedFromId?: Maybe<Scalars['Int']>;
  owner?: Maybe<User>;
  paymentGatewayProvider?: Maybe<Scalars['String']>;
  recommendation?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subscriptions: Array<Subscription>;
  tokenizationMethod?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  verified?: Maybe<Scalars['Boolean']>;
};

/** The connection type for PaymentMethod. */
export type PaymentMethodConnection = {
  __typename?: 'PaymentMethodConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentMethodEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PaymentMethod>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of PaymentMethodCreate */
export type PaymentMethodCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentMethodInput: PaymentMethodInput;
};

/** Autogenerated return type of PaymentMethodCreate. */
export type PaymentMethodCreatePayload = {
  __typename?: 'PaymentMethodCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentMethod: PaymentMethod;
};

/** Autogenerated input type of PaymentMethodDelete */
export type PaymentMethodDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PaymentMethodDelete. */
export type PaymentMethodDeletePayload = {
  __typename?: 'PaymentMethodDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentMethod: PaymentMethod;
};

/** An edge in a connection. */
export type PaymentMethodEdge = {
  __typename?: 'PaymentMethodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PaymentMethod>;
};

export type PaymentMethodInput = {
  apiCardId?: InputMaybe<Scalars['String']>;
  apiCustomerId?: InputMaybe<Scalars['String']>;
  cardFingerprint?: InputMaybe<Scalars['String']>;
  cardLast4?: InputMaybe<Scalars['String']>;
  cardMonth?: InputMaybe<Scalars['Int']>;
  cardYear?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  migratedFromId?: InputMaybe<Scalars['Int']>;
  ownerId: Scalars['ID'];
  paymentGatewayProvider?: InputMaybe<Scalars['String']>;
  shopifyCustomerId?: InputMaybe<Scalars['ID']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<TypesPaymentMethodInputTypeState>;
  token?: InputMaybe<PaymentMethodStripeToken>;
};

export type PaymentMethodStripeCard = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine1Check?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  addressZipCheck?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Scalars['String']>;
  cvcCheck?: InputMaybe<Scalars['String']>;
  dynamicLast4?: InputMaybe<Scalars['String']>;
  expMonth?: InputMaybe<Scalars['Int']>;
  expYear?: InputMaybe<Scalars['Int']>;
  fingerprint?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  last4?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  object?: InputMaybe<Scalars['String']>;
  tokenizationMethod?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  wallet?: InputMaybe<Scalars['String']>;
};

export type PaymentMethodStripeToken = {
  card?: InputMaybe<PaymentMethodStripeCard>;
  clientIp?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  livemode?: InputMaybe<Scalars['Boolean']>;
  object?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  used?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of PaymentMethodUpdate */
export type PaymentMethodUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  paymentMethodInput: PaymentMethodInput;
};

/** Autogenerated return type of PaymentMethodUpdate. */
export type PaymentMethodUpdatePayload = {
  __typename?: 'PaymentMethodUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentMethod: PaymentMethod;
};

export enum PaymentState {
  Completed = 'completed',
  Created = 'created',
  Failed = 'failed',
  PartiallyRefunded = 'partially_refunded',
  Processing = 'processing',
  Refunded = 'refunded'
}

export enum PaymentWallet {
  ApplePay = 'apple_pay',
  GooglePay = 'google_pay',
  Paypal = 'paypal',
  ShopifyPay = 'shopify_pay'
}

export type PdpHero = {
  __typename?: 'PdpHero';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<PdpHero_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<PdpHero_Buttons>>;
  description?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  images?: Maybe<Array<PdpHero_Images>>;
  linkBelowDivider?: Maybe<Array<PdpHero_LinkBelowDivider>>;
  price?: Maybe<PdpHero_Price>;
  sku?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['JSON']>;
  textBelowDivider?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['JSON']>;
};


export type PdpHeroDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type PdpHeroSubtitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type PdpHeroTextBelowDividerArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type PdpHeroTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type PdpHero_BlockSettings = {
  __typename?: 'PdpHero_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<PdpHero_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<PdpHero_BlockSettings_ResponsiveStyles>>;
};

export type PdpHero_BlockSettings_ResponsiveStyles = {
  __typename?: 'PdpHero_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<PdpHero_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<PdpHero_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<PdpHero_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum PdpHero_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum PdpHero_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum PdpHero_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum PdpHero_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type PdpHero_Buttons = {
  __typename?: 'PdpHero_Buttons';
  button?: Maybe<PdpHero_Buttons_Button>;
  id?: Maybe<Scalars['String']>;
};

export type PdpHero_Buttons_Button = {
  __typename?: 'PdpHero_Buttons_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<PdpHero_Buttons_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<PdpHero_Buttons_Button_Variant>;
};

export type PdpHero_Buttons_Button_Link = {
  __typename?: 'PdpHero_Buttons_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<PdpHero_Buttons_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum PdpHero_Buttons_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum PdpHero_Buttons_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Text = 'text'
}

export type PdpHero_Images = {
  __typename?: 'PdpHero_Images';
  id?: Maybe<Scalars['String']>;
  image?: Maybe<PdpHero_Images_Image>;
};

export type PdpHero_Images_Image = {
  __typename?: 'PdpHero_Images_Image';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type PdpHero_Images_ImageLgArgs = {
  where?: InputMaybe<PdpHero_Images_Image_Lg_Where>;
};


export type PdpHero_Images_ImageMdArgs = {
  where?: InputMaybe<PdpHero_Images_Image_Md_Where>;
};


export type PdpHero_Images_ImageSmArgs = {
  where?: InputMaybe<PdpHero_Images_Image_Sm_Where>;
};


export type PdpHero_Images_ImageXlArgs = {
  where?: InputMaybe<PdpHero_Images_Image_Xl_Where>;
};


export type PdpHero_Images_ImageXsArgs = {
  where?: InputMaybe<PdpHero_Images_Image_Xs_Where>;
};


export type PdpHero_Images_ImageXxlArgs = {
  where?: InputMaybe<PdpHero_Images_Image_Xxl_Where>;
};


export type PdpHero_Images_ImageXxsArgs = {
  where?: InputMaybe<PdpHero_Images_Image_Xxs_Where>;
};

export type PdpHero_Images_Image_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Lg_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Lg_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Lg_Width_Operator>;
};

export type PdpHero_Images_Image_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Lg_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Lg_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Lg_Width_Operator>;
};

export type PdpHero_Images_Image_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Lg_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Lg_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Lg_Width_Operator>;
};

export type PdpHero_Images_Image_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Md_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Md_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Md_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Md_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Md_Width_Operator>;
};

export type PdpHero_Images_Image_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Md_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Md_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Md_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Md_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Md_Width_Operator>;
};

export type PdpHero_Images_Image_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Md_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Md_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Md_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Md_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Md_Width_Operator>;
};

export type PdpHero_Images_Image_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Sm_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Sm_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Sm_Width_Operator>;
};

export type PdpHero_Images_Image_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Sm_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Sm_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Sm_Width_Operator>;
};

export type PdpHero_Images_Image_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Sm_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Sm_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Sm_Width_Operator>;
};

export type PdpHero_Images_Image_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Xl_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Xl_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Xl_Width_Operator>;
};

export type PdpHero_Images_Image_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Xl_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Xl_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Xl_Width_Operator>;
};

export type PdpHero_Images_Image_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Xl_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Xl_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Xl_Width_Operator>;
};

export type PdpHero_Images_Image_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Xs_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Xs_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Xs_Width_Operator>;
};

export type PdpHero_Images_Image_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Xs_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Xs_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Xs_Width_Operator>;
};

export type PdpHero_Images_Image_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Xs_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Xs_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Xs_Width_Operator>;
};

export type PdpHero_Images_Image_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Xxl_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Xxl_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Xxl_Width_Operator>;
};

export type PdpHero_Images_Image_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Xxl_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Xxl_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Xxl_Width_Operator>;
};

export type PdpHero_Images_Image_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Xxl_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Xxl_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Xxl_Width_Operator>;
};

export type PdpHero_Images_Image_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_Images_Image_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PdpHero_Images_Image_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PdpHero_Images_Image_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Xxs_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Xxs_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Xxs_Width_Operator>;
};

export type PdpHero_Images_Image_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Xxs_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Xxs_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Xxs_Width_Operator>;
};

export type PdpHero_Images_Image_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PdpHero_Images_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<PdpHero_Images_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<PdpHero_Images_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<PdpHero_Images_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<PdpHero_Images_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<PdpHero_Images_Image_Xxs_Height_Operator>;
  id?: InputMaybe<PdpHero_Images_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<PdpHero_Images_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PdpHero_Images_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PdpHero_Images_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<PdpHero_Images_Image_Xxs_Url_Operator>;
  width?: InputMaybe<PdpHero_Images_Image_Xxs_Width_Operator>;
};

export type PdpHero_Images_Image_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PdpHero_LinkBelowDivider = {
  __typename?: 'PdpHero_LinkBelowDivider';
  id?: Maybe<Scalars['String']>;
  link?: Maybe<PdpHero_LinkBelowDivider_Link>;
};

export type PdpHero_LinkBelowDivider_Link = {
  __typename?: 'PdpHero_LinkBelowDivider_Link';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<PdpHero_LinkBelowDivider_Link_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<PdpHero_LinkBelowDivider_Link_Variant>;
};

export type PdpHero_LinkBelowDivider_Link_Link = {
  __typename?: 'PdpHero_LinkBelowDivider_Link_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<PdpHero_LinkBelowDivider_Link_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum PdpHero_LinkBelowDivider_Link_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum PdpHero_LinkBelowDivider_Link_Variant {
  Text = 'text'
}

export type PdpHero_Price = {
  __typename?: 'PdpHero_Price';
  sideText?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Pet = {
  __typename?: 'Pet';
  activityLevel?: Maybe<PetActivityLevels>;
  ageGroup?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['ISO8601Date']>;
  breedType: Scalars['String'];
  calculatedCaloriesPerDay?: Maybe<Scalars['Int']>;
  completedBirthDate?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  gender?: Maybe<Scalars['String']>;
  hasFoodSensitivities?: Maybe<Scalars['Boolean']>;
  hasWellnessGoals?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  ingredientIds?: Maybe<Array<Scalars['ID']>>;
  ingredients?: Maybe<Array<Ingredient>>;
  mealLineItems?: Maybe<Array<MealLineItem>>;
  petName?: Maybe<Scalars['String']>;
  primaryBreed?: Maybe<Breed>;
  primaryBreedId?: Maybe<Scalars['Int']>;
  recommendationWizard?: Maybe<RecommendationWizard>;
  restingEnergyRate?: Maybe<Scalars['Float']>;
  secondaryBreed?: Maybe<Breed>;
  secondaryBreedId?: Maybe<Scalars['Int']>;
  servingSizeInOunces?: Maybe<Scalars['Int']>;
  spayedNeutered?: Maybe<Scalars['Boolean']>;
  subscription?: Maybe<Subscription>;
  updatedAt: Scalars['ISO8601DateTime'];
  user?: Maybe<User>;
  waistline?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
  wellnessGoalIds?: Maybe<Array<Scalars['ID']>>;
  wellnessGoals?: Maybe<Array<WellnessGoal>>;
};

export enum PetActivityLevels {
  High = 'high',
  Low = 'low',
  Moderate = 'moderate'
}

export type PetBox = {
  __typename?: 'PetBox';
  addons: PetPlateProductConnection;
  /** Find a BoxVariant its id value */
  boxVariant: BoxVariant;
  containers?: Maybe<Scalars['Int']>;
  customizableWeeks?: Maybe<Scalars['Boolean']>;
  /** Find an associated Meal Plan */
  mealPlan?: Maybe<MealPlan>;
  ouncesPerContainer?: Maybe<Scalars['Int']>;
  recipes?: Maybe<MealConnection>;
  recommendationScore?: Maybe<Scalars['Float']>;
  recommendedAddons?: Maybe<Array<RecommendedAddon>>;
  recommendedRecipes?: Maybe<Array<RecommendedRecipe>>;
  servingSize?: Maybe<Scalars['Float']>;
  shopifyLineItems?: Maybe<Array<ShopifyLineItems>>;
  weeks?: Maybe<Scalars['Int']>;
};


export type PetBoxAddonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPetPlateProductsResolverOrder>;
  sku?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type PetBoxBoxVariantArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type PetBoxRecipesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversMealsResolverOrder>;
  sku?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** The connection type for Pet. */
export type PetConnection = {
  __typename?: 'PetConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PetEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Pet>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of PetCreate */
export type PetCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  petInput: PetInput;
};

/** Autogenerated return type of PetCreate. */
export type PetCreatePayload = {
  __typename?: 'PetCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pet: Pet;
};

/** Autogenerated input type of PetDelete */
export type PetDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PetDelete. */
export type PetDeletePayload = {
  __typename?: 'PetDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pet: Pet;
};

/** An edge in a connection. */
export type PetEdge = {
  __typename?: 'PetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Pet>;
};

export type PetInput = {
  activityLevel?: InputMaybe<PetActivityLevels>;
  birthDate?: InputMaybe<Scalars['ISO8601Date']>;
  breedType?: InputMaybe<Scalars['String']>;
  completedBirthDate?: InputMaybe<Scalars['Boolean']>;
  gender?: InputMaybe<Gender>;
  hasFoodSensitivities?: InputMaybe<Scalars['Boolean']>;
  hasWellnessGoals?: InputMaybe<Scalars['Boolean']>;
  ingredientIds?: InputMaybe<Array<Scalars['Int']>>;
  petName?: InputMaybe<Scalars['String']>;
  photoData?: InputMaybe<Scalars['JSON']>;
  primaryBreedId?: InputMaybe<Scalars['Int']>;
  secondaryBreedId?: InputMaybe<Scalars['Int']>;
  servingSizeInOunces?: InputMaybe<Scalars['Int']>;
  spayedNeutered?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['Int']>;
  waistline?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
  wellnessGoalIds?: InputMaybe<Array<Scalars['Int']>>;
};

export enum PetPlateMealVariantState {
  Active = 'active',
  Discontinued = 'discontinued'
}

export type PetPlateMealVariantType = {
  __typename?: 'PetPlateMealVariantType';
  boxVariant?: Maybe<BoxVariant>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  meal?: Maybe<PetPlateProduct>;
  metadata?: Maybe<Scalars['JSON']>;
  migrationPriceRollback?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  outOfStock?: Maybe<Scalars['Boolean']>;
  preferred?: Maybe<Scalars['Boolean']>;
  sku?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for PetPlateMealVariantType. */
export type PetPlateMealVariantTypeConnection = {
  __typename?: 'PetPlateMealVariantTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PetPlateMealVariantTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PetPlateMealVariantType>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** An edge in a connection. */
export type PetPlateMealVariantTypeEdge = {
  __typename?: 'PetPlateMealVariantTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PetPlateMealVariantType>;
};

export type PetPlateProduct = {
  __typename?: 'PetPlateProduct';
  active?: Maybe<Scalars['Boolean']>;
  analysis?: Maybe<Scalars['JSON']>;
  category?: Maybe<PlanLineItemCategoryEnum>;
  clusterAvailable?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  emergencyOutOfStock?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  ingredients?: Maybe<Scalars['String']>;
  lineItemName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  outOfStock?: Maybe<Scalars['Boolean']>;
  outOfStockMessage?: Maybe<Scalars['String']>;
  pageUrl?: Maybe<Scalars['String']>;
  parentShopifyId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  priceCategory?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productPlanVariants?: Maybe<Array<MealPlanVariant>>;
  productType?: Maybe<Scalars['String']>;
  recipe?: Maybe<Recipe>;
  recommendableProducts?: Maybe<Array<RecommendableProduct>>;
  shopifyId?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  surchargeAmount: Scalars['Float'];
  updatedAt: Scalars['ISO8601DateTime'];
  weightInOunces?: Maybe<Scalars['Float']>;
};

/** The connection type for PetPlateProduct. */
export type PetPlateProductConnection = {
  __typename?: 'PetPlateProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PetPlateProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PetPlateProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of PetPlateProductCreate */
export type PetPlateProductCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  petPlateProductInput: PetPlateProductInput;
};

/** Autogenerated return type of PetPlateProductCreate. */
export type PetPlateProductCreatePayload = {
  __typename?: 'PetPlateProductCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  petPlateProduct: PetPlateProduct;
};

/** Autogenerated input type of PetPlateProductDelete */
export type PetPlateProductDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PetPlateProductDelete. */
export type PetPlateProductDeletePayload = {
  __typename?: 'PetPlateProductDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  petPlateProduct: PetPlateProduct;
};

/** An edge in a connection. */
export type PetPlateProductEdge = {
  __typename?: 'PetPlateProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PetPlateProduct>;
};

export type PetPlateProductInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  analysis?: InputMaybe<Scalars['JSON']>;
  category?: InputMaybe<PlanLineItemCategoryEnum>;
  clusterAvailable?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  emergencyOutOfStock?: InputMaybe<Scalars['Boolean']>;
  ingredients?: InputMaybe<Scalars['String']>;
  lineItemName?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  outOfStock?: InputMaybe<Scalars['Boolean']>;
  outOfStockMessage?: InputMaybe<Scalars['String']>;
  pageUrl?: InputMaybe<Scalars['String']>;
  parentShopifyId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  priceCategory?: InputMaybe<Scalars['String']>;
  productCategory?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  recipeId?: InputMaybe<Scalars['Int']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  surchargeAmount?: InputMaybe<Scalars['Float']>;
  weightInOunces?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated input type of PetPlateProductUpdate */
export type PetPlateProductUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  petPlateProductInput: PetPlateProductInput;
};

/** Autogenerated return type of PetPlateProductUpdate. */
export type PetPlateProductUpdatePayload = {
  __typename?: 'PetPlateProductUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  petPlateProduct: PetPlateProduct;
};

export type PetPlateProductVariantType = {
  __typename?: 'PetPlateProductVariantType';
  boxVariant?: Maybe<BoxVariant>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSON']>;
  migrationPriceRollback?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  outOfStock?: Maybe<Scalars['Boolean']>;
  preferred?: Maybe<Scalars['Boolean']>;
  product?: Maybe<PetPlateProduct>;
  sku?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  suggestedPiecesPerDay?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for PetPlateProductVariantType. */
export type PetPlateProductVariantTypeConnection = {
  __typename?: 'PetPlateProductVariantTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PetPlateProductVariantTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PetPlateProductVariantType>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** An edge in a connection. */
export type PetPlateProductVariantTypeEdge = {
  __typename?: 'PetPlateProductVariantTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PetPlateProductVariantType>;
};

export type PetPlateSubscription = {
  __typename?: 'PetPlateSubscription';
  id: Scalars['ID'];
  planId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** Autogenerated input type of PetPlateSubscriptionCreate */
export type PetPlateSubscriptionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  petPlateSubscriptionInput: PetPlateSubscriptionInput;
};

/** Autogenerated input type of PetPlateSubscriptionCreateOrder */
export type PetPlateSubscriptionCreateOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PetPlateSubscriptionCreateOrder. */
export type PetPlateSubscriptionCreateOrderPayload = {
  __typename?: 'PetPlateSubscriptionCreateOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dbOrder: DbOrder;
};

/** Autogenerated return type of PetPlateSubscriptionCreate. */
export type PetPlateSubscriptionCreatePayload = {
  __typename?: 'PetPlateSubscriptionCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  petPlateSubscription: PetPlateSubscription;
};

export type PetPlateSubscriptionInput = {
  userId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of PetUpdate */
export type PetUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  petInput: PetInput;
};

/** Autogenerated return type of PetUpdate. */
export type PetUpdatePayload = {
  __typename?: 'PetUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pet: Pet;
};

export type PetsServed = {
  __typename?: 'PetsServed';
  countPerAgeGroup: Array<TypesPetsServedTypePetCountPerAgeGroup>;
  countPerBreed: Array<TypesPetsServedTypePetCountPerBreed>;
};

export type PlanCalculator = {
  __typename?: 'PlanCalculator';
  asset?: Maybe<PlanCalculator_Asset>;
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<PlanCalculator_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  buttonDescription?: Maybe<Scalars['JSON']>;
  buttons?: Maybe<Array<PlanCalculator_Buttons>>;
  description?: Maybe<Scalars['JSON']>;
  disclaimer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  plansTitle?: Maybe<PlanCalculator_PlansTitle>;
  title?: Maybe<Scalars['JSON']>;
};


export type PlanCalculatorButtonDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type PlanCalculatorDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type PlanCalculatorTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type PlanCalculator_Asset = {
  __typename?: 'PlanCalculator_Asset';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type PlanCalculator_AssetLgArgs = {
  where?: InputMaybe<PlanCalculator_Asset_Lg_Where>;
};


export type PlanCalculator_AssetMdArgs = {
  where?: InputMaybe<PlanCalculator_Asset_Md_Where>;
};


export type PlanCalculator_AssetSmArgs = {
  where?: InputMaybe<PlanCalculator_Asset_Sm_Where>;
};


export type PlanCalculator_AssetXlArgs = {
  where?: InputMaybe<PlanCalculator_Asset_Xl_Where>;
};


export type PlanCalculator_AssetXsArgs = {
  where?: InputMaybe<PlanCalculator_Asset_Xs_Where>;
};


export type PlanCalculator_AssetXxlArgs = {
  where?: InputMaybe<PlanCalculator_Asset_Xxl_Where>;
};


export type PlanCalculator_AssetXxsArgs = {
  where?: InputMaybe<PlanCalculator_Asset_Xxs_Where>;
};

export type PlanCalculator_Asset_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Lg_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Lg_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Lg_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Lg_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Lg_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Lg_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Lg_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Lg_Width_Operator>;
};

export type PlanCalculator_Asset_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Lg_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Lg_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Lg_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Lg_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Lg_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Lg_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Lg_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Lg_Width_Operator>;
};

export type PlanCalculator_Asset_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Lg_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Lg_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Lg_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Lg_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Lg_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Lg_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Lg_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Lg_Width_Operator>;
};

export type PlanCalculator_Asset_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Md_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Md_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Md_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Md_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Md_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Md_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Md_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Md_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Md_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Md_Width_Operator>;
};

export type PlanCalculator_Asset_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Md_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Md_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Md_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Md_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Md_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Md_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Md_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Md_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Md_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Md_Width_Operator>;
};

export type PlanCalculator_Asset_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Md_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Md_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Md_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Md_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Md_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Md_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Md_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Md_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Md_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Md_Width_Operator>;
};

export type PlanCalculator_Asset_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Sm_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Sm_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Sm_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Sm_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Sm_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Sm_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Sm_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Sm_Width_Operator>;
};

export type PlanCalculator_Asset_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Sm_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Sm_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Sm_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Sm_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Sm_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Sm_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Sm_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Sm_Width_Operator>;
};

export type PlanCalculator_Asset_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Sm_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Sm_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Sm_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Sm_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Sm_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Sm_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Sm_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Sm_Width_Operator>;
};

export type PlanCalculator_Asset_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xl_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Xl_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Xl_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Xl_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Xl_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Xl_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Xl_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Xl_Width_Operator>;
};

export type PlanCalculator_Asset_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xl_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Xl_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Xl_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Xl_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Xl_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Xl_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Xl_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Xl_Width_Operator>;
};

export type PlanCalculator_Asset_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xl_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Xl_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Xl_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Xl_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Xl_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Xl_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Xl_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Xl_Width_Operator>;
};

export type PlanCalculator_Asset_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xs_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Xs_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Xs_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Xs_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Xs_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Xs_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Xs_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Xs_Width_Operator>;
};

export type PlanCalculator_Asset_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xs_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Xs_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Xs_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Xs_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Xs_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Xs_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Xs_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Xs_Width_Operator>;
};

export type PlanCalculator_Asset_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xs_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Xs_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Xs_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Xs_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Xs_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Xs_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Xs_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Xs_Width_Operator>;
};

export type PlanCalculator_Asset_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xxl_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Xxl_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Xxl_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Xxl_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Xxl_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Xxl_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Xxl_Width_Operator>;
};

export type PlanCalculator_Asset_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xxl_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Xxl_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Xxl_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Xxl_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Xxl_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Xxl_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Xxl_Width_Operator>;
};

export type PlanCalculator_Asset_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xxl_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Xxl_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Xxl_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Xxl_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Xxl_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Xxl_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Xxl_Width_Operator>;
};

export type PlanCalculator_Asset_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_Asset_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PlanCalculator_Asset_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlanCalculator_Asset_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xxs_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Xxs_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Xxs_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Xxs_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Xxs_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Xxs_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Xxs_Width_Operator>;
};

export type PlanCalculator_Asset_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xxs_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Xxs_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Xxs_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Xxs_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Xxs_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Xxs_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Xxs_Width_Operator>;
};

export type PlanCalculator_Asset_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PlanCalculator_Asset_Xxs_Where_Or>>>;
  alt?: InputMaybe<PlanCalculator_Asset_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<PlanCalculator_Asset_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<PlanCalculator_Asset_Xxs_Filename_Operator>;
  filesize?: InputMaybe<PlanCalculator_Asset_Xxs_Filesize_Operator>;
  height?: InputMaybe<PlanCalculator_Asset_Xxs_Height_Operator>;
  id?: InputMaybe<PlanCalculator_Asset_Xxs_Id_Operator>;
  mimeType?: InputMaybe<PlanCalculator_Asset_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<PlanCalculator_Asset_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<PlanCalculator_Asset_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<PlanCalculator_Asset_Xxs_Url_Operator>;
  width?: InputMaybe<PlanCalculator_Asset_Xxs_Width_Operator>;
};

export type PlanCalculator_Asset_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type PlanCalculator_BlockSettings = {
  __typename?: 'PlanCalculator_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<PlanCalculator_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<PlanCalculator_BlockSettings_ResponsiveStyles>>;
};

export type PlanCalculator_BlockSettings_ResponsiveStyles = {
  __typename?: 'PlanCalculator_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<PlanCalculator_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<PlanCalculator_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<PlanCalculator_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum PlanCalculator_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum PlanCalculator_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum PlanCalculator_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum PlanCalculator_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type PlanCalculator_Buttons = {
  __typename?: 'PlanCalculator_Buttons';
  button?: Maybe<PlanCalculator_Buttons_Button>;
  id?: Maybe<Scalars['String']>;
};

export type PlanCalculator_Buttons_Button = {
  __typename?: 'PlanCalculator_Buttons_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<PlanCalculator_Buttons_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<PlanCalculator_Buttons_Button_Variant>;
};

export type PlanCalculator_Buttons_Button_Link = {
  __typename?: 'PlanCalculator_Buttons_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<PlanCalculator_Buttons_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum PlanCalculator_Buttons_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum PlanCalculator_Buttons_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Text = 'text'
}

export type PlanCalculator_PlansTitle = {
  __typename?: 'PlanCalculator_PlansTitle';
  comboTitle?: Maybe<Scalars['String']>;
  fullTitle?: Maybe<Scalars['String']>;
  topperTitle?: Maybe<Scalars['String']>;
};

export type PlanCompatibilityCriterium = {
  __typename?: 'PlanCompatibilityCriterium';
  createdAt: Scalars['ISO8601DateTime'];
  displayOrder: Scalars['Int'];
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  scoreBaked: Scalars['Int'];
  scoreCombo: Scalars['Int'];
  scoreFull: Scalars['Int'];
  scoreTopper: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  weight: Scalars['Float'];
};

/** The connection type for PlanCompatibilityCriterium. */
export type PlanCompatibilityCriteriumConnection = {
  __typename?: 'PlanCompatibilityCriteriumConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PlanCompatibilityCriteriumEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PlanCompatibilityCriterium>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** An edge in a connection. */
export type PlanCompatibilityCriteriumEdge = {
  __typename?: 'PlanCompatibilityCriteriumEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PlanCompatibilityCriterium>;
};

/** Autogenerated input type of PlanCompatibilityCriteriumUpdate */
export type PlanCompatibilityCriteriumUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  scoreBaked?: InputMaybe<Scalars['Int']>;
  scoreCombo?: InputMaybe<Scalars['Int']>;
  scoreFull?: InputMaybe<Scalars['Int']>;
  scoreTopper?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated return type of PlanCompatibilityCriteriumUpdate. */
export type PlanCompatibilityCriteriumUpdatePayload = {
  __typename?: 'PlanCompatibilityCriteriumUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  planCompatibilityCriterium?: Maybe<PlanCompatibilityCriterium>;
};

export type PlanLineItem = {
  __typename?: 'PlanLineItem';
  category?: Maybe<PlanLineItemCategoryEnum>;
  discount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  product?: Maybe<PlanLineItemProduct>;
  quantity?: Maybe<Scalars['Int']>;
  reason?: Maybe<RecReason>;
  recurring?: Maybe<Scalars['Boolean']>;
  sku?: Maybe<Scalars['String']>;
};

export enum PlanLineItemCategoryEnum {
  Dry = 'dry',
  Entree = 'entree',
  EntreePacks = 'entree_packs',
  Plan = 'plan',
  SoftTreats = 'soft_treats',
  SupplementCookies = 'supplement_cookies',
  Wet = 'wet'
}

export type PlanLineItemProduct = {
  __typename?: 'PlanLineItemProduct';
  active?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  outOfStock?: Maybe<Scalars['Boolean']>;
  outOfStockMessage?: Maybe<Scalars['String']>;
  priceCategory?: Maybe<PriceCategoryEnum>;
  recipeId?: Maybe<Scalars['Int']>;
  shopifyId?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type PlanMatchCriterium = {
  __typename?: 'PlanMatchCriterium';
  active: Scalars['Boolean'];
  ageBased?: Maybe<Scalars['Boolean']>;
  ageGroup: Scalars['String'];
  calorieBased?: Maybe<Scalars['Boolean']>;
  calorieMax?: Maybe<Scalars['Int']>;
  calorieMin?: Maybe<Scalars['Int']>;
  comboPlan?: Maybe<BoxVariant>;
  comboPlanFrequency?: Maybe<Scalars['Int']>;
  comboPlanFrequencyCustomizable?: Maybe<Scalars['Boolean']>;
  comboPlanId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  displayOrder?: Maybe<Scalars['Int']>;
  freshBakedPlan?: Maybe<BoxVariant>;
  freshBakedPlanFrequency?: Maybe<Scalars['Int']>;
  freshBakedPlanFrequencyCustomizable?: Maybe<Scalars['Boolean']>;
  freshBakedPlanId?: Maybe<Scalars['Int']>;
  fullPlan?: Maybe<BoxVariant>;
  fullPlanFrequency?: Maybe<Scalars['Int']>;
  fullPlanFrequencyCustomizable?: Maybe<Scalars['Boolean']>;
  fullPlanId?: Maybe<Scalars['Int']>;
  groupingName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  planSettings: Scalars['JSON'];
  recommendedCaloriesPerDay?: Maybe<Scalars['Int']>;
  recommendedServingSizeInOunces?: Maybe<Scalars['Float']>;
  spaceSaverPlan?: Maybe<BoxVariant>;
  spaceSaverPlanFrequency?: Maybe<Scalars['Int']>;
  spaceSaverPlanFrequencyCustomizable?: Maybe<Scalars['Boolean']>;
  spaceSaverPlanId?: Maybe<Scalars['Int']>;
  status: PlanMatchCriteriumStatus;
  topperPlan?: Maybe<BoxVariant>;
  topperPlanFrequency?: Maybe<Scalars['Int']>;
  topperPlanFrequencyCustomizable?: Maybe<Scalars['Boolean']>;
  topperPlanId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  weightBased?: Maybe<Scalars['Boolean']>;
  weightMax?: Maybe<Scalars['Int']>;
  weightMin?: Maybe<Scalars['Int']>;
  welcomePlan?: Maybe<BoxVariant>;
  welcomePlanFrequency?: Maybe<Scalars['Int']>;
  welcomePlanFrequencyCustomizable?: Maybe<Scalars['Boolean']>;
  welcomePlanId?: Maybe<Scalars['Int']>;
};

/** The connection type for PlanMatchCriterium. */
export type PlanMatchCriteriumConnection = {
  __typename?: 'PlanMatchCriteriumConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PlanMatchCriteriumEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PlanMatchCriterium>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of PlanMatchCriteriumCreate */
export type PlanMatchCriteriumCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  planMatchCriteriumInput: PlanMatchCriteriumInput;
};

/** Autogenerated return type of PlanMatchCriteriumCreate. */
export type PlanMatchCriteriumCreatePayload = {
  __typename?: 'PlanMatchCriteriumCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  planMatchCriterium: PlanMatchCriterium;
};

/** Autogenerated input type of PlanMatchCriteriumDelete */
export type PlanMatchCriteriumDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PlanMatchCriteriumDelete. */
export type PlanMatchCriteriumDeletePayload = {
  __typename?: 'PlanMatchCriteriumDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  planMatchCriterium: PlanMatchCriterium;
};

/** An edge in a connection. */
export type PlanMatchCriteriumEdge = {
  __typename?: 'PlanMatchCriteriumEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PlanMatchCriterium>;
};

export type PlanMatchCriteriumInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  ageGroup?: InputMaybe<TypesPlanMatchCriteriumInputTypeAgeGroup>;
  calorieMax?: InputMaybe<Scalars['Int']>;
  calorieMin?: InputMaybe<Scalars['Int']>;
  comboPlanFrequency?: InputMaybe<Scalars['Int']>;
  comboPlanFrequencyCustomizable?: InputMaybe<Scalars['Boolean']>;
  comboPlanId?: InputMaybe<Scalars['Int']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  freshBakedPlanFrequency?: InputMaybe<Scalars['Int']>;
  freshBakedPlanFrequencyCustomizable?: InputMaybe<Scalars['Boolean']>;
  freshBakedPlanId?: InputMaybe<Scalars['Int']>;
  fullPlanFrequency?: InputMaybe<Scalars['Int']>;
  fullPlanFrequencyCustomizable?: InputMaybe<Scalars['Boolean']>;
  fullPlanId?: InputMaybe<Scalars['Int']>;
  groupingName: TypesPlanMatchCriteriumInputTypeGroupingType;
  halfPlanFrequency?: InputMaybe<Scalars['Int']>;
  halfPlanId?: InputMaybe<Scalars['Int']>;
  planSettings?: InputMaybe<Scalars['JSON']>;
  recommendedCaloriesPerDay?: InputMaybe<Scalars['Int']>;
  recommendedServingSizeInOunces?: InputMaybe<Scalars['Float']>;
  spaceSaverPlanFrequency?: InputMaybe<Scalars['Int']>;
  spaceSaverPlanFrequencyCustomizable?: InputMaybe<Scalars['Boolean']>;
  spaceSaverPlanId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<PlanMatchCriteriumStatus>;
  topperPlanFrequency?: InputMaybe<Scalars['Int']>;
  topperPlanFrequencyCustomizable?: InputMaybe<Scalars['Boolean']>;
  topperPlanId?: InputMaybe<Scalars['Int']>;
  weightMax?: InputMaybe<Scalars['Int']>;
  weightMin?: InputMaybe<Scalars['Int']>;
  welcomePlanFrequency?: InputMaybe<Scalars['Int']>;
  welcomePlanFrequencyCustomizable?: InputMaybe<Scalars['Boolean']>;
  welcomePlanId?: InputMaybe<Scalars['Int']>;
};

export enum PlanMatchCriteriumStatus {
  Current = 'current',
  Legacy = 'legacy',
  Unused = 'unused'
}

/** Autogenerated input type of PlanMatchCriteriumUpdate */
export type PlanMatchCriteriumUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  planMatchCriteriumInput: PlanMatchCriteriumInput;
};

/** Autogenerated return type of PlanMatchCriteriumUpdate. */
export type PlanMatchCriteriumUpdatePayload = {
  __typename?: 'PlanMatchCriteriumUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  planMatchCriterium: PlanMatchCriterium;
};

export type PlanRecommendation = {
  __typename?: 'PlanRecommendation';
  boxes: RecommendationBoxes;
  caloriesPerDay?: Maybe<Scalars['Int']>;
  oversized?: Maybe<Scalars['Boolean']>;
  servingSize?: Maybe<Scalars['Float']>;
};

export type PlanSettings = {
  __typename?: 'PlanSettings';
  chosenNewPlan?: Maybe<Array<Scalars['String']>>;
  currentPlanAfterQuestionnaire?: Maybe<Array<Scalars['String']>>;
  currentPlanFrequencyCustomizable?: Maybe<Scalars['Boolean']>;
  nextPlanAfterQuestionnaire?: Maybe<Array<Scalars['String']>>;
  nextPlanFrequencyCustomizable?: Maybe<Scalars['Boolean']>;
  recommendedNewCurrentPlan?: Maybe<Array<Scalars['String']>>;
  recommendedNewNextPlan?: Maybe<Array<Scalars['String']>>;
};

export type PlanSettingsInput = {
  chosenNewPlan: Array<Scalars['String']>;
  currentPlanAfterQuestionnaire: Array<Scalars['String']>;
  currentPlanFrequencyCustomizable: Scalars['Boolean'];
  nextPlanAfterQuestionnaire: Array<Scalars['String']>;
  nextPlanFrequencyCustomizable: Scalars['Boolean'];
  recommendedNewCurrentPlan: Array<Scalars['String']>;
  recommendedNewNextPlan: Array<Scalars['String']>;
};

export type PlanSummary = {
  __typename?: 'PlanSummary';
  count?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalRefunded?: Maybe<Scalars['Float']>;
};

export type PpComment = {
  __typename?: 'PpComment';
  authorType?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  namespace?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  resourceType?: Maybe<PpCommentResource>;
  updatedAt: Scalars['ISO8601DateTime'];
  user?: Maybe<User>;
};

/** The connection type for PpComment. */
export type PpCommentConnection = {
  __typename?: 'PpCommentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PpCommentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PpComment>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of PpCommentCreate */
export type PpCommentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ppCommentInput: PpCommentInput;
};

/** Autogenerated return type of PpCommentCreate. */
export type PpCommentCreatePayload = {
  __typename?: 'PpCommentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ppComment: PpComment;
};

/** Autogenerated input type of PpCommentDelete */
export type PpCommentDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PpCommentDelete. */
export type PpCommentDeletePayload = {
  __typename?: 'PpCommentDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ppComment: PpComment;
};

/** An edge in a connection. */
export type PpCommentEdge = {
  __typename?: 'PpCommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PpComment>;
};

export type PpCommentInput = {
  authorId?: InputMaybe<Scalars['Int']>;
  authorType?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601Date']>;
  createdAtTo?: InputMaybe<Scalars['ISO8601Date']>;
  namespace?: InputMaybe<Scalars['String']>;
  resourceId: Scalars['String'];
  resourceType: PpCommentResource;
};

export enum PpCommentResource {
  Payment = 'Payment',
  Pet = 'Pet',
  Subscription = 'Subscription',
  User = 'User'
}

/** Autogenerated input type of PpCommentUpdate */
export type PpCommentUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  ppCommentInput: PpCommentInput;
};

/** Autogenerated return type of PpCommentUpdate. */
export type PpCommentUpdatePayload = {
  __typename?: 'PpCommentUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ppComment: PpComment;
};

export type PpPayment = {
  __typename?: 'PpPayment';
  amount: Scalars['Float'];
  amountRefunded: Scalars['Float'];
  apiChargeId?: Maybe<Scalars['String']>;
  apiIntentId?: Maybe<Scalars['String']>;
  assessedTaxes: Scalars['Float'];
  assessedTaxesBy?: Maybe<Scalars['String']>;
  assessedTaxesError?: Maybe<Scalars['String']>;
  awardedCredits?: Maybe<Array<StoreCreditMovement>>;
  boxVariant?: Maybe<BoxVariant>;
  chargedAt?: Maybe<Scalars['ISO8601DateTime']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  errorCode?: Maybe<Scalars['String']>;
  estimatedTaxes: Scalars['Float'];
  estimatedTaxesDiscrepancy: Scalars['Float'];
  id: Scalars['ID'];
  lineItemsData: Scalars['JSON'];
  number?: Maybe<Scalars['String']>;
  paymentAdjustments: Array<PaymentAdjustment>;
  paymentGatewayProvider?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentOperatorType?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  reason?: Maybe<Scalars['String']>;
  refunds?: Maybe<Array<Refund>>;
  shipperCity?: Maybe<Scalars['String']>;
  shipperStateAbbr?: Maybe<Scalars['String']>;
  shipperZipCode?: Maybe<Scalars['String']>;
  state?: Maybe<PaymentState>;
  stateAbbr?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** The connection type for PpPayment. */
export type PpPaymentConnection = {
  __typename?: 'PpPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PpPaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PpPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of PpPaymentCreate */
export type PpPaymentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ppPaymentInput: PpPaymentInput;
};

/** Autogenerated return type of PpPaymentCreate. */
export type PpPaymentCreatePayload = {
  __typename?: 'PpPaymentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ppPayment: PpPayment;
};

/** Autogenerated input type of PpPaymentDelete */
export type PpPaymentDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PpPaymentDelete. */
export type PpPaymentDeletePayload = {
  __typename?: 'PpPaymentDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ppPayment: PpPayment;
};

/** An edge in a connection. */
export type PpPaymentEdge = {
  __typename?: 'PpPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PpPayment>;
};

export type PpPaymentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  amountRefunded?: InputMaybe<Scalars['Float']>;
  apiChargeId?: InputMaybe<Scalars['String']>;
  apiIntentId?: InputMaybe<Scalars['String']>;
  assessedTaxes?: InputMaybe<Scalars['Float']>;
  assessedTaxesBy?: InputMaybe<Scalars['String']>;
  assessedTaxesError?: InputMaybe<Scalars['String']>;
  chargedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  city?: InputMaybe<Scalars['String']>;
  errorCode?: InputMaybe<Scalars['String']>;
  estimatedTaxes?: InputMaybe<Scalars['Float']>;
  estimatedTaxesDiscrepancy?: InputMaybe<Scalars['Float']>;
  lineItemsData?: InputMaybe<Scalars['JSON']>;
  number?: InputMaybe<Scalars['String']>;
  paymentGatewayProvider?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['Int']>;
  paymentOperatorType?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  reason?: InputMaybe<Scalars['String']>;
  shipperCity?: InputMaybe<Scalars['String']>;
  shipperStateAbbr?: InputMaybe<Scalars['String']>;
  shipperZipCode?: InputMaybe<Scalars['String']>;
  shopifyBillingAttemptId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<TypesPpPaymentInputTypeState>;
  stateAbbr?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['Int']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of PpPaymentUpdate */
export type PpPaymentUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  ppPaymentInput: PpPaymentInput;
};

/** Autogenerated return type of PpPaymentUpdate. */
export type PpPaymentUpdatePayload = {
  __typename?: 'PpPaymentUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ppPayment: PpPayment;
};

export type PreparedWaysBlock = {
  __typename?: 'PreparedWaysBlock';
  backgroundColor?: Maybe<PreparedWaysBlock_BackgroundColor>;
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<PreparedWaysBlock_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['JSON']>;
};


export type PreparedWaysBlockTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type PreparedWaysBlock_BlockSettings = {
  __typename?: 'PreparedWaysBlock_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<PreparedWaysBlock_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<PreparedWaysBlock_BlockSettings_ResponsiveStyles>>;
};

export type PreparedWaysBlock_BlockSettings_ResponsiveStyles = {
  __typename?: 'PreparedWaysBlock_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<PreparedWaysBlock_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<PreparedWaysBlock_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<PreparedWaysBlock_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum PreparedWaysBlock_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum PreparedWaysBlock_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum PreparedWaysBlock_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum PreparedWaysBlock_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export enum PreparedWaysBlock_BackgroundColor {
  Dark = 'dark',
  Light = 'light'
}

export type PressLogos = {
  __typename?: 'PressLogos';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<PressLogos_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  icons: Array<PressLogos_Icons>;
  id?: Maybe<Scalars['String']>;
};

export type PressLogos_BlockSettings = {
  __typename?: 'PressLogos_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<PressLogos_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<PressLogos_BlockSettings_ResponsiveStyles>>;
};

export type PressLogos_BlockSettings_ResponsiveStyles = {
  __typename?: 'PressLogos_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<PressLogos_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<PressLogos_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<PressLogos_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum PressLogos_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum PressLogos_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum PressLogos_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum PressLogos_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type PressLogos_Icons = {
  __typename?: 'PressLogos_Icons';
  id?: Maybe<Scalars['String']>;
  pressIcons: PressLogos_Icons_PressIcons;
};

export enum PressLogos_Icons_PressIcons {
  CbsNews = 'CbsNews',
  Forbes = 'Forbes',
  FoxNews = 'FoxNews',
  Newsday = 'Newsday',
  SharkTank = 'SharkTank'
}

export enum PriceCategoryEnum {
  Addon = 'addon',
  Bundled = 'bundled',
  Dish = 'dish'
}

export type ProductPlanVariantInput = {
  inStock: Scalars['Boolean'];
  productId: Scalars['ID'];
  productVariantSku: Scalars['String'];
};

/** Autogenerated input type of ProductPlanVariantUpdate */
export type ProductPlanVariantUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: ProductPlanVariantInput;
};

/** Autogenerated return type of ProductPlanVariantUpdate. */
export type ProductPlanVariantUpdatePayload = {
  __typename?: 'ProductPlanVariantUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ProductTwoUp = {
  __typename?: 'ProductTwoUp';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<ProductTwoUp_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  button?: Maybe<Array<ProductTwoUp_Button>>;
  cards?: Maybe<Array<ProductTwoUp_Cards>>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['JSON']>;
};


export type ProductTwoUpTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type ProductTwoUp_BlockSettings = {
  __typename?: 'ProductTwoUp_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<ProductTwoUp_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<ProductTwoUp_BlockSettings_ResponsiveStyles>>;
};

export type ProductTwoUp_BlockSettings_ResponsiveStyles = {
  __typename?: 'ProductTwoUp_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<ProductTwoUp_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<ProductTwoUp_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<ProductTwoUp_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum ProductTwoUp_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum ProductTwoUp_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ProductTwoUp_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ProductTwoUp_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type ProductTwoUp_Button = {
  __typename?: 'ProductTwoUp_Button';
  button?: Maybe<ProductTwoUp_Button_Button>;
  id?: Maybe<Scalars['String']>;
};

export type ProductTwoUp_Button_Button = {
  __typename?: 'ProductTwoUp_Button_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<ProductTwoUp_Button_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<ProductTwoUp_Button_Button_Variant>;
};

export type ProductTwoUp_Button_Button_Link = {
  __typename?: 'ProductTwoUp_Button_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<ProductTwoUp_Button_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum ProductTwoUp_Button_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum ProductTwoUp_Button_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Text = 'text'
}

export type ProductTwoUp_Cards = {
  __typename?: 'ProductTwoUp_Cards';
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Cms_Media>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<ProductTwoUp_Cards_Image>;
  isModal?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  modalContent?: Maybe<ProductTwoUp_Cards_ModalContent>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  useIconAndSubtitle?: Maybe<Scalars['Boolean']>;
};


export type ProductTwoUp_CardsIconArgs = {
  where?: InputMaybe<ProductTwoUp_Cards_Icon_Where>;
};

export type ProductTwoUp_Cards_Icon_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Icon_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Icon_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Icon_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Icon_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Icon_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Icon_Where = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Icon_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Icon_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Icon_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Icon_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Icon_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Icon_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Icon_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Icon_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Icon_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Icon_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Icon_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Icon_Width_Operator>;
};

export type ProductTwoUp_Cards_Icon_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Icon_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Icon_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Icon_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Icon_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Icon_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Icon_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Icon_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Icon_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Icon_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Icon_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Icon_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Icon_Width_Operator>;
};

export type ProductTwoUp_Cards_Icon_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Icon_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Icon_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Icon_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Icon_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Icon_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Icon_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Icon_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Icon_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Icon_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Icon_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Icon_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Icon_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Icon_Width_Operator>;
};

export type ProductTwoUp_Cards_Icon_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image = {
  __typename?: 'ProductTwoUp_Cards_Image';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type ProductTwoUp_Cards_ImageLgArgs = {
  where?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Where>;
};


export type ProductTwoUp_Cards_ImageMdArgs = {
  where?: InputMaybe<ProductTwoUp_Cards_Image_Md_Where>;
};


export type ProductTwoUp_Cards_ImageSmArgs = {
  where?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Where>;
};


export type ProductTwoUp_Cards_ImageXlArgs = {
  where?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Where>;
};


export type ProductTwoUp_Cards_ImageXsArgs = {
  where?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Where>;
};


export type ProductTwoUp_Cards_ImageXxlArgs = {
  where?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Where>;
};


export type ProductTwoUp_Cards_ImageXxsArgs = {
  where?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Where>;
};

export type ProductTwoUp_Cards_Image_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Lg_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Md_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Md_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Md_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Md_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Md_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Md_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Md_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Md_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Md_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Md_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Md_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Sm_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Xl_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Xs_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Xxl_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_Image_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ProductTwoUp_Cards_Image_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductTwoUp_Cards_Image_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTwoUp_Cards_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Height_Operator>;
  id?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Url_Operator>;
  width?: InputMaybe<ProductTwoUp_Cards_Image_Xxs_Width_Operator>;
};

export type ProductTwoUp_Cards_Image_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ProductTwoUp_Cards_ModalContent = {
  __typename?: 'ProductTwoUp_Cards_ModalContent';
  AAFCO?: Maybe<Scalars['JSON']>;
  boldHeader?: Maybe<Scalars['Boolean']>;
  contentType?: Maybe<ProductTwoUp_Cards_ModalContent_ContentType>;
  guaranteedAnalysis?: Maybe<Scalars['JSON']>;
  ingredients?: Maybe<Scalars['JSON']>;
  tableColumns?: Maybe<Scalars['Float']>;
  tableContent?: Maybe<Array<ProductTwoUp_Cards_ModalContent_TableContent>>;
};


export type ProductTwoUp_Cards_ModalContentAafcoArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type ProductTwoUp_Cards_ModalContentGuaranteedAnalysisArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type ProductTwoUp_Cards_ModalContentIngredientsArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type ProductTwoUp_Cards_ModalContent_TableContent = {
  __typename?: 'ProductTwoUp_Cards_ModalContent_TableContent';
  id?: Maybe<Scalars['String']>;
  rowInputs?: Maybe<Scalars['JSON']>;
};

export enum ProductTwoUp_Cards_ModalContent_ContentType {
  RichTextContent = 'richTextContent',
  TableContent = 'tableContent'
}

/** Autogenerated input type of ProductVariantCreate */
export type ProductVariantCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productVariantInput: ProductVariantInput;
};

/** Autogenerated return type of ProductVariantCreate. */
export type ProductVariantCreatePayload = {
  __typename?: 'ProductVariantCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  productVariant?: Maybe<PetPlateProductVariantType>;
};

/** Autogenerated input type of ProductVariantDelete */
export type ProductVariantDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ProductVariantDelete. */
export type ProductVariantDeletePayload = {
  __typename?: 'ProductVariantDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  productVariant: PetPlateProductVariantType;
};

export type ProductVariantInput = {
  metadata?: InputMaybe<Scalars['JSON']>;
  migrationPriceRollback?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  outOfStock?: InputMaybe<Scalars['Boolean']>;
  planId: Scalars['Int'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['Int'];
  sku: Scalars['String'];
  state?: PetPlateMealVariantState;
};

export enum ProductVariantOrder {
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyModified = 'RECENTLY_MODIFIED'
}

/** Autogenerated input type of ProductVariantUpdate */
export type ProductVariantUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  productVariantInput: ProductVariantInput;
};

/** Autogenerated return type of ProductVariantUpdate. */
export type ProductVariantUpdatePayload = {
  __typename?: 'ProductVariantUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  productVariant: PetPlateProductVariantType;
};

export type Query = {
  __typename?: 'Query';
  Access?: Maybe<Access>;
  Cms_media?: Maybe<Cms_Media>;
  Cms_medias?: Maybe<Cms_Medias>;
  Cms_page?: Maybe<Cms_Page>;
  Cms_pages?: Maybe<Cms_Pages>;
  Footer?: Maybe<Footer>;
  Nav?: Maybe<Nav>;
  PayloadPreference?: Maybe<PayloadPreference>;
  PayloadPreferences?: Maybe<PayloadPreferences>;
  /** Find a Address its id value */
  address: Address;
  addresses: AddressConnection;
  /** Find a Automation its id value */
  automation: Automation;
  automations: AutomationConnection;
  /** Find a Box its id value */
  box: Box;
  /** Find a BoxVariant its id value */
  boxVariant: BoxVariant;
  boxVariants: BoxVariantConnection;
  boxes: BoxConnection;
  /** Find a Breed its id value */
  breed: Breed;
  breeds: BreedConnection;
  /** Find a CalorieMultiplier its id value */
  calorieMultiplier: CalorieMultiplier;
  calorieMultipliers: CalorieMultiplierConnection;
  /** Find a CancellationSurvey its id value */
  cancellationSurvey: CancellationSurvey;
  cancellationSurveys: CancellationSurveyConnection;
  changelogEntries: ChangelogEntryConnection;
  /** Find a ConversionSurvey its id value */
  conversionSurvey: ConversionSurvey;
  conversionSurveys: ConversionSurveyConnection;
  /** Find a Coupon its id value */
  coupon: Coupon;
  coupons: CouponConnection;
  /** Find a V2::Order its id value */
  dbOrder: DbOrder;
  dbOrders: DbOrderConnection;
  docAccessCms_media?: Maybe<Cms_MediaDocAccess>;
  docAccessCms_page?: Maybe<Cms_PageDocAccess>;
  docAccessFooter?: Maybe<FooterDocAccess>;
  docAccessNav?: Maybe<NavDocAccess>;
  docAccessPayloadPreference?: Maybe<Payload_PreferencesDocAccess>;
  /** List all dry ice matrix tiers */
  dryIceMatrixTiers: Array<DryIceMatrixTier>;
  /** Find a DryIcePackaging its id value */
  dryIcePackaging: DryIcePackaging;
  dryIcePackagings: DryIcePackagingConnection;
  dryIceWarehouses: Array<ResolversTransitWarehousesResolverWarehouse>;
  /** Find a FulfillmentScheduleRule its id value */
  fulfillmentScheduleRule: FulfillmentScheduleRule;
  fulfillmentScheduleRules: FulfillmentScheduleRuleConnection;
  /** Returns the url for exported fulfillment schedule rules */
  fulfillmentScheduleRulesReport: ReportDownload;
  /** Find a ImportJob its id value */
  importJob: ImportJob;
  /** Find a ImportJobLinePreview its id value */
  importJobLinePreview: ImportJobLinePreview;
  importJobLinePreviews: ImportJobLinePreviewConnection;
  importJobs: ImportJobConnection;
  /** Find a Ingredient its id value */
  ingredient: Ingredient;
  ingredients: IngredientConnection;
  /** Returns the most recent posts from PetPlate's instagram account */
  instagramPosts: Array<InstagramPost>;
  invalidZipCodeAlerts: InvalidZipCodeAlerts;
  /** Find a LineItemRule its id value */
  lineItemRule: LineItemRule;
  /** Find a LineItemRuleSet its id value */
  lineItemRuleSet: LineItemRuleSet;
  lineItemRuleSets: LineItemRuleSetConnection;
  lineItemRuleValues: Array<ResolversLineItemFieldValuesResolverValues>;
  lineItemRules: LineItemRuleConnection;
  /** Find a LogEvent its id value */
  logEvent: LogEvent;
  logEvents: LogEventConnection;
  /** The currently authenticated user. Defaults to an empty object if unauthenticated */
  me: User;
  /** Find a Meal its id value */
  meal: Meal;
  /** Find a MealLineItem its id value */
  mealLineItem: MealLineItem;
  mealLineItems: MealLineItemConnection;
  /** Find a MealVariant its id value */
  mealVariant: PetPlateMealVariantType;
  mealVariants: PetPlateMealVariantTypeConnection;
  meals: MealConnection;
  /** Find a NotificationBanner its id value */
  notificationBanner: NotificationBanner;
  notificationBanners: NotificationBannerConnection;
  operationsActiveSubscriptions: TypesOperationsDashboardTypeActiveSubscriptions;
  operationsOrdersWithoutSync: Array<TypesOperationsDashboardTypeUnsyncedOrders>;
  operationsPaymentBatches: Array<TypesOperationsDashboardTypePaymentBatch>;
  operationsRecentOrders: Array<TypesOperationsDashboardTypeRecentOrders>;
  operationsShipmentLists: Array<TypesOperationsDashboardTypeShipmentList>;
  operationsShippingAlerts: TypesOperationsDashboardTypeShippingAlert;
  operationsShippingSchedule: Array<TypesOperationsDashboardTypeShippingSchedule>;
  operationsSubscriptionStatistics: TypesOperationsDashboardTypeSubscriptionStatistics;
  /** Gets a Shopify order */
  orderDetail?: Maybe<ShopifyOrderDetail>;
  /** Find a OrderImportBatch its id value */
  orderImportBatch: OrderImportBatch;
  orderImportBatchEntries: OrderImportBatchEntryConnection;
  /** Find a OrderImportBatchEntry its id value */
  orderImportBatchEntry: OrderImportBatchEntry;
  orderImportBatches: OrderImportBatchConnection;
  /** Find a Packaging its id value */
  packaging: Packaging;
  packagings: PackagingConnection;
  /** Find a PauseSurvey its id value */
  pauseSurvey: PauseSurvey;
  pauseSurveys: PauseSurveyConnection;
  /** Find a PaymentAdjustment its id value */
  paymentAdjustment: PaymentAdjustment;
  paymentAdjustments: PaymentAdjustmentConnection;
  /** Find a PaymentBatch its id value */
  paymentBatch: PaymentBatch;
  paymentBatchEntries: PaymentBatchEntryConnection;
  /** Find a PaymentBatchEntry its id value */
  paymentBatchEntry: PaymentBatchEntry;
  paymentBatches: PaymentBatchConnection;
  /** Find a PaymentMethod its id value */
  paymentMethod: PaymentMethod;
  paymentMethods: PaymentMethodConnection;
  /** Find a Pet its id value */
  pet: Pet;
  /** Find a Product its id value */
  petPlateProduct: PetPlateProduct;
  petPlateProducts: PetPlateProductConnection;
  pets: PetConnection;
  petsServed: PetsServed;
  planCompatibilityCriteria: PlanCompatibilityCriteriumConnection;
  /** Find a PlanCompatibilityCriterium its id value */
  planCompatibilityCriterium: PlanCompatibilityCriterium;
  planMatchCriteria: PlanMatchCriteriumConnection;
  /** Find a PlanMatchCriterium its id value */
  planMatchCriterium: PlanMatchCriterium;
  /** Find a Comment its id value */
  ppComment: PpComment;
  ppComments: PpCommentConnection;
  /** Find a Payment its id value */
  ppPayment: PpPayment;
  ppPayments: PpPaymentConnection;
  /** Find a ProductVariant its id value */
  productVariant: PetPlateProductVariantType;
  productVariants: PetPlateProductVariantTypeConnection;
  /** Find a Recipe its id value */
  recipe: Recipe;
  recipes: RecipeConnection;
  /** Find a RecommendableProduct its id value */
  recommendableProduct: RecommendableProduct;
  recommendableProducts: RecommendableProductConnection;
  /** Find a RecommendationWizard its id value */
  recommendationWizard: RecommendationWizard;
  recommendationWizards: RecommendationWizardConnection;
  /** Find a ReportJob its id value */
  reportJob: ReportJob;
  reportJobs: ReportJobConnection;
  /** Find a RetailPrice its id value */
  retailPrice: RetailPrice;
  retailPrices: RetailPriceConnection;
  /** Find a RouteSchedule its id value */
  routeSchedule: RouteSchedule;
  /** Find a RouteScheduleUpload its id value */
  routeScheduleUpload: RouteScheduleUpload;
  routeScheduleUploads: RouteScheduleUploadConnection;
  routeSchedules: RouteScheduleConnection;
  /** Find settings records */
  settings?: Maybe<Array<SettingsSearchResult>>;
  shipmentEntries: ShipmentEntryConnection;
  /** Returns the url for exported filtered shipment entries */
  shipmentEntriesReport: ReportDownload;
  /** Find a ShipmentEntry its id value */
  shipmentEntry: ShipmentEntry;
  /** Find a ShipmentList its id value */
  shipmentList: ShipmentList;
  shipmentListToShipstationFormat: ShipmentListShipstationFormat;
  shipmentLists: ShipmentListConnection;
  /** Find a ShipmentUpdatesUpload its id value */
  shipmentUpdatesUpload: ShipmentUpdatesUpload;
  shipmentUpdatesUploads: ShipmentUpdatesUploadConnection;
  /** Find a ShipstationUploadJob its id value */
  shipstationUploadJob: ShipstationUploadJob;
  shopifyCoupons: ShopifyCoupons;
  shopifyDiscountInfo: Array<ShopifyDiscountInfo>;
  /** Find a SizeClass its name value */
  sizeClass: SizeClass;
  sizeClasses: SizeClassConnection;
  /** Find a StateChange its id value */
  stateChange: StateChange;
  stateChanges: StateChangeConnection;
  /** Find a StoreCreditAccount its id value */
  storeCreditAccount: StoreCreditAccount;
  storeCreditAccounts: StoreCreditAccountConnection;
  /** Find a StoreCreditMovement its id value */
  storeCreditMovement: StoreCreditMovement;
  storeCreditMovements: StoreCreditMovementConnection;
  /** Find a Subscription its id value */
  subscription: Subscription;
  /** Returns the url for exported subscription statistics */
  subscriptionStatisticsReport: SubscriptionStatisticsReport;
  subscriptions: SubscriptionConnection;
  surveyOptions: SurveyOptions;
  /** Find a Term its id value */
  tagging: Term;
  taggings: TermConnection;
  /** Find a Term its id value */
  term: Term;
  terms: TermConnection;
  /** Find a TransitConfiguration its id value */
  transitConfiguration: TransitConfiguration;
  transitConfigurations: TransitConfigurationConnection;
  unsyncedData: UnsyncedData;
  useWeatherDryIce: Scalars['Boolean'];
  /** Find a User its id value */
  user: User;
  userExists: Scalars['Boolean'];
  users: UserConnection;
  /** Find a V2::Shipment its id value */
  v2Shipment: V2Shipment;
  v2Shipments: V2ShipmentConnection;
  versionCms_page?: Maybe<Cms_PageVersion>;
  versionsCms_pages?: Maybe<VersionsCms_Pages>;
  /** Find a WellnessGoal its id value */
  wellnessGoal: WellnessGoal;
  wellnessGoals: WellnessGoalConnection;
  /** Find a ZipCode its id value */
  zipCode: ZipCode;
  /** Find a ZipCodeLocation its id value */
  zipCodeLocation: ZipCodeLocation;
  zipCodeLocations: ZipCodeLocationConnection;
  zipCodes: ZipCodeConnection;
};


export type QueryCms_MediaArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryCms_MediasArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Cms_Media_Where>;
};


export type QueryCms_PageArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryCms_PagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Cms_Page_Where>;
};


export type QueryFooterArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNavArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPayloadPreferenceArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryPayloadPreferencesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PayloadPreference_Where>;
};


export type QueryAddressArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryAddressesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AddressOrder>;
};


export type QueryAutomationArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryAutomationsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<AutomationName>;
  weekday?: InputMaybe<AutomationWeekday>;
};


export type QueryBoxArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryBoxVariantArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryBoxVariantsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  activeFromAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  activeFromBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  onlyActivePlans?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<ResolversBoxVariantsResolverOrder>;
};


export type QueryBoxesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  boxVariantSku?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversBoxesResolverOrder>;
  planType?: InputMaybe<BoxVariantPlanTypeEnum>;
  routeCode?: InputMaybe<RouteCode>;
  sku?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<TypesBoxInputTypeState>;
};


export type QueryBreedArgs = {
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryBreedsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversBreedsResolverOrder>;
};


export type QueryCalorieMultiplierArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryCalorieMultipliersArgs = {
  activityLevel?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bodyCondition?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversCalorieMultipliersResolverOrder>;
};


export type QueryCancellationSurveyArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryCancellationSurveysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  cancellationReasonOther?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversCancellationSurveysResolverOrder>;
  subscriptionNumber?: InputMaybe<Scalars['String']>;
};


export type QueryChangelogEntriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['ID']>;
  itemType?: InputMaybe<VersionedModelClassEnum>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryConversionSurveyArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryConversionSurveysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversConversionSurveysResolverOrder>;
  source?: InputMaybe<Scalars['String']>;
};


export type QueryCouponArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryCouponsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<CouponDurationEnum>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversCouponsResolverOrder>;
  shopifyReady?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDbOrderArgs = {
  id?: InputMaybe<Scalars['String']>;
  shopifyId?: InputMaybe<Scalars['String']>;
};


export type QueryDbOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  amazonPoNumber?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<ResolversDbOrdersResolverChannel>;
  chewyPoNumber?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
  estimatedShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  humanizedState?: InputMaybe<OrderHumanizedState>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  opsState?: InputMaybe<ResolversDbOrdersResolverOpsState>;
  order?: InputMaybe<ResolversDbOrdersResolverOrder>;
  orderImportBatchEntryId?: InputMaybe<Scalars['ID']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<TypesDbOrderInputTypeState>;
  subscriptionId?: InputMaybe<Scalars['ID']>;
};


export type QueryDocAccessCms_MediaArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessCms_PageArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessPayloadPreferenceArgs = {
  id: Scalars['String'];
};


export type QueryDryIcePackagingArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDryIcePackagingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DryIcePackagingOrder>;
};


export type QueryFulfillmentScheduleRuleArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryFulfillmentScheduleRulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversFulfillmentScheduleRulesResolverOrder>;
  routeCode?: InputMaybe<TypesRouteCodesType>;
  startDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  startDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type QueryFulfillmentScheduleRulesReportArgs = {
  endDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<ResolversFulfillmentScheduleRulesResolverOrder>;
  routeCode?: InputMaybe<TypesRouteCodesType>;
  startDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  startDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type QueryImportJobArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryImportJobLinePreviewArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryImportJobLinePreviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ImportJobLinePreviewOrder>;
};


export type QueryImportJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  error?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversImportJobsResolverOrder>;
};


export type QueryIngredientArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryIngredientsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IngredientOrder>;
};


export type QueryInstagramPostsArgs = {
  max?: InputMaybe<Scalars['Int']>;
};


export type QueryLineItemRuleArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryLineItemRuleSetArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryLineItemRuleSetsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  conflictStrategy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  limitStrategy?: InputMaybe<MutationsDynamicLineItemPutLimitAction>;
  lineItemDiscount?: InputMaybe<Scalars['Float']>;
  lineItemName?: InputMaybe<Scalars['String']>;
  lineItemOutOfStock?: InputMaybe<Scalars['Boolean']>;
  lineItemPrice?: InputMaybe<Scalars['Float']>;
  lineItemQuantity?: InputMaybe<Scalars['Int']>;
  lineItemReplaceSku?: InputMaybe<Scalars['String']>;
  lineItemSku?: InputMaybe<Scalars['String']>;
  lineItemType?: InputMaybe<Scalars['String']>;
  mergeCostStrategy?: InputMaybe<MutationsDynamicLineItemPutDupCostAction>;
  mergeNameStrategy?: InputMaybe<MutationsDynamicLineItemPutDupNameAction>;
  mergeQuantityStrategy?: InputMaybe<MutationsDynamicLineItemPutDupCountAction>;
  order?: InputMaybe<ResolversLineItemRuleSetsResolverOrder>;
  priority?: InputMaybe<Scalars['Int']>;
};


export type QueryLineItemRulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversLineItemRulesResolverOrder>;
};


export type QueryLogEventArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryLogEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversLogEventsResolverOrder>;
  sourceType?: InputMaybe<Scalars['String']>;
  targetId?: InputMaybe<Scalars['ID']>;
  targetType?: InputMaybe<Scalars['String']>;
};


export type QueryMealArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryMealLineItemArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryMealLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<MealLineItemOrder>;
};


export type QueryMealVariantArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryMealVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<MealVariantOrder>;
};


export type QueryMealsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversMealsResolverOrder>;
  sku?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryNotificationBannerArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryNotificationBannersArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversNotificationBannersResolverOrder>;
};


export type QueryOperationsShippingScheduleArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type QueryOrderDetailArgs = {
  cartToken: Scalars['String'];
};


export type QueryOrderImportBatchArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryOrderImportBatchEntriesArgs = {
  action?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversOrderImportBatchEntriesResolverOrder>;
  orderImportBatchId?: InputMaybe<Scalars['ID']>;
  poNumber?: InputMaybe<Scalars['String']>;
};


export type QueryOrderImportBatchEntryArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryOrderImportBatchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endedAtAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  endedAtBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  fromDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  fromDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversOrderImportBatchesResolverOrder>;
  startedAtAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  startedAtBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  untilDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  untilDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type QueryPackagingArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPackagingsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPackagingsResolverOrder>;
};


export type QueryPauseSurveyArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPauseSurveysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversPauseSurveysResolverOrder>;
};


export type QueryPaymentAdjustmentArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPaymentAdjustmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaymentAdjustmentOrder>;
};


export type QueryPaymentBatchArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPaymentBatchEntriesArgs = {
  action?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  opsState?: InputMaybe<ResolversPaymentBatchEntriesResolverOpsState>;
  order?: InputMaybe<ResolversPaymentBatchEntriesResolverOrder>;
  paymentBatchId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<TypesPaymentBatchEntryInputTypeState>;
};


export type QueryPaymentBatchEntryArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPaymentBatchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dueAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  dueAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  endedAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  endedAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversPaymentBatchesResolverOrder>;
  startedAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  startedAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  state?: InputMaybe<TypesPaymentBatchInputTypeState>;
};


export type QueryPaymentMethodArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardLast4?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversPaymentMethodsResolverOrder>;
  state?: InputMaybe<TypesPaymentMethodInputTypeState>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryPetArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPetPlateProductArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPetPlateProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPetPlateProductsResolverOrder>;
  sku?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryPetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  breedType?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversPetsResolverOrder>;
  petName?: InputMaybe<Scalars['String']>;
  primaryBreed?: InputMaybe<Scalars['String']>;
  secondaryBreed?: InputMaybe<Scalars['String']>;
  spayedNeutered?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
  weight?: InputMaybe<Scalars['Int']>;
};


export type QueryPlanCompatibilityCriteriaArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPlanCompatibilityCriteriaResolverOrder>;
};


export type QueryPlanCompatibilityCriteriumArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPlanMatchCriteriaArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  ageGroup?: InputMaybe<TypesPlanMatchCriteriumInputTypeAgeGroup>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  groupingName?: InputMaybe<TypesPlanMatchCriteriumInputTypeGroupingType>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversPlanMatchCriteriaResolverOrder>;
  status?: InputMaybe<PlanMatchCriteriumStatus>;
};


export type QueryPlanMatchCriteriumArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPpCommentArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPpCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPpCommentsResolverOrder>;
  resourceId?: InputMaybe<Scalars['ID']>;
  resourceType?: InputMaybe<PpCommentResource>;
};


export type QueryPpPaymentArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPpPaymentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPpPaymentsResolverOrder>;
  state?: InputMaybe<TypesPpPaymentInputTypeState>;
  stateAbbr?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type QueryProductVariantArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ProductVariantOrder>;
};


export type QueryRecipeArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryRecipesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<RecipeOrder>;
};


export type QueryRecommendableProductArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryRecommendableProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversRecommendableProductsResolverOrder>;
  recommendableType?: InputMaybe<TypesRecommendableProductInputTypeRecommendedType>;
  status?: InputMaybe<TypesRecommendableProductInputTypeStatus>;
};


export type QueryRecommendationWizardArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryRecommendationWizardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RecommendationWizardOrder>;
};


export type QueryReportJobArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryReportJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Scalars['String']>;
  endedAtAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  endedAtBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  errorMessage?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  logContentType?: InputMaybe<Scalars['String']>;
  logFileName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversReportJobsResolverOrder>;
  outputContentName?: InputMaybe<Scalars['String']>;
  outputContentType?: InputMaybe<Scalars['String']>;
  startedAtAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  startedAtBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  state?: InputMaybe<TypesReportJobInputTypeState>;
};


export type QueryRetailPriceArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryRetailPricesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RetailPriceOrder>;
};


export type QueryRouteScheduleArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryRouteScheduleUploadArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryRouteScheduleUploadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  fileName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversRouteScheduleUploadsResolverOrder>;
  routeType?: InputMaybe<RouteCode>;
  state?: InputMaybe<TypesRouteScheduleUploadTypeState>;
};


export type QueryRouteSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  carrier?: InputMaybe<Scalars['String']>;
  carrierCode?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversRouteSchedulesResolverOrder>;
  routeCode?: InputMaybe<TypesRouteScheduleTypeRouteCode>;
  serviced?: InputMaybe<Scalars['Boolean']>;
  transitRegion?: InputMaybe<Scalars['String']>;
  transitRegionCode?: InputMaybe<Scalars['String']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
  warehouseName?: InputMaybe<Scalars['String']>;
  warehouseZipCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type QuerySettingsArgs = {
  vars?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryShipmentEntriesArgs = {
  addressStateAbbr?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  box?: InputMaybe<Scalars['String']>;
  boxVariant?: InputMaybe<Scalars['String']>;
  carrierService?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  opsState?: InputMaybe<ResolversShipmentEntriesResolverOpsState>;
  order?: InputMaybe<ResolversShipmentEntriesResolverOrder>;
  orderNumber?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  paymentMissing?: InputMaybe<Scalars['Boolean']>;
  paymentNumber?: InputMaybe<Scalars['String']>;
  paymentStatus?: InputMaybe<Scalars['String']>;
  paymentZip?: InputMaybe<Scalars['String']>;
  routeCode?: InputMaybe<Scalars['String']>;
  scheduledShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  scheduledShippingDateFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  scheduledShippingDateTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  shipmentId?: InputMaybe<Scalars['ID']>;
  shipmentNumber?: InputMaybe<Scalars['String']>;
  shippedAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  shippedAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  state?: InputMaybe<TypesShipmentEntryInputTypeState>;
  subscriptionNumber?: InputMaybe<Scalars['String']>;
  subscriptionStatus?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
  trackingStatus?: InputMaybe<Scalars['String']>;
};


export type QueryShipmentEntriesReportArgs = {
  addressStateAbbr?: InputMaybe<Scalars['String']>;
  box?: InputMaybe<Scalars['String']>;
  boxVariant?: InputMaybe<Scalars['String']>;
  carrierService?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  opsState?: InputMaybe<ResolversShipmentEntriesResolverOpsState>;
  order?: InputMaybe<ResolversShipmentEntriesResolverOrder>;
  orderNumber?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  paymentMissing?: InputMaybe<Scalars['Boolean']>;
  paymentNumber?: InputMaybe<Scalars['String']>;
  paymentStatus?: InputMaybe<Scalars['String']>;
  paymentZip?: InputMaybe<Scalars['String']>;
  routeCode?: InputMaybe<Scalars['String']>;
  scheduledShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  scheduledShippingDateFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  scheduledShippingDateTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  shipmentId?: InputMaybe<Scalars['ID']>;
  shipmentNumber?: InputMaybe<Scalars['String']>;
  shippedAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  shippedAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  state?: InputMaybe<TypesShipmentEntryInputTypeState>;
  subscriptionNumber?: InputMaybe<Scalars['String']>;
  subscriptionStatus?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
  trackingStatus?: InputMaybe<Scalars['String']>;
};


export type QueryShipmentEntryArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryShipmentListArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryShipmentListToShipstationFormatArgs = {
  id: Scalars['String'];
};


export type QueryShipmentListsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  estimatedShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversShipmentListsResolverOrder>;
  shippedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  state?: InputMaybe<TypesShipmentListInputTypeState>;
};


export type QueryShipmentUpdatesUploadArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryShipmentUpdatesUploadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  fileName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversShipmentUpdatesUploadsResolverOrder>;
  state?: InputMaybe<TypesShipmentUpdatesUploadTypeState>;
};


export type QueryShipstationUploadJobArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryShopifyCouponsArgs = {
  input: ResolversShopifyCouponsResolverInput;
};


export type QueryShopifyDiscountInfoArgs = {
  codes: Array<Scalars['String']>;
};


export type QuerySizeClassArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QuerySizeClassesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversSizeClassesResolverOrder>;
};


export type QueryStateChangeArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryStateChangesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  nextState?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversStateChangesResolverOrder>;
  previousState?: InputMaybe<Scalars['String']>;
  statefulId?: InputMaybe<Scalars['ID']>;
  statefulType?: InputMaybe<Scalars['String']>;
};


export type QueryStoreCreditAccountArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryStoreCreditAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversStoreCreditAccountsResolverOrder>;
};


export type QueryStoreCreditMovementArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryStoreCreditMovementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversStoreCreditMovementsResolverOrder>;
  storeCreditAccountId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerySubscriptionArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QuerySubscriptionStatisticsReportArgs = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
};


export type QuerySubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  canceledAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  canceledAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  completedAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  completedAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  opsState?: InputMaybe<ResolversSubscriptionsResolverOpsState>;
  order?: InputMaybe<ResolversSubscriptionsResolverOrder>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  planType?: InputMaybe<BoxVariantPlanTypeEnum>;
  processed?: InputMaybe<Scalars['Boolean']>;
  renewals?: InputMaybe<Scalars['Int']>;
  scheduledShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  scheduledShippingDateFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  scheduledShippingDateTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TypesSubscriptionInputTypeState>;
  userId?: InputMaybe<Scalars['ID']>;
  userName?: InputMaybe<Scalars['String']>;
};


export type QueryTaggingArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryTaggingsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  grouping?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversTermsResolverOrder>;
  type?: InputMaybe<TypesTermInputTypeType>;
};


export type QueryTermArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryTermsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  grouping?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversTermsResolverOrder>;
  type?: InputMaybe<TypesTermInputTypeType>;
};


export type QueryTransitConfigurationArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryTransitConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TransitConfigurationOrder>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryUserExistsArgs = {
  email: Scalars['String'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversUsersResolverOrder>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<UserTag>;
};


export type QueryV2ShipmentArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryV2ShipmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryVersionCms_PageArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryVersionsCms_PagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<VersionsCms_Page_Where>;
};


export type QueryWellnessGoalArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryWellnessGoalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<WellnessGoalOrder>;
};


export type QueryZipCodeArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryZipCodeLocationArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryZipCodeLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversZipCodeLocationsResolverOrder>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type QueryZipCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversZipCodesResolverOrder>;
  salesTaxRate?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type Quote = {
  __typename?: 'Quote';
  backgroundColor?: Maybe<Quote_BackgroundColor>;
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<Quote_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  carouselQuote?: Maybe<Array<Quote_CarouselQuote>>;
  id?: Maybe<Scalars['String']>;
  quoteType?: Maybe<Quote_QuoteType>;
  staticQuote?: Maybe<Quote_StaticQuote>;
};

export type Quote_BlockSettings = {
  __typename?: 'Quote_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<Quote_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<Quote_BlockSettings_ResponsiveStyles>>;
};

export type Quote_BlockSettings_ResponsiveStyles = {
  __typename?: 'Quote_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<Quote_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<Quote_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<Quote_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum Quote_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum Quote_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum Quote_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum Quote_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type Quote_CarouselQuote = {
  __typename?: 'Quote_CarouselQuote';
  author?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pressIcons?: Maybe<Quote_CarouselQuote_PressIcons>;
  quote?: Maybe<Scalars['JSON']>;
};


export type Quote_CarouselQuoteQuoteArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export enum Quote_CarouselQuote_PressIcons {
  CbsNews = 'CbsNews',
  Forbes = 'Forbes',
  FoxNews = 'FoxNews',
  Newsday = 'Newsday',
  SharkTank = 'SharkTank'
}

export type Quote_StaticQuote = {
  __typename?: 'Quote_StaticQuote';
  author?: Maybe<Scalars['String']>;
  quote?: Maybe<Scalars['JSON']>;
  thumbnail?: Maybe<Quote_StaticQuote_Thumbnail>;
};


export type Quote_StaticQuoteQuoteArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Quote_StaticQuote_Thumbnail = {
  __typename?: 'Quote_StaticQuote_Thumbnail';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type Quote_StaticQuote_ThumbnailLgArgs = {
  where?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Where>;
};


export type Quote_StaticQuote_ThumbnailMdArgs = {
  where?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Where>;
};


export type Quote_StaticQuote_ThumbnailSmArgs = {
  where?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Where>;
};


export type Quote_StaticQuote_ThumbnailXlArgs = {
  where?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Where>;
};


export type Quote_StaticQuote_ThumbnailXsArgs = {
  where?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Where>;
};


export type Quote_StaticQuote_ThumbnailXxlArgs = {
  where?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Where>;
};


export type Quote_StaticQuote_ThumbnailXxsArgs = {
  where?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Where>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Lg_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Md_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Md_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Md_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Md_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Sm_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xl_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xs_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxl_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Where_Or>>>;
  alt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Filename_Operator>;
  filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Filesize_Operator>;
  height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Height_Operator>;
  id?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Id_Operator>;
  mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Url_Operator>;
  width?: InputMaybe<Quote_StaticQuote_Thumbnail_Xxs_Width_Operator>;
};

export type Quote_StaticQuote_Thumbnail_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export enum Quote_BackgroundColor {
  Dark = 'dark',
  Light = 'light'
}

export enum Quote_QuoteType {
  Carousel = 'carousel',
  Static = 'static'
}

export type QuotesCarousel = {
  __typename?: 'QuotesCarousel';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type RealFoodNoJunkBlock = {
  __typename?: 'RealFoodNoJunkBlock';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type RecReason = {
  __typename?: 'RecReason';
  name: Scalars['String'];
  type: Scalars['String'];
};

export type Recipe = {
  __typename?: 'Recipe';
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  meal: Meal;
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** The connection type for Recipe. */
export type RecipeConnection = {
  __typename?: 'RecipeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RecipeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Recipe>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of RecipeCreate */
export type RecipeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  recipeInput: RecipeInput;
};

/** Autogenerated return type of RecipeCreate. */
export type RecipeCreatePayload = {
  __typename?: 'RecipeCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  recipe: Recipe;
};

/** Autogenerated input type of RecipeDelete */
export type RecipeDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of RecipeDelete. */
export type RecipeDeletePayload = {
  __typename?: 'RecipeDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  recipe: Recipe;
};

/** An edge in a connection. */
export type RecipeEdge = {
  __typename?: 'RecipeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Recipe>;
};

export type RecipeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export enum RecipeOrder {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

/** Autogenerated input type of RecipeUpdate */
export type RecipeUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  recipeInput: RecipeInput;
};

/** Autogenerated return type of RecipeUpdate. */
export type RecipeUpdatePayload = {
  __typename?: 'RecipeUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  recipe: Recipe;
};

export type RecommendableProduct = {
  __typename?: 'RecommendableProduct';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  meal?: Maybe<Meal>;
  product?: Maybe<PetPlateProduct>;
  recommendableId?: Maybe<Scalars['Int']>;
  recommendableType: Scalars['String'];
  status: Scalars['String'];
  term?: Maybe<Term>;
  termId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for RecommendableProduct. */
export type RecommendableProductConnection = {
  __typename?: 'RecommendableProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RecommendableProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RecommendableProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of RecommendableProductCreate */
export type RecommendableProductCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  recommendableProductInput: RecommendableProductInput;
};

/** Autogenerated return type of RecommendableProductCreate. */
export type RecommendableProductCreatePayload = {
  __typename?: 'RecommendableProductCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  recommendableProduct: RecommendableProduct;
};

/** Autogenerated input type of RecommendableProductDelete */
export type RecommendableProductDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of RecommendableProductDelete. */
export type RecommendableProductDeletePayload = {
  __typename?: 'RecommendableProductDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  recommendableProduct: RecommendableProduct;
};

/** An edge in a connection. */
export type RecommendableProductEdge = {
  __typename?: 'RecommendableProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<RecommendableProduct>;
};

export type RecommendableProductInput = {
  recommendableId?: InputMaybe<Scalars['Int']>;
  recommendableType: TypesRecommendableProductInputTypeRecommendedType;
  status?: InputMaybe<TypesRecommendableProductInputTypeStatus>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of RecommendableProductUpdate */
export type RecommendableProductUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  recommendableProductInput: RecommendableProductInput;
};

/** Autogenerated return type of RecommendableProductUpdate. */
export type RecommendableProductUpdatePayload = {
  __typename?: 'RecommendableProductUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  recommendableProduct: RecommendableProduct;
};

export type RecommendationBoxes = {
  __typename?: 'RecommendationBoxes';
  comboBox?: Maybe<PetBox>;
  freshBakedBox?: Maybe<PetBox>;
  fullBox?: Maybe<PetBox>;
  spaceSaverBox?: Maybe<PetBox>;
  topperBox?: Maybe<PetBox>;
};

export type RecommendationWizard = {
  __typename?: 'RecommendationWizard';
  activityLevel?: Maybe<Scalars['String']>;
  attributions?: Maybe<Scalars['JSON']>;
  bakedIds: Array<Scalars['ID']>;
  birthDate?: Maybe<Scalars['ISO8601Date']>;
  breedType: Scalars['String'];
  checkoutUrl?: Maybe<Scalars['String']>;
  completed: Scalars['Boolean'];
  completedBirthDate?: Maybe<Scalars['Int']>;
  completedPlans?: Maybe<Scalars['Boolean']>;
  completedSupplements?: Maybe<Scalars['Boolean']>;
  completedTreats?: Maybe<Scalars['Boolean']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  cookedIds: Array<Scalars['ID']>;
  couponsData?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['ISO8601DateTime'];
  gender?: Maybe<Scalars['String']>;
  guestToken?: Maybe<Scalars['String']>;
  hasFoodSensitivities?: Maybe<Scalars['Boolean']>;
  hasWellnessGoals?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  ingredientIds?: Maybe<Array<Scalars['ID']>>;
  latestStep?: Maybe<Scalars['String']>;
  lineItemsData: Array<AddonLineItem>;
  oversized?: Maybe<Scalars['Boolean']>;
  /** Find a Pet its id value */
  pet: Pet;
  petId?: Maybe<Scalars['Int']>;
  petName?: Maybe<Scalars['String']>;
  /** Find a BoxVariant its id value */
  plan: BoxVariant;
  planId?: Maybe<Scalars['Int']>;
  /** Find Recommendation Wizard Recommendations by Wizard ID */
  planRecommendations?: Maybe<PlanRecommendation>;
  planType?: Maybe<RecommendationWizardPlanTypeEnum>;
  preferenceIds: Array<Scalars['ID']>;
  primaryBreedId?: Maybe<Scalars['Int']>;
  recipeIds: Array<Scalars['ID']>;
  recipeSkus?: Maybe<Array<Scalars['String']>>;
  recipes: RecipeConnection;
  recommendedAddons?: Maybe<Array<StorefrontProductListing>>;
  recommendedCaloriesPerDay?: Maybe<Scalars['Int']>;
  recommendedComboRecipes?: Maybe<Array<StorefrontProductListing>>;
  recommendedRecipeLineItems: Array<RecommendedRecipeLineItem>;
  recommendedRecipes?: Maybe<Array<StorefrontProductListing>>;
  recommendedServingSize?: Maybe<Scalars['Float']>;
  secondaryBreedId?: Maybe<Scalars['Int']>;
  selectedBreedOptions?: Maybe<Array<Maybe<Option>>>;
  selectedRecipeOptions?: Maybe<Array<Maybe<Option>>>;
  selectedWellnessGoalOptions?: Maybe<Array<Maybe<Option>>>;
  servingSizeInOunces?: Maybe<Scalars['Int']>;
  shopifyId?: Maybe<Scalars['String']>;
  spayedNeutered?: Maybe<Scalars['Boolean']>;
  subscription?: Maybe<Subscription>;
  subscriptionId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  /** Find a User its id value */
  user: User;
  userId?: Maybe<Scalars['Int']>;
  waistline?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
  wellnessGoalIds?: Maybe<Array<Scalars['ID']>>;
  wellnessGoals: WellnessGoalConnection;
};


export type RecommendationWizardPetArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type RecommendationWizardPlanArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type RecommendationWizardPlanRecommendationsArgs = {
  ignoreDisabledPlans?: InputMaybe<Scalars['Boolean']>;
  maintainLegacy?: InputMaybe<Scalars['Boolean']>;
};


export type RecommendationWizardRecipesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<RecipeOrder>;
};


export type RecommendationWizardUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type RecommendationWizardWellnessGoalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<WellnessGoalOrder>;
};

/** The connection type for RecommendationWizard. */
export type RecommendationWizardConnection = {
  __typename?: 'RecommendationWizardConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RecommendationWizardEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RecommendationWizard>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of RecommendationWizardCreate */
export type RecommendationWizardCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  recommendationWizardInput: RecommendationWizardInput;
};

/** Autogenerated return type of RecommendationWizardCreate. */
export type RecommendationWizardCreatePayload = {
  __typename?: 'RecommendationWizardCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  recommendationWizard: RecommendationWizard;
};

/** Autogenerated input type of RecommendationWizardDelete */
export type RecommendationWizardDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of RecommendationWizardDelete. */
export type RecommendationWizardDeletePayload = {
  __typename?: 'RecommendationWizardDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  recommendationWizard: RecommendationWizard;
};

/** An edge in a connection. */
export type RecommendationWizardEdge = {
  __typename?: 'RecommendationWizardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<RecommendationWizard>;
};

export type RecommendationWizardInput = {
  activityLevel?: InputMaybe<Scalars['String']>;
  attributions?: InputMaybe<Scalars['JSON']>;
  birthDate?: InputMaybe<Scalars['ISO8601Date']>;
  breedType?: InputMaybe<Scalars['String']>;
  completedBirthDate?: InputMaybe<Scalars['Int']>;
  completedPlans?: InputMaybe<Scalars['Boolean']>;
  completedSupplements?: InputMaybe<Scalars['Boolean']>;
  completedTreats?: InputMaybe<Scalars['Boolean']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  couponsData?: InputMaybe<Array<Scalars['String']>>;
  gender?: InputMaybe<Scalars['String']>;
  hasFoodSensitivities?: InputMaybe<Scalars['Boolean']>;
  hasWellnessGoals?: InputMaybe<Scalars['Boolean']>;
  ingredientIds?: InputMaybe<Array<Scalars['ID']>>;
  latestStep?: InputMaybe<Scalars['String']>;
  lineItemsData?: InputMaybe<Array<AddonLineItemInput>>;
  number?: InputMaybe<Scalars['String']>;
  numberUniqueness?: InputMaybe<Scalars['Boolean']>;
  petId?: InputMaybe<Scalars['Int']>;
  petName?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['Int']>;
  planType?: InputMaybe<RecommendationWizardPlanTypeEnum>;
  preferenceIds?: InputMaybe<Array<Scalars['ID']>>;
  primaryBreedId?: InputMaybe<Scalars['Int']>;
  recipeIds?: InputMaybe<Array<Scalars['ID']>>;
  secondaryBreedId?: InputMaybe<Scalars['Int']>;
  servingSizeInOunces?: InputMaybe<Scalars['Int']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  spayedNeutered?: InputMaybe<Scalars['Boolean']>;
  subscriptionId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
  waistline?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
  wellnessGoalIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum RecommendationWizardOrder {
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyModified = 'RECENTLY_MODIFIED'
}

export enum RecommendationWizardPlanTypeEnum {
  /** Allows selection of the fresh_baked plan */
  Baked = 'baked',
  /** Allows selection of the fresh_combo plan */
  Combo = 'combo',
  /** Allows selection of the full fresh_cooked plan */
  Full = 'full',
  /** Allows selection of the topper fresh_cooked plan */
  Topper = 'topper'
}

/** Autogenerated input type of RecommendationWizardUpdate */
export type RecommendationWizardUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  recommendationWizardInput: RecommendationWizardInput;
};

/** Autogenerated return type of RecommendationWizardUpdate. */
export type RecommendationWizardUpdatePayload = {
  __typename?: 'RecommendationWizardUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  recommendationWizard: RecommendationWizard;
};

export type RecommendedAddon = {
  __typename?: 'RecommendedAddon';
  emergencyOutOfStock: Scalars['Boolean'];
  name: Scalars['String'];
  outOfStock: Scalars['Boolean'];
  outOfStockMessage: Scalars['String'];
  position: Scalars['Int'];
  price: Scalars['String'];
  reason?: Maybe<RecReason>;
  recommendation: Scalars['Boolean'];
  shortName: Scalars['String'];
  sku: Scalars['String'];
  slug: Scalars['String'];
};

export type RecommendedRecipe = {
  __typename?: 'RecommendedRecipe';
  emergencyOutOfStock: Scalars['Boolean'];
  name: Scalars['String'];
  outOfStock: Scalars['Boolean'];
  outOfStockMessage: Scalars['String'];
  position: Scalars['Int'];
  reason?: Maybe<RecReason>;
  recommendation: Scalars['Boolean'];
  shortName: Scalars['String'];
  sku: Scalars['String'];
  slug: Scalars['String'];
  surchargeAmount: Scalars['String'];
};

export type RecommendedRecipeLineItem = {
  __typename?: 'RecommendedRecipeLineItem';
  category: MealCategoryEnum;
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  shopifyId: Scalars['String'];
  sku: Scalars['String'];
};

/** Autogenerated input type of RedeemCouponPromo */
export type RedeemCouponPromoInput = {
  addonQuantity?: InputMaybe<Scalars['Int']>;
  addonSku: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  couponCode: Scalars['String'];
  replaceCoupons?: InputMaybe<Scalars['Boolean']>;
  subscriptionId: Scalars['ID'];
};

/** Autogenerated return type of RedeemCouponPromo. */
export type RedeemCouponPromoPayload = {
  __typename?: 'RedeemCouponPromoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Referrals = {
  __typename?: 'Referrals';
  YotpoFieldOverrides?: Maybe<Referrals_YotpoFieldOverrides>;
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<Referrals_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Referrals_Image>;
  title?: Maybe<Scalars['JSON']>;
};


export type ReferralsTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Referrals_BlockSettings = {
  __typename?: 'Referrals_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<Referrals_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<Referrals_BlockSettings_ResponsiveStyles>>;
};

export type Referrals_BlockSettings_ResponsiveStyles = {
  __typename?: 'Referrals_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<Referrals_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<Referrals_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<Referrals_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum Referrals_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum Referrals_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum Referrals_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum Referrals_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type Referrals_Image = {
  __typename?: 'Referrals_Image';
  lg?: Maybe<Cms_Media>;
  md?: Maybe<Cms_Media>;
  sm?: Maybe<Cms_Media>;
  xl?: Maybe<Cms_Media>;
  xs?: Maybe<Cms_Media>;
  xxl?: Maybe<Cms_Media>;
  xxs?: Maybe<Cms_Media>;
};


export type Referrals_ImageLgArgs = {
  where?: InputMaybe<Referrals_Image_Lg_Where>;
};


export type Referrals_ImageMdArgs = {
  where?: InputMaybe<Referrals_Image_Md_Where>;
};


export type Referrals_ImageSmArgs = {
  where?: InputMaybe<Referrals_Image_Sm_Where>;
};


export type Referrals_ImageXlArgs = {
  where?: InputMaybe<Referrals_Image_Xl_Where>;
};


export type Referrals_ImageXsArgs = {
  where?: InputMaybe<Referrals_Image_Xs_Where>;
};


export type Referrals_ImageXxlArgs = {
  where?: InputMaybe<Referrals_Image_Xxl_Where>;
};


export type Referrals_ImageXxsArgs = {
  where?: InputMaybe<Referrals_Image_Xxs_Where>;
};

export type Referrals_Image_Lg_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Lg_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Lg_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Lg_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Lg_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Lg_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Lg_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Lg_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Lg_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Lg_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Lg_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Lg_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Lg_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Lg_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Lg_Where = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Lg_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Lg_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Lg_Width_Operator>;
};

export type Referrals_Image_Lg_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Lg_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Lg_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Lg_Width_Operator>;
};

export type Referrals_Image_Lg_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Lg_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Lg_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Lg_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Lg_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Lg_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Lg_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Lg_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Lg_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Lg_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Lg_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Lg_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Lg_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Lg_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Lg_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Lg_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Lg_Width_Operator>;
};

export type Referrals_Image_Lg_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Md_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Md_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Md_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Md_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Md_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Md_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Md_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Md_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Md_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Md_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Md_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Md_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Md_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Md_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Md_Where = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Md_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Md_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Md_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Md_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Md_Width_Operator>;
};

export type Referrals_Image_Md_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Md_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Md_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Md_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Md_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Md_Width_Operator>;
};

export type Referrals_Image_Md_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Md_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Md_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Md_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Md_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Md_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Md_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Md_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Md_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Md_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Md_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Md_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Md_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Md_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Md_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Md_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Md_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Md_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Md_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Md_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Md_Width_Operator>;
};

export type Referrals_Image_Md_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Sm_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Sm_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Sm_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Sm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Sm_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Sm_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Sm_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Sm_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Sm_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Sm_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Sm_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Sm_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Sm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Sm_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Sm_Where = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Sm_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Sm_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Sm_Width_Operator>;
};

export type Referrals_Image_Sm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Sm_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Sm_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Sm_Width_Operator>;
};

export type Referrals_Image_Sm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Sm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Sm_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Sm_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Sm_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Sm_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Sm_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Sm_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Sm_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Sm_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Sm_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Sm_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Sm_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Sm_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Sm_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Sm_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Sm_Width_Operator>;
};

export type Referrals_Image_Sm_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Xl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Xl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xl_Where = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Xl_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Xl_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Xl_Width_Operator>;
};

export type Referrals_Image_Xl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Xl_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Xl_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Xl_Width_Operator>;
};

export type Referrals_Image_Xl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Xl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Xl_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Xl_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Xl_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Xl_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Xl_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Xl_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Xl_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Xl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Xl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Xl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Xl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Xl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Xl_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Xl_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Xl_Width_Operator>;
};

export type Referrals_Image_Xl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Xs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Xs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xs_Where = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Xs_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Xs_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Xs_Width_Operator>;
};

export type Referrals_Image_Xs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Xs_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Xs_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Xs_Width_Operator>;
};

export type Referrals_Image_Xs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Xs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Xs_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Xs_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Xs_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Xs_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Xs_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Xs_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Xs_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Xs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Xs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Xs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Xs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Xs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Xs_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Xs_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Xs_Width_Operator>;
};

export type Referrals_Image_Xs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxl_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Xxl_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxl_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxl_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxl_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxl_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxl_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxl_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxl_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxl_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxl_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxl_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxl_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Xxl_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxl_Where = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Xxl_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Xxl_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Xxl_Width_Operator>;
};

export type Referrals_Image_Xxl_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Xxl_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Xxl_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Xxl_Width_Operator>;
};

export type Referrals_Image_Xxl_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Xxl_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Xxl_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Xxl_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Xxl_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Xxl_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Xxl_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Xxl_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Xxl_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Xxl_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Xxl_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Xxl_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Xxl_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Xxl_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Xxl_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Xxl_Width_Operator>;
};

export type Referrals_Image_Xxl_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxs_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Xxs_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxs_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxs_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxs_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxs_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxs_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxs_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxs_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxs_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxs_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxs_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_Image_Xxs_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Referrals_Image_Xxs_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Referrals_Image_Xxs_Where = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Xxs_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Xxs_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Xxs_Width_Operator>;
};

export type Referrals_Image_Xxs_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Xxs_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Xxs_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Xxs_Width_Operator>;
};

export type Referrals_Image_Xxs_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Referrals_Image_Xxs_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Referrals_Image_Xxs_Where_Or>>>;
  alt?: InputMaybe<Referrals_Image_Xxs_Alt_Operator>;
  createdAt?: InputMaybe<Referrals_Image_Xxs_CreatedAt_Operator>;
  filename?: InputMaybe<Referrals_Image_Xxs_Filename_Operator>;
  filesize?: InputMaybe<Referrals_Image_Xxs_Filesize_Operator>;
  height?: InputMaybe<Referrals_Image_Xxs_Height_Operator>;
  id?: InputMaybe<Referrals_Image_Xxs_Id_Operator>;
  mimeType?: InputMaybe<Referrals_Image_Xxs_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Referrals_Image_Xxs_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<Referrals_Image_Xxs_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Referrals_Image_Xxs_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<Referrals_Image_Xxs_UpdatedAt_Operator>;
  url?: InputMaybe<Referrals_Image_Xxs_Url_Operator>;
  width?: InputMaybe<Referrals_Image_Xxs_Width_Operator>;
};

export type Referrals_Image_Xxs_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Referrals_YotpoFieldOverrides = {
  __typename?: 'Referrals_YotpoFieldOverrides';
  disclaimerBottomText?: Maybe<Scalars['JSON']>;
};


export type Referrals_YotpoFieldOverridesDisclaimerBottomTextArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Refund = {
  __typename?: 'Refund';
  amount?: Maybe<Scalars['Float']>;
  apiRefundId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['ID']>;
  invoiceError?: Maybe<Scalars['String']>;
  invoiceTransactionCode?: Maybe<Scalars['String']>;
  invoicedAt?: Maybe<Scalars['ISO8601DateTime']>;
  paymentGatewayProvider?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['Int']>;
  reason?: Maybe<Term>;
  reasonId?: Maybe<Scalars['Int']>;
  refundReason?: Maybe<Scalars['String']>;
  refundedById?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum RefundSource {
  /** Box changed */
  BoxChanged = 'box_changed',
  /** Quantities changed */
  QuantitiesChanged = 'quantities_changed',
  /** System refund */
  SystemRefund = 'system_refund',
  /** Unspecified */
  Unspecified = 'unspecified'
}

export type RemoteContract = {
  __typename?: 'RemoteContract';
  appAdminUrl?: Maybe<Scalars['String']>;
  billingAttempts?: Maybe<ShopifyBillingAttemptsEdge>;
  customer?: Maybe<ShopifyContractCustomer>;
  customerPaymentMethod?: Maybe<ShopifyCustomerPaymentMethod>;
  deliveryMethod?: Maybe<ShopifyDeliveryMethod>;
  discounts?: Maybe<ShopifyDiscountsEdge>;
  id?: Maybe<Scalars['String']>;
  lines?: Maybe<ShopifyLineEdge>;
  status?: Maybe<Scalars['String']>;
};

export type ReportDownload = {
  __typename?: 'ReportDownload';
  url: Scalars['String'];
};

export type ReportJob = {
  __typename?: 'ReportJob';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  emails?: Maybe<Scalars['String']>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  exportedUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  paperclipLogContentType?: Maybe<Scalars['String']>;
  paperclipLogFileName?: Maybe<Scalars['String']>;
  paperclipLogFileSize?: Maybe<Scalars['Int']>;
  paperclipLogUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  paperclipOutputContentType?: Maybe<Scalars['String']>;
  paperclipOutputFileName?: Maybe<Scalars['String']>;
  paperclipOutputFileSize?: Maybe<Scalars['Int']>;
  paperclipOutputUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  state?: Maybe<Scalars['String']>;
  stats?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  user?: Maybe<User>;
};

/** The connection type for ReportJob. */
export type ReportJobConnection = {
  __typename?: 'ReportJobConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReportJobEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ReportJob>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of ReportJobCreate */
export type ReportJobCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  reportJobInput: ReportJobInput;
};

/** Autogenerated return type of ReportJobCreate. */
export type ReportJobCreatePayload = {
  __typename?: 'ReportJobCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  reportJob: ReportJob;
};

/** Autogenerated input type of ReportJobDelete */
export type ReportJobDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ReportJobDelete. */
export type ReportJobDeletePayload = {
  __typename?: 'ReportJobDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  reportJob: ReportJob;
};

/** An edge in a connection. */
export type ReportJobEdge = {
  __typename?: 'ReportJobEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ReportJob>;
};

export type ReportJobInput = {
  duration?: InputMaybe<Scalars['Int']>;
  emails?: InputMaybe<Scalars['String']>;
  endedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  paperclipLogContentType?: InputMaybe<Scalars['String']>;
  paperclipLogFileName?: InputMaybe<Scalars['String']>;
  paperclipLogFileSize?: InputMaybe<Scalars['Int']>;
  paperclipLogUpdatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  paperclipOutputContentType?: InputMaybe<Scalars['String']>;
  paperclipOutputFileName?: InputMaybe<Scalars['String']>;
  paperclipOutputFileSize?: InputMaybe<Scalars['Int']>;
  paperclipOutputUpdatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  startedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  state?: InputMaybe<TypesReportJobInputTypeState>;
  stats: Scalars['JSON'];
  userId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of ReportJobUpdate */
export type ReportJobUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  reportJobInput: ReportJobInput;
};

/** Autogenerated return type of ReportJobUpdate. */
export type ReportJobUpdatePayload = {
  __typename?: 'ReportJobUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  reportJob: ReportJob;
};

export type RescheduleDates = {
  __typename?: 'RescheduleDates';
  deliveryDate?: Maybe<Scalars['ISO8601Date']>;
  shippingDate?: Maybe<Scalars['ISO8601Date']>;
};

export enum ResolversBoxVariantsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversBoxesResolverOrder {
  BagQuantityAsc = 'BAG_QUANTITY_ASC',
  BagQuantityDesc = 'BAG_QUANTITY_DESC',
  BagVolumeAsc = 'BAG_VOLUME_ASC',
  BagVolumeDesc = 'BAG_VOLUME_DESC',
  BagWeightAsc = 'BAG_WEIGHT_ASC',
  BagWeightDesc = 'BAG_WEIGHT_DESC',
  ItemQuantityAsc = 'ITEM_QUANTITY_ASC',
  ItemQuantityDesc = 'ITEM_QUANTITY_DESC',
  ItemVolumeAsc = 'ITEM_VOLUME_ASC',
  ItemVolumeDesc = 'ITEM_VOLUME_DESC',
  ItemWeightAsc = 'ITEM_WEIGHT_ASC',
  ItemWeightDesc = 'ITEM_WEIGHT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum ResolversBreedsResolverOrder {
  ActivityLevelAsc = 'ACTIVITY_LEVEL_ASC',
  ActivityLevelDesc = 'ACTIVITY_LEVEL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  SizeClassAsc = 'SIZE_CLASS_ASC',
  SizeClassDesc = 'SIZE_CLASS_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC'
}

export enum ResolversCalorieMultipliersResolverOrder {
  ActivityLevelAsc = 'ACTIVITY_LEVEL_ASC',
  ActivityLevelDesc = 'ACTIVITY_LEVEL_DESC',
  AgeAsc = 'AGE_ASC',
  AgeDesc = 'AGE_DESC',
  BodyConditionAsc = 'BODY_CONDITION_ASC',
  BodyConditionDesc = 'BODY_CONDITION_DESC',
  MultiplierAsc = 'MULTIPLIER_ASC',
  MultiplierDesc = 'MULTIPLIER_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversCancellationSurveysResolverOrder {
  BudgetGradeAsc = 'BUDGET_GRADE_ASC',
  BudgetGradeDesc = 'BUDGET_GRADE_DESC',
  BudgetTopperAsc = 'BUDGET_TOPPER_ASC',
  BudgetTopperDesc = 'BUDGET_TOPPER_DESC',
  BudgetWorthAsc = 'BUDGET_WORTH_ASC',
  BudgetWorthDesc = 'BUDGET_WORTH_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversConversionSurveysResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversCouponsResolverOrder {
  AmountOffAsc = 'AMOUNT_OFF_ASC',
  AmountOffDesc = 'AMOUNT_OFF_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  PercentOffAsc = 'PERCENT_OFF_ASC',
  PercentOffDesc = 'PERCENT_OFF_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversDbOrdersResolverChannel {
  ViaAdministration = 'via_administration',
  ViaAmazonOrder = 'via_amazon_order',
  ViaChewyOrder = 'via_chewy_order',
  ViaExpressCheckout = 'via_express_checkout',
  ViaPurchaseOrder = 'via_purchase_order',
  ViaSampleOrder = 'via_sample_order',
  ViaSubscriptionCheckout = 'via_subscription_checkout'
}

export enum ResolversDbOrdersResolverOpsState {
  AlertUnavailableShippingDate = 'alert_unavailable_shipping_date',
  Renewal = 'renewal',
  Standalone = 'standalone',
  WithActiveCharge = 'with_active_charge',
  WithFailedCharge = 'with_failed_charge'
}

export enum ResolversDbOrdersResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversFulfillmentScheduleRulesResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  RouteCodeAsc = 'ROUTE_CODE_ASC',
  RouteCodeDesc = 'ROUTE_CODE_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC'
}

export enum ResolversImportJobsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  MessageAsc = 'MESSAGE_ASC',
  MessageDesc = 'MESSAGE_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ResolversLineItemFieldValuesResolverValues = {
  __typename?: 'ResolversLineItemFieldValuesResolverValues';
  collection: Array<ResolversLineItemFieldValuesResolverValuesCollection>;
  name: Scalars['String'];
  type: ResolversLineItemFieldValuesResolverValuesType;
};

export type ResolversLineItemFieldValuesResolverValuesCollection = {
  __typename?: 'ResolversLineItemFieldValuesResolverValuesCollection';
  label: Scalars['String'];
  value: Scalars['String'];
};

export enum ResolversLineItemFieldValuesResolverValuesType {
  Boolean = 'Boolean',
  Date = 'Date',
  Float = 'Float',
  Integer = 'Integer',
  String = 'String'
}

export enum ResolversLineItemRuleSetsResolverOrder {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  ConflictStrategyAsc = 'CONFLICT_STRATEGY_ASC',
  ConflictStrategyDesc = 'CONFLICT_STRATEGY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LimitAsc = 'LIMIT_ASC',
  LimitDesc = 'LIMIT_DESC',
  LimitStrategyAsc = 'LIMIT_STRATEGY_ASC',
  LimitStrategyDesc = 'LIMIT_STRATEGY_DESC',
  LineItemDiscountAsc = 'LINE_ITEM_DISCOUNT_ASC',
  LineItemDiscountDesc = 'LINE_ITEM_DISCOUNT_DESC',
  LineItemNameAsc = 'LINE_ITEM_NAME_ASC',
  LineItemNameDesc = 'LINE_ITEM_NAME_DESC',
  LineItemOutOfStockAsc = 'LINE_ITEM_OUT_OF_STOCK_ASC',
  LineItemOutOfStockDesc = 'LINE_ITEM_OUT_OF_STOCK_DESC',
  LineItemPriceAsc = 'LINE_ITEM_PRICE_ASC',
  LineItemPriceDesc = 'LINE_ITEM_PRICE_DESC',
  LineItemQuantityAsc = 'LINE_ITEM_QUANTITY_ASC',
  LineItemQuantityDesc = 'LINE_ITEM_QUANTITY_DESC',
  LineItemReplaceSkuAsc = 'LINE_ITEM_REPLACE_SKU_ASC',
  LineItemReplaceSkuDesc = 'LINE_ITEM_REPLACE_SKU_DESC',
  LineItemSkuAsc = 'LINE_ITEM_SKU_ASC',
  LineItemSkuDesc = 'LINE_ITEM_SKU_DESC',
  LineItemTypeAsc = 'LINE_ITEM_TYPE_ASC',
  LineItemTypeDesc = 'LINE_ITEM_TYPE_DESC',
  MergeCostStrategyAsc = 'MERGE_COST_STRATEGY_ASC',
  MergeCostStrategyDesc = 'MERGE_COST_STRATEGY_DESC',
  MergeNameStrategyAsc = 'MERGE_NAME_STRATEGY_ASC',
  MergeNameStrategyDesc = 'MERGE_NAME_STRATEGY_DESC',
  MergeQuantityStrategyAsc = 'MERGE_QUANTITY_STRATEGY_ASC',
  MergeQuantityStrategyDesc = 'MERGE_QUANTITY_STRATEGY_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversLineItemRulesResolverOrder {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversLogEventsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EventAsc = 'EVENT_ASC',
  EventDesc = 'EVENT_DESC',
  SourceTypeAsc = 'SOURCE_TYPE_ASC',
  SourceTypeDesc = 'SOURCE_TYPE_DESC',
  TargetTypeAsc = 'TARGET_TYPE_ASC',
  TargetTypeDesc = 'TARGET_TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversMealsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  SkuAsc = 'SKU_ASC',
  SkuDesc = 'SKU_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC'
}

export enum ResolversNotificationBannersResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  RelevantDelayDateAsc = 'RELEVANT_DELAY_DATE_ASC',
  RelevantDelayDateDesc = 'RELEVANT_DELAY_DATE_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC'
}

export enum ResolversOrderImportBatchEntriesResolverOrder {
  ActionAsc = 'ACTION_ASC',
  ActionDesc = 'ACTION_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversOrderImportBatchesResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndedAtAsc = 'ENDED_AT_ASC',
  EndedAtDesc = 'ENDED_AT_DESC',
  EntriesCountAsc = 'ENTRIES_COUNT_ASC',
  EntriesCountDesc = 'ENTRIES_COUNT_DESC',
  FailedCountAsc = 'FAILED_COUNT_ASC',
  FailedCountDesc = 'FAILED_COUNT_DESC',
  FromDateAsc = 'FROM_DATE_ASC',
  FromDateDesc = 'FROM_DATE_DESC',
  PendingCountAsc = 'PENDING_COUNT_ASC',
  PendingCountDesc = 'PENDING_COUNT_DESC',
  SkippedCountAsc = 'SKIPPED_COUNT_ASC',
  SkippedCountDesc = 'SKIPPED_COUNT_DESC',
  StartedAtAsc = 'STARTED_AT_ASC',
  StartedAtDesc = 'STARTED_AT_DESC',
  SuccessCountAsc = 'SUCCESS_COUNT_ASC',
  SuccessCountDesc = 'SUCCESS_COUNT_DESC',
  UntilDateAsc = 'UNTIL_DATE_ASC',
  UntilDateDesc = 'UNTIL_DATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversPackagingsResolverOrder {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum ResolversPauseSurveysResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversPaymentBatchEntriesResolverOpsState {
  Charged = 'charged',
  Failed = 'failed'
}

export enum ResolversPaymentBatchEntriesResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndedAtAsc = 'ENDED_AT_ASC',
  EndedAtDesc = 'ENDED_AT_DESC',
  StartedAtAsc = 'STARTED_AT_ASC',
  StartedAtDesc = 'STARTED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversPaymentBatchesResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndedAtAsc = 'ENDED_AT_ASC',
  EndedAtDesc = 'ENDED_AT_DESC',
  StartedAtAsc = 'STARTED_AT_ASC',
  StartedAtDesc = 'STARTED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversPaymentMethodsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversPetPlateProductsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  SkuAsc = 'SKU_ASC',
  SkuDesc = 'SKU_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC'
}

export enum ResolversPetsResolverOrder {
  AgeGroupAsc = 'AGE_GROUP_ASC',
  AgeGroupDesc = 'AGE_GROUP_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversPlanCompatibilityCriteriaResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DisplayOrderAsc = 'DISPLAY_ORDER_ASC',
  DisplayOrderDesc = 'DISPLAY_ORDER_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ScoreBakedAsc = 'SCORE_BAKED_ASC',
  ScoreBakedDesc = 'SCORE_BAKED_DESC',
  ScoreComboAsc = 'SCORE_COMBO_ASC',
  ScoreComboDesc = 'SCORE_COMBO_DESC',
  ScoreFullAsc = 'SCORE_FULL_ASC',
  ScoreFullDesc = 'SCORE_FULL_DESC',
  ScoreTopperAsc = 'SCORE_TOPPER_ASC',
  ScoreTopperDesc = 'SCORE_TOPPER_DESC',
  WeightAsc = 'WEIGHT_ASC',
  WeightDesc = 'WEIGHT_DESC'
}

export enum ResolversPlanMatchCriteriaResolverOrder {
  AgeGroupAsc = 'AGE_GROUP_ASC',
  AgeGroupDesc = 'AGE_GROUP_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversPpCommentsResolverOrder {
  BodyAsc = 'BODY_ASC',
  BodyDesc = 'BODY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NamespaceAsc = 'NAMESPACE_ASC',
  NamespaceDesc = 'NAMESPACE_DESC',
  ResourceTypeAsc = 'RESOURCE_TYPE_ASC',
  ResourceTypeDesc = 'RESOURCE_TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversPpPaymentsResolverOrder {
  ChargedAtAsc = 'CHARGED_AT_ASC',
  ChargedAtDesc = 'CHARGED_AT_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NumberAsc = 'NUMBER_ASC',
  NumberDesc = 'NUMBER_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC'
}

export enum ResolversRecommendableProductsResolverOrder {
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export enum ResolversReportJobsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversRouteScheduleUploadsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversRouteSchedulesResolverOrder {
  CarrierCodeAsc = 'CARRIER_CODE_ASC',
  CarrierCodeDesc = 'CARRIER_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  RouteCodeAsc = 'ROUTE_CODE_ASC',
  RouteCodeDesc = 'ROUTE_CODE_DESC',
  ScheduleStartDateAsc = 'SCHEDULE_START_DATE_ASC',
  ScheduleStartDateDesc = 'SCHEDULE_START_DATE_DESC',
  TransitRegionCodeAsc = 'TRANSIT_REGION_CODE_ASC',
  TransitRegionCodeDesc = 'TRANSIT_REGION_CODE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC'
}

export enum ResolversShipmentEntriesResolverOpsState {
  Batched = 'batched',
  ImportedManually = 'imported_manually',
  Preparing = 'preparing',
  Voided = 'voided',
  WithoutDepartedFc = 'without_departed_fc'
}

export enum ResolversShipmentEntriesResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DaysInTransitAsc = 'DAYS_IN_TRANSIT_ASC',
  DaysInTransitDesc = 'DAYS_IN_TRANSIT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  ShippedAtAsc = 'SHIPPED_AT_ASC',
  ShippedAtDesc = 'SHIPPED_AT_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  TransitRegionCodeAsc = 'TRANSIT_REGION_CODE_ASC',
  TransitRegionCodeDesc = 'TRANSIT_REGION_CODE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

export enum ResolversShipmentListsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ShippedAtAsc = 'SHIPPED_AT_ASC',
  ShippedAtDesc = 'SHIPPED_AT_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversShipmentUpdatesUploadsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ResolversShopifyCouponsResolverInput = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  title: Scalars['String'];
};

export enum ResolversSizeClassesResolverOrder {
  AgeOfMaturityAsc = 'AGE_OF_MATURITY_ASC',
  AgeOfMaturityDesc = 'AGE_OF_MATURITY_DESC',
  AgeOfSeniorityAsc = 'AGE_OF_SENIORITY_ASC',
  AgeOfSeniorityDesc = 'AGE_OF_SENIORITY_DESC',
  LifeExpectancyAsc = 'LIFE_EXPECTANCY_ASC',
  LifeExpectancyDesc = 'LIFE_EXPECTANCY_DESC',
  MaxWeightAsc = 'MAX_WEIGHT_ASC',
  MaxWeightDesc = 'MAX_WEIGHT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum ResolversStateChangesResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversStoreCreditAccountsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NumberAsc = 'NUMBER_ASC',
  NumberDesc = 'NUMBER_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversStoreCreditMovementsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversSubscriptionsResolverOpsState {
  NewlyCreated = 'newly_created',
  ReportRepeat = 'report_repeat',
  WithUnavailableShippingDate = 'with_unavailable_shipping_date'
}

export enum ResolversSubscriptionsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NumberAsc = 'NUMBER_ASC',
  NumberDesc = 'NUMBER_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ResolversTermsResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ResolversTransitWarehousesResolverWarehouse = {
  __typename?: 'ResolversTransitWarehousesResolverWarehouse';
  transits: Array<ResolversTransitWarehousesResolverWarehouseTransit>;
  warehouseCode: Scalars['String'];
};

export type ResolversTransitWarehousesResolverWarehouseTransit = {
  __typename?: 'ResolversTransitWarehousesResolverWarehouseTransit';
  id: Scalars['Int'];
  transitCode: Scalars['String'];
};

export enum ResolversUsersResolverOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC'
}

export enum ResolversZipCodeLocationsResolverOrder {
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC'
}

export enum ResolversZipCodesResolverOrder {
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  SalesTaxRateAsc = 'SALES_TAX_RATE_ASC',
  SalesTaxRateDesc = 'SALES_TAX_RATE_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC'
}

export type RetailPrice = {
  __typename?: 'RetailPrice';
  accountId: Scalars['Int'];
  boxWeightClass: Scalars['Float'];
  id: Scalars['ID'];
  price?: Maybe<Scalars['Float']>;
  product: PetPlateProduct;
};

/** The connection type for RetailPrice. */
export type RetailPriceConnection = {
  __typename?: 'RetailPriceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RetailPriceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RetailPrice>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of RetailPriceCreate */
export type RetailPriceCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  retailPriceInput: RetailPriceInput;
};

/** Autogenerated return type of RetailPriceCreate. */
export type RetailPriceCreatePayload = {
  __typename?: 'RetailPriceCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  retailPrice: RetailPrice;
};

/** Autogenerated input type of RetailPriceDelete */
export type RetailPriceDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of RetailPriceDelete. */
export type RetailPriceDeletePayload = {
  __typename?: 'RetailPriceDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  retailPrice: RetailPrice;
};

/** An edge in a connection. */
export type RetailPriceEdge = {
  __typename?: 'RetailPriceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<RetailPrice>;
};

export type RetailPriceInput = {
  accountId?: InputMaybe<Scalars['Int']>;
  boxWeightClass?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['Int']>;
};

export enum RetailPriceOrder {
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyModified = 'RECENTLY_MODIFIED'
}

/** Autogenerated input type of RetailPriceUpdate */
export type RetailPriceUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  retailPriceInput: RetailPriceInput;
};

/** Autogenerated return type of RetailPriceUpdate. */
export type RetailPriceUpdatePayload = {
  __typename?: 'RetailPriceUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  retailPrice: RetailPrice;
};

export type ReviewsList = {
  __typename?: 'ReviewsList';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<ReviewsList_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['JSON']>;
};


export type ReviewsListTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type ReviewsList_BlockSettings = {
  __typename?: 'ReviewsList_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<ReviewsList_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<ReviewsList_BlockSettings_ResponsiveStyles>>;
};

export type ReviewsList_BlockSettings_ResponsiveStyles = {
  __typename?: 'ReviewsList_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<ReviewsList_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<ReviewsList_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<ReviewsList_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum ReviewsList_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum ReviewsList_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ReviewsList_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ReviewsList_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type Role = {
  __typename?: 'Role';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum RouteCode {
  Amazon = 'amazon',
  Chewy = 'chewy',
  Dry = 'dry',
  Refrigerated = 'refrigerated'
}

export type RouteSchedule = {
  __typename?: 'RouteSchedule';
  carrier?: Maybe<Scalars['String']>;
  carrierCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  deliveryDays?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  includeDryIce: Scalars['Boolean'];
  routeCode: TypesRouteScheduleTypeRouteCode;
  scheduleData?: Maybe<Scalars['JSON']>;
  scheduleStartDate: Scalars['ISO8601Date'];
  serviced?: Maybe<Scalars['Boolean']>;
  shippingStartDate: Scalars['ISO8601Date'];
  transitRegion?: Maybe<Scalars['String']>;
  transitRegionCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  warehouseCode?: Maybe<Scalars['String']>;
  warehouseName?: Maybe<Scalars['String']>;
  warehouseZipCode?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

/** The connection type for RouteSchedule. */
export type RouteScheduleConnection = {
  __typename?: 'RouteScheduleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RouteScheduleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RouteSchedule>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of RouteScheduleCreate */
export type RouteScheduleCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  routeScheduleInput: RouteScheduleInput;
};

/** Autogenerated return type of RouteScheduleCreate. */
export type RouteScheduleCreatePayload = {
  __typename?: 'RouteScheduleCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  routeSchedule: RouteSchedule;
};

/** Autogenerated input type of RouteScheduleDelete */
export type RouteScheduleDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of RouteScheduleDelete. */
export type RouteScheduleDeletePayload = {
  __typename?: 'RouteScheduleDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  routeSchedule: RouteSchedule;
};

/** An edge in a connection. */
export type RouteScheduleEdge = {
  __typename?: 'RouteScheduleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<RouteSchedule>;
};

export type RouteScheduleInput = {
  carrier?: InputMaybe<Scalars['String']>;
  carrierCode?: InputMaybe<Scalars['String']>;
  deliveryDays?: InputMaybe<Scalars['Int']>;
  includeDryIce?: InputMaybe<Scalars['Boolean']>;
  routeCode?: InputMaybe<Scalars['String']>;
  scheduleData?: InputMaybe<Scalars['JSON']>;
  scheduleStartDate?: InputMaybe<Scalars['ISO8601Date']>;
  serviced?: InputMaybe<Scalars['Boolean']>;
  shippingStartDate?: InputMaybe<Scalars['ISO8601Date']>;
  transitRegion?: InputMaybe<Scalars['String']>;
  transitRegionCode?: InputMaybe<Scalars['String']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
  warehouseName?: InputMaybe<Scalars['String']>;
  warehouseZipCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of RouteScheduleUpdate */
export type RouteScheduleUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  routeScheduleInput: RouteScheduleInput;
};

/** Autogenerated return type of RouteScheduleUpdate. */
export type RouteScheduleUpdatePayload = {
  __typename?: 'RouteScheduleUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  routeSchedule: RouteSchedule;
};

export type RouteScheduleUpload = {
  __typename?: 'RouteScheduleUpload';
  createdAt: Scalars['ISO8601DateTime'];
  downloadFileLink?: Maybe<Scalars['String']>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  error?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  numberProcessedRoutes?: Maybe<Scalars['Int']>;
  routeType: TypesRouteScheduleTypeRouteCode;
  s3Path: Scalars['String'];
  state: TypesRouteScheduleUploadTypeState;
  updatedAt: Scalars['ISO8601DateTime'];
  zipCodesCreated?: Maybe<Scalars['Int']>;
};

/** The connection type for RouteScheduleUpload. */
export type RouteScheduleUploadConnection = {
  __typename?: 'RouteScheduleUploadConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RouteScheduleUploadEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RouteScheduleUpload>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** An edge in a connection. */
export type RouteScheduleUploadEdge = {
  __typename?: 'RouteScheduleUploadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<RouteScheduleUpload>;
};

export type SectionHeader = {
  __typename?: 'SectionHeader';
  alignment?: Maybe<SectionHeader_Alignment>;
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<SectionHeader_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  button?: Maybe<Array<SectionHeader_Button>>;
  description?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['JSON']>;
};


export type SectionHeaderDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type SectionHeaderTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type SectionHeader_BlockSettings = {
  __typename?: 'SectionHeader_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<SectionHeader_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<SectionHeader_BlockSettings_ResponsiveStyles>>;
};

export type SectionHeader_BlockSettings_ResponsiveStyles = {
  __typename?: 'SectionHeader_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<SectionHeader_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<SectionHeader_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<SectionHeader_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum SectionHeader_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum SectionHeader_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum SectionHeader_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum SectionHeader_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type SectionHeader_Button = {
  __typename?: 'SectionHeader_Button';
  button?: Maybe<SectionHeader_Button_Button>;
  id?: Maybe<Scalars['String']>;
};

export type SectionHeader_Button_Button = {
  __typename?: 'SectionHeader_Button_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<SectionHeader_Button_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<SectionHeader_Button_Button_Variant>;
};

export type SectionHeader_Button_Button_Link = {
  __typename?: 'SectionHeader_Button_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<SectionHeader_Button_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum SectionHeader_Button_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum SectionHeader_Button_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Text = 'text'
}

export enum SectionHeader_Alignment {
  Center = 'center',
  Left = 'left'
}

/** Autogenerated input type of SendAccountActivationEmail */
export type SendAccountActivationEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  subscriptionId: Scalars['String'];
};

/** Autogenerated return type of SendAccountActivationEmail. */
export type SendAccountActivationEmailPayload = {
  __typename?: 'SendAccountActivationEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subscription: Subscription;
};

export type Setting = {
  __typename?: 'Setting';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  thingId?: Maybe<Scalars['ID']>;
  thingType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  value: Scalars['String'];
  var: Scalars['String'];
};

/** Autogenerated input type of SettingDelete */
export type SettingDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

/** Autogenerated return type of SettingDelete. */
export type SettingDeletePayload = {
  __typename?: 'SettingDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

/** Represents a platform setting */
export type SettingPolymorphic = Coupon | Setting;

export type SettingsSearchResult = {
  __typename?: 'SettingsSearchResult';
  key: Scalars['String'];
  value?: Maybe<SettingPolymorphic>;
};

/** Autogenerated input type of SettingsUpdate */
export type SettingsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  settings: Array<KeyValueInput>;
};

/** Autogenerated return type of SettingsUpdate. */
export type SettingsUpdatePayload = {
  __typename?: 'SettingsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type ShipmentChange = {
  key: Scalars['String'];
  originalValue: Scalars['String'];
  value: Scalars['String'];
};

export type ShipmentChangeInput = {
  changes: Array<ShipmentChange>;
  itemSku: Scalars['String'];
  shipmentId: Scalars['String'];
};

export type ShipmentEntry = {
  __typename?: 'ShipmentEntry';
  addressData?: Maybe<Scalars['JSON']>;
  addressStateAbbr?: Maybe<Scalars['String']>;
  addressZipCode?: Maybe<Scalars['String']>;
  asnSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  box?: Maybe<Box>;
  boxVariant?: Maybe<BoxVariant>;
  carrierCode?: Maybe<Scalars['String']>;
  carrierService?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  data?: Maybe<Scalars['JSON']>;
  daysInTransit?: Maybe<Scalars['Int']>;
  deliveryDate?: Maybe<Scalars['ISO8601Date']>;
  email?: Maybe<Scalars['String']>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  index: Scalars['Int'];
  insertImageUrl?: Maybe<Scalars['String']>;
  klaviyoTrackError?: Maybe<Scalars['String']>;
  lineItemsData?: Maybe<Scalars['JSON']>;
  orderStatus?: Maybe<Scalars['String']>;
  packaging?: Maybe<Packaging>;
  payment?: Maybe<PpPayment>;
  pet?: Maybe<Pet>;
  planFrequency?: Maybe<Scalars['Int']>;
  renewals?: Maybe<Scalars['Int']>;
  requiresAsnSend: Scalars['Boolean'];
  routeCode?: Maybe<Scalars['String']>;
  scheduledShippingDate?: Maybe<Scalars['ISO8601Date']>;
  shipmentList?: Maybe<ShipmentList>;
  shipmentListId?: Maybe<Scalars['Int']>;
  shipmentNumber?: Maybe<Scalars['String']>;
  shippedAt?: Maybe<Scalars['ISO8601Date']>;
  shippingAddress?: Maybe<Address>;
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  state?: Maybe<TypesShipmentEntryStateEnumType>;
  subscription?: Maybe<Subscription>;
  subscriptionStatus?: Maybe<Scalars['String']>;
  trackedOnKlaviyoAt?: Maybe<Scalars['ISO8601DateTime']>;
  trackingLink?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingRecord?: Maybe<ShipmentListsV2Order>;
  trackingStatus?: Maybe<Scalars['String']>;
  transitRegionCode?: Maybe<Scalars['String']>;
  undigitalInsertError?: Maybe<Scalars['String']>;
  undigitalInsertedAt?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt: Scalars['ISO8601DateTime'];
  user?: Maybe<User>;
  v2Order?: Maybe<DbOrder>;
  warehouseCode?: Maybe<Scalars['String']>;
};

/** The connection type for ShipmentEntry. */
export type ShipmentEntryConnection = {
  __typename?: 'ShipmentEntryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShipmentEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ShipmentEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of ShipmentEntryCreate */
export type ShipmentEntryCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shipmentEntryInput: ShipmentEntryInput;
};

/** Autogenerated return type of ShipmentEntryCreate. */
export type ShipmentEntryCreatePayload = {
  __typename?: 'ShipmentEntryCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shipmentEntry: ShipmentEntry;
};

/** Autogenerated input type of ShipmentEntryDelete */
export type ShipmentEntryDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ShipmentEntryDelete. */
export type ShipmentEntryDeletePayload = {
  __typename?: 'ShipmentEntryDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shipmentEntry: ShipmentEntry;
};

/** An edge in a connection. */
export type ShipmentEntryEdge = {
  __typename?: 'ShipmentEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ShipmentEntry>;
};

export type ShipmentEntryInput = {
  addressData?: InputMaybe<Scalars['JSON']>;
  addressStateAbbr?: InputMaybe<Scalars['String']>;
  addressZipCode?: InputMaybe<Scalars['String']>;
  asnSentAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  boxId?: InputMaybe<Scalars['Int']>;
  carrierCode?: InputMaybe<Scalars['String']>;
  carrierService?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['JSON']>;
  daysInTransit?: InputMaybe<Scalars['Int']>;
  departedFcAt?: InputMaybe<Scalars['ISO8601Date']>;
  email?: InputMaybe<Scalars['String']>;
  index?: InputMaybe<Scalars['Int']>;
  lineItemsData?: InputMaybe<Scalars['JSON']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  packagingId?: InputMaybe<Scalars['Int']>;
  paymentId?: InputMaybe<Scalars['Int']>;
  petId?: InputMaybe<Scalars['Int']>;
  planFrequency?: InputMaybe<Scalars['Int']>;
  planId?: InputMaybe<Scalars['Int']>;
  renewals?: InputMaybe<Scalars['Int']>;
  requiresAsnSend?: InputMaybe<Scalars['Boolean']>;
  routeCode?: InputMaybe<Scalars['String']>;
  scheduledShippingDate?: InputMaybe<Scalars['ISO8601Date']>;
  shipmentId?: InputMaybe<Scalars['Int']>;
  shipmentNumber?: InputMaybe<Scalars['String']>;
  shippedAt?: InputMaybe<Scalars['ISO8601Date']>;
  state?: InputMaybe<TypesShipmentEntryInputTypeState>;
  subscriptionId?: InputMaybe<Scalars['Int']>;
  subscriptionStatus?: InputMaybe<TypesSubscriptionInputTypeState>;
  trackingNumber?: InputMaybe<Scalars['String']>;
  trackingStatus?: InputMaybe<Scalars['String']>;
  transitRegionCode?: InputMaybe<Scalars['String']>;
  undigitalInsertedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  userId?: InputMaybe<Scalars['Int']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of ShipmentEntryUpdate */
export type ShipmentEntryUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  shipmentEntryInput: ShipmentEntryInput;
};

/** Autogenerated return type of ShipmentEntryUpdate. */
export type ShipmentEntryUpdatePayload = {
  __typename?: 'ShipmentEntryUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shipmentEntry: ShipmentEntry;
};

export type ShipmentList = {
  __typename?: 'ShipmentList';
  createdAt: Scalars['ISO8601DateTime'];
  endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  estimatedShippingDate?: Maybe<Scalars['ISO8601DateTime']>;
  failureCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  processedCount?: Maybe<Scalars['Int']>;
  shipmentListsV2Orders?: Maybe<Array<ShipmentListsV2Order>>;
  shipments?: Maybe<Array<ShipmentEntry>>;
  shippedAt?: Maybe<Scalars['ISO8601Date']>;
  shipstationUploadJobs?: Maybe<Array<ShipstationUploadJob>>;
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  state?: Maybe<Scalars['String']>;
  successCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ShipmentList. */
export type ShipmentListConnection = {
  __typename?: 'ShipmentListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShipmentListEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ShipmentList>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of ShipmentListCreate */
export type ShipmentListCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shipmentListInput: ShipmentListInput;
};

/** Autogenerated return type of ShipmentListCreate. */
export type ShipmentListCreatePayload = {
  __typename?: 'ShipmentListCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shipmentList: ShipmentList;
};

/** Autogenerated input type of ShipmentListDelete */
export type ShipmentListDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ShipmentListDelete. */
export type ShipmentListDeletePayload = {
  __typename?: 'ShipmentListDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shipmentList: ShipmentList;
};

/** An edge in a connection. */
export type ShipmentListEdge = {
  __typename?: 'ShipmentListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ShipmentList>;
};

export type ShipmentListInput = {
  shippedAt?: InputMaybe<Scalars['ISO8601Date']>;
  state?: InputMaybe<TypesShipmentListInputTypeState>;
};

/** Autogenerated input type of ShipmentListShipStationUpload */
export type ShipmentListShipStationUploadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shipmentListId: Scalars['ID'];
};

/** Autogenerated return type of ShipmentListShipStationUpload. */
export type ShipmentListShipStationUploadPayload = {
  __typename?: 'ShipmentListShipStationUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type ShipmentListShipstationFormat = {
  __typename?: 'ShipmentListShipstationFormat';
  nodes: Array<ShipstationOrder>;
};

/** Autogenerated input type of ShipmentListUpdate */
export type ShipmentListUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  shipmentListInput: ShipmentListInput;
};

/** Autogenerated return type of ShipmentListUpdate. */
export type ShipmentListUpdatePayload = {
  __typename?: 'ShipmentListUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shipmentList: ShipmentList;
};

/** Autogenerated input type of ShipmentListUpload */
export type ShipmentListUploadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shipmentChanges: Array<ShipmentChangeInput>;
  shipmentListId: Scalars['ID'];
};

/** Autogenerated return type of ShipmentListUpload. */
export type ShipmentListUploadPayload = {
  __typename?: 'ShipmentListUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jobId?: Maybe<Scalars['Int']>;
};

export type ShipmentListsV2Order = {
  __typename?: 'ShipmentListsV2Order';
  error?: Maybe<Scalars['String']>;
  failure?: Maybe<Scalars['Boolean']>;
  processed?: Maybe<Scalars['Boolean']>;
  shipmentEntry?: Maybe<ShipmentEntry>;
  shipmentList?: Maybe<ShipmentList>;
  started?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
  v2Order?: Maybe<DbOrder>;
};

export type ShipmentUpdatesUpload = {
  __typename?: 'ShipmentUpdatesUpload';
  createdAt: Scalars['ISO8601DateTime'];
  downloadFileLink?: Maybe<Scalars['String']>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  error?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  numberProcessedShipments?: Maybe<Scalars['Int']>;
  s3Path: Scalars['String'];
  state: TypesShipmentUpdatesUploadTypeState;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ShipmentUpdatesUpload. */
export type ShipmentUpdatesUploadConnection = {
  __typename?: 'ShipmentUpdatesUploadConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShipmentUpdatesUploadEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ShipmentUpdatesUpload>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** An edge in a connection. */
export type ShipmentUpdatesUploadEdge = {
  __typename?: 'ShipmentUpdatesUploadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ShipmentUpdatesUpload>;
};

export type ShipmentUploadModification = {
  __typename?: 'ShipmentUploadModification';
  changes?: Maybe<Array<Change>>;
  itemSku?: Maybe<Scalars['String']>;
  shipmentId?: Maybe<Scalars['String']>;
};

export type ShipstationOrder = {
  __typename?: 'ShipstationOrder';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  amountPaid?: Maybe<Scalars['Float']>;
  box?: Maybe<OrderBox>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerFullName?: Maybe<Scalars['String']>;
  carrierCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  customField1?: Maybe<Scalars['String']>;
  customField2?: Maybe<Scalars['String']>;
  customField3?: Maybe<Scalars['String']>;
  giftMessage?: Maybe<Scalars['String']>;
  itemName?: Maybe<Scalars['String']>;
  itemQuantity?: Maybe<Scalars['Int']>;
  itemSku?: Maybe<Scalars['String']>;
  itemType?: Maybe<Scalars['String']>;
  itemWeight?: Maybe<Scalars['Float']>;
  notesFromBuyer?: Maybe<Scalars['String']>;
  orderDate?: Maybe<Scalars['ISO8601Date']>;
  orderNumber?: Maybe<Scalars['String']>;
  orderSource?: Maybe<Scalars['String']>;
  orderTotal?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<Scalars['String']>;
  recipientFullName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  warehouseCode?: Maybe<Scalars['String']>;
};

export type ShipstationUploadJob = {
  __typename?: 'ShipstationUploadJob';
  createdAt: Scalars['ISO8601DateTime'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logEvents?: Maybe<Array<LogEvent>>;
  shipmentList: ShipmentList;
  shipmentModifications?: Maybe<Array<ShipmentUploadModification>>;
  status?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
  uploaded?: Maybe<Scalars['Int']>;
};

export type ShopifyAddress = {
  __typename?: 'ShopifyAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ShopifyAmount = {
  __typename?: 'ShopifyAmount';
  amount?: Maybe<Scalars['Float']>;
};

export type ShopifyBillingAttempt = {
  __typename?: 'ShopifyBillingAttempt';
  completedAt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  processingError?: Maybe<ShopifyBillingAttemptError>;
};

export type ShopifyBillingAttemptError = {
  __typename?: 'ShopifyBillingAttemptError';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type ShopifyBillingAttemptNode = {
  __typename?: 'ShopifyBillingAttemptNode';
  node?: Maybe<ShopifyBillingAttempt>;
};

export type ShopifyBillingAttemptsEdge = {
  __typename?: 'ShopifyBillingAttemptsEdge';
  edges?: Maybe<Array<ShopifyBillingAttemptNode>>;
};

export type ShopifyContractCustomer = {
  __typename?: 'ShopifyContractCustomer';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  productSubscriberStatus?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  validEmailAddress?: Maybe<Scalars['Boolean']>;
  verifiedEmail?: Maybe<Scalars['Boolean']>;
};

export type ShopifyContractDiscount = {
  __typename?: 'ShopifyContractDiscount';
  id?: Maybe<Scalars['String']>;
  recurringCycleLimit?: Maybe<Scalars['Int']>;
  targetType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  usageCount?: Maybe<Scalars['Int']>;
  value?: Maybe<AmountOrPercentage>;
};

export type ShopifyCouponRefresh = {
  __typename?: 'ShopifyCouponRefresh';
  coupon?: Maybe<Coupon>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ShopifyCoupons = {
  __typename?: 'ShopifyCoupons';
  nodes: Array<TypesShopifyCouponsTypeNode>;
  pageInfo: TypesShopifyCouponsTypePageInfo;
};

export type ShopifyCreditCard = {
  __typename?: 'ShopifyCreditCard';
  branch?: Maybe<Scalars['String']>;
  expiresSoon?: Maybe<Scalars['Boolean']>;
  expiryMonth?: Maybe<Scalars['String']>;
  expiryYear?: Maybe<Scalars['String']>;
  firstDigits?: Maybe<Scalars['String']>;
  lastDigits?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type ShopifyCust = {
  __typename?: 'ShopifyCust';
  defaultAddress: ShopifyMailingAddress;
};

export type ShopifyCustomer = {
  __typename?: 'ShopifyCustomer';
  createdAt: Scalars['ISO8601Date'];
  email: Scalars['String'];
  id: Scalars['ID'];
  shopifyId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['ISO8601Date'];
  users: Array<User>;
};

export type ShopifyCustomerInput = {
  email: Scalars['String'];
};

export type ShopifyCustomerPaymentMethod = {
  __typename?: 'ShopifyCustomerPaymentMethod';
  id?: Maybe<Scalars['String']>;
  instrument?: Maybe<ShopifyCreditCard>;
  revokedAt?: Maybe<Scalars['String']>;
  revokedReason?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ShopifyCustomerUpdate */
export type ShopifyCustomerUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  shopifyCustomerInput: ShopifyCustomerInput;
};

/** Autogenerated return type of ShopifyCustomerUpdate. */
export type ShopifyCustomerUpdatePayload = {
  __typename?: 'ShopifyCustomerUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shopifyCustomer: ShopifyCustomer;
};

export type ShopifyDeliveryMethod = {
  __typename?: 'ShopifyDeliveryMethod';
  address?: Maybe<ShopifyAddress>;
};

export enum ShopifyDiscountAffectsClass {
  AllDiscountItems = 'AllDiscountItems',
  DiscountCollections = 'DiscountCollections',
  DiscountProducts = 'DiscountProducts',
  Unknown = 'Unknown'
}

export type ShopifyDiscountAllocation = {
  __typename?: 'ShopifyDiscountAllocation';
  discount?: Maybe<ShopifyLineItemDiscount>;
};

export type ShopifyDiscountInfo = {
  __typename?: 'ShopifyDiscountInfo';
  affectedCollections?: Maybe<Array<Scalars['String']>>;
  affectedProductSkus?: Maybe<Array<Scalars['String']>>;
  affectsClass?: Maybe<ShopifyDiscountAffectsClass>;
  amount?: Maybe<Scalars['Float']>;
  customPromoText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  inferredBannerText?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Float']>;
  status?: Maybe<ShopifyDiscountStatusEnum>;
  title?: Maybe<Scalars['String']>;
};

export enum ShopifyDiscountStatusEnum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Scheduled = 'SCHEDULED'
}

export type ShopifyDiscountsEdge = {
  __typename?: 'ShopifyDiscountsEdge';
  edges?: Maybe<Array<ShopifyDisountNode>>;
};

export type ShopifyDisountNode = {
  __typename?: 'ShopifyDisountNode';
  node?: Maybe<ShopifyContractDiscount>;
};

export type ShopifyLine = {
  __typename?: 'ShopifyLine';
  boxVariant?: Maybe<BoxVariant>;
  currentPrice?: Maybe<ShopifyAmount>;
  discountAllocations?: Maybe<Array<ShopifyDiscountAllocation>>;
  lineDiscountedPrice?: Maybe<ShopifyAmount>;
  quantity?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ShopifyLineEdge = {
  __typename?: 'ShopifyLineEdge';
  edges?: Maybe<Array<ShopifyLineNode>>;
};

export type ShopifyLineItemDiscount = {
  __typename?: 'ShopifyLineItemDiscount';
  title?: Maybe<Scalars['String']>;
};

export type ShopifyLineItems = {
  __typename?: 'ShopifyLineItems';
  category: Scalars['String'];
  quantity: Scalars['Int'];
  shopifyId: Scalars['String'];
  sku: Scalars['String'];
};

export type ShopifyLineNode = {
  __typename?: 'ShopifyLineNode';
  node?: Maybe<ShopifyLine>;
};

export type ShopifyMailingAddress = {
  __typename?: 'ShopifyMailingAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  provinceCode?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ShopifyMoney = {
  __typename?: 'ShopifyMoney';
  amount: Scalars['Int'];
  currencyCode: Scalars['String'];
};

export type ShopifyMoneyBag = {
  __typename?: 'ShopifyMoneyBag';
  presentmentMoney: ShopifyMoney;
  shopMoney: ShopifyMoney;
};

export type ShopifyOrderDetail = {
  __typename?: 'ShopifyOrderDetail';
  currentSubtotalPriceSet: ShopifyMoneyBag;
  customer: ShopifyCust;
  discountCodes: Array<Scalars['String']>;
  id: Scalars['ID'];
  lineItems?: Maybe<LineItemEdgeWrapper>;
};

export type ShopifyOrderInvoiceDiscounts = {
  __typename?: 'ShopifyOrderInvoiceDiscounts';
  amount?: Maybe<Scalars['Float']>;
  amountOff?: Maybe<Scalars['Float']>;
  applicationType: TypesSubscriptionShopifyCouponApplicationType;
  code: Scalars['String'];
  maskedCode?: Maybe<Scalars['String']>;
  percentageOff?: Maybe<Scalars['Float']>;
};

export type ShopifyOrderInvoicePreview = {
  __typename?: 'ShopifyOrderInvoicePreview';
  credit?: Maybe<Scalars['Float']>;
  discounts?: Maybe<Array<ShopifyOrderInvoiceDiscounts>>;
  subtotalCost: Scalars['Float'];
  totalCost: Scalars['Float'];
};

export type SizeClass = {
  __typename?: 'SizeClass';
  ageOfMaturity?: Maybe<Scalars['Int']>;
  ageOfSeniority?: Maybe<Scalars['Int']>;
  lifeExpectancy?: Maybe<Scalars['Int']>;
  maxWeight?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** The connection type for SizeClass. */
export type SizeClassConnection = {
  __typename?: 'SizeClassConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SizeClassEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SizeClass>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of SizeClassCreate */
export type SizeClassCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sizeClassInput: SizeClassInput;
};

/** Autogenerated return type of SizeClassCreate. */
export type SizeClassCreatePayload = {
  __typename?: 'SizeClassCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  sizeClass: SizeClass;
};

/** Autogenerated input type of SizeClassDelete */
export type SizeClassDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of SizeClassDelete. */
export type SizeClassDeletePayload = {
  __typename?: 'SizeClassDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  sizeClass: SizeClass;
};

/** An edge in a connection. */
export type SizeClassEdge = {
  __typename?: 'SizeClassEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SizeClass>;
};

export type SizeClassInput = {
  ageOfMaturity: Scalars['Int'];
  ageOfSeniority: Scalars['Int'];
  lifeExpectancy: Scalars['Int'];
  maxWeight: Scalars['Int'];
  name: Scalars['String'];
};

/** Autogenerated input type of SizeClassUpdate */
export type SizeClassUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  sizeClassInput: SizeClassInput;
};

/** Autogenerated return type of SizeClassUpdate. */
export type SizeClassUpdatePayload = {
  __typename?: 'SizeClassUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  sizeClass: SizeClass;
};

export type StateChange = {
  __typename?: 'StateChange';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  nextState?: Maybe<Scalars['String']>;
  previousState?: Maybe<Scalars['String']>;
  statefulId?: Maybe<Scalars['Int']>;
  statefulType?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
  updatedAt: Scalars['ISO8601DateTime'];
  user?: Maybe<User>;
};

/** The connection type for StateChange. */
export type StateChangeConnection = {
  __typename?: 'StateChangeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StateChangeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<StateChange>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of StateChangeCreate */
export type StateChangeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  stateChangeInput: StateChangeInput;
};

/** Autogenerated return type of StateChangeCreate. */
export type StateChangeCreatePayload = {
  __typename?: 'StateChangeCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  stateChange: StateChange;
};

/** Autogenerated input type of StateChangeDelete */
export type StateChangeDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of StateChangeDelete. */
export type StateChangeDeletePayload = {
  __typename?: 'StateChangeDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  stateChange: StateChange;
};

/** An edge in a connection. */
export type StateChangeEdge = {
  __typename?: 'StateChangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<StateChange>;
};

export type StateChangeInput = {
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  nextState?: InputMaybe<Scalars['String']>;
  previousState?: InputMaybe<Scalars['String']>;
  statefulId?: InputMaybe<Scalars['Int']>;
  statefulType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of StateChangeUpdate */
export type StateChangeUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  stateChangeInput: StateChangeInput;
};

/** Autogenerated return type of StateChangeUpdate. */
export type StateChangeUpdatePayload = {
  __typename?: 'StateChangeUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  stateChange: StateChange;
};

export type StoreCreditAccount = {
  __typename?: 'StoreCreditAccount';
  amount?: Maybe<Scalars['Float']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  number: Scalars['String'];
  transactions?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  user?: Maybe<User>;
};

/** The connection type for StoreCreditAccount. */
export type StoreCreditAccountConnection = {
  __typename?: 'StoreCreditAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StoreCreditAccountEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<StoreCreditAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of StoreCreditAccountCreate */
export type StoreCreditAccountCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  storeCreditAccountInput: StoreCreditAccountInput;
};

/** Autogenerated return type of StoreCreditAccountCreate. */
export type StoreCreditAccountCreatePayload = {
  __typename?: 'StoreCreditAccountCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  storeCreditAccount: StoreCreditAccount;
};

/** Autogenerated input type of StoreCreditAccountDelete */
export type StoreCreditAccountDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of StoreCreditAccountDelete. */
export type StoreCreditAccountDeletePayload = {
  __typename?: 'StoreCreditAccountDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  storeCreditAccount: StoreCreditAccount;
};

/** An edge in a connection. */
export type StoreCreditAccountEdge = {
  __typename?: 'StoreCreditAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<StoreCreditAccount>;
};

export type StoreCreditAccountInput = {
  number?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of StoreCreditAccountUpdate */
export type StoreCreditAccountUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  storeCreditAccountInput: StoreCreditAccountInput;
};

/** Autogenerated return type of StoreCreditAccountUpdate. */
export type StoreCreditAccountUpdatePayload = {
  __typename?: 'StoreCreditAccountUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  storeCreditAccount: StoreCreditAccount;
};

export type StoreCreditMovement = {
  __typename?: 'StoreCreditMovement';
  amount: Scalars['Float'];
  createdAt: Scalars['ISO8601DateTime'];
  creditSubmitter?: Maybe<User>;
  creditSubmitterId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
  payment?: Maybe<PpPayment>;
  reason?: Maybe<Term>;
  reasonId?: Maybe<Scalars['Int']>;
  storeCreditAccount?: Maybe<StoreCreditAccount>;
  storeCreditAccountId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  whoDidIt?: Maybe<User>;
  whoDidItId?: Maybe<Scalars['Int']>;
};

/** The connection type for StoreCreditMovement. */
export type StoreCreditMovementConnection = {
  __typename?: 'StoreCreditMovementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StoreCreditMovementEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<StoreCreditMovement>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of StoreCreditMovementCreate */
export type StoreCreditMovementCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  storeCreditMovementInput: StoreCreditMovementInput;
};

/** Autogenerated return type of StoreCreditMovementCreate. */
export type StoreCreditMovementCreatePayload = {
  __typename?: 'StoreCreditMovementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  storeCreditMovement: StoreCreditMovement;
};

/** Autogenerated input type of StoreCreditMovementDelete */
export type StoreCreditMovementDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of StoreCreditMovementDelete. */
export type StoreCreditMovementDeletePayload = {
  __typename?: 'StoreCreditMovementDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  storeCreditMovement: StoreCreditMovement;
};

/** An edge in a connection. */
export type StoreCreditMovementEdge = {
  __typename?: 'StoreCreditMovementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<StoreCreditMovement>;
};

export type StoreCreditMovementInput = {
  amount: Scalars['Float'];
  creditSubmitterId: Scalars['Int'];
  message?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
  paymentId?: InputMaybe<Scalars['Int']>;
  reasonId: Scalars['Int'];
  storeCreditAccountId?: InputMaybe<Scalars['Int']>;
  whoDidItId: Scalars['Int'];
};

/** Autogenerated input type of StoreCreditMovementUpdate */
export type StoreCreditMovementUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  storeCreditMovementInput: StoreCreditMovementInput;
};

/** Autogenerated return type of StoreCreditMovementUpdate. */
export type StoreCreditMovementUpdatePayload = {
  __typename?: 'StoreCreditMovementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  storeCreditMovement: StoreCreditMovement;
};

export type StoreLocator = {
  __typename?: 'StoreLocator';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<StoreLocator_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['JSON']>;
};


export type StoreLocatorTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type StoreLocator_BlockSettings = {
  __typename?: 'StoreLocator_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<StoreLocator_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<StoreLocator_BlockSettings_ResponsiveStyles>>;
};

export type StoreLocator_BlockSettings_ResponsiveStyles = {
  __typename?: 'StoreLocator_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<StoreLocator_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<StoreLocator_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<StoreLocator_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum StoreLocator_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum StoreLocator_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum StoreLocator_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum StoreLocator_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type StorefrontProductListing = {
  __typename?: 'StorefrontProductListing';
  category?: Maybe<PlanLineItemCategoryEnum>;
  discount?: Maybe<Scalars['Float']>;
  emergencyOutOfStock?: Maybe<Scalars['Boolean']>;
  outOfStock?: Maybe<Scalars['Boolean']>;
  outOfStockMessage?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  product?: Maybe<PlanLineItemProduct>;
  reason?: Maybe<RecReason>;
  recommended?: Maybe<Scalars['Boolean']>;
  sku?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  addonLineItems?: Maybe<Array<TypesSubscriptionTypeLineItemType>>;
  addons?: Maybe<Array<PlanLineItem>>;
  addonsCoupon?: Maybe<Coupon>;
  apiSubscriptionId?: Maybe<Scalars['String']>;
  attributions?: Maybe<Scalars['JSON']>;
  availablePostponementDates?: Maybe<Array<RescheduleDates>>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']>;
  cancellationSurvey?: Maybe<CancellationSurvey>;
  /** Retrieve the changelog for a subscription */
  changelogEntries: ChangelogEntryConnection;
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  coupons?: Maybe<Array<SubscriptionShopifyCoupon>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  currentAddonCost?: Maybe<Scalars['Float']>;
  currentCostPerDay?: Maybe<Scalars['Float']>;
  currentPlan?: Maybe<BoxVariant>;
  currentPlanCost?: Maybe<Scalars['Float']>;
  currentPlanFrequency?: Maybe<Scalars['Int']>;
  currentPlanFrequencyCustomizable?: Maybe<Scalars['Boolean']>;
  currentPlanSku?: Maybe<Scalars['String']>;
  currentPlanWithAddonCost?: Maybe<Scalars['Float']>;
  data?: Maybe<Scalars['JSON']>;
  deliveredOrders?: Maybe<Scalars['Int']>;
  dishesCount?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  entrees?: Maybe<Array<PlanLineItem>>;
  estimatedDeliveryDate?: Maybe<Scalars['ISO8601Date']>;
  estimatedNextDeliveryDates?: Maybe<Array<Scalars['ISO8601Date']>>;
  estimatedNextShippingDates?: Maybe<Array<Scalars['ISO8601Date']>>;
  freshBakedEntrees?: Maybe<Array<PlanLineItem>>;
  freshCookedEntrees?: Maybe<Array<PlanLineItem>>;
  hasEarlyCancelCoupon?: Maybe<Scalars['Boolean']>;
  hasFailedBilling: Scalars['Boolean'];
  hasLifeTimeCoupon?: Maybe<Scalars['Boolean']>;
  hasUpdatedFailedBilling: Scalars['Boolean'];
  hiddenAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  ignoreNewPlanRecommendationsAt?: Maybe<Scalars['ISO8601DateTime']>;
  incrementalCoupon?: Maybe<Coupon>;
  isHighValue?: Maybe<Scalars['Boolean']>;
  lastPaidOrderShippingDate?: Maybe<Scalars['ISO8601Date']>;
  lastShippedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lineItemsData: Scalars['JSON'];
  manuallyScheduledShipments?: Maybe<Scalars['String']>;
  mealLineItems?: Maybe<Array<MealLineItem>>;
  mostRecentOrder?: Maybe<DbOrder>;
  newPlan?: Maybe<Scalars['Boolean']>;
  nextCoupons: Array<Scalars['String']>;
  nextLinkedCoupons: Array<Scalars['String']>;
  nextOrder?: Maybe<DbOrder>;
  nextOrderAdjusted?: Maybe<DbOrder>;
  nextOrderDeliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  nextPlan?: Maybe<BoxVariant>;
  nextPlanFrequency?: Maybe<Scalars['Int']>;
  nextPlanFrequencyCustomizable?: Maybe<Scalars['Boolean']>;
  nextScheduledShippingDate?: Maybe<Scalars['ISO8601Date']>;
  number?: Maybe<Scalars['String']>;
  paidOrdersCount: Scalars['Int'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentTotal?: Maybe<Scalars['Int']>;
  payments: Array<PpPayment>;
  pet?: Maybe<Pet>;
  planSettings?: Maybe<PlanSettings>;
  planStatus?: Maybe<Scalars['String']>;
  planType?: Maybe<Scalars['String']>;
  previousPlan?: Maybe<BoxVariant>;
  publicToken?: Maybe<Scalars['String']>;
  /** Find a RecommendationWizard its id value */
  recommendationWizard: RecommendationWizard;
  remoteContract?: Maybe<RemoteContract>;
  renewals?: Maybe<Scalars['Int']>;
  routeSchedule?: Maybe<RouteSchedule>;
  scheduledShippingDate?: Maybe<Scalars['ISO8601Date']>;
  shipments?: Maybe<Array<ShipmentEntry>>;
  shippingAddress?: Maybe<Address>;
  shopifyCustomer?: Maybe<ShopifyCustomer>;
  shopifySubscriptionContractId?: Maybe<Scalars['String']>;
  skipNextCycle?: Maybe<Scalars['Int']>;
  state?: Maybe<SubscriptionStateEnum>;
  statementTotal?: Maybe<Scalars['Float']>;
  stripeUrl?: Maybe<Scalars['String']>;
  supplements?: Maybe<Array<PlanLineItem>>;
  supplementsCount?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Float']>;
  treats?: Maybe<Array<PlanLineItem>>;
  treatsCount?: Maybe<Scalars['Int']>;
  upcomingOrder?: Maybe<DbOrder>;
  upcomingOrderDeliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  upgradeAddonCost?: Maybe<Scalars['Float']>;
  upgradeCostPerDay?: Maybe<Scalars['Float']>;
  upgradePlan?: Maybe<BoxVariant>;
  upgradePlanCost?: Maybe<Scalars['Float']>;
  upgradePlanSku?: Maybe<Scalars['String']>;
  upgradePlanWithAddonCost?: Maybe<Scalars['Float']>;
  user?: Maybe<User>;
  userCoupon?: Maybe<Coupon>;
  userId?: Maybe<Scalars['Int']>;
  v2Orders: Array<DbOrder>;
  welcomeCardCount?: Maybe<Scalars['Int']>;
};


export type SubscriptionChangelogEntriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SubscriptionRecommendationWizardArgs = {
  id?: InputMaybe<Scalars['String']>;
};

/** The connection type for Subscription. */
export type SubscriptionConnection = {
  __typename?: 'SubscriptionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubscriptionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Subscription>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of SubscriptionCreate */
export type SubscriptionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  subscriptionInput: SubscriptionInput;
};

/** Autogenerated return type of SubscriptionCreate. */
export type SubscriptionCreatePayload = {
  __typename?: 'SubscriptionCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subscription: Subscription;
};

/** Autogenerated input type of SubscriptionDelete */
export type SubscriptionDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of SubscriptionDelete. */
export type SubscriptionDeletePayload = {
  __typename?: 'SubscriptionDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subscription: Subscription;
};

/** An edge in a connection. */
export type SubscriptionEdge = {
  __typename?: 'SubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Subscription>;
};

/** Autogenerated input type of SubscriptionEdit */
export type SubscriptionEditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: MutationsSubscriptionEditInput;
};

/** Autogenerated return type of SubscriptionEdit. */
export type SubscriptionEditPayload = {
  __typename?: 'SubscriptionEditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type SubscriptionInput = {
  addonLineItems?: InputMaybe<Array<TypesSubscriptionInputTypeAddonLineItemInput>>;
  apiSubscriptionId?: InputMaybe<Scalars['String']>;
  attributionChannel?: InputMaybe<Scalars['String']>;
  attributionSource?: InputMaybe<Scalars['String']>;
  attributions?: InputMaybe<Scalars['JSON']>;
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  canceledAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  couponCodes?: InputMaybe<Array<Scalars['String']>>;
  currentPlanFrequency?: InputMaybe<Scalars['Int']>;
  currentPlanFrequencyCustomizable?: InputMaybe<Scalars['Boolean']>;
  currentPlanId?: InputMaybe<Scalars['Int']>;
  data?: InputMaybe<Scalars['JSON']>;
  dishesCount?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  entreeLineItems?: InputMaybe<Array<TypesSubscriptionInputTypeLineItemInput>>;
  hiddenAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  ignoreNewPlanRecommendationsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  lastShippedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  lineItemsData?: InputMaybe<Scalars['JSON']>;
  manuallyScheduledShipments?: InputMaybe<Scalars['String']>;
  newPlan?: InputMaybe<Scalars['Boolean']>;
  nextPlanFrequency?: InputMaybe<Scalars['Int']>;
  nextPlanFrequencyCustomizable?: InputMaybe<Scalars['Boolean']>;
  nextPlanId?: InputMaybe<Scalars['Int']>;
  nextScheduledShippingDate?: InputMaybe<Scalars['ISO8601Date']>;
  number?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['Int']>;
  petId?: InputMaybe<Scalars['Int']>;
  planSettings?: InputMaybe<Scalars['JSON']>;
  postponeNextDeliveryTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  previousPlanId?: InputMaybe<Scalars['Int']>;
  publicToken?: InputMaybe<Scalars['String']>;
  recommendationWizardId?: InputMaybe<Scalars['Int']>;
  renewals?: InputMaybe<Scalars['Int']>;
  scheduledShippingDate?: InputMaybe<Scalars['ISO8601Date']>;
  shippingAddressAttributes?: InputMaybe<AddressInput>;
  shopifySubscriptionContractId?: InputMaybe<Scalars['String']>;
  skipNextCycle?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<TypesSubscriptionInputTypeState>;
  stateEvent?: InputMaybe<TypesSubscriptionInputTypeStateEvent>;
  welcomeCardCount?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionShopifyCoupon = {
  __typename?: 'SubscriptionShopifyCoupon';
  affectedCollections?: Maybe<Array<Scalars['String']>>;
  affectedProductSkus?: Maybe<Array<Scalars['String']>>;
  affectsClass?: Maybe<ShopifyDiscountAffectsClass>;
  amountOff?: Maybe<Scalars['Float']>;
  applicationType: TypesSubscriptionShopifyCouponApplicationType;
  appliesToAllItems: Scalars['Boolean'];
  code: Scalars['String'];
  entitledProducts?: Maybe<Array<SubscriptionShopifyEntitledProduct>>;
  limited: Scalars['Boolean'];
  maskedCode?: Maybe<Scalars['String']>;
  oncePerCustomer: Scalars['Boolean'];
  percentageOff?: Maybe<Scalars['Float']>;
  usageCount: Scalars['Int'];
  usageCycleLimit?: Maybe<Scalars['Int']>;
};

export type SubscriptionShopifyEntitledProduct = {
  __typename?: 'SubscriptionShopifyEntitledProduct';
  id: Scalars['String'];
  sku: Scalars['String'];
};

export enum SubscriptionStateEnum {
  Active = 'active',
  Canceled = 'canceled',
  Cart = 'cart',
  Paused = 'paused'
}

export type SubscriptionStatisticsReport = {
  __typename?: 'SubscriptionStatisticsReport';
  url: Scalars['String'];
};

/** Autogenerated input type of SubscriptionUpdate */
export type SubscriptionUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  subscriptionInput: SubscriptionInput;
};

/** Autogenerated return type of SubscriptionUpdate. */
export type SubscriptionUpdatePayload = {
  __typename?: 'SubscriptionUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  subscription: Subscription;
};

/** Autogenerated input type of Sudo */
export type SudoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of Sudo. */
export type SudoPayload = {
  __typename?: 'SudoPayload';
  authorization?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SurveyOption = {
  __typename?: 'SurveyOption';
  label: Scalars['String'];
  value: Scalars['Int'];
};

export type SurveyOptions = {
  __typename?: 'SurveyOptions';
  allergy: Array<SurveyOption>;
  breakIssue: Array<SurveyOption>;
  cancelReason: Array<SurveyOption>;
  cancelReasonLegacy: Array<SurveyOption>;
  covidReason: Array<SurveyOption>;
  creditReason: Array<SurveyOption>;
  creditReasonLegacy: Array<SurveyOption>;
  customerCareIssue: Array<SurveyOption>;
  deliveryIssue: Array<SurveyOption>;
  deliveryScheduleIssue: Array<SurveyOption>;
  foodBrand: Array<SurveyOption>;
  foodSensitivities: Array<SurveyOption>;
  foodType: Array<SurveyOption>;
  foodTypeDehydrated: Array<SurveyOption>;
  foodTypeFreezeDried: Array<SurveyOption>;
  foodTypeFresh: Array<SurveyOption>;
  foodTypeKibble: Array<SurveyOption>;
  foodTypePrescription: Array<SurveyOption>;
  foodTypeRaw: Array<SurveyOption>;
  foodTypeWet: Array<SurveyOption>;
  healthIssue: Array<SurveyOption>;
  ingredient: Array<SurveyOption>;
  mealQualityIssue: Array<SurveyOption>;
  pauseReason: Array<SurveyOption>;
  petFoodBrand: Array<SurveyOption>;
  prescriptionDietCondition: Array<SurveyOption>;
  quantityIssue: Array<SurveyOption>;
  replaceOrderReason: Array<SurveyOption>;
  secondaryAliments: Array<SurveyOption>;
  serviceIssue: Array<SurveyOption>;
  stripe: Array<SurveyOption>;
  tasteResponse: Array<SurveyOption>;
  transitionIssue: Array<SurveyOption>;
};

/** Autogenerated input type of SyncSubscriptionEntities */
export type SyncSubscriptionEntitiesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** Autogenerated return type of SyncSubscriptionEntities. */
export type SyncSubscriptionEntitiesPayload = {
  __typename?: 'SyncSubscriptionEntitiesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type Tagging = {
  __typename?: 'Tagging';
  tag?: Maybe<Tag>;
};

/** Autogenerated input type of TaggingCreate */
export type TaggingCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  taggingInput: TaggingInput;
};

/** Autogenerated return type of TaggingCreate. */
export type TaggingCreatePayload = {
  __typename?: 'TaggingCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  tagging: Tagging;
};

/** Autogenerated input type of TaggingDelete */
export type TaggingDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of TaggingDelete. */
export type TaggingDeletePayload = {
  __typename?: 'TaggingDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  tagging: Tagging;
};

export type TaggingInput = {
  context: Scalars['String'];
  tagId: Scalars['ID'];
};

/** Autogenerated input type of TaggingUpdate */
export type TaggingUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  taggingInput: TaggingInput;
};

/** Autogenerated return type of TaggingUpdate. */
export type TaggingUpdatePayload = {
  __typename?: 'TaggingUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  tagging: Tagging;
};

export type Term = {
  __typename?: 'Term';
  active: Scalars['Boolean'];
  additionalCopy?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  systemOnly?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Term. */
export type TermConnection = {
  __typename?: 'TermConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TermEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Term>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of TermCreate */
export type TermCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  termInput: TermInput;
};

/** Autogenerated return type of TermCreate. */
export type TermCreatePayload = {
  __typename?: 'TermCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  term: Term;
};

/** Autogenerated input type of TermDelete */
export type TermDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of TermDelete. */
export type TermDeletePayload = {
  __typename?: 'TermDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  term: Term;
};

/** An edge in a connection. */
export type TermEdge = {
  __typename?: 'TermEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Term>;
};

export type TermInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  additionalCopy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  systemOnly?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<TypesTermInputTypeType>;
};

/** Autogenerated input type of TermUpdate */
export type TermUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  termInput: TermInput;
};

/** Autogenerated return type of TermUpdate. */
export type TermUpdatePayload = {
  __typename?: 'TermUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  term: Term;
};

export type ThreeUpContentCards = {
  __typename?: 'ThreeUpContentCards';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<ThreeUpContentCards_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  cards?: Maybe<Array<ThreeUpContentCards_Cards>>;
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['JSON']>;
};


export type ThreeUpContentCardsTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type ThreeUpContentCards_BlockSettings = {
  __typename?: 'ThreeUpContentCards_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<ThreeUpContentCards_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<ThreeUpContentCards_BlockSettings_ResponsiveStyles>>;
};

export type ThreeUpContentCards_BlockSettings_ResponsiveStyles = {
  __typename?: 'ThreeUpContentCards_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<ThreeUpContentCards_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<ThreeUpContentCards_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<ThreeUpContentCards_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum ThreeUpContentCards_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum ThreeUpContentCards_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ThreeUpContentCards_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum ThreeUpContentCards_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type ThreeUpContentCards_Cards = {
  __typename?: 'ThreeUpContentCards_Cards';
  description?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Cms_Media>;
  title?: Maybe<Scalars['String']>;
};


export type ThreeUpContentCards_CardsDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type ThreeUpContentCards_CardsImageArgs = {
  where?: InputMaybe<ThreeUpContentCards_Cards_Image_Where>;
};

export type ThreeUpContentCards_Cards_Image_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ThreeUpContentCards_Cards_Image_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ThreeUpContentCards_Cards_Image_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ThreeUpContentCards_Cards_Image_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Tablet__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Tablet__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Tablet__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Tablet__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Tablet__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Tablet__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type ThreeUpContentCards_Cards_Image_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type ThreeUpContentCards_Cards_Image_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThreeUpContentCards_Cards_Image_Where = {
  AND?: InputMaybe<Array<InputMaybe<ThreeUpContentCards_Cards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ThreeUpContentCards_Cards_Image_Where_Or>>>;
  alt?: InputMaybe<ThreeUpContentCards_Cards_Image_Alt_Operator>;
  createdAt?: InputMaybe<ThreeUpContentCards_Cards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<ThreeUpContentCards_Cards_Image_Filename_Operator>;
  filesize?: InputMaybe<ThreeUpContentCards_Cards_Image_Filesize_Operator>;
  height?: InputMaybe<ThreeUpContentCards_Cards_Image_Height_Operator>;
  id?: InputMaybe<ThreeUpContentCards_Cards_Image_Id_Operator>;
  mimeType?: InputMaybe<ThreeUpContentCards_Cards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ThreeUpContentCards_Cards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<ThreeUpContentCards_Cards_Image_Url_Operator>;
  width?: InputMaybe<ThreeUpContentCards_Cards_Image_Width_Operator>;
};

export type ThreeUpContentCards_Cards_Image_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<ThreeUpContentCards_Cards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ThreeUpContentCards_Cards_Image_Where_Or>>>;
  alt?: InputMaybe<ThreeUpContentCards_Cards_Image_Alt_Operator>;
  createdAt?: InputMaybe<ThreeUpContentCards_Cards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<ThreeUpContentCards_Cards_Image_Filename_Operator>;
  filesize?: InputMaybe<ThreeUpContentCards_Cards_Image_Filesize_Operator>;
  height?: InputMaybe<ThreeUpContentCards_Cards_Image_Height_Operator>;
  id?: InputMaybe<ThreeUpContentCards_Cards_Image_Id_Operator>;
  mimeType?: InputMaybe<ThreeUpContentCards_Cards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ThreeUpContentCards_Cards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<ThreeUpContentCards_Cards_Image_Url_Operator>;
  width?: InputMaybe<ThreeUpContentCards_Cards_Image_Width_Operator>;
};

export type ThreeUpContentCards_Cards_Image_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<ThreeUpContentCards_Cards_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<ThreeUpContentCards_Cards_Image_Where_Or>>>;
  alt?: InputMaybe<ThreeUpContentCards_Cards_Image_Alt_Operator>;
  createdAt?: InputMaybe<ThreeUpContentCards_Cards_Image_CreatedAt_Operator>;
  filename?: InputMaybe<ThreeUpContentCards_Cards_Image_Filename_Operator>;
  filesize?: InputMaybe<ThreeUpContentCards_Cards_Image_Filesize_Operator>;
  height?: InputMaybe<ThreeUpContentCards_Cards_Image_Height_Operator>;
  id?: InputMaybe<ThreeUpContentCards_Cards_Image_Id_Operator>;
  mimeType?: InputMaybe<ThreeUpContentCards_Cards_Image_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Card__Width_Operator>;
  sizes__tablet__filename?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Filename_Operator>;
  sizes__tablet__filesize?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Filesize_Operator>;
  sizes__tablet__height?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Height_Operator>;
  sizes__tablet__mimeType?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__MimeType_Operator>;
  sizes__tablet__url?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Url_Operator>;
  sizes__tablet__width?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Tablet__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<ThreeUpContentCards_Cards_Image_Sizes__Thumbnail__Width_Operator>;
  updatedAt?: InputMaybe<ThreeUpContentCards_Cards_Image_UpdatedAt_Operator>;
  url?: InputMaybe<ThreeUpContentCards_Cards_Image_Url_Operator>;
  width?: InputMaybe<ThreeUpContentCards_Cards_Image_Width_Operator>;
};

export type ThreeUpContentCards_Cards_Image_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TransitConfiguration = {
  __typename?: 'TransitConfiguration';
  createdAt: Scalars['ISO8601DateTime'];
  dryIcePackagings?: Maybe<Array<DryIcePackaging>>;
  id: Scalars['ID'];
  settings: Scalars['JSON'];
  transitCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  warehouseCode?: Maybe<Scalars['String']>;
};

/** The connection type for TransitConfiguration. */
export type TransitConfigurationConnection = {
  __typename?: 'TransitConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TransitConfigurationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TransitConfiguration>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of TransitConfigurationCreate */
export type TransitConfigurationCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  transitConfigurationInput: TransitConfigurationInput;
};

/** Autogenerated return type of TransitConfigurationCreate. */
export type TransitConfigurationCreatePayload = {
  __typename?: 'TransitConfigurationCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  transitConfiguration: TransitConfiguration;
};

/** Autogenerated input type of TransitConfigurationDelete */
export type TransitConfigurationDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of TransitConfigurationDelete. */
export type TransitConfigurationDeletePayload = {
  __typename?: 'TransitConfigurationDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  transitConfiguration: TransitConfiguration;
};

/** An edge in a connection. */
export type TransitConfigurationEdge = {
  __typename?: 'TransitConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TransitConfiguration>;
};

export type TransitConfigurationInput = {
  settings?: InputMaybe<Scalars['JSON']>;
  transitCode?: InputMaybe<Scalars['String']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export enum TransitConfigurationOrder {
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyModified = 'RECENTLY_MODIFIED'
}

/** Autogenerated input type of TransitConfigurationUpdate */
export type TransitConfigurationUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  transitConfigurationInput: TransitConfigurationInput;
};

/** Autogenerated return type of TransitConfigurationUpdate. */
export type TransitConfigurationUpdatePayload = {
  __typename?: 'TransitConfigurationUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  transitConfiguration: TransitConfiguration;
};

export enum TypesBoxInputTypeState {
  Active = 'active',
  Discontinued = 'discontinued',
  Draft = 'draft'
}

export enum TypesBoxVariantCategory {
  Amazon = 'amazon',
  Bundle = 'bundle',
  CalorieBased = 'calorie_based',
  Chewy = 'chewy',
  Retail = 'retail',
  WeightBased = 'weight_based'
}

export enum TypesDbOrderInputTypeAttributionChannel {
  /** PetPlate Admin */
  PpAd = 'PP_AD',
  /** Petplate Amazon Order */
  PpAz = 'PP_AZ',
  /** Petplate Chewy Order */
  PpCh = 'PP_CH',
  /** PetPlate Express Checkout */
  PpEc = 'PP_EC',
  /** PetPlate Gift Order */
  PpGift = 'PP_GIFT',
  /** Purchase Order */
  PpPo = 'PP_PO',
  /** PetPlate Sample Order */
  PpSample = 'PP_SAMPLE',
  /** PetPlate Subscription Checkout */
  PpSc = 'PP_SC'
}

export enum TypesDbOrderInputTypeAttributionSource {
  /** Amazon */
  Amz = 'AMZ',
  /** Chewy */
  Chw = 'CHW',
  /** Independent Pet Partners */
  Ipp = 'IPP',
  /** PetPlate */
  Pp = 'PP',
  /** Pet Supplies Plus */
  Psp = 'PSP',
  /** Williams Sonoma */
  Ws = 'WS'
}

export enum TypesDbOrderInputTypeState {
  Anonymized = 'anonymized',
  Drafted = 'drafted',
  Invalid = 'invalid',
  ProcessingFulfillment = 'processing_fulfillment',
  ProcessingOrigination = 'processing_origination',
  RequiresFulfillers = 'requires_fulfillers',
  RequiresOriginatorDetermination = 'requires_originator_determination',
  RequiresOriginators = 'requires_originators',
  Settled = 'settled',
  Unsettled = 'unsettled',
  WaitingAcknowledge = 'waiting_acknowledge'
}

export type TypesInvalidZipCodeAlertsTypeInvalidOrderZipCodes = {
  __typename?: 'TypesInvalidZipCodeAlertsTypeInvalidOrderZipCodes';
  orderId: Scalars['Int'];
  orderShippingDate?: Maybe<Scalars['String']>;
  orderStatus: Scalars['String'];
};

export type TypesInvalidZipCodeAlertsTypeInvalidSubZipCodes = {
  __typename?: 'TypesInvalidZipCodeAlertsTypeInvalidSubZipCodes';
  subscriptionId: Scalars['Int'];
  subscriptionStatus: Scalars['String'];
};

export type TypesOperationsDashboardTypeActiveSubscriptions = {
  __typename?: 'TypesOperationsDashboardTypeActiveSubscriptions';
  stats: Scalars['Int'];
};

export type TypesOperationsDashboardTypePaymentBatch = {
  __typename?: 'TypesOperationsDashboardTypePaymentBatch';
  batch: TypesOperationsDashboardTypeShipmentListBatch;
  export: TypesOperationsDashboardTypePaymentBatchExport;
  link: Scalars['String'];
  status: Scalars['String'];
};

export type TypesOperationsDashboardTypePaymentBatchExport = {
  __typename?: 'TypesOperationsDashboardTypePaymentBatchExport';
  charged: Scalars['Int'];
  failed: Scalars['Int'];
  skipped: Scalars['Int'];
};

export type TypesOperationsDashboardTypeRecentOrders = {
  __typename?: 'TypesOperationsDashboardTypeRecentOrders';
  date: Scalars['ISO8601Date'];
  ppAd?: Maybe<Scalars['Int']>;
  ppAz?: Maybe<Scalars['Int']>;
  ppCh?: Maybe<Scalars['Int']>;
  ppEc?: Maybe<Scalars['Int']>;
  ppSample?: Maybe<Scalars['Int']>;
  ppSc?: Maybe<Scalars['Int']>;
};

export type TypesOperationsDashboardTypeShipmentList = {
  __typename?: 'TypesOperationsDashboardTypeShipmentList';
  batch: TypesOperationsDashboardTypeShipmentListBatch;
  link: Scalars['String'];
  shipments: Scalars['Int'];
  status: Scalars['String'];
};

export type TypesOperationsDashboardTypeShipmentListBatch = {
  __typename?: 'TypesOperationsDashboardTypeShipmentListBatch';
  date: Scalars['ISO8601DateTime'];
  id: Scalars['String'];
};

export type TypesOperationsDashboardTypeShippingAlert = {
  __typename?: 'TypesOperationsDashboardTypeShippingAlert';
  alertChewyShipments: Array<TypesOperationsDashboardTypeShippingAlertChewyShipmentCount>;
  alertPastOrders: Array<TypesOperationsDashboardTypeShippingAlertPastOrders>;
  alertPastSubscriptions: Array<TypesOperationsDashboardTypeShippingAlertPastSubscriptions>;
  alertUnavailableDate: Array<TypesOperationsDashboardTypeShippingAlertUnavailableDate>;
  alertUnavailableShipping: Array<TypesOperationsDashboardTypeShippingAlertUnavailableShipping>;
};

export type TypesOperationsDashboardTypeShippingAlertChewyShipmentCount = {
  __typename?: 'TypesOperationsDashboardTypeShippingAlertChewyShipmentCount';
  count: Scalars['Int'];
  date: Scalars['ISO8601Date'];
};

export type TypesOperationsDashboardTypeShippingAlertPastOrders = {
  __typename?: 'TypesOperationsDashboardTypeShippingAlertPastOrders';
  id: Scalars['Int'];
  missedDate: Scalars['ISO8601Date'];
};

export type TypesOperationsDashboardTypeShippingAlertPastSubscriptions = {
  __typename?: 'TypesOperationsDashboardTypeShippingAlertPastSubscriptions';
  missedDate: Scalars['ISO8601Date'];
  subscriptions: Scalars['Int'];
};

export type TypesOperationsDashboardTypeShippingAlertUnavailableDate = {
  __typename?: 'TypesOperationsDashboardTypeShippingAlertUnavailableDate';
  orders: Scalars['Int'];
  unavailableDate?: Maybe<Scalars['ISO8601Date']>;
};

export type TypesOperationsDashboardTypeShippingAlertUnavailableShipping = {
  __typename?: 'TypesOperationsDashboardTypeShippingAlertUnavailableShipping';
  subscriptions: Scalars['Int'];
  unavailableDate: Scalars['ISO8601Date'];
};

export type TypesOperationsDashboardTypeShippingSchedule = {
  __typename?: 'TypesOperationsDashboardTypeShippingSchedule';
  link: Scalars['String'];
  orders: TypesOperationsDashboardTypeShippingScheduleOrders;
  payments: TypesOperationsDashboardTypeShippingSchedulePayments;
  schedule: Scalars['ISO8601DateTime'];
  shipments: TypesOperationsDashboardTypeShippingScheduleShipments;
  statusTags: Array<TypesShippingScheduleStatusTagType>;
  subscriptionsScheduled: Scalars['Int'];
};

export type TypesOperationsDashboardTypeShippingScheduleOrders = {
  __typename?: 'TypesOperationsDashboardTypeShippingScheduleOrders';
  newOneoff: Scalars['Int'];
  newOneoffIds: Scalars['String'];
  newRecurring: Scalars['Int'];
  newRecurringIds: Scalars['String'];
  repeatOneoff: Scalars['Int'];
  repeatOneoffIds: Scalars['String'];
  repeatRecurring: Scalars['Int'];
  repeatRecurringIds: Scalars['String'];
};

export type TypesOperationsDashboardTypeShippingSchedulePayments = {
  __typename?: 'TypesOperationsDashboardTypeShippingSchedulePayments';
  failed: Scalars['Int'];
  failedIds: Scalars['String'];
  paid: Scalars['Int'];
  paidIds: Scalars['String'];
};

export type TypesOperationsDashboardTypeShippingScheduleShipments = {
  __typename?: 'TypesOperationsDashboardTypeShippingScheduleShipments';
  batched: Scalars['Int'];
  imported: Scalars['Int'];
  replaced: Scalars['Int'];
  voided: Scalars['Int'];
  waiting: Scalars['Int'];
};

export type TypesOperationsDashboardTypeSubscriptionStatistics = {
  __typename?: 'TypesOperationsDashboardTypeSubscriptionStatistics';
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
  weeklyStats: Array<WeeklyStats>;
};

export type TypesOperationsDashboardTypeUnsyncedOrders = {
  __typename?: 'TypesOperationsDashboardTypeUnsyncedOrders';
  createdAt: Scalars['ISO8601DateTime'];
  error: Scalars['String'];
  shopifyOrderId: Scalars['String'];
  topic: Scalars['String'];
};

export enum TypesPaymentBatchEntryInputTypeState {
  Created = 'created',
  Error = 'error',
  Finished = 'finished',
  Processing = 'processing',
  Skipped = 'skipped'
}

export enum TypesPaymentBatchInputTypeState {
  Created = 'created',
  Error = 'error',
  Finished = 'finished',
  Processing = 'processing'
}

export enum TypesPaymentMethodInputTypeState {
  Active = 'active',
  Inactive = 'inactive',
  Primary = 'primary',
  Risky = 'risky'
}

export enum TypesPetsServedTypePetAgeGroup {
  Adult = 'adult',
  Puppy = 'puppy',
  Senior = 'senior'
}

export type TypesPetsServedTypePetCountPerAgeGroup = {
  __typename?: 'TypesPetsServedTypePetCountPerAgeGroup';
  ageGroup: TypesPetsServedTypePetAgeGroup;
  count: Scalars['Int'];
};

export type TypesPetsServedTypePetCountPerBreed = {
  __typename?: 'TypesPetsServedTypePetCountPerBreed';
  count: Scalars['Int'];
  id: Scalars['ID'];
};

export enum TypesPlanMatchCriteriumInputTypeAgeGroup {
  /** Adult Dog */
  AdultDog = 'adult_dog',
  /** Puppy */
  Puppy = 'puppy'
}

export enum TypesPlanMatchCriteriumInputTypeGroupingType {
  CalorieBased = 'calorie_based',
  WeightBased = 'weight_based'
}

export enum TypesPpPaymentInputTypeState {
  Challenged = 'challenged',
  Completed = 'completed',
  Created = 'created',
  Failed = 'failed',
  PartiallyRefunded = 'partially_refunded',
  Processing = 'processing',
  Refunded = 'refunded'
}

export enum TypesRecommendableProductInputTypeRecommendedType {
  Meal = 'Meal',
  Product = 'Product'
}

export enum TypesRecommendableProductInputTypeStatus {
  Neutral = 'neutral',
  NotSuitable = 'not_suitable',
  Recommended = 'recommended'
}

export enum TypesReportJobInputTypeState {
  Completed = 'completed',
  Enqueued = 'enqueued',
  Failed = 'failed',
  Started = 'started'
}

export enum TypesRouteCodesType {
  AmazonAir = 'amazon_air',
  AmazonGround = 'amazon_ground',
  Chewy = 'chewy',
  Dry = 'dry',
  Refrigerated = 'refrigerated'
}

export enum TypesRouteScheduleTypeRouteCode {
  AmazonAir = 'amazon_air',
  AmazonGround = 'amazon_ground',
  Chewy = 'chewy',
  Dry = 'dry',
  Refrigerated = 'refrigerated'
}

export enum TypesRouteScheduleUploadTypeState {
  Error = 'error',
  Finished = 'finished',
  Pending = 'pending',
  Processing = 'processing'
}

export enum TypesShipmentEntryInputTypeState {
  Delivered = 'delivered',
  NotDelivered = 'not_delivered',
  NotShipped = 'not_shipped',
  Preparing = 'preparing',
  Replaced = 'replaced',
  SentBack = 'sent_back',
  Shipped = 'shipped',
  Voided = 'voided'
}

export enum TypesShipmentEntryStateEnumType {
  Delivered = 'delivered',
  NotDelivered = 'not_delivered',
  NotShipped = 'not_shipped',
  Preparing = 'preparing',
  Replaced = 'replaced',
  SentBack = 'sent_back',
  Shipped = 'shipped',
  Unknown = 'unknown',
  Voided = 'voided'
}

export enum TypesShipmentListInputTypeState {
  Created = 'created',
  Error = 'error',
  Finished = 'finished',
  Processing = 'processing'
}

export enum TypesShipmentUpdatesUploadTypeState {
  Error = 'error',
  Finished = 'finished',
  Pending = 'pending',
  Processing = 'processing'
}

export enum TypesShippingScheduleStatusTagType {
  AcceptingOrders = 'accepting_orders',
  ClosedCustomers = 'closed_customers',
  ClosedOps = 'closed_ops',
  Scheduled = 'scheduled',
  Soonest = 'soonest'
}

export type TypesShopifyCouponsTypeNode = {
  __typename?: 'TypesShopifyCouponsTypeNode';
  code?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type TypesShopifyCouponsTypePageInfo = {
  __typename?: 'TypesShopifyCouponsTypePageInfo';
  endCursor?: Maybe<Scalars['String']>;
};

export type TypesSubscriptionInputTypeAddonLineItemInput = {
  quantity: Scalars['Int'];
  recurring?: InputMaybe<Scalars['Boolean']>;
  sku: Scalars['String'];
};

export type TypesSubscriptionInputTypeLineItemInput = {
  quantity: Scalars['Int'];
  sku: Scalars['String'];
};

export enum TypesSubscriptionInputTypeState {
  Active = 'active',
  Canceled = 'canceled',
  Cart = 'cart',
  Paused = 'paused'
}

export enum TypesSubscriptionInputTypeStateEvent {
  Activate = 'activate',
  Cancel = 'cancel',
  Pause = 'pause',
  Reactivate = 'reactivate',
  Resume = 'resume'
}

export enum TypesSubscriptionShopifyCouponApplicationType {
  FixedAmount = 'fixed_amount',
  Percentage = 'percentage',
  Unknown = 'unknown'
}

export type TypesSubscriptionTypeLineItemType = {
  __typename?: 'TypesSubscriptionTypeLineItemType';
  discount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  recurring?: Maybe<Scalars['Boolean']>;
  sku?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum TypesTermInputTypeType {
  /** Allergy */
  Allergy = 'allergy',
  /** Subscription paused automatically because multiple payments failed */
  AutomaticPauseReason = 'automatic_pause_reason',
  /** Break Issue */
  BreakIssue = 'break_issue',
  /** Cancelation reason */
  CancelReason = 'cancel_reason',
  /** Cancelation reason (legacy) */
  CancelReasonLegacy = 'cancel_reason_legacy',
  /** COVID-19 */
  CovidReason = 'covid_reason',
  /** CX credit/refund reason */
  CreditReason = 'credit_reason',
  /** CX credit/refund reason (legacy) */
  CreditReasonLegacy = 'credit_reason_legacy',
  /** Credit redeemed */
  CreditRedeemedReason = 'credit_redeemed_reason',
  /** Customer care issue */
  CustomerCareIssue = 'customer_care_issue',
  /** Delivery issue */
  DeliveryIssue = 'delivery_issue',
  /** Delivery schedule issue */
  DeliveryScheduleIssue = 'delivery_schedule_issue',
  /** Food brand */
  FoodBrand = 'food_brand',
  /** Food sensitivities */
  FoodSensitivities = 'food_sensitivities',
  /** Food type */
  FoodType = 'food_type',
  /** Dehydrated food */
  FoodTypeDehydrated = 'food_type_dehydrated',
  /** Freeze dried food */
  FoodTypeFreezeDried = 'food_type_freeze_dried',
  /** Fresh food */
  FoodTypeFresh = 'food_type_fresh',
  /** Kibble food */
  FoodTypeKibble = 'food_type_kibble',
  /** Prescription food */
  FoodTypePrescription = 'food_type_prescription',
  /** Raw food */
  FoodTypeRaw = 'food_type_raw',
  /** Wet food */
  FoodTypeWet = 'food_type_wet',
  /** Gift card remainder */
  GiftCardRemainderReason = 'gift_card_remainder_reason',
  /** Health issue */
  HealthIssue = 'health_issue',
  /** Ingredient */
  Ingredient = 'ingredient',
  /** Loyalty Customer Redeemed Points For Credits */
  LoyaltyCustomerRedeemedPointsForCreditsReason = 'loyalty_customer_redeemed_points_for_credits_reason',
  /** Meal quality issue */
  MealQualityIssue = 'meal_quality_issue',
  /** Pause reason */
  PauseReason = 'pause_reason',
  /** Pet food brand */
  PetFoodBrand = 'pet_food_brand',
  /** Prescription diet condition */
  PrescriptionDietCondition = 'prescription_diet_condition',
  /** Quantity issue */
  QuantityIssue = 'quantity_issue',
  /** Referral program */
  ReferralProgramReason = 'referral_program_reason',
  /** Replace order reason */
  ReplaceOrderReason = 'replace_order_reason',
  /** Replacement */
  ReplacementReason = 'replacement_reason',
  /** Secondary aliments */
  SecondaryAliments = 'secondary_aliments',
  /** Service issue */
  ServiceIssue = 'service_issue',
  /** Stripe Payment Gateway */
  Stripe = 'stripe',
  /** Taste response */
  TasteResponse = 'taste_response',
  /** Transition issue */
  TransitionIssue = 'transition_issue'
}

export type TypesUnsyncedDataTypeUnsyncedError = {
  __typename?: 'TypesUnsyncedDataTypeUnsyncedError';
  batchId: Scalars['ID'];
  error: Scalars['String'];
  id: Scalars['ID'];
};

export type TypesUnsyncedDataTypeUnsynchedOrders = {
  __typename?: 'TypesUnsyncedDataTypeUnsynchedOrders';
  count: Scalars['Int'];
  errors: Array<TypesUnsyncedDataTypeUnsyncedError>;
};

export type TypesUnsyncedDataTypeUnsynchedOrdersPaymentWithShopify = {
  __typename?: 'TypesUnsyncedDataTypeUnsynchedOrdersPaymentWithShopify';
  count: Scalars['Int'];
};

export type UnsyncedData = {
  __typename?: 'UnsyncedData';
  unsynchedOrders: TypesUnsyncedDataTypeUnsynchedOrders;
  unsynchedOrdersPaymentWithShopify: TypesUnsyncedDataTypeUnsynchedOrdersPaymentWithShopify;
};

export type User = {
  __typename?: 'User';
  acceptsMarketing?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Address>;
  addresses?: Maybe<Array<Address>>;
  cohorts?: Maybe<Array<Scalars['String']>>;
  completedSetup?: Maybe<Scalars['Boolean']>;
  confirmationSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  creditMovements?: Maybe<Array<StoreCreditMovement>>;
  currentSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  currentSignInIp?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  ensuredStoreCreditAccount: StoreCreditAccount;
  failedToSyncEmail?: Maybe<Scalars['Boolean']>;
  hasActiveSubs?: Maybe<Scalars['Boolean']>;
  hasFailedBilling: Scalars['Boolean'];
  hasSubscriptions?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  klaviyoUrl?: Maybe<Scalars['String']>;
  lastSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastSignInIp?: Maybe<Scalars['String']>;
  loyaltyPoints?: Maybe<Scalars['Int']>;
  loyaltyTier?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  notificationBanners: Array<NotificationBanner>;
  numberOfSubscriptions?: Maybe<Scalars['Int']>;
  /** Gets a Shopify order */
  orderDetail?: Maybe<ShopifyOrderDetail>;
  paymentMethods: Array<PaymentMethod>;
  payments: Array<PpPayment>;
  pets?: Maybe<Array<Pet>>;
  phoneNumber?: Maybe<Scalars['String']>;
  pupPoints?: Maybe<Scalars['Int']>;
  referrals?: Maybe<Scalars['Int']>;
  rememberCreatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  resetPasswordSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  roles?: Maybe<Array<Role>>;
  shopifyCustomers: Array<ShopifyCustomer>;
  shopifyId?: Maybe<Scalars['String']>;
  smsConsent?: Maybe<Scalars['Boolean']>;
  storeCreditAccount?: Maybe<StoreCreditAccount>;
  subscriptions: SubscriptionConnection;
  subscriptionsWithFailedBilling?: Maybe<Array<Scalars['String']>>;
  subscriptionsWithUpdatedFailedBilling?: Maybe<Array<Scalars['String']>>;
  tagListView?: Maybe<Array<UserTag>>;
  totalCreditAmount?: Maybe<Scalars['Float']>;
  uid?: Maybe<Scalars['String']>;
  unconfirmedEmail?: Maybe<Scalars['String']>;
  upcomingOrders?: Maybe<Array<DbOrder>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  userVisibleOrders: DbOrderConnection;
  v2Orders: Array<DbOrder>;
  vipTier?: Maybe<Scalars['String']>;
  zendeskUrl?: Maybe<Scalars['String']>;
};


export type UserOrderDetailArgs = {
  cartToken: Scalars['String'];
};


export type UserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  canceledAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  canceledAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  completedAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  completedAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  opsState?: InputMaybe<ResolversSubscriptionsResolverOpsState>;
  order?: InputMaybe<ResolversSubscriptionsResolverOrder>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  planType?: InputMaybe<BoxVariantPlanTypeEnum>;
  processed?: InputMaybe<Scalars['Boolean']>;
  renewals?: InputMaybe<Scalars['Int']>;
  scheduledShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  scheduledShippingDateFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  scheduledShippingDateTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TypesSubscriptionInputTypeState>;
  userId?: InputMaybe<Scalars['ID']>;
  userName?: InputMaybe<Scalars['String']>;
};


export type UserUserVisibleOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  amazonPoNumber?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<ResolversDbOrdersResolverChannel>;
  chewyPoNumber?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
  estimatedShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  humanizedState?: InputMaybe<OrderHumanizedState>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  opsState?: InputMaybe<ResolversDbOrdersResolverOpsState>;
  order?: InputMaybe<ResolversDbOrdersResolverOrder>;
  orderImportBatchEntryId?: InputMaybe<Scalars['ID']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<TypesDbOrderInputTypeState>;
  subscriptionId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of UserConfirmRegistrationWithToken. */
export type UserConfirmRegistrationWithTokenPayload = {
  __typename?: 'UserConfirmRegistrationWithTokenPayload';
  authenticatable: User;
  /** Authentication credentials. Null unless user is signed in after confirmation. */
  credentials?: Maybe<Credential>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of UserCreate */
export type UserCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userInput: UserInput;
};

/** Autogenerated return type of UserCreate. */
export type UserCreatePayload = {
  __typename?: 'UserCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  user: User;
};

/** Autogenerated input type of UserDelete */
export type UserDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UserDelete. */
export type UserDeletePayload = {
  __typename?: 'UserDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  user: User;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserInput = {
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<AddressInput>;
  addresses?: InputMaybe<Array<AddressInput>>;
  allowPasswordChange?: InputMaybe<Scalars['Boolean']>;
  confirmationSentAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  encryptedPassword?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  passwordConfirmation?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  rememberCreatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  resetPasswordSentAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  smsConsent?: InputMaybe<Scalars['Boolean']>;
  tagList?: InputMaybe<Array<UserTag>>;
  tokens?: InputMaybe<Scalars['JSON']>;
  uid?: InputMaybe<Scalars['String']>;
  unconfirmedEmail?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UserLogin. */
export type UserLoginPayload = {
  __typename?: 'UserLoginPayload';
  authenticatable: User;
  credentials: Credential;
};

/** Autogenerated return type of UserLogout. */
export type UserLogoutPayload = {
  __typename?: 'UserLogoutPayload';
  authenticatable: User;
};

/** Autogenerated input type of UserNewsletterSignUp */
export type UserNewsletterSignUpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

/** Autogenerated return type of UserNewsletterSignUp. */
export type UserNewsletterSignUpPayload = {
  __typename?: 'UserNewsletterSignUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of UserRegister. */
export type UserRegisterPayload = {
  __typename?: 'UserRegisterPayload';
  authenticatable: User;
  /**
   * Authentication credentials. Null if after signUp resource is not active for
   * authentication (e.g. Email confirmation required).
   */
  credentials?: Maybe<Credential>;
};

/** Autogenerated return type of UserResendConfirmationWithToken. */
export type UserResendConfirmationWithTokenPayload = {
  __typename?: 'UserResendConfirmationWithTokenPayload';
  message: Scalars['String'];
};

/** Autogenerated return type of UserResetPasswordWithToken. */
export type UserResetPasswordWithTokenPayload = {
  __typename?: 'UserResetPasswordWithTokenPayload';
  authenticatable: User;
  /** Authentication credentials. Resource must be signed_in for credentials to be returned. */
  credentials?: Maybe<Credential>;
};

/** Autogenerated return type of UserSendPasswordResetWithToken. */
export type UserSendPasswordResetWithTokenPayload = {
  __typename?: 'UserSendPasswordResetWithTokenPayload';
  message: Scalars['String'];
};

/** Autogenerated return type of UserSignUp. */
export type UserSignUpPayload = {
  __typename?: 'UserSignUpPayload';
  authenticatable: User;
  /**
   * Authentication credentials. Null if after signUp resource is not active for
   * authentication (e.g. Email confirmation required).
   */
  credentials?: Maybe<Credential>;
};

export enum UserTag {
  CustomPlan = 'custom_plan',
  Investor = 'investor',
  LoyalCustomer = 'loyal_customer',
  SuperCustomer = 'super_customer',
  Vipp = 'vipp'
}

/** Autogenerated input type of UserUpdate */
export type UserUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  userInput: UserInput;
};

/** Autogenerated return type of UserUpdatePasswordWithToken. */
export type UserUpdatePasswordWithTokenPayload = {
  __typename?: 'UserUpdatePasswordWithTokenPayload';
  authenticatable: User;
  /** Authentication credentials. Resource must be signed_in for credentials to be returned. */
  credentials?: Maybe<Credential>;
};

/** Autogenerated return type of UserUpdate. */
export type UserUpdatePayload = {
  __typename?: 'UserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  user: User;
};

export type V2Shipment = {
  __typename?: 'V2Shipment';
  createdAt: Scalars['ISO8601DateTime'];
  order?: Maybe<DbOrder>;
  shipmentEntry?: Maybe<ShipmentEntry>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for V2Shipment. */
export type V2ShipmentConnection = {
  __typename?: 'V2ShipmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<V2ShipmentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<V2Shipment>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of V2ShipmentCreate */
export type V2ShipmentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  v2ShipmentInput: V2ShipmentInput;
};

/** Autogenerated return type of V2ShipmentCreate. */
export type V2ShipmentCreatePayload = {
  __typename?: 'V2ShipmentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  v2Shipment: V2Shipment;
};

/** Autogenerated input type of V2ShipmentDelete */
export type V2ShipmentDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of V2ShipmentDelete. */
export type V2ShipmentDeletePayload = {
  __typename?: 'V2ShipmentDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  v2Shipment: V2Shipment;
};

/** An edge in a connection. */
export type V2ShipmentEdge = {
  __typename?: 'V2ShipmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<V2Shipment>;
};

export type V2ShipmentInput = {
  orderId: Scalars['Int'];
  shipmentEntryId: Scalars['Int'];
};

/** Autogenerated input type of V2ShipmentUpdate */
export type V2ShipmentUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  v2ShipmentInput: V2ShipmentInput;
};

/** Autogenerated return type of V2ShipmentUpdate. */
export type V2ShipmentUpdatePayload = {
  __typename?: 'V2ShipmentUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  v2Shipment: V2Shipment;
};

/** Autogenerated input type of VerifyCaptchaToken */
export type VerifyCaptchaTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

/** Autogenerated return type of VerifyCaptchaToken. */
export type VerifyCaptchaTokenPayload = {
  __typename?: 'VerifyCaptchaTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  score?: Maybe<Scalars['Float']>;
  success: Scalars['Boolean'];
};

export enum VersionedModelClassEnum {
  Address = 'Address',
  Box = 'Box',
  BoxVariant = 'BoxVariant',
  CancellationSurvey = 'CancellationSurvey',
  Meal = 'Meal',
  MealLineItem = 'MealLineItem',
  MealVariant = 'MealVariant',
  Packaging = 'Packaging',
  PauseSurvey = 'PauseSurvey',
  Payment = 'Payment',
  PaymentMethod = 'PaymentMethod',
  Pet = 'Pet',
  PlanCompatibilityCriterium = 'PlanCompatibilityCriterium',
  PlanMatchCriterium = 'PlanMatchCriterium',
  Product = 'Product',
  ProductVariant = 'ProductVariant',
  ShipmentEntry = 'ShipmentEntry',
  StoreCreditAccount = 'StoreCreditAccount',
  StoreCreditMovement = 'StoreCreditMovement',
  Subscription = 'Subscription',
  Term = 'Term',
  User = 'User',
  V2Order = 'V2__Order',
  V2Payment = 'V2__Payment',
  V2Shipment = 'V2__Shipment'
}

export type WeeklyStats = {
  __typename?: 'WeeklyStats';
  date: Scalars['ISO8601Date'];
  stats: CountStats;
};

export type WellnessGoal = {
  __typename?: 'WellnessGoal';
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** The connection type for WellnessGoal. */
export type WellnessGoalConnection = {
  __typename?: 'WellnessGoalConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WellnessGoalEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WellnessGoal>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of WellnessGoalCreate */
export type WellnessGoalCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  wellnessGoalInput: WellnessGoalInput;
};

/** Autogenerated return type of WellnessGoalCreate. */
export type WellnessGoalCreatePayload = {
  __typename?: 'WellnessGoalCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  wellnessGoal: WellnessGoal;
};

/** Autogenerated input type of WellnessGoalDelete */
export type WellnessGoalDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of WellnessGoalDelete. */
export type WellnessGoalDeletePayload = {
  __typename?: 'WellnessGoalDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  wellnessGoal: WellnessGoal;
};

/** An edge in a connection. */
export type WellnessGoalEdge = {
  __typename?: 'WellnessGoalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<WellnessGoal>;
};

export type WellnessGoalInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export enum WellnessGoalOrder {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

/** Autogenerated input type of WellnessGoalUpdate */
export type WellnessGoalUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  wellnessGoalInput: WellnessGoalInput;
};

/** Autogenerated return type of WellnessGoalUpdate. */
export type WellnessGoalUpdatePayload = {
  __typename?: 'WellnessGoalUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  wellnessGoal: WellnessGoal;
};

export type Wysiwyg = {
  __typename?: 'Wysiwyg';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<Wysiwyg_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['JSON']>;
};


export type WysiwygContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type WysiwygTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Wysiwyg_BlockSettings = {
  __typename?: 'Wysiwyg_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<Wysiwyg_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<Wysiwyg_BlockSettings_ResponsiveStyles>>;
};

export type Wysiwyg_BlockSettings_ResponsiveStyles = {
  __typename?: 'Wysiwyg_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<Wysiwyg_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<Wysiwyg_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<Wysiwyg_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum Wysiwyg_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum Wysiwyg_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum Wysiwyg_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum Wysiwyg_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type YotpoReviewsCarousel = {
  __typename?: 'YotpoReviewsCarousel';
  backgroundColor?: Maybe<YotpoReviewsCarousel_BackgroundColor>;
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<YotpoReviewsCarousel_BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  buttonPosition?: Maybe<YotpoReviewsCarousel_ButtonPosition>;
  buttons?: Maybe<Array<YotpoReviewsCarousel_Buttons>>;
  id?: Maybe<Scalars['String']>;
  reviewType?: Maybe<YotpoReviewsCarousel_ReviewType>;
  showArrows?: Maybe<Scalars['Boolean']>;
  sku?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['JSON']>;
  textAlignment?: Maybe<YotpoReviewsCarousel_TextAlignment>;
  title?: Maybe<Scalars['JSON']>;
};


export type YotpoReviewsCarouselSubtitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type YotpoReviewsCarouselTitleArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type YotpoReviewsCarousel_BlockSettings = {
  __typename?: 'YotpoReviewsCarousel_BlockSettings';
  anchorId?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<YotpoReviewsCarousel_BlockSettings_MaxWidth>;
  responsiveStyles?: Maybe<Array<YotpoReviewsCarousel_BlockSettings_ResponsiveStyles>>;
};

export type YotpoReviewsCarousel_BlockSettings_ResponsiveStyles = {
  __typename?: 'YotpoReviewsCarousel_BlockSettings_ResponsiveStyles';
  breakpoint?: Maybe<YotpoReviewsCarousel_BlockSettings_ResponsiveStyles_Breakpoint>;
  id?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<YotpoReviewsCarousel_BlockSettings_ResponsiveStyles_MarginBottom>;
  marginTop?: Maybe<YotpoReviewsCarousel_BlockSettings_ResponsiveStyles_MarginTop>;
};

export enum YotpoReviewsCarousel_BlockSettings_ResponsiveStyles_Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs'
}

export enum YotpoReviewsCarousel_BlockSettings_ResponsiveStyles_MarginBottom {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum YotpoReviewsCarousel_BlockSettings_ResponsiveStyles_MarginTop {
  '0' = '_0',
  '4' = '_4',
  '6' = '_6',
  '8' = '_8',
  '10' = '_10',
  '11' = '_11',
  '12' = '_12',
  '13' = '_13'
}

export enum YotpoReviewsCarousel_BlockSettings_MaxWidth {
  '768px' = '_768px',
  '1100px' = '_1100px',
  '1400px' = '_1400px',
  None = 'none'
}

export type YotpoReviewsCarousel_Buttons = {
  __typename?: 'YotpoReviewsCarousel_Buttons';
  button?: Maybe<YotpoReviewsCarousel_Buttons_Button>;
  id?: Maybe<Scalars['String']>;
};

export type YotpoReviewsCarousel_Buttons_Button = {
  __typename?: 'YotpoReviewsCarousel_Buttons_Button';
  cmsIcon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<YotpoReviewsCarousel_Buttons_Button_Link>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<YotpoReviewsCarousel_Buttons_Button_Variant>;
};

export type YotpoReviewsCarousel_Buttons_Button_Link = {
  __typename?: 'YotpoReviewsCarousel_Buttons_Button_Link';
  absoluteUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<YotpoReviewsCarousel_Buttons_Button_Link_LinkType>;
  page?: Maybe<Cms_Page>;
  stripQueryParams?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum YotpoReviewsCarousel_Buttons_Button_Link_LinkType {
  AbsoluteUrl = 'absoluteUrl',
  Page = 'page'
}

export enum YotpoReviewsCarousel_Buttons_Button_Variant {
  Primary = 'primary',
  Secondary = 'secondary'
}

export enum YotpoReviewsCarousel_BackgroundColor {
  Blue = 'blue',
  Neutral = 'neutral',
  White = 'white'
}

export enum YotpoReviewsCarousel_ButtonPosition {
  BottomRight = 'bottomRight',
  TopLeft = 'topLeft'
}

export enum YotpoReviewsCarousel_ReviewType {
  Company = 'company',
  Product = 'product',
  Supplements = 'supplements',
  Treats = 'treats'
}

export enum YotpoReviewsCarousel_TextAlignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export type ZipCode = {
  __typename?: 'ZipCode';
  chargeSalesTax: Scalars['Boolean'];
  city?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  salesTaxRate: Scalars['Float'];
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  zipCode?: Maybe<Scalars['String']>;
};

/** The connection type for ZipCode. */
export type ZipCodeConnection = {
  __typename?: 'ZipCodeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ZipCodeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ZipCode>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of ZipCodeCreate */
export type ZipCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  zipCodeInput: ZipCodeInput;
};

/** Autogenerated return type of ZipCodeCreate. */
export type ZipCodeCreatePayload = {
  __typename?: 'ZipCodeCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  zipCode: ZipCode;
};

/** Autogenerated input type of ZipCodeDelete */
export type ZipCodeDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ZipCodeDelete. */
export type ZipCodeDeletePayload = {
  __typename?: 'ZipCodeDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  zipCode: ZipCode;
};

/** An edge in a connection. */
export type ZipCodeEdge = {
  __typename?: 'ZipCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ZipCode>;
};

export type ZipCodeInput = {
  chargeSalesTax?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  salesTaxRate?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ZipCodeLocation = {
  __typename?: 'ZipCodeLocation';
  city: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  latitude: Scalars['String'];
  longitude: Scalars['String'];
  state: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  zipCode: Scalars['String'];
};

/** The connection type for ZipCodeLocation. */
export type ZipCodeLocationConnection = {
  __typename?: 'ZipCodeLocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ZipCodeLocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ZipCodeLocation>>>;
  /** Information to aid in pagination. */
  pageInfo: PpPageInfo;
};

/** Autogenerated input type of ZipCodeLocationCreate */
export type ZipCodeLocationCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  zipCodeLocationInput: ZipCodeLocationInput;
};

/** Autogenerated return type of ZipCodeLocationCreate. */
export type ZipCodeLocationCreatePayload = {
  __typename?: 'ZipCodeLocationCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  zipCodeLocation: ZipCodeLocation;
};

/** Autogenerated input type of ZipCodeLocationDelete */
export type ZipCodeLocationDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ZipCodeLocationDelete. */
export type ZipCodeLocationDeletePayload = {
  __typename?: 'ZipCodeLocationDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  zipCodeLocation: ZipCodeLocation;
};

/** An edge in a connection. */
export type ZipCodeLocationEdge = {
  __typename?: 'ZipCodeLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ZipCodeLocation>;
};

export type ZipCodeLocationInput = {
  city?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of ZipCodeLocationUpdate */
export type ZipCodeLocationUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  zipCodeLocationInput: ZipCodeLocationInput;
};

/** Autogenerated return type of ZipCodeLocationUpdate. */
export type ZipCodeLocationUpdatePayload = {
  __typename?: 'ZipCodeLocationUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  zipCodeLocation: ZipCodeLocation;
};

/** Autogenerated input type of ZipCodeUpdate */
export type ZipCodeUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  zipCodeInput: ZipCodeInput;
};

/** Autogenerated return type of ZipCodeUpdate. */
export type ZipCodeUpdatePayload = {
  __typename?: 'ZipCodeUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  zipCode: ZipCode;
};

export type Cms_MediaAccess = {
  __typename?: 'cms_mediaAccess';
  create?: Maybe<Cms_MediaCreateAccess>;
  delete?: Maybe<Cms_MediaDeleteAccess>;
  fields?: Maybe<Cms_MediaFields>;
  read?: Maybe<Cms_MediaReadAccess>;
  update?: Maybe<Cms_MediaUpdateAccess>;
};

export type Cms_MediaDocAccess = {
  __typename?: 'cms_mediaDocAccess';
  create?: Maybe<Cms_MediaCreateDocAccess>;
  delete?: Maybe<Cms_MediaDeleteDocAccess>;
  fields?: Maybe<Cms_MediaDocAccessFields>;
  read?: Maybe<Cms_MediaReadDocAccess>;
  update?: Maybe<Cms_MediaUpdateDocAccess>;
};

export type Cms_PageAccess = {
  __typename?: 'cms_pageAccess';
  create?: Maybe<Cms_PageCreateAccess>;
  delete?: Maybe<Cms_PageDeleteAccess>;
  fields?: Maybe<Cms_PageFields>;
  read?: Maybe<Cms_PageReadAccess>;
  readVersions?: Maybe<Cms_PageReadVersionsAccess>;
  update?: Maybe<Cms_PageUpdateAccess>;
};

export type Cms_PageDocAccess = {
  __typename?: 'cms_pageDocAccess';
  create?: Maybe<Cms_PageCreateDocAccess>;
  delete?: Maybe<Cms_PageDeleteDocAccess>;
  fields?: Maybe<Cms_PageDocAccessFields>;
  read?: Maybe<Cms_PageReadDocAccess>;
  readVersions?: Maybe<Cms_PageReadVersionsDocAccess>;
  update?: Maybe<Cms_PageUpdateDocAccess>;
};

export type FooterAccess = {
  __typename?: 'footerAccess';
  fields?: Maybe<FooterFields>;
  read?: Maybe<FooterReadAccess>;
  update?: Maybe<FooterUpdateAccess>;
};

export type FooterDocAccess = {
  __typename?: 'footerDocAccess';
  fields?: Maybe<FooterDocAccessFields>;
  read?: Maybe<FooterReadDocAccess>;
  update?: Maybe<FooterUpdateDocAccess>;
};

export enum Join__Graph {
  Api = 'API',
  Cms = 'CMS'
}

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

export type MutationCms_MediaInput = {
  alt?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  sizes?: InputMaybe<MutationCms_Media_SizesInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationCms_MediaUpdateInput = {
  alt?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  sizes?: InputMaybe<MutationCms_MediaUpdate_SizesInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationCms_MediaUpdate_SizesInput = {
  card?: InputMaybe<MutationCms_MediaUpdate_Sizes_CardInput>;
  tablet?: InputMaybe<MutationCms_MediaUpdate_Sizes_TabletInput>;
  thumbnail?: InputMaybe<MutationCms_MediaUpdate_Sizes_ThumbnailInput>;
};

export type MutationCms_MediaUpdate_Sizes_CardInput = {
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationCms_MediaUpdate_Sizes_TabletInput = {
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationCms_MediaUpdate_Sizes_ThumbnailInput = {
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationCms_Media_SizesInput = {
  card?: InputMaybe<MutationCms_Media_Sizes_CardInput>;
  tablet?: InputMaybe<MutationCms_Media_Sizes_TabletInput>;
  thumbnail?: InputMaybe<MutationCms_Media_Sizes_ThumbnailInput>;
};

export type MutationCms_Media_Sizes_CardInput = {
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationCms_Media_Sizes_TabletInput = {
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationCms_Media_Sizes_ThumbnailInput = {
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationCms_PageInput = {
  _status?: InputMaybe<Cms_Page__Status_MutationInput>;
  breadcrumbs?: InputMaybe<Array<InputMaybe<MutationCms_Page_BreadcrumbsInput>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Scalars['JSON']>;
  meta?: InputMaybe<MutationCms_Page_MetaInput>;
  parent?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCms_PageUpdateInput = {
  _status?: InputMaybe<Cms_PageUpdate__Status_MutationInput>;
  breadcrumbs?: InputMaybe<Array<InputMaybe<MutationCms_PageUpdate_BreadcrumbsInput>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Scalars['JSON']>;
  meta?: InputMaybe<MutationCms_PageUpdate_MetaInput>;
  parent?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCms_PageUpdate_BreadcrumbsInput = {
  doc?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type MutationCms_PageUpdate_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationCms_Page_BreadcrumbsInput = {
  doc?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type MutationCms_Page_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationFooterInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<Array<InputMaybe<MutationFooter_SectionsInput>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationFooter_SectionsInput = {
  header: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<InputMaybe<MutationFooter_Sections_LinksInput>>>;
};

export type MutationFooter_Sections_LinksInput = {
  id?: InputMaybe<Scalars['String']>;
  isLinkPrefetched?: InputMaybe<Scalars['Boolean']>;
  stripQueryParams?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type MutationNavInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<InputMaybe<MutationNav_LinksInput>>>;
  sections?: InputMaybe<Array<InputMaybe<MutationNav_SectionsInput>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationNav_LinksInput = {
  id?: InputMaybe<Scalars['String']>;
  isLinkPrefetched?: InputMaybe<Scalars['Boolean']>;
  stripQueryParams?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type MutationNav_SectionsInput = {
  header: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<InputMaybe<MutationNav_Sections_LinksInput>>>;
};

export type MutationNav_Sections_LinksInput = {
  id?: InputMaybe<Scalars['String']>;
  isLinkPrefetched?: InputMaybe<Scalars['Boolean']>;
  stripQueryParams?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type MutationPayloadPreferenceInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type MutationPayloadPreferenceUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type NavAccess = {
  __typename?: 'navAccess';
  fields?: Maybe<NavFields>;
  read?: Maybe<NavReadAccess>;
  update?: Maybe<NavUpdateAccess>;
};

export type NavDocAccess = {
  __typename?: 'navDocAccess';
  fields?: Maybe<NavDocAccessFields>;
  read?: Maybe<NavReadDocAccess>;
  update?: Maybe<NavUpdateDocAccess>;
};

export type Payload_PreferencesAccess = {
  __typename?: 'payload_preferencesAccess';
  create?: Maybe<PayloadPreferencesCreateAccess>;
  delete?: Maybe<PayloadPreferencesDeleteAccess>;
  fields?: Maybe<PayloadPreferencesFields>;
  read?: Maybe<PayloadPreferencesReadAccess>;
  update?: Maybe<PayloadPreferencesUpdateAccess>;
};

export type Payload_PreferencesDocAccess = {
  __typename?: 'payload_preferencesDocAccess';
  create?: Maybe<PayloadPreferencesCreateDocAccess>;
  delete?: Maybe<PayloadPreferencesDeleteDocAccess>;
  fields?: Maybe<PayloadPreferencesDocAccessFields>;
  read?: Maybe<PayloadPreferencesReadDocAccess>;
  update?: Maybe<PayloadPreferencesUpdateDocAccess>;
};

export type VersionsCms_Page_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsCms_Page_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsCms_Page_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsCms_Page_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsCms_Page_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export enum VersionsCms_Page_Version___Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export type VersionsCms_Page_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCms_Page_Version___Status_Input>>>;
  equals?: InputMaybe<VersionsCms_Page_Version___Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<VersionsCms_Page_Version___Status_Input>>>;
  not_equals?: InputMaybe<VersionsCms_Page_Version___Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<VersionsCms_Page_Version___Status_Input>>>;
};

export type VersionsCms_Page_Version__Breadcrumbs__Doc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsCms_Page_Version__Breadcrumbs__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsCms_Page_Version__Breadcrumbs__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsCms_Page_Version__Breadcrumbs__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsCms_Page_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsCms_Page_Version__Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type VersionsCms_Page_Version__Meta__Keywords_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsCms_Page_Version__Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsCms_Page_Version__Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsCms_Page_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsCms_Page_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsCms_Page_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsCms_Page_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCms_Page_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsCms_Page_Where_Or>>>;
  createdAt?: InputMaybe<VersionsCms_Page_CreatedAt_Operator>;
  id?: InputMaybe<VersionsCms_Page_Id_Operator>;
  latest?: InputMaybe<VersionsCms_Page_Latest_Operator>;
  parent?: InputMaybe<VersionsCms_Page_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsCms_Page_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsCms_Page_Version___Status_Operator>;
  version__breadcrumbs__doc?: InputMaybe<VersionsCms_Page_Version__Breadcrumbs__Doc_Operator>;
  version__breadcrumbs__id?: InputMaybe<VersionsCms_Page_Version__Breadcrumbs__Id_Operator>;
  version__breadcrumbs__label?: InputMaybe<VersionsCms_Page_Version__Breadcrumbs__Label_Operator>;
  version__breadcrumbs__url?: InputMaybe<VersionsCms_Page_Version__Breadcrumbs__Url_Operator>;
  version__createdAt?: InputMaybe<VersionsCms_Page_Version__CreatedAt_Operator>;
  version__meta__description?: InputMaybe<VersionsCms_Page_Version__Meta__Description_Operator>;
  version__meta__keywords?: InputMaybe<VersionsCms_Page_Version__Meta__Keywords_Operator>;
  version__meta__title?: InputMaybe<VersionsCms_Page_Version__Meta__Title_Operator>;
  version__parent?: InputMaybe<VersionsCms_Page_Version__Parent_Operator>;
  version__slug?: InputMaybe<VersionsCms_Page_Version__Slug_Operator>;
  version__title?: InputMaybe<VersionsCms_Page_Version__Title_Operator>;
  version__updatedAt?: InputMaybe<VersionsCms_Page_Version__UpdatedAt_Operator>;
};

export type VersionsCms_Page_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCms_Page_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsCms_Page_Where_Or>>>;
  createdAt?: InputMaybe<VersionsCms_Page_CreatedAt_Operator>;
  id?: InputMaybe<VersionsCms_Page_Id_Operator>;
  latest?: InputMaybe<VersionsCms_Page_Latest_Operator>;
  parent?: InputMaybe<VersionsCms_Page_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsCms_Page_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsCms_Page_Version___Status_Operator>;
  version__breadcrumbs__doc?: InputMaybe<VersionsCms_Page_Version__Breadcrumbs__Doc_Operator>;
  version__breadcrumbs__id?: InputMaybe<VersionsCms_Page_Version__Breadcrumbs__Id_Operator>;
  version__breadcrumbs__label?: InputMaybe<VersionsCms_Page_Version__Breadcrumbs__Label_Operator>;
  version__breadcrumbs__url?: InputMaybe<VersionsCms_Page_Version__Breadcrumbs__Url_Operator>;
  version__createdAt?: InputMaybe<VersionsCms_Page_Version__CreatedAt_Operator>;
  version__meta__description?: InputMaybe<VersionsCms_Page_Version__Meta__Description_Operator>;
  version__meta__keywords?: InputMaybe<VersionsCms_Page_Version__Meta__Keywords_Operator>;
  version__meta__title?: InputMaybe<VersionsCms_Page_Version__Meta__Title_Operator>;
  version__parent?: InputMaybe<VersionsCms_Page_Version__Parent_Operator>;
  version__slug?: InputMaybe<VersionsCms_Page_Version__Slug_Operator>;
  version__title?: InputMaybe<VersionsCms_Page_Version__Title_Operator>;
  version__updatedAt?: InputMaybe<VersionsCms_Page_Version__UpdatedAt_Operator>;
};

export type VersionsCms_Page_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCms_Page_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsCms_Page_Where_Or>>>;
  createdAt?: InputMaybe<VersionsCms_Page_CreatedAt_Operator>;
  id?: InputMaybe<VersionsCms_Page_Id_Operator>;
  latest?: InputMaybe<VersionsCms_Page_Latest_Operator>;
  parent?: InputMaybe<VersionsCms_Page_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsCms_Page_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsCms_Page_Version___Status_Operator>;
  version__breadcrumbs__doc?: InputMaybe<VersionsCms_Page_Version__Breadcrumbs__Doc_Operator>;
  version__breadcrumbs__id?: InputMaybe<VersionsCms_Page_Version__Breadcrumbs__Id_Operator>;
  version__breadcrumbs__label?: InputMaybe<VersionsCms_Page_Version__Breadcrumbs__Label_Operator>;
  version__breadcrumbs__url?: InputMaybe<VersionsCms_Page_Version__Breadcrumbs__Url_Operator>;
  version__createdAt?: InputMaybe<VersionsCms_Page_Version__CreatedAt_Operator>;
  version__meta__description?: InputMaybe<VersionsCms_Page_Version__Meta__Description_Operator>;
  version__meta__keywords?: InputMaybe<VersionsCms_Page_Version__Meta__Keywords_Operator>;
  version__meta__title?: InputMaybe<VersionsCms_Page_Version__Meta__Title_Operator>;
  version__parent?: InputMaybe<VersionsCms_Page_Version__Parent_Operator>;
  version__slug?: InputMaybe<VersionsCms_Page_Version__Slug_Operator>;
  version__title?: InputMaybe<VersionsCms_Page_Version__Title_Operator>;
  version__updatedAt?: InputMaybe<VersionsCms_Page_Version__UpdatedAt_Operator>;
};

export type VersionsCms_Pages = {
  __typename?: 'versionsCms_pages';
  docs?: Maybe<Array<Maybe<Cms_PageVersion>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type RecommendedProductFragment = { __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null };

export type RecommendedBoxFragment = { __typename?: 'PetBox', recommendationScore?: number | null, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string, sku: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, planType?: BoxVariantPlanTypeEnum | null, recommended: boolean, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } };

export type RecWizardAttrsFragment = { __typename?: 'RecommendationWizard', id: string, petName?: string | null, petId?: number | null, userId?: number | null, activityLevel?: string | null, attributions?: any | null, birthDate?: any | null, breedType: string, contactEmail?: string | null, contactName?: string | null, contactPhoneNumber?: string | null, couponsData?: any | null, weight?: number | null, gender?: string | null, spayedNeutered?: boolean | null, primaryBreedId?: number | null, secondaryBreedId?: number | null, waistline?: string | null, wellnessGoalIds?: Array<string> | null, ingredientIds?: Array<string> | null, hasFoodSensitivities?: boolean | null, preferenceIds: Array<string>, recipeIds: Array<string>, recipeSkus?: Array<string> | null, planId?: number | null, planType?: RecommendationWizardPlanTypeEnum | null, latestStep?: string | null, recommendedCaloriesPerDay?: number | null, subscriptionId?: number | null, guestToken?: string | null, shopifyId?: string | null, lineItemsData: Array<{ __typename?: 'AddonLineItem', quantity: number, shopifyId: string, sku: string, discount: number, price: number, recurring: boolean, type: string }>, recommendedRecipeLineItems: Array<{ __typename?: 'RecommendedRecipeLineItem', sku: string, shopifyId: string, quantity: number }>, plan: { __typename?: 'BoxVariant', sku?: string | null, name: string, planType?: BoxVariantPlanTypeEnum | null, addonUnits: number, box?: { __typename?: 'Box', bagQuantity?: number | null, itemQuantity: number } | null }, selectedBreedOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null, selectedWellnessGoalOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null, selectedRecipeOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null };

export type RecommendationsFragment = { __typename?: 'RecommendationWizard', planRecommendations?: { __typename?: 'PlanRecommendation', caloriesPerDay?: number | null, boxes: { __typename?: 'RecommendationBoxes', fullBox?: { __typename?: 'PetBox', recommendationScore?: number | null, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string, sku: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, planType?: BoxVariantPlanTypeEnum | null, recommended: boolean, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null, topperBox?: { __typename?: 'PetBox', recommendationScore?: number | null, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string, sku: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, planType?: BoxVariantPlanTypeEnum | null, recommended: boolean, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null, comboBox?: { __typename?: 'PetBox', recommendationScore?: number | null, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string, sku: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, planType?: BoxVariantPlanTypeEnum | null, recommended: boolean, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null, freshBakedBox?: { __typename?: 'PetBox', recommendationScore?: number | null, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string, sku: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, planType?: BoxVariantPlanTypeEnum | null, recommended: boolean, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null } } | null, recommendedRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null, recommendedAddons?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null, recommendedComboRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null };

export type SubflowSignInMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type SubflowSignInMutation = { __typename?: 'Mutation', userLogin?: { __typename?: 'UserLoginPayload', credentials: { __typename?: 'Credential', accessToken: string, client: string, expiry: number, tokenType: string, uid: string }, authenticatable: { __typename?: 'User', id?: string | null, uid?: string | null, name?: string | null, hasSubscriptions?: boolean | null } } | null };

export type UpdateRecWizardMutationVariables = Exact<{
  id: Scalars['ID'];
  input: RecommendationWizardInput;
}>;


export type UpdateRecWizardMutation = { __typename?: 'Mutation', recommendationWizardUpdate?: { __typename?: 'RecommendationWizardUpdatePayload', recommendationWizard: { __typename?: 'RecommendationWizard', id: string, petName?: string | null, petId?: number | null, userId?: number | null, activityLevel?: string | null, attributions?: any | null, birthDate?: any | null, breedType: string, contactEmail?: string | null, contactName?: string | null, contactPhoneNumber?: string | null, couponsData?: any | null, weight?: number | null, gender?: string | null, spayedNeutered?: boolean | null, primaryBreedId?: number | null, secondaryBreedId?: number | null, waistline?: string | null, wellnessGoalIds?: Array<string> | null, ingredientIds?: Array<string> | null, hasFoodSensitivities?: boolean | null, preferenceIds: Array<string>, recipeIds: Array<string>, recipeSkus?: Array<string> | null, planId?: number | null, planType?: RecommendationWizardPlanTypeEnum | null, latestStep?: string | null, recommendedCaloriesPerDay?: number | null, subscriptionId?: number | null, guestToken?: string | null, shopifyId?: string | null, lineItemsData: Array<{ __typename?: 'AddonLineItem', quantity: number, shopifyId: string, sku: string, discount: number, price: number, recurring: boolean, type: string }>, recommendedRecipeLineItems: Array<{ __typename?: 'RecommendedRecipeLineItem', sku: string, shopifyId: string, quantity: number }>, plan: { __typename?: 'BoxVariant', sku?: string | null, name: string, planType?: BoxVariantPlanTypeEnum | null, addonUnits: number, box?: { __typename?: 'Box', bagQuantity?: number | null, itemQuantity: number } | null }, selectedBreedOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null, selectedWellnessGoalOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null, selectedRecipeOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null, planRecommendations?: { __typename?: 'PlanRecommendation', caloriesPerDay?: number | null, boxes: { __typename?: 'RecommendationBoxes', fullBox?: { __typename?: 'PetBox', recommendationScore?: number | null, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string, sku: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, planType?: BoxVariantPlanTypeEnum | null, recommended: boolean, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null, topperBox?: { __typename?: 'PetBox', recommendationScore?: number | null, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string, sku: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, planType?: BoxVariantPlanTypeEnum | null, recommended: boolean, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null, comboBox?: { __typename?: 'PetBox', recommendationScore?: number | null, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string, sku: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, planType?: BoxVariantPlanTypeEnum | null, recommended: boolean, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null, freshBakedBox?: { __typename?: 'PetBox', recommendationScore?: number | null, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string, sku: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, planType?: BoxVariantPlanTypeEnum | null, recommended: boolean, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null } } | null, recommendedRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null, recommendedAddons?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null, recommendedComboRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null } } | null };

export type UpdateRecWizardUserMutationVariables = Exact<{
  id: Scalars['ID'];
  input: RecommendationWizardInput;
}>;


export type UpdateRecWizardUserMutation = { __typename?: 'Mutation', recommendationWizardUpdate?: { __typename?: 'RecommendationWizardUpdatePayload', recommendationWizard: { __typename?: 'RecommendationWizard', id: string, userId?: number | null, contactEmail?: string | null } } | null };

export type CreateRecWizardMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']>;
}>;


export type CreateRecWizardMutation = { __typename?: 'Mutation', recommendationWizardCreate?: { __typename?: 'RecommendationWizardCreatePayload', recommendationWizard: { __typename?: 'RecommendationWizard', id: string, petName?: string | null, petId?: number | null, userId?: number | null, activityLevel?: string | null, attributions?: any | null, birthDate?: any | null, breedType: string, contactEmail?: string | null, contactName?: string | null, contactPhoneNumber?: string | null, couponsData?: any | null, weight?: number | null, gender?: string | null, spayedNeutered?: boolean | null, primaryBreedId?: number | null, secondaryBreedId?: number | null, waistline?: string | null, wellnessGoalIds?: Array<string> | null, ingredientIds?: Array<string> | null, hasFoodSensitivities?: boolean | null, preferenceIds: Array<string>, recipeIds: Array<string>, recipeSkus?: Array<string> | null, planId?: number | null, planType?: RecommendationWizardPlanTypeEnum | null, latestStep?: string | null, recommendedCaloriesPerDay?: number | null, subscriptionId?: number | null, guestToken?: string | null, shopifyId?: string | null, lineItemsData: Array<{ __typename?: 'AddonLineItem', quantity: number, shopifyId: string, sku: string, discount: number, price: number, recurring: boolean, type: string }>, recommendedRecipeLineItems: Array<{ __typename?: 'RecommendedRecipeLineItem', sku: string, shopifyId: string, quantity: number }>, plan: { __typename?: 'BoxVariant', sku?: string | null, name: string, planType?: BoxVariantPlanTypeEnum | null, addonUnits: number, box?: { __typename?: 'Box', bagQuantity?: number | null, itemQuantity: number } | null }, selectedBreedOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null, selectedWellnessGoalOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null, selectedRecipeOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null } } | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', me: { __typename?: 'User', id?: string | null, uid?: string | null, name?: string | null, email?: string | null, hasSubscriptions?: boolean | null, numberOfSubscriptions?: number | null } };

export type CheckDiscountQueryVariables = Exact<{
  codes: Array<Scalars['String']> | Scalars['String'];
}>;


export type CheckDiscountQuery = { __typename?: 'Query', shopifyDiscountInfo: Array<{ __typename?: 'ShopifyDiscountInfo', id?: string | null, status?: ShopifyDiscountStatusEnum | null, title?: string | null, amount?: number | null, percentage?: number | null, customPromoText?: string | null, inferredBannerText?: string | null, affectsClass?: ShopifyDiscountAffectsClass | null, affectedProductSkus?: Array<string> | null, affectedCollections?: Array<string> | null }> };

export type GetSettingsQueryVariables = Exact<{
  vars?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetSettingsQuery = { __typename?: 'Query', settings?: Array<{ __typename?: 'SettingsSearchResult', key: string, value?: { __typename?: 'Coupon', id: string, code?: string | null, percentOff?: number | null, amountOff?: number | null, maskedCode?: string | null, customPromoText?: string | null, inferredBannerText?: string | null, affectsClass?: ShopifyDiscountAffectsClass | null, affectedProductSkus?: Array<string> | null, affectedCollections?: Array<string> | null } | { __typename?: 'Setting' } | null }> | null };

export type GetPlanPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlanPreferencesQuery = { __typename?: 'Query', planCompatibilityCriteria: { __typename?: 'PlanCompatibilityCriteriumConnection', nodes?: Array<{ __typename?: 'PlanCompatibilityCriterium', id: string, name: string } | null> | null } };

export type GetRecommendationsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetRecommendationsQuery = { __typename?: 'Query', recommendationWizard: { __typename?: 'RecommendationWizard', planRecommendations?: { __typename?: 'PlanRecommendation', caloriesPerDay?: number | null, boxes: { __typename?: 'RecommendationBoxes', fullBox?: { __typename?: 'PetBox', recommendationScore?: number | null, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string, sku: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, planType?: BoxVariantPlanTypeEnum | null, recommended: boolean, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null, topperBox?: { __typename?: 'PetBox', recommendationScore?: number | null, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string, sku: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, planType?: BoxVariantPlanTypeEnum | null, recommended: boolean, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null, comboBox?: { __typename?: 'PetBox', recommendationScore?: number | null, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string, sku: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, planType?: BoxVariantPlanTypeEnum | null, recommended: boolean, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null, freshBakedBox?: { __typename?: 'PetBox', recommendationScore?: number | null, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string, sku: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, planType?: BoxVariantPlanTypeEnum | null, recommended: boolean, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null } } | null, recommendedRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null, recommendedAddons?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null, recommendedComboRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null } };

export type GetBreedsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type GetBreedsQuery = { __typename?: 'Query', breeds: { __typename?: 'BreedConnection', nodes?: Array<{ __typename?: 'Breed', id: string, name: string } | null> | null } };

export type GetPetsServedByBreedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPetsServedByBreedQuery = { __typename?: 'Query', petsServed: { __typename?: 'PetsServed', countPerBreed: Array<{ __typename?: 'TypesPetsServedTypePetCountPerBreed', id: string, count: number }> } };

export type GetPetsServedByAgeGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPetsServedByAgeGroupQuery = { __typename?: 'Query', petsServed: { __typename?: 'PetsServed', countPerAgeGroup: Array<{ __typename?: 'TypesPetsServedTypePetCountPerAgeGroup', ageGroup: TypesPetsServedTypePetAgeGroup, count: number }> } };

export type BreedAgeDataQueryVariables = Exact<{
  breedId: Scalars['String'];
}>;


export type BreedAgeDataQuery = { __typename?: 'Query', breed: { __typename?: 'Breed', name: string, sizeClass?: string | null }, sizeClasses: { __typename?: 'SizeClassConnection', nodes?: Array<{ __typename?: 'SizeClass', ageOfMaturity?: number | null, ageOfSeniority?: number | null, lifeExpectancy?: number | null, maxWeight?: number | null, name?: string | null } | null> | null } };

export type GetFoodSensitivityOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFoodSensitivityOptionsQuery = { __typename?: 'Query', ingredients: { __typename?: 'IngredientConnection', nodes?: Array<{ __typename?: 'Ingredient', id: string, name: string } | null> | null }, wellnessGoals: { __typename?: 'WellnessGoalConnection', nodes?: Array<{ __typename?: 'WellnessGoal', id: string, name: string } | null> | null } };

export type GetWellnessGoalOptionsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type GetWellnessGoalOptionsQuery = { __typename?: 'Query', wellnessGoals: { __typename?: 'WellnessGoalConnection', nodes?: Array<{ __typename?: 'WellnessGoal', id: string, name: string, active: boolean } | null> | null } };

export type CheckUserExistenceQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type CheckUserExistenceQuery = { __typename?: 'Query', userExists: boolean };

export type GetOrderIdFromShopifyIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrderIdFromShopifyIdQuery = { __typename?: 'Query', dbOrder: { __typename?: 'DbOrder', orderNumber?: string | null } };

export type CheckWizardCompletedQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CheckWizardCompletedQuery = { __typename?: 'Query', recommendationWizard: { __typename?: 'RecommendationWizard', completed: boolean } };

export type ChangePasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', userResetPasswordWithToken?: { __typename?: 'UserResetPasswordWithTokenPayload', authenticatable: { __typename?: 'User', uid?: string | null }, credentials?: { __typename?: 'Credential', accessToken: string, client: string, expiry: number, tokenType: string, uid: string } | null } | null };

export type ChangePasswordPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ChangePasswordPageQuery = { __typename?: 'Query', me: { __typename?: 'User', uid?: string | null, name?: string | null } };

export type PasswordResetRequestMutationVariables = Exact<{
  email: Scalars['String'];
  redirectUrl: Scalars['String'];
}>;


export type PasswordResetRequestMutation = { __typename?: 'Mutation', userSendPasswordResetWithToken?: { __typename?: 'UserSendPasswordResetWithTokenPayload', message: string } | null };

export type ForgotPasswordPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ForgotPasswordPageQuery = { __typename?: 'Query', me: { __typename?: 'User', uid?: string | null, name?: string | null } };

export type VerifyCaptchaResultMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyCaptchaResultMutation = { __typename?: 'Mutation', verifyCaptchaToken: { __typename?: 'VerifyCaptchaTokenPayload', success: boolean, score?: number | null, errors?: Array<string> | null } };

export type UserSignInMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type UserSignInMutation = { __typename?: 'Mutation', userLogin?: { __typename?: 'UserLoginPayload', credentials: { __typename?: 'Credential', accessToken: string, client: string, expiry: number, tokenType: string, uid: string }, authenticatable: { __typename?: 'User', id?: string | null, uid?: string | null, confirmedAt?: any | null } } | null };

export type AuthenticateAndAssignUserToRecWizMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  recommendationWizardId: Scalars['String'];
  guestToken: Scalars['String'];
}>;


export type AuthenticateAndAssignUserToRecWizMutation = { __typename?: 'Mutation', assignUserToSubflow?: { __typename?: 'AssignUserToSubflowPayload', credentials: { __typename?: 'Credential', accessToken: string, client: string, expiry: number, tokenType: string, uid: string }, authenticatable: { __typename?: 'User', id?: string | null, uid?: string | null, confirmedAt?: any | null } } | null };

export type UserSignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type UserSignOutMutation = { __typename?: 'Mutation', userLogout?: { __typename?: 'UserLogoutPayload', authenticatable: { __typename?: 'User', uid?: string | null } } | null };

export type LoginPageQueryVariables = Exact<{ [key: string]: never; }>;


export type LoginPageQuery = { __typename?: 'Query', me: { __typename?: 'User', uid?: string | null, name?: string | null } };

export type UserSignUpMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  confirmUrl: Scalars['String'];
}>;


export type UserSignUpMutation = { __typename?: 'Mutation', userSignUp?: { __typename?: 'UserSignUpPayload', credentials?: { __typename?: 'Credential', accessToken: string, client: string, expiry: number, tokenType: string, uid: string } | null, authenticatable: { __typename?: 'User', uid?: string | null, id?: string | null } } | null };

export type UserSignUpWizardAssociateMutationVariables = Exact<{
  id: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  guestToken: Scalars['String'];
}>;


export type UserSignUpWizardAssociateMutation = { __typename?: 'Mutation', createUserForSubflow?: { __typename?: 'CreateUserForSubflowPayload', credentials?: { __typename?: 'Credential', accessToken: string, client: string, expiry: number, tokenType: string, uid: string } | null, authenticatable: { __typename?: 'User', uid?: string | null, id?: string | null }, recommendationWizard: { __typename?: 'RecommendationWizard', id: string, userId?: number | null, contactEmail?: string | null } } | null };

export type SignUpPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SignUpPageQuery = { __typename?: 'Query', me: { __typename?: 'User', uid?: string | null, name?: string | null } };

export type ConfirmEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ConfirmEmailMutation = { __typename?: 'Mutation', userConfirmRegistrationWithToken?: { __typename?: 'UserConfirmRegistrationWithTokenPayload', credentials?: { __typename?: 'Credential', accessToken: string, client: string, expiry: number, tokenType: string, uid: string } | null } | null };

export type VerifyAccountPageQueryVariables = Exact<{ [key: string]: never; }>;


export type VerifyAccountPageQuery = { __typename?: 'Query', me: { __typename?: 'User', uid?: string | null, name?: string | null } };

export type UserNewsletterSignUpMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type UserNewsletterSignUpMutation = { __typename?: 'Mutation', userNewsletterSignUp: { __typename?: 'UserNewsletterSignUpPayload', success: boolean, errors?: Array<string> | null } };

export type SubscriptionCartAttrsFragment = { __typename?: 'RecommendationWizard', id: string, petName?: string | null, petId?: number | null, userId?: number | null, activityLevel?: string | null, attributions?: any | null, birthDate?: any | null, breedType: string, contactEmail?: string | null, contactName?: string | null, contactPhoneNumber?: string | null, couponsData?: any | null, weight?: number | null, gender?: string | null, spayedNeutered?: boolean | null, primaryBreedId?: number | null, secondaryBreedId?: number | null, waistline?: string | null, wellnessGoalIds?: Array<string> | null, hasWellnessGoals?: boolean | null, ingredientIds?: Array<string> | null, hasFoodSensitivities?: boolean | null, preferenceIds: Array<string>, recipeIds: Array<string>, recipeSkus?: Array<string> | null, bakedIds: Array<string>, cookedIds: Array<string>, planId?: number | null, planType?: RecommendationWizardPlanTypeEnum | null, recommendedCaloriesPerDay?: number | null, subscriptionId?: number | null, guestToken?: string | null, shopifyId?: string | null, latestStep?: string | null, lineItemsData: Array<{ __typename?: 'AddonLineItem', quantity: number, shopifyId: string, sku: string, discount: number, price: number, recurring: boolean, type: string }>, recommendedRecipeLineItems: Array<{ __typename?: 'RecommendedRecipeLineItem', sku: string, shopifyId: string, quantity: number }>, plan: { __typename?: 'BoxVariant', sku?: string | null, name: string, planType?: BoxVariantPlanTypeEnum | null, sellingPlanId?: string | null, shopifyId?: string | null, addonUnits: number, box?: { __typename?: 'Box', bagQuantity?: number | null, itemQuantity: number } | null }, selectedBreedOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null, selectedWellnessGoalOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null, selectedRecipeOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null };

export type RecommendedProductAttrsFragment = { __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null };

export type RecBoxAttrsFragment = { __typename?: 'PetBox', addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, planType?: BoxVariantPlanTypeEnum | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } };

export type GetMyAccRecommendationsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  maintainLegacy?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetMyAccRecommendationsQuery = { __typename?: 'Query', recommendationWizard: { __typename?: 'RecommendationWizard', planRecommendations?: { __typename?: 'PlanRecommendation', caloriesPerDay?: number | null, boxes: { __typename?: 'RecommendationBoxes', fullBox?: { __typename?: 'PetBox', addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, planType?: BoxVariantPlanTypeEnum | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null, topperBox?: { __typename?: 'PetBox', addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, planType?: BoxVariantPlanTypeEnum | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null, comboBox?: { __typename?: 'PetBox', addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, planType?: BoxVariantPlanTypeEnum | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null, freshBakedBox?: { __typename?: 'PetBox', addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, planType?: BoxVariantPlanTypeEnum | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null, spaceSaverBox?: { __typename?: 'PetBox', addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, slug?: string | null, sku?: string | null, category?: PlanLineItemCategoryEnum | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, description?: string | null, priceCategory?: string | null, shopifyId?: string | null, price?: number | null, metadata?: any | null, recipe?: { __typename?: 'Recipe', id: string } | null } | null> | null }, shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', quantity: number, shopifyId: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, sku?: string | null, planType?: BoxVariantPlanTypeEnum | null, addonUnits: number, mealsPerDay: number, calorieGroup?: number | null, defaultFrequency?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, feedingGuideline?: { __typename?: 'FeedingGuideline', calorieGroup?: number | null, planType?: string | null, dailyIntake?: string | null, frozenPortion?: number | null, frozenMeasure?: string | null, frozenWeight?: number | null, frozenWeightMeasure?: string | null, dryPortion?: number | null, dryMeasure?: string | null } | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } } | null } } | null, recommendedRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null, recommendedAddons?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null, recommendedComboRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null } };

export type FindRecommendationWizardQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type FindRecommendationWizardQuery = { __typename?: 'Query', me: { __typename?: 'User', hasActiveSubs?: boolean | null }, recommendationWizard: { __typename?: 'RecommendationWizard', id: string, petName?: string | null, petId?: number | null, userId?: number | null, activityLevel?: string | null, attributions?: any | null, birthDate?: any | null, breedType: string, contactEmail?: string | null, contactName?: string | null, contactPhoneNumber?: string | null, couponsData?: any | null, weight?: number | null, gender?: string | null, spayedNeutered?: boolean | null, primaryBreedId?: number | null, secondaryBreedId?: number | null, waistline?: string | null, wellnessGoalIds?: Array<string> | null, hasWellnessGoals?: boolean | null, ingredientIds?: Array<string> | null, hasFoodSensitivities?: boolean | null, preferenceIds: Array<string>, recipeIds: Array<string>, recipeSkus?: Array<string> | null, bakedIds: Array<string>, cookedIds: Array<string>, planId?: number | null, planType?: RecommendationWizardPlanTypeEnum | null, recommendedCaloriesPerDay?: number | null, subscriptionId?: number | null, guestToken?: string | null, shopifyId?: string | null, latestStep?: string | null, lineItemsData: Array<{ __typename?: 'AddonLineItem', quantity: number, shopifyId: string, sku: string, discount: number, price: number, recurring: boolean, type: string }>, recommendedRecipeLineItems: Array<{ __typename?: 'RecommendedRecipeLineItem', sku: string, shopifyId: string, quantity: number }>, plan: { __typename?: 'BoxVariant', sku?: string | null, name: string, planType?: BoxVariantPlanTypeEnum | null, sellingPlanId?: string | null, shopifyId?: string | null, addonUnits: number, box?: { __typename?: 'Box', bagQuantity?: number | null, itemQuantity: number } | null }, selectedBreedOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null, selectedWellnessGoalOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null, selectedRecipeOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null } };

export type CreateRecommendationWizardMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']>;
  subscriptionId?: InputMaybe<Scalars['Int']>;
  petName?: InputMaybe<Scalars['String']>;
}>;


export type CreateRecommendationWizardMutation = { __typename?: 'Mutation', recommendationWizardCreate?: { __typename?: 'RecommendationWizardCreatePayload', recommendationWizard: { __typename?: 'RecommendationWizard', id: string, petName?: string | null, petId?: number | null, userId?: number | null, activityLevel?: string | null, attributions?: any | null, birthDate?: any | null, breedType: string, contactEmail?: string | null, contactName?: string | null, contactPhoneNumber?: string | null, couponsData?: any | null, weight?: number | null, gender?: string | null, spayedNeutered?: boolean | null, primaryBreedId?: number | null, secondaryBreedId?: number | null, waistline?: string | null, wellnessGoalIds?: Array<string> | null, hasWellnessGoals?: boolean | null, ingredientIds?: Array<string> | null, hasFoodSensitivities?: boolean | null, preferenceIds: Array<string>, recipeIds: Array<string>, recipeSkus?: Array<string> | null, bakedIds: Array<string>, cookedIds: Array<string>, planId?: number | null, planType?: RecommendationWizardPlanTypeEnum | null, recommendedCaloriesPerDay?: number | null, subscriptionId?: number | null, guestToken?: string | null, shopifyId?: string | null, latestStep?: string | null, lineItemsData: Array<{ __typename?: 'AddonLineItem', quantity: number, shopifyId: string, sku: string, discount: number, price: number, recurring: boolean, type: string }>, recommendedRecipeLineItems: Array<{ __typename?: 'RecommendedRecipeLineItem', sku: string, shopifyId: string, quantity: number }>, plan: { __typename?: 'BoxVariant', sku?: string | null, name: string, planType?: BoxVariantPlanTypeEnum | null, sellingPlanId?: string | null, shopifyId?: string | null, addonUnits: number, box?: { __typename?: 'Box', bagQuantity?: number | null, itemQuantity: number } | null }, selectedBreedOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null, selectedWellnessGoalOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null, selectedRecipeOptions?: Array<{ __typename?: 'Option', label?: string | null, value?: string | null } | null> | null } } | null };

export type CreatePetPlateSubscriptionMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']>;
}>;


export type CreatePetPlateSubscriptionMutation = { __typename?: 'Mutation', petPlateSubscriptionCreate?: { __typename?: 'PetPlateSubscriptionCreatePayload', petPlateSubscription: { __typename?: 'PetPlateSubscription', id: string } } | null };

export type GetUserAndLoyaltyInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAndLoyaltyInfoQuery = { __typename?: 'Query', me: { __typename?: 'User', uid?: string | null, id?: string | null, pupPoints?: number | null, vipTier?: string | null, referrals?: number | null } };

export type CartUpdatePlanMutationVariables = Exact<{
  id: Scalars['ID'];
  input: RecommendationWizardInput;
}>;


export type CartUpdatePlanMutation = { __typename?: 'Mutation', recommendationWizardUpdate?: { __typename?: 'RecommendationWizardUpdatePayload', recommendationWizard: { __typename?: 'RecommendationWizard', id: string, planId?: number | null } } | null };

export type GetUserAndOrdersQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetUserAndOrdersQuery = { __typename?: 'Query', me: { __typename?: 'User', uid?: string | null, id?: string | null, userVisibleOrders: { __typename?: 'DbOrderConnection', nodes?: Array<{ __typename?: 'DbOrder', id?: number | null, attributionChannel?: string | null, estimatedShippingDate?: any | null, state?: OrderState | null, humanizedState?: OrderHumanizedState | null, orderNumber?: string | null, createdAt?: any | null, shopifyId?: string | null, shopifyTotal?: string | null, lineItemsData?: any | null, petNames?: string | null, statement?: { __typename?: 'OrderStatement', taxableSubtotal: string, totalPaidLine: { __typename?: 'OrderStatamentLine', label: string, amount: string }, totalDueLine: { __typename?: 'OrderStatamentLine', label: string, amount: string } } | null, taggings?: Array<{ __typename?: 'Tagging', tag?: { __typename?: 'Tag', name?: string | null } | null }> | null, subscription?: { __typename?: 'Subscription', id: string, scheduledShippingDate?: any | null, state?: SubscriptionStateEnum | null, pet?: { __typename?: 'Pet', petName?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, pageSize: number, startCursor?: string | null, endCursor?: string | null, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } }, subscriptions: { __typename?: 'SubscriptionConnection', nodes?: Array<{ __typename?: 'Subscription', currentPlanFrequency?: number | null, id: string, scheduledShippingDate?: any | null, state?: SubscriptionStateEnum | null, hasFailedBilling: boolean, hasUpdatedFailedBilling: boolean, estimatedDeliveryDate?: any | null, availablePostponementDates?: Array<{ __typename?: 'RescheduleDates', shippingDate?: any | null, deliveryDate?: any | null }> | null, nextOrderAdjusted?: { __typename?: 'DbOrder', humanizedState?: OrderHumanizedState | null, shippingAddress?: any | null, estimatedDeliveryDate?: any | null, paymentStatus?: string | null, lastShipmentEntry?: { __typename?: 'ShipmentEntry', state?: TypesShipmentEntryStateEnumType | null } | null } | null, pet?: { __typename?: 'Pet', petName?: string | null } | null, shippingAddress?: { __typename?: 'Address', id: string, name?: string | null, address?: string | null, aptNo?: string | null, city?: string | null, stateAbbr?: string | null, zipCode?: string | null, phoneNumber?: string | null } | null } | null> | null } } };

export type GetOrderByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetOrderByIdQuery = { __typename?: 'Query', dbOrder: { __typename?: 'DbOrder', attributionChannel?: string | null, attributionSource?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhoneNumber?: string | null, couponsData?: any | null, createdAt?: any | null, estimatedShippingDate?: any | null, humanizedState?: OrderHumanizedState | null, id?: number | null, lineItemsData?: any | null, metadata?: any | null, orderNumber?: string | null, petNames?: string | null, statementItemsList?: any | null, paymentStatus?: string | null, shippingAddress?: any | null, shopifyId?: string | null, shopifyTotal?: string | null, state?: OrderState | null, lastShipmentEntry?: { __typename?: 'ShipmentEntry', id: string, shippedAt?: any | null, deliveryDate?: any | null, state?: TypesShipmentEntryStateEnumType | null, trackingLink?: string | null } | null, statement?: { __typename?: 'OrderStatement', taxableSubtotal: string, planWithSurchargesLine?: { __typename?: 'OrderStatamentLine', label: string, amount: string } | null, totalPaidLine: { __typename?: 'OrderStatamentLine', label: string, amount: string }, addonsLine?: { __typename?: 'OrderStatamentLine', label: string, amount: string } | null, taxesLine: { __typename?: 'OrderStatamentLine', label: string, amount: string }, shippingLine: { __typename?: 'OrderStatamentLine', label: string, amount: string }, surchargesLine?: { __typename?: 'OrderStatamentLine', label: string, amount: string } | null, discountLines: Array<{ __typename?: 'OrderStatamentLine', label: string, amount: string, coupon?: { __typename?: 'OrderStatementCoupon', code: string } | null }>, creditLines: Array<{ __typename?: 'OrderStatamentLine', label: string, amount: string }>, totalDueLine: { __typename?: 'OrderStatamentLine', label: string, amount: string } } | null, shipments: Array<{ __typename?: 'V2Shipment', shipmentEntry?: { __typename?: 'ShipmentEntry', id: string, shippedAt?: any | null, state?: TypesShipmentEntryStateEnumType | null } | null }>, taggings?: Array<{ __typename?: 'Tagging', tag?: { __typename?: 'Tag', name?: string | null } | null }> | null, subscription?: { __typename?: 'Subscription', id: string, dishesCount?: number | null, number?: string | null, planType?: string | null, planStatus?: string | null, state?: SubscriptionStateEnum | null, scheduledShippingDate?: any | null, treatsCount?: number | null, supplementsCount?: number | null, mealLineItems?: Array<{ __typename?: 'MealLineItem', total: number, meal?: { __typename?: 'Meal', name?: string | null, sku?: string | null } | null }> | null, addonLineItems?: Array<{ __typename?: 'TypesSubscriptionTypeLineItemType', quantity?: number | null, sku?: string | null }> | null, pet?: { __typename?: 'Pet', birthDate?: any | null, id: string, petName?: string | null, weight?: number | null, primaryBreed?: { __typename?: 'Breed', name: string } | null } | null, payments: Array<{ __typename?: 'PpPayment', id: string, assessedTaxes: number }> } | null, customer?: { __typename?: 'User', email?: string | null, id?: string | null, address?: { __typename?: 'Address', address?: string | null, city?: string | null, stateAbbr?: string | null, zipCode?: string | null } | null } | null } };

export type AccountUpdatePetMutationVariables = Exact<{
  input: PetUpdateInput;
}>;


export type AccountUpdatePetMutation = { __typename?: 'Mutation', petUpdate?: { __typename?: 'PetUpdatePayload', pet: { __typename?: 'Pet', petName?: string | null, gender?: string | null, spayedNeutered?: boolean | null, birthDate?: any | null, primaryBreedId?: number | null, secondaryBreedId?: number | null, weight?: number | null, activityLevel?: PetActivityLevels | null, waistline?: string | null, ingredientIds?: Array<string> | null, wellnessGoalIds?: Array<string> | null } } | null };

export type AccountPetDetailDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountPetDetailDataQuery = { __typename?: 'Query', ingredients: { __typename?: 'IngredientConnection', nodes?: Array<{ __typename?: 'Ingredient', id: string, name: string } | null> | null }, wellnessGoals: { __typename?: 'WellnessGoalConnection', nodes?: Array<{ __typename?: 'WellnessGoal', id: string, name: string } | null> | null } };

export type GetPetEditInfoQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPetEditInfoQuery = { __typename?: 'Query', pet: { __typename?: 'Pet', petName?: string | null, gender?: string | null, spayedNeutered?: boolean | null, birthDate?: any | null, weight?: number | null, activityLevel?: PetActivityLevels | null, waistline?: string | null, ingredientIds?: Array<string> | null, wellnessGoalIds?: Array<string> | null, primaryBreed?: { __typename?: 'Breed', name: string, id: string } | null, secondaryBreed?: { __typename?: 'Breed', name: string, id: string } | null, subscription?: { __typename?: 'Subscription', id: string, currentPlan?: { __typename?: 'BoxVariant', sku?: string | null, defaultFrequency?: number | null, calorieGroup?: number | null, addonUnits: number, sellingPlanId?: string | null, shopifyId?: string | null, price?: number | null, planType?: BoxVariantPlanTypeEnum | null, id: string, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } | null, recommendationWizard: { __typename?: 'RecommendationWizard', id: string, planRecommendations?: { __typename?: 'PlanRecommendation', caloriesPerDay?: number | null } | null } } | null } };

export type MyAccBreedSearchQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type MyAccBreedSearchQuery = { __typename?: 'Query', breeds: { __typename?: 'BreedConnection', nodes?: Array<{ __typename?: 'Breed', id: string, name: string } | null> | null } };

export type AccountSubscriptionIndexRecommendedProductAttrsFragment = { __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null };

export type AccountSubscriptionAddonsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AccountSubscriptionAddonsQuery = { __typename?: 'Query', subscription: { __typename?: 'Subscription', addons?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, shopifyId?: string | null, outOfStock?: boolean | null } | null }> | null } };

export type AccountSubscriptionIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSubscriptionIndexQuery = { __typename?: 'Query', me: { __typename?: 'User', subscriptions: { __typename?: 'SubscriptionConnection', nodes?: Array<{ __typename?: 'Subscription', id: string, currentPlanFrequency?: number | null, treatsCount?: number | null, supplementsCount?: number | null, state?: SubscriptionStateEnum | null, planType?: string | null, hasFailedBilling: boolean, hasUpdatedFailedBilling: boolean, estimatedDeliveryDate?: any | null, availablePostponementDates?: Array<{ __typename?: 'RescheduleDates', shippingDate?: any | null, deliveryDate?: any | null }> | null, upcomingOrder?: { __typename?: 'DbOrder', invoicePreview?: { __typename?: 'ShopifyOrderInvoicePreview', subtotalCost: number, totalCost: number, credit?: number | null, discounts?: Array<{ __typename?: 'ShopifyOrderInvoiceDiscounts', code: string, maskedCode?: string | null, applicationType: TypesSubscriptionShopifyCouponApplicationType, amountOff?: number | null, percentageOff?: number | null, amount?: number | null }> | null } | null } | null, nextOrderAdjusted?: { __typename?: 'DbOrder', id?: number | null, state?: OrderState | null, estimatedDeliveryDate?: any | null, paymentStatus?: string | null, shippingAddress?: any | null, humanizedState?: OrderHumanizedState | null, lastShipmentEntry?: { __typename?: 'ShipmentEntry', state?: TypesShipmentEntryStateEnumType | null, deliveryDate?: any | null, trackingNumber?: string | null, carrierService?: string | null } | null } | null, recommendationWizard: { __typename?: 'RecommendationWizard', id: string, petName?: string | null, planType?: RecommendationWizardPlanTypeEnum | null, planId?: number | null, ingredientIds?: Array<string> | null, recipeIds: Array<string> }, currentPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, calorieGroup?: number | null, addonUnits: number, sellingPlanId?: string | null, shopifyId?: string | null, price?: number | null, planType?: BoxVariantPlanTypeEnum | null, id: string, sku?: string | null, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null } | null, upgradePlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, calorieGroup?: number | null, addonUnits: number, sellingPlanId?: string | null, shopifyId?: string | null, price?: number | null, planType?: BoxVariantPlanTypeEnum | null, id: string, sku?: string | null } | null, previousPlan?: { __typename?: 'BoxVariant', id: string, sku?: string | null, price?: number | null } | null, pet?: { __typename?: 'Pet', id: string, petName?: string | null, birthDate?: any | null, weight?: number | null, gender?: string | null, primaryBreed?: { __typename?: 'Breed', name: string } | null, secondaryBreed?: { __typename?: 'Breed', name: string } | null } | null, coupons?: Array<{ __typename?: 'SubscriptionShopifyCoupon', code: string }> | null, shippingAddress?: { __typename?: 'Address', address?: string | null, aptNo?: string | null, city?: string | null, zipCode?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean, pageSize: number, totalPages: number, startCursor?: string | null, endCursor?: string | null } } } };

export type AccountCreditQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountCreditQuery = { __typename?: 'Query', me: { __typename?: 'User', id?: string | null, totalCreditAmount?: number | null, hasFailedBilling: boolean, subscriptionsWithFailedBilling?: Array<string> | null, subscriptionsWithUpdatedFailedBilling?: Array<string> | null } };

export type CheckSubPaymentMethodUpdatedQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CheckSubPaymentMethodUpdatedQuery = { __typename?: 'Query', subscription: { __typename?: 'Subscription', hasUpdatedFailedBilling: boolean } };

export type IndexProductItemAttrsFragment = { __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, shopifyId?: string | null, outOfStock?: boolean | null } | null };

export type MyAccountNotificationBannersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAccountNotificationBannersQuery = { __typename?: 'Query', me: { __typename?: 'User', notificationBanners: Array<{ __typename?: 'NotificationBanner', id: string, notificationBannerType: NotificationBannerTypeEnum, message: string }> } };

export type UpdatePasswordMutationVariables = Exact<{
  id: Scalars['ID'];
  pw: Scalars['String'];
  pwConfirm: Scalars['String'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', userUpdate?: { __typename?: 'UserUpdatePayload', user: { __typename?: 'User', id?: string | null, email?: string | null } } | null };

export type UpdateEmailMutationVariables = Exact<{
  id: Scalars['ID'];
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', userUpdate?: { __typename?: 'UserUpdatePayload', user: { __typename?: 'User', id?: string | null, email?: string | null } } | null, userLogin?: { __typename?: 'UserLoginPayload', credentials: { __typename?: 'Credential', accessToken: string, client: string, expiry: number, tokenType: string, uid: string }, authenticatable: { __typename?: 'User', id?: string | null, uid?: string | null, confirmedAt?: any | null } } | null };

export type UpdateUserMarketingMutationVariables = Exact<{
  id: Scalars['ID'];
  marketing: Scalars['Boolean'];
  phoneNumber: Scalars['String'];
  smsConsent: Scalars['Boolean'];
}>;


export type UpdateUserMarketingMutation = { __typename?: 'Mutation', userUpdate?: { __typename?: 'UserUpdatePayload', user: { __typename?: 'User', id?: string | null, email?: string | null, acceptsMarketing?: boolean | null, phoneNumber?: string | null, smsConsent?: boolean | null } } | null };

export type GetUserAccountSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAccountSettingsQuery = { __typename?: 'Query', me: { __typename?: 'User', uid?: string | null, id?: string | null, phoneNumber?: string | null, email?: string | null, acceptsMarketing?: boolean | null, smsConsent?: boolean | null } };

export type MyAccountUpdatePlanMutationVariables = Exact<{
  id: Scalars['ID'];
  input: RecommendationWizardInput;
}>;


export type MyAccountUpdatePlanMutation = { __typename?: 'Mutation', recommendationWizardUpdate?: { __typename?: 'RecommendationWizardUpdatePayload', recommendationWizard: { __typename?: 'RecommendationWizard', id: string, planType?: RecommendationWizardPlanTypeEnum | null, ingredientIds?: Array<string> | null, planId?: number | null } } | null };

export type MyAccountUpdateSubscriptionLineItemFragment = { __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null };

export type MyAccountCreateSubscriptionPaymentMethodMutationVariables = Exact<{
  input: PaymentMethodInput;
}>;


export type MyAccountCreateSubscriptionPaymentMethodMutation = { __typename?: 'Mutation', paymentMethodCreate?: { __typename?: 'PaymentMethodCreatePayload', paymentMethod: { __typename?: 'PaymentMethod', id: string, cardLast4?: string | null } } | null };

export type MyAccountUpdateSubscriptionMutationVariables = Exact<{
  id: Scalars['ID'];
  input: SubscriptionInput;
}>;


export type MyAccountUpdateSubscriptionMutation = { __typename?: 'Mutation', subscriptionUpdate?: { __typename?: 'SubscriptionUpdatePayload', subscription: { __typename?: 'Subscription', id: string, state?: SubscriptionStateEnum | null, hiddenAt?: any | null, coupons?: Array<{ __typename?: 'SubscriptionShopifyCoupon', code: string }> | null, treats?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null }> | null, supplements?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null }> | null, freshBakedEntrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null }> | null, freshCookedEntrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null }> | null } } | null };

export type BoxAttrsFragment = { __typename?: 'PetBox', shopifyLineItems?: Array<{ __typename?: 'ShopifyLineItems', sku: string, quantity: number, shopifyId: string, category: string }> | null, boxVariant: { __typename?: 'BoxVariant', id: string, price?: number | null, name: string, calorieGroup?: number | null, defaultFrequency?: number | null, mealsPerDay: number, shopifyId?: string | null, sellingPlanId?: string | null }, addons: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, slug?: string | null, sku?: string | null, name?: string | null, shopifyId?: string | null, productCategory?: string | null, priceCategory?: string | null, price?: number | null, productType?: string | null, category?: PlanLineItemCategoryEnum | null, shortName?: string | null, metadata?: any | null, description?: string | null, ingredients?: string | null } | null> | null }, recipes?: { __typename?: 'MealConnection', nodes?: Array<{ __typename?: 'Meal', id: string, slug?: string | null, sku?: string | null, name?: string | null, category?: MealCategoryEnum | null, subtitle?: string | null, recommended?: boolean | null, priceCategory?: string | null, shopifyId?: string | null, recipeId?: number | null } | null> | null } | null };

export type ProductItemAttrsFragment = { __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, shopifyId?: string | null, outOfStock?: boolean | null, outOfStockMessage?: string | null } | null };

export type AccountSubscriptionDetailRecommendedProductAttrsFragment = { __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null };

export type AccountSubsAddonsHltvQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSubsAddonsHltvQuery = { __typename?: 'Query', me: { __typename?: 'User', subscriptions: { __typename?: 'SubscriptionConnection', nodes?: Array<{ __typename?: 'Subscription', isHighValue?: boolean | null, treats?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, shopifyId?: string | null, outOfStock?: boolean | null } | null }> | null, supplements?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, shopifyId?: string | null, outOfStock?: boolean | null } | null }> | null } | null> | null } } };

export type AccountSubscriptionDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type AccountSubscriptionDetailQuery = { __typename?: 'Query', subscription: { __typename?: 'Subscription', id: string, number?: string | null, currentPlanSku?: string | null, isHighValue?: boolean | null, createdAt?: any | null, deliveredOrders?: number | null, paidOrdersCount: number, hasLifeTimeCoupon?: boolean | null, hasEarlyCancelCoupon?: boolean | null, nextLinkedCoupons: Array<string>, scheduledShippingDate?: any | null, nextScheduledShippingDate?: any | null, currentPlanFrequency?: number | null, planType?: string | null, state?: SubscriptionStateEnum | null, renewals?: number | null, hasFailedBilling: boolean, hasUpdatedFailedBilling: boolean, estimatedDeliveryDate?: any | null, lastPaidOrderShippingDate?: any | null, upcomingOrderDeliveryDate?: any | null, nextOrderDeliveryDate?: any | null, availablePostponementDates?: Array<{ __typename?: 'RescheduleDates', shippingDate?: any | null, deliveryDate?: any | null }> | null, nextOrderAdjusted?: { __typename?: 'DbOrder', id?: number | null, state?: OrderState | null, humanizedState?: OrderHumanizedState | null, estimatedDeliveryDate?: any | null, paymentStatus?: string | null, shippingAddress?: any | null, lastShipmentEntry?: { __typename?: 'ShipmentEntry', state?: TypesShipmentEntryStateEnumType | null, deliveryDate?: any | null, trackingNumber?: string | null, carrierCode?: string | null } | null } | null, nextOrder?: { __typename?: 'DbOrder', id?: number | null, state?: OrderState | null, estimatedDeliveryDate?: any | null, paymentStatus?: string | null, shippingAddress?: any | null, lastShipmentEntry?: { __typename?: 'ShipmentEntry', state?: TypesShipmentEntryStateEnumType | null, deliveryDate?: any | null, trackingNumber?: string | null, carrierService?: string | null } | null } | null, upcomingOrder?: { __typename?: 'DbOrder', estimatedDeliveryDate?: any | null, invoicePreview?: { __typename?: 'ShopifyOrderInvoicePreview', subtotalCost: number, totalCost: number, credit?: number | null, discounts?: Array<{ __typename?: 'ShopifyOrderInvoiceDiscounts', code: string, maskedCode?: string | null, applicationType: TypesSubscriptionShopifyCouponApplicationType, amountOff?: number | null, percentageOff?: number | null, amount?: number | null }> | null } | null } | null, coupons?: Array<{ __typename?: 'SubscriptionShopifyCoupon', code: string, maskedCode?: string | null, applicationType: TypesSubscriptionShopifyCouponApplicationType, amountOff?: number | null, percentageOff?: number | null, affectsClass?: ShopifyDiscountAffectsClass | null, affectedProductSkus?: Array<string> | null, affectedCollections?: Array<string> | null, usageCycleLimit?: number | null, usageCount: number, limited: boolean, oncePerCustomer: boolean, appliesToAllItems: boolean, entitledProducts?: Array<{ __typename?: 'SubscriptionShopifyEntitledProduct', id: string, sku: string }> | null }> | null, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, numberOfSubscriptions?: number | null } | null, shopifyCustomer?: { __typename?: 'ShopifyCustomer', email: string, shopifyId?: string | null } | null, recommendationWizard: { __typename?: 'RecommendationWizard', id: string, planType?: RecommendationWizardPlanTypeEnum | null, planId?: number | null, ingredientIds?: Array<string> | null, recipeIds: Array<string>, petName?: string | null, wellnessGoals: { __typename?: 'WellnessGoalConnection', nodes?: Array<{ __typename?: 'WellnessGoal', id: string, name: string } | null> | null }, planRecommendations?: { __typename?: 'PlanRecommendation', caloriesPerDay?: number | null, boxes: { __typename?: 'RecommendationBoxes', topperBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', price?: number | null, defaultFrequency?: number | null } } | null, fullBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', price?: number | null, defaultFrequency?: number | null } } | null, comboBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', price?: number | null, defaultFrequency?: number | null } } | null, freshBakedBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', price?: number | null, defaultFrequency?: number | null } } | null } } | null, recommendedAddons?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null, recommendedRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, position?: number | null, recommended?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, description?: string | null, priceCategory?: PriceCategoryEnum | null, recipeId?: number | null, shopifyId?: string | null } | null }> | null }, previousPlan?: { __typename?: 'BoxVariant', id: string, sku?: string | null, price?: number | null } | null, currentPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, calorieGroup?: number | null, addonUnits: number, sellingPlanId?: string | null, shopifyId?: string | null, price?: number | null, planType?: BoxVariantPlanTypeEnum | null, id: string, box?: { __typename?: 'Box', name: string, bagQuantity?: number | null, bagWeight?: number | null, itemQuantity: number, itemWeight?: number | null } | null, productVariants?: Array<{ __typename?: 'PetPlateProductVariantType', suggestedPiecesPerDay?: number | null }> | null } | null, upgradePlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, calorieGroup?: number | null, addonUnits: number, sellingPlanId?: string | null, shopifyId?: string | null, price?: number | null, planType?: BoxVariantPlanTypeEnum | null, id: string } | null, pet?: { __typename?: 'Pet', petName?: string | null, birthDate?: any | null, weight?: number | null, gender?: string | null, id: string, wellnessGoals?: Array<{ __typename?: 'WellnessGoal', name: string }> | null, ingredients?: Array<{ __typename?: 'Ingredient', name: string }> | null } | null, shippingAddress?: { __typename?: 'Address', id: string, name?: string | null, address?: string | null, aptNo?: string | null, city?: string | null, stateAbbr?: string | null, zipCode?: string | null, phoneNumber?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, lowercaseMetadata?: { __typename?: 'PaymentMetadata', company?: string | null, wallet?: PaymentWallet | null, paypalEmail?: string | null } | null } | null, treats?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, shopifyId?: string | null, outOfStock?: boolean | null, outOfStockMessage?: string | null } | null }> | null, supplements?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, shopifyId?: string | null, outOfStock?: boolean | null, outOfStockMessage?: string | null } | null }> | null, freshBakedEntrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, shopifyId?: string | null, outOfStock?: boolean | null, outOfStockMessage?: string | null } | null }> | null, freshCookedEntrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, shopifyId?: string | null, outOfStock?: boolean | null, outOfStockMessage?: string | null } | null }> | null, addons?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, reason?: { __typename?: 'RecReason', type: string, name: string } | null, product?: { __typename?: 'PlanLineItemProduct', id?: string | null, name?: string | null, slug?: string | null, shopifyId?: string | null, outOfStock?: boolean | null, outOfStockMessage?: string | null } | null }> | null, v2Orders: Array<{ __typename?: 'DbOrder', id?: number | null, humanizedState?: OrderHumanizedState | null, renewal?: boolean | null, lastChargeSuccessful?: boolean | null, couponsData?: any | null }> } };

export type GetSurveyOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSurveyOptionsQuery = { __typename?: 'Query', surveyOptions: { __typename?: 'SurveyOptions', pauseReason: Array<{ __typename?: 'SurveyOption', label: string, value: number }>, cancelReason: Array<{ __typename?: 'SurveyOption', label: string, value: number }> } };

export type GetDiscountInfoQueryVariables = Exact<{
  codes: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetDiscountInfoQuery = { __typename?: 'Query', shopifyDiscountInfo: Array<{ __typename?: 'ShopifyDiscountInfo', title?: string | null, amount?: number | null, status?: ShopifyDiscountStatusEnum | null, percentage?: number | null, customPromoText?: string | null, inferredBannerText?: string | null, affectsClass?: ShopifyDiscountAffectsClass | null, affectedProductSkus?: Array<string> | null, affectedCollections?: Array<string> | null }> };

export type MainNavContentQueryVariables = Exact<{ [key: string]: never; }>;


export type MainNavContentQuery = { __typename?: 'Query', Nav?: { __typename?: 'Nav', links?: Array<{ __typename?: 'Nav_Links', id?: string | null, title?: string | null, url?: string | null, isLinkPrefetched?: boolean | null }> | null, sections?: Array<{ __typename?: 'Nav_Sections', header?: string | null, id?: string | null, links?: Array<{ __typename?: 'Nav_Sections_Links', id?: string | null, title?: string | null, url?: string | null, isLinkPrefetched?: boolean | null }> | null }> | null } | null };

export type MainFooterContentQueryVariables = Exact<{ [key: string]: never; }>;


export type MainFooterContentQuery = { __typename?: 'Query', Footer?: { __typename?: 'Footer', sections?: Array<{ __typename?: 'Footer_Sections', id?: string | null, header?: string | null, links?: Array<{ __typename?: 'Footer_Sections_Links', id?: string | null, title?: string | null, url?: string | null, isLinkPrefetched?: boolean | null, stripQueryParams?: boolean | null }> | null }> | null } | null };

export type RedeemPromoMutationVariables = Exact<{
  subId: Scalars['ID'];
  couponCode: Scalars['String'];
  addonSku: Scalars['String'];
  addonQuantity?: InputMaybe<Scalars['Int']>;
  replaceCoupons?: InputMaybe<Scalars['Boolean']>;
}>;


export type RedeemPromoMutation = { __typename?: 'Mutation', redeemCouponPromo?: { __typename?: 'RedeemCouponPromoPayload', success: boolean } | null };

export type RedeemPromoGetSubscriptionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type RedeemPromoGetSubscriptionQuery = { __typename?: 'Query', subscription: { __typename?: 'Subscription', id: string, coupons?: Array<{ __typename?: 'SubscriptionShopifyCoupon', code: string }> | null } };

export type AdminOperationsDashboardRecentOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOperationsDashboardRecentOrdersQuery = { __typename?: 'Query', operationsRecentOrders: Array<{ __typename?: 'TypesOperationsDashboardTypeRecentOrders', date: any, ppSc?: number | null, ppEc?: number | null, ppCh?: number | null, ppSample?: number | null, ppAd?: number | null, ppAz?: number | null }> };

export type AdminSubscriptionStatisticsReportQueryVariables = Exact<{
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
}>;


export type AdminSubscriptionStatisticsReportQuery = { __typename?: 'Query', subscriptionStatisticsReport: { __typename?: 'SubscriptionStatisticsReport', url: string } };

export type AdminOperationsDashboardActiveSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOperationsDashboardActiveSubscriptionsQuery = { __typename?: 'Query', operationsActiveSubscriptions: { __typename?: 'TypesOperationsDashboardTypeActiveSubscriptions', stats: number } };

export type AdminOperationsDashboardOrdersWithoutSyncQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOperationsDashboardOrdersWithoutSyncQuery = { __typename?: 'Query', operationsOrdersWithoutSync: Array<{ __typename?: 'TypesOperationsDashboardTypeUnsyncedOrders', shopifyOrderId: string, error: string, topic: string, createdAt: any }> };

export type AdminAutomationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminAutomationQuery = { __typename?: 'Query', automation: { __typename?: 'Automation', active: boolean, id: string, lastRunAt?: any | null, name: string, scheduledFor?: any | null, targetDay: number, time: any, weekday: string } };

export type AdminAutomationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<AutomationName>;
  weekday?: InputMaybe<AutomationWeekday>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminAutomationsQuery = { __typename?: 'Query', automations: { __typename?: 'AutomationConnection', nodes?: Array<{ __typename?: 'Automation', active: boolean, id: string, lastRunAt?: any | null, name: string, scheduledFor?: any | null, targetDay: number, time: any, weekday: string } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null, currentPage: number, totalPages: number } } };

export type AdminAutomationCreateMutationVariables = Exact<{
  input: AutomationCreateInput;
}>;


export type AdminAutomationCreateMutation = { __typename?: 'Mutation', automationCreate?: { __typename?: 'AutomationCreatePayload', automation: { __typename?: 'Automation', active: boolean, id: string, lastRunAt?: any | null, name: string, scheduledFor?: any | null, targetDay: number, time: any, weekday: string } } | null };

export type AdminAutomationUpdateMutationVariables = Exact<{
  input: AutomationUpdateInput;
}>;


export type AdminAutomationUpdateMutation = { __typename?: 'Mutation', automationUpdate?: { __typename?: 'AutomationUpdatePayload', automation: { __typename?: 'Automation', active: boolean, id: string, lastRunAt?: any | null, name: string, scheduledFor?: any | null, targetDay: number, time: any, weekday: string } } | null };

export type AdminAutomationRunMutationVariables = Exact<{
  input: AutomationRunInput;
}>;


export type AdminAutomationRunMutation = { __typename?: 'Mutation', automationRun?: { __typename?: 'AutomationRunPayload', automation: { __typename?: 'Automation', active: boolean, id: string, lastRunAt?: any | null, name: string, scheduledFor?: any | null, targetDay: number, time: any, weekday: string } } | null };

export type AdminAutomationDeleteMutationVariables = Exact<{
  input: AutomationDeleteInput;
}>;


export type AdminAutomationDeleteMutation = { __typename?: 'Mutation', automationDelete?: { __typename?: 'AutomationDeletePayload', automation: { __typename?: 'Automation', id: string } } | null };

export type AutomationPropsFragment = { __typename?: 'Automation', active: boolean, id: string, lastRunAt?: any | null, name: string, scheduledFor?: any | null, targetDay: number, time: any, weekday: string };

export type AdminDeleteMealVariantMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminDeleteMealVariantMutation = { __typename?: 'Mutation', mealVariantDelete?: { __typename?: 'MealVariantDeletePayload', mealVariant: { __typename?: 'PetPlateMealVariantType', id: string } } | null };

export type AdminUpdateMealVariantMutationVariables = Exact<{
  input: MealVariantUpdateInput;
}>;


export type AdminUpdateMealVariantMutation = { __typename?: 'Mutation', mealVariantUpdate?: { __typename?: 'MealVariantUpdatePayload', mealVariant: { __typename?: 'PetPlateMealVariantType', id: string } } | null };

export type AdminMealVariantCreateMutationVariables = Exact<{
  input: MealVariantCreateInput;
}>;


export type AdminMealVariantCreateMutation = { __typename?: 'Mutation', mealVariantCreate?: { __typename?: 'MealVariantCreatePayload', mealVariant?: { __typename?: 'PetPlateMealVariantType', id: string } | null } | null };

export type MealVariantPropsFragment = { __typename?: 'PetPlateMealVariantType', id: string };

export type AdminMealVariantQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminMealVariantQuery = { __typename?: 'Query', mealVariant: { __typename?: 'PetPlateMealVariantType', id: string, state: string, name?: string | null, sku?: string | null, preferred?: boolean | null, outOfStock?: boolean | null, createdAt: any, updatedAt: any, meal?: { __typename?: 'PetPlateProduct', name?: string | null, sku?: string | null, parentShopifyId?: string | null, id: string } | null, boxVariant?: { __typename?: 'BoxVariant', name: string, sku?: string | null, id: string } | null } };

export type AdminDeleteProductVariantMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminDeleteProductVariantMutation = { __typename?: 'Mutation', productVariantDelete?: { __typename?: 'ProductVariantDeletePayload', productVariant: { __typename?: 'PetPlateProductVariantType', id: string } } | null };

export type AdminUpdateProductVariantMutationVariables = Exact<{
  input: ProductVariantUpdateInput;
}>;


export type AdminUpdateProductVariantMutation = { __typename?: 'Mutation', productVariantUpdate?: { __typename?: 'ProductVariantUpdatePayload', productVariant: { __typename?: 'PetPlateProductVariantType', id: string } } | null };

export type AdminProductVariantCreateMutationVariables = Exact<{
  input: ProductVariantCreateInput;
}>;


export type AdminProductVariantCreateMutation = { __typename?: 'Mutation', productVariantCreate?: { __typename?: 'ProductVariantCreatePayload', productVariant?: { __typename?: 'PetPlateProductVariantType', id: string } | null } | null };

export type ProductVariantPropsFragment = { __typename?: 'PetPlateProductVariantType', id: string };

export type AdminProductVariantQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminProductVariantQuery = { __typename?: 'Query', productVariant: { __typename?: 'PetPlateProductVariantType', id: string, state: string, name?: string | null, sku?: string | null, preferred?: boolean | null, outOfStock?: boolean | null, createdAt: any, updatedAt: any, product?: { __typename?: 'PetPlateProduct', name?: string | null, sku?: string | null, parentShopifyId?: string | null, id: string } | null, boxVariant?: { __typename?: 'BoxVariant', name: string, sku?: string | null, id: string } | null } };

export type AdminBoxVariantQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminBoxVariantQuery = { __typename?: 'Query', boxVariant: { __typename?: 'BoxVariant', active?: boolean | null, activeFrom?: any | null, activeUntil?: any | null, addonUnits: number, calorieGroup?: number | null, category: string, categoryMapped: TypesBoxVariantCategory, defaultFrequency?: number | null, deletedAt?: any | null, displayOrder?: number | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, price?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, sku?: string | null, box?: { __typename?: 'Box', name: string, id: string, sku?: string | null } | null, meals?: Array<{ __typename?: 'Meal', id: string, name?: string | null, shopifyId?: string | null, sku?: string | null }> | null, products?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, sku?: string | null }> | null, mealVariants?: Array<{ __typename?: 'PetPlateMealVariantType', id: string, name?: string | null, sku?: string | null, outOfStock?: boolean | null, meal?: { __typename?: 'PetPlateProduct', sku?: string | null, parentShopifyId?: string | null, name?: string | null } | null }> | null, productVariants?: Array<{ __typename?: 'PetPlateProductVariantType', id: string, name?: string | null, sku?: string | null, outOfStock?: boolean | null, product?: { __typename?: 'PetPlateProduct', sku?: string | null, parentShopifyId?: string | null, name?: string | null } | null }> | null } };

export type AdminBoxVariantsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversBoxVariantsResolverOrder>;
}>;


export type AdminBoxVariantsQuery = { __typename?: 'Query', boxVariants: { __typename?: 'BoxVariantConnection', nodes?: Array<{ __typename?: 'BoxVariant', active?: boolean | null, activeFrom?: any | null, activeUntil?: any | null, addonUnits: number, calorieGroup?: number | null, category: string, categoryMapped: TypesBoxVariantCategory, defaultFrequency?: number | null, deletedAt?: any | null, displayOrder?: number | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, price?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, sku?: string | null, box?: { __typename?: 'Box', name: string, id: string, sku?: string | null } | null, meals?: Array<{ __typename?: 'Meal', id: string, name?: string | null, shopifyId?: string | null, sku?: string | null }> | null, products?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, sku?: string | null }> | null, mealVariants?: Array<{ __typename?: 'PetPlateMealVariantType', id: string, name?: string | null, sku?: string | null, outOfStock?: boolean | null, meal?: { __typename?: 'PetPlateProduct', sku?: string | null, parentShopifyId?: string | null, name?: string | null } | null }> | null, productVariants?: Array<{ __typename?: 'PetPlateProductVariantType', id: string, name?: string | null, sku?: string | null, outOfStock?: boolean | null, product?: { __typename?: 'PetPlateProduct', sku?: string | null, parentShopifyId?: string | null, name?: string | null } | null }> | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminBoxVariantCreateMutationVariables = Exact<{
  input: BoxVariantCreateInput;
}>;


export type AdminBoxVariantCreateMutation = { __typename?: 'Mutation', boxVariantCreate?: { __typename?: 'BoxVariantCreatePayload', boxVariant: { __typename?: 'BoxVariant', active?: boolean | null, activeFrom?: any | null, activeUntil?: any | null, addonUnits: number, calorieGroup?: number | null, category: string, categoryMapped: TypesBoxVariantCategory, defaultFrequency?: number | null, deletedAt?: any | null, displayOrder?: number | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, price?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, sku?: string | null, box?: { __typename?: 'Box', name: string, id: string, sku?: string | null } | null, meals?: Array<{ __typename?: 'Meal', id: string, name?: string | null, shopifyId?: string | null, sku?: string | null }> | null, products?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, sku?: string | null }> | null, mealVariants?: Array<{ __typename?: 'PetPlateMealVariantType', id: string, name?: string | null, sku?: string | null, outOfStock?: boolean | null, meal?: { __typename?: 'PetPlateProduct', sku?: string | null, parentShopifyId?: string | null, name?: string | null } | null }> | null, productVariants?: Array<{ __typename?: 'PetPlateProductVariantType', id: string, name?: string | null, sku?: string | null, outOfStock?: boolean | null, product?: { __typename?: 'PetPlateProduct', sku?: string | null, parentShopifyId?: string | null, name?: string | null } | null }> | null } } | null };

export type AdminBoxVariantUpdateMutationVariables = Exact<{
  input: BoxVariantUpdateInput;
}>;


export type AdminBoxVariantUpdateMutation = { __typename?: 'Mutation', boxVariantUpdate?: { __typename?: 'BoxVariantUpdatePayload', boxVariant: { __typename?: 'BoxVariant', active?: boolean | null, activeFrom?: any | null, activeUntil?: any | null, addonUnits: number, calorieGroup?: number | null, category: string, categoryMapped: TypesBoxVariantCategory, defaultFrequency?: number | null, deletedAt?: any | null, displayOrder?: number | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, price?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, sku?: string | null, box?: { __typename?: 'Box', name: string, id: string, sku?: string | null } | null, meals?: Array<{ __typename?: 'Meal', id: string, name?: string | null, shopifyId?: string | null, sku?: string | null }> | null, products?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, sku?: string | null }> | null, mealVariants?: Array<{ __typename?: 'PetPlateMealVariantType', id: string, name?: string | null, sku?: string | null, outOfStock?: boolean | null, meal?: { __typename?: 'PetPlateProduct', sku?: string | null, parentShopifyId?: string | null, name?: string | null } | null }> | null, productVariants?: Array<{ __typename?: 'PetPlateProductVariantType', id: string, name?: string | null, sku?: string | null, outOfStock?: boolean | null, product?: { __typename?: 'PetPlateProduct', sku?: string | null, parentShopifyId?: string | null, name?: string | null } | null }> | null } } | null };

export type BoxVariantPropsFragment = { __typename?: 'BoxVariant', active?: boolean | null, activeFrom?: any | null, activeUntil?: any | null, addonUnits: number, calorieGroup?: number | null, category: string, categoryMapped: TypesBoxVariantCategory, defaultFrequency?: number | null, deletedAt?: any | null, displayOrder?: number | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, price?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, sku?: string | null, box?: { __typename?: 'Box', name: string, id: string, sku?: string | null } | null, meals?: Array<{ __typename?: 'Meal', id: string, name?: string | null, shopifyId?: string | null, sku?: string | null }> | null, products?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, sku?: string | null }> | null, mealVariants?: Array<{ __typename?: 'PetPlateMealVariantType', id: string, name?: string | null, sku?: string | null, outOfStock?: boolean | null, meal?: { __typename?: 'PetPlateProduct', sku?: string | null, parentShopifyId?: string | null, name?: string | null } | null }> | null, productVariants?: Array<{ __typename?: 'PetPlateProductVariantType', id: string, name?: string | null, sku?: string | null, outOfStock?: boolean | null, product?: { __typename?: 'PetPlateProduct', sku?: string | null, parentShopifyId?: string | null, name?: string | null } | null }> | null };

export type AdminBoxQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminBoxQuery = { __typename?: 'Query', box: { __typename?: 'Box', bagQuantity?: number | null, bagWeight?: number | null, bagVolume?: number | null, itemQuantity: number, itemWeight?: number | null, itemVolume?: number | null, routeCode: RouteCode, state: string, displayOrder?: number | null, id: string, legacyCategory: string, legacyDefaultFrequency?: number | null, name: string, sku?: string | null, packagingId?: number | null, packaging?: { __typename?: 'Packaging', id: string, name?: string | null, code?: string | null, description?: string | null } | null, boxVariants?: Array<{ __typename?: 'BoxVariant', id: string, sku?: string | null, name: string, addonUnits: number, calorieGroup?: number | null, category: string, defaultFrequency?: number | null, mealsPerDay: number, price?: number | null, planType?: BoxVariantPlanTypeEnum | null, active?: boolean | null, activeFrom?: any | null, activeUntil?: any | null, deletedAt?: any | null, displayOrder?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, meals?: Array<{ __typename?: 'Meal', id: string, sku?: string | null, category?: MealCategoryEnum | null, name?: string | null, weightInOunces?: number | null, price?: number | null, shopifyId?: string | null, surchargeAmount: number }> | null, products?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, sku?: string | null, weightInOunces?: number | null, shopifyId?: string | null, surchargeAmount: number, recipe?: { __typename?: 'Recipe', id: string, name: string } | null }> | null, box?: { __typename?: 'Box', id: string } | null }> | null } };

export type AdminBoxesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversBoxesResolverOrder>;
  name?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<TypesBoxInputTypeState>;
  planType?: InputMaybe<BoxVariantPlanTypeEnum>;
  routeCode?: InputMaybe<RouteCode>;
  boxVariantSku?: InputMaybe<Scalars['String']>;
}>;


export type AdminBoxesQuery = { __typename?: 'Query', boxes: { __typename?: 'BoxConnection', nodes?: Array<{ __typename?: 'Box', id: string, sku?: string | null, routeCode: RouteCode, bagQuantity?: number | null, bagWeight?: number | null, bagVolume?: number | null, itemQuantity: number, itemWeight?: number | null, itemVolume?: number | null, boxVariants?: Array<{ __typename?: 'BoxVariant', id: string, sku?: string | null, name: string, calorieGroup?: number | null }> | null, packaging?: { __typename?: 'Packaging', name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminBoxCreateMutationVariables = Exact<{
  input: BoxCreateInput;
}>;


export type AdminBoxCreateMutation = { __typename?: 'Mutation', boxCreate?: { __typename?: 'BoxCreatePayload', box: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null, displayOrder?: number | null, id: string, itemQuantity: number, itemVolume?: number | null, itemWeight?: number | null, legacyCategory: string, legacyDefaultFrequency?: number | null, name: string, routeCode: RouteCode, sku?: string | null, packagingId?: number | null, state: string, boxVariants?: Array<{ __typename?: 'BoxVariant', active?: boolean | null, activeFrom?: any | null, activeUntil?: any | null, addonUnits: number, calorieGroup?: number | null, category: string, defaultFrequency?: number | null, deletedAt?: any | null, displayOrder?: number | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, price?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, sku?: string | null, box?: { __typename?: 'Box', id: string } | null }> | null, packaging?: { __typename?: 'Packaging', name?: string | null } | null } } | null };

export type AdminBoxUpdateMutationVariables = Exact<{
  input: BoxUpdateInput;
}>;


export type AdminBoxUpdateMutation = { __typename?: 'Mutation', boxUpdate?: { __typename?: 'BoxUpdatePayload', box: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null, displayOrder?: number | null, id: string, itemQuantity: number, itemVolume?: number | null, itemWeight?: number | null, legacyCategory: string, legacyDefaultFrequency?: number | null, name: string, routeCode: RouteCode, sku?: string | null, packagingId?: number | null, state: string, boxVariants?: Array<{ __typename?: 'BoxVariant', active?: boolean | null, activeFrom?: any | null, activeUntil?: any | null, addonUnits: number, calorieGroup?: number | null, category: string, defaultFrequency?: number | null, deletedAt?: any | null, displayOrder?: number | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, price?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, sku?: string | null, box?: { __typename?: 'Box', id: string } | null }> | null, packaging?: { __typename?: 'Packaging', name?: string | null } | null } } | null };

export type BoxPropsFragment = { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null, displayOrder?: number | null, id: string, itemQuantity: number, itemVolume?: number | null, itemWeight?: number | null, legacyCategory: string, legacyDefaultFrequency?: number | null, name: string, routeCode: RouteCode, sku?: string | null, packagingId?: number | null, state: string, boxVariants?: Array<{ __typename?: 'BoxVariant', active?: boolean | null, activeFrom?: any | null, activeUntil?: any | null, addonUnits: number, calorieGroup?: number | null, category: string, defaultFrequency?: number | null, deletedAt?: any | null, displayOrder?: number | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, price?: number | null, sellingPlanId?: string | null, shopifyId?: string | null, sku?: string | null, box?: { __typename?: 'Box', id: string } | null }> | null, packaging?: { __typename?: 'Packaging', name?: string | null } | null };

export type AdminSearchPackagingsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchPackagingsQuery = { __typename?: 'Query', packagings: { __typename?: 'PackagingConnection', nodes?: Array<{ __typename?: 'Packaging', id: string, name?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminBreedQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminBreedQuery = { __typename?: 'Query', breed: { __typename?: 'Breed', active: boolean, activityLevel?: string | null, id: string, mixedBreed: boolean, name: string, sizeClass?: string | null, slug: string } };

export type AdminBreedsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversBreedsResolverOrder>;
  name?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminBreedsQuery = { __typename?: 'Query', breeds: { __typename?: 'BreedConnection', nodes?: Array<{ __typename?: 'Breed', active: boolean, activityLevel?: string | null, id: string, mixedBreed: boolean, name: string, sizeClass?: string | null, slug: string } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null, currentPage: number, totalPages: number } } };

export type AdminBreedCreateMutationVariables = Exact<{
  input: BreedCreateInput;
}>;


export type AdminBreedCreateMutation = { __typename?: 'Mutation', breedCreate?: { __typename?: 'BreedCreatePayload', breed: { __typename?: 'Breed', active: boolean, activityLevel?: string | null, id: string, mixedBreed: boolean, name: string, sizeClass?: string | null, slug: string } } | null };

export type AdminBreedUpdateMutationVariables = Exact<{
  input: BreedUpdateInput;
}>;


export type AdminBreedUpdateMutation = { __typename?: 'Mutation', breedUpdate?: { __typename?: 'BreedUpdatePayload', breed: { __typename?: 'Breed', active: boolean, activityLevel?: string | null, id: string, mixedBreed: boolean, name: string, sizeClass?: string | null, slug: string } } | null };

export type BreedPropsFragment = { __typename?: 'Breed', active: boolean, activityLevel?: string | null, id: string, mixedBreed: boolean, name: string, sizeClass?: string | null, slug: string };

export type AdminCalorieMultiplierQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminCalorieMultiplierQuery = { __typename?: 'Query', calorieMultiplier: { __typename?: 'CalorieMultiplier', activityLevel?: string | null, age?: string | null, bodyCondition?: string | null, createdAt: any, id: string, multiplier?: number | null, noteToCustomer?: string | null, notes?: string | null, obeseProneness?: string | null, spayedNeutered?: string | null, updatedAt: any } };

export type AdminCalorieMultipliersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversCalorieMultipliersResolverOrder>;
  activityLevel?: InputMaybe<Scalars['String']>;
  bodyCondition?: InputMaybe<Scalars['String']>;
}>;


export type AdminCalorieMultipliersQuery = { __typename?: 'Query', calorieMultipliers: { __typename?: 'CalorieMultiplierConnection', nodes?: Array<{ __typename?: 'CalorieMultiplier', activityLevel?: string | null, age?: string | null, bodyCondition?: string | null, createdAt: any, id: string, multiplier?: number | null, noteToCustomer?: string | null, notes?: string | null, obeseProneness?: string | null, spayedNeutered?: string | null, updatedAt: any } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminCalorieMultiplierCreateMutationVariables = Exact<{
  input: CalorieMultiplierCreateInput;
}>;


export type AdminCalorieMultiplierCreateMutation = { __typename?: 'Mutation', calorieMultiplierCreate?: { __typename?: 'CalorieMultiplierCreatePayload', calorieMultiplier: { __typename?: 'CalorieMultiplier', activityLevel?: string | null, age?: string | null, bodyCondition?: string | null, createdAt: any, id: string, multiplier?: number | null, noteToCustomer?: string | null, notes?: string | null, obeseProneness?: string | null, spayedNeutered?: string | null, updatedAt: any } } | null };

export type AdminCalorieMultiplierUpdateMutationVariables = Exact<{
  input: CalorieMultiplierUpdateInput;
}>;


export type AdminCalorieMultiplierUpdateMutation = { __typename?: 'Mutation', calorieMultiplierUpdate?: { __typename?: 'CalorieMultiplierUpdatePayload', calorieMultiplier: { __typename?: 'CalorieMultiplier', activityLevel?: string | null, age?: string | null, bodyCondition?: string | null, createdAt: any, id: string, multiplier?: number | null, noteToCustomer?: string | null, notes?: string | null, obeseProneness?: string | null, spayedNeutered?: string | null, updatedAt: any } } | null };

export type AdminCalorieMultiplierRemoveMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminCalorieMultiplierRemoveMutation = { __typename?: 'Mutation', calorieMultiplierDelete?: { __typename?: 'CalorieMultiplierDeletePayload', calorieMultiplier: { __typename?: 'CalorieMultiplier', activityLevel?: string | null, age?: string | null, bodyCondition?: string | null, createdAt: any, id: string, multiplier?: number | null, noteToCustomer?: string | null, notes?: string | null, obeseProneness?: string | null, spayedNeutered?: string | null, updatedAt: any } } | null };

export type CalorieMultiplierPropsFragment = { __typename?: 'CalorieMultiplier', activityLevel?: string | null, age?: string | null, bodyCondition?: string | null, createdAt: any, id: string, multiplier?: number | null, noteToCustomer?: string | null, notes?: string | null, obeseProneness?: string | null, spayedNeutered?: string | null, updatedAt: any };

export type AdminCancellationSurveyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminCancellationSurveyQuery = { __typename?: 'Query', cancellationSurvey: { __typename?: 'CancellationSurvey', id: string, subscription?: { __typename?: 'Subscription', renewals?: number | null, state?: SubscriptionStateEnum | null, updatedAt?: any | null, id: string, number?: string | null, previousPlan?: { __typename?: 'BoxVariant', id: string } | null, currentPlan?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, name?: string | null } | null, pet?: { __typename?: 'Pet', petName?: string | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null } | null, cancellationReasonTerm?: { __typename?: 'Term', id: string, description?: string | null } | null } };

export type AdminCancellationSurveysQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversCancellationSurveysResolverOrder>;
  subscriptionNumber?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  cancellationReasonOther?: InputMaybe<Scalars['String']>;
}>;


export type AdminCancellationSurveysQuery = { __typename?: 'Query', cancellationSurveys: { __typename?: 'CancellationSurveyConnection', nodes?: Array<{ __typename?: 'CancellationSurvey', id: string, subscription?: { __typename?: 'Subscription', renewals?: number | null, state?: SubscriptionStateEnum | null, updatedAt?: any | null, id: string, number?: string | null, previousPlan?: { __typename?: 'BoxVariant', id: string } | null, currentPlan?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, name?: string | null } | null, pet?: { __typename?: 'Pet', petName?: string | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null } | null, cancellationReasonTerm?: { __typename?: 'Term', id: string, description?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminCancellationSurveyCreateMutationVariables = Exact<{
  input: CancellationSurveyCreateInput;
}>;


export type AdminCancellationSurveyCreateMutation = { __typename?: 'Mutation', cancellationSurveyCreate?: { __typename?: 'CancellationSurveyCreatePayload', cancellationSurvey: { __typename?: 'CancellationSurvey', id: string, subscription?: { __typename?: 'Subscription', renewals?: number | null, state?: SubscriptionStateEnum | null, updatedAt?: any | null, id: string, number?: string | null, previousPlan?: { __typename?: 'BoxVariant', id: string } | null, currentPlan?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, name?: string | null } | null, pet?: { __typename?: 'Pet', petName?: string | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null } | null, cancellationReasonTerm?: { __typename?: 'Term', id: string, description?: string | null } | null } } | null };

export type AdminCancellationSurveyUpdateMutationVariables = Exact<{
  input: CancellationSurveyUpdateInput;
}>;


export type AdminCancellationSurveyUpdateMutation = { __typename?: 'Mutation', cancellationSurveyUpdate?: { __typename?: 'CancellationSurveyUpdatePayload', cancellationSurvey: { __typename?: 'CancellationSurvey', id: string, subscription?: { __typename?: 'Subscription', renewals?: number | null, state?: SubscriptionStateEnum | null, updatedAt?: any | null, id: string, number?: string | null, previousPlan?: { __typename?: 'BoxVariant', id: string } | null, currentPlan?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, name?: string | null } | null, pet?: { __typename?: 'Pet', petName?: string | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null } | null, cancellationReasonTerm?: { __typename?: 'Term', id: string, description?: string | null } | null } } | null };

export type CancellationSurveyPropsFragment = { __typename?: 'CancellationSurvey', id: string, subscription?: { __typename?: 'Subscription', renewals?: number | null, state?: SubscriptionStateEnum | null, updatedAt?: any | null, id: string, number?: string | null, previousPlan?: { __typename?: 'BoxVariant', id: string } | null, currentPlan?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, name?: string | null } | null, pet?: { __typename?: 'Pet', petName?: string | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null } | null, cancellationReasonTerm?: { __typename?: 'Term', id: string, description?: string | null } | null };

export type AdminSearchTermsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchTermsQuery = { __typename?: 'Query', terms: { __typename?: 'TermConnection', nodes?: Array<{ __typename?: 'Term', id: string, name?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminSearchSubscriptionsQueryVariables = Exact<{
  number?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchSubscriptionsQuery = { __typename?: 'Query', subscriptions: { __typename?: 'SubscriptionConnection', nodes?: Array<{ __typename?: 'Subscription', id: string, number?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type ChangelogQueryVariables = Exact<{
  itemId: Scalars['ID'];
  itemType?: InputMaybe<VersionedModelClassEnum>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ChangelogQuery = { __typename?: 'Query', changelogEntries: { __typename?: 'ChangelogEntryConnection', nodes?: Array<{ __typename?: 'ChangelogEntry', createdAt?: any | null, event?: string | null, itemId: string, itemType: string, whodunnit?: string | null, changes?: any | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null, hasNextPage: boolean, totalPages: number, pageSize: number } } };

export type SubscriptionChangelogQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SubscriptionChangelogQuery = { __typename?: 'Query', subscription: { __typename?: 'Subscription', changelogEntries: { __typename?: 'ChangelogEntryConnection', nodes?: Array<{ __typename?: 'ChangelogEntry', createdAt?: any | null, event?: string | null, itemId: string, itemType: string, whodunnit?: string | null, changes?: any | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null, hasNextPage: boolean, totalPages: number, pageSize: number } } } };

export type AdminCommentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminCommentQuery = { __typename?: 'Query', ppComment: { __typename?: 'PpComment', authorType?: string | null, body?: string | null, createdAt: any, id: string, namespace?: string | null, resourceId?: string | null, resourceType?: PpCommentResource | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } };

export type AdminCommentRmMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminCommentRmMutation = { __typename?: 'Mutation', ppCommentDelete?: { __typename?: 'PpCommentDeletePayload', ppComment: { __typename?: 'PpComment', authorType?: string | null, body?: string | null, createdAt: any, id: string, namespace?: string | null, resourceId?: string | null, resourceType?: PpCommentResource | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } } | null };

export type AdminCommentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPpCommentsResolverOrder>;
  resourceType?: InputMaybe<PpCommentResource>;
  resourceId?: InputMaybe<Scalars['ID']>;
  namespace?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  createdAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type AdminCommentsQuery = { __typename?: 'Query', ppComments: { __typename?: 'PpCommentConnection', nodes?: Array<{ __typename?: 'PpComment', authorType?: string | null, body?: string | null, createdAt: any, id: string, namespace?: string | null, resourceId?: string | null, resourceType?: PpCommentResource | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminCommentCreateMutationVariables = Exact<{
  input: PpCommentCreateInput;
}>;


export type AdminCommentCreateMutation = { __typename?: 'Mutation', ppCommentCreate?: { __typename?: 'PpCommentCreatePayload', ppComment: { __typename?: 'PpComment', authorType?: string | null, body?: string | null, createdAt: any, id: string, namespace?: string | null, resourceId?: string | null, resourceType?: PpCommentResource | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } } | null };

export type CommentPropsFragment = { __typename?: 'PpComment', authorType?: string | null, body?: string | null, createdAt: any, id: string, namespace?: string | null, resourceId?: string | null, resourceType?: PpCommentResource | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null };

export type AdminConversionSurveyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminConversionSurveyQuery = { __typename?: 'Query', conversionSurvey: { __typename?: 'ConversionSurvey', createdAt: any, id: string, otherWebsite?: string | null, source: string, updatedAt: any, subscription?: { __typename?: 'Subscription', email?: string | null, number?: string | null, id: string, user?: { __typename?: 'User', id?: string | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null, currentPlan?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null } | null } };

export type AdminConversionSurveysQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversConversionSurveysResolverOrder>;
  source?: InputMaybe<Scalars['String']>;
}>;


export type AdminConversionSurveysQuery = { __typename?: 'Query', conversionSurveys: { __typename?: 'ConversionSurveyConnection', nodes?: Array<{ __typename?: 'ConversionSurvey', createdAt: any, id: string, otherWebsite?: string | null, source: string, updatedAt: any, subscription?: { __typename?: 'Subscription', email?: string | null, number?: string | null, id: string, user?: { __typename?: 'User', id?: string | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null, currentPlan?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminConversionSurveyCreateMutationVariables = Exact<{
  input: ConversionSurveyCreateInput;
}>;


export type AdminConversionSurveyCreateMutation = { __typename?: 'Mutation', conversionSurveyCreate?: { __typename?: 'ConversionSurveyCreatePayload', conversionSurvey: { __typename?: 'ConversionSurvey', createdAt: any, id: string, otherWebsite?: string | null, source: string, updatedAt: any, subscription?: { __typename?: 'Subscription', email?: string | null, number?: string | null, id: string, user?: { __typename?: 'User', id?: string | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null, currentPlan?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null } | null } } | null };

export type AdminConversionSurveyUpdateMutationVariables = Exact<{
  input: ConversionSurveyUpdateInput;
}>;


export type AdminConversionSurveyUpdateMutation = { __typename?: 'Mutation', conversionSurveyUpdate?: { __typename?: 'ConversionSurveyUpdatePayload', conversionSurvey: { __typename?: 'ConversionSurvey', createdAt: any, id: string, otherWebsite?: string | null, source: string, updatedAt: any, subscription?: { __typename?: 'Subscription', email?: string | null, number?: string | null, id: string, user?: { __typename?: 'User', id?: string | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null, currentPlan?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null } | null } } | null };

export type ConversionSurveyPropsFragment = { __typename?: 'ConversionSurvey', createdAt: any, id: string, otherWebsite?: string | null, source: string, updatedAt: any, subscription?: { __typename?: 'Subscription', email?: string | null, number?: string | null, id: string, user?: { __typename?: 'User', id?: string | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null, currentPlan?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null } | null };

export type AdminUpdateCouponMutationVariables = Exact<{
  input: CouponUpdateInput;
}>;


export type AdminUpdateCouponMutation = { __typename?: 'Mutation', couponUpdate?: { __typename?: 'CouponUpdatePayload', coupon: { __typename?: 'Coupon', id: string } } | null };

export type AdminImportShopifyCouponMutationVariables = Exact<{
  input: CouponImportInput;
}>;


export type AdminImportShopifyCouponMutation = { __typename?: 'Mutation', couponImport?: { __typename?: 'CouponImportPayload', result?: { __typename?: 'ShopifyCouponRefresh', errorMessage?: string | null, coupon?: { __typename?: 'Coupon', id: string, code?: string | null } | null } | null } | null };

export type AdminRefreshCouponMutationVariables = Exact<{
  input: CouponRefreshInput;
}>;


export type AdminRefreshCouponMutation = { __typename?: 'Mutation', couponRefresh?: { __typename?: 'CouponRefreshPayload', result?: { __typename?: 'ShopifyCouponRefresh', errorMessage?: string | null, coupon?: { __typename?: 'Coupon', id: string, code?: string | null } | null } | null } | null };

export type AdminCouponsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversCouponsResolverOrder>;
  shopifyReady?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<CouponDurationEnum>;
}>;


export type AdminCouponsQuery = { __typename?: 'Query', coupons: { __typename?: 'CouponConnection', nodes?: Array<{ __typename?: 'Coupon', id: string, code?: string | null, shopifyId?: string | null, maskedCode?: string | null, note?: string | null, percentOff?: number | null, amountOff?: number | null, createdAt?: any | null, updatedAt?: any | null, duration?: CouponDurationEnum | null, linkable?: boolean | null, linkedCouponId?: string | null, linkedCoupon?: { __typename?: 'Coupon', id: string, code?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminCouponQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminCouponQuery = { __typename?: 'Query', coupon: { __typename?: 'Coupon', customPromoText?: string | null, id: string, code?: string | null, shopifyId?: string | null, maskedCode?: string | null, note?: string | null, percentOff?: number | null, amountOff?: number | null, createdAt?: any | null, updatedAt?: any | null, duration?: CouponDurationEnum | null, linkable?: boolean | null, linkedCouponId?: string | null, linkedCoupon?: { __typename?: 'Coupon', id: string, code?: string | null } | null } };

export type AdminSearchPlatformCouponsQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchPlatformCouponsQuery = { __typename?: 'Query', coupons: { __typename?: 'CouponConnection', nodes?: Array<{ __typename?: 'Coupon', id: string, code?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type CouponPropsFragment = { __typename?: 'Coupon', id: string, code?: string | null, shopifyId?: string | null, maskedCode?: string | null, note?: string | null, percentOff?: number | null, amountOff?: number | null, createdAt?: any | null, updatedAt?: any | null, duration?: CouponDurationEnum | null, linkable?: boolean | null, linkedCouponId?: string | null, linkedCoupon?: { __typename?: 'Coupon', id: string, code?: string | null } | null };

export type AdminStoreCreditAccountQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminStoreCreditAccountQuery = { __typename?: 'Query', storeCreditAccount: { __typename?: 'StoreCreditAccount', amount?: number | null, createdAt: any, id: string, number: string, transactions?: number | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } };

export type AdminStoreCreditAccountsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversStoreCreditAccountsResolverOrder>;
  number?: InputMaybe<Scalars['String']>;
}>;


export type AdminStoreCreditAccountsQuery = { __typename?: 'Query', storeCreditAccounts: { __typename?: 'StoreCreditAccountConnection', nodes?: Array<{ __typename?: 'StoreCreditAccount', amount?: number | null, createdAt: any, id: string, number: string, transactions?: number | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminStoreCreditAccountCreateMutationVariables = Exact<{
  input: StoreCreditAccountCreateInput;
}>;


export type AdminStoreCreditAccountCreateMutation = { __typename?: 'Mutation', storeCreditAccountCreate?: { __typename?: 'StoreCreditAccountCreatePayload', storeCreditAccount: { __typename?: 'StoreCreditAccount', amount?: number | null, createdAt: any, id: string, number: string, transactions?: number | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } } | null };

export type AdminStoreCreditAccountUpdateMutationVariables = Exact<{
  input: StoreCreditAccountUpdateInput;
}>;


export type AdminStoreCreditAccountUpdateMutation = { __typename?: 'Mutation', storeCreditAccountUpdate?: { __typename?: 'StoreCreditAccountUpdatePayload', storeCreditAccount: { __typename?: 'StoreCreditAccount', amount?: number | null, createdAt: any, id: string, number: string, transactions?: number | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } } | null };

export type StoreCreditAccountPropsFragment = { __typename?: 'StoreCreditAccount', amount?: number | null, createdAt: any, id: string, number: string, transactions?: number | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null };

export type UserPropsFragment = { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null };

export type AdminSearchStoreCreditAccountsQueryVariables = Exact<{
  number?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchStoreCreditAccountsQuery = { __typename?: 'Query', storeCreditAccounts: { __typename?: 'StoreCreditAccountConnection', nodes?: Array<{ __typename?: 'StoreCreditAccount', id: string, number: string } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminUserCreditAccountQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminUserCreditAccountQuery = { __typename?: 'Query', user: { __typename?: 'User', id?: string | null, ensuredStoreCreditAccount: { __typename?: 'StoreCreditAccount', id: string, number: string } } };

export type AdminStoreCreditMovementQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminStoreCreditMovementQuery = { __typename?: 'Query', storeCreditMovement: { __typename?: 'StoreCreditMovement', amount: number, createdAt: any, id: string, message?: string | null, number: number, reasonId?: number | null, updatedAt: any, whoDidItId?: number | null, creditSubmitterId?: number | null, storeCreditAccountId?: number | null, whoDidIt?: { __typename?: 'User', id?: string | null, email?: string | null } | null, creditSubmitter?: { __typename?: 'User', id?: string | null, email?: string | null } | null, payment?: { __typename?: 'PpPayment', id: string } | null, reason?: { __typename?: 'Term', id: string, name?: string | null } | null, storeCreditAccount?: { __typename?: 'StoreCreditAccount', createdAt: any, id: string, number: string, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null } };

export type AdminStoreCreditReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminStoreCreditReasonsQuery = { __typename?: 'Query', surveyOptions: { __typename?: 'SurveyOptions', creditReason: Array<{ __typename?: 'SurveyOption', label: string, value: number }> } };

export type AdminStoreCreditMovementsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<ResolversStoreCreditMovementsResolverOrder>;
}>;


export type AdminStoreCreditMovementsQuery = { __typename?: 'Query', storeCreditMovements: { __typename?: 'StoreCreditMovementConnection', nodes?: Array<{ __typename?: 'StoreCreditMovement', amount: number, createdAt: any, id: string, message?: string | null, number: number, reasonId?: number | null, updatedAt: any, whoDidItId?: number | null, creditSubmitterId?: number | null, storeCreditAccountId?: number | null, whoDidIt?: { __typename?: 'User', id?: string | null, email?: string | null } | null, creditSubmitter?: { __typename?: 'User', id?: string | null, email?: string | null } | null, payment?: { __typename?: 'PpPayment', id: string } | null, reason?: { __typename?: 'Term', id: string, name?: string | null } | null, storeCreditAccount?: { __typename?: 'StoreCreditAccount', createdAt: any, id: string, number: string, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminStoreCreditMovementCreateMutationVariables = Exact<{
  input: StoreCreditMovementCreateInput;
}>;


export type AdminStoreCreditMovementCreateMutation = { __typename?: 'Mutation', storeCreditMovementCreate?: { __typename?: 'StoreCreditMovementCreatePayload', storeCreditMovement: { __typename?: 'StoreCreditMovement', amount: number, createdAt: any, id: string, message?: string | null, number: number, reasonId?: number | null, updatedAt: any, whoDidItId?: number | null, creditSubmitterId?: number | null, storeCreditAccountId?: number | null, whoDidIt?: { __typename?: 'User', id?: string | null, email?: string | null } | null, creditSubmitter?: { __typename?: 'User', id?: string | null, email?: string | null } | null, payment?: { __typename?: 'PpPayment', id: string } | null, reason?: { __typename?: 'Term', id: string, name?: string | null } | null, storeCreditAccount?: { __typename?: 'StoreCreditAccount', createdAt: any, id: string, number: string, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null } } | null };

export type AdminStoreCreditMovementUpdateMutationVariables = Exact<{
  input: StoreCreditMovementUpdateInput;
}>;


export type AdminStoreCreditMovementUpdateMutation = { __typename?: 'Mutation', storeCreditMovementUpdate?: { __typename?: 'StoreCreditMovementUpdatePayload', storeCreditMovement: { __typename?: 'StoreCreditMovement', amount: number, createdAt: any, id: string, message?: string | null, number: number, reasonId?: number | null, updatedAt: any, whoDidItId?: number | null, creditSubmitterId?: number | null, storeCreditAccountId?: number | null, whoDidIt?: { __typename?: 'User', id?: string | null, email?: string | null } | null, creditSubmitter?: { __typename?: 'User', id?: string | null, email?: string | null } | null, payment?: { __typename?: 'PpPayment', id: string } | null, reason?: { __typename?: 'Term', id: string, name?: string | null } | null, storeCreditAccount?: { __typename?: 'StoreCreditAccount', createdAt: any, id: string, number: string, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null } } | null };

export type StoreCreditMovementPropsFragment = { __typename?: 'StoreCreditMovement', amount: number, createdAt: any, id: string, message?: string | null, number: number, reasonId?: number | null, updatedAt: any, whoDidItId?: number | null, creditSubmitterId?: number | null, storeCreditAccountId?: number | null, whoDidIt?: { __typename?: 'User', id?: string | null, email?: string | null } | null, creditSubmitter?: { __typename?: 'User', id?: string | null, email?: string | null } | null, payment?: { __typename?: 'PpPayment', id: string } | null, reason?: { __typename?: 'Term', id: string, name?: string | null } | null, storeCreditAccount?: { __typename?: 'StoreCreditAccount', createdAt: any, id: string, number: string, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null };

export type MovementStoreCreditAccountPropsFragment = { __typename?: 'StoreCreditAccount', createdAt: any, id: string, number: string, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null };

export type AdminDryIceMatrixTiersQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminDryIceMatrixTiersQuery = { __typename?: 'Query', dryIceMatrixTiers: Array<{ __typename?: 'DryIceMatrixTier', id: string, min?: number | null, max?: number | null, day1?: number | null, day2?: number | null, day3?: number | null, boxSize?: string | null, createdAt: any, updatedAt: any }> };

export type AdminDryIceMatrixTierUpdateMutationVariables = Exact<{
  input: DryIceMatrixTierUpdateInput;
}>;


export type AdminDryIceMatrixTierUpdateMutation = { __typename?: 'Mutation', dryIceMatrixTierUpdate?: { __typename?: 'DryIceMatrixTierUpdatePayload', dryIceMatrixTier: { __typename?: 'DryIceMatrixTier', id: string, min?: number | null, max?: number | null, day1?: number | null, day2?: number | null, day3?: number | null, boxSize?: string | null, createdAt: any, updatedAt: any } } | null };

export type DryIceMatrixTierPropsFragment = { __typename?: 'DryIceMatrixTier', id: string, min?: number | null, max?: number | null, day1?: number | null, day2?: number | null, day3?: number | null, boxSize?: string | null, createdAt: any, updatedAt: any };

export type AdminDryIceTransitWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminDryIceTransitWarehousesQuery = { __typename?: 'Query', dryIceWarehouses: Array<{ __typename?: 'ResolversTransitWarehousesResolverWarehouse', warehouseCode: string, transits: Array<{ __typename?: 'ResolversTransitWarehousesResolverWarehouseTransit', id: number, transitCode: string }> }> };

export type AdminTransitQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminTransitQuery = { __typename?: 'Query', transitConfiguration: { __typename?: 'TransitConfiguration', id: string, transitCode?: string | null, dryIcePackagings?: Array<{ __typename?: 'DryIcePackaging', id: string, dryIceBlocks: number, packaging?: { __typename?: 'Packaging', name?: string | null } | null }> | null } };

export type AdminDryIcePackagingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminDryIcePackagingQuery = { __typename?: 'Query', dryIcePackaging: { __typename?: 'DryIcePackaging', id: string, dryIceBlocks: number, packaging?: { __typename?: 'Packaging', name?: string | null } | null } };

export type AdminDryIcePackagingMassUpdateMutationVariables = Exact<{
  inputs: DryIcePackagingMassUpdateInput;
}>;


export type AdminDryIcePackagingMassUpdateMutation = { __typename?: 'Mutation', dryIcePackagingMassUpdate?: { __typename?: 'DryIcePackagingMassUpdatePayload', dryIcePackagings: Array<{ __typename?: 'DryIcePackaging', id: string, dryIceBlocks: number, packaging?: { __typename?: 'Packaging', name?: string | null } | null }> } | null };

export type AdminDryIcePackagingMassCreateMutationVariables = Exact<{
  inputs: Array<MutationsDryIcePackagingMassCreateMassCreate> | MutationsDryIcePackagingMassCreateMassCreate;
}>;


export type AdminDryIcePackagingMassCreateMutation = { __typename?: 'Mutation', dryIcePackagingMassCreate?: { __typename?: 'DryIcePackagingMassCreatePayload', dryIcePackagings: Array<{ __typename?: 'DryIcePackaging', id: string, dryIceBlocks: number, packaging?: { __typename?: 'Packaging', name?: string | null } | null }> } | null };

export type AdminDryIcePackagingDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminDryIcePackagingDeleteMutation = { __typename?: 'Mutation', dryIcePackagingDelete?: { __typename?: 'DryIcePackagingDeletePayload', dryIcePackaging: { __typename?: 'DryIcePackaging', id: string } } | null };

export type AdminTransitConfigurationCreateMutationVariables = Exact<{
  input: TransitConfigurationCreateInput;
}>;


export type AdminTransitConfigurationCreateMutation = { __typename?: 'Mutation', transitConfigurationCreate?: { __typename?: 'TransitConfigurationCreatePayload', transitConfiguration: { __typename?: 'TransitConfiguration', id: string, transitCode?: string | null, warehouseCode?: string | null } } | null };

export type AdminTransitConfigurationDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminTransitConfigurationDeleteMutation = { __typename?: 'Mutation', transitConfigurationDelete?: { __typename?: 'TransitConfigurationDeletePayload', transitConfiguration: { __typename?: 'TransitConfiguration', id: string } } | null };

export type AdminDryIcePackagingFragmentFragment = { __typename?: 'DryIcePackaging', id: string, dryIceBlocks: number, packaging?: { __typename?: 'Packaging', name?: string | null } | null };

export type AdminLineItemRuleQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminLineItemRuleQuery = { __typename?: 'Query', lineItemRule: { __typename?: 'LineItemRule', active?: boolean | null, createdAt: any, fieldName?: string | null, id: string, operator?: string | null, updatedAt: any, value: any, lineItemRuleSet?: { __typename?: 'LineItemRuleSet', active?: boolean | null, conflictStrategy?: string | null, createdAt: any, description?: string | null, id: string, limit: number, limitStrategy?: MutationsDynamicLineItemPutLimitAction | null, lineItemDiscount: number, lineItemName?: string | null, lineItemWeight: number, lineItemPrice: number, lineItemQuantity: number, lineItemSku?: string | null, lineItemType?: string | null, logicOperator?: string | null, mergeCostStrategy: string, mergeNameStrategy?: string | null, mergeQuantityStrategy?: string | null, mergeWeightStrategy?: string | null, priority?: number | null, updatedAt: any, lineItemReplacements?: Array<{ __typename?: 'LineItemReplacement', sku: string, active: boolean }> | null, rules: Array<{ __typename?: 'LineItemRule', id: string, active?: boolean | null, fieldName?: string | null, operator?: string | null, value: any }> } | null } };

export type AdminLineItemRulesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversLineItemRulesResolverOrder>;
}>;


export type AdminLineItemRulesQuery = { __typename?: 'Query', lineItemRules: { __typename?: 'LineItemRuleConnection', nodes?: Array<{ __typename?: 'LineItemRule', active?: boolean | null, createdAt: any, fieldName?: string | null, id: string, operator?: string | null, updatedAt: any, value: any, lineItemRuleSet?: { __typename?: 'LineItemRuleSet', active?: boolean | null, conflictStrategy?: string | null, createdAt: any, description?: string | null, id: string, limit: number, limitStrategy?: MutationsDynamicLineItemPutLimitAction | null, lineItemDiscount: number, lineItemName?: string | null, lineItemWeight: number, lineItemPrice: number, lineItemQuantity: number, lineItemSku?: string | null, lineItemType?: string | null, logicOperator?: string | null, mergeCostStrategy: string, mergeNameStrategy?: string | null, mergeQuantityStrategy?: string | null, mergeWeightStrategy?: string | null, priority?: number | null, updatedAt: any, lineItemReplacements?: Array<{ __typename?: 'LineItemReplacement', sku: string, active: boolean }> | null, rules: Array<{ __typename?: 'LineItemRule', id: string, active?: boolean | null, fieldName?: string | null, operator?: string | null, value: any }> } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null, currentPage: number, totalPages: number } } };

export type AdminLineItemRuleCreateMutationVariables = Exact<{
  input: LineItemRuleCreateInput;
}>;


export type AdminLineItemRuleCreateMutation = { __typename?: 'Mutation', lineItemRuleCreate?: { __typename?: 'LineItemRuleCreatePayload', lineItemRule: { __typename?: 'LineItemRule', active?: boolean | null, createdAt: any, fieldName?: string | null, id: string, operator?: string | null, updatedAt: any, value: any, lineItemRuleSet?: { __typename?: 'LineItemRuleSet', active?: boolean | null, conflictStrategy?: string | null, createdAt: any, description?: string | null, id: string, limit: number, limitStrategy?: MutationsDynamicLineItemPutLimitAction | null, lineItemDiscount: number, lineItemName?: string | null, lineItemWeight: number, lineItemPrice: number, lineItemQuantity: number, lineItemSku?: string | null, lineItemType?: string | null, logicOperator?: string | null, mergeCostStrategy: string, mergeNameStrategy?: string | null, mergeQuantityStrategy?: string | null, mergeWeightStrategy?: string | null, priority?: number | null, updatedAt: any, lineItemReplacements?: Array<{ __typename?: 'LineItemReplacement', sku: string, active: boolean }> | null, rules: Array<{ __typename?: 'LineItemRule', id: string, active?: boolean | null, fieldName?: string | null, operator?: string | null, value: any }> } | null } } | null };

export type AdminLineItemRuleUpdateMutationVariables = Exact<{
  input: LineItemRuleUpdateInput;
}>;


export type AdminLineItemRuleUpdateMutation = { __typename?: 'Mutation', lineItemRuleUpdate?: { __typename?: 'LineItemRuleUpdatePayload', lineItemRule: { __typename?: 'LineItemRule', active?: boolean | null, createdAt: any, fieldName?: string | null, id: string, operator?: string | null, updatedAt: any, value: any, lineItemRuleSet?: { __typename?: 'LineItemRuleSet', active?: boolean | null, conflictStrategy?: string | null, createdAt: any, description?: string | null, id: string, limit: number, limitStrategy?: MutationsDynamicLineItemPutLimitAction | null, lineItemDiscount: number, lineItemName?: string | null, lineItemWeight: number, lineItemPrice: number, lineItemQuantity: number, lineItemSku?: string | null, lineItemType?: string | null, logicOperator?: string | null, mergeCostStrategy: string, mergeNameStrategy?: string | null, mergeQuantityStrategy?: string | null, mergeWeightStrategy?: string | null, priority?: number | null, updatedAt: any, lineItemReplacements?: Array<{ __typename?: 'LineItemReplacement', sku: string, active: boolean }> | null, rules: Array<{ __typename?: 'LineItemRule', id: string, active?: boolean | null, fieldName?: string | null, operator?: string | null, value: any }> } | null } } | null };

export type LineItemRulePropsFragment = { __typename?: 'LineItemRule', active?: boolean | null, createdAt: any, fieldName?: string | null, id: string, operator?: string | null, updatedAt: any, value: any, lineItemRuleSet?: { __typename?: 'LineItemRuleSet', active?: boolean | null, conflictStrategy?: string | null, createdAt: any, description?: string | null, id: string, limit: number, limitStrategy?: MutationsDynamicLineItemPutLimitAction | null, lineItemDiscount: number, lineItemName?: string | null, lineItemWeight: number, lineItemPrice: number, lineItemQuantity: number, lineItemSku?: string | null, lineItemType?: string | null, logicOperator?: string | null, mergeCostStrategy: string, mergeNameStrategy?: string | null, mergeQuantityStrategy?: string | null, mergeWeightStrategy?: string | null, priority?: number | null, updatedAt: any, lineItemReplacements?: Array<{ __typename?: 'LineItemReplacement', sku: string, active: boolean }> | null, rules: Array<{ __typename?: 'LineItemRule', id: string, active?: boolean | null, fieldName?: string | null, operator?: string | null, value: any }> } | null };

export type AdminSearchLineRuleSetsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type AdminSearchLineRuleSetsQuery = { __typename?: 'Query', lineItemRuleSets: { __typename?: 'LineItemRuleSetConnection', nodes?: Array<{ __typename?: 'LineItemRuleSet', active?: boolean | null, conflictStrategy?: string | null, createdAt: any, description?: string | null, id: string, limit: number, limitStrategy?: MutationsDynamicLineItemPutLimitAction | null, lineItemDiscount: number, lineItemName?: string | null, lineItemWeight: number, lineItemPrice: number, lineItemQuantity: number, lineItemSku?: string | null, lineItemOutOfStock?: boolean | null, lineItemType?: string | null, logicOperator?: string | null, mergeCostStrategy: string, mergeNameStrategy?: string | null, mergeQuantityStrategy?: string | null, mergeWeightStrategy?: string | null, priority?: number | null, updatedAt: any, rules: Array<{ __typename?: 'LineItemRule', id: string, active?: boolean | null, fieldName?: string | null, operator?: string | null, value: any }> } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null, totalPages: number, currentPage: number } } };

export type AdminPutDynamicLineItemMutationVariables = Exact<{
  input: DynamicLineItemPutInput;
}>;


export type AdminPutDynamicLineItemMutation = { __typename?: 'Mutation', dynamicLineItem: { __typename?: 'DynamicLineItemPutPayload', id: string } };

export type AdminDynamicLineItemQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminDynamicLineItemQuery = { __typename?: 'Query', lineItemRule: { __typename?: 'LineItemRule', active?: boolean | null, fieldName?: string | null, id: string, operator?: string | null, value: any } };

export type AdminDynamicLineItemRuleSetQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminDynamicLineItemRuleSetQuery = { __typename?: 'Query', lineItemRuleSet: { __typename?: 'LineItemRuleSet', active?: boolean | null, conflictStrategy?: string | null, id: string, limit: number, limitStrategy?: MutationsDynamicLineItemPutLimitAction | null, lineItemName?: string | null, lineItemWeight: number, lineItemQuantity: number, lineItemSku?: string | null, lineItemOutOfStock?: boolean | null, lineItemReplaceSku?: string | null, lineItemPrice: number, lineItemDiscount: number, lineItemType?: string | null, description?: string | null, logicOperator?: string | null, mergeCostStrategy: string, mergeNameStrategy?: string | null, mergeQuantityStrategy?: string | null, mergeSkuStrategy?: string | null, mergeWeightStrategy?: string | null, priority?: number | null, lineItemReplacements?: Array<{ __typename?: 'LineItemReplacement', sku: string, active: boolean }> | null, rules: Array<{ __typename?: 'LineItemRule', active?: boolean | null, fieldName?: string | null, id: string, operator?: string | null, value: any }> } };

export type AdminDynamicLineItemRuleSetsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversLineItemRuleSetsResolverOrder>;
  active?: InputMaybe<Scalars['Boolean']>;
  conflictStrategy?: InputMaybe<Scalars['String']>;
  lineItemName?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  lineItemQuantity?: InputMaybe<Scalars['Int']>;
  lineItemSku?: InputMaybe<Scalars['String']>;
  lineItemOutOfStock?: InputMaybe<Scalars['Boolean']>;
  lineItemReplaceSku?: InputMaybe<Scalars['String']>;
  lineItemPrice?: InputMaybe<Scalars['Float']>;
  lineItemDiscount?: InputMaybe<Scalars['Float']>;
  lineItemType?: InputMaybe<Scalars['String']>;
  limitStrategy?: InputMaybe<MutationsDynamicLineItemPutLimitAction>;
  mergeCostStrategy?: InputMaybe<MutationsDynamicLineItemPutDupCostAction>;
  mergeNameStrategy?: InputMaybe<MutationsDynamicLineItemPutDupNameAction>;
  mergeQuantityStrategy?: InputMaybe<MutationsDynamicLineItemPutDupCountAction>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type AdminDynamicLineItemRuleSetsQuery = { __typename?: 'Query', lineItemRuleSets: { __typename?: 'LineItemRuleSetConnection', nodes?: Array<{ __typename?: 'LineItemRuleSet', active?: boolean | null, conflictStrategy?: string | null, id: string, limit: number, limitStrategy?: MutationsDynamicLineItemPutLimitAction | null, lineItemName?: string | null, lineItemWeight: number, lineItemQuantity: number, lineItemSku?: string | null, lineItemOutOfStock?: boolean | null, lineItemReplaceSku?: string | null, lineItemPrice: number, lineItemDiscount: number, lineItemType?: string | null, description?: string | null, logicOperator?: string | null, mergeCostStrategy: string, mergeNameStrategy?: string | null, mergeQuantityStrategy?: string | null, mergeSkuStrategy?: string | null, mergeWeightStrategy?: string | null, priority?: number | null, lineItemReplacements?: Array<{ __typename?: 'LineItemReplacement', sku: string, active: boolean }> | null, rules: Array<{ __typename?: 'LineItemRule', active?: boolean | null, fieldName?: string | null, id: string, operator?: string | null, value: any }> } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null, currentPage: number, totalPages: number } } };

export type AdminDynamicLineItemRuleSetFragment = { __typename?: 'LineItemRuleSet', active?: boolean | null, conflictStrategy?: string | null, id: string, limit: number, limitStrategy?: MutationsDynamicLineItemPutLimitAction | null, lineItemName?: string | null, lineItemWeight: number, lineItemQuantity: number, lineItemSku?: string | null, lineItemOutOfStock?: boolean | null, lineItemReplaceSku?: string | null, lineItemPrice: number, lineItemDiscount: number, lineItemType?: string | null, description?: string | null, logicOperator?: string | null, mergeCostStrategy: string, mergeNameStrategy?: string | null, mergeQuantityStrategy?: string | null, mergeSkuStrategy?: string | null, mergeWeightStrategy?: string | null, priority?: number | null, lineItemReplacements?: Array<{ __typename?: 'LineItemReplacement', sku: string, active: boolean }> | null, rules: Array<{ __typename?: 'LineItemRule', active?: boolean | null, fieldName?: string | null, id: string, operator?: string | null, value: any }> };

export type AdminDynamicLineItemRuleValuesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminDynamicLineItemRuleValuesQuery = { __typename?: 'Query', lineItemRuleValues: Array<{ __typename?: 'ResolversLineItemFieldValuesResolverValues', name: string, type: ResolversLineItemFieldValuesResolverValuesType, collection: Array<{ __typename?: 'ResolversLineItemFieldValuesResolverValuesCollection', label: string, value: string }> }> };

export type AdminSearchZipCodesQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchZipCodesQuery = { __typename?: 'Query', zipCodes: { __typename?: 'ZipCodeConnection', nodes?: Array<{ __typename?: 'ZipCode', id: string, zipCode?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminSearchOrdersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchOrdersQuery = { __typename?: 'Query', dbOrders: { __typename?: 'DbOrderConnection', nodes?: Array<{ __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminLogEventQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminLogEventQuery = { __typename?: 'Query', logEvent: { __typename?: 'LogEvent', createdAt: any, data?: any | null, event?: string | null, id: string, message?: string | null, sourceId?: number | null, sourceType?: string | null, targetId?: number | null, targetType?: string | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } };

export type AdminLogEventsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversLogEventsResolverOrder>;
  event?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  sourceType?: InputMaybe<Scalars['String']>;
  targetType?: InputMaybe<Scalars['String']>;
  targetId?: InputMaybe<Scalars['ID']>;
}>;


export type AdminLogEventsQuery = { __typename?: 'Query', logEvents: { __typename?: 'LogEventConnection', nodes?: Array<{ __typename?: 'LogEvent', createdAt: any, data?: any | null, event?: string | null, id: string, message?: string | null, sourceId?: number | null, sourceType?: string | null, targetId?: number | null, targetType?: string | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null, currentPage: number, totalPages: number } } };

export type AdminLogEventCreateMutationVariables = Exact<{
  input: LogEventCreateInput;
}>;


export type AdminLogEventCreateMutation = { __typename?: 'Mutation', logEventCreate?: { __typename?: 'LogEventCreatePayload', logEvent: { __typename?: 'LogEvent', createdAt: any, data?: any | null, event?: string | null, id: string, message?: string | null, sourceId?: number | null, sourceType?: string | null, targetId?: number | null, targetType?: string | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } } | null };

export type AdminLogEventUpdateMutationVariables = Exact<{
  input: LogEventUpdateInput;
}>;


export type AdminLogEventUpdateMutation = { __typename?: 'Mutation', logEventUpdate?: { __typename?: 'LogEventUpdatePayload', logEvent: { __typename?: 'LogEvent', createdAt: any, data?: any | null, event?: string | null, id: string, message?: string | null, sourceId?: number | null, sourceType?: string | null, targetId?: number | null, targetType?: string | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } } | null };

export type LogEventPropsFragment = { __typename?: 'LogEvent', createdAt: any, data?: any | null, event?: string | null, id: string, message?: string | null, sourceId?: number | null, sourceType?: string | null, targetId?: number | null, targetType?: string | null, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null };

export type AdminReportJobQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminReportJobQuery = { __typename?: 'Query', reportJob: { __typename?: 'ReportJob', createdAt?: any | null, duration?: number | null, emails?: string | null, endedAt?: any | null, errorMessage?: string | null, exportedUrl?: string | null, id?: string | null, name?: string | null, paperclipLogContentType?: string | null, paperclipLogFileName?: string | null, paperclipLogFileSize?: number | null, paperclipLogUpdatedAt?: any | null, paperclipOutputContentType?: string | null, paperclipOutputFileName?: string | null, paperclipOutputFileSize?: number | null, paperclipOutputUpdatedAt?: any | null, startedAt?: any | null, state?: string | null, stats?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id?: string | null } | null } };

export type AdminReportJobsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversReportJobsResolverOrder>;
  name?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Scalars['String']>;
  endedAtAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  endedAtBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  errorMessage?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<TypesReportJobInputTypeState>;
  startedAtBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  startedAtAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  logContentType?: InputMaybe<Scalars['String']>;
  logFileName?: InputMaybe<Scalars['String']>;
  outputContentType?: InputMaybe<Scalars['String']>;
  outputContentName?: InputMaybe<Scalars['String']>;
}>;


export type AdminReportJobsQuery = { __typename?: 'Query', reportJobs: { __typename?: 'ReportJobConnection', nodes?: Array<{ __typename?: 'ReportJob', createdAt?: any | null, duration?: number | null, emails?: string | null, endedAt?: any | null, errorMessage?: string | null, exportedUrl?: string | null, id?: string | null, name?: string | null, paperclipLogContentType?: string | null, paperclipLogFileName?: string | null, paperclipLogFileSize?: number | null, paperclipLogUpdatedAt?: any | null, paperclipOutputContentType?: string | null, paperclipOutputFileName?: string | null, paperclipOutputFileSize?: number | null, paperclipOutputUpdatedAt?: any | null, startedAt?: any | null, state?: string | null, stats?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminReportJobCreateMutationVariables = Exact<{
  input: ReportJobCreateInput;
}>;


export type AdminReportJobCreateMutation = { __typename?: 'Mutation', reportJobCreate?: { __typename?: 'ReportJobCreatePayload', reportJob: { __typename?: 'ReportJob', createdAt?: any | null, duration?: number | null, emails?: string | null, endedAt?: any | null, errorMessage?: string | null, exportedUrl?: string | null, id?: string | null, name?: string | null, paperclipLogContentType?: string | null, paperclipLogFileName?: string | null, paperclipLogFileSize?: number | null, paperclipLogUpdatedAt?: any | null, paperclipOutputContentType?: string | null, paperclipOutputFileName?: string | null, paperclipOutputFileSize?: number | null, paperclipOutputUpdatedAt?: any | null, startedAt?: any | null, state?: string | null, stats?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id?: string | null } | null } } | null };

export type AdminReportJobUpdateMutationVariables = Exact<{
  input: ReportJobUpdateInput;
}>;


export type AdminReportJobUpdateMutation = { __typename?: 'Mutation', reportJobUpdate?: { __typename?: 'ReportJobUpdatePayload', reportJob: { __typename?: 'ReportJob', createdAt?: any | null, duration?: number | null, emails?: string | null, endedAt?: any | null, errorMessage?: string | null, exportedUrl?: string | null, id?: string | null, name?: string | null, paperclipLogContentType?: string | null, paperclipLogFileName?: string | null, paperclipLogFileSize?: number | null, paperclipLogUpdatedAt?: any | null, paperclipOutputContentType?: string | null, paperclipOutputFileName?: string | null, paperclipOutputFileSize?: number | null, paperclipOutputUpdatedAt?: any | null, startedAt?: any | null, state?: string | null, stats?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id?: string | null } | null } } | null };

export type ReportJobPropsFragment = { __typename?: 'ReportJob', createdAt?: any | null, duration?: number | null, emails?: string | null, endedAt?: any | null, errorMessage?: string | null, exportedUrl?: string | null, id?: string | null, name?: string | null, paperclipLogContentType?: string | null, paperclipLogFileName?: string | null, paperclipLogFileSize?: number | null, paperclipLogUpdatedAt?: any | null, paperclipOutputContentType?: string | null, paperclipOutputFileName?: string | null, paperclipOutputFileSize?: number | null, paperclipOutputUpdatedAt?: any | null, startedAt?: any | null, state?: string | null, stats?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id?: string | null } | null };

export type AdminFulfillmentScheduleRuleQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminFulfillmentScheduleRuleQuery = { __typename?: 'Query', fulfillmentScheduleRule: { __typename?: 'FulfillmentScheduleRule', id?: string | null, startDate?: any | null, endDate?: any | null, strategy?: FulfillmentScheduleRuleStrategyEnum | null, jumpDate?: any | null, routeCode?: string | null, warehouseCode?: string | null, zipCode?: string | null, scheduleData?: any | null } };

export type AdminFulfillmentScheduleRulesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversFulfillmentScheduleRulesResolverOrder>;
  routeCode?: InputMaybe<TypesRouteCodesType>;
  warehouseCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
  endDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  startDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  startDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type AdminFulfillmentScheduleRulesQuery = { __typename?: 'Query', fulfillmentScheduleRules: { __typename?: 'FulfillmentScheduleRuleConnection', nodes?: Array<{ __typename?: 'FulfillmentScheduleRule', id?: string | null, startDate?: any | null, endDate?: any | null, strategy?: FulfillmentScheduleRuleStrategyEnum | null, jumpDate?: any | null, routeCode?: string | null, warehouseCode?: string | null, zipCode?: string | null, scheduleData?: any | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminFulfillmentScheduleRulesCreateMutationVariables = Exact<{
  input: FulfillmentScheduleRulesCreateInput;
}>;


export type AdminFulfillmentScheduleRulesCreateMutation = { __typename?: 'Mutation', fulfillmentScheduleRulesCreate?: { __typename?: 'FulfillmentScheduleRulesCreatePayload', success: boolean, errors?: string | null } | null };

export type AdminFulfillmentScheduleRuleDeleteMutationVariables = Exact<{
  input: FulfillmentScheduleRuleDeleteInput;
}>;


export type AdminFulfillmentScheduleRuleDeleteMutation = { __typename?: 'Mutation', fulfillmentScheduleRuleDelete?: { __typename?: 'FulfillmentScheduleRuleDeletePayload', fulfillmentScheduleRule: { __typename?: 'FulfillmentScheduleRule', id?: string | null } } | null };

export type FulfillmentScheduleRulePropsFragment = { __typename?: 'FulfillmentScheduleRule', id?: string | null, startDate?: any | null, endDate?: any | null, strategy?: FulfillmentScheduleRuleStrategyEnum | null, jumpDate?: any | null, routeCode?: string | null, warehouseCode?: string | null, zipCode?: string | null, scheduleData?: any | null };

export type AdminFulfillmentScheduleRulesReportQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<ResolversFulfillmentScheduleRulesResolverOrder>;
  routeCode?: InputMaybe<TypesRouteCodesType>;
  warehouseCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
  endDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  startDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  startDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type AdminFulfillmentScheduleRulesReportQuery = { __typename?: 'Query', fulfillmentScheduleRulesReport: { __typename?: 'ReportDownload', url: string } };

export type AdminTransitConfigurationWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminTransitConfigurationWarehousesQuery = { __typename?: 'Query', dryIceWarehouses: Array<{ __typename?: 'ResolversTransitWarehousesResolverWarehouse', warehouseCode: string }> };

export type AdminImportJobQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminImportJobQuery = { __typename?: 'Query', importJob: { __typename?: 'ImportJob', createdAt: any, createdLines?: number | null, errorLines?: number | null, id: string, importType?: string | null, keyBinding?: any | null, keys?: string | null, message?: string | null, paperclipBackupContentType?: string | null, paperclipBackupFileName?: string | null, paperclipBackupFileSize?: number | null, paperclipBackupUpdatedAt?: any | null, paperclipDataContentType?: string | null, paperclipDataFileName?: string | null, paperclipDataFileSize?: number | null, paperclipDataUpdatedAt?: any | null, uploadedUrl?: string | null, parsedHeaders?: any | null, shipmentId?: number | null, state?: string | null, totalLines?: number | null, updatedAt: any, updatedLines?: number | null, ignoredLines?: number | null, importJobLinePreviews?: Array<{ __typename?: 'ImportJobLinePreview', id: string }> | null, blob?: { __typename?: 'Blob', byteSize?: number | null, fileName?: string | null } | null, user?: { __typename?: 'User', email?: string | null, id?: string | null } | null } };

export type AdminImportJobsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversImportJobsResolverOrder>;
  error?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminImportJobsQuery = { __typename?: 'Query', importJobs: { __typename?: 'ImportJobConnection', nodes?: Array<{ __typename?: 'ImportJob', createdAt: any, createdLines?: number | null, errorLines?: number | null, id: string, importType?: string | null, keyBinding?: any | null, keys?: string | null, message?: string | null, paperclipBackupContentType?: string | null, paperclipBackupFileName?: string | null, paperclipBackupFileSize?: number | null, paperclipBackupUpdatedAt?: any | null, paperclipDataContentType?: string | null, paperclipDataFileName?: string | null, paperclipDataFileSize?: number | null, paperclipDataUpdatedAt?: any | null, uploadedUrl?: string | null, parsedHeaders?: any | null, shipmentId?: number | null, state?: string | null, totalLines?: number | null, updatedAt: any, updatedLines?: number | null, ignoredLines?: number | null, importJobLinePreviews?: Array<{ __typename?: 'ImportJobLinePreview', id: string }> | null, blob?: { __typename?: 'Blob', byteSize?: number | null, fileName?: string | null } | null, user?: { __typename?: 'User', email?: string | null, id?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, endCursor?: string | null, totalPages: number } } };

export type AdminImportJobPropertiesFragment = { __typename?: 'ImportJob', createdAt: any, createdLines?: number | null, errorLines?: number | null, id: string, importType?: string | null, keyBinding?: any | null, keys?: string | null, message?: string | null, paperclipBackupContentType?: string | null, paperclipBackupFileName?: string | null, paperclipBackupFileSize?: number | null, paperclipBackupUpdatedAt?: any | null, paperclipDataContentType?: string | null, paperclipDataFileName?: string | null, paperclipDataFileSize?: number | null, paperclipDataUpdatedAt?: any | null, uploadedUrl?: string | null, parsedHeaders?: any | null, shipmentId?: number | null, state?: string | null, totalLines?: number | null, updatedAt: any, updatedLines?: number | null, ignoredLines?: number | null, importJobLinePreviews?: Array<{ __typename?: 'ImportJobLinePreview', id: string }> | null, blob?: { __typename?: 'Blob', byteSize?: number | null, fileName?: string | null } | null, user?: { __typename?: 'User', email?: string | null, id?: string | null } | null };

export type AdminMealPlanRecommendationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminMealPlanRecommendationQuery = { __typename?: 'Query', planMatchCriterium: { __typename?: 'PlanMatchCriterium', active: boolean, status: PlanMatchCriteriumStatus, ageBased?: boolean | null, ageGroup: string, calorieBased?: boolean | null, calorieMax?: number | null, calorieMin?: number | null, comboPlanFrequency?: number | null, comboPlanFrequencyCustomizable?: boolean | null, comboPlanId?: number | null, freshBakedPlanFrequencyCustomizable?: boolean | null, fullPlanFrequency?: number | null, fullPlanFrequencyCustomizable?: boolean | null, fullPlanId?: number | null, groupingName?: string | null, id: string, recommendedCaloriesPerDay?: number | null, recommendedServingSizeInOunces?: number | null, spaceSaverPlanFrequencyCustomizable?: boolean | null, spaceSaverPlanId?: number | null, topperPlanFrequency?: number | null, topperPlanFrequencyCustomizable?: boolean | null, topperPlanId?: number | null, weightBased?: boolean | null, weightMax?: number | null, weightMin?: number | null, welcomePlanFrequencyCustomizable?: boolean | null, welcomePlanId?: number | null, comboPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, fullPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, spaceSaverPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, topperPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, welcomePlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, freshBakedPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null } };

export type AdminMealPlanRecommendationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPlanMatchCriteriaResolverOrder>;
  id?: InputMaybe<Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<PlanMatchCriteriumStatus>;
  groupingName?: InputMaybe<TypesPlanMatchCriteriumInputTypeGroupingType>;
  ageGroup?: InputMaybe<TypesPlanMatchCriteriumInputTypeAgeGroup>;
}>;


export type AdminMealPlanRecommendationsQuery = { __typename?: 'Query', planMatchCriteria: { __typename?: 'PlanMatchCriteriumConnection', nodes?: Array<{ __typename?: 'PlanMatchCriterium', active: boolean, status: PlanMatchCriteriumStatus, ageBased?: boolean | null, ageGroup: string, calorieBased?: boolean | null, calorieMax?: number | null, calorieMin?: number | null, comboPlanFrequency?: number | null, comboPlanFrequencyCustomizable?: boolean | null, comboPlanId?: number | null, freshBakedPlanFrequencyCustomizable?: boolean | null, fullPlanFrequency?: number | null, fullPlanFrequencyCustomizable?: boolean | null, fullPlanId?: number | null, groupingName?: string | null, id: string, recommendedCaloriesPerDay?: number | null, recommendedServingSizeInOunces?: number | null, spaceSaverPlanFrequencyCustomizable?: boolean | null, spaceSaverPlanId?: number | null, topperPlanFrequency?: number | null, topperPlanFrequencyCustomizable?: boolean | null, topperPlanId?: number | null, weightBased?: boolean | null, weightMax?: number | null, weightMin?: number | null, welcomePlanFrequencyCustomizable?: boolean | null, welcomePlanId?: number | null, comboPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, fullPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, spaceSaverPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, topperPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, welcomePlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, freshBakedPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number, endCursor?: string | null, hasNextPage: boolean } } };

export type AdminMealPlanRecommendationCreateMutationVariables = Exact<{
  input: PlanMatchCriteriumCreateInput;
}>;


export type AdminMealPlanRecommendationCreateMutation = { __typename?: 'Mutation', planMatchCriteriumCreate?: { __typename?: 'PlanMatchCriteriumCreatePayload', planMatchCriterium: { __typename?: 'PlanMatchCriterium', id: string } } | null };

export type AdminMealPlanRecommendationUpdateMutationVariables = Exact<{
  input: PlanMatchCriteriumUpdateInput;
}>;


export type AdminMealPlanRecommendationUpdateMutation = { __typename?: 'Mutation', planMatchCriteriumUpdate?: { __typename?: 'PlanMatchCriteriumUpdatePayload', planMatchCriterium: { __typename?: 'PlanMatchCriterium', id: string } } | null };

export type AdminMealPlanMatchFragFragment = { __typename?: 'PlanMatchCriterium', active: boolean, status: PlanMatchCriteriumStatus, ageBased?: boolean | null, ageGroup: string, calorieBased?: boolean | null, calorieMax?: number | null, calorieMin?: number | null, comboPlanFrequency?: number | null, comboPlanFrequencyCustomizable?: boolean | null, comboPlanId?: number | null, freshBakedPlanFrequencyCustomizable?: boolean | null, fullPlanFrequency?: number | null, fullPlanFrequencyCustomizable?: boolean | null, fullPlanId?: number | null, groupingName?: string | null, id: string, recommendedCaloriesPerDay?: number | null, recommendedServingSizeInOunces?: number | null, spaceSaverPlanFrequencyCustomizable?: boolean | null, spaceSaverPlanId?: number | null, topperPlanFrequency?: number | null, topperPlanFrequencyCustomizable?: boolean | null, topperPlanId?: number | null, weightBased?: boolean | null, weightMax?: number | null, weightMin?: number | null, welcomePlanFrequencyCustomizable?: boolean | null, welcomePlanId?: number | null, comboPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, fullPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, spaceSaverPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, topperPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, welcomePlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null, freshBakedPlan?: { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null } | null };

export type AdminMealPlanRecBoxVarFragment = { __typename?: 'BoxVariant', defaultFrequency?: number | null, id: string, name: string, sku?: string | null, price?: number | null, box?: { __typename?: 'Box', bagQuantity?: number | null, bagVolume?: number | null, bagWeight?: number | null } | null };

export type MealPlanVariantUpdateMutationVariables = Exact<{
  input: MealPlanVariantUpdateInput;
}>;


export type MealPlanVariantUpdateMutation = { __typename?: 'Mutation', mealPlanVariantUpdate?: { __typename?: 'MealPlanVariantUpdatePayload', success: boolean } | null };

export type AdminMealQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminMealQuery = { __typename?: 'Query', meal: { __typename?: 'Meal', id: string, sku?: string | null, name?: string | null, shortName?: string | null, slug?: string | null, active?: boolean | null, category?: MealCategoryEnum | null, description?: string | null, lineItemName?: string | null, price?: number | null, displayOrder?: number | null, emergencyOutOfStock?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, createdAt: any, updatedAt: any, mealPlanVariants?: Array<{ __typename?: 'MealPlanVariant', sku?: string | null, name?: string | null, variants?: Array<{ __typename?: 'MealPlanVariantEntry', id?: string | null, outOfStock?: boolean | null, state?: MealPlanVariantState | null, plan?: { __typename?: 'BoxVariant', sku?: string | null, name: string, id: string } | null }> | null }> | null } };

export type AdminMealsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversMealsResolverOrder>;
  name?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
}>;


export type AdminMealsQuery = { __typename?: 'Query', meals: { __typename?: 'MealConnection', nodes?: Array<{ __typename?: 'Meal', id: string, sku?: string | null, name?: string | null, slug?: string | null, price?: number | null, active?: boolean | null, category?: MealCategoryEnum | null, emergencyOutOfStock?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, parentShopifyId?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null, currentPage: number, totalPages: number } } };

export type AdminMealUpdateMutationVariables = Exact<{
  input: MealUpdateInput;
}>;


export type AdminMealUpdateMutation = { __typename?: 'Mutation', mealUpdate?: { __typename?: 'MealUpdatePayload', meal: { __typename?: 'Meal', id: string, sku?: string | null, name?: string | null, shortName?: string | null, slug?: string | null, active?: boolean | null, category?: MealCategoryEnum | null, description?: string | null, lineItemName?: string | null, price?: number | null, displayOrder?: number | null, emergencyOutOfStock?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, createdAt: any, updatedAt: any, mealPlanVariants?: Array<{ __typename?: 'MealPlanVariant', sku?: string | null, name?: string | null, variants?: Array<{ __typename?: 'MealPlanVariantEntry', id?: string | null, outOfStock?: boolean | null, state?: MealPlanVariantState | null, plan?: { __typename?: 'BoxVariant', sku?: string | null, name: string, id: string } | null }> | null }> | null } } | null };

export type MealListPropsFragment = { __typename?: 'Meal', id: string, sku?: string | null, name?: string | null, slug?: string | null, price?: number | null, active?: boolean | null, category?: MealCategoryEnum | null, emergencyOutOfStock?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, parentShopifyId?: string | null };

export type MealPropsFragment = { __typename?: 'Meal', id: string, sku?: string | null, name?: string | null, shortName?: string | null, slug?: string | null, active?: boolean | null, category?: MealCategoryEnum | null, description?: string | null, lineItemName?: string | null, price?: number | null, displayOrder?: number | null, emergencyOutOfStock?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, createdAt: any, updatedAt: any, mealPlanVariants?: Array<{ __typename?: 'MealPlanVariant', sku?: string | null, name?: string | null, variants?: Array<{ __typename?: 'MealPlanVariantEntry', id?: string | null, outOfStock?: boolean | null, state?: MealPlanVariantState | null, plan?: { __typename?: 'BoxVariant', sku?: string | null, name: string, id: string } | null }> | null }> | null };

export type NotificationBannerPropsFragment = { __typename?: 'NotificationBanner', id: string, notificationBannerType: NotificationBannerTypeEnum, message: string, startDate: any, endDate: any, relevantDelayDate?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null };

export type AdminNotificationBannersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversNotificationBannersResolverOrder>;
}>;


export type AdminNotificationBannersQuery = { __typename?: 'Query', notificationBanners: { __typename?: 'NotificationBannerConnection', nodes?: Array<{ __typename?: 'NotificationBanner', id: string, notificationBannerType: NotificationBannerTypeEnum, message: string, startDate: any, endDate: any, relevantDelayDate?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, endCursor?: string | null, totalPages: number } } };

export type AdminNotificationBannerQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminNotificationBannerQuery = { __typename?: 'Query', notificationBanner: { __typename?: 'NotificationBanner', id: string, notificationBannerType: NotificationBannerTypeEnum, message: string, startDate: any, endDate: any, relevantDelayDate?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } };

export type AdminNotificationBannerCreateMutationVariables = Exact<{
  input: NotificationBannerCreateInput;
}>;


export type AdminNotificationBannerCreateMutation = { __typename?: 'Mutation', notificationBannerCreate?: { __typename?: 'NotificationBannerCreatePayload', notificationBanner: { __typename?: 'NotificationBanner', id: string, notificationBannerType: NotificationBannerTypeEnum, message: string, startDate: any, endDate: any, relevantDelayDate?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } } | null };

export type AdminNotificationBannerUpdateMutationVariables = Exact<{
  input: NotificationBannerUpdateInput;
}>;


export type AdminNotificationBannerUpdateMutation = { __typename?: 'Mutation', notificationBannerUpdate?: { __typename?: 'NotificationBannerUpdatePayload', notificationBanner: { __typename?: 'NotificationBanner', id: string, notificationBannerType: NotificationBannerTypeEnum, message: string, startDate: any, endDate: any, relevantDelayDate?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } } | null };

export type AdminNotificationBannerDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminNotificationBannerDeleteMutation = { __typename?: 'Mutation', notificationBannerDelete?: { __typename?: 'NotificationBannerDeletePayload', notificationBanner: { __typename?: 'NotificationBanner', id: string, notificationBannerType: NotificationBannerTypeEnum, message: string, startDate: any, endDate: any, relevantDelayDate?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } } | null };

export type AdminOperationsDashboardShippingScheduleQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
}>;


export type AdminOperationsDashboardShippingScheduleQuery = { __typename?: 'Query', operationsShippingSchedule: Array<{ __typename?: 'TypesOperationsDashboardTypeShippingSchedule', schedule: any, statusTags: Array<TypesShippingScheduleStatusTagType>, subscriptionsScheduled: number, link: string, orders: { __typename?: 'TypesOperationsDashboardTypeShippingScheduleOrders', newOneoff: number, newOneoffIds: string, newRecurring: number, newRecurringIds: string, repeatOneoff: number, repeatOneoffIds: string, repeatRecurring: number, repeatRecurringIds: string }, payments: { __typename?: 'TypesOperationsDashboardTypeShippingSchedulePayments', paid: number, failed: number, paidIds: string, failedIds: string }, shipments: { __typename?: 'TypesOperationsDashboardTypeShippingScheduleShipments', waiting: number, imported: number, batched: number, voided: number, replaced: number } }> };

export type AdminOperationsDashboardShippingListsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOperationsDashboardShippingListsQuery = { __typename?: 'Query', operationsShipmentLists: Array<{ __typename?: 'TypesOperationsDashboardTypeShipmentList', shipments: number, status: string, link: string, batch: { __typename?: 'TypesOperationsDashboardTypeShipmentListBatch', id: string, date: any } }> };

export type AdminOperationsDashboardAlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOperationsDashboardAlertsQuery = { __typename?: 'Query', operationsShippingAlerts: { __typename?: 'TypesOperationsDashboardTypeShippingAlert', alertPastOrders: Array<{ __typename?: 'TypesOperationsDashboardTypeShippingAlertPastOrders', missedDate: any, id: number }>, alertChewyShipments: Array<{ __typename?: 'TypesOperationsDashboardTypeShippingAlertChewyShipmentCount', date: any, count: number }>, alertPastSubscriptions: Array<{ __typename?: 'TypesOperationsDashboardTypeShippingAlertPastSubscriptions', missedDate: any, subscriptions: number }>, alertUnavailableDate: Array<{ __typename?: 'TypesOperationsDashboardTypeShippingAlertUnavailableDate', unavailableDate?: any | null, orders: number }>, alertUnavailableShipping: Array<{ __typename?: 'TypesOperationsDashboardTypeShippingAlertUnavailableShipping', unavailableDate: any, subscriptions: number }> } };

export type AdminOperationsDashboardInvalidZipCodeAlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOperationsDashboardInvalidZipCodeAlertsQuery = { __typename?: 'Query', invalidZipCodeAlerts: { __typename?: 'InvalidZipCodeAlerts', alertInvalidSubZipCodes: Array<{ __typename?: 'TypesInvalidZipCodeAlertsTypeInvalidSubZipCodes', subscriptionId: number, subscriptionStatus: string }>, alertInvalidOrderZipCodes: Array<{ __typename?: 'TypesInvalidZipCodeAlertsTypeInvalidOrderZipCodes', orderId: number, orderShippingDate?: string | null, orderStatus: string }> } };

export type AdminOperationsDashboardUnsyncedDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOperationsDashboardUnsyncedDataQuery = { __typename?: 'Query', unsyncedData: { __typename?: 'UnsyncedData', unsynchedOrders: { __typename?: 'TypesUnsyncedDataTypeUnsynchedOrders', count: number, errors: Array<{ __typename?: 'TypesUnsyncedDataTypeUnsyncedError', id: string, batchId: string, error: string }> }, unsynchedOrdersPaymentWithShopify: { __typename?: 'TypesUnsyncedDataTypeUnsynchedOrdersPaymentWithShopify', count: number } } };

export type AdminOperationsDashboardPaymentBatchesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOperationsDashboardPaymentBatchesQuery = { __typename?: 'Query', operationsPaymentBatches: Array<{ __typename?: 'TypesOperationsDashboardTypePaymentBatch', status: string, link: string, batch: { __typename?: 'TypesOperationsDashboardTypeShipmentListBatch', id: string, date: any }, exports: { __typename?: 'TypesOperationsDashboardTypePaymentBatchExport', charged: number, failed: number } }> };

export type AdminOperationsDashboardSubscriptionStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOperationsDashboardSubscriptionStatisticsQuery = { __typename?: 'Query', operationsSubscriptionStatistics: { __typename?: 'TypesOperationsDashboardTypeSubscriptionStatistics', startDate: any, endDate: any, weeklyStats: Array<{ __typename?: 'WeeklyStats', date: any, stats: { __typename?: 'CountStats', active: number, paused: number, canceled: number, created: number } }> } };

export type AdminOrderImportBatchEntryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminOrderImportBatchEntryQuery = { __typename?: 'Query', orderImportBatchEntry: { __typename?: 'OrderImportBatchEntry', action?: string | null, createdAt: any, departedFcAt?: any | null, id: string, index: number, orderImportBatchId?: number | null, payload?: any | null, poNumber?: string | null, processData?: string | null, startedAt?: any | null, state?: string | null, updatedAt: any } };

export type AdminOrderImportBatchEntryOrdersQueryVariables = Exact<{
  orderImportBatchEntryId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversDbOrdersResolverOrder>;
  estimatedShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
}>;


export type AdminOrderImportBatchEntryOrdersQuery = { __typename?: 'Query', dbOrders: { __typename?: 'DbOrderConnection', nodes?: Array<{ __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null, state?: OrderState | null, orderImportBatchEntry?: { __typename?: 'OrderImportBatchEntry', action?: string | null, createdAt: any, departedFcAt?: any | null, id: string, index: number, orderImportBatchId?: number | null, payload?: any | null, poNumber?: string | null, processData?: string | null, startedAt?: any | null, state?: string | null, updatedAt: any } | null, shipments: Array<{ __typename?: 'V2Shipment', shipmentEntry?: { __typename?: 'ShipmentEntry', id: string, shipmentNumber?: string | null } | null }> } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminOrderImportBatchesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversOrderImportBatchesResolverOrder>;
  startedAtAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  startedAtBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  endedAtAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  endedAtBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  fromDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  fromDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  untilDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  untilDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type AdminOrderImportBatchesQuery = { __typename?: 'Query', orderImportBatches: { __typename?: 'OrderImportBatchConnection', nodes?: Array<{ __typename?: 'OrderImportBatch', endedAt?: any | null, entriesCount: number, failedCount: number, fromDate?: any | null, id: string, pendingCount: number, skippedCount: number, startedAt: any, state: string, successCount: number, untilDate?: any | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminOrderImportBatchQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminOrderImportBatchQuery = { __typename?: 'Query', orderImportBatch: { __typename?: 'OrderImportBatch', endedAt?: any | null, entriesCount: number, failedCount: number, fromDate?: any | null, id: string, pendingCount: number, skippedCount: number, startedAt: any, state: string, successCount: number, untilDate?: any | null } };

export type AdminOrderImportBatchFragmentFragment = { __typename?: 'OrderImportBatch', endedAt?: any | null, entriesCount: number, failedCount: number, fromDate?: any | null, id: string, pendingCount: number, skippedCount: number, startedAt: any, state: string, successCount: number, untilDate?: any | null };

export type AdminOrderImportBatchEntriesQueryVariables = Exact<{
  orderImportBatchId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversOrderImportBatchEntriesResolverOrder>;
  action?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  poNumber?: InputMaybe<Scalars['String']>;
}>;


export type AdminOrderImportBatchEntriesQuery = { __typename?: 'Query', orderImportBatchEntries: { __typename?: 'OrderImportBatchEntryConnection', nodes?: Array<{ __typename?: 'OrderImportBatchEntry', action?: string | null, createdAt: any, departedFcAt?: any | null, id: string, index: number, orderImportBatchId?: number | null, payload?: any | null, poNumber?: string | null, processData?: string | null, startedAt?: any | null, state?: string | null, updatedAt: any } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminOrderImportBatchEntryFragmentFragment = { __typename?: 'OrderImportBatchEntry', action?: string | null, createdAt: any, departedFcAt?: any | null, id: string, index: number, orderImportBatchId?: number | null, payload?: any | null, poNumber?: string | null, processData?: string | null, startedAt?: any | null, state?: string | null, updatedAt: any };

export type AdminOrderImportBatchEntryOrderFragmentFragment = { __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null, state?: OrderState | null, orderImportBatchEntry?: { __typename?: 'OrderImportBatchEntry', action?: string | null, createdAt: any, departedFcAt?: any | null, id: string, index: number, orderImportBatchId?: number | null, payload?: any | null, poNumber?: string | null, processData?: string | null, startedAt?: any | null, state?: string | null, updatedAt: any } | null, shipments: Array<{ __typename?: 'V2Shipment', shipmentEntry?: { __typename?: 'ShipmentEntry', id: string, shipmentNumber?: string | null } | null }> };

export type AdminDbOrdersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversDbOrdersResolverOrder>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<ResolversDbOrdersResolverChannel>;
  opsState?: InputMaybe<ResolversDbOrdersResolverOpsState>;
  state?: InputMaybe<TypesDbOrderInputTypeState>;
  humanizedState?: InputMaybe<OrderHumanizedState>;
  estimatedShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
  subscriptionId?: InputMaybe<Scalars['ID']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  chewyPoNumber?: InputMaybe<Scalars['String']>;
  amazonPoNumber?: InputMaybe<Scalars['String']>;
}>;


export type AdminDbOrdersQuery = { __typename?: 'Query', dbOrders: { __typename?: 'DbOrderConnection', nodes?: Array<{ __typename?: 'DbOrder', attributionChannel?: string | null, estimatedShippingDate?: any | null, estimatedDeliveryDate?: any | null, createdAt?: any | null, humanizedState?: OrderHumanizedState | null, id?: number | null, orderNumber?: string | null, chewyPoNumber?: string | null, amazonPoNumber?: string | null, state?: OrderState | null, couponsData?: any | null, charges: Array<{ __typename?: 'PpPayment', id: string, number?: string | null, state?: PaymentState | null, amount: number, chargedAt?: any | null }>, storeCredits?: Array<{ __typename?: 'StoreCreditMovement', id: string, amount: number }> | null, taggings?: Array<{ __typename?: 'Tagging', tag?: { __typename?: 'Tag', name?: string | null } | null }> | null, lastShipmentEntry?: { __typename?: 'ShipmentEntry', deliveryDate?: any | null } | null, shipments: Array<{ __typename?: 'V2Shipment', shipmentEntry?: { __typename?: 'ShipmentEntry', id: string, state?: TypesShipmentEntryStateEnumType | null, shipmentNumber?: string | null, shippedAt?: any | null, carrierCode?: string | null, trackingNumber?: string | null, shipmentList?: { __typename?: 'ShipmentList', id: string, state?: string | null } | null } | null }>, customer?: { __typename?: 'User', email?: string | null, id?: string | null, address?: { __typename?: 'Address', address?: string | null, aptNo?: string | null, city?: string | null, stateAbbr?: string | null, zipCode?: string | null } | null } | null, subscription?: { __typename?: 'Subscription', id: string, state?: SubscriptionStateEnum | null, number?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, endCursor?: string | null, totalPages: number } } };

export type AdminDbOrderProductItemAttrsFragment = { __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', name?: string | null, active?: boolean | null } | null };

export type AdminDbOrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminDbOrderQuery = { __typename?: 'Query', dbOrder: { __typename?: 'DbOrder', planId?: number | null, planSku?: string | null, isCancellable?: boolean | null, cancelReason?: string | null, eligibleForRecreation?: boolean | null, shopifyAdminUrl?: string | null, shopifyInvoiceUrl?: string | null, attributionChannel?: string | null, attributionSource?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhoneNumber?: string | null, createdAt?: any | null, estimatedShippingDate?: any | null, estimatedDeliveryDate?: any | null, shopifyId?: string | null, chewyPoNumber?: string | null, amazonPoNumber?: string | null, amazonShipMethod?: string | null, id?: number | null, orderNumber?: string | null, petNames?: string | null, state?: OrderState | null, humanizedState?: OrderHumanizedState | null, updatedAt?: any | null, shippingAddress?: any | null, estimatedTaxRate?: number | null, normalizedCoupons?: Array<any> | null, statement?: { __typename?: 'OrderStatement', planWithSurchargesLine?: { __typename?: 'OrderStatamentLine', label: string, amount: string } | null, totalPaidLine: { __typename?: 'OrderStatamentLine', label: string, amount: string }, totalValueLine: { __typename?: 'OrderStatamentLine', label: string, amount: string }, totalDueLine: { __typename?: 'OrderStatamentLine', label: string, amount: string }, totalUnpaidLine: { __typename?: 'OrderStatamentLine', label: string, amount: string }, subtotalLine: { __typename?: 'OrderStatamentLine', label: string, amount: string }, addonsLine?: { __typename?: 'OrderStatamentLine', label: string, amount: string } | null, taxesLine: { __typename?: 'OrderStatamentLine', label: string, amount: string }, shippingLine: { __typename?: 'OrderStatamentLine', label: string, amount: string }, surchargesLine?: { __typename?: 'OrderStatamentLine', label: string, amount: string } | null, discountLines: Array<{ __typename?: 'OrderStatamentLine', label: string, amount: string, coupon?: { __typename?: 'OrderStatementCoupon', code: string } | null }>, creditLines: Array<{ __typename?: 'OrderStatamentLine', label: string, amount: string }> } | null, addons?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', name?: string | null, active?: boolean | null } | null }> | null, entrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', name?: string | null, active?: boolean | null } | null }> | null, entreePacks?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', name?: string | null, active?: boolean | null } | null }> | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null, state?: SubscriptionStateEnum | null, addonLineItems?: Array<{ __typename?: 'TypesSubscriptionTypeLineItemType', quantity?: number | null, sku?: string | null }> | null, mealLineItems?: Array<{ __typename?: 'MealLineItem', total: number, meal?: { __typename?: 'Meal', name?: string | null, sku?: string | null } | null }> | null } | null, createdBy?: { __typename?: 'OrderAuditUser', userId?: number | null, label?: string | null } | null, canceledBy?: { __typename?: 'OrderAuditUser', userId?: number | null, label?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, paymentGatewayProvider?: string | null, lowercaseMetadata?: { __typename?: 'PaymentMetadata', company?: string | null, wallet?: PaymentWallet | null, paypalEmail?: string | null } | null } | null, taggings?: Array<{ __typename?: 'Tagging', tag?: { __typename?: 'Tag', name?: string | null } | null }> | null, charges: Array<{ __typename?: 'PpPayment', createdAt?: any | null, chargedAt?: any | null, id: string, number?: string | null, state?: PaymentState | null, price?: number | null, assessedTaxes: number, amount: number }>, shipments: Array<{ __typename?: 'V2Shipment', shipmentEntry?: { __typename?: 'ShipmentEntry', id: string, shipmentNumber?: string | null, shippedAt?: any | null, state?: TypesShipmentEntryStateEnumType | null, shipmentList?: { __typename?: 'ShipmentList', id: string, state?: string | null } | null } | null }>, lastShipmentEntry?: { __typename?: 'ShipmentEntry', deliveryDate?: any | null, state?: TypesShipmentEntryStateEnumType | null, id: string, shipmentNumber?: string | null } | null, customer?: { __typename?: 'User', email?: string | null, id?: string | null, shopifyId?: string | null, totalCreditAmount?: number | null, address?: { __typename?: 'Address', address?: string | null, city?: string | null, stateAbbr?: string | null, zipCode?: string | null } | null, pets?: Array<{ __typename?: 'Pet', id: string, petName?: string | null }> | null } | null } };

export type AdminDbOrderPropsFragment = { __typename?: 'DbOrder', attributionChannel?: string | null, attributionSource?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhoneNumber?: string | null, createdAt?: any | null, estimatedShippingDate?: any | null, estimatedDeliveryDate?: any | null, shopifyId?: string | null, chewyPoNumber?: string | null, amazonPoNumber?: string | null, amazonShipMethod?: string | null, id?: number | null, orderNumber?: string | null, petNames?: string | null, state?: OrderState | null, humanizedState?: OrderHumanizedState | null, updatedAt?: any | null, shippingAddress?: any | null, estimatedTaxRate?: number | null, normalizedCoupons?: Array<any> | null, taggings?: Array<{ __typename?: 'Tagging', tag?: { __typename?: 'Tag', name?: string | null } | null }> | null, charges: Array<{ __typename?: 'PpPayment', createdAt?: any | null, chargedAt?: any | null, id: string, number?: string | null, state?: PaymentState | null, price?: number | null, assessedTaxes: number, amount: number }>, shipments: Array<{ __typename?: 'V2Shipment', shipmentEntry?: { __typename?: 'ShipmentEntry', id: string, shipmentNumber?: string | null, shippedAt?: any | null, state?: TypesShipmentEntryStateEnumType | null, shipmentList?: { __typename?: 'ShipmentList', id: string, state?: string | null } | null } | null }>, lastShipmentEntry?: { __typename?: 'ShipmentEntry', deliveryDate?: any | null, state?: TypesShipmentEntryStateEnumType | null, id: string, shipmentNumber?: string | null } | null, customer?: { __typename?: 'User', email?: string | null, id?: string | null, shopifyId?: string | null, totalCreditAmount?: number | null, address?: { __typename?: 'Address', address?: string | null, city?: string | null, stateAbbr?: string | null, zipCode?: string | null } | null, pets?: Array<{ __typename?: 'Pet', id: string, petName?: string | null }> | null } | null };

export type AdminSearchOrderBoxQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchOrderBoxQuery = { __typename?: 'Query', boxVariants: { __typename?: 'BoxVariantConnection', nodes?: Array<{ __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null> | null } };

export type AdminBoxVariantProductsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminBoxVariantProductsQuery = { __typename?: 'Query', boxVariant: { __typename?: 'BoxVariant', price?: number | null, category: string, addonUnits: number, defaultFrequency?: number | null, box?: { __typename?: 'Box', itemQuantity: number, bagQuantity?: number | null } | null, products?: Array<{ __typename?: 'PetPlateProduct', sku?: string | null, name?: string | null, price?: number | null, slug?: string | null, category?: PlanLineItemCategoryEnum | null, shopifyId?: string | null, imageUrl?: string | null }> | null, meals?: Array<{ __typename?: 'Meal', sku?: string | null, name?: string | null, price?: number | null, slug?: string | null, category?: MealCategoryEnum | null, shopifyId?: string | null, imageUrl?: string | null }> | null } };

export type AdminLoadPlanChangeOptionsQueryVariables = Exact<{
  onlyActivePlans: Scalars['Boolean'];
}>;


export type AdminLoadPlanChangeOptionsQuery = { __typename?: 'Query', boxVariants: { __typename?: 'BoxVariantConnection', nodes?: Array<{ __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, price?: number | null, planType?: BoxVariantPlanTypeEnum | null } | null> | null } };

export type AdminOrderEditMutationVariables = Exact<{
  input: DbOrderEditInput;
}>;


export type AdminOrderEditMutation = { __typename?: 'Mutation', dbOrderEdit?: { __typename?: 'DbOrderEditPayload', id: string } | null };

export type AdminOrderUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: DbOrderInput;
}>;


export type AdminOrderUpdateMutation = { __typename?: 'Mutation', dbOrderUpdate?: { __typename?: 'DbOrderUpdatePayload', dbOrder: { __typename?: 'DbOrder', id?: number | null } } | null };

export type AdminOrderRecreateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminOrderRecreateMutation = { __typename?: 'Mutation', dbOrderRecreate?: { __typename?: 'DbOrderRecreatePayload', newDbOrder: { __typename?: 'DbOrder', id?: number | null } } | null };

export type AdminOrderCreateMutationVariables = Exact<{
  input: DbOrderCreateInput;
}>;


export type AdminOrderCreateMutation = { __typename?: 'Mutation', dbOrderCreate?: { __typename?: 'DbOrderCreatePayload', dbOrder: { __typename?: 'DbOrder', id?: number | null } } | null };

export type AdminOrderReplaceMutationVariables = Exact<{
  id: Scalars['ID'];
  reasonId: Scalars['Int'];
  entreeLineItems?: InputMaybe<Array<TypesSubscriptionInputTypeLineItemInput> | TypesSubscriptionInputTypeLineItemInput>;
  addonLineItems?: InputMaybe<Array<TypesSubscriptionInputTypeLineItemInput> | TypesSubscriptionInputTypeLineItemInput>;
}>;


export type AdminOrderReplaceMutation = { __typename?: 'Mutation', dbOrderReplace?: { __typename?: 'DbOrderReplacePayload', dbOrder: { __typename?: 'DbOrder', id?: number | null } } | null };

export type AdminMarkOrderAsDeliveredMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminMarkOrderAsDeliveredMutation = { __typename?: 'Mutation', markOrderAsDelivered?: { __typename?: 'MarkOrderAsDeliveredPayload', result: boolean } | null };

export type AdminMarkOrderPaymentAsFailedMutationVariables = Exact<{
  id: Scalars['Int'];
  reason: Scalars['String'];
  errorCode: Scalars['String'];
}>;


export type AdminMarkOrderPaymentAsFailedMutation = { __typename?: 'Mutation', markOrderPaymentAsFailed?: { __typename?: 'MarkOrderPaymentAsFailedPayload', result: boolean } | null };

export type AdminOrderBoxVariantProductFragment = { __typename?: 'PetPlateProduct', id: string, productType?: string | null, pageUrl?: string | null };

export type AdminSearchCouponsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
}>;


export type AdminSearchCouponsQuery = { __typename?: 'Query', shopifyCoupons: { __typename?: 'ShopifyCoupons', nodes: Array<{ __typename?: 'TypesShopifyCouponsTypeNode', title?: string | null, code?: string | null }>, pageInfo: { __typename?: 'TypesShopifyCouponsTypePageInfo', endCursor?: string | null } } };

export type AdminPackagingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminPackagingQuery = { __typename?: 'Query', packaging: { __typename?: 'Packaging', id: string, active?: boolean | null, code?: string | null, description?: string | null, name?: string | null, boxes?: Array<{ __typename?: 'Box', packaging?: { __typename?: 'Packaging', id: string } | null }> | null } };

export type AdminPackagingsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPackagingsResolverOrder>;
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type AdminPackagingsQuery = { __typename?: 'Query', packagings: { __typename?: 'PackagingConnection', nodes?: Array<{ __typename?: 'Packaging', id: string, active?: boolean | null, code?: string | null, description?: string | null, name?: string | null, boxes?: Array<{ __typename?: 'Box', packaging?: { __typename?: 'Packaging', id: string } | null }> | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null, currentPage: number, totalPages: number } } };

export type AdminPackagingCreateMutationVariables = Exact<{
  input: PackagingCreateInput;
}>;


export type AdminPackagingCreateMutation = { __typename?: 'Mutation', packagingCreate?: { __typename?: 'PackagingCreatePayload', packaging: { __typename?: 'Packaging', id: string, active?: boolean | null, code?: string | null, description?: string | null, name?: string | null, boxes?: Array<{ __typename?: 'Box', packaging?: { __typename?: 'Packaging', id: string } | null }> | null } } | null };

export type AdminPackagingUpdateMutationVariables = Exact<{
  input: PackagingUpdateInput;
}>;


export type AdminPackagingUpdateMutation = { __typename?: 'Mutation', packagingUpdate?: { __typename?: 'PackagingUpdatePayload', packaging: { __typename?: 'Packaging', id: string, active?: boolean | null, code?: string | null, description?: string | null, name?: string | null, boxes?: Array<{ __typename?: 'Box', packaging?: { __typename?: 'Packaging', id: string } | null }> | null } } | null };

export type PackagingPropsFragment = { __typename?: 'Packaging', id: string, active?: boolean | null, code?: string | null, description?: string | null, name?: string | null, boxes?: Array<{ __typename?: 'Box', packaging?: { __typename?: 'Packaging', id: string } | null }> | null };

export type AdminPauseSurveyQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPauseSurveysResolverOrder>;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type AdminPauseSurveyQuery = { __typename?: 'Query', pauseSurveys: { __typename?: 'PauseSurveyConnection', nodes?: Array<{ __typename?: 'PauseSurvey', id: string, subscription?: { __typename?: 'Subscription', id: string, number?: string | null, updatedAt?: any | null, state?: SubscriptionStateEnum | null, canceledAt?: any | null, pet?: { __typename?: 'Pet', petName?: string | null } | null, currentPlan?: { __typename?: 'BoxVariant', box?: { __typename?: 'Box', id: string, name: string } | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, name?: string | null, shopifyId?: string | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null } | null, pauseReasonTerm?: { __typename?: 'Term', id: string, description?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, endCursor?: string | null, totalPages: number } } };

export type AdminPauseSurveyCreateMutationVariables = Exact<{
  input: PauseSurveyCreateInput;
}>;


export type AdminPauseSurveyCreateMutation = { __typename?: 'Mutation', pauseSurveyCreate?: { __typename?: 'PauseSurveyCreatePayload', pauseSurvey: { __typename?: 'PauseSurvey', id: string } } | null };

export type AdminPaymentBatchEntryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminPaymentBatchEntryQuery = { __typename?: 'Query', paymentBatchEntry: { __typename?: 'PaymentBatchEntry', id: string, state?: string | null, updatedAt: any, startedAt?: any | null, endedAt?: any | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, order?: { __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null, shopifyId?: string | null } | null, paymentBatch?: { __typename?: 'PaymentBatch', id: string } | null, payment?: { __typename?: 'PpPayment', state?: PaymentState | null, number?: string | null, amount: number, amountRefunded: number, assessedTaxes: number, id: string, price?: number | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null, paymentAdjustments: Array<{ __typename?: 'PaymentAdjustment', amount: number, sourceType?: string | null, sourceId?: number | null }> } | null } };

export type AdminPaymentBatchEntriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPaymentBatchEntriesResolverOrder>;
  paymentBatchId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<TypesPaymentBatchEntryInputTypeState>;
  action?: InputMaybe<Scalars['String']>;
  opsState?: InputMaybe<ResolversPaymentBatchEntriesResolverOpsState>;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type AdminPaymentBatchEntriesQuery = { __typename?: 'Query', paymentBatchEntries: { __typename?: 'PaymentBatchEntryConnection', nodes?: Array<{ __typename?: 'PaymentBatchEntry', id: string, state?: string | null, updatedAt: any, startedAt?: any | null, endedAt?: any | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, order?: { __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null, shopifyId?: string | null } | null, paymentBatch?: { __typename?: 'PaymentBatch', id: string } | null, payment?: { __typename?: 'PpPayment', state?: PaymentState | null, number?: string | null, amount: number, amountRefunded: number, assessedTaxes: number, id: string, price?: number | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null, paymentAdjustments: Array<{ __typename?: 'PaymentAdjustment', amount: number, sourceType?: string | null, sourceId?: number | null }> } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminPaymentBatchEntryCreateMutationVariables = Exact<{
  input: PaymentBatchEntryCreateInput;
}>;


export type AdminPaymentBatchEntryCreateMutation = { __typename?: 'Mutation', paymentBatchEntryCreate?: { __typename?: 'PaymentBatchEntryCreatePayload', paymentBatchEntry: { __typename?: 'PaymentBatchEntry', id: string, state?: string | null, updatedAt: any, startedAt?: any | null, endedAt?: any | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, order?: { __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null, shopifyId?: string | null } | null, paymentBatch?: { __typename?: 'PaymentBatch', id: string } | null, payment?: { __typename?: 'PpPayment', state?: PaymentState | null, number?: string | null, amount: number, amountRefunded: number, assessedTaxes: number, id: string, price?: number | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null, paymentAdjustments: Array<{ __typename?: 'PaymentAdjustment', amount: number, sourceType?: string | null, sourceId?: number | null }> } | null } } | null };

export type AdminPaymentBatchEntryUpdateMutationVariables = Exact<{
  input: PaymentBatchEntryUpdateInput;
}>;


export type AdminPaymentBatchEntryUpdateMutation = { __typename?: 'Mutation', paymentBatchEntryUpdate?: { __typename?: 'PaymentBatchEntryUpdatePayload', paymentBatchEntry: { __typename?: 'PaymentBatchEntry', id: string, state?: string | null, updatedAt: any, startedAt?: any | null, endedAt?: any | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, order?: { __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null, shopifyId?: string | null } | null, paymentBatch?: { __typename?: 'PaymentBatch', id: string } | null, payment?: { __typename?: 'PpPayment', state?: PaymentState | null, number?: string | null, amount: number, amountRefunded: number, assessedTaxes: number, id: string, price?: number | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null, paymentAdjustments: Array<{ __typename?: 'PaymentAdjustment', amount: number, sourceType?: string | null, sourceId?: number | null }> } | null } } | null };

export type PaymentBatchEntriesPropsFragment = { __typename?: 'PaymentBatchEntry', id: string, state?: string | null, updatedAt: any, startedAt?: any | null, endedAt?: any | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, order?: { __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null, shopifyId?: string | null } | null, paymentBatch?: { __typename?: 'PaymentBatch', id: string } | null, payment?: { __typename?: 'PpPayment', state?: PaymentState | null, number?: string | null, amount: number, amountRefunded: number, assessedTaxes: number, id: string, price?: number | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null, paymentAdjustments: Array<{ __typename?: 'PaymentAdjustment', amount: number, sourceType?: string | null, sourceId?: number | null }> } | null };

export type AdminPaymentBatchQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminPaymentBatchQuery = { __typename?: 'Query', paymentBatch: { __typename?: 'PaymentBatch', chargedCount?: number | null, createdAt: any, dueAt?: any | null, endedAt?: any | null, overdueCount?: number | null, failedCount?: number | null, id: string, pendingCount?: number | null, shippingDates?: Array<any> | null, skippedCount?: number | null, startedAt?: any | null, state: string, totalCount?: number | null, updatedAt: any, paymentBatchEntries?: Array<{ __typename?: 'PaymentBatchEntry', action?: string | null, createdAt: any, endedAt?: any | null, id: string, index: number, state?: string | null }> | null, summaries?: Array<{ __typename?: 'PlanSummary', count?: number | null, sku?: string | null, totalAmount?: number | null, totalRefunded?: number | null }> | null } };

export type AdminPaymentBatchesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPaymentBatchesResolverOrder>;
  startedAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  startedAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  endedAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  endedAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  state?: InputMaybe<TypesPaymentBatchInputTypeState>;
}>;


export type AdminPaymentBatchesQuery = { __typename?: 'Query', paymentBatches: { __typename?: 'PaymentBatchConnection', nodes?: Array<{ __typename?: 'PaymentBatch', chargedCount?: number | null, createdAt: any, dueAt?: any | null, endedAt?: any | null, overdueCount?: number | null, failedCount?: number | null, id: string, pendingCount?: number | null, shippingDates?: Array<any> | null, skippedCount?: number | null, startedAt?: any | null, state: string, totalCount?: number | null, updatedAt: any } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminPaymentBatchCreateMutationVariables = Exact<{
  input: PaymentBatchCreateInput;
}>;


export type AdminPaymentBatchCreateMutation = { __typename?: 'Mutation', paymentBatchCreate?: { __typename?: 'PaymentBatchCreatePayload', paymentBatch: { __typename?: 'PaymentBatch', chargedCount?: number | null, createdAt: any, dueAt?: any | null, endedAt?: any | null, overdueCount?: number | null, failedCount?: number | null, id: string, pendingCount?: number | null, shippingDates?: Array<any> | null, skippedCount?: number | null, startedAt?: any | null, state: string, totalCount?: number | null, updatedAt: any, paymentBatchEntries?: Array<{ __typename?: 'PaymentBatchEntry', action?: string | null, createdAt: any, endedAt?: any | null, id: string, index: number, state?: string | null }> | null, summaries?: Array<{ __typename?: 'PlanSummary', count?: number | null, sku?: string | null, totalAmount?: number | null, totalRefunded?: number | null }> | null } } | null };

export type AdminPaymentBatchUpdateMutationVariables = Exact<{
  input: PaymentBatchUpdateInput;
}>;


export type AdminPaymentBatchUpdateMutation = { __typename?: 'Mutation', paymentBatchUpdate?: { __typename?: 'PaymentBatchUpdatePayload', paymentBatch: { __typename?: 'PaymentBatch', chargedCount?: number | null, createdAt: any, dueAt?: any | null, endedAt?: any | null, overdueCount?: number | null, failedCount?: number | null, id: string, pendingCount?: number | null, shippingDates?: Array<any> | null, skippedCount?: number | null, startedAt?: any | null, state: string, totalCount?: number | null, updatedAt: any, paymentBatchEntries?: Array<{ __typename?: 'PaymentBatchEntry', action?: string | null, createdAt: any, endedAt?: any | null, id: string, index: number, state?: string | null }> | null, summaries?: Array<{ __typename?: 'PlanSummary', count?: number | null, sku?: string | null, totalAmount?: number | null, totalRefunded?: number | null }> | null } } | null };

export type PaymentBatchPropsFragment = { __typename?: 'PaymentBatch', chargedCount?: number | null, createdAt: any, dueAt?: any | null, endedAt?: any | null, overdueCount?: number | null, failedCount?: number | null, id: string, pendingCount?: number | null, shippingDates?: Array<any> | null, skippedCount?: number | null, startedAt?: any | null, state: string, totalCount?: number | null, updatedAt: any, paymentBatchEntries?: Array<{ __typename?: 'PaymentBatchEntry', action?: string | null, createdAt: any, endedAt?: any | null, id: string, index: number, state?: string | null }> | null, summaries?: Array<{ __typename?: 'PlanSummary', count?: number | null, sku?: string | null, totalAmount?: number | null, totalRefunded?: number | null }> | null };

export type PaymentBatchEntryPropsFragment = { __typename?: 'PaymentBatchEntry', order?: { __typename?: 'DbOrder', shopifyId?: string | null } | null };

export type AdminPaymentMethodQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminPaymentMethodQuery = { __typename?: 'Query', paymentMethod: { __typename?: 'PaymentMethod', apiCardId?: string | null, apiCustomerId?: string | null, brand?: string | null, cardFingerprint?: string | null, cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, createdAt: any, fraudScore?: string | null, funding?: string | null, id: string, migratedFromId?: number | null, paymentGatewayProvider?: string | null, recommendation?: string | null, state?: string | null, updatedAt: any, lowercaseMetadata?: { __typename?: 'PaymentMetadata', company?: string | null, wallet?: PaymentWallet | null, paypalEmail?: string | null } | null, owner?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, subscriptions: Array<{ __typename?: 'Subscription', id: string, number?: string | null }> } };

export type AdminPaymentMethodsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPaymentMethodsResolverOrder>;
  state?: InputMaybe<TypesPaymentMethodInputTypeState>;
  cardLast4?: InputMaybe<Scalars['String']>;
}>;


export type AdminPaymentMethodsQuery = { __typename?: 'Query', paymentMethods: { __typename?: 'PaymentMethodConnection', nodes?: Array<{ __typename?: 'PaymentMethod', apiCardId?: string | null, apiCustomerId?: string | null, brand?: string | null, cardFingerprint?: string | null, cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, createdAt: any, fraudScore?: string | null, funding?: string | null, id: string, migratedFromId?: number | null, paymentGatewayProvider?: string | null, recommendation?: string | null, state?: string | null, updatedAt: any, lowercaseMetadata?: { __typename?: 'PaymentMetadata', company?: string | null, wallet?: PaymentWallet | null, paypalEmail?: string | null } | null, owner?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, subscriptions: Array<{ __typename?: 'Subscription', id: string, number?: string | null }> } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminPaymentMethodCreateMutationVariables = Exact<{
  input: PaymentMethodCreateInput;
}>;


export type AdminPaymentMethodCreateMutation = { __typename?: 'Mutation', paymentMethodCreate?: { __typename?: 'PaymentMethodCreatePayload', paymentMethod: { __typename?: 'PaymentMethod', apiCardId?: string | null, apiCustomerId?: string | null, brand?: string | null, cardFingerprint?: string | null, cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, createdAt: any, fraudScore?: string | null, funding?: string | null, id: string, migratedFromId?: number | null, paymentGatewayProvider?: string | null, recommendation?: string | null, state?: string | null, updatedAt: any, lowercaseMetadata?: { __typename?: 'PaymentMetadata', company?: string | null, wallet?: PaymentWallet | null, paypalEmail?: string | null } | null, owner?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, subscriptions: Array<{ __typename?: 'Subscription', id: string, number?: string | null }> } } | null };

export type PaymentMethodPropsFragment = { __typename?: 'PaymentMethod', apiCardId?: string | null, apiCustomerId?: string | null, brand?: string | null, cardFingerprint?: string | null, cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, createdAt: any, fraudScore?: string | null, funding?: string | null, id: string, migratedFromId?: number | null, paymentGatewayProvider?: string | null, recommendation?: string | null, state?: string | null, updatedAt: any, lowercaseMetadata?: { __typename?: 'PaymentMetadata', company?: string | null, wallet?: PaymentWallet | null, paypalEmail?: string | null } | null, owner?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, subscriptions: Array<{ __typename?: 'Subscription', id: string, number?: string | null }> };

export type AdminPaymentMethodSetPrimaryMutationVariables = Exact<{
  id: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type AdminPaymentMethodSetPrimaryMutation = { __typename?: 'Mutation', paymentMethodUpdate?: { __typename?: 'PaymentMethodUpdatePayload', paymentMethod: { __typename?: 'PaymentMethod', apiCardId?: string | null, apiCustomerId?: string | null, brand?: string | null, cardFingerprint?: string | null, cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, createdAt: any, fraudScore?: string | null, funding?: string | null, id: string, migratedFromId?: number | null, paymentGatewayProvider?: string | null, recommendation?: string | null, state?: string | null, updatedAt: any, lowercaseMetadata?: { __typename?: 'PaymentMetadata', company?: string | null, wallet?: PaymentWallet | null, paypalEmail?: string | null } | null, owner?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, subscriptions: Array<{ __typename?: 'Subscription', id: string, number?: string | null }> } } | null };

export type AdminPaymentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminPaymentQuery = { __typename?: 'Query', ppPayment: { __typename?: 'PpPayment', amount: number, amountRefunded: number, apiChargeId?: string | null, apiIntentId?: string | null, assessedTaxes: number, assessedTaxesBy?: string | null, assessedTaxesError?: string | null, chargedAt?: any | null, city?: string | null, createdAt?: any | null, estimatedTaxes: number, estimatedTaxesDiscrepancy: number, id: string, lineItemsData: any, number?: string | null, paymentGatewayProvider?: string | null, paymentOperatorType?: string | null, price?: number | null, reason?: string | null, shipperCity?: string | null, shipperStateAbbr?: string | null, shipperZipCode?: string | null, state?: PaymentState | null, stateAbbr?: string | null, updatedAt?: any | null, zipCode?: string | null, awardedCredits?: Array<{ __typename?: 'StoreCreditMovement', id: string, amount: number }> | null, boxVariant?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null, paymentAdjustments: Array<{ __typename?: 'PaymentAdjustment', amount: number, sourceType?: string | null, sourceId?: number | null }>, paymentMethod?: { __typename?: 'PaymentMethod', id: string, cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, state?: string | null, owner?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null, email?: string | null, v2Orders: Array<{ __typename?: 'DbOrder', id?: number | null }>, user?: { __typename?: 'User', id?: string | null } | null } | null, refunds?: Array<{ __typename?: 'Refund', id?: string | null, amount?: number | null, invoicedAt?: any | null, createdAt?: any | null, invoiceError?: string | null, state?: string | null, source?: string | null, reason?: { __typename?: 'Term', id: string, name?: string | null, description?: string | null } | null }> | null } };

export type AdminPaymentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPpPaymentsResolverOrder>;
  state?: InputMaybe<TypesPpPaymentInputTypeState>;
  stateAbbr?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
}>;


export type AdminPaymentsQuery = { __typename?: 'Query', ppPayments: { __typename?: 'PpPaymentConnection', nodes?: Array<{ __typename?: 'PpPayment', amount: number, assessedTaxes: number, createdAt?: any | null, id: string, number?: string | null, state?: PaymentState | null, stateAbbr?: string | null, zipCode?: string | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, sku?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', owner?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null, paymentAdjustments: Array<{ __typename?: 'PaymentAdjustment', sourceId?: number | null, sourceType?: string | null, amount: number }> } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminPaymentCreateMutationVariables = Exact<{
  input: PpPaymentCreateInput;
}>;


export type AdminPaymentCreateMutation = { __typename?: 'Mutation', ppPaymentCreate?: { __typename?: 'PpPaymentCreatePayload', ppPayment: { __typename?: 'PpPayment', amount: number, amountRefunded: number, apiChargeId?: string | null, apiIntentId?: string | null, assessedTaxes: number, assessedTaxesBy?: string | null, assessedTaxesError?: string | null, chargedAt?: any | null, city?: string | null, createdAt?: any | null, estimatedTaxes: number, estimatedTaxesDiscrepancy: number, id: string, lineItemsData: any, number?: string | null, paymentGatewayProvider?: string | null, paymentOperatorType?: string | null, price?: number | null, reason?: string | null, shipperCity?: string | null, shipperStateAbbr?: string | null, shipperZipCode?: string | null, state?: PaymentState | null, stateAbbr?: string | null, updatedAt?: any | null, zipCode?: string | null, awardedCredits?: Array<{ __typename?: 'StoreCreditMovement', id: string, amount: number }> | null, boxVariant?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null, paymentAdjustments: Array<{ __typename?: 'PaymentAdjustment', amount: number, sourceType?: string | null, sourceId?: number | null }>, paymentMethod?: { __typename?: 'PaymentMethod', id: string, cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, state?: string | null, owner?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null, email?: string | null, v2Orders: Array<{ __typename?: 'DbOrder', id?: number | null }>, user?: { __typename?: 'User', id?: string | null } | null } | null, refunds?: Array<{ __typename?: 'Refund', id?: string | null, amount?: number | null, invoicedAt?: any | null, createdAt?: any | null, invoiceError?: string | null, state?: string | null, source?: string | null, reason?: { __typename?: 'Term', id: string, name?: string | null, description?: string | null } | null }> | null } } | null };

export type PaymentPropsFragment = { __typename?: 'PpPayment', amount: number, amountRefunded: number, apiChargeId?: string | null, apiIntentId?: string | null, assessedTaxes: number, assessedTaxesBy?: string | null, assessedTaxesError?: string | null, chargedAt?: any | null, city?: string | null, createdAt?: any | null, estimatedTaxes: number, estimatedTaxesDiscrepancy: number, id: string, lineItemsData: any, number?: string | null, paymentGatewayProvider?: string | null, paymentOperatorType?: string | null, price?: number | null, reason?: string | null, shipperCity?: string | null, shipperStateAbbr?: string | null, shipperZipCode?: string | null, state?: PaymentState | null, stateAbbr?: string | null, updatedAt?: any | null, zipCode?: string | null, awardedCredits?: Array<{ __typename?: 'StoreCreditMovement', id: string, amount: number }> | null, boxVariant?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null } | null, paymentAdjustments: Array<{ __typename?: 'PaymentAdjustment', amount: number, sourceType?: string | null, sourceId?: number | null }>, paymentMethod?: { __typename?: 'PaymentMethod', id: string, cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, state?: string | null, owner?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null, email?: string | null, v2Orders: Array<{ __typename?: 'DbOrder', id?: number | null }>, user?: { __typename?: 'User', id?: string | null } | null } | null, refunds?: Array<{ __typename?: 'Refund', id?: string | null, amount?: number | null, invoicedAt?: any | null, createdAt?: any | null, invoiceError?: string | null, state?: string | null, source?: string | null, reason?: { __typename?: 'Term', id: string, name?: string | null, description?: string | null } | null }> | null };

export type AdminRefundLegacyPaymentMutationVariables = Exact<{
  input: MutationsRefundLegacyPaymentInput;
}>;


export type AdminRefundLegacyPaymentMutation = { __typename?: 'Mutation', refundLegacyPayment?: { __typename?: 'MutationsRefundLegacyPaymentPayload', id?: string | null } | null };

export type AdminRefundReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminRefundReasonsQuery = { __typename?: 'Query', surveyOptions: { __typename?: 'SurveyOptions', creditReason: Array<{ __typename?: 'SurveyOption', label: string, value: number }> } };

export type AdminPetQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminPetQuery = { __typename?: 'Query', pet: { __typename?: 'Pet', activityLevel?: PetActivityLevels | null, ageGroup?: string | null, birthDate?: any | null, breedType: string, calculatedCaloriesPerDay?: number | null, completedBirthDate?: boolean | null, createdAt: any, gender?: string | null, hasFoodSensitivities?: boolean | null, hasWellnessGoals?: boolean | null, id: string, waistline?: string | null, petName?: string | null, primaryBreedId?: number | null, restingEnergyRate?: number | null, secondaryBreedId?: number | null, servingSizeInOunces?: number | null, spayedNeutered?: boolean | null, updatedAt: any, weight?: number | null, ingredientIds?: Array<string> | null, wellnessGoalIds?: Array<string> | null, primaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, secondaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, ingredients?: Array<{ __typename?: 'Ingredient', name: string }> | null, mealLineItems?: Array<{ __typename?: 'MealLineItem', meal?: { __typename?: 'Meal', name?: string | null } | null }> | null, recommendationWizard?: { __typename?: 'RecommendationWizard', id: string, weight?: number | null, recommendedRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedComboRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedAddons?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null } | null, wellnessGoals?: Array<{ __typename?: 'WellnessGoal', name: string }> | null, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } };

export type AdminPetsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<ResolversPetsResolverOrder>;
  petName?: InputMaybe<Scalars['String']>;
  createdAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  weight?: InputMaybe<Scalars['Int']>;
  spayedNeutered?: InputMaybe<Scalars['Boolean']>;
  breedType?: InputMaybe<Scalars['String']>;
  primaryBreed?: InputMaybe<Scalars['String']>;
  secondaryBreed?: InputMaybe<Scalars['String']>;
}>;


export type AdminPetsQuery = { __typename?: 'Query', pets: { __typename?: 'PetConnection', nodes?: Array<{ __typename?: 'Pet', ageGroup?: string | null, birthDate?: any | null, calculatedCaloriesPerDay?: number | null, gender?: string | null, id: string, petName?: string | null, restingEnergyRate?: number | null, servingSizeInOunces?: number | null, spayedNeutered?: boolean | null, weight?: number | null, primaryBreed?: { __typename?: 'Breed', name: string } | null, secondaryBreed?: { __typename?: 'Breed', name: string } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminPetCreateMutationVariables = Exact<{
  input: PetCreateInput;
}>;


export type AdminPetCreateMutation = { __typename?: 'Mutation', petCreate?: { __typename?: 'PetCreatePayload', pet: { __typename?: 'Pet', activityLevel?: PetActivityLevels | null, ageGroup?: string | null, birthDate?: any | null, breedType: string, calculatedCaloriesPerDay?: number | null, completedBirthDate?: boolean | null, createdAt: any, gender?: string | null, hasFoodSensitivities?: boolean | null, hasWellnessGoals?: boolean | null, id: string, waistline?: string | null, petName?: string | null, primaryBreedId?: number | null, restingEnergyRate?: number | null, secondaryBreedId?: number | null, servingSizeInOunces?: number | null, spayedNeutered?: boolean | null, updatedAt: any, weight?: number | null, ingredientIds?: Array<string> | null, wellnessGoalIds?: Array<string> | null, primaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, secondaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, ingredients?: Array<{ __typename?: 'Ingredient', name: string }> | null, mealLineItems?: Array<{ __typename?: 'MealLineItem', meal?: { __typename?: 'Meal', name?: string | null } | null }> | null, recommendationWizard?: { __typename?: 'RecommendationWizard', id: string, weight?: number | null, recommendedRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedComboRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedAddons?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null } | null, wellnessGoals?: Array<{ __typename?: 'WellnessGoal', name: string }> | null, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } } | null };

export type AdminPetUpdateMutationVariables = Exact<{
  input: PetUpdateInput;
}>;


export type AdminPetUpdateMutation = { __typename?: 'Mutation', petUpdate?: { __typename?: 'PetUpdatePayload', pet: { __typename?: 'Pet', activityLevel?: PetActivityLevels | null, ageGroup?: string | null, birthDate?: any | null, breedType: string, calculatedCaloriesPerDay?: number | null, completedBirthDate?: boolean | null, createdAt: any, gender?: string | null, hasFoodSensitivities?: boolean | null, hasWellnessGoals?: boolean | null, id: string, waistline?: string | null, petName?: string | null, primaryBreedId?: number | null, restingEnergyRate?: number | null, secondaryBreedId?: number | null, servingSizeInOunces?: number | null, spayedNeutered?: boolean | null, updatedAt: any, weight?: number | null, ingredientIds?: Array<string> | null, wellnessGoalIds?: Array<string> | null, primaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, secondaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, ingredients?: Array<{ __typename?: 'Ingredient', name: string }> | null, mealLineItems?: Array<{ __typename?: 'MealLineItem', meal?: { __typename?: 'Meal', name?: string | null } | null }> | null, recommendationWizard?: { __typename?: 'RecommendationWizard', id: string, weight?: number | null, recommendedRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedComboRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedAddons?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null } | null, wellnessGoals?: Array<{ __typename?: 'WellnessGoal', name: string }> | null, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } } | null };

export type PetPropsFragment = { __typename?: 'Pet', activityLevel?: PetActivityLevels | null, ageGroup?: string | null, birthDate?: any | null, breedType: string, calculatedCaloriesPerDay?: number | null, completedBirthDate?: boolean | null, createdAt: any, gender?: string | null, hasFoodSensitivities?: boolean | null, hasWellnessGoals?: boolean | null, id: string, waistline?: string | null, petName?: string | null, primaryBreedId?: number | null, restingEnergyRate?: number | null, secondaryBreedId?: number | null, servingSizeInOunces?: number | null, spayedNeutered?: boolean | null, updatedAt: any, weight?: number | null, ingredientIds?: Array<string> | null, wellnessGoalIds?: Array<string> | null, primaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, secondaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, ingredients?: Array<{ __typename?: 'Ingredient', name: string }> | null, mealLineItems?: Array<{ __typename?: 'MealLineItem', meal?: { __typename?: 'Meal', name?: string | null } | null }> | null, recommendationWizard?: { __typename?: 'RecommendationWizard', id: string, weight?: number | null, recommendedRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedComboRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedAddons?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null } | null, wellnessGoals?: Array<{ __typename?: 'WellnessGoal', name: string }> | null, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null };

export type PetBreedPropsFragment = { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null };

export type AdminSearchBreedsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchBreedsQuery = { __typename?: 'Query', breeds: { __typename?: 'BreedConnection', nodes?: Array<{ __typename?: 'Breed', id: string, name: string } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminSearchUsersQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', nodes?: Array<{ __typename?: 'User', id?: string | null, email?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminPlanCompatibilityCriteriumQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type AdminPlanCompatibilityCriteriumQuery = { __typename?: 'Query', planCompatibilityCriterium: { __typename?: 'PlanCompatibilityCriterium', id: string, name: string, weight: number, scoreFull: number, scoreTopper: number, scoreCombo: number, scoreBaked: number, displayOrder: number, hidden: boolean, createdAt: any, updatedAt: any } };

export type AdminPlanCompatibilityCriteriaQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPlanCompatibilityCriteriaResolverOrder>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type AdminPlanCompatibilityCriteriaQuery = { __typename?: 'Query', planCompatibilityCriteria: { __typename?: 'PlanCompatibilityCriteriumConnection', nodes?: Array<{ __typename?: 'PlanCompatibilityCriterium', id: string, name: string, weight: number, scoreFull: number, scoreTopper: number, scoreCombo: number, scoreBaked: number, displayOrder: number, hidden: boolean, createdAt: any, updatedAt: any } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminPlanCompatibilityCriteriumUpdateMutationVariables = Exact<{
  input: PlanCompatibilityCriteriumUpdateInput;
}>;


export type AdminPlanCompatibilityCriteriumUpdateMutation = { __typename?: 'Mutation', planCompatibilityCriteriumUpdate?: { __typename?: 'PlanCompatibilityCriteriumUpdatePayload', planCompatibilityCriterium?: { __typename?: 'PlanCompatibilityCriterium', id: string, name: string, weight: number, scoreFull: number, scoreTopper: number, scoreCombo: number, scoreBaked: number, displayOrder: number, hidden: boolean, createdAt: any, updatedAt: any } | null } | null };

export type PlanCompatibilityCriteriumPropsFragment = { __typename?: 'PlanCompatibilityCriterium', id: string, name: string, weight: number, scoreFull: number, scoreTopper: number, scoreCombo: number, scoreBaked: number, displayOrder: number, hidden: boolean, createdAt: any, updatedAt: any };

export type ProductPlanVariantUpdateMutationVariables = Exact<{
  input: ProductPlanVariantUpdateInput;
}>;


export type ProductPlanVariantUpdateMutation = { __typename?: 'Mutation', productPlanVariantUpdate?: { __typename?: 'ProductPlanVariantUpdatePayload', success: boolean } | null };

export type AdminProductQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminProductQuery = { __typename?: 'Query', petPlateProduct: { __typename?: 'PetPlateProduct', id: string, sku?: string | null, name?: string | null, shortName?: string | null, slug?: string | null, active?: boolean | null, category?: PlanLineItemCategoryEnum | null, description?: string | null, lineItemName?: string | null, price?: number | null, displayOrder?: number | null, emergencyOutOfStock?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, createdAt: any, updatedAt: any, productPlanVariants?: Array<{ __typename?: 'MealPlanVariant', sku?: string | null, name?: string | null, variants?: Array<{ __typename?: 'MealPlanVariantEntry', id?: string | null, outOfStock?: boolean | null, state?: MealPlanVariantState | null, plan?: { __typename?: 'BoxVariant', sku?: string | null, name: string, id: string } | null }> | null }> | null } };

export type AdminProductsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversPetPlateProductsResolverOrder>;
  name?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
}>;


export type AdminProductsQuery = { __typename?: 'Query', petPlateProducts: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, sku?: string | null, name?: string | null, slug?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, active?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, parentShopifyId?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminProductUpdateMutationVariables = Exact<{
  input: PetPlateProductUpdateInput;
}>;


export type AdminProductUpdateMutation = { __typename?: 'Mutation', petPlateProductUpdate?: { __typename?: 'PetPlateProductUpdatePayload', petPlateProduct: { __typename?: 'PetPlateProduct', id: string, sku?: string | null, name?: string | null, shortName?: string | null, slug?: string | null, active?: boolean | null, category?: PlanLineItemCategoryEnum | null, description?: string | null, lineItemName?: string | null, price?: number | null, displayOrder?: number | null, emergencyOutOfStock?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, createdAt: any, updatedAt: any, productPlanVariants?: Array<{ __typename?: 'MealPlanVariant', sku?: string | null, name?: string | null, variants?: Array<{ __typename?: 'MealPlanVariantEntry', id?: string | null, outOfStock?: boolean | null, state?: MealPlanVariantState | null, plan?: { __typename?: 'BoxVariant', sku?: string | null, name: string, id: string } | null }> | null }> | null } } | null };

export type ProductListPropsFragment = { __typename?: 'PetPlateProduct', id: string, sku?: string | null, name?: string | null, slug?: string | null, category?: PlanLineItemCategoryEnum | null, price?: number | null, active?: boolean | null, emergencyOutOfStock?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, parentShopifyId?: string | null };

export type ProductPropsFragment = { __typename?: 'PetPlateProduct', id: string, sku?: string | null, name?: string | null, shortName?: string | null, slug?: string | null, active?: boolean | null, category?: PlanLineItemCategoryEnum | null, description?: string | null, lineItemName?: string | null, price?: number | null, displayOrder?: number | null, emergencyOutOfStock?: boolean | null, outOfStock?: boolean | null, outOfStockMessage?: string | null, shopifyId?: string | null, parentShopifyId?: string | null, createdAt: any, updatedAt: any, productPlanVariants?: Array<{ __typename?: 'MealPlanVariant', sku?: string | null, name?: string | null, variants?: Array<{ __typename?: 'MealPlanVariantEntry', id?: string | null, outOfStock?: boolean | null, state?: MealPlanVariantState | null, plan?: { __typename?: 'BoxVariant', sku?: string | null, name: string, id: string } | null }> | null }> | null };

export type AdminRecommendableProductQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminRecommendableProductQuery = { __typename?: 'Query', recommendableProduct: { __typename?: 'RecommendableProduct', createdAt: any, id: string, recommendableId?: number | null, recommendableType: string, status: string, termId?: number | null, updatedAt: any, meal?: { __typename?: 'Meal', name?: string | null, sku?: string | null } | null, product?: { __typename?: 'PetPlateProduct', name?: string | null, sku?: string | null } | null, term?: { __typename?: 'Term', name?: string | null, type?: string | null } | null } };

export type AdminRecommendableProductsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversRecommendableProductsResolverOrder>;
  status?: InputMaybe<TypesRecommendableProductInputTypeStatus>;
  recommendableType?: InputMaybe<TypesRecommendableProductInputTypeRecommendedType>;
}>;


export type AdminRecommendableProductsQuery = { __typename?: 'Query', recommendableProducts: { __typename?: 'RecommendableProductConnection', nodes?: Array<{ __typename?: 'RecommendableProduct', createdAt: any, id: string, recommendableId?: number | null, recommendableType: string, status: string, termId?: number | null, updatedAt: any, meal?: { __typename?: 'Meal', name?: string | null, sku?: string | null } | null, product?: { __typename?: 'PetPlateProduct', name?: string | null, sku?: string | null } | null, term?: { __typename?: 'Term', name?: string | null, type?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminRecommendableProductDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminRecommendableProductDeleteMutation = { __typename?: 'Mutation', recommendableProductDelete?: { __typename?: 'RecommendableProductDeletePayload', recommendableProduct: { __typename?: 'RecommendableProduct', createdAt: any, id: string, recommendableId?: number | null, recommendableType: string, status: string, termId?: number | null, updatedAt: any, meal?: { __typename?: 'Meal', name?: string | null, sku?: string | null } | null, product?: { __typename?: 'PetPlateProduct', name?: string | null, sku?: string | null } | null, term?: { __typename?: 'Term', name?: string | null, type?: string | null } | null } } | null };

export type AdminRecommendableProductUpdateMutationVariables = Exact<{
  input: RecommendableProductUpdateInput;
}>;


export type AdminRecommendableProductUpdateMutation = { __typename?: 'Mutation', recommendableProductUpdate?: { __typename?: 'RecommendableProductUpdatePayload', recommendableProduct: { __typename?: 'RecommendableProduct', createdAt: any, id: string, recommendableId?: number | null, recommendableType: string, status: string, termId?: number | null, updatedAt: any, meal?: { __typename?: 'Meal', name?: string | null, sku?: string | null } | null, product?: { __typename?: 'PetPlateProduct', name?: string | null, sku?: string | null } | null, term?: { __typename?: 'Term', name?: string | null, type?: string | null } | null } } | null };

export type AdminRecommendableProductCreateMutationVariables = Exact<{
  input: RecommendableProductCreateInput;
}>;


export type AdminRecommendableProductCreateMutation = { __typename?: 'Mutation', recommendableProductCreate?: { __typename?: 'RecommendableProductCreatePayload', recommendableProduct: { __typename?: 'RecommendableProduct', createdAt: any, id: string, recommendableId?: number | null, recommendableType: string, status: string, termId?: number | null, updatedAt: any, meal?: { __typename?: 'Meal', name?: string | null, sku?: string | null } | null, product?: { __typename?: 'PetPlateProduct', name?: string | null, sku?: string | null } | null, term?: { __typename?: 'Term', name?: string | null, type?: string | null } | null } } | null };

export type RecommendableProductPropsFragment = { __typename?: 'RecommendableProduct', createdAt: any, id: string, recommendableId?: number | null, recommendableType: string, status: string, termId?: number | null, updatedAt: any, meal?: { __typename?: 'Meal', name?: string | null, sku?: string | null } | null, product?: { __typename?: 'PetPlateProduct', name?: string | null, sku?: string | null } | null, term?: { __typename?: 'Term', name?: string | null, type?: string | null } | null };

export type AdminSearchMealsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchMealsQuery = { __typename?: 'Query', meals: { __typename?: 'MealConnection', nodes?: Array<{ __typename?: 'Meal', id: string, name?: string | null, sku?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminSearchProductsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchProductsQuery = { __typename?: 'Query', petPlateProducts: { __typename?: 'PetPlateProductConnection', nodes?: Array<{ __typename?: 'PetPlateProduct', id: string, name?: string | null, sku?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminRouteScheduleUploadJobQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminRouteScheduleUploadJobQuery = { __typename?: 'Query', routeScheduleUpload: { __typename?: 'RouteScheduleUpload', id: string, createdAt: any, updatedAt: any, state: TypesRouteScheduleUploadTypeState, routeType: TypesRouteScheduleTypeRouteCode, error?: string | null, fileName?: string | null, downloadFileLink?: string | null, numberProcessedRoutes?: number | null, zipCodesCreated?: number | null, endedAt?: any | null } };

export type AdminRouteScheduleUploadJobsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  fileName?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<TypesRouteScheduleUploadTypeState>;
  routeType?: InputMaybe<RouteCode>;
  order?: InputMaybe<ResolversRouteScheduleUploadsResolverOrder>;
  createdAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type AdminRouteScheduleUploadJobsQuery = { __typename?: 'Query', routeScheduleUploads: { __typename?: 'RouteScheduleUploadConnection', nodes?: Array<{ __typename?: 'RouteScheduleUpload', id: string, createdAt: any, updatedAt: any, state: TypesRouteScheduleUploadTypeState, routeType: TypesRouteScheduleTypeRouteCode, error?: string | null, fileName?: string | null, numberProcessedRoutes?: number | null, endedAt?: any | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminRouteScheduleQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminRouteScheduleQuery = { __typename?: 'Query', routeSchedule: { __typename?: 'RouteSchedule', carrier?: string | null, carrierCode?: string | null, createdAt: any, deliveryDays?: number | null, id: string, includeDryIce: boolean, routeCode: TypesRouteScheduleTypeRouteCode, scheduleData?: any | null, scheduleStartDate: any, serviced?: boolean | null, shippingStartDate: any, transitRegion?: string | null, transitRegionCode?: string | null, updatedAt: any, warehouseCode?: string | null, warehouseName?: string | null, warehouseZipCode?: string | null, zipCode: string } };

export type AdminRouteSchedulesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<ResolversRouteSchedulesResolverOrder>;
  carrier?: InputMaybe<Scalars['String']>;
  carrierCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
  routeCode?: InputMaybe<TypesRouteScheduleTypeRouteCode>;
  transitRegion?: InputMaybe<Scalars['String']>;
  transitRegionCode?: InputMaybe<Scalars['String']>;
  warehouseName?: InputMaybe<Scalars['String']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
}>;


export type AdminRouteSchedulesQuery = { __typename?: 'Query', routeSchedules: { __typename?: 'RouteScheduleConnection', nodes?: Array<{ __typename?: 'RouteSchedule', carrier?: string | null, carrierCode?: string | null, createdAt: any, deliveryDays?: number | null, id: string, includeDryIce: boolean, routeCode: TypesRouteScheduleTypeRouteCode, scheduleData?: any | null, scheduleStartDate: any, serviced?: boolean | null, shippingStartDate: any, transitRegion?: string | null, transitRegionCode?: string | null, updatedAt: any, warehouseCode?: string | null, warehouseName?: string | null, warehouseZipCode?: string | null, zipCode: string } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminRouteScheduleCreateMutationVariables = Exact<{
  input: RouteScheduleCreateInput;
}>;


export type AdminRouteScheduleCreateMutation = { __typename?: 'Mutation', routeScheduleCreate?: { __typename?: 'RouteScheduleCreatePayload', routeSchedule: { __typename?: 'RouteSchedule', carrier?: string | null, carrierCode?: string | null, createdAt: any, deliveryDays?: number | null, id: string, includeDryIce: boolean, routeCode: TypesRouteScheduleTypeRouteCode, scheduleData?: any | null, scheduleStartDate: any, serviced?: boolean | null, shippingStartDate: any, transitRegion?: string | null, transitRegionCode?: string | null, updatedAt: any, warehouseCode?: string | null, warehouseName?: string | null, warehouseZipCode?: string | null, zipCode: string } } | null };

export type AdminRouteScheduleUpdateMutationVariables = Exact<{
  input: RouteScheduleUpdateInput;
}>;


export type AdminRouteScheduleUpdateMutation = { __typename?: 'Mutation', routeScheduleUpdate?: { __typename?: 'RouteScheduleUpdatePayload', routeSchedule: { __typename?: 'RouteSchedule', carrier?: string | null, carrierCode?: string | null, createdAt: any, deliveryDays?: number | null, id: string, includeDryIce: boolean, routeCode: TypesRouteScheduleTypeRouteCode, scheduleData?: any | null, scheduleStartDate: any, serviced?: boolean | null, shippingStartDate: any, transitRegion?: string | null, transitRegionCode?: string | null, updatedAt: any, warehouseCode?: string | null, warehouseName?: string | null, warehouseZipCode?: string | null, zipCode: string } } | null };

export type AdminRouteScheduleDeleteMutationVariables = Exact<{
  input: RouteScheduleDeleteInput;
}>;


export type AdminRouteScheduleDeleteMutation = { __typename?: 'Mutation', routeScheduleDelete?: { __typename?: 'RouteScheduleDeletePayload', routeSchedule: { __typename?: 'RouteSchedule', carrier?: string | null, carrierCode?: string | null, createdAt: any, deliveryDays?: number | null, id: string, includeDryIce: boolean, routeCode: TypesRouteScheduleTypeRouteCode, scheduleData?: any | null, scheduleStartDate: any, serviced?: boolean | null, shippingStartDate: any, transitRegion?: string | null, transitRegionCode?: string | null, updatedAt: any, warehouseCode?: string | null, warehouseName?: string | null, warehouseZipCode?: string | null, zipCode: string } } | null };

export type RouteSchedulePropsFragment = { __typename?: 'RouteSchedule', carrier?: string | null, carrierCode?: string | null, createdAt: any, deliveryDays?: number | null, id: string, includeDryIce: boolean, routeCode: TypesRouteScheduleTypeRouteCode, scheduleData?: any | null, scheduleStartDate: any, serviced?: boolean | null, shippingStartDate: any, transitRegion?: string | null, transitRegionCode?: string | null, updatedAt: any, warehouseCode?: string | null, warehouseName?: string | null, warehouseZipCode?: string | null, zipCode: string };

export type WhoamiQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoamiQuery = { __typename?: 'Query', me: { __typename?: 'User', id?: string | null, email?: string | null, roles?: Array<{ __typename?: 'Role', name: string }> | null } };

export type UpdateSettingsMutationVariables = Exact<{
  input: SettingsUpdateInput;
}>;


export type UpdateSettingsMutation = { __typename?: 'Mutation', settingsUpdate?: { __typename?: 'SettingsUpdatePayload', ok: boolean } | null };

export type DeleteSettingMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type DeleteSettingMutation = { __typename?: 'Mutation', settingDelete?: { __typename?: 'SettingDeletePayload', ok?: boolean | null } | null };

export type AdminPlatformCouponsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
}>;


export type AdminPlatformCouponsQuery = { __typename?: 'Query', coupons: { __typename?: 'CouponConnection', nodes?: Array<{ __typename?: 'Coupon', id: string, code?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type PlatformSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformSettingsQuery = { __typename?: 'Query', coupons?: Array<{ __typename?: 'SettingsSearchResult', key: string, value?: { __typename?: 'Coupon', code?: string | null, id: string } | { __typename?: 'Setting' } | null }> | null };

export type WeatherDryIceFlagQueryVariables = Exact<{ [key: string]: never; }>;


export type WeatherDryIceFlagQuery = { __typename?: 'Query', useWeatherDryIce: boolean };

export type ShipmentListUploadMutationVariables = Exact<{
  input: ShipmentListUploadInput;
}>;


export type ShipmentListUploadMutation = { __typename?: 'Mutation', shipmentListUpload?: { __typename?: 'ShipmentListUploadPayload', jobId?: number | null, id?: number | null } | null };

export type ShipmentListShipStationUploadMutationVariables = Exact<{
  input: ShipmentListShipStationUploadInput;
}>;


export type ShipmentListShipStationUploadMutation = { __typename?: 'Mutation', shipmentListShipStationUpload?: { __typename?: 'ShipmentListShipStationUploadPayload', id?: number | null } | null };

export type AdminShipmentListQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminShipmentListQuery = { __typename?: 'Query', shipmentList: { __typename?: 'ShipmentList', totalCount?: number | null, processedCount?: number | null, successCount?: number | null, failureCount?: number | null, createdAt: any, startedAt?: any | null, endedAt?: any | null, id: string, shippedAt?: any | null, state?: string | null, updatedAt: any, shipmentListsV2Orders?: Array<{ __typename?: 'ShipmentListsV2Order', success?: boolean | null, failure?: boolean | null, started?: boolean | null, processed?: boolean | null, error?: string | null, v2Order?: { __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null, contactEmail?: string | null, customerId?: string | null } | null, shipmentEntry?: { __typename?: 'ShipmentEntry', id: string, state?: TypesShipmentEntryStateEnumType | null, shipmentNumber?: string | null, createdAt: any, updatedAt: any, index: number } | null }> | null, shipstationUploadJobs?: Array<{ __typename?: 'ShipstationUploadJob', id: string, createdAt: any, updatedAt?: any | null, status?: string | null, errorMessage?: string | null, logEvents?: Array<{ __typename?: 'LogEvent', data?: any | null, message?: string | null, event?: string | null }> | null, shipmentModifications?: Array<{ __typename?: 'ShipmentUploadModification', shipmentId?: string | null, itemSku?: string | null, changes?: Array<{ __typename?: 'Change', key?: string | null, value?: string | null }> | null }> | null }> | null, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string, shipmentNumber?: string | null, state?: TypesShipmentEntryStateEnumType | null, trackingNumber?: string | null, trackingStatus?: string | null, createdAt: any, updatedAt: any, trackedOnKlaviyoAt?: any | null, undigitalInsertedAt?: any | null, startedAt?: any | null, endedAt?: any | null, undigitalInsertError?: string | null, klaviyoTrackError?: string | null, v2Order?: { __typename?: 'DbOrder', id?: number | null, contactEmail?: string | null, orderNumber?: string | null } | null }> | null } };

export type AdminShipmentListInShipstationFormatQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminShipmentListInShipstationFormatQuery = { __typename?: 'Query', shipmentListToShipstationFormat: { __typename?: 'ShipmentListShipstationFormat', nodes: Array<{ __typename?: 'ShipstationOrder', addressLine1?: string | null, addressLine2?: string | null, amountPaid?: number | null, buyerEmail?: string | null, buyerFullName?: string | null, city?: string | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, giftMessage?: string | null, carrierCode?: string | null, itemName?: string | null, itemQuantity?: number | null, itemSku?: string | null, itemWeight?: number | null, notesFromBuyer?: string | null, warehouseCode?: string | null, orderDate?: any | null, orderNumber?: string | null, orderSource?: string | null, orderTotal?: number | null, postalCode?: string | null, recipientFullName?: string | null, state?: string | null, itemType?: string | null, box?: { __typename?: 'OrderBox', itemWeight?: number | null, bagWeight?: number | null } | null }> } };

export type AdminShipmentListsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversShipmentListsResolverOrder>;
  state?: InputMaybe<TypesShipmentListInputTypeState>;
  estimatedShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  shippedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type AdminShipmentListsQuery = { __typename?: 'Query', shipmentLists: { __typename?: 'ShipmentListConnection', nodes?: Array<{ __typename?: 'ShipmentList', createdAt: any, startedAt?: any | null, endedAt?: any | null, id: string, shippedAt?: any | null, state?: string | null, updatedAt: any, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminShipmentListCreateMutationVariables = Exact<{
  input: ShipmentListCreateInput;
}>;


export type AdminShipmentListCreateMutation = { __typename?: 'Mutation', shipmentListCreate?: { __typename?: 'ShipmentListCreatePayload', shipmentList: { __typename?: 'ShipmentList', createdAt: any, startedAt?: any | null, endedAt?: any | null, id: string, shippedAt?: any | null, state?: string | null, updatedAt: any, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null } } | null };

export type AdminShipmentListUpdateMutationVariables = Exact<{
  input: ShipmentListUpdateInput;
}>;


export type AdminShipmentListUpdateMutation = { __typename?: 'Mutation', shipmentListUpdate?: { __typename?: 'ShipmentListUpdatePayload', shipmentList: { __typename?: 'ShipmentList', createdAt: any, startedAt?: any | null, endedAt?: any | null, id: string, shippedAt?: any | null, state?: string | null, updatedAt: any, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null } } | null };

export type ShipmentListIndexPropsFragment = { __typename?: 'ShipmentList', createdAt: any, startedAt?: any | null, endedAt?: any | null, id: string, shippedAt?: any | null, state?: string | null, updatedAt: any, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string }> | null };

export type ShipmentListViewPropsFragment = { __typename?: 'ShipmentList', createdAt: any, startedAt?: any | null, endedAt?: any | null, id: string, shippedAt?: any | null, state?: string | null, updatedAt: any, shipments?: Array<{ __typename?: 'ShipmentEntry', id: string, shipmentNumber?: string | null, state?: TypesShipmentEntryStateEnumType | null, trackingNumber?: string | null, trackingStatus?: string | null, createdAt: any, updatedAt: any, trackedOnKlaviyoAt?: any | null, undigitalInsertedAt?: any | null, startedAt?: any | null, endedAt?: any | null, undigitalInsertError?: string | null, klaviyoTrackError?: string | null, v2Order?: { __typename?: 'DbOrder', id?: number | null, contactEmail?: string | null, orderNumber?: string | null } | null }> | null };

export type AdminShipmentUpdatesUploadJobLinkQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminShipmentUpdatesUploadJobLinkQuery = { __typename?: 'Query', shipmentUpdatesUpload: { __typename?: 'ShipmentUpdatesUpload', downloadFileLink?: string | null } };

export type AdminShipmentUpdatesUploadJobQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminShipmentUpdatesUploadJobQuery = { __typename?: 'Query', shipmentUpdatesUpload: { __typename?: 'ShipmentUpdatesUpload', id: string, createdAt: any, updatedAt: any, state: TypesShipmentUpdatesUploadTypeState, error?: string | null, fileName?: string | null, numberProcessedShipments?: number | null, endedAt?: any | null } };

export type AdminShipmentUpdatesUploadJobsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  fileName?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<TypesShipmentUpdatesUploadTypeState>;
  order?: InputMaybe<ResolversShipmentUpdatesUploadsResolverOrder>;
  createdAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type AdminShipmentUpdatesUploadJobsQuery = { __typename?: 'Query', shipmentUpdatesUploads: { __typename?: 'ShipmentUpdatesUploadConnection', nodes?: Array<{ __typename?: 'ShipmentUpdatesUpload', id: string, createdAt: any, updatedAt: any, state: TypesShipmentUpdatesUploadTypeState, error?: string | null, fileName?: string | null, numberProcessedShipments?: number | null, endedAt?: any | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminShipmentEntryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminShipmentEntryQuery = { __typename?: 'Query', shipmentEntry: { __typename?: 'ShipmentEntry', insertImageUrl?: string | null, addressData?: any | null, addressStateAbbr?: string | null, addressZipCode?: string | null, shipmentListId?: number | null, carrierCode?: string | null, carrierService?: string | null, createdAt: any, data?: any | null, daysInTransit?: number | null, email?: string | null, id: string, index: number, lineItemsData?: any | null, orderStatus?: string | null, planFrequency?: number | null, renewals?: number | null, routeCode?: string | null, scheduledShippingDate?: any | null, shipmentNumber?: string | null, shippedAt?: any | null, state?: TypesShipmentEntryStateEnumType | null, subscriptionStatus?: string | null, trackingNumber?: string | null, trackingStatus?: string | null, transitRegionCode?: string | null, updatedAt: any, undigitalInsertedAt?: any | null, trackedOnKlaviyoAt?: any | null, startedAt?: any | null, endedAt?: any | null, warehouseCode?: string | null, trackingRecord?: { __typename?: 'ShipmentListsV2Order', started?: boolean | null, success?: boolean | null, failure?: boolean | null, processed?: boolean | null, error?: string | null, v2Order?: { __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null, contactEmail?: string | null, customerId?: string | null } | null, shipmentEntry?: { __typename?: 'ShipmentEntry', id: string, state?: TypesShipmentEntryStateEnumType | null, shipmentNumber?: string | null } | null } | null, box?: { __typename?: 'Box', id: string, sku?: string | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, sku?: string | null, name: string, price?: number | null } | null, v2Order?: { __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null } | null, packaging?: { __typename?: 'Packaging', id: string, name?: string | null } | null, payment?: { __typename?: 'PpPayment', id: string, number?: string | null, state?: PaymentState | null } | null, pet?: { __typename?: 'Pet', id: string } | null, shipmentList?: { __typename?: 'ShipmentList', id: string } | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, phoneNumber?: string | null } | null } };

export type AdminShipmentEntriesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversShipmentEntriesResolverOrder>;
  state?: InputMaybe<TypesShipmentEntryInputTypeState>;
  scheduledShippingDateFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  scheduledShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  scheduledShippingDateTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  shippedAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  shippedAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  routeCode?: InputMaybe<Scalars['String']>;
  subscriptionStatus?: InputMaybe<Scalars['String']>;
  subscriptionNumber?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  shipmentNumber?: InputMaybe<Scalars['String']>;
  shipmentId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  paymentMissing?: InputMaybe<Scalars['Boolean']>;
  paymentNumber?: InputMaybe<Scalars['String']>;
  paymentStatus?: InputMaybe<Scalars['String']>;
  paymentZip?: InputMaybe<Scalars['String']>;
  boxVariant?: InputMaybe<Scalars['String']>;
  box?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  addressStateAbbr?: InputMaybe<Scalars['String']>;
  carrierService?: InputMaybe<Scalars['String']>;
  opsState?: InputMaybe<ResolversShipmentEntriesResolverOpsState>;
  trackingNumber?: InputMaybe<Scalars['String']>;
  trackingStatus?: InputMaybe<Scalars['String']>;
}>;


export type AdminShipmentEntriesQuery = { __typename?: 'Query', shipmentEntries: { __typename?: 'ShipmentEntryConnection', nodes?: Array<{ __typename?: 'ShipmentEntry', addressData?: any | null, addressStateAbbr?: string | null, addressZipCode?: string | null, shipmentListId?: number | null, carrierCode?: string | null, carrierService?: string | null, createdAt: any, data?: any | null, daysInTransit?: number | null, email?: string | null, id: string, index: number, lineItemsData?: any | null, orderStatus?: string | null, planFrequency?: number | null, renewals?: number | null, routeCode?: string | null, scheduledShippingDate?: any | null, shipmentNumber?: string | null, shippedAt?: any | null, state?: TypesShipmentEntryStateEnumType | null, subscriptionStatus?: string | null, trackingNumber?: string | null, trackingStatus?: string | null, transitRegionCode?: string | null, updatedAt: any, undigitalInsertedAt?: any | null, trackedOnKlaviyoAt?: any | null, startedAt?: any | null, endedAt?: any | null, warehouseCode?: string | null, box?: { __typename?: 'Box', id: string, sku?: string | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, sku?: string | null, name: string, price?: number | null } | null, v2Order?: { __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null } | null, packaging?: { __typename?: 'Packaging', id: string, name?: string | null } | null, payment?: { __typename?: 'PpPayment', id: string, number?: string | null, state?: PaymentState | null } | null, pet?: { __typename?: 'Pet', id: string } | null, shipmentList?: { __typename?: 'ShipmentList', id: string } | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, phoneNumber?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminShipmentEntriesReportQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<ResolversShipmentEntriesResolverOrder>;
  state?: InputMaybe<TypesShipmentEntryInputTypeState>;
  scheduledShippingDateFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  scheduledShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  scheduledShippingDateTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  shippedAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  shippedAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  routeCode?: InputMaybe<Scalars['String']>;
  subscriptionStatus?: InputMaybe<Scalars['String']>;
  subscriptionNumber?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  shipmentNumber?: InputMaybe<Scalars['String']>;
  shipmentId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  paymentMissing?: InputMaybe<Scalars['Boolean']>;
  paymentNumber?: InputMaybe<Scalars['String']>;
  paymentStatus?: InputMaybe<Scalars['String']>;
  paymentZip?: InputMaybe<Scalars['String']>;
  boxVariant?: InputMaybe<Scalars['String']>;
  box?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  addressStateAbbr?: InputMaybe<Scalars['String']>;
  carrierService?: InputMaybe<Scalars['String']>;
  opsState?: InputMaybe<ResolversShipmentEntriesResolverOpsState>;
  trackingNumber?: InputMaybe<Scalars['String']>;
  trackingStatus?: InputMaybe<Scalars['String']>;
}>;


export type AdminShipmentEntriesReportQuery = { __typename?: 'Query', shipmentEntriesReport: { __typename?: 'ReportDownload', url: string } };

export type AdminShipmentEntryCreateMutationVariables = Exact<{
  input: ShipmentEntryCreateInput;
}>;


export type AdminShipmentEntryCreateMutation = { __typename?: 'Mutation', shipmentEntryCreate?: { __typename?: 'ShipmentEntryCreatePayload', shipmentEntry: { __typename?: 'ShipmentEntry', addressData?: any | null, addressStateAbbr?: string | null, addressZipCode?: string | null, shipmentListId?: number | null, carrierCode?: string | null, carrierService?: string | null, createdAt: any, data?: any | null, daysInTransit?: number | null, email?: string | null, id: string, index: number, lineItemsData?: any | null, orderStatus?: string | null, planFrequency?: number | null, renewals?: number | null, routeCode?: string | null, scheduledShippingDate?: any | null, shipmentNumber?: string | null, shippedAt?: any | null, state?: TypesShipmentEntryStateEnumType | null, subscriptionStatus?: string | null, trackingNumber?: string | null, trackingStatus?: string | null, transitRegionCode?: string | null, updatedAt: any, undigitalInsertedAt?: any | null, trackedOnKlaviyoAt?: any | null, startedAt?: any | null, endedAt?: any | null, warehouseCode?: string | null, box?: { __typename?: 'Box', id: string, sku?: string | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, sku?: string | null, name: string, price?: number | null } | null, v2Order?: { __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null } | null, packaging?: { __typename?: 'Packaging', id: string, name?: string | null } | null, payment?: { __typename?: 'PpPayment', id: string, number?: string | null, state?: PaymentState | null } | null, pet?: { __typename?: 'Pet', id: string } | null, shipmentList?: { __typename?: 'ShipmentList', id: string } | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, phoneNumber?: string | null } | null } } | null };

export type AdminShipmentEntryUpdateMutationVariables = Exact<{
  input: ShipmentEntryUpdateInput;
}>;


export type AdminShipmentEntryUpdateMutation = { __typename?: 'Mutation', shipmentEntryUpdate?: { __typename?: 'ShipmentEntryUpdatePayload', shipmentEntry: { __typename?: 'ShipmentEntry', addressData?: any | null, addressStateAbbr?: string | null, addressZipCode?: string | null, shipmentListId?: number | null, carrierCode?: string | null, carrierService?: string | null, createdAt: any, data?: any | null, daysInTransit?: number | null, email?: string | null, id: string, index: number, lineItemsData?: any | null, orderStatus?: string | null, planFrequency?: number | null, renewals?: number | null, routeCode?: string | null, scheduledShippingDate?: any | null, shipmentNumber?: string | null, shippedAt?: any | null, state?: TypesShipmentEntryStateEnumType | null, subscriptionStatus?: string | null, trackingNumber?: string | null, trackingStatus?: string | null, transitRegionCode?: string | null, updatedAt: any, undigitalInsertedAt?: any | null, trackedOnKlaviyoAt?: any | null, startedAt?: any | null, endedAt?: any | null, warehouseCode?: string | null, box?: { __typename?: 'Box', id: string, sku?: string | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, sku?: string | null, name: string, price?: number | null } | null, v2Order?: { __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null } | null, packaging?: { __typename?: 'Packaging', id: string, name?: string | null } | null, payment?: { __typename?: 'PpPayment', id: string, number?: string | null, state?: PaymentState | null } | null, pet?: { __typename?: 'Pet', id: string } | null, shipmentList?: { __typename?: 'ShipmentList', id: string } | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, phoneNumber?: string | null } | null } } | null };

export type ShipmentEntryPropsFragment = { __typename?: 'ShipmentEntry', addressData?: any | null, addressStateAbbr?: string | null, addressZipCode?: string | null, shipmentListId?: number | null, carrierCode?: string | null, carrierService?: string | null, createdAt: any, data?: any | null, daysInTransit?: number | null, email?: string | null, id: string, index: number, lineItemsData?: any | null, orderStatus?: string | null, planFrequency?: number | null, renewals?: number | null, routeCode?: string | null, scheduledShippingDate?: any | null, shipmentNumber?: string | null, shippedAt?: any | null, state?: TypesShipmentEntryStateEnumType | null, subscriptionStatus?: string | null, trackingNumber?: string | null, trackingStatus?: string | null, transitRegionCode?: string | null, updatedAt: any, undigitalInsertedAt?: any | null, trackedOnKlaviyoAt?: any | null, startedAt?: any | null, endedAt?: any | null, warehouseCode?: string | null, box?: { __typename?: 'Box', id: string, sku?: string | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, sku?: string | null, name: string, price?: number | null } | null, v2Order?: { __typename?: 'DbOrder', id?: number | null, orderNumber?: string | null } | null, packaging?: { __typename?: 'Packaging', id: string, name?: string | null } | null, payment?: { __typename?: 'PpPayment', id: string, number?: string | null, state?: PaymentState | null } | null, pet?: { __typename?: 'Pet', id: string } | null, shipmentList?: { __typename?: 'ShipmentList', id: string } | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, phoneNumber?: string | null } | null };

export type AdminSearchBoxQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchBoxQuery = { __typename?: 'Query', boxes: { __typename?: 'BoxConnection', nodes?: Array<{ __typename?: 'Box', id: string, name: string } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminSearchPetsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchPetsQuery = { __typename?: 'Query', pets: { __typename?: 'PetConnection', nodes?: Array<{ __typename?: 'Pet', id: string, petName?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminSearchBoxVariantsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchBoxVariantsQuery = { __typename?: 'Query', boxVariants: { __typename?: 'BoxVariantConnection', nodes?: Array<{ __typename?: 'BoxVariant', id: string, name: string } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminSearchPaymentsQueryVariables = Exact<{
  number?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchPaymentsQuery = { __typename?: 'Query', ppPayments: { __typename?: 'PpPaymentConnection', nodes?: Array<{ __typename?: 'PpPayment', id: string, number?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminSearchShipmentsQueryVariables = Exact<{
  date?: InputMaybe<Scalars['ISO8601DateTime']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSearchShipmentsQuery = { __typename?: 'Query', shipmentLists: { __typename?: 'ShipmentListConnection', nodes?: Array<{ __typename?: 'ShipmentList', id: string, shippedAt?: any | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminShipstationUploadJobQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminShipstationUploadJobQuery = { __typename?: 'Query', shipstationUploadJob: { __typename?: 'ShipstationUploadJob', id: string, createdAt: any, updatedAt?: any | null, errorMessage?: string | null, total?: number | null, uploaded?: number | null, status?: string | null, logEvents?: Array<{ __typename?: 'LogEvent', id: string, data?: any | null, event?: string | null, message?: string | null, createdAt: any }> | null, shipmentList: { __typename?: 'ShipmentList', id: string }, shipmentModifications?: Array<{ __typename?: 'ShipmentUploadModification', itemSku?: string | null, shipmentId?: string | null, changes?: Array<{ __typename?: 'Change', value?: string | null, key?: string | null, originalValue?: string | null }> | null }> | null } };

export type AdminPetPlateProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminPetPlateProductsQuery = { __typename?: 'Query', productVariants: { __typename?: 'PetPlateProductVariantTypeConnection', nodes?: Array<{ __typename?: 'PetPlateProductVariantType', sku?: string | null, name?: string | null, product?: { __typename?: 'PetPlateProduct', name?: string | null, weightInOunces?: number | null, productType?: string | null, lineItemName?: string | null } | null, boxVariant?: { __typename?: 'BoxVariant', sku?: string | null, box?: { __typename?: 'Box', itemWeight?: number | null, bagWeight?: number | null } | null } | null } | null> | null }, mealVariants: { __typename?: 'PetPlateMealVariantTypeConnection', nodes?: Array<{ __typename?: 'PetPlateMealVariantType', sku?: string | null, name?: string | null, meal?: { __typename?: 'PetPlateProduct', weightInOunces?: number | null, name?: string | null, lineItemName?: string | null, productType?: string | null } | null, boxVariant?: { __typename?: 'BoxVariant', sku?: string | null, box?: { __typename?: 'Box', itemWeight?: number | null, bagWeight?: number | null } | null } | null } | null> | null }, cupHolders: { __typename?: 'LineItemRuleSetConnection', nodes?: Array<{ __typename?: 'LineItemRuleSet', lineItemType?: string | null, lineItemSku?: string | null, description?: string | null, lineItemName?: string | null, id: string } | null> | null } };

export type AdminSizeClassesNameOnlyQueryVariables = Exact<{
  batch: Scalars['Int'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type AdminSizeClassesNameOnlyQuery = { __typename?: 'Query', sizeClasses: { __typename?: 'SizeClassConnection', nodes?: Array<{ __typename?: 'SizeClass', name?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', endCursor?: string | null } } };

export type AdminSizeClassQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminSizeClassQuery = { __typename?: 'Query', sizeClass: { __typename?: 'SizeClass', ageOfMaturity?: number | null, ageOfSeniority?: number | null, lifeExpectancy?: number | null, maxWeight?: number | null, name?: string | null } };

export type AdminSizeClassesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversSizeClassesResolverOrder>;
}>;


export type AdminSizeClassesQuery = { __typename?: 'Query', sizeClasses: { __typename?: 'SizeClassConnection', nodes?: Array<{ __typename?: 'SizeClass', ageOfMaturity?: number | null, ageOfSeniority?: number | null, lifeExpectancy?: number | null, maxWeight?: number | null, name?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminSizeClassUpdateMutationVariables = Exact<{
  input: SizeClassUpdateInput;
}>;


export type AdminSizeClassUpdateMutation = { __typename?: 'Mutation', sizeClassUpdate?: { __typename?: 'SizeClassUpdatePayload', sizeClass: { __typename?: 'SizeClass', ageOfMaturity?: number | null, ageOfSeniority?: number | null, lifeExpectancy?: number | null, maxWeight?: number | null, name?: string | null } } | null };

export type AdminSizeClassCreateMutationVariables = Exact<{
  input: SizeClassCreateInput;
}>;


export type AdminSizeClassCreateMutation = { __typename?: 'Mutation', sizeClassCreate?: { __typename?: 'SizeClassCreatePayload', sizeClass: { __typename?: 'SizeClass', ageOfMaturity?: number | null, ageOfSeniority?: number | null, lifeExpectancy?: number | null, maxWeight?: number | null, name?: string | null } } | null };

export type SizeClassPropsFragment = { __typename?: 'SizeClass', ageOfMaturity?: number | null, ageOfSeniority?: number | null, lifeExpectancy?: number | null, maxWeight?: number | null, name?: string | null };

export type AdminStatusLogsQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversStateChangesResolverOrder>;
  id?: InputMaybe<Scalars['ID']>;
  previousState?: InputMaybe<Scalars['String']>;
  nextState?: InputMaybe<Scalars['String']>;
  statefulType?: InputMaybe<Scalars['String']>;
  statefulId?: InputMaybe<Scalars['ID']>;
}>;


export type AdminStatusLogsQuery = { __typename?: 'Query', stateChanges: { __typename?: 'StateChangeConnection', nodes?: Array<{ __typename?: 'StateChange', createdAt: any, id: string, name?: string | null, nextState?: string | null, previousState?: string | null, subscription?: { __typename?: 'Subscription', id: string, number?: string | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminSubscriptionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminSubscriptionQuery = { __typename?: 'Query', subscription: { __typename?: 'Subscription', apiSubscriptionId?: string | null, attributions?: any | null, cancelAtPeriodEnd?: boolean | null, canceledAt?: any | null, completedAt?: any | null, createdAt?: any | null, currentPlanFrequency?: number | null, data?: any | null, dishesCount?: number | null, renewals?: number | null, email?: string | null, hiddenAt?: any | null, id: string, ignoreNewPlanRecommendationsAt?: any | null, lastShippedAt?: any | null, lineItemsData: any, manuallyScheduledShipments?: string | null, newPlan?: boolean | null, nextPlanFrequency?: number | null, nextScheduledShippingDate?: any | null, number?: string | null, paymentTotal?: number | null, scheduledShippingDate?: any | null, state?: SubscriptionStateEnum | null, statementTotal?: number | null, total?: number | null, updatedAt?: any | null, estimatedDeliveryDate?: any | null, estimatedNextDeliveryDates?: Array<any> | null, estimatedNextShippingDates?: Array<any> | null, stripeUrl?: string | null, cancellationSurvey?: { __typename?: 'CancellationSurvey', cancellationReasonId?: number | null, cancellationReasonOther?: string | null, cancellationReasonOtherMoreDetails?: string | null, cancellationReasonTerm?: { __typename?: 'Term', id: string, description?: string | null } | null } | null, routeSchedule?: { __typename?: 'RouteSchedule', warehouseCode?: string | null, warehouseName?: string | null, carrierCode?: string | null, deliveryDays?: number | null, includeDryIce: boolean, routeCode: TypesRouteScheduleTypeRouteCode, transitRegionCode?: string | null, shippingStartDate: any, scheduleStartDate: any } | null, coupons?: Array<{ __typename?: 'SubscriptionShopifyCoupon', code: string, maskedCode?: string | null, applicationType: TypesSubscriptionShopifyCouponApplicationType, amountOff?: number | null, percentageOff?: number | null, usageCycleLimit?: number | null, limited: boolean, usageCount: number, oncePerCustomer: boolean, appliesToAllItems: boolean }> | null, remoteContract?: { __typename?: 'RemoteContract', id?: string | null, status?: string | null, appAdminUrl?: string | null, customer?: { __typename?: 'ShopifyContractCustomer', email?: string | null, firstName?: string | null, id?: string | null, lastName?: string | null, productSubscriberStatus?: string | null, state?: string | null, validEmailAddress?: boolean | null, verifiedEmail?: boolean | null } | null, customerPaymentMethod?: { __typename?: 'ShopifyCustomerPaymentMethod', id?: string | null, revokedAt?: string | null, revokedReason?: string | null, instrument?: { __typename?: 'ShopifyCreditCard', branch?: string | null, expiresSoon?: boolean | null, expiryMonth?: string | null, expiryYear?: string | null, firstDigits?: string | null, lastDigits?: string | null, name?: string | null, source?: string | null } | null } | null, discounts?: { __typename?: 'ShopifyDiscountsEdge', edges?: Array<{ __typename?: 'ShopifyDisountNode', node?: { __typename?: 'ShopifyContractDiscount', id?: string | null, targetType?: string | null, title?: string | null, type?: string | null, usageCount?: number | null, recurringCycleLimit?: number | null, value?: { __typename?: 'AmountOrPercentage', percentage?: number | null, amount?: { __typename?: 'AmountAmount', amount?: number | null } | null } | null } | null }> | null } | null, lines?: { __typename?: 'ShopifyLineEdge', edges?: Array<{ __typename?: 'ShopifyLineNode', node?: { __typename?: 'ShopifyLine', sku?: string | null, title?: string | null, quantity?: number | null, lineDiscountedPrice?: { __typename?: 'ShopifyAmount', amount?: number | null } | null, currentPrice?: { __typename?: 'ShopifyAmount', amount?: number | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } | null, discountAllocations?: Array<{ __typename?: 'ShopifyDiscountAllocation', discount?: { __typename?: 'ShopifyLineItemDiscount', title?: string | null } | null }> | null } | null }> | null } | null, deliveryMethod?: { __typename?: 'ShopifyDeliveryMethod', address?: { __typename?: 'ShopifyAddress', address1?: string | null, address2?: string | null, city?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, zip?: string | null } | null } | null, billingAttempts?: { __typename?: 'ShopifyBillingAttemptsEdge', edges?: Array<{ __typename?: 'ShopifyBillingAttemptNode', node?: { __typename?: 'ShopifyBillingAttempt', id?: string | null, createdAt?: string | null, completedAt?: string | null, processingError?: { __typename?: 'ShopifyBillingAttemptError', code?: string | null, message?: string | null } | null } | null }> | null } | null } | null, shippingAddress?: { __typename?: 'Address', address?: string | null, aptNo?: string | null, city?: string | null, createdAt?: any | null, name?: string | null, note?: string | null, phoneNumber?: string | null, stateAbbr?: string | null, updatedAt?: any | null, zipCode?: string | null, normalizedZipCode?: string | null } | null, planSettings?: { __typename?: 'PlanSettings', chosenNewPlan?: Array<string> | null, recommendedNewNextPlan?: Array<string> | null, recommendedNewCurrentPlan?: Array<string> | null, nextPlanAfterQuestionnaire?: Array<string> | null, currentPlanAfterQuestionnaire?: Array<string> | null, nextPlanFrequencyCustomizable?: boolean | null, currentPlanFrequencyCustomizable?: boolean | null } | null, addonsCoupon?: { __typename?: 'Coupon', id: string } | null, addons?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', shopifyId?: string | null } | null }> | null, entrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', shopifyId?: string | null } | null }> | null, freshBakedEntrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', shopifyId?: string | null } | null }> | null, freshCookedEntrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', shopifyId?: string | null } | null }> | null, currentPlan?: { __typename?: 'BoxVariant', activeFrom?: any | null, activeUntil?: any | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, sellingPlanId?: string | null, shopifyId?: string | null, price?: number | null, sku?: string | null, box?: { __typename?: 'Box', id: string, itemQuantity: number, name: string, sku?: string | null } | null } | null, previousPlan?: { __typename?: 'BoxVariant', id: string } | null, upcomingOrder?: { __typename?: 'DbOrder', estimatedShippingDate?: any | null, estimatedDeliveryDate?: any | null, shippingAddress?: any | null, invoicePreview?: { __typename?: 'ShopifyOrderInvoicePreview', subtotalCost: number, credit?: number | null, totalCost: number, discounts?: Array<{ __typename?: 'ShopifyOrderInvoiceDiscounts', code: string, maskedCode?: string | null, applicationType: TypesSubscriptionShopifyCouponApplicationType, amountOff?: number | null, percentageOff?: number | null, amount?: number | null }> | null } | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', addressData?: any | null, addressStateAbbr?: string | null, addressZipCode?: string | null, carrierCode?: string | null, carrierService?: string | null, createdAt: any, data?: any | null, daysInTransit?: number | null, email?: string | null, id: string, index: number, lineItemsData?: any | null, orderStatus?: string | null, planFrequency?: number | null, renewals?: number | null, routeCode?: string | null, scheduledShippingDate?: any | null, shipmentNumber?: string | null, shippedAt?: any | null, state?: TypesShipmentEntryStateEnumType | null, subscriptionStatus?: string | null, trackingNumber?: string | null, trackingStatus?: string | null, transitRegionCode?: string | null, updatedAt: any, warehouseCode?: string | null, payment?: { __typename?: 'PpPayment', id: string } | null, pet?: { __typename?: 'Pet', id: string } | null, boxVariant?: { __typename?: 'BoxVariant', id: string } | null, shipmentList?: { __typename?: 'ShipmentList', id: string } | null }> | null, nextPlan?: { __typename?: 'BoxVariant', activeFrom?: any | null, activeUntil?: any | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, sellingPlanId?: string | null, shopifyId?: string | null, price?: number | null, sku?: string | null, box?: { __typename?: 'Box', id: string, itemQuantity: number, name: string, sku?: string | null } | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, state?: string | null, id: string, lowercaseMetadata?: { __typename?: 'PaymentMetadata', company?: string | null, wallet?: PaymentWallet | null, paypalEmail?: string | null } | null } | null, pet?: { __typename?: 'Pet', activityLevel?: PetActivityLevels | null, ageGroup?: string | null, birthDate?: any | null, breedType: string, calculatedCaloriesPerDay?: number | null, completedBirthDate?: boolean | null, createdAt: any, gender?: string | null, hasFoodSensitivities?: boolean | null, hasWellnessGoals?: boolean | null, ingredientIds?: Array<string> | null, wellnessGoalIds?: Array<string> | null, id: string, waistline?: string | null, petName?: string | null, primaryBreedId?: number | null, restingEnergyRate?: number | null, secondaryBreedId?: number | null, servingSizeInOunces?: number | null, spayedNeutered?: boolean | null, updatedAt: any, weight?: number | null, primaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, secondaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, ingredients?: Array<{ __typename?: 'Ingredient', name: string }> | null, mealLineItems?: Array<{ __typename?: 'MealLineItem', meal?: { __typename?: 'Meal', name?: string | null } | null }> | null, recommendationWizard?: { __typename?: 'RecommendationWizard', id: string, weight?: number | null, recommendedRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedComboRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedAddons?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null } | null, wellnessGoals?: Array<{ __typename?: 'WellnessGoal', name: string }> | null, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, totalCreditAmount?: number | null, tagListView?: Array<UserTag> | null, klaviyoUrl?: string | null, zendeskUrl?: string | null, completedSetup?: boolean | null } | null, payments: Array<{ __typename?: 'PpPayment', amount: number, assessedTaxes: number, price?: number | null, boxVariant?: { __typename?: 'BoxVariant', id: string } | null, paymentAdjustments: Array<{ __typename?: 'PaymentAdjustment', amount: number, createdAt: any, sourceId?: number | null, sourceType?: string | null }> }>, v2Orders: Array<{ __typename?: 'DbOrder', id?: number | null, couponsData?: any | null, lastChargeSuccessful?: boolean | null, orderNumber?: string | null, attributionChannel?: string | null, estimatedShippingDate?: any | null, shippingAddress?: any | null, charges: Array<{ __typename?: 'PpPayment', state?: PaymentState | null, amount: number, chargedAt?: any | null }>, shipments: Array<{ __typename?: 'V2Shipment', createdAt: any }> }>, recommendationWizard: { __typename?: 'RecommendationWizard', planRecommendations?: { __typename?: 'PlanRecommendation', boxes: { __typename?: 'RecommendationBoxes', comboBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null, freshBakedBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null, fullBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null, spaceSaverBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null, topperBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null } } | null } } };

export type AdminSubscriptionViaShopifyIdQueryVariables = Exact<{
  shopifyId: Scalars['String'];
}>;


export type AdminSubscriptionViaShopifyIdQuery = { __typename?: 'Query', subscriptions: { __typename?: 'SubscriptionConnection', nodes?: Array<{ __typename?: 'Subscription', apiSubscriptionId?: string | null, attributions?: any | null, cancelAtPeriodEnd?: boolean | null, canceledAt?: any | null, completedAt?: any | null, createdAt?: any | null, currentPlanFrequency?: number | null, data?: any | null, dishesCount?: number | null, renewals?: number | null, email?: string | null, hiddenAt?: any | null, id: string, ignoreNewPlanRecommendationsAt?: any | null, lastShippedAt?: any | null, lineItemsData: any, manuallyScheduledShipments?: string | null, newPlan?: boolean | null, nextPlanFrequency?: number | null, nextScheduledShippingDate?: any | null, number?: string | null, paymentTotal?: number | null, scheduledShippingDate?: any | null, state?: SubscriptionStateEnum | null, statementTotal?: number | null, total?: number | null, updatedAt?: any | null, estimatedDeliveryDate?: any | null, estimatedNextDeliveryDates?: Array<any> | null, estimatedNextShippingDates?: Array<any> | null, stripeUrl?: string | null, cancellationSurvey?: { __typename?: 'CancellationSurvey', cancellationReasonId?: number | null, cancellationReasonOther?: string | null, cancellationReasonOtherMoreDetails?: string | null, cancellationReasonTerm?: { __typename?: 'Term', id: string, description?: string | null } | null } | null, routeSchedule?: { __typename?: 'RouteSchedule', warehouseCode?: string | null, warehouseName?: string | null, carrierCode?: string | null, deliveryDays?: number | null, includeDryIce: boolean, routeCode: TypesRouteScheduleTypeRouteCode, transitRegionCode?: string | null, shippingStartDate: any, scheduleStartDate: any } | null, coupons?: Array<{ __typename?: 'SubscriptionShopifyCoupon', code: string, maskedCode?: string | null, applicationType: TypesSubscriptionShopifyCouponApplicationType, amountOff?: number | null, percentageOff?: number | null, usageCycleLimit?: number | null, limited: boolean, usageCount: number, oncePerCustomer: boolean, appliesToAllItems: boolean }> | null, remoteContract?: { __typename?: 'RemoteContract', id?: string | null, status?: string | null, appAdminUrl?: string | null, customer?: { __typename?: 'ShopifyContractCustomer', email?: string | null, firstName?: string | null, id?: string | null, lastName?: string | null, productSubscriberStatus?: string | null, state?: string | null, validEmailAddress?: boolean | null, verifiedEmail?: boolean | null } | null, customerPaymentMethod?: { __typename?: 'ShopifyCustomerPaymentMethod', id?: string | null, revokedAt?: string | null, revokedReason?: string | null, instrument?: { __typename?: 'ShopifyCreditCard', branch?: string | null, expiresSoon?: boolean | null, expiryMonth?: string | null, expiryYear?: string | null, firstDigits?: string | null, lastDigits?: string | null, name?: string | null, source?: string | null } | null } | null, discounts?: { __typename?: 'ShopifyDiscountsEdge', edges?: Array<{ __typename?: 'ShopifyDisountNode', node?: { __typename?: 'ShopifyContractDiscount', id?: string | null, targetType?: string | null, title?: string | null, type?: string | null, usageCount?: number | null, recurringCycleLimit?: number | null, value?: { __typename?: 'AmountOrPercentage', percentage?: number | null, amount?: { __typename?: 'AmountAmount', amount?: number | null } | null } | null } | null }> | null } | null, lines?: { __typename?: 'ShopifyLineEdge', edges?: Array<{ __typename?: 'ShopifyLineNode', node?: { __typename?: 'ShopifyLine', sku?: string | null, title?: string | null, quantity?: number | null, lineDiscountedPrice?: { __typename?: 'ShopifyAmount', amount?: number | null } | null, currentPrice?: { __typename?: 'ShopifyAmount', amount?: number | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } | null, discountAllocations?: Array<{ __typename?: 'ShopifyDiscountAllocation', discount?: { __typename?: 'ShopifyLineItemDiscount', title?: string | null } | null }> | null } | null }> | null } | null, deliveryMethod?: { __typename?: 'ShopifyDeliveryMethod', address?: { __typename?: 'ShopifyAddress', address1?: string | null, address2?: string | null, city?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, zip?: string | null } | null } | null, billingAttempts?: { __typename?: 'ShopifyBillingAttemptsEdge', edges?: Array<{ __typename?: 'ShopifyBillingAttemptNode', node?: { __typename?: 'ShopifyBillingAttempt', id?: string | null, createdAt?: string | null, completedAt?: string | null, processingError?: { __typename?: 'ShopifyBillingAttemptError', code?: string | null, message?: string | null } | null } | null }> | null } | null } | null, shippingAddress?: { __typename?: 'Address', address?: string | null, aptNo?: string | null, city?: string | null, createdAt?: any | null, name?: string | null, note?: string | null, phoneNumber?: string | null, stateAbbr?: string | null, updatedAt?: any | null, zipCode?: string | null, normalizedZipCode?: string | null } | null, planSettings?: { __typename?: 'PlanSettings', chosenNewPlan?: Array<string> | null, recommendedNewNextPlan?: Array<string> | null, recommendedNewCurrentPlan?: Array<string> | null, nextPlanAfterQuestionnaire?: Array<string> | null, currentPlanAfterQuestionnaire?: Array<string> | null, nextPlanFrequencyCustomizable?: boolean | null, currentPlanFrequencyCustomizable?: boolean | null } | null, addonsCoupon?: { __typename?: 'Coupon', id: string } | null, addons?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', shopifyId?: string | null } | null }> | null, entrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', shopifyId?: string | null } | null }> | null, freshBakedEntrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', shopifyId?: string | null } | null }> | null, freshCookedEntrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', shopifyId?: string | null } | null }> | null, currentPlan?: { __typename?: 'BoxVariant', activeFrom?: any | null, activeUntil?: any | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, sellingPlanId?: string | null, shopifyId?: string | null, price?: number | null, sku?: string | null, box?: { __typename?: 'Box', id: string, itemQuantity: number, name: string, sku?: string | null } | null } | null, previousPlan?: { __typename?: 'BoxVariant', id: string } | null, upcomingOrder?: { __typename?: 'DbOrder', estimatedShippingDate?: any | null, estimatedDeliveryDate?: any | null, shippingAddress?: any | null, invoicePreview?: { __typename?: 'ShopifyOrderInvoicePreview', subtotalCost: number, credit?: number | null, totalCost: number, discounts?: Array<{ __typename?: 'ShopifyOrderInvoiceDiscounts', code: string, maskedCode?: string | null, applicationType: TypesSubscriptionShopifyCouponApplicationType, amountOff?: number | null, percentageOff?: number | null, amount?: number | null }> | null } | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', addressData?: any | null, addressStateAbbr?: string | null, addressZipCode?: string | null, carrierCode?: string | null, carrierService?: string | null, createdAt: any, data?: any | null, daysInTransit?: number | null, email?: string | null, id: string, index: number, lineItemsData?: any | null, orderStatus?: string | null, planFrequency?: number | null, renewals?: number | null, routeCode?: string | null, scheduledShippingDate?: any | null, shipmentNumber?: string | null, shippedAt?: any | null, state?: TypesShipmentEntryStateEnumType | null, subscriptionStatus?: string | null, trackingNumber?: string | null, trackingStatus?: string | null, transitRegionCode?: string | null, updatedAt: any, warehouseCode?: string | null, payment?: { __typename?: 'PpPayment', id: string } | null, pet?: { __typename?: 'Pet', id: string } | null, boxVariant?: { __typename?: 'BoxVariant', id: string } | null, shipmentList?: { __typename?: 'ShipmentList', id: string } | null }> | null, nextPlan?: { __typename?: 'BoxVariant', activeFrom?: any | null, activeUntil?: any | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, sellingPlanId?: string | null, shopifyId?: string | null, price?: number | null, sku?: string | null, box?: { __typename?: 'Box', id: string, itemQuantity: number, name: string, sku?: string | null } | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, state?: string | null, id: string, lowercaseMetadata?: { __typename?: 'PaymentMetadata', company?: string | null, wallet?: PaymentWallet | null, paypalEmail?: string | null } | null } | null, pet?: { __typename?: 'Pet', activityLevel?: PetActivityLevels | null, ageGroup?: string | null, birthDate?: any | null, breedType: string, calculatedCaloriesPerDay?: number | null, completedBirthDate?: boolean | null, createdAt: any, gender?: string | null, hasFoodSensitivities?: boolean | null, hasWellnessGoals?: boolean | null, ingredientIds?: Array<string> | null, wellnessGoalIds?: Array<string> | null, id: string, waistline?: string | null, petName?: string | null, primaryBreedId?: number | null, restingEnergyRate?: number | null, secondaryBreedId?: number | null, servingSizeInOunces?: number | null, spayedNeutered?: boolean | null, updatedAt: any, weight?: number | null, primaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, secondaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, ingredients?: Array<{ __typename?: 'Ingredient', name: string }> | null, mealLineItems?: Array<{ __typename?: 'MealLineItem', meal?: { __typename?: 'Meal', name?: string | null } | null }> | null, recommendationWizard?: { __typename?: 'RecommendationWizard', id: string, weight?: number | null, recommendedRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedComboRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedAddons?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null } | null, wellnessGoals?: Array<{ __typename?: 'WellnessGoal', name: string }> | null, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, totalCreditAmount?: number | null, tagListView?: Array<UserTag> | null, klaviyoUrl?: string | null, zendeskUrl?: string | null, completedSetup?: boolean | null } | null, payments: Array<{ __typename?: 'PpPayment', amount: number, assessedTaxes: number, price?: number | null, boxVariant?: { __typename?: 'BoxVariant', id: string } | null, paymentAdjustments: Array<{ __typename?: 'PaymentAdjustment', amount: number, createdAt: any, sourceId?: number | null, sourceType?: string | null }> }>, v2Orders: Array<{ __typename?: 'DbOrder', id?: number | null, couponsData?: any | null, lastChargeSuccessful?: boolean | null, orderNumber?: string | null, attributionChannel?: string | null, estimatedShippingDate?: any | null, shippingAddress?: any | null, charges: Array<{ __typename?: 'PpPayment', state?: PaymentState | null, amount: number, chargedAt?: any | null }>, shipments: Array<{ __typename?: 'V2Shipment', createdAt: any }> }>, recommendationWizard: { __typename?: 'RecommendationWizard', planRecommendations?: { __typename?: 'PlanRecommendation', boxes: { __typename?: 'RecommendationBoxes', comboBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null, freshBakedBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null, fullBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null, spaceSaverBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null, topperBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null } } | null } } | null> | null } };

export type AdminSubscriptionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  canceledAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  userId?: InputMaybe<Scalars['ID']>;
  canceledAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  completedAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  completedAtTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResolversSubscriptionsResolverOrder>;
  renewals?: InputMaybe<Scalars['Int']>;
  scheduledShippingDateFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  opsState?: InputMaybe<ResolversSubscriptionsResolverOpsState>;
  scheduledShippingDateTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  status?: InputMaybe<TypesSubscriptionInputTypeState>;
  number?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  scheduledShippingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  planType?: InputMaybe<BoxVariantPlanTypeEnum>;
}>;


export type AdminSubscriptionsQuery = { __typename?: 'Query', subscriptions: { __typename?: 'SubscriptionConnection', nodes?: Array<{ __typename?: 'Subscription', id: string, currentPlanSku?: string | null, upgradePlanSku?: string | null, currentPlanCost?: number | null, upgradePlanCost?: number | null, currentAddonCost?: number | null, upgradeAddonCost?: number | null, currentPlanWithAddonCost?: number | null, upgradePlanWithAddonCost?: number | null, currentCostPerDay?: number | null, upgradeCostPerDay?: number | null, createdAt?: any | null, renewals?: number | null, number?: string | null, state?: SubscriptionStateEnum | null, scheduledShippingDate?: any | null, statementTotal?: number | null, v2Orders: Array<{ __typename?: 'DbOrder', couponsData?: any | null }>, pet?: { __typename?: 'Pet', id: string, petName?: string | null, gender?: string | null } | null, currentPlan?: { __typename?: 'BoxVariant', sku?: string | null, id: string } | null, previousPlan?: { __typename?: 'BoxVariant', id: string, sku?: string | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminSubscriptionCreateMutationVariables = Exact<{
  input: SubscriptionCreateInput;
}>;


export type AdminSubscriptionCreateMutation = { __typename?: 'Mutation', subscriptionCreate?: { __typename?: 'SubscriptionCreatePayload', subscription: { __typename?: 'Subscription', id: string } } | null };

export type AdminSubscriptionUpdateMutationVariables = Exact<{
  input: SubscriptionUpdateInput;
}>;


export type AdminSubscriptionUpdateMutation = { __typename?: 'Mutation', subscriptionUpdate?: { __typename?: 'SubscriptionUpdatePayload', subscription: { __typename?: 'Subscription', id: string } } | null };

export type AdminSubscriptionProductItemAttrsFragment = { __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', shopifyId?: string | null } | null };

export type SubscriptionPropsFragment = { __typename?: 'Subscription', apiSubscriptionId?: string | null, attributions?: any | null, cancelAtPeriodEnd?: boolean | null, canceledAt?: any | null, completedAt?: any | null, createdAt?: any | null, currentPlanFrequency?: number | null, data?: any | null, dishesCount?: number | null, renewals?: number | null, email?: string | null, hiddenAt?: any | null, id: string, ignoreNewPlanRecommendationsAt?: any | null, lastShippedAt?: any | null, lineItemsData: any, manuallyScheduledShipments?: string | null, newPlan?: boolean | null, nextPlanFrequency?: number | null, nextScheduledShippingDate?: any | null, number?: string | null, paymentTotal?: number | null, scheduledShippingDate?: any | null, state?: SubscriptionStateEnum | null, statementTotal?: number | null, total?: number | null, updatedAt?: any | null, estimatedDeliveryDate?: any | null, estimatedNextDeliveryDates?: Array<any> | null, estimatedNextShippingDates?: Array<any> | null, stripeUrl?: string | null, cancellationSurvey?: { __typename?: 'CancellationSurvey', cancellationReasonId?: number | null, cancellationReasonOther?: string | null, cancellationReasonOtherMoreDetails?: string | null, cancellationReasonTerm?: { __typename?: 'Term', id: string, description?: string | null } | null } | null, routeSchedule?: { __typename?: 'RouteSchedule', warehouseCode?: string | null, warehouseName?: string | null, carrierCode?: string | null, deliveryDays?: number | null, includeDryIce: boolean, routeCode: TypesRouteScheduleTypeRouteCode, transitRegionCode?: string | null, shippingStartDate: any, scheduleStartDate: any } | null, coupons?: Array<{ __typename?: 'SubscriptionShopifyCoupon', code: string, maskedCode?: string | null, applicationType: TypesSubscriptionShopifyCouponApplicationType, amountOff?: number | null, percentageOff?: number | null, usageCycleLimit?: number | null, limited: boolean, usageCount: number, oncePerCustomer: boolean, appliesToAllItems: boolean }> | null, remoteContract?: { __typename?: 'RemoteContract', id?: string | null, status?: string | null, appAdminUrl?: string | null, customer?: { __typename?: 'ShopifyContractCustomer', email?: string | null, firstName?: string | null, id?: string | null, lastName?: string | null, productSubscriberStatus?: string | null, state?: string | null, validEmailAddress?: boolean | null, verifiedEmail?: boolean | null } | null, customerPaymentMethod?: { __typename?: 'ShopifyCustomerPaymentMethod', id?: string | null, revokedAt?: string | null, revokedReason?: string | null, instrument?: { __typename?: 'ShopifyCreditCard', branch?: string | null, expiresSoon?: boolean | null, expiryMonth?: string | null, expiryYear?: string | null, firstDigits?: string | null, lastDigits?: string | null, name?: string | null, source?: string | null } | null } | null, discounts?: { __typename?: 'ShopifyDiscountsEdge', edges?: Array<{ __typename?: 'ShopifyDisountNode', node?: { __typename?: 'ShopifyContractDiscount', id?: string | null, targetType?: string | null, title?: string | null, type?: string | null, usageCount?: number | null, recurringCycleLimit?: number | null, value?: { __typename?: 'AmountOrPercentage', percentage?: number | null, amount?: { __typename?: 'AmountAmount', amount?: number | null } | null } | null } | null }> | null } | null, lines?: { __typename?: 'ShopifyLineEdge', edges?: Array<{ __typename?: 'ShopifyLineNode', node?: { __typename?: 'ShopifyLine', sku?: string | null, title?: string | null, quantity?: number | null, lineDiscountedPrice?: { __typename?: 'ShopifyAmount', amount?: number | null } | null, currentPrice?: { __typename?: 'ShopifyAmount', amount?: number | null } | null, boxVariant?: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } | null, discountAllocations?: Array<{ __typename?: 'ShopifyDiscountAllocation', discount?: { __typename?: 'ShopifyLineItemDiscount', title?: string | null } | null }> | null } | null }> | null } | null, deliveryMethod?: { __typename?: 'ShopifyDeliveryMethod', address?: { __typename?: 'ShopifyAddress', address1?: string | null, address2?: string | null, city?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, zip?: string | null } | null } | null, billingAttempts?: { __typename?: 'ShopifyBillingAttemptsEdge', edges?: Array<{ __typename?: 'ShopifyBillingAttemptNode', node?: { __typename?: 'ShopifyBillingAttempt', id?: string | null, createdAt?: string | null, completedAt?: string | null, processingError?: { __typename?: 'ShopifyBillingAttemptError', code?: string | null, message?: string | null } | null } | null }> | null } | null } | null, shippingAddress?: { __typename?: 'Address', address?: string | null, aptNo?: string | null, city?: string | null, createdAt?: any | null, name?: string | null, note?: string | null, phoneNumber?: string | null, stateAbbr?: string | null, updatedAt?: any | null, zipCode?: string | null, normalizedZipCode?: string | null } | null, planSettings?: { __typename?: 'PlanSettings', chosenNewPlan?: Array<string> | null, recommendedNewNextPlan?: Array<string> | null, recommendedNewCurrentPlan?: Array<string> | null, nextPlanAfterQuestionnaire?: Array<string> | null, currentPlanAfterQuestionnaire?: Array<string> | null, nextPlanFrequencyCustomizable?: boolean | null, currentPlanFrequencyCustomizable?: boolean | null } | null, addonsCoupon?: { __typename?: 'Coupon', id: string } | null, addons?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', shopifyId?: string | null } | null }> | null, entrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', shopifyId?: string | null } | null }> | null, freshBakedEntrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', shopifyId?: string | null } | null }> | null, freshCookedEntrees?: Array<{ __typename?: 'PlanLineItem', sku?: string | null, quantity?: number | null, category?: PlanLineItemCategoryEnum | null, product?: { __typename?: 'PlanLineItemProduct', shopifyId?: string | null } | null }> | null, currentPlan?: { __typename?: 'BoxVariant', activeFrom?: any | null, activeUntil?: any | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, sellingPlanId?: string | null, shopifyId?: string | null, price?: number | null, sku?: string | null, box?: { __typename?: 'Box', id: string, itemQuantity: number, name: string, sku?: string | null } | null } | null, previousPlan?: { __typename?: 'BoxVariant', id: string } | null, upcomingOrder?: { __typename?: 'DbOrder', estimatedShippingDate?: any | null, estimatedDeliveryDate?: any | null, shippingAddress?: any | null, invoicePreview?: { __typename?: 'ShopifyOrderInvoicePreview', subtotalCost: number, credit?: number | null, totalCost: number, discounts?: Array<{ __typename?: 'ShopifyOrderInvoiceDiscounts', code: string, maskedCode?: string | null, applicationType: TypesSubscriptionShopifyCouponApplicationType, amountOff?: number | null, percentageOff?: number | null, amount?: number | null }> | null } | null } | null, shipments?: Array<{ __typename?: 'ShipmentEntry', addressData?: any | null, addressStateAbbr?: string | null, addressZipCode?: string | null, carrierCode?: string | null, carrierService?: string | null, createdAt: any, data?: any | null, daysInTransit?: number | null, email?: string | null, id: string, index: number, lineItemsData?: any | null, orderStatus?: string | null, planFrequency?: number | null, renewals?: number | null, routeCode?: string | null, scheduledShippingDate?: any | null, shipmentNumber?: string | null, shippedAt?: any | null, state?: TypesShipmentEntryStateEnumType | null, subscriptionStatus?: string | null, trackingNumber?: string | null, trackingStatus?: string | null, transitRegionCode?: string | null, updatedAt: any, warehouseCode?: string | null, payment?: { __typename?: 'PpPayment', id: string } | null, pet?: { __typename?: 'Pet', id: string } | null, boxVariant?: { __typename?: 'BoxVariant', id: string } | null, shipmentList?: { __typename?: 'ShipmentList', id: string } | null }> | null, nextPlan?: { __typename?: 'BoxVariant', activeFrom?: any | null, activeUntil?: any | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, sellingPlanId?: string | null, shopifyId?: string | null, price?: number | null, sku?: string | null, box?: { __typename?: 'Box', id: string, itemQuantity: number, name: string, sku?: string | null } | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, state?: string | null, id: string, lowercaseMetadata?: { __typename?: 'PaymentMetadata', company?: string | null, wallet?: PaymentWallet | null, paypalEmail?: string | null } | null } | null, pet?: { __typename?: 'Pet', activityLevel?: PetActivityLevels | null, ageGroup?: string | null, birthDate?: any | null, breedType: string, calculatedCaloriesPerDay?: number | null, completedBirthDate?: boolean | null, createdAt: any, gender?: string | null, hasFoodSensitivities?: boolean | null, hasWellnessGoals?: boolean | null, ingredientIds?: Array<string> | null, wellnessGoalIds?: Array<string> | null, id: string, waistline?: string | null, petName?: string | null, primaryBreedId?: number | null, restingEnergyRate?: number | null, secondaryBreedId?: number | null, servingSizeInOunces?: number | null, spayedNeutered?: boolean | null, updatedAt: any, weight?: number | null, primaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, secondaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, ingredients?: Array<{ __typename?: 'Ingredient', name: string }> | null, mealLineItems?: Array<{ __typename?: 'MealLineItem', meal?: { __typename?: 'Meal', name?: string | null } | null }> | null, recommendationWizard?: { __typename?: 'RecommendationWizard', id: string, weight?: number | null, recommendedRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedComboRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedAddons?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null } | null, wellnessGoals?: Array<{ __typename?: 'WellnessGoal', name: string }> | null, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null } | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, totalCreditAmount?: number | null, tagListView?: Array<UserTag> | null, klaviyoUrl?: string | null, zendeskUrl?: string | null, completedSetup?: boolean | null } | null, payments: Array<{ __typename?: 'PpPayment', amount: number, assessedTaxes: number, price?: number | null, boxVariant?: { __typename?: 'BoxVariant', id: string } | null, paymentAdjustments: Array<{ __typename?: 'PaymentAdjustment', amount: number, createdAt: any, sourceId?: number | null, sourceType?: string | null }> }>, v2Orders: Array<{ __typename?: 'DbOrder', id?: number | null, couponsData?: any | null, lastChargeSuccessful?: boolean | null, orderNumber?: string | null, attributionChannel?: string | null, estimatedShippingDate?: any | null, shippingAddress?: any | null, charges: Array<{ __typename?: 'PpPayment', state?: PaymentState | null, amount: number, chargedAt?: any | null }>, shipments: Array<{ __typename?: 'V2Shipment', createdAt: any }> }>, recommendationWizard: { __typename?: 'RecommendationWizard', planRecommendations?: { __typename?: 'PlanRecommendation', boxes: { __typename?: 'RecommendationBoxes', comboBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null, freshBakedBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null, fullBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null, spaceSaverBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null, topperBox?: { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } } | null } } | null } };

export type AdminPetBoxFragment = { __typename?: 'PetBox', boxVariant: { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null } };

export type AdminBoxVariantPropsFragment = { __typename?: 'BoxVariant', id: string, name: string, sku?: string | null, box?: { __typename?: 'Box', itemQuantity: number, itemWeight?: number | null, bagQuantity?: number | null, bagWeight?: number | null } | null };

export type MealLineItemPropsFragment = { __typename?: 'MealLineItem', id: string, total: number, meal?: { __typename?: 'Meal', name?: string | null, sku?: string | null } | null };

export type SubOrderPropsFragment = { __typename?: 'DbOrder', id?: number | null, estimatedShippingDate?: any | null, estimatedDeliveryDate?: any | null, humanizedState?: OrderHumanizedState | null, lineItemsData?: any | null, orderNumber?: string | null, shippingAddress?: any | null, shopifyId?: string | null, couponsData?: any | null, renewal?: boolean | null, state?: OrderState | null, lastChargeSuccessful?: boolean | null, statement?: { __typename?: 'OrderStatement', couponCodes?: Array<string> | null } | null, shipments: Array<{ __typename?: 'V2Shipment', shipmentEntry?: { __typename?: 'ShipmentEntry', addressData?: any | null, addressStateAbbr?: string | null, addressZipCode?: string | null, carrierCode?: string | null, carrierService?: string | null, createdAt: any, data?: any | null, daysInTransit?: number | null, email?: string | null, id: string, index: number, lineItemsData?: any | null, orderStatus?: string | null, planFrequency?: number | null, renewals?: number | null, routeCode?: string | null, scheduledShippingDate?: any | null, shipmentNumber?: string | null, shippedAt?: any | null, state?: TypesShipmentEntryStateEnumType | null, subscriptionStatus?: string | null, trackingNumber?: string | null, trackingStatus?: string | null, transitRegionCode?: string | null, updatedAt: any, warehouseCode?: string | null, payment?: { __typename?: 'PpPayment', id: string } | null, pet?: { __typename?: 'Pet', id: string } | null, boxVariant?: { __typename?: 'BoxVariant', id: string } | null, shipmentList?: { __typename?: 'ShipmentList', id: string } | null } | null }>, charges: Array<{ __typename?: 'PpPayment', amount: number, chargedAt?: any | null }>, customer?: { __typename?: 'User', email?: string | null } | null, taggings?: Array<{ __typename?: 'Tagging', tag?: { __typename?: 'Tag', name?: string | null } | null }> | null };

export type AdminSubShipmentPropsFragment = { __typename?: 'ShipmentEntry', addressData?: any | null, addressStateAbbr?: string | null, addressZipCode?: string | null, carrierCode?: string | null, carrierService?: string | null, createdAt: any, data?: any | null, daysInTransit?: number | null, email?: string | null, id: string, index: number, lineItemsData?: any | null, orderStatus?: string | null, planFrequency?: number | null, renewals?: number | null, routeCode?: string | null, scheduledShippingDate?: any | null, shipmentNumber?: string | null, shippedAt?: any | null, state?: TypesShipmentEntryStateEnumType | null, subscriptionStatus?: string | null, trackingNumber?: string | null, trackingStatus?: string | null, transitRegionCode?: string | null, updatedAt: any, warehouseCode?: string | null, payment?: { __typename?: 'PpPayment', id: string } | null, pet?: { __typename?: 'Pet', id: string } | null, boxVariant?: { __typename?: 'BoxVariant', id: string } | null, shipmentList?: { __typename?: 'ShipmentList', id: string } | null };

export type SubPetPropsFragment = { __typename?: 'Pet', activityLevel?: PetActivityLevels | null, ageGroup?: string | null, birthDate?: any | null, breedType: string, calculatedCaloriesPerDay?: number | null, completedBirthDate?: boolean | null, createdAt: any, gender?: string | null, hasFoodSensitivities?: boolean | null, hasWellnessGoals?: boolean | null, ingredientIds?: Array<string> | null, wellnessGoalIds?: Array<string> | null, id: string, waistline?: string | null, petName?: string | null, primaryBreedId?: number | null, restingEnergyRate?: number | null, secondaryBreedId?: number | null, servingSizeInOunces?: number | null, spayedNeutered?: boolean | null, updatedAt: any, weight?: number | null, primaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, secondaryBreed?: { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null } | null, ingredients?: Array<{ __typename?: 'Ingredient', name: string }> | null, mealLineItems?: Array<{ __typename?: 'MealLineItem', meal?: { __typename?: 'Meal', name?: string | null } | null }> | null, recommendationWizard?: { __typename?: 'RecommendationWizard', id: string, weight?: number | null, recommendedRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedComboRecipes?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null, recommendedAddons?: Array<{ __typename?: 'StorefrontProductListing', sku?: string | null }> | null } | null, wellnessGoals?: Array<{ __typename?: 'WellnessGoal', name: string }> | null, user?: { __typename?: 'User', id?: string | null, email?: string | null } | null };

export type SubPetBreedPropsFragment = { __typename?: 'Breed', id: string, mixedBreed: boolean, name: string, sizeClass?: string | null };

export type SubPaymentPropsFragment = { __typename?: 'PaymentMethod', cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, state?: string | null, id: string, lowercaseMetadata?: { __typename?: 'PaymentMetadata', company?: string | null, wallet?: PaymentWallet | null, paypalEmail?: string | null } | null };

export type SubPlanPropsFragment = { __typename?: 'BoxVariant', activeFrom?: any | null, activeUntil?: any | null, id: string, mealsPerDay: number, name: string, planType?: BoxVariantPlanTypeEnum | null, sellingPlanId?: string | null, shopifyId?: string | null, price?: number | null, sku?: string | null, box?: { __typename?: 'Box', id: string, itemQuantity: number, name: string, sku?: string | null } | null };

export type AdminSubscriptionEditMutationVariables = Exact<{
  input: MutationsSubscriptionEditInput;
}>;


export type AdminSubscriptionEditMutation = { __typename?: 'Mutation', subscriptionEdit?: { __typename?: 'SubscriptionEditPayload', id: number } | null };

export type AdminSudoMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminSudoMutation = { __typename?: 'Mutation', sudo?: { __typename?: 'SudoPayload', authorization?: string | null } | null };

export type AdminLoadCancelSubReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminLoadCancelSubReasonsQuery = { __typename?: 'Query', surveyOptions: { __typename?: 'SurveyOptions', cancelReason: Array<{ __typename?: 'SurveyOption', label: string, value: number }> } };

export type AdminLoadPauseSubReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminLoadPauseSubReasonsQuery = { __typename?: 'Query', surveyOptions: { __typename?: 'SurveyOptions', pauseReason: Array<{ __typename?: 'SurveyOption', label: string, value: number }> } };

export type AdminReplaceOrderReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminReplaceOrderReasonsQuery = { __typename?: 'Query', surveyOptions: { __typename?: 'SurveyOptions', replaceOrderReason: Array<{ __typename?: 'SurveyOption', label: string, value: number }> } };

export type AdminSubscriptionCreateOrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminSubscriptionCreateOrderMutation = { __typename?: 'Mutation', petPlateSubscriptionCreateOrder?: { __typename?: 'PetPlateSubscriptionCreateOrderPayload', dbOrder: { __typename?: 'DbOrder', id?: number | null } } | null };

export type ResendActivationEmailMutationVariables = Exact<{
  input: SendAccountActivationEmailInput;
}>;


export type ResendActivationEmailMutation = { __typename?: 'Mutation', sendAccountActivationEmail?: { __typename?: 'SendAccountActivationEmailPayload', subscription: { __typename?: 'Subscription', id: string } } | null };

export type SyncSubscriptionEntitiesMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SyncSubscriptionEntitiesMutation = { __typename?: 'Mutation', syncSubscriptionEntities?: { __typename?: 'SyncSubscriptionEntitiesPayload', success: boolean } | null };

export type AdminTermQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminTermQuery = { __typename?: 'Query', term: { __typename?: 'Term', active: boolean, additionalCopy?: string | null, createdAt: any, description?: string | null, displayOrder?: number | null, id: string, name?: string | null, systemOnly?: boolean | null, type?: string | null, updatedAt: any } };

export type AdminTermsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversTermsResolverOrder>;
  name?: InputMaybe<Scalars['String']>;
  grouping?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<TypesTermInputTypeType>;
}>;


export type AdminTermsQuery = { __typename?: 'Query', terms: { __typename?: 'TermConnection', nodes?: Array<{ __typename?: 'Term', active: boolean, additionalCopy?: string | null, createdAt: any, description?: string | null, displayOrder?: number | null, id: string, name?: string | null, systemOnly?: boolean | null, type?: string | null, updatedAt: any } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminTermCreateMutationVariables = Exact<{
  input: TermCreateInput;
}>;


export type AdminTermCreateMutation = { __typename?: 'Mutation', termCreate?: { __typename?: 'TermCreatePayload', term: { __typename?: 'Term', active: boolean, additionalCopy?: string | null, createdAt: any, description?: string | null, displayOrder?: number | null, id: string, name?: string | null, systemOnly?: boolean | null, type?: string | null, updatedAt: any } } | null };

export type AdminTermUpdateMutationVariables = Exact<{
  input: TermUpdateInput;
}>;


export type AdminTermUpdateMutation = { __typename?: 'Mutation', termUpdate?: { __typename?: 'TermUpdatePayload', term: { __typename?: 'Term', active: boolean, additionalCopy?: string | null, createdAt: any, description?: string | null, displayOrder?: number | null, id: string, name?: string | null, systemOnly?: boolean | null, type?: string | null, updatedAt: any } } | null };

export type TermPropsFragment = { __typename?: 'Term', active: boolean, additionalCopy?: string | null, createdAt: any, description?: string | null, displayOrder?: number | null, id: string, name?: string | null, systemOnly?: boolean | null, type?: string | null, updatedAt: any };

export type AdminUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type AdminUserQuery = { __typename?: 'Query', user: { __typename?: 'User', acceptsMarketing?: boolean | null, cohorts?: Array<string> | null, currentSignInAt?: any | null, currentSignInIp?: string | null, email?: string | null, id?: string | null, lastSignInAt?: any | null, lastSignInIp?: string | null, loyaltyPoints?: number | null, loyaltyTier?: string | null, name?: string | null, tagListView?: Array<UserTag> | null, nickname?: string | null, phoneNumber?: string | null, referrals?: number | null, shopifyId?: string | null, smsConsent?: boolean | null, klaviyoUrl?: string | null, zendeskUrl?: string | null, roles?: Array<{ __typename?: 'Role', id: string, name: string }> | null, pets?: Array<{ __typename?: 'Pet', id: string, petName?: string | null, primaryBreed?: { __typename?: 'Breed', name: string } | null }> | null, storeCreditAccount?: { __typename?: 'StoreCreditAccount', id: string } | null, shopifyCustomers: Array<{ __typename?: 'ShopifyCustomer', id: string, email: string, shopifyId?: string | null }> } };

export type AdminUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversUsersResolverOrder>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<UserTag>;
}>;


export type AdminUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', nodes?: Array<{ __typename?: 'User', email?: string | null, id?: string | null, name?: string | null, tagListView?: Array<UserTag> | null, phoneNumber?: string | null, shopifyId?: string | null, pets?: Array<{ __typename?: 'Pet', id: string, petName?: string | null, primaryBreed?: { __typename?: 'Breed', name: string } | null }> | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminUserUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  email: Scalars['String'];
  tagList?: InputMaybe<Array<UserTag> | UserTag>;
}>;


export type AdminUserUpdateMutation = { __typename?: 'Mutation', userUpdate?: { __typename?: 'UserUpdatePayload', user: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, tagListView?: Array<UserTag> | null, failedToSyncEmail?: boolean | null } } | null };

export type AdminShopifyCustomerUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  email: Scalars['String'];
}>;


export type AdminShopifyCustomerUpdateMutation = { __typename?: 'Mutation', shopifyCustomerUpdate: { __typename?: 'ShopifyCustomerUpdatePayload', shopifyCustomer: { __typename?: 'ShopifyCustomer', id: string, email: string, shopifyId?: string | null } } };

export type AdminUserPaymentMethodsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type AdminUserPaymentMethodsQuery = { __typename?: 'Query', paymentMethods: { __typename?: 'PaymentMethodConnection', nodes?: Array<{ __typename?: 'PaymentMethod', id: string, createdAt: any, cardLast4?: string | null, cardMonth?: number | null, cardYear?: number | null, lowercaseMetadata?: { __typename?: 'PaymentMetadata', company?: string | null, wallet?: PaymentWallet | null, paypalEmail?: string | null } | null, subscriptions: Array<{ __typename?: 'Subscription', id: string, number?: string | null }> } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminUserPropsFragment = { __typename?: 'User', acceptsMarketing?: boolean | null, cohorts?: Array<string> | null, currentSignInAt?: any | null, currentSignInIp?: string | null, email?: string | null, id?: string | null, lastSignInAt?: any | null, lastSignInIp?: string | null, loyaltyPoints?: number | null, loyaltyTier?: string | null, name?: string | null, tagListView?: Array<UserTag> | null, nickname?: string | null, phoneNumber?: string | null, referrals?: number | null, shopifyId?: string | null, smsConsent?: boolean | null, klaviyoUrl?: string | null, zendeskUrl?: string | null, roles?: Array<{ __typename?: 'Role', id: string, name: string }> | null, pets?: Array<{ __typename?: 'Pet', id: string, petName?: string | null, primaryBreed?: { __typename?: 'Breed', name: string } | null }> | null, storeCreditAccount?: { __typename?: 'StoreCreditAccount', id: string } | null, shopifyCustomers: Array<{ __typename?: 'ShopifyCustomer', id: string, email: string, shopifyId?: string | null }> };

export type AdminShopifyCustPropsFragment = { __typename?: 'ShopifyCustomer', id: string, email: string, shopifyId?: string | null };

export type AdminZipCodeLocationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminZipCodeLocationQuery = { __typename?: 'Query', zipCodeLocation: { __typename?: 'ZipCodeLocation', id: string, zipCode: string, city: string, state: string, latitude: string, longitude: string, createdAt: any, updatedAt: any } };

export type AdminZipCodeLocationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversZipCodeLocationsResolverOrder>;
  zipCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
}>;


export type AdminZipCodeLocationsQuery = { __typename?: 'Query', zipCodeLocations: { __typename?: 'ZipCodeLocationConnection', nodes?: Array<{ __typename?: 'ZipCodeLocation', id: string, zipCode: string, city: string, state: string, latitude: string, longitude: string, createdAt: any, updatedAt: any } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminZipCodeLocationCreateMutationVariables = Exact<{
  input: ZipCodeLocationCreateInput;
}>;


export type AdminZipCodeLocationCreateMutation = { __typename?: 'Mutation', zipCodeLocationCreate?: { __typename?: 'ZipCodeLocationCreatePayload', zipCodeLocation: { __typename?: 'ZipCodeLocation', id: string, zipCode: string, city: string, state: string, latitude: string, longitude: string, createdAt: any, updatedAt: any } } | null };

export type AdminZipCodeLocationUpdateMutationVariables = Exact<{
  input: ZipCodeLocationUpdateInput;
}>;


export type AdminZipCodeLocationUpdateMutation = { __typename?: 'Mutation', zipCodeLocationUpdate?: { __typename?: 'ZipCodeLocationUpdatePayload', zipCodeLocation: { __typename?: 'ZipCodeLocation', id: string, zipCode: string, city: string, state: string, latitude: string, longitude: string, createdAt: any, updatedAt: any } } | null };

export type AdminZipCodeLocationDeleteMutationVariables = Exact<{
  input: ZipCodeLocationDeleteInput;
}>;


export type AdminZipCodeLocationDeleteMutation = { __typename?: 'Mutation', zipCodeLocationDelete?: { __typename?: 'ZipCodeLocationDeletePayload', zipCodeLocation: { __typename?: 'ZipCodeLocation', id: string, zipCode: string, city: string, state: string, latitude: string, longitude: string, createdAt: any, updatedAt: any } } | null };

export type ZipCodeLocationPropsFragment = { __typename?: 'ZipCodeLocation', id: string, zipCode: string, city: string, state: string, latitude: string, longitude: string, createdAt: any, updatedAt: any };

export type AdminZipCodeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminZipCodeQuery = { __typename?: 'Query', zipCode: { __typename?: 'ZipCode', chargeSalesTax: boolean, city?: string | null, createdAt: any, id: string, salesTaxRate: number, state?: string | null, updatedAt: any, zipCode?: string | null } };

export type AdminZipCodesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<ResolversZipCodesResolverOrder>;
  zipCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  salesTaxRate?: InputMaybe<Scalars['Float']>;
}>;


export type AdminZipCodesQuery = { __typename?: 'Query', zipCodes: { __typename?: 'ZipCodeConnection', nodes?: Array<{ __typename?: 'ZipCode', chargeSalesTax: boolean, city?: string | null, createdAt: any, id: string, salesTaxRate: number, state?: string | null, updatedAt: any, zipCode?: string | null } | null> | null, pageInfo: { __typename?: 'PPPageInfo', currentPage: number, totalPages: number } } };

export type AdminZipCodeCreateMutationVariables = Exact<{
  input: ZipCodeCreateInput;
}>;


export type AdminZipCodeCreateMutation = { __typename?: 'Mutation', zipCodeCreate?: { __typename?: 'ZipCodeCreatePayload', zipCode: { __typename?: 'ZipCode', chargeSalesTax: boolean, city?: string | null, createdAt: any, id: string, salesTaxRate: number, state?: string | null, updatedAt: any, zipCode?: string | null } } | null };

export type AdminZipCodeUpdateMutationVariables = Exact<{
  input: ZipCodeUpdateInput;
}>;


export type AdminZipCodeUpdateMutation = { __typename?: 'Mutation', zipCodeUpdate?: { __typename?: 'ZipCodeUpdatePayload', zipCode: { __typename?: 'ZipCode', chargeSalesTax: boolean, city?: string | null, createdAt: any, id: string, salesTaxRate: number, state?: string | null, updatedAt: any, zipCode?: string | null } } | null };

export type ZipCodePropsFragment = { __typename?: 'ZipCode', chargeSalesTax: boolean, city?: string | null, createdAt: any, id: string, salesTaxRate: number, state?: string | null, updatedAt: any, zipCode?: string | null };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', me: { __typename?: 'User', uid?: string | null, id?: string | null, name?: string | null, hasActiveSubs?: boolean | null } };

export type RecentInstagramPostsQueryVariables = Exact<{
  max: Scalars['Int'];
}>;


export type RecentInstagramPostsQuery = { __typename?: 'Query', instagramPosts: Array<{ __typename?: 'InstagramPost', id: string, permalink: string, caption?: string | null, mediaUrl?: string | null }> };

export type FindUserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type FindUserByEmailQuery = { __typename?: 'Query', user: { __typename?: 'User', email?: string | null } };

export const RecWizardAttrsFragmentDoc = gql`
    fragment RecWizardAttrs on RecommendationWizard {
  id
  petName
  petId
  userId
  activityLevel
  attributions
  birthDate
  breedType
  contactEmail
  contactName
  contactPhoneNumber
  couponsData
  weight
  gender
  spayedNeutered
  primaryBreedId
  secondaryBreedId
  waistline
  wellnessGoalIds
  ingredientIds
  hasFoodSensitivities
  preferenceIds
  recipeIds
  recipeSkus
  planId
  planType
  latestStep
  lineItemsData {
    quantity
    shopifyId
    sku
    discount
    price
    recurring
    type
  }
  recommendedRecipeLineItems {
    sku
    shopifyId
    quantity
  }
  recommendedCaloriesPerDay
  subscriptionId
  guestToken
  shopifyId
  plan {
    sku
    name
    planType
    addonUnits
    box {
      bagQuantity
      itemQuantity
    }
  }
  selectedBreedOptions {
    label
    value
  }
  selectedWellnessGoalOptions {
    label
    value
  }
  selectedRecipeOptions {
    label
    value
  }
}
    `;
export const RecommendedBoxFragmentDoc = gql`
    fragment RecommendedBox on PetBox {
  addons {
    nodes {
      id
      name
      slug
      sku
      category
      outOfStock
      outOfStockMessage
      description
      priceCategory
      shopifyId
      price
      metadata
      shopifyId
      recipe {
        id
      }
    }
  }
  recommendationScore
  shopifyLineItems {
    quantity
    shopifyId
    sku
    category
  }
  boxVariant {
    id
    price
    sku
    addonUnits
    mealsPerDay
    calorieGroup
    defaultFrequency
    sellingPlanId
    shopifyId
    parentShopifyId
    planType
    recommended
    feedingGuideline {
      calorieGroup
      planType
      dailyIntake
      frozenPortion
      frozenMeasure
      frozenWeight
      frozenWeightMeasure
      dryPortion
      dryMeasure
    }
    box {
      name
      bagQuantity
      bagWeight
      itemQuantity
      itemWeight
    }
  }
}
    `;
export const RecommendedProductFragmentDoc = gql`
    fragment RecommendedProduct on StorefrontProductListing {
  sku
  category
  price
  position
  recommended
  outOfStock
  emergencyOutOfStock
  outOfStockMessage
  reason {
    type
    name
  }
  product {
    id
    name
    slug
    description
    priceCategory
    recipeId
    shopifyId
  }
}
    `;
export const RecommendationsFragmentDoc = gql`
    fragment Recommendations on RecommendationWizard {
  planRecommendations(ignoreDisabledPlans: false) {
    caloriesPerDay
    boxes {
      fullBox {
        ...RecommendedBox
      }
      topperBox {
        ...RecommendedBox
      }
      comboBox {
        ...RecommendedBox
      }
      freshBakedBox {
        ...RecommendedBox
      }
    }
  }
  recommendedRecipes {
    ...RecommendedProduct
  }
  recommendedAddons {
    ...RecommendedProduct
  }
  recommendedComboRecipes {
    ...RecommendedProduct
  }
}
    ${RecommendedBoxFragmentDoc}
${RecommendedProductFragmentDoc}`;
export const SubscriptionCartAttrsFragmentDoc = gql`
    fragment SubscriptionCartAttrs on RecommendationWizard {
  id
  petName
  petId
  userId
  activityLevel
  attributions
  birthDate
  breedType
  contactEmail
  contactName
  contactPhoneNumber
  couponsData
  weight
  gender
  spayedNeutered
  primaryBreedId
  secondaryBreedId
  waistline
  wellnessGoalIds
  hasWellnessGoals
  ingredientIds
  hasFoodSensitivities
  preferenceIds
  recipeIds
  recipeSkus
  bakedIds
  cookedIds
  planId
  planType
  lineItemsData {
    quantity
    shopifyId
    sku
    discount
    price
    recurring
    type
  }
  recommendedCaloriesPerDay
  recommendedRecipeLineItems {
    sku
    shopifyId
    quantity
  }
  subscriptionId
  guestToken
  shopifyId
  latestStep
  plan {
    sku
    name
    planType
    sellingPlanId
    shopifyId
    addonUnits
    box {
      bagQuantity
      itemQuantity
    }
  }
  selectedBreedOptions {
    label
    value
  }
  selectedWellnessGoalOptions {
    label
    value
  }
  selectedRecipeOptions {
    label
    value
  }
}
    `;
export const RecommendedProductAttrsFragmentDoc = gql`
    fragment RecommendedProductAttrs on StorefrontProductListing {
  sku
  category
  price
  position
  recommended
  outOfStock
  emergencyOutOfStock
  outOfStockMessage
  reason {
    type
    name
  }
  product {
    id
    name
    slug
    description
    priceCategory
    recipeId
    shopifyId
  }
}
    `;
export const RecBoxAttrsFragmentDoc = gql`
    fragment RecBoxAttrs on PetBox {
  addons {
    nodes {
      id
      name
      slug
      sku
      category
      outOfStock
      outOfStockMessage
      description
      priceCategory
      shopifyId
      price
      metadata
      shopifyId
      recipe {
        id
      }
    }
  }
  shopifyLineItems {
    quantity
    shopifyId
  }
  boxVariant {
    id
    price
    sku
    planType
    addonUnits
    mealsPerDay
    calorieGroup
    defaultFrequency
    sellingPlanId
    shopifyId
    feedingGuideline {
      calorieGroup
      planType
      dailyIntake
      frozenPortion
      frozenMeasure
      frozenWeight
      frozenWeightMeasure
      dryPortion
      dryMeasure
    }
    box {
      name
      bagQuantity
      bagWeight
      itemQuantity
      itemWeight
    }
  }
}
    `;
export const AccountSubscriptionIndexRecommendedProductAttrsFragmentDoc = gql`
    fragment AccountSubscriptionIndexRecommendedProductAttrs on StorefrontProductListing {
  sku
  category
  price
  position
  recommended
  outOfStock
  outOfStockMessage
  product {
    id
    name
    slug
    description
    priceCategory
    recipeId
    shopifyId
  }
}
    `;
export const IndexProductItemAttrsFragmentDoc = gql`
    fragment IndexProductItemAttrs on PlanLineItem {
  sku
  quantity
  category
  price
  product {
    id
    name
    slug
    shopifyId
    outOfStock
  }
}
    `;
export const MyAccountUpdateSubscriptionLineItemFragmentDoc = gql`
    fragment MyAccountUpdateSubscriptionLineItem on PlanLineItem {
  sku
  quantity
}
    `;
export const BoxAttrsFragmentDoc = gql`
    fragment BoxAttrs on PetBox {
  shopifyLineItems {
    sku
    quantity
    shopifyId
    category
  }
  boxVariant {
    id
    price
    name
    calorieGroup
    defaultFrequency
    mealsPerDay
    shopifyId
    sellingPlanId
  }
  addons {
    nodes {
      id
      slug
      sku
      name
      shopifyId
      productCategory
      priceCategory
      price
      productType
      category
      shortName
      metadata
      description
      ingredients
    }
  }
  recipes {
    nodes {
      id
      slug
      sku
      name
      category
      subtitle
      recommended
      priceCategory
      shopifyId
      recipeId
    }
  }
}
    `;
export const ProductItemAttrsFragmentDoc = gql`
    fragment ProductItemAttrs on PlanLineItem {
  sku
  quantity
  category
  price
  reason {
    type
    name
  }
  product {
    id
    name
    slug
    shopifyId
    outOfStock
    outOfStockMessage
  }
}
    `;
export const AccountSubscriptionDetailRecommendedProductAttrsFragmentDoc = gql`
    fragment AccountSubscriptionDetailRecommendedProductAttrs on StorefrontProductListing {
  sku
  category
  price
  position
  recommended
  outOfStock
  outOfStockMessage
  reason {
    type
    name
  }
  product {
    id
    name
    slug
    description
    priceCategory
    recipeId
    shopifyId
  }
}
    `;
export const AutomationPropsFragmentDoc = gql`
    fragment AutomationProps on Automation {
  active
  id
  lastRunAt
  name
  scheduledFor
  targetDay
  time
  weekday
}
    `;
export const MealVariantPropsFragmentDoc = gql`
    fragment MealVariantProps on PetPlateMealVariantType {
  id
}
    `;
export const ProductVariantPropsFragmentDoc = gql`
    fragment ProductVariantProps on PetPlateProductVariantType {
  id
}
    `;
export const BoxVariantPropsFragmentDoc = gql`
    fragment BoxVariantProps on BoxVariant {
  active
  activeFrom
  activeUntil
  addonUnits
  calorieGroup
  category
  categoryMapped
  defaultFrequency
  deletedAt
  displayOrder
  id
  mealsPerDay
  name
  planType
  price
  sellingPlanId
  shopifyId
  sku
  box {
    name
    id
    sku
  }
  meals {
    id
    name
    shopifyId
    sku
  }
  products {
    id
    name
    shopifyId
    parentShopifyId
    sku
  }
  mealVariants {
    id
    name
    sku
    outOfStock
    meal {
      sku
      parentShopifyId
      name
    }
  }
  productVariants {
    id
    name
    sku
    outOfStock
    product {
      sku
      parentShopifyId
      name
    }
  }
}
    `;
export const BoxPropsFragmentDoc = gql`
    fragment BoxProps on Box {
  bagQuantity
  bagVolume
  bagWeight
  displayOrder
  id
  itemQuantity
  itemVolume
  itemWeight
  legacyCategory
  legacyDefaultFrequency
  name
  routeCode
  sku
  packagingId
  state
  boxVariants {
    active
    activeFrom
    activeUntil
    addonUnits
    box {
      id
    }
    calorieGroup
    category
    defaultFrequency
    deletedAt
    displayOrder
    id
    mealsPerDay
    name
    planType
    price
    sellingPlanId
    shopifyId
    sku
  }
  packaging {
    name
  }
}
    `;
export const BreedPropsFragmentDoc = gql`
    fragment BreedProps on Breed {
  active
  activityLevel
  id
  mixedBreed
  name
  name
  sizeClass
  slug
}
    `;
export const CalorieMultiplierPropsFragmentDoc = gql`
    fragment CalorieMultiplierProps on CalorieMultiplier {
  activityLevel
  age
  bodyCondition
  createdAt
  id
  multiplier
  noteToCustomer
  notes
  obeseProneness
  spayedNeutered
  updatedAt
}
    `;
export const CancellationSurveyPropsFragmentDoc = gql`
    fragment CancellationSurveyProps on CancellationSurvey {
  id
  subscription {
    renewals
    previousPlan {
      id
    }
    state
    updatedAt
    id
    number
    currentPlan {
      id
      name
      sku
    }
    user {
      id
      email
      name
    }
    pet {
      petName
    }
    shipments {
      id
    }
  }
  cancellationReasonTerm {
    id
    description
  }
}
    `;
export const CommentPropsFragmentDoc = gql`
    fragment CommentProps on PpComment {
  authorType
  body
  createdAt
  id
  namespace
  resourceId
  resourceType
  updatedAt
  user {
    id
    name
    email
  }
}
    `;
export const ConversionSurveyPropsFragmentDoc = gql`
    fragment ConversionSurveyProps on ConversionSurvey {
  createdAt
  id
  otherWebsite
  source
  subscription {
    email
    user {
      id
    }
    number
    id
    shipments {
      id
    }
    currentPlan {
      id
      name
      sku
    }
  }
  updatedAt
}
    `;
export const CouponPropsFragmentDoc = gql`
    fragment CouponProps on Coupon {
  id
  code
  shopifyId
  maskedCode
  note
  percentOff
  amountOff
  createdAt
  updatedAt
  duration
  linkable
  linkedCouponId
  linkedCoupon {
    id
    code
  }
}
    `;
export const UserPropsFragmentDoc = gql`
    fragment UserProps on User {
  id
  name
  email
}
    `;
export const StoreCreditAccountPropsFragmentDoc = gql`
    fragment StoreCreditAccountProps on StoreCreditAccount {
  amount
  createdAt
  id
  number
  transactions
  updatedAt
  user {
    ...UserProps
  }
}
    ${UserPropsFragmentDoc}`;
export const MovementStoreCreditAccountPropsFragmentDoc = gql`
    fragment MovementStoreCreditAccountProps on StoreCreditAccount {
  createdAt
  id
  number
  updatedAt
  user {
    id
    email
  }
}
    `;
export const StoreCreditMovementPropsFragmentDoc = gql`
    fragment StoreCreditMovementProps on StoreCreditMovement {
  amount
  createdAt
  id
  message
  number
  reasonId
  updatedAt
  whoDidIt {
    id
    email
  }
  whoDidItId
  creditSubmitter {
    id
    email
  }
  creditSubmitterId
  storeCreditAccountId
  payment {
    id
  }
  reason {
    id
    name
  }
  storeCreditAccount {
    ...MovementStoreCreditAccountProps
  }
}
    ${MovementStoreCreditAccountPropsFragmentDoc}`;
export const DryIceMatrixTierPropsFragmentDoc = gql`
    fragment DryIceMatrixTierProps on DryIceMatrixTier {
  id
  min
  max
  day1
  day2
  day3
  boxSize
  createdAt
  updatedAt
}
    `;
export const AdminDryIcePackagingFragmentFragmentDoc = gql`
    fragment AdminDryIcePackagingFragment on DryIcePackaging {
  id
  dryIceBlocks
  packaging {
    name
  }
}
    `;
export const LineItemRulePropsFragmentDoc = gql`
    fragment LineItemRuleProps on LineItemRule {
  active
  createdAt
  fieldName
  id
  lineItemRuleSet {
    active
    conflictStrategy
    createdAt
    description
    id
    limit
    limitStrategy
    lineItemDiscount
    lineItemName
    lineItemWeight
    lineItemPrice
    lineItemQuantity
    lineItemSku
    lineItemType
    logicOperator
    mergeCostStrategy
    mergeNameStrategy
    mergeQuantityStrategy
    mergeWeightStrategy
    priority
    updatedAt
    lineItemReplacements {
      sku
      active
    }
    rules {
      id
      active
      fieldName
      operator
      value
    }
  }
  operator
  updatedAt
  value
}
    `;
export const AdminDynamicLineItemRuleSetFragmentDoc = gql`
    fragment AdminDynamicLineItemRuleSet on LineItemRuleSet {
  active
  conflictStrategy
  id
  limit
  limitStrategy
  lineItemName
  lineItemWeight
  lineItemQuantity
  lineItemSku
  lineItemOutOfStock
  lineItemReplaceSku
  lineItemPrice
  lineItemDiscount
  lineItemType
  description
  logicOperator
  mergeCostStrategy
  mergeNameStrategy
  mergeQuantityStrategy
  mergeSkuStrategy
  mergeWeightStrategy
  priority
  lineItemReplacements {
    sku
    active
  }
  rules {
    active
    fieldName
    id
    operator
    value
  }
}
    `;
export const LogEventPropsFragmentDoc = gql`
    fragment LogEventProps on LogEvent {
  createdAt
  data
  event
  id
  message
  sourceId
  sourceType
  targetId
  targetType
  updatedAt
  user {
    id
    email
  }
}
    `;
export const ReportJobPropsFragmentDoc = gql`
    fragment ReportJobProps on ReportJob {
  createdAt
  duration
  emails
  endedAt
  errorMessage
  exportedUrl
  id
  name
  paperclipLogContentType
  paperclipLogFileName
  paperclipLogFileSize
  paperclipLogUpdatedAt
  paperclipOutputContentType
  paperclipOutputFileName
  paperclipOutputFileSize
  paperclipOutputUpdatedAt
  startedAt
  state
  stats
  updatedAt
  user {
    id
  }
}
    `;
export const FulfillmentScheduleRulePropsFragmentDoc = gql`
    fragment FulfillmentScheduleRuleProps on FulfillmentScheduleRule {
  id
  startDate
  endDate
  strategy
  jumpDate
  routeCode
  warehouseCode
  zipCode
  scheduleData
}
    `;
export const AdminImportJobPropertiesFragmentDoc = gql`
    fragment AdminImportJobProperties on ImportJob {
  createdAt
  createdLines
  errorLines
  id
  importType
  keyBinding
  keys
  message
  paperclipBackupContentType
  paperclipBackupFileName
  paperclipBackupFileSize
  paperclipBackupUpdatedAt
  paperclipDataContentType
  paperclipDataFileName
  paperclipDataFileSize
  paperclipDataUpdatedAt
  uploadedUrl
  parsedHeaders
  shipmentId
  state
  totalLines
  updatedAt
  updatedLines
  ignoredLines
  importJobLinePreviews {
    id
  }
  blob {
    byteSize
    fileName
  }
  user {
    email
    id
  }
}
    `;
export const AdminMealPlanRecBoxVarFragmentDoc = gql`
    fragment AdminMealPlanRecBoxVar on BoxVariant {
  defaultFrequency
  id
  name
  sku
  price
  box {
    bagQuantity
    bagVolume
    bagWeight
  }
}
    `;
export const AdminMealPlanMatchFragFragmentDoc = gql`
    fragment AdminMealPlanMatchFrag on PlanMatchCriterium {
  active
  status
  ageBased
  ageGroup
  calorieBased
  calorieMax
  calorieMin
  comboPlanFrequency
  comboPlanFrequencyCustomizable
  comboPlanId
  freshBakedPlanFrequencyCustomizable
  fullPlanFrequency
  fullPlanFrequencyCustomizable
  fullPlanId
  groupingName
  id
  recommendedCaloriesPerDay
  recommendedServingSizeInOunces
  spaceSaverPlanFrequencyCustomizable
  spaceSaverPlanId
  topperPlanFrequency
  topperPlanFrequencyCustomizable
  topperPlanId
  weightBased
  weightMax
  weightMin
  welcomePlanFrequencyCustomizable
  welcomePlanId
  comboPlan {
    ...AdminMealPlanRecBoxVar
  }
  fullPlan {
    ...AdminMealPlanRecBoxVar
  }
  spaceSaverPlan {
    ...AdminMealPlanRecBoxVar
  }
  topperPlan {
    ...AdminMealPlanRecBoxVar
  }
  welcomePlan {
    ...AdminMealPlanRecBoxVar
  }
  freshBakedPlan {
    ...AdminMealPlanRecBoxVar
  }
}
    ${AdminMealPlanRecBoxVarFragmentDoc}`;
export const MealListPropsFragmentDoc = gql`
    fragment MealListProps on Meal {
  id
  sku
  name
  slug
  price
  active
  category
  emergencyOutOfStock
  outOfStock
  outOfStockMessage
  parentShopifyId
}
    `;
export const MealPropsFragmentDoc = gql`
    fragment MealProps on Meal {
  id
  sku
  name
  shortName
  slug
  active
  category
  description
  lineItemName
  price
  displayOrder
  emergencyOutOfStock
  outOfStock
  outOfStockMessage
  shopifyId
  parentShopifyId
  createdAt
  updatedAt
  mealPlanVariants {
    sku
    name
    variants {
      id
      outOfStock
      state
      plan {
        sku
        name
        id
      }
    }
  }
}
    `;
export const NotificationBannerPropsFragmentDoc = gql`
    fragment NotificationBannerProps on NotificationBanner {
  id
  notificationBannerType
  message
  startDate
  endDate
  relevantDelayDate
  createdAt
  updatedAt
  user {
    id
    email
  }
}
    `;
export const AdminOrderImportBatchFragmentFragmentDoc = gql`
    fragment AdminOrderImportBatchFragment on OrderImportBatch {
  endedAt
  entriesCount
  failedCount
  fromDate
  id
  pendingCount
  skippedCount
  startedAt
  state
  successCount
  untilDate
}
    `;
export const AdminOrderImportBatchEntryFragmentFragmentDoc = gql`
    fragment AdminOrderImportBatchEntryFragment on OrderImportBatchEntry {
  action
  createdAt
  departedFcAt
  id
  index
  orderImportBatchId
  payload
  poNumber
  processData
  startedAt
  state
  updatedAt
}
    `;
export const AdminOrderImportBatchEntryOrderFragmentFragmentDoc = gql`
    fragment AdminOrderImportBatchEntryOrderFragment on DbOrder {
  id
  orderNumber
  state
  orderImportBatchEntry {
    ...AdminOrderImportBatchEntryFragment
  }
  shipments {
    shipmentEntry {
      id
      shipmentNumber
    }
  }
}
    ${AdminOrderImportBatchEntryFragmentFragmentDoc}`;
export const AdminDbOrderProductItemAttrsFragmentDoc = gql`
    fragment AdminDbOrderProductItemAttrs on PlanLineItem {
  sku
  quantity
  category
  product {
    name
    active
  }
}
    `;
export const AdminDbOrderPropsFragmentDoc = gql`
    fragment AdminDbOrderProps on DbOrder {
  attributionChannel
  attributionSource
  contactEmail
  contactName
  contactPhoneNumber
  createdAt
  estimatedShippingDate
  estimatedDeliveryDate
  shopifyId
  chewyPoNumber
  amazonPoNumber
  amazonShipMethod
  id
  orderNumber
  petNames
  state
  humanizedState
  updatedAt
  shippingAddress
  estimatedTaxRate
  normalizedCoupons
  taggings {
    tag {
      name
    }
  }
  charges {
    createdAt
    chargedAt
    id
    number
    state
    price
    assessedTaxes
    amount
  }
  shipments {
    shipmentEntry {
      id
      shipmentNumber
      shippedAt
      shipmentList {
        id
        state
      }
      state
    }
  }
  lastShipmentEntry {
    deliveryDate
    state
    id
    shipmentNumber
  }
  customer {
    email
    id
    shopifyId
    totalCreditAmount
    address {
      address
      city
      stateAbbr
      zipCode
    }
    pets {
      id
      petName
    }
  }
  shopifyId
}
    `;
export const AdminOrderBoxVariantProductFragmentDoc = gql`
    fragment AdminOrderBoxVariantProduct on PetPlateProduct {
  id
  productType
  pageUrl
}
    `;
export const PackagingPropsFragmentDoc = gql`
    fragment PackagingProps on Packaging {
  id
  active
  code
  description
  name
  boxes {
    packaging {
      id
    }
  }
}
    `;
export const PaymentBatchEntriesPropsFragmentDoc = gql`
    fragment PaymentBatchEntriesProps on PaymentBatchEntry {
  id
  subscription {
    id
    number
  }
  order {
    id
    orderNumber
    shopifyId
  }
  paymentBatch {
    id
  }
  payment {
    state
    number
    amount
    amountRefunded
    assessedTaxes
    subscription {
      id
      number
    }
    boxVariant {
      id
      name
      sku
    }
    id
    price
    paymentAdjustments {
      amount
      sourceType
      sourceId
    }
  }
  subscription {
    id
  }
  state
  updatedAt
  startedAt
  endedAt
}
    `;
export const PaymentBatchPropsFragmentDoc = gql`
    fragment PaymentBatchProps on PaymentBatch {
  chargedCount
  createdAt
  dueAt
  endedAt
  overdueCount
  failedCount
  id
  pendingCount
  shippingDates
  skippedCount
  startedAt
  state
  totalCount
  updatedAt
  paymentBatchEntries {
    action
    createdAt
    endedAt
    id
    index
    state
  }
  summaries {
    count
    sku
    totalAmount
    totalRefunded
  }
}
    `;
export const PaymentBatchEntryPropsFragmentDoc = gql`
    fragment PaymentBatchEntryProps on PaymentBatchEntry {
  order {
    shopifyId
  }
}
    `;
export const PaymentMethodPropsFragmentDoc = gql`
    fragment PaymentMethodProps on PaymentMethod {
  apiCardId
  apiCustomerId
  brand
  cardFingerprint
  cardLast4
  cardMonth
  cardYear
  createdAt
  fraudScore
  funding
  id
  migratedFromId
  paymentGatewayProvider
  recommendation
  state
  updatedAt
  lowercaseMetadata {
    company
    wallet
    paypalEmail
  }
  owner {
    ...UserProps
  }
  subscriptions {
    id
    number
  }
}
    ${UserPropsFragmentDoc}`;
export const PaymentPropsFragmentDoc = gql`
    fragment PaymentProps on PpPayment {
  amount
  amountRefunded
  apiChargeId
  apiIntentId
  assessedTaxes
  assessedTaxesBy
  assessedTaxesError
  awardedCredits {
    id
    amount
  }
  boxVariant {
    id
    name
    sku
  }
  chargedAt
  city
  createdAt
  estimatedTaxes
  estimatedTaxesDiscrepancy
  id
  lineItemsData
  number
  paymentAdjustments {
    amount
    sourceType
    sourceId
  }
  paymentGatewayProvider
  paymentMethod {
    id
    cardLast4
    cardMonth
    cardYear
    state
    owner {
      id
      email
    }
  }
  paymentOperatorType
  price
  reason
  shipperCity
  shipperStateAbbr
  shipperZipCode
  state
  stateAbbr
  subscription {
    id
    v2Orders {
      id
    }
    number
    email
    user {
      id
    }
  }
  updatedAt
  zipCode
  paymentAdjustments {
    amount
    sourceId
    sourceType
  }
  refunds {
    id
    amount
    invoicedAt
    createdAt
    invoiceError
    state
    source
    reason {
      id
      name
      description
    }
  }
}
    `;
export const PetBreedPropsFragmentDoc = gql`
    fragment PetBreedProps on Breed {
  id
  mixedBreed
  name
  sizeClass
}
    `;
export const PetPropsFragmentDoc = gql`
    fragment PetProps on Pet {
  activityLevel
  ageGroup
  birthDate
  breedType
  calculatedCaloriesPerDay
  completedBirthDate
  createdAt
  gender
  hasFoodSensitivities
  hasWellnessGoals
  id
  waistline
  petName
  primaryBreedId
  restingEnergyRate
  secondaryBreedId
  servingSizeInOunces
  spayedNeutered
  updatedAt
  weight
  primaryBreed {
    ...PetBreedProps
  }
  secondaryBreed {
    ...PetBreedProps
  }
  ingredients {
    name
  }
  ingredientIds
  mealLineItems {
    meal {
      name
    }
  }
  recommendationWizard {
    id
    weight
    recommendedRecipes {
      sku
    }
    recommendedComboRecipes {
      sku
    }
    recommendedAddons {
      sku
    }
  }
  wellnessGoals {
    name
  }
  wellnessGoalIds
  user {
    id
    email
  }
}
    ${PetBreedPropsFragmentDoc}`;
export const PlanCompatibilityCriteriumPropsFragmentDoc = gql`
    fragment PlanCompatibilityCriteriumProps on PlanCompatibilityCriterium {
  id
  name
  weight
  scoreFull
  scoreTopper
  scoreCombo
  scoreBaked
  displayOrder
  hidden
  createdAt
  updatedAt
}
    `;
export const ProductListPropsFragmentDoc = gql`
    fragment ProductListProps on PetPlateProduct {
  id
  sku
  name
  slug
  category
  price
  active
  emergencyOutOfStock
  outOfStock
  outOfStockMessage
  parentShopifyId
}
    `;
export const ProductPropsFragmentDoc = gql`
    fragment ProductProps on PetPlateProduct {
  id
  sku
  name
  shortName
  slug
  active
  category
  description
  lineItemName
  price
  displayOrder
  emergencyOutOfStock
  outOfStock
  outOfStockMessage
  shopifyId
  parentShopifyId
  createdAt
  updatedAt
  productPlanVariants {
    sku
    name
    variants {
      id
      outOfStock
      state
      plan {
        sku
        name
        id
      }
    }
  }
}
    `;
export const RecommendableProductPropsFragmentDoc = gql`
    fragment RecommendableProductProps on RecommendableProduct {
  createdAt
  id
  recommendableId
  recommendableType
  status
  termId
  updatedAt
  meal {
    name
    sku
  }
  product {
    name
    sku
  }
  term {
    name
    type
  }
}
    `;
export const RouteSchedulePropsFragmentDoc = gql`
    fragment RouteScheduleProps on RouteSchedule {
  carrier
  carrierCode
  createdAt
  deliveryDays
  id
  includeDryIce
  routeCode
  scheduleData
  scheduleStartDate
  serviced
  shippingStartDate
  transitRegion
  transitRegionCode
  updatedAt
  warehouseCode
  warehouseName
  warehouseZipCode
  zipCode
}
    `;
export const ShipmentListIndexPropsFragmentDoc = gql`
    fragment ShipmentListIndexProps on ShipmentList {
  createdAt
  startedAt
  endedAt
  id
  shippedAt
  state
  updatedAt
  shipments {
    id
  }
}
    `;
export const ShipmentListViewPropsFragmentDoc = gql`
    fragment ShipmentListViewProps on ShipmentList {
  createdAt
  startedAt
  endedAt
  id
  shippedAt
  state
  updatedAt
  shipments {
    id
    shipmentNumber
    state
    trackingNumber
    trackingStatus
    createdAt
    updatedAt
    trackedOnKlaviyoAt
    undigitalInsertedAt
    startedAt
    endedAt
    v2Order {
      id
      contactEmail
      orderNumber
    }
    undigitalInsertError
    klaviyoTrackError
  }
}
    `;
export const ShipmentEntryPropsFragmentDoc = gql`
    fragment ShipmentEntryProps on ShipmentEntry {
  addressData
  addressStateAbbr
  addressZipCode
  shipmentListId
  box {
    id
    sku
  }
  boxVariant {
    id
    sku
    name
    price
  }
  carrierCode
  carrierService
  createdAt
  data
  daysInTransit
  email
  id
  index
  lineItemsData
  orderStatus
  v2Order {
    id
    orderNumber
  }
  packaging {
    id
    name
  }
  payment {
    id
    number
    state
  }
  pet {
    id
  }
  planFrequency
  boxVariant {
    id
    sku
  }
  renewals
  routeCode
  scheduledShippingDate
  shipmentList {
    id
  }
  shipmentNumber
  shippedAt
  state
  subscription {
    id
    number
  }
  subscriptionStatus
  trackingNumber
  trackingStatus
  transitRegionCode
  updatedAt
  undigitalInsertedAt
  trackedOnKlaviyoAt
  startedAt
  endedAt
  user {
    id
    email
    phoneNumber
  }
  warehouseCode
}
    `;
export const SizeClassPropsFragmentDoc = gql`
    fragment SizeClassProps on SizeClass {
  ageOfMaturity
  ageOfSeniority
  lifeExpectancy
  maxWeight
  name
}
    `;
export const AdminBoxVariantPropsFragmentDoc = gql`
    fragment AdminBoxVariantProps on BoxVariant {
  id
  name
  sku
  box {
    itemQuantity
    itemWeight
    bagQuantity
    bagWeight
  }
}
    `;
export const AdminSubscriptionProductItemAttrsFragmentDoc = gql`
    fragment AdminSubscriptionProductItemAttrs on PlanLineItem {
  sku
  quantity
  category
  product {
    shopifyId
  }
}
    `;
export const SubPlanPropsFragmentDoc = gql`
    fragment SubPlanProps on BoxVariant {
  activeFrom
  activeUntil
  id
  mealsPerDay
  name
  planType
  sellingPlanId
  shopifyId
  price
  sku
  box {
    id
    itemQuantity
    name
    sku
  }
}
    `;
export const AdminSubShipmentPropsFragmentDoc = gql`
    fragment AdminSubShipmentProps on ShipmentEntry {
  addressData
  addressStateAbbr
  addressZipCode
  carrierCode
  carrierService
  createdAt
  data
  daysInTransit
  email
  id
  index
  lineItemsData
  orderStatus
  planFrequency
  renewals
  routeCode
  scheduledShippingDate
  shipmentNumber
  shippedAt
  state
  subscriptionStatus
  trackingNumber
  trackingStatus
  transitRegionCode
  updatedAt
  warehouseCode
  payment {
    id
  }
  pet {
    id
  }
  boxVariant {
    id
  }
  shipmentList {
    id
  }
}
    `;
export const SubPaymentPropsFragmentDoc = gql`
    fragment SubPaymentProps on PaymentMethod {
  cardLast4
  cardMonth
  cardYear
  state
  id
  lowercaseMetadata {
    company
    wallet
    paypalEmail
  }
}
    `;
export const SubPetBreedPropsFragmentDoc = gql`
    fragment SubPetBreedProps on Breed {
  id
  mixedBreed
  name
  sizeClass
}
    `;
export const SubPetPropsFragmentDoc = gql`
    fragment SubPetProps on Pet {
  activityLevel
  ageGroup
  birthDate
  breedType
  calculatedCaloriesPerDay
  completedBirthDate
  createdAt
  gender
  hasFoodSensitivities
  hasWellnessGoals
  ingredientIds
  wellnessGoalIds
  id
  waistline
  petName
  primaryBreedId
  restingEnergyRate
  secondaryBreedId
  servingSizeInOunces
  spayedNeutered
  updatedAt
  weight
  primaryBreed {
    ...SubPetBreedProps
  }
  secondaryBreed {
    ...SubPetBreedProps
  }
  ingredients {
    name
  }
  mealLineItems {
    meal {
      name
    }
  }
  recommendationWizard {
    id
    weight
    recommendedRecipes {
      sku
    }
    recommendedComboRecipes {
      sku
    }
    recommendedAddons {
      sku
    }
  }
  wellnessGoals {
    name
  }
  user {
    id
    email
  }
}
    ${SubPetBreedPropsFragmentDoc}`;
export const AdminPetBoxFragmentDoc = gql`
    fragment AdminPetBox on PetBox {
  boxVariant {
    ...AdminBoxVariantProps
  }
}
    ${AdminBoxVariantPropsFragmentDoc}`;
export const SubscriptionPropsFragmentDoc = gql`
    fragment SubscriptionProps on Subscription {
  apiSubscriptionId
  attributions
  cancelAtPeriodEnd
  canceledAt
  cancellationSurvey {
    cancellationReasonId
    cancellationReasonTerm {
      id
      description
    }
    cancellationReasonOther
    cancellationReasonOtherMoreDetails
  }
  completedAt
  routeSchedule {
    warehouseCode
    warehouseName
    carrierCode
    deliveryDays
    includeDryIce
    routeCode
    transitRegionCode
    shippingStartDate
    scheduleStartDate
  }
  coupons {
    code
    maskedCode
    applicationType
    amountOff
    percentageOff
    usageCycleLimit
    limited
    usageCount
    oncePerCustomer
    appliesToAllItems
  }
  createdAt
  currentPlanFrequency
  data
  dishesCount
  renewals
  email
  hiddenAt
  id
  ignoreNewPlanRecommendationsAt
  lastShippedAt
  lineItemsData
  manuallyScheduledShipments
  newPlan
  nextPlanFrequency
  nextScheduledShippingDate
  number
  paymentTotal
  renewals
  scheduledShippingDate
  state
  statementTotal
  total
  updatedAt
  estimatedDeliveryDate
  estimatedNextDeliveryDates
  estimatedNextShippingDates
  stripeUrl
  remoteContract {
    id
    status
    appAdminUrl
    customer {
      email
      firstName
      id
      lastName
      productSubscriberStatus
      state
      validEmailAddress
      verifiedEmail
    }
    customerPaymentMethod {
      id
      revokedAt
      revokedReason
      instrument {
        branch
        expiresSoon
        expiryMonth
        expiryYear
        firstDigits
        lastDigits
        name
        source
      }
    }
    discounts {
      edges {
        node {
          id
          targetType
          title
          type
          usageCount
          recurringCycleLimit
          value {
            amount {
              amount
            }
            percentage
          }
        }
      }
    }
    lines {
      edges {
        node {
          sku
          title
          quantity
          lineDiscountedPrice {
            amount
          }
          currentPrice {
            amount
          }
          boxVariant {
            ...AdminBoxVariantProps
          }
          discountAllocations {
            discount {
              title
            }
          }
        }
      }
    }
    deliveryMethod {
      address {
        address1
        address2
        city
        firstName
        lastName
        phone
        zip
      }
    }
    billingAttempts {
      edges {
        node {
          id
          createdAt
          processingError {
            code
            message
          }
          completedAt
        }
      }
    }
  }
  shippingAddress {
    address
    aptNo
    city
    createdAt
    name
    note
    phoneNumber
    stateAbbr
    updatedAt
    zipCode
    normalizedZipCode
  }
  planSettings {
    chosenNewPlan
    recommendedNewNextPlan
    recommendedNewCurrentPlan
    nextPlanAfterQuestionnaire
    currentPlanAfterQuestionnaire
    nextPlanFrequencyCustomizable
    currentPlanFrequencyCustomizable
  }
  addonsCoupon {
    id
  }
  addons {
    ...AdminSubscriptionProductItemAttrs
  }
  entrees {
    ...AdminSubscriptionProductItemAttrs
  }
  freshBakedEntrees {
    ...AdminSubscriptionProductItemAttrs
  }
  freshCookedEntrees {
    ...AdminSubscriptionProductItemAttrs
  }
  currentPlan {
    ...SubPlanProps
  }
  previousPlan {
    id
  }
  upcomingOrder {
    estimatedShippingDate
    estimatedDeliveryDate
    shippingAddress
    invoicePreview {
      subtotalCost
      credit
      totalCost
      discounts {
        code
        maskedCode
        applicationType
        amountOff
        percentageOff
        amount
      }
    }
  }
  shipments {
    ...AdminSubShipmentProps
  }
  nextPlan {
    ...SubPlanProps
  }
  paymentMethod {
    ...SubPaymentProps
  }
  pet {
    ...SubPetProps
  }
  user {
    id
    email
    totalCreditAmount
    tagListView
    klaviyoUrl
    zendeskUrl
    completedSetup
  }
  payments {
    amount
    assessedTaxes
    price
    boxVariant {
      id
    }
    paymentAdjustments {
      amount
      createdAt
      sourceId
      sourceType
    }
  }
  v2Orders {
    id
    couponsData
    lastChargeSuccessful
    orderNumber
    attributionChannel
    charges {
      state
      amount
      chargedAt
    }
    estimatedShippingDate
    shippingAddress
    shipments {
      createdAt
    }
  }
  recommendationWizard {
    planRecommendations {
      boxes {
        comboBox {
          ...AdminPetBox
        }
        freshBakedBox {
          ...AdminPetBox
        }
        fullBox {
          ...AdminPetBox
        }
        spaceSaverBox {
          ...AdminPetBox
        }
        topperBox {
          ...AdminPetBox
        }
      }
    }
  }
}
    ${AdminBoxVariantPropsFragmentDoc}
${AdminSubscriptionProductItemAttrsFragmentDoc}
${SubPlanPropsFragmentDoc}
${AdminSubShipmentPropsFragmentDoc}
${SubPaymentPropsFragmentDoc}
${SubPetPropsFragmentDoc}
${AdminPetBoxFragmentDoc}`;
export const MealLineItemPropsFragmentDoc = gql`
    fragment MealLineItemProps on MealLineItem {
  id
  total
  meal {
    name
    sku
  }
}
    `;
export const SubOrderPropsFragmentDoc = gql`
    fragment SubOrderProps on DbOrder {
  id
  estimatedShippingDate
  estimatedDeliveryDate
  humanizedState
  lineItemsData
  orderNumber
  shippingAddress
  shopifyId
  couponsData
  statement {
    couponCodes
  }
  renewal
  state
  shipments {
    shipmentEntry {
      ...AdminSubShipmentProps
    }
  }
  charges {
    amount
    chargedAt
  }
  lastChargeSuccessful
  customer {
    email
  }
  taggings {
    tag {
      name
    }
  }
}
    ${AdminSubShipmentPropsFragmentDoc}`;
export const TermPropsFragmentDoc = gql`
    fragment TermProps on Term {
  active
  additionalCopy
  createdAt
  description
  displayOrder
  id
  name
  systemOnly
  type
  updatedAt
}
    `;
export const AdminShopifyCustPropsFragmentDoc = gql`
    fragment AdminShopifyCustProps on ShopifyCustomer {
  id
  email
  shopifyId
}
    `;
export const AdminUserPropsFragmentDoc = gql`
    fragment AdminUserProps on User {
  acceptsMarketing
  cohorts
  currentSignInAt
  currentSignInIp
  email
  id
  lastSignInAt
  lastSignInIp
  loyaltyPoints
  loyaltyTier
  name
  tagListView
  nickname
  phoneNumber
  referrals
  roles {
    id
    name
  }
  shopifyId
  smsConsent
  klaviyoUrl
  zendeskUrl
  pets {
    id
    petName
    primaryBreed {
      name
    }
  }
  storeCreditAccount {
    id
  }
  shopifyCustomers {
    ...AdminShopifyCustProps
  }
}
    ${AdminShopifyCustPropsFragmentDoc}`;
export const ZipCodeLocationPropsFragmentDoc = gql`
    fragment ZipCodeLocationProps on ZipCodeLocation {
  id
  zipCode
  city
  state
  latitude
  longitude
  createdAt
  updatedAt
}
    `;
export const ZipCodePropsFragmentDoc = gql`
    fragment ZipCodeProps on ZipCode {
  chargeSalesTax
  city
  createdAt
  id
  salesTaxRate
  state
  updatedAt
  zipCode
}
    `;
export const SubflowSignInDocument = gql`
    mutation SubflowSignIn($email: String!, $password: String!) {
  userLogin(email: $email, password: $password) {
    credentials {
      accessToken
      client
      expiry
      tokenType
      uid
    }
    authenticatable {
      id
      uid
      name
      hasSubscriptions
    }
  }
}
    `;
export const UpdateRecWizardDocument = gql`
    mutation UpdateRecWizard($id: ID!, $input: RecommendationWizardInput!) {
  recommendationWizardUpdate(input: {id: $id, recommendationWizardInput: $input}) {
    recommendationWizard {
      ...RecWizardAttrs
      ...Recommendations
    }
  }
}
    ${RecWizardAttrsFragmentDoc}
${RecommendationsFragmentDoc}`;
export const UpdateRecWizardUserDocument = gql`
    mutation UpdateRecWizardUser($id: ID!, $input: RecommendationWizardInput!) {
  recommendationWizardUpdate(input: {id: $id, recommendationWizardInput: $input}) {
    recommendationWizard {
      id
      userId
      contactEmail
    }
  }
}
    `;
export const CreateRecWizardDocument = gql`
    mutation CreateRecWizard($userId: Int) {
  recommendationWizardCreate(
    input: {recommendationWizardInput: {userId: $userId}}
  ) {
    recommendationWizard {
      ...RecWizardAttrs
    }
  }
}
    ${RecWizardAttrsFragmentDoc}`;
export const GetUserDocument = gql`
    query GetUser {
  me {
    id
    uid
    name
    email
    hasSubscriptions
    numberOfSubscriptions
  }
}
    `;
export const CheckDiscountDocument = gql`
    query CheckDiscount($codes: [String!]!) {
  shopifyDiscountInfo(codes: $codes) {
    id
    status
    title
    amount
    percentage
    customPromoText
    inferredBannerText
    affectsClass
    affectedProductSkus
    affectedCollections
  }
}
    `;
export const GetSettingsDocument = gql`
    query GetSettings($vars: [String!]) {
  settings(vars: $vars) {
    key
    value {
      ... on Coupon {
        id
        code
        percentOff
        amountOff
        maskedCode
        customPromoText
        inferredBannerText
        affectsClass
        affectedProductSkus
        affectedCollections
      }
    }
  }
}
    `;
export const GetPlanPreferencesDocument = gql`
    query GetPlanPreferences {
  planCompatibilityCriteria {
    nodes {
      id
      name
    }
  }
}
    `;
export const GetRecommendationsDocument = gql`
    query GetRecommendations($id: String) {
  recommendationWizard(id: $id) {
    planRecommendations {
      caloriesPerDay
      boxes {
        fullBox {
          ...RecommendedBox
        }
        topperBox {
          ...RecommendedBox
        }
        comboBox {
          ...RecommendedBox
        }
        freshBakedBox {
          ...RecommendedBox
        }
      }
    }
    recommendedRecipes {
      ...RecommendedProduct
    }
    recommendedAddons {
      ...RecommendedProduct
    }
    recommendedComboRecipes {
      ...RecommendedProduct
    }
  }
}
    ${RecommendedBoxFragmentDoc}
${RecommendedProductFragmentDoc}`;
export const GetBreedsDocument = gql`
    query GetBreeds($name: String) {
  breeds(first: 999, order: NAME_ASC, name: $name) {
    nodes {
      id
      name
    }
  }
}
    `;
export const GetPetsServedByBreedDocument = gql`
    query GetPetsServedByBreed {
  petsServed {
    countPerBreed {
      id
      count
    }
  }
}
    `;
export const GetPetsServedByAgeGroupDocument = gql`
    query GetPetsServedByAgeGroup {
  petsServed {
    countPerAgeGroup {
      ageGroup
      count
    }
  }
}
    `;
export const BreedAgeDataDocument = gql`
    query BreedAgeData($breedId: String!) {
  breed(id: $breedId) {
    name
    sizeClass
  }
  sizeClasses {
    nodes {
      ageOfMaturity
      ageOfSeniority
      lifeExpectancy
      maxWeight
      name
    }
  }
}
    `;
export const GetFoodSensitivityOptionsDocument = gql`
    query GetFoodSensitivityOptions {
  ingredients(first: 99) {
    nodes {
      id
      name
    }
  }
  wellnessGoals(first: 10) {
    nodes {
      id
      name
    }
  }
}
    `;
export const GetWellnessGoalOptionsDocument = gql`
    query GetWellnessGoalOptions($name: String) {
  wellnessGoals(first: 10, name: $name) {
    nodes {
      id
      name
      active
    }
  }
}
    `;
export const CheckUserExistenceDocument = gql`
    query CheckUserExistence($email: String!) {
  userExists(email: $email)
}
    `;
export const GetOrderIdFromShopifyIdDocument = gql`
    query GetOrderIdFromShopifyId($id: String!) {
  dbOrder(shopifyId: $id) {
    orderNumber
  }
}
    `;
export const CheckWizardCompletedDocument = gql`
    query CheckWizardCompleted($id: String!) {
  recommendationWizard(id: $id) {
    completed
  }
}
    `;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($token: String!, $password: String!, $passwordConfirmation: String!) {
  userResetPasswordWithToken(
    password: $password
    passwordConfirmation: $passwordConfirmation
    resetPasswordToken: $token
  ) {
    authenticatable {
      uid
    }
    credentials {
      accessToken
      client
      expiry
      tokenType
      uid
    }
  }
}
    `;
export const ChangePasswordPageDocument = gql`
    query ChangePasswordPage {
  me {
    uid
    name
  }
}
    `;
export const PasswordResetRequestDocument = gql`
    mutation PasswordResetRequest($email: String!, $redirectUrl: String!) {
  userSendPasswordResetWithToken(email: $email, redirectUrl: $redirectUrl) {
    message
  }
}
    `;
export const ForgotPasswordPageDocument = gql`
    query ForgotPasswordPage {
  me {
    uid
    name
  }
}
    `;
export const VerifyCaptchaResultDocument = gql`
    mutation VerifyCaptchaResult($token: String!) {
  verifyCaptchaToken(input: {token: $token}) {
    success
    score
    errors
  }
}
    `;
export const UserSignInDocument = gql`
    mutation UserSignIn($email: String!, $password: String!) {
  userLogin(email: $email, password: $password) {
    credentials {
      accessToken
      client
      expiry
      tokenType
      uid
    }
    authenticatable {
      id
      uid
      confirmedAt
    }
  }
}
    `;
export const AuthenticateAndAssignUserToRecWizDocument = gql`
    mutation AuthenticateAndAssignUserToRecWiz($email: String!, $password: String!, $recommendationWizardId: String!, $guestToken: String!) {
  assignUserToSubflow(
    email: $email
    password: $password
    recommendationWizardId: $recommendationWizardId
    guestToken: $guestToken
  ) {
    credentials {
      accessToken
      client
      expiry
      tokenType
      uid
    }
    authenticatable {
      id
      uid
      confirmedAt
    }
  }
}
    `;
export const UserSignOutDocument = gql`
    mutation UserSignOut {
  userLogout {
    authenticatable {
      uid
    }
  }
}
    `;
export const LoginPageDocument = gql`
    query LoginPage {
  me {
    uid
    name
  }
}
    `;
export const UserSignUpDocument = gql`
    mutation UserSignUp($email: String!, $password: String!, $passwordConfirmation: String!, $confirmUrl: String!) {
  userSignUp(
    email: $email
    password: $password
    passwordConfirmation: $passwordConfirmation
    confirmUrl: $confirmUrl
  ) {
    credentials {
      accessToken
      client
      expiry
      tokenType
      uid
    }
    authenticatable {
      uid
      id
    }
  }
}
    `;
export const UserSignUpWizardAssociateDocument = gql`
    mutation UserSignUpWizardAssociate($id: String!, $email: String!, $password: String!, $passwordConfirmation: String!, $guestToken: String!) {
  createUserForSubflow(
    email: $email
    password: $password
    passwordConfirmation: $passwordConfirmation
    recommendationWizardId: $id
    guestToken: $guestToken
  ) {
    credentials {
      accessToken
      client
      expiry
      tokenType
      uid
    }
    authenticatable {
      uid
      id
    }
    recommendationWizard {
      id
      userId
      contactEmail
    }
  }
}
    `;
export const SignUpPageDocument = gql`
    query SignUpPage {
  me {
    uid
    name
  }
}
    `;
export const ConfirmEmailDocument = gql`
    mutation ConfirmEmail($token: String!) {
  userConfirmRegistrationWithToken(confirmationToken: $token) {
    credentials {
      accessToken
      client
      expiry
      tokenType
      uid
    }
  }
}
    `;
export const VerifyAccountPageDocument = gql`
    query VerifyAccountPage {
  me {
    uid
    name
  }
}
    `;
export const UserNewsletterSignUpDocument = gql`
    mutation UserNewsletterSignUp($email: String!) {
  userNewsletterSignUp(input: {email: $email}) {
    success
    errors
  }
}
    `;
export const GetMyAccRecommendationsDocument = gql`
    query GetMyAccRecommendations($id: String, $maintainLegacy: Boolean) {
  recommendationWizard(id: $id) {
    planRecommendations(maintainLegacy: $maintainLegacy) {
      caloriesPerDay
      boxes {
        fullBox {
          ...RecBoxAttrs
        }
        topperBox {
          ...RecBoxAttrs
        }
        comboBox {
          ...RecBoxAttrs
        }
        freshBakedBox {
          ...RecBoxAttrs
        }
        spaceSaverBox {
          ...RecBoxAttrs
        }
      }
    }
    recommendedRecipes {
      ...RecommendedProductAttrs
    }
    recommendedAddons {
      ...RecommendedProductAttrs
    }
    recommendedComboRecipes {
      ...RecommendedProductAttrs
    }
  }
}
    ${RecBoxAttrsFragmentDoc}
${RecommendedProductAttrsFragmentDoc}`;
export const FindRecommendationWizardDocument = gql`
    query FindRecommendationWizard($id: String) {
  me {
    hasActiveSubs
  }
  recommendationWizard(id: $id) {
    ...SubscriptionCartAttrs
  }
}
    ${SubscriptionCartAttrsFragmentDoc}`;
export const CreateRecommendationWizardDocument = gql`
    mutation CreateRecommendationWizard($userId: Int, $subscriptionId: Int, $petName: String) {
  recommendationWizardCreate(
    input: {recommendationWizardInput: {userId: $userId, subscriptionId: $subscriptionId, petName: $petName}}
  ) {
    recommendationWizard {
      ...SubscriptionCartAttrs
    }
  }
}
    ${SubscriptionCartAttrsFragmentDoc}`;
export const CreatePetPlateSubscriptionDocument = gql`
    mutation CreatePetPlateSubscription($userId: Int) {
  petPlateSubscriptionCreate(
    input: {petPlateSubscriptionInput: {userId: $userId}}
  ) {
    petPlateSubscription {
      id
    }
  }
}
    `;
export const GetUserAndLoyaltyInfoDocument = gql`
    query GetUserAndLoyaltyInfo {
  me {
    uid
    id
    pupPoints
    vipTier
    referrals
  }
}
    `;
export const CartUpdatePlanDocument = gql`
    mutation CartUpdatePlan($id: ID!, $input: RecommendationWizardInput!) {
  recommendationWizardUpdate(input: {id: $id, recommendationWizardInput: $input}) {
    recommendationWizard {
      id
      planId
    }
  }
}
    `;
export const GetUserAndOrdersDocument = gql`
    query GetUserAndOrders($first: Int!, $after: String) {
  me {
    uid
    id
    userVisibleOrders(first: $first, after: $after) {
      nodes {
        id
        attributionChannel
        estimatedShippingDate
        state
        humanizedState
        orderNumber
        createdAt
        shopifyId
        shopifyTotal
        lineItemsData
        petNames
        statement {
          taxableSubtotal
          totalPaidLine {
            label
            amount
          }
          totalDueLine {
            label
            amount
          }
        }
        taggings {
          tag {
            name
          }
        }
        subscription {
          id
          scheduledShippingDate
          state
          pet {
            petName
          }
        }
      }
      pageInfo {
        currentPage
        pageSize
        startCursor
        endCursor
        totalPages
        hasNextPage
        hasPreviousPage
      }
    }
    subscriptions(processed: true) {
      nodes {
        currentPlanFrequency
        id
        scheduledShippingDate
        state
        hasFailedBilling
        hasUpdatedFailedBilling
        availablePostponementDates {
          shippingDate
          deliveryDate
        }
        estimatedDeliveryDate
        nextOrderAdjusted {
          humanizedState
          shippingAddress
          estimatedDeliveryDate
          paymentStatus
          lastShipmentEntry {
            state
          }
        }
        pet {
          petName
        }
        shippingAddress {
          id
          name
          address
          aptNo
          city
          stateAbbr
          zipCode
          phoneNumber
        }
      }
    }
  }
}
    `;
export const GetOrderByIdDocument = gql`
    query GetOrderById($id: String) {
  dbOrder(id: $id) {
    attributionChannel
    attributionSource
    contactEmail
    contactName
    contactPhoneNumber
    couponsData
    createdAt
    estimatedShippingDate
    humanizedState
    id
    lastShipmentEntry {
      id
      shippedAt
      deliveryDate
      state
      trackingLink
    }
    lineItemsData
    metadata
    orderNumber
    petNames
    statementItemsList
    paymentStatus
    statement {
      taxableSubtotal
      planWithSurchargesLine {
        label
        amount
      }
      totalPaidLine {
        label
        amount
      }
      addonsLine {
        label
        amount
      }
      taxesLine {
        label
        amount
      }
      shippingLine {
        label
        amount
      }
      surchargesLine {
        label
        amount
      }
      discountLines {
        label
        amount
        coupon {
          code
        }
      }
      creditLines {
        label
        amount
      }
      totalDueLine {
        label
        amount
      }
    }
    shipments {
      shipmentEntry {
        id
        shippedAt
        state
      }
    }
    shippingAddress
    shopifyId
    shopifyTotal
    state
    taggings {
      tag {
        name
      }
    }
    subscription {
      id
      dishesCount
      number
      planType
      planStatus
      state
      scheduledShippingDate
      treatsCount
      supplementsCount
      mealLineItems {
        total
        meal {
          name
          sku
        }
      }
      addonLineItems {
        quantity
        sku
      }
      pet {
        birthDate
        id
        petName
        weight
        primaryBreed {
          name
        }
      }
      payments {
        id
        assessedTaxes
      }
    }
    customer {
      email
      id
      address {
        address
        city
        stateAbbr
        zipCode
      }
    }
  }
}
    `;
export const AccountUpdatePetDocument = gql`
    mutation AccountUpdatePet($input: PetUpdateInput!) {
  petUpdate(input: $input) {
    pet {
      petName
      gender
      spayedNeutered
      birthDate
      primaryBreedId
      secondaryBreedId
      weight
      activityLevel
      waistline
      ingredientIds
      wellnessGoalIds
    }
  }
}
    `;
export const AccountPetDetailDataDocument = gql`
    query AccountPetDetailData {
  ingredients(first: 20) {
    nodes {
      id
      name
    }
  }
  wellnessGoals(first: 20) {
    nodes {
      id
      name
    }
  }
}
    `;
export const GetPetEditInfoDocument = gql`
    query GetPetEditInfo($id: String!) {
  pet(id: $id) {
    petName
    gender
    spayedNeutered
    birthDate
    primaryBreed {
      name
      id
    }
    secondaryBreed {
      name
      id
    }
    weight
    activityLevel
    waistline
    ingredientIds
    wellnessGoalIds
    subscription {
      id
      currentPlan {
        sku
        defaultFrequency
        calorieGroup
        addonUnits
        sellingPlanId
        shopifyId
        price
        planType
        id
        box {
          name
          bagQuantity
          bagWeight
          itemQuantity
          itemWeight
        }
      }
      recommendationWizard {
        id
        planRecommendations {
          caloriesPerDay
        }
      }
    }
  }
}
    `;
export const MyAccBreedSearchDocument = gql`
    query MyAccBreedSearch($name: String) {
  breeds(first: 999, order: NAME_ASC, name: $name) {
    nodes {
      id
      name
    }
  }
}
    `;
export const AccountSubscriptionAddonsDocument = gql`
    query AccountSubscriptionAddons($id: String!) {
  subscription(id: $id) {
    addons {
      ...IndexProductItemAttrs
    }
  }
}
    ${IndexProductItemAttrsFragmentDoc}`;
export const AccountSubscriptionIndexDocument = gql`
    query AccountSubscriptionIndex {
  me {
    subscriptions(first: 50, processed: true, hidden: true) {
      nodes {
        id
        currentPlanFrequency
        treatsCount
        supplementsCount
        state
        planType
        hasFailedBilling
        hasUpdatedFailedBilling
        availablePostponementDates {
          shippingDate
          deliveryDate
        }
        estimatedDeliveryDate
        upcomingOrder {
          invoicePreview {
            subtotalCost
            totalCost
            credit
            discounts {
              code
              maskedCode
              applicationType
              amountOff
              percentageOff
              amount
            }
          }
        }
        nextOrderAdjusted {
          id
          state
          estimatedDeliveryDate
          paymentStatus
          shippingAddress
          humanizedState
          lastShipmentEntry {
            state
            deliveryDate
            trackingNumber
            carrierService
          }
        }
        recommendationWizard {
          id
          petName
          planType
          planId
          ingredientIds
          recipeIds
        }
        currentPlan {
          defaultFrequency
          calorieGroup
          addonUnits
          sellingPlanId
          shopifyId
          price
          planType
          id
          sku
          box {
            name
            bagQuantity
            bagWeight
            itemQuantity
            itemWeight
          }
        }
        upgradePlan {
          defaultFrequency
          calorieGroup
          addonUnits
          sellingPlanId
          shopifyId
          price
          planType
          id
          sku
        }
        previousPlan {
          id
          sku
          price
        }
        pet {
          id
          petName
          birthDate
          weight
          gender
          primaryBreed {
            name
          }
          secondaryBreed {
            name
          }
        }
        coupons {
          code
        }
        shippingAddress {
          address
          aptNo
          city
          zipCode
        }
      }
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        pageSize
        totalPages
        startCursor
        endCursor
      }
    }
  }
}
    `;
export const AccountCreditDocument = gql`
    query AccountCredit {
  me {
    id
    totalCreditAmount
    hasFailedBilling
    subscriptionsWithFailedBilling
    subscriptionsWithUpdatedFailedBilling
  }
}
    `;
export const CheckSubPaymentMethodUpdatedDocument = gql`
    query CheckSubPaymentMethodUpdated($id: String!) {
  subscription(id: $id) {
    hasUpdatedFailedBilling
  }
}
    `;
export const MyAccountNotificationBannersDocument = gql`
    query MyAccountNotificationBanners {
  me {
    notificationBanners {
      id
      notificationBannerType
      message
    }
  }
}
    `;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($id: ID!, $pw: String!, $pwConfirm: String!) {
  userUpdate(
    input: {id: $id, userInput: {password: $pw, passwordConfirmation: $pwConfirm}}
  ) {
    user {
      id
      email
    }
  }
}
    `;
export const UpdateEmailDocument = gql`
    mutation UpdateEmail($id: ID!, $email: String!, $password: String!) {
  userUpdate(input: {id: $id, userInput: {email: $email}}) {
    user {
      id
      email
    }
  }
  userLogin(email: $email, password: $password) {
    credentials {
      accessToken
      client
      expiry
      tokenType
      uid
    }
    authenticatable {
      id
      uid
      confirmedAt
    }
  }
}
    `;
export const UpdateUserMarketingDocument = gql`
    mutation UpdateUserMarketing($id: ID!, $marketing: Boolean!, $phoneNumber: String!, $smsConsent: Boolean!) {
  userUpdate(
    input: {id: $id, userInput: {acceptsMarketing: $marketing, phoneNumber: $phoneNumber, smsConsent: $smsConsent}}
  ) {
    user {
      id
      email
      acceptsMarketing
      phoneNumber
      smsConsent
    }
  }
}
    `;
export const GetUserAccountSettingsDocument = gql`
    query GetUserAccountSettings {
  me {
    uid
    id
    phoneNumber
    email
    acceptsMarketing
    smsConsent
  }
}
    `;
export const MyAccountUpdatePlanDocument = gql`
    mutation MyAccountUpdatePlan($id: ID!, $input: RecommendationWizardInput!) {
  recommendationWizardUpdate(input: {id: $id, recommendationWizardInput: $input}) {
    recommendationWizard {
      id
      planType
      ingredientIds
      planId
    }
  }
}
    `;
export const MyAccountCreateSubscriptionPaymentMethodDocument = gql`
    mutation MyAccountCreateSubscriptionPaymentMethod($input: PaymentMethodInput!) {
  paymentMethodCreate(input: {paymentMethodInput: $input}) {
    paymentMethod {
      id
      cardLast4
    }
  }
}
    `;
export const MyAccountUpdateSubscriptionDocument = gql`
    mutation MyAccountUpdateSubscription($id: ID!, $input: SubscriptionInput!) {
  subscriptionUpdate(input: {id: $id, subscriptionInput: $input}) {
    subscription {
      id
      state
      hiddenAt
      coupons {
        code
      }
      treats {
        ...MyAccountUpdateSubscriptionLineItem
      }
      supplements {
        ...MyAccountUpdateSubscriptionLineItem
      }
      freshBakedEntrees {
        ...MyAccountUpdateSubscriptionLineItem
      }
      freshCookedEntrees {
        ...MyAccountUpdateSubscriptionLineItem
      }
    }
  }
}
    ${MyAccountUpdateSubscriptionLineItemFragmentDoc}`;
export const AccountSubsAddonsHltvDocument = gql`
    query AccountSubsAddonsHLTV {
  me {
    subscriptions(first: 50, processed: true, hidden: true) {
      nodes {
        isHighValue
        treats {
          ...IndexProductItemAttrs
        }
        supplements {
          ...IndexProductItemAttrs
        }
      }
    }
  }
}
    ${IndexProductItemAttrsFragmentDoc}`;
export const AccountSubscriptionDetailDocument = gql`
    query AccountSubscriptionDetail($id: String) {
  subscription(id: $id) {
    id
    number
    currentPlanSku
    isHighValue
    createdAt
    deliveredOrders
    paidOrdersCount
    hasLifeTimeCoupon
    hasEarlyCancelCoupon
    nextLinkedCoupons
    scheduledShippingDate
    nextScheduledShippingDate
    currentPlanFrequency
    planType
    state
    renewals
    hasFailedBilling
    hasUpdatedFailedBilling
    availablePostponementDates {
      shippingDate
      deliveryDate
    }
    estimatedDeliveryDate
    lastPaidOrderShippingDate
    upcomingOrderDeliveryDate
    nextOrderDeliveryDate
    nextOrderAdjusted {
      id
      state
      humanizedState
      estimatedDeliveryDate
      paymentStatus
      shippingAddress
      lastShipmentEntry {
        state
        deliveryDate
        trackingNumber
        carrierCode
      }
    }
    nextOrder {
      id
      state
      estimatedDeliveryDate
      paymentStatus
      shippingAddress
      lastShipmentEntry {
        state
        deliveryDate
        trackingNumber
        carrierService
      }
    }
    upcomingOrder {
      estimatedDeliveryDate
      invoicePreview {
        subtotalCost
        totalCost
        credit
        discounts {
          code
          maskedCode
          applicationType
          amountOff
          percentageOff
          amount
        }
      }
    }
    coupons {
      code
      maskedCode
      applicationType
      amountOff
      percentageOff
      entitledProducts {
        id
        sku
      }
      affectsClass
      affectedProductSkus
      affectedCollections
      usageCycleLimit
      usageCount
      limited
      oncePerCustomer
      appliesToAllItems
    }
    user {
      id
      name
      email
      numberOfSubscriptions
    }
    shopifyCustomer {
      email
      shopifyId
    }
    recommendationWizard {
      id
      planType
      planId
      ingredientIds
      recipeIds
      petName
      wellnessGoals {
        nodes {
          id
          name
        }
      }
      planRecommendations {
        caloriesPerDay
        boxes {
          topperBox {
            boxVariant {
              price
              defaultFrequency
            }
          }
          fullBox {
            boxVariant {
              price
              defaultFrequency
            }
          }
          comboBox {
            boxVariant {
              price
              defaultFrequency
            }
          }
          freshBakedBox {
            boxVariant {
              price
              defaultFrequency
            }
          }
        }
      }
      recommendedAddons {
        ...AccountSubscriptionDetailRecommendedProductAttrs
      }
      recommendedRecipes {
        ...AccountSubscriptionDetailRecommendedProductAttrs
      }
    }
    previousPlan {
      id
      sku
      price
    }
    currentPlan {
      defaultFrequency
      calorieGroup
      addonUnits
      sellingPlanId
      shopifyId
      price
      planType
      id
      box {
        name
        bagQuantity
        bagWeight
        itemQuantity
        itemWeight
      }
      productVariants(first: 1) {
        suggestedPiecesPerDay
      }
    }
    upgradePlan {
      defaultFrequency
      calorieGroup
      addonUnits
      sellingPlanId
      shopifyId
      price
      planType
      id
    }
    pet {
      petName
      birthDate
      weight
      gender
      id
      wellnessGoals {
        name
      }
      ingredients {
        name
      }
    }
    shippingAddress {
      id
      name
      address
      aptNo
      city
      stateAbbr
      zipCode
      phoneNumber
    }
    paymentMethod {
      cardLast4
      cardMonth
      cardYear
      lowercaseMetadata {
        company
        wallet
        paypalEmail
      }
    }
    treats {
      ...ProductItemAttrs
    }
    supplements {
      ...ProductItemAttrs
    }
    freshBakedEntrees {
      ...ProductItemAttrs
    }
    freshCookedEntrees {
      ...ProductItemAttrs
    }
    addons {
      ...ProductItemAttrs
    }
    v2Orders {
      id
      humanizedState
      renewal
      lastChargeSuccessful
      couponsData
    }
  }
}
    ${AccountSubscriptionDetailRecommendedProductAttrsFragmentDoc}
${ProductItemAttrsFragmentDoc}`;
export const GetSurveyOptionsDocument = gql`
    query GetSurveyOptions {
  surveyOptions {
    pauseReason {
      label
      value
    }
    cancelReason {
      label
      value
    }
  }
}
    `;
export const GetDiscountInfoDocument = gql`
    query GetDiscountInfo($codes: [String!]!) {
  shopifyDiscountInfo(codes: $codes) {
    title
    amount
    status
    percentage
    customPromoText
    inferredBannerText
    affectsClass
    affectedProductSkus
    affectedCollections
  }
}
    `;
export const MainNavContentDocument = gql`
    query MainNavContent {
  Nav {
    links {
      id
      title
      url
      isLinkPrefetched
    }
    sections {
      header
      id
      links {
        id
        title
        url
        isLinkPrefetched
      }
    }
  }
}
    `;
export const MainFooterContentDocument = gql`
    query MainFooterContent {
  Footer {
    sections {
      id
      header
      links {
        id
        title
        url
        isLinkPrefetched
        stripQueryParams
      }
    }
  }
}
    `;
export const RedeemPromoDocument = gql`
    mutation RedeemPromo($subId: ID!, $couponCode: String!, $addonSku: String!, $addonQuantity: Int, $replaceCoupons: Boolean) {
  redeemCouponPromo(
    input: {subscriptionId: $subId, couponCode: $couponCode, addonSku: $addonSku, addonQuantity: $addonQuantity, replaceCoupons: $replaceCoupons}
  ) {
    success
  }
}
    `;
export const RedeemPromoGetSubscriptionDocument = gql`
    query RedeemPromoGetSubscription($id: String!) {
  subscription(id: $id) {
    id
    coupons {
      code
    }
  }
}
    `;
export const AdminOperationsDashboardRecentOrdersDocument = gql`
    query AdminOperationsDashboardRecentOrders {
  operationsRecentOrders {
    date
    ppSc
    ppEc
    ppCh
    ppSample
    ppAd
    ppAz
  }
}
    `;
export const AdminSubscriptionStatisticsReportDocument = gql`
    query AdminSubscriptionStatisticsReport($startDate: ISO8601Date!, $endDate: ISO8601Date!) {
  subscriptionStatisticsReport(startDate: $startDate, endDate: $endDate) {
    url
  }
}
    `;
export const AdminOperationsDashboardActiveSubscriptionsDocument = gql`
    query AdminOperationsDashboardActiveSubscriptions {
  operationsActiveSubscriptions {
    stats
  }
}
    `;
export const AdminOperationsDashboardOrdersWithoutSyncDocument = gql`
    query AdminOperationsDashboardOrdersWithoutSync {
  operationsOrdersWithoutSync {
    shopifyOrderId
    error
    topic
    createdAt
  }
}
    `;
export const AdminAutomationDocument = gql`
    query AdminAutomation($id: String!) {
  automation(id: $id) {
    ...AutomationProps
  }
}
    ${AutomationPropsFragmentDoc}`;
export const AdminAutomationsDocument = gql`
    query AdminAutomations($first: Int, $last: Int, $before: String, $id: ID, $after: String, $name: AutomationName, $weekday: AutomationWeekday, $active: Boolean) {
  automations(
    first: $first
    last: $last
    before: $before
    id: $id
    after: $after
    name: $name
    weekday: $weekday
    active: $active
  ) {
    nodes {
      ...AutomationProps
    }
    pageInfo {
      endCursor
      currentPage
      totalPages
    }
  }
}
    ${AutomationPropsFragmentDoc}`;
export const AdminAutomationCreateDocument = gql`
    mutation AdminAutomationCreate($input: AutomationCreateInput!) {
  automationCreate(input: $input) {
    automation {
      ...AutomationProps
    }
  }
}
    ${AutomationPropsFragmentDoc}`;
export const AdminAutomationUpdateDocument = gql`
    mutation AdminAutomationUpdate($input: AutomationUpdateInput!) {
  automationUpdate(input: $input) {
    automation {
      ...AutomationProps
    }
  }
}
    ${AutomationPropsFragmentDoc}`;
export const AdminAutomationRunDocument = gql`
    mutation AdminAutomationRun($input: AutomationRunInput!) {
  automationRun(input: $input) {
    automation {
      ...AutomationProps
    }
  }
}
    ${AutomationPropsFragmentDoc}`;
export const AdminAutomationDeleteDocument = gql`
    mutation AdminAutomationDelete($input: AutomationDeleteInput!) {
  automationDelete(input: $input) {
    automation {
      id
    }
  }
}
    `;
export const AdminDeleteMealVariantDocument = gql`
    mutation AdminDeleteMealVariant($id: ID!) {
  mealVariantDelete(input: {id: $id}) {
    mealVariant {
      id
    }
  }
}
    `;
export const AdminUpdateMealVariantDocument = gql`
    mutation AdminUpdateMealVariant($input: MealVariantUpdateInput!) {
  mealVariantUpdate(input: $input) {
    mealVariant {
      id
    }
  }
}
    `;
export const AdminMealVariantCreateDocument = gql`
    mutation AdminMealVariantCreate($input: MealVariantCreateInput!) {
  mealVariantCreate(input: $input) {
    mealVariant {
      ...MealVariantProps
    }
  }
}
    ${MealVariantPropsFragmentDoc}`;
export const AdminMealVariantDocument = gql`
    query AdminMealVariant($id: String!) {
  mealVariant(id: $id) {
    meal {
      name
      sku
      parentShopifyId
      id
    }
    boxVariant {
      name
      sku
      id
    }
    id
    state
    name
    sku
    preferred
    outOfStock
    createdAt
    updatedAt
  }
}
    `;
export const AdminDeleteProductVariantDocument = gql`
    mutation AdminDeleteProductVariant($id: ID!) {
  productVariantDelete(input: {id: $id}) {
    productVariant {
      id
    }
  }
}
    `;
export const AdminUpdateProductVariantDocument = gql`
    mutation AdminUpdateProductVariant($input: ProductVariantUpdateInput!) {
  productVariantUpdate(input: $input) {
    productVariant {
      id
    }
  }
}
    `;
export const AdminProductVariantCreateDocument = gql`
    mutation AdminProductVariantCreate($input: ProductVariantCreateInput!) {
  productVariantCreate(input: $input) {
    productVariant {
      ...ProductVariantProps
    }
  }
}
    ${ProductVariantPropsFragmentDoc}`;
export const AdminProductVariantDocument = gql`
    query AdminProductVariant($id: String!) {
  productVariant(id: $id) {
    product {
      name
      sku
      parentShopifyId
      id
    }
    boxVariant {
      name
      sku
      id
    }
    id
    state
    name
    sku
    preferred
    outOfStock
    createdAt
    updatedAt
  }
}
    `;
export const AdminBoxVariantDocument = gql`
    query AdminBoxVariant($id: String!) {
  boxVariant(id: $id) {
    ...BoxVariantProps
  }
}
    ${BoxVariantPropsFragmentDoc}`;
export const AdminBoxVariantsDocument = gql`
    query AdminBoxVariants($first: Int, $last: Int, $id: ID, $before: String, $after: String, $order: ResolversBoxVariantsResolverOrder) {
  boxVariants(
    first: $first
    last: $last
    before: $before
    after: $after
    order: $order
    id: $id
  ) {
    nodes {
      ...BoxVariantProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${BoxVariantPropsFragmentDoc}`;
export const AdminBoxVariantCreateDocument = gql`
    mutation AdminBoxVariantCreate($input: BoxVariantCreateInput!) {
  boxVariantCreate(input: $input) {
    boxVariant {
      ...BoxVariantProps
    }
  }
}
    ${BoxVariantPropsFragmentDoc}`;
export const AdminBoxVariantUpdateDocument = gql`
    mutation AdminBoxVariantUpdate($input: BoxVariantUpdateInput!) {
  boxVariantUpdate(input: $input) {
    boxVariant {
      ...BoxVariantProps
    }
  }
}
    ${BoxVariantPropsFragmentDoc}`;
export const AdminBoxDocument = gql`
    query AdminBox($id: String!) {
  box(id: $id) {
    ...BoxProps
    bagQuantity
    bagWeight
    bagVolume
    itemQuantity
    itemWeight
    itemVolume
    routeCode
    state
    packaging {
      id
      name
      code
      description
    }
    boxVariants {
      id
      sku
      name
      addonUnits
      calorieGroup
      category
      defaultFrequency
      mealsPerDay
      price
      planType
      meals {
        id
        sku
        category
        name
        weightInOunces
        price
        shopifyId
        surchargeAmount
      }
      products {
        id
        name
        category
        price
        sku
        recipe {
          id
          name
        }
        weightInOunces
        shopifyId
        surchargeAmount
      }
    }
  }
}
    ${BoxPropsFragmentDoc}`;
export const AdminBoxesDocument = gql`
    query AdminBoxes($first: Int, $last: Int, $id: ID, $before: String, $after: String, $order: ResolversBoxesResolverOrder, $name: String, $sku: String, $state: TypesBoxInputTypeState, $planType: BoxVariantPlanTypeEnum, $routeCode: RouteCode, $boxVariantSku: String) {
  boxes(
    first: $first
    id: $id
    last: $last
    before: $before
    after: $after
    order: $order
    name: $name
    sku: $sku
    state: $state
    planType: $planType
    routeCode: $routeCode
    boxVariantSku: $boxVariantSku
  ) {
    nodes {
      id
      sku
      routeCode
      boxVariants {
        id
        sku
        name
        calorieGroup
      }
      bagQuantity
      bagWeight
      bagVolume
      itemQuantity
      itemWeight
      itemVolume
      packaging {
        name
      }
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    `;
export const AdminBoxCreateDocument = gql`
    mutation AdminBoxCreate($input: BoxCreateInput!) {
  boxCreate(input: $input) {
    box {
      ...BoxProps
    }
  }
}
    ${BoxPropsFragmentDoc}`;
export const AdminBoxUpdateDocument = gql`
    mutation AdminBoxUpdate($input: BoxUpdateInput!) {
  boxUpdate(input: $input) {
    box {
      ...BoxProps
    }
  }
}
    ${BoxPropsFragmentDoc}`;
export const AdminSearchPackagingsDocument = gql`
    query AdminSearchPackagings($name: String, $cursor: String) {
  packagings(first: 20, name: $name, after: $cursor) {
    nodes {
      id
      name
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminBreedDocument = gql`
    query AdminBreed($id: String!) {
  breed(id: $id) {
    ...BreedProps
  }
}
    ${BreedPropsFragmentDoc}`;
export const AdminBreedsDocument = gql`
    query AdminBreeds($first: Int, $last: Int, $before: String, $id: ID, $after: String, $order: ResolversBreedsResolverOrder, $name: String, $active: Boolean) {
  breeds(
    first: $first
    last: $last
    before: $before
    id: $id
    after: $after
    order: $order
    name: $name
    active: $active
  ) {
    nodes {
      ...BreedProps
    }
    pageInfo {
      endCursor
      currentPage
      totalPages
    }
  }
}
    ${BreedPropsFragmentDoc}`;
export const AdminBreedCreateDocument = gql`
    mutation AdminBreedCreate($input: BreedCreateInput!) {
  breedCreate(input: $input) {
    breed {
      ...BreedProps
    }
  }
}
    ${BreedPropsFragmentDoc}`;
export const AdminBreedUpdateDocument = gql`
    mutation AdminBreedUpdate($input: BreedUpdateInput!) {
  breedUpdate(input: $input) {
    breed {
      ...BreedProps
    }
  }
}
    ${BreedPropsFragmentDoc}`;
export const AdminCalorieMultiplierDocument = gql`
    query AdminCalorieMultiplier($id: String!) {
  calorieMultiplier(id: $id) {
    ...CalorieMultiplierProps
  }
}
    ${CalorieMultiplierPropsFragmentDoc}`;
export const AdminCalorieMultipliersDocument = gql`
    query AdminCalorieMultipliers($first: Int, $last: Int, $id: ID, $before: String, $after: String, $order: ResolversCalorieMultipliersResolverOrder, $activityLevel: String, $bodyCondition: String) {
  calorieMultipliers(
    first: $first
    last: $last
    before: $before
    id: $id
    after: $after
    order: $order
    bodyCondition: $bodyCondition
    activityLevel: $activityLevel
  ) {
    nodes {
      ...CalorieMultiplierProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${CalorieMultiplierPropsFragmentDoc}`;
export const AdminCalorieMultiplierCreateDocument = gql`
    mutation AdminCalorieMultiplierCreate($input: CalorieMultiplierCreateInput!) {
  calorieMultiplierCreate(input: $input) {
    calorieMultiplier {
      ...CalorieMultiplierProps
    }
  }
}
    ${CalorieMultiplierPropsFragmentDoc}`;
export const AdminCalorieMultiplierUpdateDocument = gql`
    mutation AdminCalorieMultiplierUpdate($input: CalorieMultiplierUpdateInput!) {
  calorieMultiplierUpdate(input: $input) {
    calorieMultiplier {
      ...CalorieMultiplierProps
    }
  }
}
    ${CalorieMultiplierPropsFragmentDoc}`;
export const AdminCalorieMultiplierRemoveDocument = gql`
    mutation AdminCalorieMultiplierRemove($id: ID!) {
  calorieMultiplierDelete(input: {id: $id}) {
    calorieMultiplier {
      ...CalorieMultiplierProps
    }
  }
}
    ${CalorieMultiplierPropsFragmentDoc}`;
export const AdminCancellationSurveyDocument = gql`
    query AdminCancellationSurvey($id: String!) {
  cancellationSurvey(id: $id) {
    ...CancellationSurveyProps
  }
}
    ${CancellationSurveyPropsFragmentDoc}`;
export const AdminCancellationSurveysDocument = gql`
    query AdminCancellationSurveys($id: ID, $first: Int, $last: Int, $before: String, $after: String, $order: ResolversCancellationSurveysResolverOrder, $subscriptionNumber: String, $createdAtFrom: ISO8601DateTime, $createdAtTo: ISO8601DateTime, $cancellationReason: String, $cancellationReasonOther: String) {
  cancellationSurveys(
    first: $first
    last: $last
    id: $id
    before: $before
    after: $after
    order: $order
    subscriptionNumber: $subscriptionNumber
    createdAtFrom: $createdAtFrom
    createdAtTo: $createdAtTo
    cancellationReason: $cancellationReason
    cancellationReasonOther: $cancellationReasonOther
  ) {
    nodes {
      ...CancellationSurveyProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${CancellationSurveyPropsFragmentDoc}`;
export const AdminCancellationSurveyCreateDocument = gql`
    mutation AdminCancellationSurveyCreate($input: CancellationSurveyCreateInput!) {
  cancellationSurveyCreate(input: $input) {
    cancellationSurvey {
      ...CancellationSurveyProps
    }
  }
}
    ${CancellationSurveyPropsFragmentDoc}`;
export const AdminCancellationSurveyUpdateDocument = gql`
    mutation AdminCancellationSurveyUpdate($input: CancellationSurveyUpdateInput!) {
  cancellationSurveyUpdate(input: $input) {
    cancellationSurvey {
      ...CancellationSurveyProps
    }
  }
}
    ${CancellationSurveyPropsFragmentDoc}`;
export const AdminSearchTermsDocument = gql`
    query AdminSearchTerms($name: String, $cursor: String) {
  terms(first: 20, name: $name, after: $cursor) {
    nodes {
      id
      name
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminSearchSubscriptionsDocument = gql`
    query AdminSearchSubscriptions($number: String, $cursor: String) {
  subscriptions(first: 20, number: $number, after: $cursor) {
    nodes {
      id
      number
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const ChangelogDocument = gql`
    query Changelog($itemId: ID!, $itemType: VersionedModelClassEnum, $after: String) {
  changelogEntries(itemId: $itemId, itemType: $itemType, first: 10, after: $after) {
    nodes {
      createdAt
      event
      itemId
      itemType
      whodunnit
      changes
    }
    pageInfo {
      endCursor
      hasNextPage
      totalPages
      pageSize
    }
  }
}
    `;
export const SubscriptionChangelogDocument = gql`
    query SubscriptionChangelog($id: String, $after: String) {
  subscription(id: $id) {
    changelogEntries(first: 10, after: $after) {
      nodes {
        createdAt
        event
        itemId
        itemType
        whodunnit
        changes
      }
      pageInfo {
        endCursor
        hasNextPage
        totalPages
        pageSize
      }
    }
  }
}
    `;
export const AdminCommentDocument = gql`
    query AdminComment($id: String!) {
  ppComment(id: $id) {
    ...CommentProps
  }
}
    ${CommentPropsFragmentDoc}`;
export const AdminCommentRmDocument = gql`
    mutation AdminCommentRm($id: ID!) {
  ppCommentDelete(input: {id: $id}) {
    ppComment {
      ...CommentProps
    }
  }
}
    ${CommentPropsFragmentDoc}`;
export const AdminCommentsDocument = gql`
    query AdminComments($first: Int, $id: ID, $last: Int, $before: String, $after: String, $order: ResolversPpCommentsResolverOrder, $resourceType: PpCommentResource, $resourceId: ID, $namespace: String, $body: String, $createdAtTo: ISO8601DateTime, $createdAtFrom: ISO8601DateTime) {
  ppComments(
    id: $id
    first: $first
    last: $last
    before: $before
    after: $after
    order: $order
    resourceType: $resourceType
    resourceId: $resourceId
    namespace: $namespace
    body: $body
    createdAtTo: $createdAtTo
    createdAtFrom: $createdAtFrom
  ) {
    nodes {
      ...CommentProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${CommentPropsFragmentDoc}`;
export const AdminCommentCreateDocument = gql`
    mutation AdminCommentCreate($input: PpCommentCreateInput!) {
  ppCommentCreate(input: $input) {
    ppComment {
      ...CommentProps
    }
  }
}
    ${CommentPropsFragmentDoc}`;
export const AdminConversionSurveyDocument = gql`
    query AdminConversionSurvey($id: String!) {
  conversionSurvey(id: $id) {
    ...ConversionSurveyProps
  }
}
    ${ConversionSurveyPropsFragmentDoc}`;
export const AdminConversionSurveysDocument = gql`
    query AdminConversionSurveys($first: Int, $last: Int, $before: String, $id: ID, $after: String, $order: ResolversConversionSurveysResolverOrder, $source: String) {
  conversionSurveys(
    first: $first
    last: $last
    id: $id
    before: $before
    after: $after
    order: $order
    source: $source
  ) {
    nodes {
      ...ConversionSurveyProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${ConversionSurveyPropsFragmentDoc}`;
export const AdminConversionSurveyCreateDocument = gql`
    mutation AdminConversionSurveyCreate($input: ConversionSurveyCreateInput!) {
  conversionSurveyCreate(input: $input) {
    conversionSurvey {
      ...ConversionSurveyProps
    }
  }
}
    ${ConversionSurveyPropsFragmentDoc}`;
export const AdminConversionSurveyUpdateDocument = gql`
    mutation AdminConversionSurveyUpdate($input: ConversionSurveyUpdateInput!) {
  conversionSurveyUpdate(input: $input) {
    conversionSurvey {
      ...ConversionSurveyProps
    }
  }
}
    ${ConversionSurveyPropsFragmentDoc}`;
export const AdminUpdateCouponDocument = gql`
    mutation AdminUpdateCoupon($input: CouponUpdateInput!) {
  couponUpdate(input: $input) {
    coupon {
      id
    }
  }
}
    `;
export const AdminImportShopifyCouponDocument = gql`
    mutation AdminImportShopifyCoupon($input: CouponImportInput!) {
  couponImport(input: $input) {
    result {
      errorMessage
      coupon {
        id
        code
      }
    }
  }
}
    `;
export const AdminRefreshCouponDocument = gql`
    mutation AdminRefreshCoupon($input: CouponRefreshInput!) {
  couponRefresh(input: $input) {
    result {
      errorMessage
      coupon {
        id
        code
      }
    }
  }
}
    `;
export const AdminCouponsDocument = gql`
    query AdminCoupons($first: Int, $last: Int, $before: String, $after: String, $code: String, $order: ResolversCouponsResolverOrder, $shopifyReady: Boolean, $duration: CouponDurationEnum) {
  coupons(
    first: $first
    last: $last
    before: $before
    after: $after
    code: $code
    order: $order
    shopifyReady: $shopifyReady
    duration: $duration
  ) {
    nodes {
      ...CouponProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${CouponPropsFragmentDoc}`;
export const AdminCouponDocument = gql`
    query AdminCoupon($id: String!) {
  coupon(id: $id) {
    ...CouponProps
    customPromoText
  }
}
    ${CouponPropsFragmentDoc}`;
export const AdminSearchPlatformCouponsDocument = gql`
    query AdminSearchPlatformCoupons($code: String, $cursor: String) {
  coupons(first: 20, code: $code, after: $cursor) {
    nodes {
      id
      code
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminStoreCreditAccountDocument = gql`
    query AdminStoreCreditAccount($id: String!) {
  storeCreditAccount(id: $id) {
    ...StoreCreditAccountProps
  }
}
    ${StoreCreditAccountPropsFragmentDoc}`;
export const AdminStoreCreditAccountsDocument = gql`
    query AdminStoreCreditAccounts($first: Int, $last: Int, $id: ID, $after: String, $before: String, $order: ResolversStoreCreditAccountsResolverOrder, $number: String) {
  storeCreditAccounts(
    first: $first
    last: $last
    id: $id
    before: $before
    after: $after
    order: $order
    number: $number
  ) {
    nodes {
      ...StoreCreditAccountProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${StoreCreditAccountPropsFragmentDoc}`;
export const AdminStoreCreditAccountCreateDocument = gql`
    mutation AdminStoreCreditAccountCreate($input: StoreCreditAccountCreateInput!) {
  storeCreditAccountCreate(input: $input) {
    storeCreditAccount {
      ...StoreCreditAccountProps
    }
  }
}
    ${StoreCreditAccountPropsFragmentDoc}`;
export const AdminStoreCreditAccountUpdateDocument = gql`
    mutation AdminStoreCreditAccountUpdate($input: StoreCreditAccountUpdateInput!) {
  storeCreditAccountUpdate(input: $input) {
    storeCreditAccount {
      ...StoreCreditAccountProps
    }
  }
}
    ${StoreCreditAccountPropsFragmentDoc}`;
export const AdminSearchStoreCreditAccountsDocument = gql`
    query AdminSearchStoreCreditAccounts($number: String, $cursor: String) {
  storeCreditAccounts(first: 20, number: $number, after: $cursor) {
    nodes {
      id
      number
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminUserCreditAccountDocument = gql`
    query AdminUserCreditAccount($id: String!) {
  user(id: $id) {
    id
    ensuredStoreCreditAccount {
      id
      number
    }
  }
}
    `;
export const AdminStoreCreditMovementDocument = gql`
    query AdminStoreCreditMovement($id: String!) {
  storeCreditMovement(id: $id) {
    ...StoreCreditMovementProps
  }
}
    ${StoreCreditMovementPropsFragmentDoc}`;
export const AdminStoreCreditReasonsDocument = gql`
    query AdminStoreCreditReasons {
  surveyOptions {
    creditReason {
      label
      value
    }
  }
}
    `;
export const AdminStoreCreditMovementsDocument = gql`
    query AdminStoreCreditMovements($first: Int, $userId: ID, $last: Int, $before: String, $after: String, $id: ID, $order: ResolversStoreCreditMovementsResolverOrder) {
  storeCreditMovements(
    first: $first
    last: $last
    userId: $userId
    before: $before
    after: $after
    order: $order
    id: $id
  ) {
    nodes {
      ...StoreCreditMovementProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${StoreCreditMovementPropsFragmentDoc}`;
export const AdminStoreCreditMovementCreateDocument = gql`
    mutation AdminStoreCreditMovementCreate($input: StoreCreditMovementCreateInput!) {
  storeCreditMovementCreate(input: $input) {
    storeCreditMovement {
      ...StoreCreditMovementProps
    }
  }
}
    ${StoreCreditMovementPropsFragmentDoc}`;
export const AdminStoreCreditMovementUpdateDocument = gql`
    mutation AdminStoreCreditMovementUpdate($input: StoreCreditMovementUpdateInput!) {
  storeCreditMovementUpdate(input: $input) {
    storeCreditMovement {
      ...StoreCreditMovementProps
    }
  }
}
    ${StoreCreditMovementPropsFragmentDoc}`;
export const AdminDryIceMatrixTiersDocument = gql`
    query AdminDryIceMatrixTiers {
  dryIceMatrixTiers {
    ...DryIceMatrixTierProps
  }
}
    ${DryIceMatrixTierPropsFragmentDoc}`;
export const AdminDryIceMatrixTierUpdateDocument = gql`
    mutation AdminDryIceMatrixTierUpdate($input: DryIceMatrixTierUpdateInput!) {
  dryIceMatrixTierUpdate(input: $input) {
    dryIceMatrixTier {
      ...DryIceMatrixTierProps
    }
  }
}
    ${DryIceMatrixTierPropsFragmentDoc}`;
export const AdminDryIceTransitWarehousesDocument = gql`
    query AdminDryIceTransitWarehouses {
  dryIceWarehouses {
    warehouseCode
    transits {
      id
      transitCode
    }
  }
}
    `;
export const AdminTransitDocument = gql`
    query AdminTransit($id: String!) {
  transitConfiguration(id: $id) {
    id
    transitCode
    dryIcePackagings {
      ...AdminDryIcePackagingFragment
    }
  }
}
    ${AdminDryIcePackagingFragmentFragmentDoc}`;
export const AdminDryIcePackagingDocument = gql`
    query AdminDryIcePackaging($id: String!) {
  dryIcePackaging(id: $id) {
    ...AdminDryIcePackagingFragment
  }
}
    ${AdminDryIcePackagingFragmentFragmentDoc}`;
export const AdminDryIcePackagingMassUpdateDocument = gql`
    mutation AdminDryIcePackagingMassUpdate($inputs: DryIcePackagingMassUpdateInput!) {
  dryIcePackagingMassUpdate(input: $inputs) {
    dryIcePackagings {
      ...AdminDryIcePackagingFragment
    }
  }
}
    ${AdminDryIcePackagingFragmentFragmentDoc}`;
export const AdminDryIcePackagingMassCreateDocument = gql`
    mutation AdminDryIcePackagingMassCreate($inputs: [MutationsDryIcePackagingMassCreateMassCreate!]!) {
  dryIcePackagingMassCreate(input: {inputs: $inputs}) {
    dryIcePackagings {
      ...AdminDryIcePackagingFragment
    }
  }
}
    ${AdminDryIcePackagingFragmentFragmentDoc}`;
export const AdminDryIcePackagingDeleteDocument = gql`
    mutation AdminDryIcePackagingDelete($id: ID!) {
  dryIcePackagingDelete(input: {id: $id}) {
    dryIcePackaging {
      id
    }
  }
}
    `;
export const AdminTransitConfigurationCreateDocument = gql`
    mutation AdminTransitConfigurationCreate($input: TransitConfigurationCreateInput!) {
  transitConfigurationCreate(input: $input) {
    transitConfiguration {
      id
      transitCode
      warehouseCode
    }
  }
}
    `;
export const AdminTransitConfigurationDeleteDocument = gql`
    mutation AdminTransitConfigurationDelete($id: ID!) {
  transitConfigurationDelete(input: {id: $id}) {
    transitConfiguration {
      id
    }
  }
}
    `;
export const AdminLineItemRuleDocument = gql`
    query AdminLineItemRule($id: String!) {
  lineItemRule(id: $id) {
    ...LineItemRuleProps
  }
}
    ${LineItemRulePropsFragmentDoc}`;
export const AdminLineItemRulesDocument = gql`
    query AdminLineItemRules($first: Int, $last: Int, $before: String, $after: String, $order: ResolversLineItemRulesResolverOrder) {
  lineItemRules(
    first: $first
    last: $last
    before: $before
    after: $after
    order: $order
  ) {
    nodes {
      ...LineItemRuleProps
    }
    pageInfo {
      endCursor
      currentPage
      totalPages
    }
  }
}
    ${LineItemRulePropsFragmentDoc}`;
export const AdminLineItemRuleCreateDocument = gql`
    mutation AdminLineItemRuleCreate($input: LineItemRuleCreateInput!) {
  lineItemRuleCreate(input: $input) {
    lineItemRule {
      ...LineItemRuleProps
    }
  }
}
    ${LineItemRulePropsFragmentDoc}`;
export const AdminLineItemRuleUpdateDocument = gql`
    mutation AdminLineItemRuleUpdate($input: LineItemRuleUpdateInput!) {
  lineItemRuleUpdate(input: $input) {
    lineItemRule {
      ...LineItemRuleProps
    }
  }
}
    ${LineItemRulePropsFragmentDoc}`;
export const AdminSearchLineRuleSetsDocument = gql`
    query AdminSearchLineRuleSets($name: String, $cursor: String, $id: ID) {
  lineItemRuleSets(first: 20, lineItemName: $name, after: $cursor, id: $id) {
    nodes {
      active
      conflictStrategy
      createdAt
      description
      id
      limit
      limitStrategy
      lineItemDiscount
      lineItemName
      lineItemWeight
      lineItemPrice
      lineItemQuantity
      lineItemSku
      lineItemOutOfStock
      lineItemType
      logicOperator
      mergeCostStrategy
      mergeNameStrategy
      mergeQuantityStrategy
      mergeWeightStrategy
      priority
      updatedAt
      rules {
        id
        active
        fieldName
        operator
        value
      }
    }
    pageInfo {
      endCursor
      totalPages
      currentPage
    }
  }
}
    `;
export const AdminPutDynamicLineItemDocument = gql`
    mutation AdminPutDynamicLineItem($input: DynamicLineItemPutInput!) {
  dynamicLineItem(input: $input) {
    id
  }
}
    `;
export const AdminDynamicLineItemDocument = gql`
    query AdminDynamicLineItem($id: String!) {
  lineItemRule(id: $id) {
    active
    fieldName
    id
    operator
    value
  }
}
    `;
export const AdminDynamicLineItemRuleSetDocument = gql`
    query AdminDynamicLineItemRuleSet($id: String!) {
  lineItemRuleSet(id: $id) {
    ...AdminDynamicLineItemRuleSet
  }
}
    ${AdminDynamicLineItemRuleSetFragmentDoc}`;
export const AdminDynamicLineItemRuleSetsDocument = gql`
    query AdminDynamicLineItemRuleSets($first: Int, $last: Int, $before: String, $after: String, $order: ResolversLineItemRuleSetsResolverOrder, $active: Boolean, $conflictStrategy: String, $lineItemName: String, $priority: Int, $id: ID, $lineItemQuantity: Int, $lineItemSku: String, $lineItemOutOfStock: Boolean, $lineItemReplaceSku: String, $lineItemPrice: Float, $lineItemDiscount: Float, $lineItemType: String, $limitStrategy: MutationsDynamicLineItemPutLimitAction, $mergeCostStrategy: MutationsDynamicLineItemPutDupCostAction, $mergeNameStrategy: MutationsDynamicLineItemPutDupNameAction, $mergeQuantityStrategy: MutationsDynamicLineItemPutDupCountAction, $description: String) {
  lineItemRuleSets(
    first: $first
    id: $id
    last: $last
    before: $before
    after: $after
    priority: $priority
    order: $order
    active: $active
    conflictStrategy: $conflictStrategy
    lineItemName: $lineItemName
    lineItemQuantity: $lineItemQuantity
    lineItemSku: $lineItemSku
    lineItemReplaceSku: $lineItemReplaceSku
    lineItemOutOfStock: $lineItemOutOfStock
    lineItemPrice: $lineItemPrice
    lineItemDiscount: $lineItemDiscount
    lineItemType: $lineItemType
    limitStrategy: $limitStrategy
    mergeCostStrategy: $mergeCostStrategy
    mergeNameStrategy: $mergeNameStrategy
    mergeQuantityStrategy: $mergeQuantityStrategy
    description: $description
  ) {
    nodes {
      ...AdminDynamicLineItemRuleSet
    }
    pageInfo {
      endCursor
      currentPage
      totalPages
    }
  }
}
    ${AdminDynamicLineItemRuleSetFragmentDoc}`;
export const AdminDynamicLineItemRuleValuesDocument = gql`
    query AdminDynamicLineItemRuleValues {
  lineItemRuleValues {
    name
    type
    collection {
      label
      value
    }
  }
}
    `;
export const AdminSearchZipCodesDocument = gql`
    query AdminSearchZipCodes($cursor: String, $zipCode: String) {
  zipCodes(first: 20, after: $cursor, zipCode: $zipCode) {
    nodes {
      id
      zipCode
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminSearchOrdersDocument = gql`
    query AdminSearchOrders($cursor: String, $orderNumber: String) {
  dbOrders(first: 20, after: $cursor, orderNumber: $orderNumber) {
    nodes {
      id
      orderNumber
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminLogEventDocument = gql`
    query AdminLogEvent($id: String!) {
  logEvent(id: $id) {
    ...LogEventProps
  }
}
    ${LogEventPropsFragmentDoc}`;
export const AdminLogEventsDocument = gql`
    query AdminLogEvents($first: Int, $last: Int, $before: String, $after: String, $order: ResolversLogEventsResolverOrder, $event: String, $id: ID, $sourceType: String, $targetType: String, $targetId: ID) {
  logEvents(
    first: $first
    last: $last
    before: $before
    after: $after
    id: $id
    order: $order
    event: $event
    sourceType: $sourceType
    targetType: $targetType
    targetId: $targetId
  ) {
    nodes {
      ...LogEventProps
    }
    pageInfo {
      endCursor
      currentPage
      totalPages
    }
  }
}
    ${LogEventPropsFragmentDoc}`;
export const AdminLogEventCreateDocument = gql`
    mutation AdminLogEventCreate($input: LogEventCreateInput!) {
  logEventCreate(input: $input) {
    logEvent {
      ...LogEventProps
    }
  }
}
    ${LogEventPropsFragmentDoc}`;
export const AdminLogEventUpdateDocument = gql`
    mutation AdminLogEventUpdate($input: LogEventUpdateInput!) {
  logEventUpdate(input: $input) {
    logEvent {
      ...LogEventProps
    }
  }
}
    ${LogEventPropsFragmentDoc}`;
export const AdminReportJobDocument = gql`
    query AdminReportJob($id: String!) {
  reportJob(id: $id) {
    ...ReportJobProps
  }
}
    ${ReportJobPropsFragmentDoc}`;
export const AdminReportJobsDocument = gql`
    query AdminReportJobs($first: Int, $id: ID, $last: Int, $before: String, $after: String, $order: ResolversReportJobsResolverOrder, $name: String, $emails: String, $endedAtAfter: ISO8601DateTime, $endedAtBefore: ISO8601DateTime, $errorMessage: Boolean, $state: TypesReportJobInputTypeState, $startedAtBefore: ISO8601DateTime, $startedAtAfter: ISO8601DateTime, $logContentType: String, $logFileName: String, $outputContentType: String, $outputContentName: String) {
  reportJobs(
    id: $id
    first: $first
    last: $last
    before: $before
    after: $after
    order: $order
    name: $name
    emails: $emails
    endedAtAfter: $endedAtAfter
    endedAtBefore: $endedAtBefore
    errorMessage: $errorMessage
    state: $state
    startedAtBefore: $startedAtBefore
    startedAtAfter: $startedAtAfter
    logContentType: $logContentType
    logFileName: $logFileName
    outputContentType: $outputContentType
    outputContentName: $outputContentName
  ) {
    nodes {
      ...ReportJobProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${ReportJobPropsFragmentDoc}`;
export const AdminReportJobCreateDocument = gql`
    mutation AdminReportJobCreate($input: ReportJobCreateInput!) {
  reportJobCreate(input: $input) {
    reportJob {
      ...ReportJobProps
    }
  }
}
    ${ReportJobPropsFragmentDoc}`;
export const AdminReportJobUpdateDocument = gql`
    mutation AdminReportJobUpdate($input: ReportJobUpdateInput!) {
  reportJobUpdate(input: $input) {
    reportJob {
      ...ReportJobProps
    }
  }
}
    ${ReportJobPropsFragmentDoc}`;
export const AdminFulfillmentScheduleRuleDocument = gql`
    query AdminFulfillmentScheduleRule($id: String!) {
  fulfillmentScheduleRule(id: $id) {
    ...FulfillmentScheduleRuleProps
  }
}
    ${FulfillmentScheduleRulePropsFragmentDoc}`;
export const AdminFulfillmentScheduleRulesDocument = gql`
    query AdminFulfillmentScheduleRules($first: Int, $id: ID, $last: Int, $before: String, $after: String, $order: ResolversFulfillmentScheduleRulesResolverOrder, $routeCode: TypesRouteCodesType, $warehouseCode: String, $zipCode: String, $endDateBefore: ISO8601DateTime, $endDateAfter: ISO8601DateTime, $startDateBefore: ISO8601DateTime, $startDateAfter: ISO8601DateTime) {
  fulfillmentScheduleRules(
    first: $first
    last: $last
    id: $id
    before: $before
    after: $after
    order: $order
    routeCode: $routeCode
    warehouseCode: $warehouseCode
    zipCode: $zipCode
    endDateBefore: $endDateBefore
    endDateAfter: $endDateAfter
    startDateBefore: $startDateBefore
    startDateAfter: $startDateAfter
  ) {
    nodes {
      ...FulfillmentScheduleRuleProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${FulfillmentScheduleRulePropsFragmentDoc}`;
export const AdminFulfillmentScheduleRulesCreateDocument = gql`
    mutation AdminFulfillmentScheduleRulesCreate($input: FulfillmentScheduleRulesCreateInput!) {
  fulfillmentScheduleRulesCreate(input: $input) {
    success
    errors
  }
}
    `;
export const AdminFulfillmentScheduleRuleDeleteDocument = gql`
    mutation AdminFulfillmentScheduleRuleDelete($input: FulfillmentScheduleRuleDeleteInput!) {
  fulfillmentScheduleRuleDelete(input: $input) {
    fulfillmentScheduleRule {
      id
    }
  }
}
    `;
export const AdminFulfillmentScheduleRulesReportDocument = gql`
    query AdminFulfillmentScheduleRulesReport($id: ID, $order: ResolversFulfillmentScheduleRulesResolverOrder, $routeCode: TypesRouteCodesType, $warehouseCode: String, $zipCode: String, $endDateBefore: ISO8601DateTime, $endDateAfter: ISO8601DateTime, $startDateBefore: ISO8601DateTime, $startDateAfter: ISO8601DateTime) {
  fulfillmentScheduleRulesReport(
    id: $id
    order: $order
    routeCode: $routeCode
    warehouseCode: $warehouseCode
    zipCode: $zipCode
    endDateBefore: $endDateBefore
    endDateAfter: $endDateAfter
    startDateBefore: $startDateBefore
    startDateAfter: $startDateAfter
  ) {
    url
  }
}
    `;
export const AdminTransitConfigurationWarehousesDocument = gql`
    query AdminTransitConfigurationWarehouses {
  dryIceWarehouses {
    warehouseCode
  }
}
    `;
export const AdminImportJobDocument = gql`
    query AdminImportJob($id: String!) {
  importJob(id: $id) {
    ...AdminImportJobProperties
  }
}
    ${AdminImportJobPropertiesFragmentDoc}`;
export const AdminImportJobsDocument = gql`
    query AdminImportJobs($first: Int, $id: ID, $last: Int, $before: String, $after: String, $order: ResolversImportJobsResolverOrder, $error: Boolean) {
  importJobs(
    first: $first
    id: $id
    last: $last
    before: $before
    after: $after
    order: $order
    error: $error
  ) {
    nodes {
      ...AdminImportJobProperties
    }
    pageInfo {
      currentPage
      endCursor
      totalPages
    }
  }
}
    ${AdminImportJobPropertiesFragmentDoc}`;
export const AdminMealPlanRecommendationDocument = gql`
    query AdminMealPlanRecommendation($id: String!) {
  planMatchCriterium(id: $id) {
    ...AdminMealPlanMatchFrag
  }
}
    ${AdminMealPlanMatchFragFragmentDoc}`;
export const AdminMealPlanRecommendationsDocument = gql`
    query AdminMealPlanRecommendations($first: Int, $after: String, $order: ResolversPlanMatchCriteriaResolverOrder, $id: ID, $active: Boolean, $status: PlanMatchCriteriumStatus, $groupingName: TypesPlanMatchCriteriumInputTypeGroupingType, $ageGroup: TypesPlanMatchCriteriumInputTypeAgeGroup) {
  planMatchCriteria(
    first: $first
    after: $after
    id: $id
    order: $order
    active: $active
    status: $status
    groupingName: $groupingName
    ageGroup: $ageGroup
  ) {
    nodes {
      ...AdminMealPlanMatchFrag
    }
    pageInfo {
      currentPage
      totalPages
      endCursor
      hasNextPage
    }
  }
}
    ${AdminMealPlanMatchFragFragmentDoc}`;
export const AdminMealPlanRecommendationCreateDocument = gql`
    mutation AdminMealPlanRecommendationCreate($input: PlanMatchCriteriumCreateInput!) {
  planMatchCriteriumCreate(input: $input) {
    planMatchCriterium {
      id
    }
  }
}
    `;
export const AdminMealPlanRecommendationUpdateDocument = gql`
    mutation AdminMealPlanRecommendationUpdate($input: PlanMatchCriteriumUpdateInput!) {
  planMatchCriteriumUpdate(input: $input) {
    planMatchCriterium {
      id
    }
  }
}
    `;
export const MealPlanVariantUpdateDocument = gql`
    mutation MealPlanVariantUpdate($input: MealPlanVariantUpdateInput!) {
  mealPlanVariantUpdate(input: $input) {
    success
  }
}
    `;
export const AdminMealDocument = gql`
    query AdminMeal($id: String!) {
  meal(id: $id) {
    ...MealProps
  }
}
    ${MealPropsFragmentDoc}`;
export const AdminMealsDocument = gql`
    query AdminMeals($first: Int, $last: Int, $before: String, $after: String, $order: ResolversMealsResolverOrder, $name: String, $sku: String, $slug: String) {
  meals(
    first: $first
    last: $last
    before: $before
    after: $after
    order: $order
    name: $name
    sku: $sku
    slug: $slug
  ) {
    nodes {
      ...MealListProps
    }
    pageInfo {
      endCursor
      currentPage
      totalPages
    }
  }
}
    ${MealListPropsFragmentDoc}`;
export const AdminMealUpdateDocument = gql`
    mutation AdminMealUpdate($input: MealUpdateInput!) {
  mealUpdate(input: $input) {
    meal {
      ...MealProps
    }
  }
}
    ${MealPropsFragmentDoc}`;
export const AdminNotificationBannersDocument = gql`
    query AdminNotificationBanners($first: Int, $last: Int, $before: String, $after: String, $order: ResolversNotificationBannersResolverOrder) {
  notificationBanners(
    first: $first
    last: $last
    before: $before
    after: $after
    order: $order
  ) {
    nodes {
      ...NotificationBannerProps
    }
    pageInfo {
      currentPage
      endCursor
      totalPages
    }
  }
}
    ${NotificationBannerPropsFragmentDoc}`;
export const AdminNotificationBannerDocument = gql`
    query AdminNotificationBanner($id: String!) {
  notificationBanner(id: $id) {
    ...NotificationBannerProps
  }
}
    ${NotificationBannerPropsFragmentDoc}`;
export const AdminNotificationBannerCreateDocument = gql`
    mutation AdminNotificationBannerCreate($input: NotificationBannerCreateInput!) {
  notificationBannerCreate(input: $input) {
    notificationBanner {
      ...NotificationBannerProps
    }
  }
}
    ${NotificationBannerPropsFragmentDoc}`;
export const AdminNotificationBannerUpdateDocument = gql`
    mutation AdminNotificationBannerUpdate($input: NotificationBannerUpdateInput!) {
  notificationBannerUpdate(input: $input) {
    notificationBanner {
      ...NotificationBannerProps
    }
  }
}
    ${NotificationBannerPropsFragmentDoc}`;
export const AdminNotificationBannerDeleteDocument = gql`
    mutation AdminNotificationBannerDelete($id: ID!) {
  notificationBannerDelete(input: {id: $id}) {
    notificationBanner {
      ...NotificationBannerProps
    }
  }
}
    ${NotificationBannerPropsFragmentDoc}`;
export const AdminOperationsDashboardShippingScheduleDocument = gql`
    query AdminOperationsDashboardShippingSchedule($startDate: ISO8601Date, $endDate: ISO8601Date) {
  operationsShippingSchedule(startDate: $startDate, endDate: $endDate) {
    schedule
    statusTags
    subscriptionsScheduled
    orders {
      newOneoff
      newOneoffIds
      newRecurring
      newRecurringIds
      repeatOneoff
      repeatOneoffIds
      repeatRecurring
      repeatRecurringIds
    }
    payments {
      paid
      failed
      paidIds
      failedIds
    }
    shipments {
      waiting
      imported
      batched
      voided
      replaced
    }
    link
  }
}
    `;
export const AdminOperationsDashboardShippingListsDocument = gql`
    query AdminOperationsDashboardShippingLists {
  operationsShipmentLists {
    batch {
      id
      date
    }
    shipments
    status
    link
  }
}
    `;
export const AdminOperationsDashboardAlertsDocument = gql`
    query AdminOperationsDashboardAlerts {
  operationsShippingAlerts {
    alertPastOrders {
      missedDate
      id
    }
    alertChewyShipments {
      date
      count
    }
    alertPastSubscriptions {
      missedDate
      subscriptions
    }
    alertUnavailableDate {
      unavailableDate
      orders
    }
    alertUnavailableShipping {
      unavailableDate
      subscriptions
    }
  }
}
    `;
export const AdminOperationsDashboardInvalidZipCodeAlertsDocument = gql`
    query AdminOperationsDashboardInvalidZipCodeAlerts {
  invalidZipCodeAlerts {
    alertInvalidSubZipCodes {
      subscriptionId
      subscriptionStatus
    }
    alertInvalidOrderZipCodes {
      orderId
      orderShippingDate
      orderStatus
    }
  }
}
    `;
export const AdminOperationsDashboardUnsyncedDataDocument = gql`
    query AdminOperationsDashboardUnsyncedData {
  unsyncedData {
    unsynchedOrders {
      count
      errors {
        id
        batchId
        error
      }
    }
    unsynchedOrdersPaymentWithShopify {
      count
    }
  }
}
    `;
export const AdminOperationsDashboardPaymentBatchesDocument = gql`
    query AdminOperationsDashboardPaymentBatches {
  operationsPaymentBatches {
    batch {
      id
      date
    }
    exports: export {
      charged
      failed
    }
    status
    link
  }
}
    `;
export const AdminOperationsDashboardSubscriptionStatisticsDocument = gql`
    query AdminOperationsDashboardSubscriptionStatistics {
  operationsSubscriptionStatistics {
    startDate
    endDate
    weeklyStats {
      date
      stats {
        active
        paused
        canceled
        created
      }
    }
  }
}
    `;
export const AdminOrderImportBatchEntryDocument = gql`
    query AdminOrderImportBatchEntry($id: String!) {
  orderImportBatchEntry(id: $id) {
    ...AdminOrderImportBatchEntryFragment
  }
}
    ${AdminOrderImportBatchEntryFragmentFragmentDoc}`;
export const AdminOrderImportBatchEntryOrdersDocument = gql`
    query AdminOrderImportBatchEntryOrders($orderImportBatchEntryId: ID, $first: Int, $after: String, $order: ResolversDbOrdersResolverOrder, $estimatedShippingDate: ISO8601DateTime, $contactName: String, $contactEmail: String, $contactPhoneNumber: String) {
  dbOrders(
    orderImportBatchEntryId: $orderImportBatchEntryId
    first: $first
    after: $after
    order: $order
    estimatedShippingDate: $estimatedShippingDate
    contactName: $contactName
    contactEmail: $contactEmail
    contactPhoneNumber: $contactPhoneNumber
  ) {
    nodes {
      ...AdminOrderImportBatchEntryOrderFragment
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${AdminOrderImportBatchEntryOrderFragmentFragmentDoc}`;
export const AdminOrderImportBatchesDocument = gql`
    query AdminOrderImportBatches($first: Int, $after: String, $order: ResolversOrderImportBatchesResolverOrder, $startedAtAfter: ISO8601DateTime, $startedAtBefore: ISO8601DateTime, $endedAtAfter: ISO8601DateTime, $endedAtBefore: ISO8601DateTime, $fromDateBefore: ISO8601DateTime, $fromDateAfter: ISO8601DateTime, $untilDateBefore: ISO8601DateTime, $untilDateAfter: ISO8601DateTime, $id: ID) {
  orderImportBatches(
    first: $first
    after: $after
    order: $order
    id: $id
    startedAtAfter: $startedAtAfter
    startedAtBefore: $startedAtBefore
    endedAtAfter: $endedAtAfter
    endedAtBefore: $endedAtBefore
    fromDateBefore: $fromDateBefore
    fromDateAfter: $fromDateAfter
    untilDateBefore: $untilDateBefore
    untilDateAfter: $untilDateAfter
  ) {
    nodes {
      ...AdminOrderImportBatchFragment
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${AdminOrderImportBatchFragmentFragmentDoc}`;
export const AdminOrderImportBatchDocument = gql`
    query AdminOrderImportBatch($id: String!) {
  orderImportBatch(id: $id) {
    ...AdminOrderImportBatchFragment
  }
}
    ${AdminOrderImportBatchFragmentFragmentDoc}`;
export const AdminOrderImportBatchEntriesDocument = gql`
    query AdminOrderImportBatchEntries($orderImportBatchId: ID, $first: Int, $after: String, $order: ResolversOrderImportBatchEntriesResolverOrder, $action: String, $id: ID, $poNumber: String) {
  orderImportBatchEntries(
    orderImportBatchId: $orderImportBatchId
    first: $first
    after: $after
    id: $id
    order: $order
    action: $action
    poNumber: $poNumber
  ) {
    nodes {
      ...AdminOrderImportBatchEntryFragment
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${AdminOrderImportBatchEntryFragmentFragmentDoc}`;
export const AdminDbOrdersDocument = gql`
    query AdminDbOrders($first: Int, $after: String, $order: ResolversDbOrdersResolverOrder, $paymentMethodId: ID, $id: ID, $ids: String, $channel: ResolversDbOrdersResolverChannel, $opsState: ResolversDbOrdersResolverOpsState, $state: TypesDbOrderInputTypeState, $humanizedState: OrderHumanizedState, $estimatedShippingDate: ISO8601DateTime, $contactName: String, $contactEmail: String, $contactPhoneNumber: String, $customerId: ID, $subscriptionId: ID, $orderNumber: String, $shopifyId: String, $chewyPoNumber: String, $amazonPoNumber: String) {
  dbOrders(
    first: $first
    after: $after
    id: $id
    ids: $ids
    order: $order
    channel: $channel
    opsState: $opsState
    orderNumber: $orderNumber
    state: $state
    humanizedState: $humanizedState
    estimatedShippingDate: $estimatedShippingDate
    contactName: $contactName
    contactEmail: $contactEmail
    contactPhoneNumber: $contactPhoneNumber
    customerId: $customerId
    paymentMethodId: $paymentMethodId
    subscriptionId: $subscriptionId
    shopifyId: $shopifyId
    chewyPoNumber: $chewyPoNumber
    amazonPoNumber: $amazonPoNumber
  ) {
    nodes {
      attributionChannel
      estimatedShippingDate
      estimatedDeliveryDate
      createdAt
      humanizedState
      id
      orderNumber
      chewyPoNumber
      amazonPoNumber
      state
      charges {
        id
        number
        state
        amount
        chargedAt
      }
      storeCredits {
        id
        amount
      }
      taggings {
        tag {
          name
        }
      }
      lastShipmentEntry {
        deliveryDate
      }
      shipments {
        shipmentEntry {
          id
          state
          shipmentNumber
          shippedAt
          carrierCode
          trackingNumber
          shipmentList {
            id
            state
          }
        }
      }
      customer {
        email
        id
        address {
          address
          aptNo
          city
          stateAbbr
          zipCode
        }
      }
      subscription {
        id
        state
        number
      }
      couponsData
    }
    pageInfo {
      currentPage
      endCursor
      totalPages
    }
  }
}
    `;
export const AdminDbOrderDocument = gql`
    query AdminDbOrder($id: String!) {
  dbOrder(id: $id) {
    ...AdminDbOrderProps
    statement {
      planWithSurchargesLine {
        label
        amount
      }
      totalPaidLine {
        label
        amount
      }
      totalValueLine {
        label
        amount
      }
      totalDueLine {
        label
        amount
      }
      totalUnpaidLine {
        label
        amount
      }
      subtotalLine {
        label
        amount
      }
      addonsLine {
        label
        amount
      }
      taxesLine {
        label
        amount
      }
      shippingLine {
        label
        amount
      }
      surchargesLine {
        label
        amount
      }
      discountLines {
        label
        amount
        coupon {
          code
        }
      }
      creditLines {
        label
        amount
      }
    }
    planId
    planSku
    addons {
      ...AdminDbOrderProductItemAttrs
    }
    entrees {
      ...AdminDbOrderProductItemAttrs
    }
    entreePacks {
      ...AdminDbOrderProductItemAttrs
    }
    subscription {
      id
      number
      state
      addonLineItems {
        quantity
        sku
      }
      mealLineItems {
        total
        meal {
          name
          sku
        }
      }
    }
    createdBy {
      userId
      label
    }
    canceledBy {
      userId
      label
    }
    paymentMethod {
      cardLast4
      cardMonth
      cardYear
      paymentGatewayProvider
      lowercaseMetadata {
        company
        wallet
        paypalEmail
      }
    }
    isCancellable
    cancelReason
    eligibleForRecreation
    shopifyAdminUrl
    shopifyInvoiceUrl
  }
}
    ${AdminDbOrderPropsFragmentDoc}
${AdminDbOrderProductItemAttrsFragmentDoc}`;
export const AdminSearchOrderBoxDocument = gql`
    query AdminSearchOrderBox($cursor: String) {
  boxVariants(first: 10, after: $cursor, active: true) {
    nodes {
      id
      name
      sku
    }
  }
}
    `;
export const AdminBoxVariantProductsDocument = gql`
    query AdminBoxVariantProducts($id: String!) {
  boxVariant(id: $id) {
    price
    category
    addonUnits
    defaultFrequency
    box {
      itemQuantity
      bagQuantity
    }
    products {
      sku
      name
      price
      sku
      slug
      category
      shopifyId
      imageUrl
    }
    meals {
      sku
      name
      price
      sku
      slug
      category
      shopifyId
      imageUrl
    }
  }
}
    `;
export const AdminLoadPlanChangeOptionsDocument = gql`
    query AdminLoadPlanChangeOptions($onlyActivePlans: Boolean!) {
  boxVariants(first: 999, onlyActivePlans: $onlyActivePlans) {
    nodes {
      id
      name
      sku
      price
      planType
    }
  }
}
    `;
export const AdminOrderEditDocument = gql`
    mutation AdminOrderEdit($input: DbOrderEditInput!) {
  dbOrderEdit(input: $input) {
    id
  }
}
    `;
export const AdminOrderUpdateDocument = gql`
    mutation AdminOrderUpdate($id: ID!, $input: DbOrderInput!) {
  dbOrderUpdate(input: {id: $id, dbOrderInput: $input}) {
    dbOrder {
      id
    }
  }
}
    `;
export const AdminOrderRecreateDocument = gql`
    mutation AdminOrderRecreate($id: ID!) {
  dbOrderRecreate(input: {id: $id}) {
    newDbOrder {
      id
    }
  }
}
    `;
export const AdminOrderCreateDocument = gql`
    mutation AdminOrderCreate($input: DbOrderCreateInput!) {
  dbOrderCreate(input: $input) {
    dbOrder {
      id
    }
  }
}
    `;
export const AdminOrderReplaceDocument = gql`
    mutation AdminOrderReplace($id: ID!, $reasonId: Int!, $entreeLineItems: [TypesSubscriptionInputTypeLineItemInput!], $addonLineItems: [TypesSubscriptionInputTypeLineItemInput!]) {
  dbOrderReplace(
    input: {id: $id, reasonId: $reasonId, entreeLineItems: $entreeLineItems, addonLineItems: $addonLineItems}
  ) {
    dbOrder {
      id
    }
  }
}
    `;
export const AdminMarkOrderAsDeliveredDocument = gql`
    mutation AdminMarkOrderAsDelivered($id: Int!) {
  markOrderAsDelivered(input: {id: $id}) {
    result
  }
}
    `;
export const AdminMarkOrderPaymentAsFailedDocument = gql`
    mutation AdminMarkOrderPaymentAsFailed($id: Int!, $reason: String!, $errorCode: String!) {
  markOrderPaymentAsFailed(
    input: {id: $id, reason: $reason, errorCode: $errorCode}
  ) {
    result
  }
}
    `;
export const AdminSearchCouponsDocument = gql`
    query AdminSearchCoupons($cursor: String, $title: String!) {
  shopifyCoupons(input: {first: 10, after: $cursor, title: $title}) {
    nodes {
      title
      code
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminPackagingDocument = gql`
    query AdminPackaging($id: String!) {
  packaging(id: $id) {
    ...PackagingProps
  }
}
    ${PackagingPropsFragmentDoc}`;
export const AdminPackagingsDocument = gql`
    query AdminPackagings($first: Int, $last: Int, $before: String, $id: ID, $after: String, $order: ResolversPackagingsResolverOrder, $active: Boolean, $code: String, $name: String) {
  packagings(
    first: $first
    last: $last
    id: $id
    before: $before
    after: $after
    order: $order
    active: $active
    code: $code
    name: $name
  ) {
    nodes {
      ...PackagingProps
    }
    pageInfo {
      endCursor
      currentPage
      totalPages
    }
  }
}
    ${PackagingPropsFragmentDoc}`;
export const AdminPackagingCreateDocument = gql`
    mutation AdminPackagingCreate($input: PackagingCreateInput!) {
  packagingCreate(input: $input) {
    packaging {
      ...PackagingProps
    }
  }
}
    ${PackagingPropsFragmentDoc}`;
export const AdminPackagingUpdateDocument = gql`
    mutation AdminPackagingUpdate($input: PackagingUpdateInput!) {
  packagingUpdate(input: $input) {
    packaging {
      ...PackagingProps
    }
  }
}
    ${PackagingPropsFragmentDoc}`;
export const AdminPauseSurveyDocument = gql`
    query AdminPauseSurvey($first: Int!, $after: String, $order: ResolversPauseSurveysResolverOrder, $id: ID) {
  pauseSurveys(first: $first, after: $after, order: $order, id: $id) {
    nodes {
      id
      subscription {
        id
        number
        updatedAt
        state
        canceledAt
        pet {
          petName
        }
        currentPlan {
          box {
            id
            name
          }
        }
        user {
          id
          email
          name
          shopifyId
        }
        shipments {
          id
        }
      }
      pauseReasonTerm {
        id
        description
      }
    }
    pageInfo {
      currentPage
      endCursor
      totalPages
    }
  }
}
    `;
export const AdminPauseSurveyCreateDocument = gql`
    mutation AdminPauseSurveyCreate($input: PauseSurveyCreateInput!) {
  pauseSurveyCreate(input: $input) {
    pauseSurvey {
      id
    }
  }
}
    `;
export const AdminPaymentBatchEntryDocument = gql`
    query AdminPaymentBatchEntry($id: String!) {
  paymentBatchEntry(id: $id) {
    ...PaymentBatchEntriesProps
  }
}
    ${PaymentBatchEntriesPropsFragmentDoc}`;
export const AdminPaymentBatchEntriesDocument = gql`
    query AdminPaymentBatchEntries($first: Int, $last: Int, $before: String, $after: String, $order: ResolversPaymentBatchEntriesResolverOrder, $paymentBatchId: ID, $state: TypesPaymentBatchEntryInputTypeState, $action: String, $opsState: ResolversPaymentBatchEntriesResolverOpsState, $id: ID) {
  paymentBatchEntries(
    first: $first
    last: $last
    before: $before
    id: $id
    after: $after
    order: $order
    paymentBatchId: $paymentBatchId
    state: $state
    action: $action
    opsState: $opsState
  ) {
    nodes {
      ...PaymentBatchEntriesProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${PaymentBatchEntriesPropsFragmentDoc}`;
export const AdminPaymentBatchEntryCreateDocument = gql`
    mutation AdminPaymentBatchEntryCreate($input: PaymentBatchEntryCreateInput!) {
  paymentBatchEntryCreate(input: $input) {
    paymentBatchEntry {
      ...PaymentBatchEntriesProps
    }
  }
}
    ${PaymentBatchEntriesPropsFragmentDoc}`;
export const AdminPaymentBatchEntryUpdateDocument = gql`
    mutation AdminPaymentBatchEntryUpdate($input: PaymentBatchEntryUpdateInput!) {
  paymentBatchEntryUpdate(input: $input) {
    paymentBatchEntry {
      ...PaymentBatchEntriesProps
    }
  }
}
    ${PaymentBatchEntriesPropsFragmentDoc}`;
export const AdminPaymentBatchDocument = gql`
    query AdminPaymentBatch($id: String!) {
  paymentBatch(id: $id) {
    ...PaymentBatchProps
  }
}
    ${PaymentBatchPropsFragmentDoc}`;
export const AdminPaymentBatchesDocument = gql`
    query AdminPaymentBatches($first: Int, $last: Int, $before: String, $id: ID, $after: String, $order: ResolversPaymentBatchesResolverOrder, $startedAtTo: ISO8601DateTime, $startedAtFrom: ISO8601DateTime, $endedAtTo: ISO8601DateTime, $endedAtFrom: ISO8601DateTime, $state: TypesPaymentBatchInputTypeState) {
  paymentBatches(
    first: $first
    last: $last
    before: $before
    id: $id
    after: $after
    order: $order
    startedAtTo: $startedAtTo
    startedAtFrom: $startedAtFrom
    endedAtTo: $endedAtTo
    endedAtFrom: $endedAtFrom
    state: $state
  ) {
    nodes {
      chargedCount
      createdAt
      dueAt
      endedAt
      overdueCount
      failedCount
      id
      pendingCount
      shippingDates
      skippedCount
      startedAt
      state
      totalCount
      updatedAt
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    `;
export const AdminPaymentBatchCreateDocument = gql`
    mutation AdminPaymentBatchCreate($input: PaymentBatchCreateInput!) {
  paymentBatchCreate(input: $input) {
    paymentBatch {
      ...PaymentBatchProps
    }
  }
}
    ${PaymentBatchPropsFragmentDoc}`;
export const AdminPaymentBatchUpdateDocument = gql`
    mutation AdminPaymentBatchUpdate($input: PaymentBatchUpdateInput!) {
  paymentBatchUpdate(input: $input) {
    paymentBatch {
      ...PaymentBatchProps
    }
  }
}
    ${PaymentBatchPropsFragmentDoc}`;
export const AdminPaymentMethodDocument = gql`
    query AdminPaymentMethod($id: String!) {
  paymentMethod(id: $id) {
    ...PaymentMethodProps
  }
}
    ${PaymentMethodPropsFragmentDoc}`;
export const AdminPaymentMethodsDocument = gql`
    query AdminPaymentMethods($first: Int, $last: Int, $id: ID, $before: String, $userId: ID, $after: String, $order: ResolversPaymentMethodsResolverOrder, $state: TypesPaymentMethodInputTypeState, $cardLast4: String) {
  paymentMethods(
    first: $first
    last: $last
    id: $id
    userId: $userId
    before: $before
    after: $after
    order: $order
    state: $state
    cardLast4: $cardLast4
  ) {
    nodes {
      ...PaymentMethodProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${PaymentMethodPropsFragmentDoc}`;
export const AdminPaymentMethodCreateDocument = gql`
    mutation AdminPaymentMethodCreate($input: PaymentMethodCreateInput!) {
  paymentMethodCreate(input: $input) {
    paymentMethod {
      ...PaymentMethodProps
    }
  }
}
    ${PaymentMethodPropsFragmentDoc}`;
export const AdminPaymentMethodSetPrimaryDocument = gql`
    mutation AdminPaymentMethodSetPrimary($id: ID!, $userId: ID!) {
  paymentMethodUpdate(
    input: {id: $id, paymentMethodInput: {state: primary, ownerId: $userId}}
  ) {
    paymentMethod {
      ...PaymentMethodProps
    }
  }
}
    ${PaymentMethodPropsFragmentDoc}`;
export const AdminPaymentDocument = gql`
    query AdminPayment($id: String!) {
  ppPayment(id: $id) {
    ...PaymentProps
  }
}
    ${PaymentPropsFragmentDoc}`;
export const AdminPaymentsDocument = gql`
    query AdminPayments($first: Int, $last: Int, $before: String, $after: String, $order: ResolversPpPaymentsResolverOrder, $state: TypesPpPaymentInputTypeState, $stateAbbr: String, $number: String, $city: String, $zipCode: String) {
  ppPayments(
    first: $first
    last: $last
    before: $before
    after: $after
    order: $order
    state: $state
    stateAbbr: $stateAbbr
    number: $number
    city: $city
    zipCode: $zipCode
  ) {
    nodes {
      amount
      assessedTaxes
      createdAt
      id
      number
      state
      stateAbbr
      zipCode
      subscription {
        id
        number
      }
      boxVariant {
        id
        sku
      }
      paymentMethod {
        owner {
          id
          email
        }
      }
      paymentAdjustments {
        sourceId
        sourceType
        amount
      }
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    `;
export const AdminPaymentCreateDocument = gql`
    mutation AdminPaymentCreate($input: PpPaymentCreateInput!) {
  ppPaymentCreate(input: $input) {
    ppPayment {
      ...PaymentProps
    }
  }
}
    ${PaymentPropsFragmentDoc}`;
export const AdminRefundLegacyPaymentDocument = gql`
    mutation AdminRefundLegacyPayment($input: MutationsRefundLegacyPaymentInput!) {
  refundLegacyPayment(input: $input) {
    id
  }
}
    `;
export const AdminRefundReasonsDocument = gql`
    query AdminRefundReasons {
  surveyOptions {
    creditReason {
      label
      value
    }
  }
}
    `;
export const AdminPetDocument = gql`
    query AdminPet($id: String!) {
  pet(id: $id) {
    ...PetProps
  }
}
    ${PetPropsFragmentDoc}`;
export const AdminPetsDocument = gql`
    query AdminPets($first: Int, $last: Int, $before: String, $userId: ID, $after: String, $id: ID, $order: ResolversPetsResolverOrder, $petName: String, $createdAtTo: ISO8601DateTime, $createdAtFrom: ISO8601DateTime, $weight: Int, $spayedNeutered: Boolean, $breedType: String, $primaryBreed: String, $secondaryBreed: String) {
  pets(
    first: $first
    last: $last
    userId: $userId
    before: $before
    id: $id
    after: $after
    order: $order
    petName: $petName
    createdAtTo: $createdAtTo
    createdAtFrom: $createdAtFrom
    weight: $weight
    spayedNeutered: $spayedNeutered
    breedType: $breedType
    primaryBreed: $primaryBreed
    secondaryBreed: $secondaryBreed
  ) {
    nodes {
      ageGroup
      birthDate
      calculatedCaloriesPerDay
      gender
      id
      petName
      restingEnergyRate
      servingSizeInOunces
      spayedNeutered
      weight
      primaryBreed {
        name
      }
      secondaryBreed {
        name
      }
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    `;
export const AdminPetCreateDocument = gql`
    mutation AdminPetCreate($input: PetCreateInput!) {
  petCreate(input: $input) {
    pet {
      ...PetProps
    }
  }
}
    ${PetPropsFragmentDoc}`;
export const AdminPetUpdateDocument = gql`
    mutation AdminPetUpdate($input: PetUpdateInput!) {
  petUpdate(input: $input) {
    pet {
      ...PetProps
    }
  }
}
    ${PetPropsFragmentDoc}`;
export const AdminSearchBreedsDocument = gql`
    query AdminSearchBreeds($name: String, $cursor: String) {
  breeds(first: 20, name: $name, after: $cursor) {
    nodes {
      id
      name
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminSearchUsersDocument = gql`
    query AdminSearchUsers($email: String, $cursor: String) {
  users(first: 20, email: $email, after: $cursor) {
    nodes {
      id
      email
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminPlanCompatibilityCriteriumDocument = gql`
    query AdminPlanCompatibilityCriterium($id: String) {
  planCompatibilityCriterium(id: $id) {
    ...PlanCompatibilityCriteriumProps
  }
}
    ${PlanCompatibilityCriteriumPropsFragmentDoc}`;
export const AdminPlanCompatibilityCriteriaDocument = gql`
    query AdminPlanCompatibilityCriteria($first: Int, $last: Int, $before: String, $after: String, $order: ResolversPlanCompatibilityCriteriaResolverOrder, $name: String) {
  planCompatibilityCriteria(
    first: $first
    last: $last
    before: $before
    after: $after
    order: $order
    name: $name
    includeHidden: true
  ) {
    nodes {
      ...PlanCompatibilityCriteriumProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${PlanCompatibilityCriteriumPropsFragmentDoc}`;
export const AdminPlanCompatibilityCriteriumUpdateDocument = gql`
    mutation AdminPlanCompatibilityCriteriumUpdate($input: PlanCompatibilityCriteriumUpdateInput!) {
  planCompatibilityCriteriumUpdate(input: $input) {
    planCompatibilityCriterium {
      ...PlanCompatibilityCriteriumProps
    }
  }
}
    ${PlanCompatibilityCriteriumPropsFragmentDoc}`;
export const ProductPlanVariantUpdateDocument = gql`
    mutation ProductPlanVariantUpdate($input: ProductPlanVariantUpdateInput!) {
  productPlanVariantUpdate(input: $input) {
    success
  }
}
    `;
export const AdminProductDocument = gql`
    query AdminProduct($id: String!) {
  petPlateProduct(id: $id) {
    ...ProductProps
  }
}
    ${ProductPropsFragmentDoc}`;
export const AdminProductsDocument = gql`
    query AdminProducts($first: Int, $last: Int, $before: String, $after: String, $order: ResolversPetPlateProductsResolverOrder, $name: String, $sku: String, $slug: String) {
  petPlateProducts(
    first: $first
    after: $after
    before: $before
    last: $last
    order: $order
    name: $name
    sku: $sku
    slug: $slug
  ) {
    nodes {
      ...ProductListProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${ProductListPropsFragmentDoc}`;
export const AdminProductUpdateDocument = gql`
    mutation AdminProductUpdate($input: PetPlateProductUpdateInput!) {
  petPlateProductUpdate(input: $input) {
    petPlateProduct {
      ...ProductProps
    }
  }
}
    ${ProductPropsFragmentDoc}`;
export const AdminRecommendableProductDocument = gql`
    query AdminRecommendableProduct($id: String!) {
  recommendableProduct(id: $id) {
    ...RecommendableProductProps
  }
}
    ${RecommendableProductPropsFragmentDoc}`;
export const AdminRecommendableProductsDocument = gql`
    query AdminRecommendableProducts($first: Int, $last: Int, $id: ID, $before: String, $after: String, $order: ResolversRecommendableProductsResolverOrder, $status: TypesRecommendableProductInputTypeStatus, $recommendableType: TypesRecommendableProductInputTypeRecommendedType) {
  recommendableProducts(
    first: $first
    last: $last
    id: $id
    before: $before
    after: $after
    order: $order
    status: $status
    recommendableType: $recommendableType
  ) {
    nodes {
      ...RecommendableProductProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${RecommendableProductPropsFragmentDoc}`;
export const AdminRecommendableProductDeleteDocument = gql`
    mutation AdminRecommendableProductDelete($id: ID!) {
  recommendableProductDelete(input: {id: $id}) {
    recommendableProduct {
      ...RecommendableProductProps
    }
  }
}
    ${RecommendableProductPropsFragmentDoc}`;
export const AdminRecommendableProductUpdateDocument = gql`
    mutation AdminRecommendableProductUpdate($input: RecommendableProductUpdateInput!) {
  recommendableProductUpdate(input: $input) {
    recommendableProduct {
      ...RecommendableProductProps
    }
  }
}
    ${RecommendableProductPropsFragmentDoc}`;
export const AdminRecommendableProductCreateDocument = gql`
    mutation AdminRecommendableProductCreate($input: RecommendableProductCreateInput!) {
  recommendableProductCreate(input: $input) {
    recommendableProduct {
      ...RecommendableProductProps
    }
  }
}
    ${RecommendableProductPropsFragmentDoc}`;
export const AdminSearchMealsDocument = gql`
    query AdminSearchMeals($name: String, $cursor: String) {
  meals(first: 20, name: $name, after: $cursor) {
    nodes {
      id
      name
      sku
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminSearchProductsDocument = gql`
    query AdminSearchProducts($name: String, $cursor: String) {
  petPlateProducts(first: 30, name: $name, after: $cursor) {
    nodes {
      id
      name
      sku
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminRouteScheduleUploadJobDocument = gql`
    query AdminRouteScheduleUploadJob($id: String!) {
  routeScheduleUpload(id: $id) {
    id
    createdAt
    updatedAt
    state
    routeType
    error
    fileName
    downloadFileLink
    numberProcessedRoutes
    zipCodesCreated
    endedAt
  }
}
    `;
export const AdminRouteScheduleUploadJobsDocument = gql`
    query AdminRouteScheduleUploadJobs($first: Int, $last: Int, $before: String, $after: String, $id: ID, $fileName: String, $state: TypesRouteScheduleUploadTypeState, $routeType: RouteCode, $order: ResolversRouteScheduleUploadsResolverOrder, $createdAtTo: ISO8601DateTime, $createdAtFrom: ISO8601DateTime) {
  routeScheduleUploads(
    id: $id
    first: $first
    last: $last
    before: $before
    state: $state
    after: $after
    order: $order
    routeType: $routeType
    fileName: $fileName
    createdAtTo: $createdAtTo
    createdAtFrom: $createdAtFrom
  ) {
    nodes {
      id
      createdAt
      updatedAt
      state
      routeType
      error
      fileName
      numberProcessedRoutes
      endedAt
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    `;
export const AdminRouteScheduleDocument = gql`
    query AdminRouteSchedule($id: String!) {
  routeSchedule(id: $id) {
    ...RouteScheduleProps
  }
}
    ${RouteSchedulePropsFragmentDoc}`;
export const AdminRouteSchedulesDocument = gql`
    query AdminRouteSchedules($first: Int, $last: Int, $before: String, $after: String, $id: ID, $order: ResolversRouteSchedulesResolverOrder, $carrier: String, $carrierCode: String, $zipCode: String, $routeCode: TypesRouteScheduleTypeRouteCode, $transitRegion: String, $transitRegionCode: String, $warehouseName: String, $warehouseCode: String) {
  routeSchedules(
    first: $first
    last: $last
    id: $id
    before: $before
    after: $after
    order: $order
    carrier: $carrier
    carrierCode: $carrierCode
    zipCode: $zipCode
    routeCode: $routeCode
    transitRegion: $transitRegion
    transitRegionCode: $transitRegionCode
    warehouseName: $warehouseName
    warehouseCode: $warehouseCode
  ) {
    nodes {
      ...RouteScheduleProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${RouteSchedulePropsFragmentDoc}`;
export const AdminRouteScheduleCreateDocument = gql`
    mutation AdminRouteScheduleCreate($input: RouteScheduleCreateInput!) {
  routeScheduleCreate(input: $input) {
    routeSchedule {
      ...RouteScheduleProps
    }
  }
}
    ${RouteSchedulePropsFragmentDoc}`;
export const AdminRouteScheduleUpdateDocument = gql`
    mutation AdminRouteScheduleUpdate($input: RouteScheduleUpdateInput!) {
  routeScheduleUpdate(input: $input) {
    routeSchedule {
      ...RouteScheduleProps
    }
  }
}
    ${RouteSchedulePropsFragmentDoc}`;
export const AdminRouteScheduleDeleteDocument = gql`
    mutation AdminRouteScheduleDelete($input: RouteScheduleDeleteInput!) {
  routeScheduleDelete(input: $input) {
    routeSchedule {
      ...RouteScheduleProps
    }
  }
}
    ${RouteSchedulePropsFragmentDoc}`;
export const WhoamiDocument = gql`
    query whoami {
  me {
    id
    email
    roles {
      name
    }
  }
}
    `;
export const UpdateSettingsDocument = gql`
    mutation UpdateSettings($input: SettingsUpdateInput!) {
  settingsUpdate(input: $input) {
    ok
  }
}
    `;
export const DeleteSettingDocument = gql`
    mutation DeleteSetting($key: String!) {
  settingDelete(input: {key: $key}) {
    ok
  }
}
    `;
export const AdminPlatformCouponsDocument = gql`
    query AdminPlatformCoupons($cursor: String, $code: String!) {
  coupons(first: 10, after: $cursor, code: $code, shopifyReady: true) {
    nodes {
      id
      code
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const PlatformSettingsDocument = gql`
    query PlatformSettings {
  coupons: settings(
    vars: ["site_wide_coupon", "site_wide_second_subscription_coupon", "sub_cancelled_entrees_discount", "high_ltv_coupon", "treats_coupon", "early_cancel_coupon"]
  ) {
    key
    value {
      ... on Coupon {
        code
        id
      }
    }
  }
}
    `;
export const WeatherDryIceFlagDocument = gql`
    query WeatherDryIceFlag {
  useWeatherDryIce
}
    `;
export const ShipmentListUploadDocument = gql`
    mutation ShipmentListUpload($input: ShipmentListUploadInput!) {
  shipmentListUpload(input: $input) {
    jobId
    id
  }
}
    `;
export const ShipmentListShipStationUploadDocument = gql`
    mutation ShipmentListShipStationUpload($input: ShipmentListShipStationUploadInput!) {
  shipmentListShipStationUpload(input: $input) {
    id
  }
}
    `;
export const AdminShipmentListDocument = gql`
    query AdminShipmentList($id: String!) {
  shipmentList(id: $id) {
    ...ShipmentListViewProps
    totalCount
    processedCount
    successCount
    failureCount
    shipmentListsV2Orders {
      success
      failure
      started
      processed
      error
      v2Order {
        id
        orderNumber
        contactEmail
        customerId
      }
      shipmentEntry {
        id
        state
        shipmentNumber
        createdAt
        updatedAt
        index
      }
    }
    shipstationUploadJobs {
      id
      createdAt
      updatedAt
      status
      errorMessage
      logEvents {
        data
        message
        event
      }
      shipmentModifications {
        shipmentId
        itemSku
        changes {
          key
          value
        }
      }
    }
  }
}
    ${ShipmentListViewPropsFragmentDoc}`;
export const AdminShipmentListInShipstationFormatDocument = gql`
    query AdminShipmentListInShipstationFormat($id: String!) {
  shipmentListToShipstationFormat(id: $id) {
    nodes {
      addressLine1
      addressLine2
      amountPaid
      buyerEmail
      buyerFullName
      city
      customField1
      customField2
      customField3
      giftMessage
      carrierCode
      itemName
      itemQuantity
      itemSku
      itemWeight
      notesFromBuyer
      warehouseCode
      orderDate
      orderNumber
      orderSource
      orderTotal
      postalCode
      recipientFullName
      state
      itemType
      box {
        itemWeight
        bagWeight
      }
    }
  }
}
    `;
export const AdminShipmentListsDocument = gql`
    query AdminShipmentLists($first: Int, $last: Int, $id: ID, $before: String, $after: String, $order: ResolversShipmentListsResolverOrder, $state: TypesShipmentListInputTypeState, $estimatedShippingDate: ISO8601DateTime, $shippedAt: ISO8601DateTime) {
  shipmentLists(
    id: $id
    first: $first
    last: $last
    before: $before
    after: $after
    order: $order
    state: $state
    estimatedShippingDate: $estimatedShippingDate
    shippedAt: $shippedAt
  ) {
    nodes {
      ...ShipmentListIndexProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${ShipmentListIndexPropsFragmentDoc}`;
export const AdminShipmentListCreateDocument = gql`
    mutation AdminShipmentListCreate($input: ShipmentListCreateInput!) {
  shipmentListCreate(input: $input) {
    shipmentList {
      ...ShipmentListIndexProps
    }
  }
}
    ${ShipmentListIndexPropsFragmentDoc}`;
export const AdminShipmentListUpdateDocument = gql`
    mutation AdminShipmentListUpdate($input: ShipmentListUpdateInput!) {
  shipmentListUpdate(input: $input) {
    shipmentList {
      ...ShipmentListIndexProps
    }
  }
}
    ${ShipmentListIndexPropsFragmentDoc}`;
export const AdminShipmentUpdatesUploadJobLinkDocument = gql`
    query AdminShipmentUpdatesUploadJobLink($id: String!) {
  shipmentUpdatesUpload(id: $id) {
    downloadFileLink
  }
}
    `;
export const AdminShipmentUpdatesUploadJobDocument = gql`
    query AdminShipmentUpdatesUploadJob($id: String!) {
  shipmentUpdatesUpload(id: $id) {
    id
    createdAt
    updatedAt
    state
    error
    fileName
    numberProcessedShipments
    endedAt
  }
}
    `;
export const AdminShipmentUpdatesUploadJobsDocument = gql`
    query AdminShipmentUpdatesUploadJobs($first: Int, $last: Int, $before: String, $after: String, $id: ID, $fileName: String, $state: TypesShipmentUpdatesUploadTypeState, $order: ResolversShipmentUpdatesUploadsResolverOrder, $createdAtTo: ISO8601DateTime, $createdAtFrom: ISO8601DateTime) {
  shipmentUpdatesUploads(
    id: $id
    first: $first
    last: $last
    before: $before
    state: $state
    after: $after
    order: $order
    fileName: $fileName
    createdAtTo: $createdAtTo
    createdAtFrom: $createdAtFrom
  ) {
    nodes {
      id
      createdAt
      updatedAt
      state
      error
      fileName
      numberProcessedShipments
      endedAt
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    `;
export const AdminShipmentEntryDocument = gql`
    query AdminShipmentEntry($id: String!) {
  shipmentEntry(id: $id) {
    ...ShipmentEntryProps
    insertImageUrl
    trackingRecord {
      started
      success
      failure
      processed
      error
      v2Order {
        id
        orderNumber
        contactEmail
        customerId
      }
      shipmentEntry {
        id
        state
        shipmentNumber
      }
    }
  }
}
    ${ShipmentEntryPropsFragmentDoc}`;
export const AdminShipmentEntriesDocument = gql`
    query AdminShipmentEntries($id: ID, $first: Int, $last: Int, $before: String, $after: String, $order: ResolversShipmentEntriesResolverOrder, $state: TypesShipmentEntryInputTypeState, $scheduledShippingDateFrom: ISO8601DateTime, $scheduledShippingDate: ISO8601DateTime, $scheduledShippingDateTo: ISO8601DateTime, $shippedAtFrom: ISO8601DateTime, $shippedAtTo: ISO8601DateTime, $routeCode: String, $subscriptionStatus: String, $subscriptionNumber: String, $orderNumber: String, $shipmentNumber: String, $shipmentId: ID, $email: String, $paymentMissing: Boolean, $paymentNumber: String, $paymentStatus: String, $paymentZip: String, $boxVariant: String, $box: String, $packaging: String, $addressStateAbbr: String, $carrierService: String, $opsState: ResolversShipmentEntriesResolverOpsState, $trackingNumber: String, $trackingStatus: String) {
  shipmentEntries(
    first: $first
    last: $last
    id: $id
    before: $before
    after: $after
    order: $order
    state: $state
    scheduledShippingDateFrom: $scheduledShippingDateFrom
    scheduledShippingDateTo: $scheduledShippingDateTo
    shippedAtFrom: $shippedAtFrom
    shippedAtTo: $shippedAtTo
    routeCode: $routeCode
    subscriptionStatus: $subscriptionStatus
    orderNumber: $orderNumber
    shipmentNumber: $shipmentNumber
    shipmentId: $shipmentId
    email: $email
    paymentMissing: $paymentMissing
    paymentNumber: $paymentNumber
    scheduledShippingDate: $scheduledShippingDate
    paymentStatus: $paymentStatus
    paymentZip: $paymentZip
    boxVariant: $boxVariant
    box: $box
    packaging: $packaging
    addressStateAbbr: $addressStateAbbr
    carrierService: $carrierService
    trackingNumber: $trackingNumber
    trackingStatus: $trackingStatus
    subscriptionNumber: $subscriptionNumber
    opsState: $opsState
  ) {
    nodes {
      ...ShipmentEntryProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${ShipmentEntryPropsFragmentDoc}`;
export const AdminShipmentEntriesReportDocument = gql`
    query AdminShipmentEntriesReport($id: ID, $order: ResolversShipmentEntriesResolverOrder, $state: TypesShipmentEntryInputTypeState, $scheduledShippingDateFrom: ISO8601DateTime, $scheduledShippingDate: ISO8601DateTime, $scheduledShippingDateTo: ISO8601DateTime, $shippedAtFrom: ISO8601DateTime, $shippedAtTo: ISO8601DateTime, $routeCode: String, $subscriptionStatus: String, $subscriptionNumber: String, $orderNumber: String, $shipmentNumber: String, $shipmentId: ID, $email: String, $paymentMissing: Boolean, $paymentNumber: String, $paymentStatus: String, $paymentZip: String, $boxVariant: String, $box: String, $packaging: String, $addressStateAbbr: String, $carrierService: String, $opsState: ResolversShipmentEntriesResolverOpsState, $trackingNumber: String, $trackingStatus: String) {
  shipmentEntriesReport(
    id: $id
    order: $order
    state: $state
    scheduledShippingDateFrom: $scheduledShippingDateFrom
    scheduledShippingDateTo: $scheduledShippingDateTo
    shippedAtFrom: $shippedAtFrom
    shippedAtTo: $shippedAtTo
    routeCode: $routeCode
    subscriptionStatus: $subscriptionStatus
    orderNumber: $orderNumber
    shipmentNumber: $shipmentNumber
    shipmentId: $shipmentId
    email: $email
    paymentMissing: $paymentMissing
    paymentNumber: $paymentNumber
    scheduledShippingDate: $scheduledShippingDate
    paymentStatus: $paymentStatus
    paymentZip: $paymentZip
    boxVariant: $boxVariant
    box: $box
    packaging: $packaging
    addressStateAbbr: $addressStateAbbr
    carrierService: $carrierService
    trackingNumber: $trackingNumber
    trackingStatus: $trackingStatus
    subscriptionNumber: $subscriptionNumber
    opsState: $opsState
  ) {
    url
  }
}
    `;
export const AdminShipmentEntryCreateDocument = gql`
    mutation AdminShipmentEntryCreate($input: ShipmentEntryCreateInput!) {
  shipmentEntryCreate(input: $input) {
    shipmentEntry {
      ...ShipmentEntryProps
    }
  }
}
    ${ShipmentEntryPropsFragmentDoc}`;
export const AdminShipmentEntryUpdateDocument = gql`
    mutation AdminShipmentEntryUpdate($input: ShipmentEntryUpdateInput!) {
  shipmentEntryUpdate(input: $input) {
    shipmentEntry {
      ...ShipmentEntryProps
    }
  }
}
    ${ShipmentEntryPropsFragmentDoc}`;
export const AdminSearchBoxDocument = gql`
    query AdminSearchBox($name: String, $cursor: String) {
  boxes(first: 20, name: $name, after: $cursor) {
    nodes {
      id
      name
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminSearchPetsDocument = gql`
    query AdminSearchPets($name: String, $cursor: String) {
  pets(first: 20, petName: $name, after: $cursor) {
    nodes {
      id
      petName
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminSearchBoxVariantsDocument = gql`
    query AdminSearchBoxVariants($name: String, $cursor: String) {
  boxVariants(first: 20, name: $name, after: $cursor, active: true) {
    nodes {
      id
      name
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminSearchPaymentsDocument = gql`
    query AdminSearchPayments($number: String, $cursor: String) {
  ppPayments(first: 20, number: $number, after: $cursor) {
    nodes {
      id
      number
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminSearchShipmentsDocument = gql`
    query AdminSearchShipments($date: ISO8601DateTime, $cursor: String) {
  shipmentLists(first: 20, shippedAt: $date, after: $cursor) {
    nodes {
      id
      shippedAt
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminShipstationUploadJobDocument = gql`
    query AdminShipstationUploadJob($id: String!) {
  shipstationUploadJob(id: $id) {
    id
    createdAt
    updatedAt
    errorMessage
    total
    uploaded
    status
    logEvents {
      id
      data
      event
      message
      createdAt
    }
    shipmentList {
      id
    }
    shipmentModifications {
      itemSku
      shipmentId
      changes {
        value
        key
        originalValue
      }
    }
  }
}
    `;
export const AdminPetPlateProductsDocument = gql`
    query AdminPetPlateProducts {
  productVariants {
    nodes {
      sku
      name
      product {
        name
        weightInOunces
        productType
        lineItemName
      }
      boxVariant {
        sku
        box {
          itemWeight
          bagWeight
        }
      }
    }
  }
  mealVariants {
    nodes {
      sku
      name
      meal {
        weightInOunces
        name
        lineItemName
        productType
      }
      boxVariant {
        sku
        box {
          itemWeight
          bagWeight
        }
      }
    }
  }
  cupHolders: lineItemRuleSets(lineItemType: "packaging", active: true) {
    nodes {
      lineItemType
      lineItemSku
      description
      lineItemName
      id
    }
  }
}
    `;
export const AdminSizeClassesNameOnlyDocument = gql`
    query AdminSizeClassesNameOnly($batch: Int!, $cursor: String) {
  sizeClasses(first: $batch, after: $cursor) {
    nodes {
      name
    }
    pageInfo {
      endCursor
    }
  }
}
    `;
export const AdminSizeClassDocument = gql`
    query AdminSizeClass($id: String!) {
  sizeClass(id: $id) {
    ...SizeClassProps
  }
}
    ${SizeClassPropsFragmentDoc}`;
export const AdminSizeClassesDocument = gql`
    query AdminSizeClasses($first: Int, $last: Int, $before: String, $after: String, $order: ResolversSizeClassesResolverOrder) {
  sizeClasses(
    first: $first
    last: $last
    before: $before
    after: $after
    order: $order
  ) {
    nodes {
      ...SizeClassProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${SizeClassPropsFragmentDoc}`;
export const AdminSizeClassUpdateDocument = gql`
    mutation AdminSizeClassUpdate($input: SizeClassUpdateInput!) {
  sizeClassUpdate(input: $input) {
    sizeClass {
      ...SizeClassProps
    }
  }
}
    ${SizeClassPropsFragmentDoc}`;
export const AdminSizeClassCreateDocument = gql`
    mutation AdminSizeClassCreate($input: SizeClassCreateInput!) {
  sizeClassCreate(input: $input) {
    sizeClass {
      ...SizeClassProps
    }
  }
}
    ${SizeClassPropsFragmentDoc}`;
export const AdminStatusLogsDocument = gql`
    query AdminStatusLogs($first: Int!, $after: String, $order: ResolversStateChangesResolverOrder, $id: ID, $previousState: String, $nextState: String, $statefulType: String, $statefulId: ID) {
  stateChanges(
    first: $first
    id: $id
    after: $after
    order: $order
    previousState: $previousState
    nextState: $nextState
    statefulType: $statefulType
    statefulId: $statefulId
  ) {
    nodes {
      createdAt
      id
      name
      nextState
      previousState
      subscription {
        id
        number
      }
      user {
        id
        email
      }
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    `;
export const AdminSubscriptionDocument = gql`
    query AdminSubscription($id: String!) {
  subscription(id: $id) {
    ...SubscriptionProps
  }
}
    ${SubscriptionPropsFragmentDoc}`;
export const AdminSubscriptionViaShopifyIdDocument = gql`
    query AdminSubscriptionViaShopifyId($shopifyId: String!) {
  subscriptions(shopifyId: $shopifyId) {
    nodes {
      ...SubscriptionProps
    }
  }
}
    ${SubscriptionPropsFragmentDoc}`;
export const AdminSubscriptionsDocument = gql`
    query AdminSubscriptions($after: String, $before: String, $canceledAtFrom: ISO8601DateTime, $userId: ID, $canceledAtTo: ISO8601DateTime, $completedAtFrom: ISO8601DateTime, $id: ID, $completedAtTo: ISO8601DateTime, $email: String, $userName: String, $phoneNumber: String, $first: Int, $last: Int, $order: ResolversSubscriptionsResolverOrder, $renewals: Int, $scheduledShippingDateFrom: ISO8601DateTime, $opsState: ResolversSubscriptionsResolverOpsState, $scheduledShippingDateTo: ISO8601DateTime, $status: TypesSubscriptionInputTypeState, $number: String, $paymentMethodId: ID, $scheduledShippingDate: ISO8601DateTime, $shopifyId: String, $planType: BoxVariantPlanTypeEnum) {
  subscriptions(
    after: $after
    scheduledShippingDate: $scheduledShippingDate
    userId: $userId
    before: $before
    opsState: $opsState
    id: $id
    canceledAtFrom: $canceledAtFrom
    canceledAtTo: $canceledAtTo
    completedAtFrom: $completedAtFrom
    completedAtTo: $completedAtTo
    paymentMethodId: $paymentMethodId
    email: $email
    userName: $userName
    phoneNumber: $phoneNumber
    first: $first
    last: $last
    order: $order
    renewals: $renewals
    scheduledShippingDateFrom: $scheduledShippingDateFrom
    status: $status
    scheduledShippingDateTo: $scheduledShippingDateTo
    number: $number
    shopifyId: $shopifyId
    planType: $planType
  ) {
    nodes {
      id
      currentPlanSku
      upgradePlanSku
      currentPlanCost
      upgradePlanCost
      currentAddonCost
      upgradeAddonCost
      currentPlanWithAddonCost
      upgradePlanWithAddonCost
      currentCostPerDay
      upgradeCostPerDay
      createdAt
      renewals
      number
      v2Orders {
        couponsData
      }
      state
      pet {
        id
        petName
        gender
      }
      scheduledShippingDate
      currentPlan {
        sku
        id
      }
      previousPlan {
        id
        sku
      }
      statementTotal
      user {
        id
        email
      }
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    `;
export const AdminSubscriptionCreateDocument = gql`
    mutation AdminSubscriptionCreate($input: SubscriptionCreateInput!) {
  subscriptionCreate(input: $input) {
    subscription {
      id
    }
  }
}
    `;
export const AdminSubscriptionUpdateDocument = gql`
    mutation AdminSubscriptionUpdate($input: SubscriptionUpdateInput!) {
  subscriptionUpdate(input: $input) {
    subscription {
      id
    }
  }
}
    `;
export const AdminSubscriptionEditDocument = gql`
    mutation AdminSubscriptionEdit($input: MutationsSubscriptionEditInput!) {
  subscriptionEdit(input: {input: $input}) {
    id
  }
}
    `;
export const AdminSudoDocument = gql`
    mutation AdminSudo($id: ID!) {
  sudo(input: {id: $id}) {
    authorization
  }
}
    `;
export const AdminLoadCancelSubReasonsDocument = gql`
    query AdminLoadCancelSubReasons {
  surveyOptions {
    cancelReason {
      label
      value
    }
  }
}
    `;
export const AdminLoadPauseSubReasonsDocument = gql`
    query AdminLoadPauseSubReasons {
  surveyOptions {
    pauseReason {
      label
      value
    }
  }
}
    `;
export const AdminReplaceOrderReasonsDocument = gql`
    query AdminReplaceOrderReasons {
  surveyOptions {
    replaceOrderReason {
      label
      value
    }
  }
}
    `;
export const AdminSubscriptionCreateOrderDocument = gql`
    mutation AdminSubscriptionCreateOrder($id: ID!) {
  petPlateSubscriptionCreateOrder(input: {id: $id}) {
    dbOrder {
      id
    }
  }
}
    `;
export const ResendActivationEmailDocument = gql`
    mutation ResendActivationEmail($input: SendAccountActivationEmailInput!) {
  sendAccountActivationEmail(input: $input) {
    subscription {
      id
    }
  }
}
    `;
export const SyncSubscriptionEntitiesDocument = gql`
    mutation SyncSubscriptionEntities($id: String!) {
  syncSubscriptionEntities(input: {id: $id}) {
    success
  }
}
    `;
export const AdminTermDocument = gql`
    query AdminTerm($id: String!) {
  term(id: $id) {
    ...TermProps
  }
}
    ${TermPropsFragmentDoc}`;
export const AdminTermsDocument = gql`
    query AdminTerms($first: Int, $last: Int, $before: String, $id: ID, $after: String, $order: ResolversTermsResolverOrder, $name: String, $grouping: String, $active: Boolean, $type: TypesTermInputTypeType) {
  terms(
    first: $first
    last: $last
    before: $before
    id: $id
    after: $after
    order: $order
    name: $name
    grouping: $grouping
    active: $active
    type: $type
  ) {
    nodes {
      ...TermProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${TermPropsFragmentDoc}`;
export const AdminTermCreateDocument = gql`
    mutation AdminTermCreate($input: TermCreateInput!) {
  termCreate(input: $input) {
    term {
      ...TermProps
    }
  }
}
    ${TermPropsFragmentDoc}`;
export const AdminTermUpdateDocument = gql`
    mutation AdminTermUpdate($input: TermUpdateInput!) {
  termUpdate(input: $input) {
    term {
      ...TermProps
    }
  }
}
    ${TermPropsFragmentDoc}`;
export const AdminUserDocument = gql`
    query AdminUser($id: String) {
  user(id: $id) {
    ...AdminUserProps
  }
}
    ${AdminUserPropsFragmentDoc}`;
export const AdminUsersDocument = gql`
    query AdminUsers($first: Int, $after: String, $last: Int, $before: String, $order: ResolversUsersResolverOrder, $email: String, $name: String, $phoneNumber: String, $tag: UserTag) {
  users(
    first: $first
    after: $after
    last: $last
    before: $before
    order: $order
    email: $email
    name: $name
    phoneNumber: $phoneNumber
    tag: $tag
  ) {
    nodes {
      email
      id
      name
      tagListView
      phoneNumber
      shopifyId
      pets {
        id
        petName
        primaryBreed {
          name
        }
      }
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    `;
export const AdminUserUpdateDocument = gql`
    mutation AdminUserUpdate($id: ID!, $name: String!, $email: String!, $tagList: [UserTag!]) {
  userUpdate(
    input: {id: $id, userInput: {name: $name, email: $email, tagList: $tagList}}
  ) {
    user {
      id
      name
      email
      tagListView
      failedToSyncEmail
    }
  }
}
    `;
export const AdminShopifyCustomerUpdateDocument = gql`
    mutation AdminShopifyCustomerUpdate($id: ID!, $email: String!) {
  shopifyCustomerUpdate(input: {id: $id, shopifyCustomerInput: {email: $email}}) {
    shopifyCustomer {
      ...AdminShopifyCustProps
    }
  }
}
    ${AdminShopifyCustPropsFragmentDoc}`;
export const AdminUserPaymentMethodsDocument = gql`
    query AdminUserPaymentMethods($first: Int, $last: Int, $before: String, $userId: ID, $after: String) {
  paymentMethods(
    first: $first
    last: $last
    userId: $userId
    before: $before
    after: $after
  ) {
    nodes {
      id
      createdAt
      cardLast4
      cardMonth
      cardYear
      lowercaseMetadata {
        company
        wallet
        paypalEmail
      }
      subscriptions {
        id
        number
      }
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    `;
export const AdminZipCodeLocationDocument = gql`
    query AdminZipCodeLocation($id: String!) {
  zipCodeLocation(id: $id) {
    ...ZipCodeLocationProps
  }
}
    ${ZipCodeLocationPropsFragmentDoc}`;
export const AdminZipCodeLocationsDocument = gql`
    query AdminZipCodeLocations($first: Int, $last: Int, $id: ID, $before: String, $after: String, $order: ResolversZipCodeLocationsResolverOrder, $zipCode: String, $state: String, $city: String) {
  zipCodeLocations(
    first: $first
    last: $last
    id: $id
    before: $before
    after: $after
    order: $order
    zipCode: $zipCode
    state: $state
    city: $city
  ) {
    nodes {
      ...ZipCodeLocationProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${ZipCodeLocationPropsFragmentDoc}`;
export const AdminZipCodeLocationCreateDocument = gql`
    mutation AdminZipCodeLocationCreate($input: ZipCodeLocationCreateInput!) {
  zipCodeLocationCreate(input: $input) {
    zipCodeLocation {
      ...ZipCodeLocationProps
    }
  }
}
    ${ZipCodeLocationPropsFragmentDoc}`;
export const AdminZipCodeLocationUpdateDocument = gql`
    mutation AdminZipCodeLocationUpdate($input: ZipCodeLocationUpdateInput!) {
  zipCodeLocationUpdate(input: $input) {
    zipCodeLocation {
      ...ZipCodeLocationProps
    }
  }
}
    ${ZipCodeLocationPropsFragmentDoc}`;
export const AdminZipCodeLocationDeleteDocument = gql`
    mutation AdminZipCodeLocationDelete($input: ZipCodeLocationDeleteInput!) {
  zipCodeLocationDelete(input: $input) {
    zipCodeLocation {
      ...ZipCodeLocationProps
    }
  }
}
    ${ZipCodeLocationPropsFragmentDoc}`;
export const AdminZipCodeDocument = gql`
    query AdminZipCode($id: String!) {
  zipCode(id: $id) {
    ...ZipCodeProps
  }
}
    ${ZipCodePropsFragmentDoc}`;
export const AdminZipCodesDocument = gql`
    query AdminZipCodes($first: Int, $last: Int, $id: ID, $before: String, $after: String, $order: ResolversZipCodesResolverOrder, $zipCode: String, $state: String, $city: String, $salesTaxRate: Float) {
  zipCodes(
    first: $first
    last: $last
    id: $id
    before: $before
    after: $after
    order: $order
    zipCode: $zipCode
    state: $state
    city: $city
    salesTaxRate: $salesTaxRate
  ) {
    nodes {
      ...ZipCodeProps
    }
    pageInfo {
      currentPage
      totalPages
    }
  }
}
    ${ZipCodePropsFragmentDoc}`;
export const AdminZipCodeCreateDocument = gql`
    mutation AdminZipCodeCreate($input: ZipCodeCreateInput!) {
  zipCodeCreate(input: $input) {
    zipCode {
      ...ZipCodeProps
    }
  }
}
    ${ZipCodePropsFragmentDoc}`;
export const AdminZipCodeUpdateDocument = gql`
    mutation AdminZipCodeUpdate($input: ZipCodeUpdateInput!) {
  zipCodeUpdate(input: $input) {
    zipCode {
      ...ZipCodeProps
    }
  }
}
    ${ZipCodePropsFragmentDoc}`;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  me {
    uid
    id
    name
    hasActiveSubs
  }
}
    `;
export const RecentInstagramPostsDocument = gql`
    query RecentInstagramPosts($max: Int!) {
  instagramPosts(max: $max) {
    id
    permalink
    caption
    mediaUrl
  }
}
    `;
export const FindUserByEmailDocument = gql`
    query FindUserByEmail($email: String!) {
  user(email: $email) {
    email
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    SubflowSignIn(variables: SubflowSignInMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SubflowSignInMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubflowSignInMutation>(SubflowSignInDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SubflowSignIn', 'mutation');
    },
    UpdateRecWizard(variables: UpdateRecWizardMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateRecWizardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRecWizardMutation>(UpdateRecWizardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateRecWizard', 'mutation');
    },
    UpdateRecWizardUser(variables: UpdateRecWizardUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateRecWizardUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRecWizardUserMutation>(UpdateRecWizardUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateRecWizardUser', 'mutation');
    },
    CreateRecWizard(variables?: CreateRecWizardMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateRecWizardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRecWizardMutation>(CreateRecWizardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateRecWizard', 'mutation');
    },
    GetUser(variables?: GetUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserQuery>(GetUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUser', 'query');
    },
    CheckDiscount(variables: CheckDiscountQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CheckDiscountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckDiscountQuery>(CheckDiscountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckDiscount', 'query');
    },
    GetSettings(variables?: GetSettingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSettingsQuery>(GetSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSettings', 'query');
    },
    GetPlanPreferences(variables?: GetPlanPreferencesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPlanPreferencesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPlanPreferencesQuery>(GetPlanPreferencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPlanPreferences', 'query');
    },
    GetRecommendations(variables?: GetRecommendationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetRecommendationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRecommendationsQuery>(GetRecommendationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetRecommendations', 'query');
    },
    GetBreeds(variables?: GetBreedsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBreedsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBreedsQuery>(GetBreedsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBreeds', 'query');
    },
    GetPetsServedByBreed(variables?: GetPetsServedByBreedQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPetsServedByBreedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPetsServedByBreedQuery>(GetPetsServedByBreedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPetsServedByBreed', 'query');
    },
    GetPetsServedByAgeGroup(variables?: GetPetsServedByAgeGroupQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPetsServedByAgeGroupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPetsServedByAgeGroupQuery>(GetPetsServedByAgeGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPetsServedByAgeGroup', 'query');
    },
    BreedAgeData(variables: BreedAgeDataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BreedAgeDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BreedAgeDataQuery>(BreedAgeDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BreedAgeData', 'query');
    },
    GetFoodSensitivityOptions(variables?: GetFoodSensitivityOptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetFoodSensitivityOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFoodSensitivityOptionsQuery>(GetFoodSensitivityOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetFoodSensitivityOptions', 'query');
    },
    GetWellnessGoalOptions(variables?: GetWellnessGoalOptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetWellnessGoalOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetWellnessGoalOptionsQuery>(GetWellnessGoalOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetWellnessGoalOptions', 'query');
    },
    CheckUserExistence(variables: CheckUserExistenceQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CheckUserExistenceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckUserExistenceQuery>(CheckUserExistenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckUserExistence', 'query');
    },
    GetOrderIdFromShopifyId(variables: GetOrderIdFromShopifyIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOrderIdFromShopifyIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderIdFromShopifyIdQuery>(GetOrderIdFromShopifyIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetOrderIdFromShopifyId', 'query');
    },
    CheckWizardCompleted(variables: CheckWizardCompletedQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CheckWizardCompletedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckWizardCompletedQuery>(CheckWizardCompletedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckWizardCompleted', 'query');
    },
    ChangePassword(variables: ChangePasswordMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ChangePasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangePasswordMutation>(ChangePasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChangePassword', 'mutation');
    },
    ChangePasswordPage(variables?: ChangePasswordPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ChangePasswordPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangePasswordPageQuery>(ChangePasswordPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChangePasswordPage', 'query');
    },
    PasswordResetRequest(variables: PasswordResetRequestMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PasswordResetRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PasswordResetRequestMutation>(PasswordResetRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PasswordResetRequest', 'mutation');
    },
    ForgotPasswordPage(variables?: ForgotPasswordPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ForgotPasswordPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ForgotPasswordPageQuery>(ForgotPasswordPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ForgotPasswordPage', 'query');
    },
    VerifyCaptchaResult(variables: VerifyCaptchaResultMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<VerifyCaptchaResultMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyCaptchaResultMutation>(VerifyCaptchaResultDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VerifyCaptchaResult', 'mutation');
    },
    UserSignIn(variables: UserSignInMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserSignInMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserSignInMutation>(UserSignInDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserSignIn', 'mutation');
    },
    AuthenticateAndAssignUserToRecWiz(variables: AuthenticateAndAssignUserToRecWizMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AuthenticateAndAssignUserToRecWizMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthenticateAndAssignUserToRecWizMutation>(AuthenticateAndAssignUserToRecWizDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AuthenticateAndAssignUserToRecWiz', 'mutation');
    },
    UserSignOut(variables?: UserSignOutMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserSignOutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserSignOutMutation>(UserSignOutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserSignOut', 'mutation');
    },
    LoginPage(variables?: LoginPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LoginPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginPageQuery>(LoginPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LoginPage', 'query');
    },
    UserSignUp(variables: UserSignUpMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserSignUpMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserSignUpMutation>(UserSignUpDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserSignUp', 'mutation');
    },
    UserSignUpWizardAssociate(variables: UserSignUpWizardAssociateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserSignUpWizardAssociateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserSignUpWizardAssociateMutation>(UserSignUpWizardAssociateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserSignUpWizardAssociate', 'mutation');
    },
    SignUpPage(variables?: SignUpPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SignUpPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignUpPageQuery>(SignUpPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SignUpPage', 'query');
    },
    ConfirmEmail(variables: ConfirmEmailMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ConfirmEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmEmailMutation>(ConfirmEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ConfirmEmail', 'mutation');
    },
    VerifyAccountPage(variables?: VerifyAccountPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<VerifyAccountPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyAccountPageQuery>(VerifyAccountPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VerifyAccountPage', 'query');
    },
    UserNewsletterSignUp(variables: UserNewsletterSignUpMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserNewsletterSignUpMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserNewsletterSignUpMutation>(UserNewsletterSignUpDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserNewsletterSignUp', 'mutation');
    },
    GetMyAccRecommendations(variables?: GetMyAccRecommendationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMyAccRecommendationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMyAccRecommendationsQuery>(GetMyAccRecommendationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMyAccRecommendations', 'query');
    },
    FindRecommendationWizard(variables?: FindRecommendationWizardQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindRecommendationWizardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindRecommendationWizardQuery>(FindRecommendationWizardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FindRecommendationWizard', 'query');
    },
    CreateRecommendationWizard(variables?: CreateRecommendationWizardMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateRecommendationWizardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRecommendationWizardMutation>(CreateRecommendationWizardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateRecommendationWizard', 'mutation');
    },
    CreatePetPlateSubscription(variables?: CreatePetPlateSubscriptionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreatePetPlateSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePetPlateSubscriptionMutation>(CreatePetPlateSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePetPlateSubscription', 'mutation');
    },
    GetUserAndLoyaltyInfo(variables?: GetUserAndLoyaltyInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserAndLoyaltyInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserAndLoyaltyInfoQuery>(GetUserAndLoyaltyInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUserAndLoyaltyInfo', 'query');
    },
    CartUpdatePlan(variables: CartUpdatePlanMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CartUpdatePlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CartUpdatePlanMutation>(CartUpdatePlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CartUpdatePlan', 'mutation');
    },
    GetUserAndOrders(variables: GetUserAndOrdersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserAndOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserAndOrdersQuery>(GetUserAndOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUserAndOrders', 'query');
    },
    GetOrderById(variables?: GetOrderByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOrderByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderByIdQuery>(GetOrderByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetOrderById', 'query');
    },
    AccountUpdatePet(variables: AccountUpdatePetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AccountUpdatePetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountUpdatePetMutation>(AccountUpdatePetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AccountUpdatePet', 'mutation');
    },
    AccountPetDetailData(variables?: AccountPetDetailDataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AccountPetDetailDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountPetDetailDataQuery>(AccountPetDetailDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AccountPetDetailData', 'query');
    },
    GetPetEditInfo(variables: GetPetEditInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPetEditInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPetEditInfoQuery>(GetPetEditInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPetEditInfo', 'query');
    },
    MyAccBreedSearch(variables?: MyAccBreedSearchQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MyAccBreedSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyAccBreedSearchQuery>(MyAccBreedSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MyAccBreedSearch', 'query');
    },
    AccountSubscriptionAddons(variables: AccountSubscriptionAddonsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AccountSubscriptionAddonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountSubscriptionAddonsQuery>(AccountSubscriptionAddonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AccountSubscriptionAddons', 'query');
    },
    AccountSubscriptionIndex(variables?: AccountSubscriptionIndexQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AccountSubscriptionIndexQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountSubscriptionIndexQuery>(AccountSubscriptionIndexDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AccountSubscriptionIndex', 'query');
    },
    AccountCredit(variables?: AccountCreditQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AccountCreditQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountCreditQuery>(AccountCreditDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AccountCredit', 'query');
    },
    CheckSubPaymentMethodUpdated(variables: CheckSubPaymentMethodUpdatedQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CheckSubPaymentMethodUpdatedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckSubPaymentMethodUpdatedQuery>(CheckSubPaymentMethodUpdatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckSubPaymentMethodUpdated', 'query');
    },
    MyAccountNotificationBanners(variables?: MyAccountNotificationBannersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MyAccountNotificationBannersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyAccountNotificationBannersQuery>(MyAccountNotificationBannersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MyAccountNotificationBanners', 'query');
    },
    UpdatePassword(variables: UpdatePasswordMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePasswordMutation>(UpdatePasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdatePassword', 'mutation');
    },
    UpdateEmail(variables: UpdateEmailMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateEmailMutation>(UpdateEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateEmail', 'mutation');
    },
    UpdateUserMarketing(variables: UpdateUserMarketingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUserMarketingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserMarketingMutation>(UpdateUserMarketingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUserMarketing', 'mutation');
    },
    GetUserAccountSettings(variables?: GetUserAccountSettingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserAccountSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserAccountSettingsQuery>(GetUserAccountSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUserAccountSettings', 'query');
    },
    MyAccountUpdatePlan(variables: MyAccountUpdatePlanMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MyAccountUpdatePlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyAccountUpdatePlanMutation>(MyAccountUpdatePlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MyAccountUpdatePlan', 'mutation');
    },
    MyAccountCreateSubscriptionPaymentMethod(variables: MyAccountCreateSubscriptionPaymentMethodMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MyAccountCreateSubscriptionPaymentMethodMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyAccountCreateSubscriptionPaymentMethodMutation>(MyAccountCreateSubscriptionPaymentMethodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MyAccountCreateSubscriptionPaymentMethod', 'mutation');
    },
    MyAccountUpdateSubscription(variables: MyAccountUpdateSubscriptionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MyAccountUpdateSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyAccountUpdateSubscriptionMutation>(MyAccountUpdateSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MyAccountUpdateSubscription', 'mutation');
    },
    AccountSubsAddonsHLTV(variables?: AccountSubsAddonsHltvQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AccountSubsAddonsHltvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountSubsAddonsHltvQuery>(AccountSubsAddonsHltvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AccountSubsAddonsHLTV', 'query');
    },
    AccountSubscriptionDetail(variables?: AccountSubscriptionDetailQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AccountSubscriptionDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountSubscriptionDetailQuery>(AccountSubscriptionDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AccountSubscriptionDetail', 'query');
    },
    GetSurveyOptions(variables?: GetSurveyOptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSurveyOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSurveyOptionsQuery>(GetSurveyOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSurveyOptions', 'query');
    },
    GetDiscountInfo(variables: GetDiscountInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDiscountInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDiscountInfoQuery>(GetDiscountInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetDiscountInfo', 'query');
    },
    MainNavContent(variables?: MainNavContentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MainNavContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MainNavContentQuery>(MainNavContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MainNavContent', 'query');
    },
    MainFooterContent(variables?: MainFooterContentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MainFooterContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MainFooterContentQuery>(MainFooterContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MainFooterContent', 'query');
    },
    RedeemPromo(variables: RedeemPromoMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RedeemPromoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RedeemPromoMutation>(RedeemPromoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RedeemPromo', 'mutation');
    },
    RedeemPromoGetSubscription(variables: RedeemPromoGetSubscriptionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RedeemPromoGetSubscriptionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RedeemPromoGetSubscriptionQuery>(RedeemPromoGetSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RedeemPromoGetSubscription', 'query');
    },
    AdminOperationsDashboardRecentOrders(variables?: AdminOperationsDashboardRecentOrdersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOperationsDashboardRecentOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOperationsDashboardRecentOrdersQuery>(AdminOperationsDashboardRecentOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOperationsDashboardRecentOrders', 'query');
    },
    AdminSubscriptionStatisticsReport(variables: AdminSubscriptionStatisticsReportQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSubscriptionStatisticsReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSubscriptionStatisticsReportQuery>(AdminSubscriptionStatisticsReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSubscriptionStatisticsReport', 'query');
    },
    AdminOperationsDashboardActiveSubscriptions(variables?: AdminOperationsDashboardActiveSubscriptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOperationsDashboardActiveSubscriptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOperationsDashboardActiveSubscriptionsQuery>(AdminOperationsDashboardActiveSubscriptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOperationsDashboardActiveSubscriptions', 'query');
    },
    AdminOperationsDashboardOrdersWithoutSync(variables?: AdminOperationsDashboardOrdersWithoutSyncQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOperationsDashboardOrdersWithoutSyncQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOperationsDashboardOrdersWithoutSyncQuery>(AdminOperationsDashboardOrdersWithoutSyncDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOperationsDashboardOrdersWithoutSync', 'query');
    },
    AdminAutomation(variables: AdminAutomationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminAutomationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAutomationQuery>(AdminAutomationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAutomation', 'query');
    },
    AdminAutomations(variables?: AdminAutomationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminAutomationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAutomationsQuery>(AdminAutomationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAutomations', 'query');
    },
    AdminAutomationCreate(variables: AdminAutomationCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminAutomationCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAutomationCreateMutation>(AdminAutomationCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAutomationCreate', 'mutation');
    },
    AdminAutomationUpdate(variables: AdminAutomationUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminAutomationUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAutomationUpdateMutation>(AdminAutomationUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAutomationUpdate', 'mutation');
    },
    AdminAutomationRun(variables: AdminAutomationRunMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminAutomationRunMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAutomationRunMutation>(AdminAutomationRunDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAutomationRun', 'mutation');
    },
    AdminAutomationDelete(variables: AdminAutomationDeleteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminAutomationDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAutomationDeleteMutation>(AdminAutomationDeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAutomationDelete', 'mutation');
    },
    AdminDeleteMealVariant(variables: AdminDeleteMealVariantMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDeleteMealVariantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeleteMealVariantMutation>(AdminDeleteMealVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDeleteMealVariant', 'mutation');
    },
    AdminUpdateMealVariant(variables: AdminUpdateMealVariantMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminUpdateMealVariantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateMealVariantMutation>(AdminUpdateMealVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateMealVariant', 'mutation');
    },
    AdminMealVariantCreate(variables: AdminMealVariantCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminMealVariantCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMealVariantCreateMutation>(AdminMealVariantCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMealVariantCreate', 'mutation');
    },
    AdminMealVariant(variables: AdminMealVariantQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminMealVariantQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMealVariantQuery>(AdminMealVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMealVariant', 'query');
    },
    AdminDeleteProductVariant(variables: AdminDeleteProductVariantMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDeleteProductVariantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeleteProductVariantMutation>(AdminDeleteProductVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDeleteProductVariant', 'mutation');
    },
    AdminUpdateProductVariant(variables: AdminUpdateProductVariantMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminUpdateProductVariantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateProductVariantMutation>(AdminUpdateProductVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateProductVariant', 'mutation');
    },
    AdminProductVariantCreate(variables: AdminProductVariantCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminProductVariantCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductVariantCreateMutation>(AdminProductVariantCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProductVariantCreate', 'mutation');
    },
    AdminProductVariant(variables: AdminProductVariantQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminProductVariantQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductVariantQuery>(AdminProductVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProductVariant', 'query');
    },
    AdminBoxVariant(variables: AdminBoxVariantQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminBoxVariantQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBoxVariantQuery>(AdminBoxVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBoxVariant', 'query');
    },
    AdminBoxVariants(variables?: AdminBoxVariantsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminBoxVariantsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBoxVariantsQuery>(AdminBoxVariantsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBoxVariants', 'query');
    },
    AdminBoxVariantCreate(variables: AdminBoxVariantCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminBoxVariantCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBoxVariantCreateMutation>(AdminBoxVariantCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBoxVariantCreate', 'mutation');
    },
    AdminBoxVariantUpdate(variables: AdminBoxVariantUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminBoxVariantUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBoxVariantUpdateMutation>(AdminBoxVariantUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBoxVariantUpdate', 'mutation');
    },
    AdminBox(variables: AdminBoxQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminBoxQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBoxQuery>(AdminBoxDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBox', 'query');
    },
    AdminBoxes(variables?: AdminBoxesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminBoxesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBoxesQuery>(AdminBoxesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBoxes', 'query');
    },
    AdminBoxCreate(variables: AdminBoxCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminBoxCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBoxCreateMutation>(AdminBoxCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBoxCreate', 'mutation');
    },
    AdminBoxUpdate(variables: AdminBoxUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminBoxUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBoxUpdateMutation>(AdminBoxUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBoxUpdate', 'mutation');
    },
    AdminSearchPackagings(variables?: AdminSearchPackagingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchPackagingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchPackagingsQuery>(AdminSearchPackagingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchPackagings', 'query');
    },
    AdminBreed(variables: AdminBreedQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminBreedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBreedQuery>(AdminBreedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBreed', 'query');
    },
    AdminBreeds(variables?: AdminBreedsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminBreedsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBreedsQuery>(AdminBreedsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBreeds', 'query');
    },
    AdminBreedCreate(variables: AdminBreedCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminBreedCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBreedCreateMutation>(AdminBreedCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBreedCreate', 'mutation');
    },
    AdminBreedUpdate(variables: AdminBreedUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminBreedUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBreedUpdateMutation>(AdminBreedUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBreedUpdate', 'mutation');
    },
    AdminCalorieMultiplier(variables: AdminCalorieMultiplierQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCalorieMultiplierQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCalorieMultiplierQuery>(AdminCalorieMultiplierDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCalorieMultiplier', 'query');
    },
    AdminCalorieMultipliers(variables?: AdminCalorieMultipliersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCalorieMultipliersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCalorieMultipliersQuery>(AdminCalorieMultipliersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCalorieMultipliers', 'query');
    },
    AdminCalorieMultiplierCreate(variables: AdminCalorieMultiplierCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCalorieMultiplierCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCalorieMultiplierCreateMutation>(AdminCalorieMultiplierCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCalorieMultiplierCreate', 'mutation');
    },
    AdminCalorieMultiplierUpdate(variables: AdminCalorieMultiplierUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCalorieMultiplierUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCalorieMultiplierUpdateMutation>(AdminCalorieMultiplierUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCalorieMultiplierUpdate', 'mutation');
    },
    AdminCalorieMultiplierRemove(variables: AdminCalorieMultiplierRemoveMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCalorieMultiplierRemoveMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCalorieMultiplierRemoveMutation>(AdminCalorieMultiplierRemoveDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCalorieMultiplierRemove', 'mutation');
    },
    AdminCancellationSurvey(variables: AdminCancellationSurveyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCancellationSurveyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCancellationSurveyQuery>(AdminCancellationSurveyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCancellationSurvey', 'query');
    },
    AdminCancellationSurveys(variables?: AdminCancellationSurveysQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCancellationSurveysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCancellationSurveysQuery>(AdminCancellationSurveysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCancellationSurveys', 'query');
    },
    AdminCancellationSurveyCreate(variables: AdminCancellationSurveyCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCancellationSurveyCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCancellationSurveyCreateMutation>(AdminCancellationSurveyCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCancellationSurveyCreate', 'mutation');
    },
    AdminCancellationSurveyUpdate(variables: AdminCancellationSurveyUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCancellationSurveyUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCancellationSurveyUpdateMutation>(AdminCancellationSurveyUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCancellationSurveyUpdate', 'mutation');
    },
    AdminSearchTerms(variables?: AdminSearchTermsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchTermsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchTermsQuery>(AdminSearchTermsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchTerms', 'query');
    },
    AdminSearchSubscriptions(variables?: AdminSearchSubscriptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchSubscriptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchSubscriptionsQuery>(AdminSearchSubscriptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchSubscriptions', 'query');
    },
    Changelog(variables: ChangelogQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ChangelogQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangelogQuery>(ChangelogDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Changelog', 'query');
    },
    SubscriptionChangelog(variables?: SubscriptionChangelogQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SubscriptionChangelogQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubscriptionChangelogQuery>(SubscriptionChangelogDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SubscriptionChangelog', 'query');
    },
    AdminComment(variables: AdminCommentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCommentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCommentQuery>(AdminCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminComment', 'query');
    },
    AdminCommentRm(variables: AdminCommentRmMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCommentRmMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCommentRmMutation>(AdminCommentRmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCommentRm', 'mutation');
    },
    AdminComments(variables?: AdminCommentsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCommentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCommentsQuery>(AdminCommentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminComments', 'query');
    },
    AdminCommentCreate(variables: AdminCommentCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCommentCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCommentCreateMutation>(AdminCommentCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCommentCreate', 'mutation');
    },
    AdminConversionSurvey(variables: AdminConversionSurveyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminConversionSurveyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminConversionSurveyQuery>(AdminConversionSurveyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminConversionSurvey', 'query');
    },
    AdminConversionSurveys(variables?: AdminConversionSurveysQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminConversionSurveysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminConversionSurveysQuery>(AdminConversionSurveysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminConversionSurveys', 'query');
    },
    AdminConversionSurveyCreate(variables: AdminConversionSurveyCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminConversionSurveyCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminConversionSurveyCreateMutation>(AdminConversionSurveyCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminConversionSurveyCreate', 'mutation');
    },
    AdminConversionSurveyUpdate(variables: AdminConversionSurveyUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminConversionSurveyUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminConversionSurveyUpdateMutation>(AdminConversionSurveyUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminConversionSurveyUpdate', 'mutation');
    },
    AdminUpdateCoupon(variables: AdminUpdateCouponMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminUpdateCouponMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateCouponMutation>(AdminUpdateCouponDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateCoupon', 'mutation');
    },
    AdminImportShopifyCoupon(variables: AdminImportShopifyCouponMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminImportShopifyCouponMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminImportShopifyCouponMutation>(AdminImportShopifyCouponDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminImportShopifyCoupon', 'mutation');
    },
    AdminRefreshCoupon(variables: AdminRefreshCouponMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRefreshCouponMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRefreshCouponMutation>(AdminRefreshCouponDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRefreshCoupon', 'mutation');
    },
    AdminCoupons(variables?: AdminCouponsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCouponsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCouponsQuery>(AdminCouponsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCoupons', 'query');
    },
    AdminCoupon(variables: AdminCouponQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminCouponQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCouponQuery>(AdminCouponDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCoupon', 'query');
    },
    AdminSearchPlatformCoupons(variables?: AdminSearchPlatformCouponsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchPlatformCouponsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchPlatformCouponsQuery>(AdminSearchPlatformCouponsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchPlatformCoupons', 'query');
    },
    AdminStoreCreditAccount(variables: AdminStoreCreditAccountQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminStoreCreditAccountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminStoreCreditAccountQuery>(AdminStoreCreditAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminStoreCreditAccount', 'query');
    },
    AdminStoreCreditAccounts(variables?: AdminStoreCreditAccountsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminStoreCreditAccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminStoreCreditAccountsQuery>(AdminStoreCreditAccountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminStoreCreditAccounts', 'query');
    },
    AdminStoreCreditAccountCreate(variables: AdminStoreCreditAccountCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminStoreCreditAccountCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminStoreCreditAccountCreateMutation>(AdminStoreCreditAccountCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminStoreCreditAccountCreate', 'mutation');
    },
    AdminStoreCreditAccountUpdate(variables: AdminStoreCreditAccountUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminStoreCreditAccountUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminStoreCreditAccountUpdateMutation>(AdminStoreCreditAccountUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminStoreCreditAccountUpdate', 'mutation');
    },
    AdminSearchStoreCreditAccounts(variables?: AdminSearchStoreCreditAccountsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchStoreCreditAccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchStoreCreditAccountsQuery>(AdminSearchStoreCreditAccountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchStoreCreditAccounts', 'query');
    },
    AdminUserCreditAccount(variables: AdminUserCreditAccountQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminUserCreditAccountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserCreditAccountQuery>(AdminUserCreditAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUserCreditAccount', 'query');
    },
    AdminStoreCreditMovement(variables: AdminStoreCreditMovementQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminStoreCreditMovementQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminStoreCreditMovementQuery>(AdminStoreCreditMovementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminStoreCreditMovement', 'query');
    },
    AdminStoreCreditReasons(variables?: AdminStoreCreditReasonsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminStoreCreditReasonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminStoreCreditReasonsQuery>(AdminStoreCreditReasonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminStoreCreditReasons', 'query');
    },
    AdminStoreCreditMovements(variables?: AdminStoreCreditMovementsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminStoreCreditMovementsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminStoreCreditMovementsQuery>(AdminStoreCreditMovementsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminStoreCreditMovements', 'query');
    },
    AdminStoreCreditMovementCreate(variables: AdminStoreCreditMovementCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminStoreCreditMovementCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminStoreCreditMovementCreateMutation>(AdminStoreCreditMovementCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminStoreCreditMovementCreate', 'mutation');
    },
    AdminStoreCreditMovementUpdate(variables: AdminStoreCreditMovementUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminStoreCreditMovementUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminStoreCreditMovementUpdateMutation>(AdminStoreCreditMovementUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminStoreCreditMovementUpdate', 'mutation');
    },
    AdminDryIceMatrixTiers(variables?: AdminDryIceMatrixTiersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDryIceMatrixTiersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDryIceMatrixTiersQuery>(AdminDryIceMatrixTiersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDryIceMatrixTiers', 'query');
    },
    AdminDryIceMatrixTierUpdate(variables: AdminDryIceMatrixTierUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDryIceMatrixTierUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDryIceMatrixTierUpdateMutation>(AdminDryIceMatrixTierUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDryIceMatrixTierUpdate', 'mutation');
    },
    AdminDryIceTransitWarehouses(variables?: AdminDryIceTransitWarehousesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDryIceTransitWarehousesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDryIceTransitWarehousesQuery>(AdminDryIceTransitWarehousesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDryIceTransitWarehouses', 'query');
    },
    AdminTransit(variables: AdminTransitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminTransitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTransitQuery>(AdminTransitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminTransit', 'query');
    },
    AdminDryIcePackaging(variables: AdminDryIcePackagingQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDryIcePackagingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDryIcePackagingQuery>(AdminDryIcePackagingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDryIcePackaging', 'query');
    },
    AdminDryIcePackagingMassUpdate(variables: AdminDryIcePackagingMassUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDryIcePackagingMassUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDryIcePackagingMassUpdateMutation>(AdminDryIcePackagingMassUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDryIcePackagingMassUpdate', 'mutation');
    },
    AdminDryIcePackagingMassCreate(variables: AdminDryIcePackagingMassCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDryIcePackagingMassCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDryIcePackagingMassCreateMutation>(AdminDryIcePackagingMassCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDryIcePackagingMassCreate', 'mutation');
    },
    AdminDryIcePackagingDelete(variables: AdminDryIcePackagingDeleteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDryIcePackagingDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDryIcePackagingDeleteMutation>(AdminDryIcePackagingDeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDryIcePackagingDelete', 'mutation');
    },
    AdminTransitConfigurationCreate(variables: AdminTransitConfigurationCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminTransitConfigurationCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTransitConfigurationCreateMutation>(AdminTransitConfigurationCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminTransitConfigurationCreate', 'mutation');
    },
    AdminTransitConfigurationDelete(variables: AdminTransitConfigurationDeleteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminTransitConfigurationDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTransitConfigurationDeleteMutation>(AdminTransitConfigurationDeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminTransitConfigurationDelete', 'mutation');
    },
    AdminLineItemRule(variables: AdminLineItemRuleQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminLineItemRuleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLineItemRuleQuery>(AdminLineItemRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminLineItemRule', 'query');
    },
    AdminLineItemRules(variables?: AdminLineItemRulesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminLineItemRulesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLineItemRulesQuery>(AdminLineItemRulesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminLineItemRules', 'query');
    },
    AdminLineItemRuleCreate(variables: AdminLineItemRuleCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminLineItemRuleCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLineItemRuleCreateMutation>(AdminLineItemRuleCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminLineItemRuleCreate', 'mutation');
    },
    AdminLineItemRuleUpdate(variables: AdminLineItemRuleUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminLineItemRuleUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLineItemRuleUpdateMutation>(AdminLineItemRuleUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminLineItemRuleUpdate', 'mutation');
    },
    AdminSearchLineRuleSets(variables?: AdminSearchLineRuleSetsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchLineRuleSetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchLineRuleSetsQuery>(AdminSearchLineRuleSetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchLineRuleSets', 'query');
    },
    AdminPutDynamicLineItem(variables: AdminPutDynamicLineItemMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPutDynamicLineItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPutDynamicLineItemMutation>(AdminPutDynamicLineItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPutDynamicLineItem', 'mutation');
    },
    AdminDynamicLineItem(variables: AdminDynamicLineItemQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDynamicLineItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDynamicLineItemQuery>(AdminDynamicLineItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDynamicLineItem', 'query');
    },
    AdminDynamicLineItemRuleSet(variables: AdminDynamicLineItemRuleSetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDynamicLineItemRuleSetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDynamicLineItemRuleSetQuery>(AdminDynamicLineItemRuleSetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDynamicLineItemRuleSet', 'query');
    },
    AdminDynamicLineItemRuleSets(variables?: AdminDynamicLineItemRuleSetsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDynamicLineItemRuleSetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDynamicLineItemRuleSetsQuery>(AdminDynamicLineItemRuleSetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDynamicLineItemRuleSets', 'query');
    },
    AdminDynamicLineItemRuleValues(variables?: AdminDynamicLineItemRuleValuesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDynamicLineItemRuleValuesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDynamicLineItemRuleValuesQuery>(AdminDynamicLineItemRuleValuesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDynamicLineItemRuleValues', 'query');
    },
    AdminSearchZipCodes(variables?: AdminSearchZipCodesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchZipCodesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchZipCodesQuery>(AdminSearchZipCodesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchZipCodes', 'query');
    },
    AdminSearchOrders(variables?: AdminSearchOrdersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchOrdersQuery>(AdminSearchOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchOrders', 'query');
    },
    AdminLogEvent(variables: AdminLogEventQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminLogEventQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLogEventQuery>(AdminLogEventDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminLogEvent', 'query');
    },
    AdminLogEvents(variables?: AdminLogEventsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminLogEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLogEventsQuery>(AdminLogEventsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminLogEvents', 'query');
    },
    AdminLogEventCreate(variables: AdminLogEventCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminLogEventCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLogEventCreateMutation>(AdminLogEventCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminLogEventCreate', 'mutation');
    },
    AdminLogEventUpdate(variables: AdminLogEventUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminLogEventUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLogEventUpdateMutation>(AdminLogEventUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminLogEventUpdate', 'mutation');
    },
    AdminReportJob(variables: AdminReportJobQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminReportJobQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminReportJobQuery>(AdminReportJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminReportJob', 'query');
    },
    AdminReportJobs(variables?: AdminReportJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminReportJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminReportJobsQuery>(AdminReportJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminReportJobs', 'query');
    },
    AdminReportJobCreate(variables: AdminReportJobCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminReportJobCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminReportJobCreateMutation>(AdminReportJobCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminReportJobCreate', 'mutation');
    },
    AdminReportJobUpdate(variables: AdminReportJobUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminReportJobUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminReportJobUpdateMutation>(AdminReportJobUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminReportJobUpdate', 'mutation');
    },
    AdminFulfillmentScheduleRule(variables: AdminFulfillmentScheduleRuleQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminFulfillmentScheduleRuleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminFulfillmentScheduleRuleQuery>(AdminFulfillmentScheduleRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminFulfillmentScheduleRule', 'query');
    },
    AdminFulfillmentScheduleRules(variables?: AdminFulfillmentScheduleRulesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminFulfillmentScheduleRulesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminFulfillmentScheduleRulesQuery>(AdminFulfillmentScheduleRulesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminFulfillmentScheduleRules', 'query');
    },
    AdminFulfillmentScheduleRulesCreate(variables: AdminFulfillmentScheduleRulesCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminFulfillmentScheduleRulesCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminFulfillmentScheduleRulesCreateMutation>(AdminFulfillmentScheduleRulesCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminFulfillmentScheduleRulesCreate', 'mutation');
    },
    AdminFulfillmentScheduleRuleDelete(variables: AdminFulfillmentScheduleRuleDeleteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminFulfillmentScheduleRuleDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminFulfillmentScheduleRuleDeleteMutation>(AdminFulfillmentScheduleRuleDeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminFulfillmentScheduleRuleDelete', 'mutation');
    },
    AdminFulfillmentScheduleRulesReport(variables?: AdminFulfillmentScheduleRulesReportQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminFulfillmentScheduleRulesReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminFulfillmentScheduleRulesReportQuery>(AdminFulfillmentScheduleRulesReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminFulfillmentScheduleRulesReport', 'query');
    },
    AdminTransitConfigurationWarehouses(variables?: AdminTransitConfigurationWarehousesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminTransitConfigurationWarehousesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTransitConfigurationWarehousesQuery>(AdminTransitConfigurationWarehousesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminTransitConfigurationWarehouses', 'query');
    },
    AdminImportJob(variables: AdminImportJobQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminImportJobQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminImportJobQuery>(AdminImportJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminImportJob', 'query');
    },
    AdminImportJobs(variables?: AdminImportJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminImportJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminImportJobsQuery>(AdminImportJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminImportJobs', 'query');
    },
    AdminMealPlanRecommendation(variables: AdminMealPlanRecommendationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminMealPlanRecommendationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMealPlanRecommendationQuery>(AdminMealPlanRecommendationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMealPlanRecommendation', 'query');
    },
    AdminMealPlanRecommendations(variables?: AdminMealPlanRecommendationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminMealPlanRecommendationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMealPlanRecommendationsQuery>(AdminMealPlanRecommendationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMealPlanRecommendations', 'query');
    },
    AdminMealPlanRecommendationCreate(variables: AdminMealPlanRecommendationCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminMealPlanRecommendationCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMealPlanRecommendationCreateMutation>(AdminMealPlanRecommendationCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMealPlanRecommendationCreate', 'mutation');
    },
    AdminMealPlanRecommendationUpdate(variables: AdminMealPlanRecommendationUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminMealPlanRecommendationUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMealPlanRecommendationUpdateMutation>(AdminMealPlanRecommendationUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMealPlanRecommendationUpdate', 'mutation');
    },
    MealPlanVariantUpdate(variables: MealPlanVariantUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MealPlanVariantUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MealPlanVariantUpdateMutation>(MealPlanVariantUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MealPlanVariantUpdate', 'mutation');
    },
    AdminMeal(variables: AdminMealQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminMealQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMealQuery>(AdminMealDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMeal', 'query');
    },
    AdminMeals(variables?: AdminMealsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminMealsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMealsQuery>(AdminMealsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMeals', 'query');
    },
    AdminMealUpdate(variables: AdminMealUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminMealUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMealUpdateMutation>(AdminMealUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMealUpdate', 'mutation');
    },
    AdminNotificationBanners(variables?: AdminNotificationBannersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminNotificationBannersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminNotificationBannersQuery>(AdminNotificationBannersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminNotificationBanners', 'query');
    },
    AdminNotificationBanner(variables: AdminNotificationBannerQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminNotificationBannerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminNotificationBannerQuery>(AdminNotificationBannerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminNotificationBanner', 'query');
    },
    AdminNotificationBannerCreate(variables: AdminNotificationBannerCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminNotificationBannerCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminNotificationBannerCreateMutation>(AdminNotificationBannerCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminNotificationBannerCreate', 'mutation');
    },
    AdminNotificationBannerUpdate(variables: AdminNotificationBannerUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminNotificationBannerUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminNotificationBannerUpdateMutation>(AdminNotificationBannerUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminNotificationBannerUpdate', 'mutation');
    },
    AdminNotificationBannerDelete(variables: AdminNotificationBannerDeleteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminNotificationBannerDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminNotificationBannerDeleteMutation>(AdminNotificationBannerDeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminNotificationBannerDelete', 'mutation');
    },
    AdminOperationsDashboardShippingSchedule(variables?: AdminOperationsDashboardShippingScheduleQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOperationsDashboardShippingScheduleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOperationsDashboardShippingScheduleQuery>(AdminOperationsDashboardShippingScheduleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOperationsDashboardShippingSchedule', 'query');
    },
    AdminOperationsDashboardShippingLists(variables?: AdminOperationsDashboardShippingListsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOperationsDashboardShippingListsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOperationsDashboardShippingListsQuery>(AdminOperationsDashboardShippingListsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOperationsDashboardShippingLists', 'query');
    },
    AdminOperationsDashboardAlerts(variables?: AdminOperationsDashboardAlertsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOperationsDashboardAlertsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOperationsDashboardAlertsQuery>(AdminOperationsDashboardAlertsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOperationsDashboardAlerts', 'query');
    },
    AdminOperationsDashboardInvalidZipCodeAlerts(variables?: AdminOperationsDashboardInvalidZipCodeAlertsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOperationsDashboardInvalidZipCodeAlertsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOperationsDashboardInvalidZipCodeAlertsQuery>(AdminOperationsDashboardInvalidZipCodeAlertsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOperationsDashboardInvalidZipCodeAlerts', 'query');
    },
    AdminOperationsDashboardUnsyncedData(variables?: AdminOperationsDashboardUnsyncedDataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOperationsDashboardUnsyncedDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOperationsDashboardUnsyncedDataQuery>(AdminOperationsDashboardUnsyncedDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOperationsDashboardUnsyncedData', 'query');
    },
    AdminOperationsDashboardPaymentBatches(variables?: AdminOperationsDashboardPaymentBatchesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOperationsDashboardPaymentBatchesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOperationsDashboardPaymentBatchesQuery>(AdminOperationsDashboardPaymentBatchesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOperationsDashboardPaymentBatches', 'query');
    },
    AdminOperationsDashboardSubscriptionStatistics(variables?: AdminOperationsDashboardSubscriptionStatisticsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOperationsDashboardSubscriptionStatisticsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOperationsDashboardSubscriptionStatisticsQuery>(AdminOperationsDashboardSubscriptionStatisticsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOperationsDashboardSubscriptionStatistics', 'query');
    },
    AdminOrderImportBatchEntry(variables: AdminOrderImportBatchEntryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOrderImportBatchEntryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderImportBatchEntryQuery>(AdminOrderImportBatchEntryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrderImportBatchEntry', 'query');
    },
    AdminOrderImportBatchEntryOrders(variables?: AdminOrderImportBatchEntryOrdersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOrderImportBatchEntryOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderImportBatchEntryOrdersQuery>(AdminOrderImportBatchEntryOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrderImportBatchEntryOrders', 'query');
    },
    AdminOrderImportBatches(variables?: AdminOrderImportBatchesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOrderImportBatchesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderImportBatchesQuery>(AdminOrderImportBatchesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrderImportBatches', 'query');
    },
    AdminOrderImportBatch(variables: AdminOrderImportBatchQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOrderImportBatchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderImportBatchQuery>(AdminOrderImportBatchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrderImportBatch', 'query');
    },
    AdminOrderImportBatchEntries(variables?: AdminOrderImportBatchEntriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOrderImportBatchEntriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderImportBatchEntriesQuery>(AdminOrderImportBatchEntriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrderImportBatchEntries', 'query');
    },
    AdminDbOrders(variables?: AdminDbOrdersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDbOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDbOrdersQuery>(AdminDbOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDbOrders', 'query');
    },
    AdminDbOrder(variables: AdminDbOrderQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminDbOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDbOrderQuery>(AdminDbOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDbOrder', 'query');
    },
    AdminSearchOrderBox(variables?: AdminSearchOrderBoxQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchOrderBoxQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchOrderBoxQuery>(AdminSearchOrderBoxDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchOrderBox', 'query');
    },
    AdminBoxVariantProducts(variables: AdminBoxVariantProductsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminBoxVariantProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBoxVariantProductsQuery>(AdminBoxVariantProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBoxVariantProducts', 'query');
    },
    AdminLoadPlanChangeOptions(variables: AdminLoadPlanChangeOptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminLoadPlanChangeOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLoadPlanChangeOptionsQuery>(AdminLoadPlanChangeOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminLoadPlanChangeOptions', 'query');
    },
    AdminOrderEdit(variables: AdminOrderEditMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOrderEditMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderEditMutation>(AdminOrderEditDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrderEdit', 'mutation');
    },
    AdminOrderUpdate(variables: AdminOrderUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOrderUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderUpdateMutation>(AdminOrderUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrderUpdate', 'mutation');
    },
    AdminOrderRecreate(variables: AdminOrderRecreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOrderRecreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderRecreateMutation>(AdminOrderRecreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrderRecreate', 'mutation');
    },
    AdminOrderCreate(variables: AdminOrderCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOrderCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderCreateMutation>(AdminOrderCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrderCreate', 'mutation');
    },
    AdminOrderReplace(variables: AdminOrderReplaceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminOrderReplaceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderReplaceMutation>(AdminOrderReplaceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrderReplace', 'mutation');
    },
    AdminMarkOrderAsDelivered(variables: AdminMarkOrderAsDeliveredMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminMarkOrderAsDeliveredMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMarkOrderAsDeliveredMutation>(AdminMarkOrderAsDeliveredDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMarkOrderAsDelivered', 'mutation');
    },
    AdminMarkOrderPaymentAsFailed(variables: AdminMarkOrderPaymentAsFailedMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminMarkOrderPaymentAsFailedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMarkOrderPaymentAsFailedMutation>(AdminMarkOrderPaymentAsFailedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMarkOrderPaymentAsFailed', 'mutation');
    },
    AdminSearchCoupons(variables: AdminSearchCouponsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchCouponsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchCouponsQuery>(AdminSearchCouponsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchCoupons', 'query');
    },
    AdminPackaging(variables: AdminPackagingQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPackagingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPackagingQuery>(AdminPackagingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPackaging', 'query');
    },
    AdminPackagings(variables?: AdminPackagingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPackagingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPackagingsQuery>(AdminPackagingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPackagings', 'query');
    },
    AdminPackagingCreate(variables: AdminPackagingCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPackagingCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPackagingCreateMutation>(AdminPackagingCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPackagingCreate', 'mutation');
    },
    AdminPackagingUpdate(variables: AdminPackagingUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPackagingUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPackagingUpdateMutation>(AdminPackagingUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPackagingUpdate', 'mutation');
    },
    AdminPauseSurvey(variables: AdminPauseSurveyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPauseSurveyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPauseSurveyQuery>(AdminPauseSurveyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPauseSurvey', 'query');
    },
    AdminPauseSurveyCreate(variables: AdminPauseSurveyCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPauseSurveyCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPauseSurveyCreateMutation>(AdminPauseSurveyCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPauseSurveyCreate', 'mutation');
    },
    AdminPaymentBatchEntry(variables: AdminPaymentBatchEntryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentBatchEntryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentBatchEntryQuery>(AdminPaymentBatchEntryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPaymentBatchEntry', 'query');
    },
    AdminPaymentBatchEntries(variables?: AdminPaymentBatchEntriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentBatchEntriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentBatchEntriesQuery>(AdminPaymentBatchEntriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPaymentBatchEntries', 'query');
    },
    AdminPaymentBatchEntryCreate(variables: AdminPaymentBatchEntryCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentBatchEntryCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentBatchEntryCreateMutation>(AdminPaymentBatchEntryCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPaymentBatchEntryCreate', 'mutation');
    },
    AdminPaymentBatchEntryUpdate(variables: AdminPaymentBatchEntryUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentBatchEntryUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentBatchEntryUpdateMutation>(AdminPaymentBatchEntryUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPaymentBatchEntryUpdate', 'mutation');
    },
    AdminPaymentBatch(variables: AdminPaymentBatchQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentBatchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentBatchQuery>(AdminPaymentBatchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPaymentBatch', 'query');
    },
    AdminPaymentBatches(variables?: AdminPaymentBatchesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentBatchesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentBatchesQuery>(AdminPaymentBatchesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPaymentBatches', 'query');
    },
    AdminPaymentBatchCreate(variables: AdminPaymentBatchCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentBatchCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentBatchCreateMutation>(AdminPaymentBatchCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPaymentBatchCreate', 'mutation');
    },
    AdminPaymentBatchUpdate(variables: AdminPaymentBatchUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentBatchUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentBatchUpdateMutation>(AdminPaymentBatchUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPaymentBatchUpdate', 'mutation');
    },
    AdminPaymentMethod(variables: AdminPaymentMethodQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentMethodQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentMethodQuery>(AdminPaymentMethodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPaymentMethod', 'query');
    },
    AdminPaymentMethods(variables?: AdminPaymentMethodsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentMethodsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentMethodsQuery>(AdminPaymentMethodsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPaymentMethods', 'query');
    },
    AdminPaymentMethodCreate(variables: AdminPaymentMethodCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentMethodCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentMethodCreateMutation>(AdminPaymentMethodCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPaymentMethodCreate', 'mutation');
    },
    AdminPaymentMethodSetPrimary(variables: AdminPaymentMethodSetPrimaryMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentMethodSetPrimaryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentMethodSetPrimaryMutation>(AdminPaymentMethodSetPrimaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPaymentMethodSetPrimary', 'mutation');
    },
    AdminPayment(variables: AdminPaymentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentQuery>(AdminPaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPayment', 'query');
    },
    AdminPayments(variables?: AdminPaymentsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentsQuery>(AdminPaymentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPayments', 'query');
    },
    AdminPaymentCreate(variables: AdminPaymentCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPaymentCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentCreateMutation>(AdminPaymentCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPaymentCreate', 'mutation');
    },
    AdminRefundLegacyPayment(variables: AdminRefundLegacyPaymentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRefundLegacyPaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRefundLegacyPaymentMutation>(AdminRefundLegacyPaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRefundLegacyPayment', 'mutation');
    },
    AdminRefundReasons(variables?: AdminRefundReasonsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRefundReasonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRefundReasonsQuery>(AdminRefundReasonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRefundReasons', 'query');
    },
    AdminPet(variables: AdminPetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPetQuery>(AdminPetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPet', 'query');
    },
    AdminPets(variables?: AdminPetsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPetsQuery>(AdminPetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPets', 'query');
    },
    AdminPetCreate(variables: AdminPetCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPetCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPetCreateMutation>(AdminPetCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPetCreate', 'mutation');
    },
    AdminPetUpdate(variables: AdminPetUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPetUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPetUpdateMutation>(AdminPetUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPetUpdate', 'mutation');
    },
    AdminSearchBreeds(variables?: AdminSearchBreedsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchBreedsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchBreedsQuery>(AdminSearchBreedsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchBreeds', 'query');
    },
    AdminSearchUsers(variables?: AdminSearchUsersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchUsersQuery>(AdminSearchUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchUsers', 'query');
    },
    AdminPlanCompatibilityCriterium(variables?: AdminPlanCompatibilityCriteriumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPlanCompatibilityCriteriumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPlanCompatibilityCriteriumQuery>(AdminPlanCompatibilityCriteriumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPlanCompatibilityCriterium', 'query');
    },
    AdminPlanCompatibilityCriteria(variables?: AdminPlanCompatibilityCriteriaQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPlanCompatibilityCriteriaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPlanCompatibilityCriteriaQuery>(AdminPlanCompatibilityCriteriaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPlanCompatibilityCriteria', 'query');
    },
    AdminPlanCompatibilityCriteriumUpdate(variables: AdminPlanCompatibilityCriteriumUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPlanCompatibilityCriteriumUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPlanCompatibilityCriteriumUpdateMutation>(AdminPlanCompatibilityCriteriumUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPlanCompatibilityCriteriumUpdate', 'mutation');
    },
    ProductPlanVariantUpdate(variables: ProductPlanVariantUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProductPlanVariantUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductPlanVariantUpdateMutation>(ProductPlanVariantUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProductPlanVariantUpdate', 'mutation');
    },
    AdminProduct(variables: AdminProductQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductQuery>(AdminProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProduct', 'query');
    },
    AdminProducts(variables?: AdminProductsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductsQuery>(AdminProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProducts', 'query');
    },
    AdminProductUpdate(variables: AdminProductUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminProductUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductUpdateMutation>(AdminProductUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProductUpdate', 'mutation');
    },
    AdminRecommendableProduct(variables: AdminRecommendableProductQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRecommendableProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRecommendableProductQuery>(AdminRecommendableProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRecommendableProduct', 'query');
    },
    AdminRecommendableProducts(variables?: AdminRecommendableProductsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRecommendableProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRecommendableProductsQuery>(AdminRecommendableProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRecommendableProducts', 'query');
    },
    AdminRecommendableProductDelete(variables: AdminRecommendableProductDeleteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRecommendableProductDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRecommendableProductDeleteMutation>(AdminRecommendableProductDeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRecommendableProductDelete', 'mutation');
    },
    AdminRecommendableProductUpdate(variables: AdminRecommendableProductUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRecommendableProductUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRecommendableProductUpdateMutation>(AdminRecommendableProductUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRecommendableProductUpdate', 'mutation');
    },
    AdminRecommendableProductCreate(variables: AdminRecommendableProductCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRecommendableProductCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRecommendableProductCreateMutation>(AdminRecommendableProductCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRecommendableProductCreate', 'mutation');
    },
    AdminSearchMeals(variables?: AdminSearchMealsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchMealsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchMealsQuery>(AdminSearchMealsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchMeals', 'query');
    },
    AdminSearchProducts(variables?: AdminSearchProductsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchProductsQuery>(AdminSearchProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchProducts', 'query');
    },
    AdminRouteScheduleUploadJob(variables: AdminRouteScheduleUploadJobQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRouteScheduleUploadJobQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRouteScheduleUploadJobQuery>(AdminRouteScheduleUploadJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRouteScheduleUploadJob', 'query');
    },
    AdminRouteScheduleUploadJobs(variables?: AdminRouteScheduleUploadJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRouteScheduleUploadJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRouteScheduleUploadJobsQuery>(AdminRouteScheduleUploadJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRouteScheduleUploadJobs', 'query');
    },
    AdminRouteSchedule(variables: AdminRouteScheduleQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRouteScheduleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRouteScheduleQuery>(AdminRouteScheduleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRouteSchedule', 'query');
    },
    AdminRouteSchedules(variables?: AdminRouteSchedulesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRouteSchedulesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRouteSchedulesQuery>(AdminRouteSchedulesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRouteSchedules', 'query');
    },
    AdminRouteScheduleCreate(variables: AdminRouteScheduleCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRouteScheduleCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRouteScheduleCreateMutation>(AdminRouteScheduleCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRouteScheduleCreate', 'mutation');
    },
    AdminRouteScheduleUpdate(variables: AdminRouteScheduleUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRouteScheduleUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRouteScheduleUpdateMutation>(AdminRouteScheduleUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRouteScheduleUpdate', 'mutation');
    },
    AdminRouteScheduleDelete(variables: AdminRouteScheduleDeleteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminRouteScheduleDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRouteScheduleDeleteMutation>(AdminRouteScheduleDeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRouteScheduleDelete', 'mutation');
    },
    whoami(variables?: WhoamiQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<WhoamiQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WhoamiQuery>(WhoamiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'whoami', 'query');
    },
    UpdateSettings(variables: UpdateSettingsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSettingsMutation>(UpdateSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSettings', 'mutation');
    },
    DeleteSetting(variables: DeleteSettingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteSettingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSettingMutation>(DeleteSettingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteSetting', 'mutation');
    },
    AdminPlatformCoupons(variables: AdminPlatformCouponsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPlatformCouponsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPlatformCouponsQuery>(AdminPlatformCouponsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPlatformCoupons', 'query');
    },
    PlatformSettings(variables?: PlatformSettingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PlatformSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformSettingsQuery>(PlatformSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PlatformSettings', 'query');
    },
    WeatherDryIceFlag(variables?: WeatherDryIceFlagQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<WeatherDryIceFlagQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WeatherDryIceFlagQuery>(WeatherDryIceFlagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'WeatherDryIceFlag', 'query');
    },
    ShipmentListUpload(variables: ShipmentListUploadMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ShipmentListUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShipmentListUploadMutation>(ShipmentListUploadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ShipmentListUpload', 'mutation');
    },
    ShipmentListShipStationUpload(variables: ShipmentListShipStationUploadMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ShipmentListShipStationUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShipmentListShipStationUploadMutation>(ShipmentListShipStationUploadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ShipmentListShipStationUpload', 'mutation');
    },
    AdminShipmentList(variables: AdminShipmentListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipmentListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipmentListQuery>(AdminShipmentListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipmentList', 'query');
    },
    AdminShipmentListInShipstationFormat(variables: AdminShipmentListInShipstationFormatQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipmentListInShipstationFormatQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipmentListInShipstationFormatQuery>(AdminShipmentListInShipstationFormatDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipmentListInShipstationFormat', 'query');
    },
    AdminShipmentLists(variables?: AdminShipmentListsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipmentListsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipmentListsQuery>(AdminShipmentListsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipmentLists', 'query');
    },
    AdminShipmentListCreate(variables: AdminShipmentListCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipmentListCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipmentListCreateMutation>(AdminShipmentListCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipmentListCreate', 'mutation');
    },
    AdminShipmentListUpdate(variables: AdminShipmentListUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipmentListUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipmentListUpdateMutation>(AdminShipmentListUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipmentListUpdate', 'mutation');
    },
    AdminShipmentUpdatesUploadJobLink(variables: AdminShipmentUpdatesUploadJobLinkQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipmentUpdatesUploadJobLinkQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipmentUpdatesUploadJobLinkQuery>(AdminShipmentUpdatesUploadJobLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipmentUpdatesUploadJobLink', 'query');
    },
    AdminShipmentUpdatesUploadJob(variables: AdminShipmentUpdatesUploadJobQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipmentUpdatesUploadJobQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipmentUpdatesUploadJobQuery>(AdminShipmentUpdatesUploadJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipmentUpdatesUploadJob', 'query');
    },
    AdminShipmentUpdatesUploadJobs(variables?: AdminShipmentUpdatesUploadJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipmentUpdatesUploadJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipmentUpdatesUploadJobsQuery>(AdminShipmentUpdatesUploadJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipmentUpdatesUploadJobs', 'query');
    },
    AdminShipmentEntry(variables: AdminShipmentEntryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipmentEntryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipmentEntryQuery>(AdminShipmentEntryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipmentEntry', 'query');
    },
    AdminShipmentEntries(variables?: AdminShipmentEntriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipmentEntriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipmentEntriesQuery>(AdminShipmentEntriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipmentEntries', 'query');
    },
    AdminShipmentEntriesReport(variables?: AdminShipmentEntriesReportQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipmentEntriesReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipmentEntriesReportQuery>(AdminShipmentEntriesReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipmentEntriesReport', 'query');
    },
    AdminShipmentEntryCreate(variables: AdminShipmentEntryCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipmentEntryCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipmentEntryCreateMutation>(AdminShipmentEntryCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipmentEntryCreate', 'mutation');
    },
    AdminShipmentEntryUpdate(variables: AdminShipmentEntryUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipmentEntryUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipmentEntryUpdateMutation>(AdminShipmentEntryUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipmentEntryUpdate', 'mutation');
    },
    AdminSearchBox(variables?: AdminSearchBoxQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchBoxQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchBoxQuery>(AdminSearchBoxDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchBox', 'query');
    },
    AdminSearchPets(variables?: AdminSearchPetsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchPetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchPetsQuery>(AdminSearchPetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchPets', 'query');
    },
    AdminSearchBoxVariants(variables?: AdminSearchBoxVariantsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchBoxVariantsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchBoxVariantsQuery>(AdminSearchBoxVariantsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchBoxVariants', 'query');
    },
    AdminSearchPayments(variables?: AdminSearchPaymentsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchPaymentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchPaymentsQuery>(AdminSearchPaymentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchPayments', 'query');
    },
    AdminSearchShipments(variables?: AdminSearchShipmentsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSearchShipmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchShipmentsQuery>(AdminSearchShipmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchShipments', 'query');
    },
    AdminShipstationUploadJob(variables: AdminShipstationUploadJobQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShipstationUploadJobQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShipstationUploadJobQuery>(AdminShipstationUploadJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShipstationUploadJob', 'query');
    },
    AdminPetPlateProducts(variables?: AdminPetPlateProductsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminPetPlateProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPetPlateProductsQuery>(AdminPetPlateProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPetPlateProducts', 'query');
    },
    AdminSizeClassesNameOnly(variables: AdminSizeClassesNameOnlyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSizeClassesNameOnlyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSizeClassesNameOnlyQuery>(AdminSizeClassesNameOnlyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSizeClassesNameOnly', 'query');
    },
    AdminSizeClass(variables: AdminSizeClassQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSizeClassQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSizeClassQuery>(AdminSizeClassDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSizeClass', 'query');
    },
    AdminSizeClasses(variables?: AdminSizeClassesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSizeClassesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSizeClassesQuery>(AdminSizeClassesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSizeClasses', 'query');
    },
    AdminSizeClassUpdate(variables: AdminSizeClassUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSizeClassUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSizeClassUpdateMutation>(AdminSizeClassUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSizeClassUpdate', 'mutation');
    },
    AdminSizeClassCreate(variables: AdminSizeClassCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSizeClassCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSizeClassCreateMutation>(AdminSizeClassCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSizeClassCreate', 'mutation');
    },
    AdminStatusLogs(variables: AdminStatusLogsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminStatusLogsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminStatusLogsQuery>(AdminStatusLogsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminStatusLogs', 'query');
    },
    AdminSubscription(variables: AdminSubscriptionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSubscriptionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSubscriptionQuery>(AdminSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSubscription', 'query');
    },
    AdminSubscriptionViaShopifyId(variables: AdminSubscriptionViaShopifyIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSubscriptionViaShopifyIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSubscriptionViaShopifyIdQuery>(AdminSubscriptionViaShopifyIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSubscriptionViaShopifyId', 'query');
    },
    AdminSubscriptions(variables?: AdminSubscriptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSubscriptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSubscriptionsQuery>(AdminSubscriptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSubscriptions', 'query');
    },
    AdminSubscriptionCreate(variables: AdminSubscriptionCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSubscriptionCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSubscriptionCreateMutation>(AdminSubscriptionCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSubscriptionCreate', 'mutation');
    },
    AdminSubscriptionUpdate(variables: AdminSubscriptionUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSubscriptionUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSubscriptionUpdateMutation>(AdminSubscriptionUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSubscriptionUpdate', 'mutation');
    },
    AdminSubscriptionEdit(variables: AdminSubscriptionEditMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSubscriptionEditMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSubscriptionEditMutation>(AdminSubscriptionEditDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSubscriptionEdit', 'mutation');
    },
    AdminSudo(variables: AdminSudoMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSudoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSudoMutation>(AdminSudoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSudo', 'mutation');
    },
    AdminLoadCancelSubReasons(variables?: AdminLoadCancelSubReasonsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminLoadCancelSubReasonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLoadCancelSubReasonsQuery>(AdminLoadCancelSubReasonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminLoadCancelSubReasons', 'query');
    },
    AdminLoadPauseSubReasons(variables?: AdminLoadPauseSubReasonsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminLoadPauseSubReasonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLoadPauseSubReasonsQuery>(AdminLoadPauseSubReasonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminLoadPauseSubReasons', 'query');
    },
    AdminReplaceOrderReasons(variables?: AdminReplaceOrderReasonsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminReplaceOrderReasonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminReplaceOrderReasonsQuery>(AdminReplaceOrderReasonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminReplaceOrderReasons', 'query');
    },
    AdminSubscriptionCreateOrder(variables: AdminSubscriptionCreateOrderMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminSubscriptionCreateOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSubscriptionCreateOrderMutation>(AdminSubscriptionCreateOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSubscriptionCreateOrder', 'mutation');
    },
    ResendActivationEmail(variables: ResendActivationEmailMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ResendActivationEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResendActivationEmailMutation>(ResendActivationEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ResendActivationEmail', 'mutation');
    },
    SyncSubscriptionEntities(variables: SyncSubscriptionEntitiesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SyncSubscriptionEntitiesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncSubscriptionEntitiesMutation>(SyncSubscriptionEntitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SyncSubscriptionEntities', 'mutation');
    },
    AdminTerm(variables: AdminTermQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminTermQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTermQuery>(AdminTermDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminTerm', 'query');
    },
    AdminTerms(variables?: AdminTermsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminTermsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTermsQuery>(AdminTermsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminTerms', 'query');
    },
    AdminTermCreate(variables: AdminTermCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminTermCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTermCreateMutation>(AdminTermCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminTermCreate', 'mutation');
    },
    AdminTermUpdate(variables: AdminTermUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminTermUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTermUpdateMutation>(AdminTermUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminTermUpdate', 'mutation');
    },
    AdminUser(variables?: AdminUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserQuery>(AdminUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUser', 'query');
    },
    AdminUsers(variables?: AdminUsersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUsersQuery>(AdminUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUsers', 'query');
    },
    AdminUserUpdate(variables: AdminUserUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminUserUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserUpdateMutation>(AdminUserUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUserUpdate', 'mutation');
    },
    AdminShopifyCustomerUpdate(variables: AdminShopifyCustomerUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminShopifyCustomerUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminShopifyCustomerUpdateMutation>(AdminShopifyCustomerUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminShopifyCustomerUpdate', 'mutation');
    },
    AdminUserPaymentMethods(variables?: AdminUserPaymentMethodsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminUserPaymentMethodsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserPaymentMethodsQuery>(AdminUserPaymentMethodsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUserPaymentMethods', 'query');
    },
    AdminZipCodeLocation(variables: AdminZipCodeLocationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminZipCodeLocationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminZipCodeLocationQuery>(AdminZipCodeLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminZipCodeLocation', 'query');
    },
    AdminZipCodeLocations(variables?: AdminZipCodeLocationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminZipCodeLocationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminZipCodeLocationsQuery>(AdminZipCodeLocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminZipCodeLocations', 'query');
    },
    AdminZipCodeLocationCreate(variables: AdminZipCodeLocationCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminZipCodeLocationCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminZipCodeLocationCreateMutation>(AdminZipCodeLocationCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminZipCodeLocationCreate', 'mutation');
    },
    AdminZipCodeLocationUpdate(variables: AdminZipCodeLocationUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminZipCodeLocationUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminZipCodeLocationUpdateMutation>(AdminZipCodeLocationUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminZipCodeLocationUpdate', 'mutation');
    },
    AdminZipCodeLocationDelete(variables: AdminZipCodeLocationDeleteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminZipCodeLocationDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminZipCodeLocationDeleteMutation>(AdminZipCodeLocationDeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminZipCodeLocationDelete', 'mutation');
    },
    AdminZipCode(variables: AdminZipCodeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminZipCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminZipCodeQuery>(AdminZipCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminZipCode', 'query');
    },
    AdminZipCodes(variables?: AdminZipCodesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminZipCodesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminZipCodesQuery>(AdminZipCodesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminZipCodes', 'query');
    },
    AdminZipCodeCreate(variables: AdminZipCodeCreateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminZipCodeCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminZipCodeCreateMutation>(AdminZipCodeCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminZipCodeCreate', 'mutation');
    },
    AdminZipCodeUpdate(variables: AdminZipCodeUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AdminZipCodeUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminZipCodeUpdateMutation>(AdminZipCodeUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminZipCodeUpdate', 'mutation');
    },
    GetCurrentUser(variables?: GetCurrentUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCurrentUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCurrentUserQuery>(GetCurrentUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCurrentUser', 'query');
    },
    RecentInstagramPosts(variables: RecentInstagramPostsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RecentInstagramPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecentInstagramPostsQuery>(RecentInstagramPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecentInstagramPosts', 'query');
    },
    FindUserByEmail(variables: FindUserByEmailQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindUserByEmailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindUserByEmailQuery>(FindUserByEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FindUserByEmail', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;